import type { GuideModule, GuideData } from '@/shared/schemas/config.schema';
export type { GuideModule, GuideData };

export const guideData: GuideData = {
   "app_name": "APV ERP — Cẩm Nang Hướng Dẫn Sử Dụng & Kiểm Thử Vận Hành Go-Live Toàn Hệ Thống",
   "version": "04.11.2026.1",
   "last_updated": "2026-11-04",
   "modules": [
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 00. Tổng Quan Hệ Thống, Bản Đồ Menu & Chuỗi Giá Trị Go-Live
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "overview",
         "aliases": [
            "dashboard",
            "home",
            "general",
            "ux",
            "ui-ux",
            "shared",
            "mobile",
            "reports"
         ],
         "title": "00. Tổng Quan Hệ Thống, Bản Đồ Menu & Chuỗi Giá Trị Go-Live",
         "icon": "LayoutDashboard",
         "isoRef": "HD-HT-00",
         "purpose": "Cho anh/chị bức tranh tổng thể về chuỗi giá trị bao bì giấy offset trên APV ERP: thanh menu bên trái (6 phân khu, 12 nhóm menu), thứ tự các bước nghiệp vụ từ Dữ liệu gốc, Khách hàng, Báo giá, Đơn hàng, Bình file, Lệnh sản xuất, Kế hoạch vật tư và Mua hàng, Khuôn và Kẽm, Xưởng sản xuất, Kiểm soát chất lượng, Đóng gói và Nhập kho, Giao hàng đến Thu chi và Công nợ, kèm số chương hướng dẫn chi tiết của từng bước.",
         "scope": [
            "Áp dụng cho mọi tài khoản của 18 vai trò: ADMIN, DIRECTOR (toàn quyền) và 16 vai trò nghiệp vụ MANAGER, SALES_MANAGER, SALES, PLANNER, PRODUCTION_MANAGER, TECH_MANAGER, TECH, QAQC_MANAGER, QC_INSPECTOR, QC, ACCOUNTANT, WAREHOUSE, DELIVERY, OPERATOR, HR, USER (xem Chương 16).",
            "Mỗi nhóm menu xếp trang quy trình trước, danh mục sau. Danh mục nền nằm trong nhóm của bộ phận phụ trách: Sản phẩm, Loại sản phẩm ở Kinh doanh; Danh mục Vật tư, Loại vật tư ở Mua hàng; Thiết bị SX ở Xưởng sản xuất; Quy trình SX, Ma trận Hao hụt, Cấu hình ở Hệ Thống & Quy Trình (xem Chương 03).",
            "Chứng từ bước sau được lập từ chứng từ bước trước bằng nút chuyển bước (VD [Lập Đơn Hàng] trên Báo giá, [Lập Lệnh SX] trên Đơn hàng, [Tạo Lệnh SX] trên bài bình, [Đóng gói] ở Đóng Gói & Nhập Kho, [Lập phiếu] ở Giao hàng); form mới được điền sẵn thông tin gốc để anh/chị kiểm tra trước khi lưu."
         ],
         "references": [
            "Tiêu chuẩn Quản lý Chất lượng ISO 9001:2015 — Kiểm soát quy trình từ Yêu cầu khách hàng đến Giao hàng",
            "Tiêu chuẩn Chuỗi hành trình sản phẩm FSC-STD-40-004 (Truy xuất nguồn gốc giấy FSC CoC)",
            "Quy chế Quản trị Vận hành & Phân quyền Bảo mật Nội bộ APV ERP"
         ],
         "terms": [
            {
               "term": "Bản đồ menu (6 phân khu, 12 nhóm menu)",
               "definition": "Thanh menu bên trái chia 6 phân khu: Tổng quan; Bán hàng & Thương mại; Kế hoạch & Sản xuất; Kho vận & Cung ứng; Tài chính & Kế toán; Hệ thống & Quản trị. Các nhóm menu: Dashboard, Báo Cáo Quản Trị, Kinh doanh, Kế hoạch, Xưởng sản xuất, Kỹ thuật, Chất lượng, Mua hàng, Kho, Tài Chính, Hệ Thống & Quy Trình, Hỗ Trợ. Khi mở trang, ba nhóm Kinh doanh, Kế hoạch, Xưởng sản xuất mở sẵn, cùng với nhóm của trang đang xem. Menu chỉ hiện mục mà vai trò của anh/chị có quyền Xem."
            },
            {
               "term": "Lập chứng từ từ chứng từ gốc",
               "definition": "Bấm nút chuyển bước trên chứng từ để mở form bước sau đã điền sẵn. VD: Báo giá Đã duyệt → [Lập Đơn Hàng] → [Tiếp tục & Lập Đơn]; Đơn hàng → [Lập Lệnh SX] → [Tạo Lệnh SX 1-Chạm]; bài bình ở tab Chờ tạo lệnh → [Tạo Lệnh SX]; lô FQC Đạt tự sinh phiếu đóng gói ở Đóng Gói & Nhập Kho; lô đã nhập kho → [Giao Hàng] hoặc Giao hàng › tab Chờ Xuất Giao → [Lập phiếu]; Phiếu giao hàng → [Lập Phiếu Thu]."
            },
            {
               "term": "Thêm nhanh trong ô chọn",
               "definition": "Nhiều ô chọn có dòng thêm mới ở cuối danh sách, VD Thêm KH mới (ô Khách hàng), Thêm loại sản phẩm (ô N.Sản phẩm), Thêm vật tư, Thêm sản phẩm mới. Cửa sổ thêm nhanh không tự đóng khi bấm ra ngoài hay nhấn Esc, chỉ đóng bằng [Huỷ] hoặc dấu X. Lưu xong (VD nút [Tạo & Chọn ngay]), bản ghi mới được chọn sẵn vào ô mà anh/chị không phải rời form. Nếu khách hàng bị báo trùng MST, bấm [Dùng khách hàng này] để chọn hồ sơ có sẵn (xem Chương 04)."
            },
            {
               "term": "Lưu nháp và Lưu",
               "definition": "Trên Báo giá, Đơn hàng, Lệnh sản xuất, Đơn mua hàng, Đơn gia công, Phiếu kho, Phiếu giao hàng và Phiếu thu/chi: [Lưu nháp] ghi tạm ở Bản nháp, chỉ người tạo, ADMIN và DIRECTOR thấy; [Lưu] kiểm tra đủ thông tin và chuyển chứng từ sang bước kế tiếp để mọi người có quyền xem đều thấy. Danh mục (Sản phẩm, Vật tư, Thiết bị...) không có Lưu nháp."
            },
            {
               "term": "Thanh công cụ danh sách hai dòng",
               "definition": "Trang danh sách có hai dòng công cụ: dòng trên là các tab của trang (thường có tab Thùng rác) và nút thao tác như [Xuất Excel], [Khác] (gom Nhập Excel và việc ít dùng) và nút tạo mới; dòng dưới là bộ lọc thời gian, nút [Lọc] và các thẻ lọc nhanh. Cuộn xuống thì dòng tiêu đề cột đứng yên ở trên, thanh phân trang ở đáy."
            },
            {
               "term": "Bộ lọc thời gian",
               "definition": "Các danh sách chứng từ có ô thời gian ở đầu dòng lọc với các lựa chọn Tất cả, Hôm nay, Tuần này, Tháng này, Quý này, Năm nay và Tùy chỉnh (chọn khoảng ngày)."
            },
            {
               "term": "Thanh thao tác hàng loạt",
               "definition": "Tích chọn nhiều dòng trên danh sách, thanh màu tối nổi ở đáy màn hình hiện số dòng Đã chọn và các nút dùng cho danh sách đó (VD [Xuất Excel], [Xoá] khi có quyền). Bấm dấu X trên thanh để bỏ chọn."
            },
            {
               "term": "Trang chi tiết chuẩn",
               "definition": "Bấm vào một dòng trên danh sách để mở chi tiết của chính bản ghi đó. Trên trang chi tiết, các ô liên kết (khách hàng, sản phẩm, đơn hàng, lệnh SX, nhà cung cấp, công đoạn...) là đường dẫn bấm mở thẳng bản ghi. Cuối trang có ba tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật và dòng Tạo lúc … bởi …, Cập nhật lúc … bởi … kèm nút Xem lịch sử."
            }
         ],
         "responsibilities": [
            {
               "role": "Ban Giám Đốc & Quản Trị Viên (ADMIN / DIRECTOR)",
               "tasks": [
                  "Theo dõi điều hành qua Dashboard và Báo Cáo Quản Trị",
                  "Duyệt các chứng từ cần quyền Duyệt (VD [Duyệt Đơn], [Duyệt Ban Hành], [Duyệt PO], [Duyệt & Chốt Kho], [Chốt sổ] kỳ đối soát)",
                  "Quản lý Nhân sự, Phân quyền, xem Lịch sử hệ thống và Nhật ký sự kiện — Chương 16"
               ]
            },
            {
               "role": "Kinh doanh (SALES, SALES_MANAGER)",
               "tasks": [
                  "Quản lý Khách hàng (tra cứu MST), Sản phẩm, Loại sản phẩm — Chương 03, 04",
                  "Lập Báo giá (giá bán do anh/chị nhập), Đơn hàng, theo dõi giao hàng và chốt đơn — Chương 05, 06, 14"
               ]
            },
            {
               "role": "Kế hoạch, Bình file & Kỹ thuật (PLANNER, TECH, TECH_MANAGER)",
               "tasks": [
                  "Bình file ghép bài, lập Lệnh sản xuất, Duyệt Ban Hành, Kế hoạch vật tư — Chương 07, 08, 09",
                  "Khai báo Quy trình SX, Ma trận Hao hụt; chuẩn bị khuôn bế, bản kẽm CTP; Artwork và Tiêu chuẩn SP — Chương 03, 07, 10"
               ]
            },
            {
               "role": "Xưởng sản xuất & Chất lượng (PRODUCTION_MANAGER, OPERATOR, QAQC_MANAGER, QC_INSPECTOR, QC)",
               "tasks": [
                  "Điều độ máy ở Kế hoạch sản xuất, ghi sản lượng ở Nhật ký sản xuất hoặc Màn hình xưởng, đóng gói và nhập kho thành phẩm, quản lý thiết bị — Chương 11",
                  "Kiểm IQC, IPQC, FQC (chỉ kết luận chất lượng), xử lý NCR 8D, quản lý Biểu mẫu QC — Chương 12"
               ]
            },
            {
               "role": "Mua hàng, Kho, Giao hàng & Kế toán (WAREHOUSE, DELIVERY, ACCOUNTANT)",
               "tasks": [
                  "Lập Đơn mua hàng và Đơn gia công ngoài; nhập kho vật tư sau IQC, cấp vật tư cho lệnh, kiểm kê; lập và giao Phiếu giao hàng — Chương 13, 14",
                  "Lập Phiếu thu / chi, theo dõi Công nợ KH, Công nợ NCC, đối soát và chốt sổ hằng tháng — Chương 15"
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN, DIRECTOR (toàn quyền)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền trên mọi phân hệ, gồm Nhân sự, Phân quyền, Lịch sử hệ thống và Nhật ký sự kiện."
            },
            {
               "role": "16 vai trò nghiệp vụ (MANAGER ... USER) — cấu hình Go-Live",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Được mở đủ quyền và Phạm vi Tất cả trên các phân hệ nghiệp vụ; không thấy Nhân sự, Phân quyền, Lịch sử hệ thống và Nhật ký sự kiện. Khi kết thúc Go-Live, Admin thu hẹp quyền từng vai trò tại Hệ Thống & Quy Trình › Phân quyền (Chương 16); nút Thêm / Sửa / Xoá / Duyệt tự ẩn khi vai trò không có quyền."
            }
         ],
         "processFlowchart": "graph LR\n    A[1. Dữ liệu gốc và Khách hàng - Ch 03 04] --> B[2. Báo giá - Ch 05]\n    B --> C[3. Đơn hàng - Ch 06]\n    C --> D[4. Bình file - Ch 07]\n    D --> E[5. Lệnh sản xuất - Ch 08]\n    E --> F[6. Kế hoạch vật tư và Mua hàng - Ch 09 13]\n    F --> F2[IQC rồi nhập Kho Vật tư - Ch 12 14]\n    F2 --> H[8. Xưởng sản xuất và IPQC - Ch 11 12]\n    E --> G[7. Khuôn bế và Bản kẽm - Ch 10]\n    G --> H\n    H --> I[9. FQC Thành phẩm - Ch 12]\n    I --> J[10. Đóng gói và Nhập kho - Ch 11 12]\n    J --> K[11. Giao hàng và Chốt đơn - Ch 14 06]\n    K --> L[12. Thu chi và Công nợ - Ch 15]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Thiết lập Dữ liệu gốc và Hồ sơ Khách hàng (Chương 03, 04)",
               "detail": "• Khai báo Cấu hình, Loại vật tư, Vật tư, Thiết bị SX (máy in có Khổ Kẽm CTP), Quy trình SX, Loại sản phẩm.\n• Khách hàng: Kinh doanh › Khách hàng › [Thêm KH], nhập MST rồi bấm [Tra cứu MST 1-chạm] để điền sẵn tên, địa chỉ; hệ thống chặn trùng MST / mã khách hàng.\n• Sản phẩm: Kinh doanh › Sản phẩm › [Thêm SP] với khách hàng, kích thước, khổ trải, Số bát (Outs), Số cái / thùng, Hướng thớ giấy, Chứng nhận FSC, vật tư và quy trình sản xuất; trên chi tiết bấm [Đồng bộ BOM]."
            },
            {
               "step": 2,
               "action": "Lập Báo giá (Chương 05)",
               "detail": "• Kinh doanh › Báo giá › [Tạo BG], chọn khách hàng, [Thêm dòng], nhập Số lượng và Giá chốt; [Lưu nháp] hoặc [Lưu] (sang Đang xử lý).\n• Giá bán do anh/chị nhập; [Tính giá] chỉ cho giá vốn tham khảo (Dự toán BM-KT-01), không thay đổi Giá chốt.\n• [Gửi BG] → [Khách duyệt]; in gửi khách bằng [In BG]."
            },
            {
               "step": 3,
               "action": "Lập và Duyệt Đơn hàng (Chương 06)",
               "detail": "• Từ Báo giá Đã duyệt bấm [Lập Đơn Hàng], chọn dòng rồi [Tiếp tục & Lập Đơn]; hoặc Kinh doanh › Đơn hàng › [Tạo đơn].\n• [Lưu nháp] (Bản nháp) hoặc [Lưu] (Chờ duyệt).\n• Người có quyền Duyệt bấm [Duyệt Đơn] › [Xác nhận duyệt]: đơn sang Đã xác nhận, các dòng sang Chờ bình file. Khách thiếu MST hoặc Địa chỉ thì chưa duyệt được."
            },
            {
               "step": 4,
               "action": "Bình file (Chương 07)",
               "detail": "• Kế hoạch › Bình file Prepress, tab Chờ bình: [Bình file] trên dòng; tích nhiều dòng rồi [Bình File / Ghép Bài (n)] để ghép bài.\n• Chỉ ghép khi cùng đơn hàng, cùng chất liệu giấy, cùng kiểu cán màng; dòng số lượng lớn tách nhiều bài bằng [Tách thêm bài].\n• Tab Chờ tạo lệnh: bấm [Tạo Lệnh SX] để mở form lệnh đã nạp sẵn khổ in, số con, số tờ, vật tư, khuôn kẽm, công đoạn."
            },
            {
               "step": 5,
               "action": "Lập và Ban hành Lệnh sản xuất (Chương 08)",
               "detail": "• Trên đơn hàng đã duyệt bấm [Lập Lệnh SX] → [Tạo Lệnh SX 1-Chạm]; hoặc Kế hoạch › Lệnh sản xuất › [Thêm LSX]. [Lưu nháp] / [Lưu].\n• Với lệnh ghép / tách, người lập lệnh đặt lại công đoạn, bù hao, số con và số lượng từng mặt hàng ngay trên form.\n• Trên chi tiết lệnh bấm [Duyệt Ban Hành]. Thiếu vật tư thì hộp Cảnh báo thiếu vật tư cho chọn [Hủy], [Bỏ qua & Ban hành] hoặc [Tạo PR & Ban hành].\n• Theo dõi tiến độ ở Kế hoạch › Tiến Độ Công Đoạn."
            },
            {
               "step": 6,
               "action": "Kế hoạch vật tư, Mua hàng, IQC và Nhập kho vật tư (Chương 09, 13, 12, 14)",
               "detail": "• Kế hoạch › Kế hoạch Vật tư: [Cân Đối MRP]; dòng thiếu bấm [Mua] hoặc tích nhiều dòng → [Tạo ĐMH (n)]; dòng đã đặt đủ không lập đơn mua trùng.\n• Mua hàng › ĐH Mua hàng: [Trình duyệt] → [Duyệt PO] → [Đã đặt hàng]. Đơn chưa duyệt không nhận hàng; nhận không vượt SL đặt + 5%.\n• Hàng về: QC lập phiếu ở Chất lượng › IQC Đầu vào. Lô Đạt hiện ngay ở Kho › Kho Vật tư, tab Chờ nhập kho; thủ kho bấm [Nhập Kho NVL] rồi [Duyệt & Chốt Kho].\n• Cấp vật tư cho lệnh: [Cấp Đủ] hoặc [Cấp vật tư] ở Kế hoạch Vật tư / tab 2. Kế hoạch vật tư của lệnh, hoặc Kho Vật tư › tab Chờ cấp phát › [Xuất Cấp Phát]. Chỉ cấp cho lệnh đã duyệt và còn chạy."
            },
            {
               "step": 7,
               "action": "Khuôn bế và Bản kẽm CTP (Chương 10)",
               "detail": "• Máy in phải khai Khổ Kẽm CTP (Xưởng sản xuất › Thiết bị SX); công đoạn in của lệnh phải được giao máy in.\n• Tab 3. Kế hoạch khuôn kẽm của lệnh: [Gửi ghi bản kẽm] → [Ghi bản kẽm xong] (trừ kho kẽm một lần, tự ghi nhật ký kẽm); ký proof, lắp máy ở Kỹ thuật › Kẽm CTP & Log.\n• Khuôn: chỉ gán khuôn đúng loại và đang Sẵn sàng; một khuôn chỉ ở một máy; chạy xong phải trả khuôn về kho từ đúng lệnh đang giữ khuôn, kèm tình trạng khuôn."
            },
            {
               "step": 8,
               "action": "Điều độ máy, Ghi sản lượng và IPQC (Chương 11, 12)",
               "detail": "• Xưởng sản xuất › Kế hoạch sản xuất: gán máy, thợ, giờ chạy trong hộp Điều Độ & Gán Lịch Máy Sản Xuất → [Lưu Điều Độ]; trên Gantt có [Xếp theo hạn] để xếp lại một máy theo hạn giao.\n• Lệnh chưa ban hành, đã hủy, tạm giữ hoặc kẽm / khuôn chưa sẵn sàng thì không bắt đầu được công đoạn.\n• Ghi sản lượng: [Ghi Nhật Ký] ở Kế hoạch sản xuất, hoặc Xưởng sản xuất › Nhật ký sản xuất › [Thêm Nhật Ký], hoặc Màn hình xưởng. Công đoạn sau không ghi vượt đầu ra công đoạn trước.\n• QC kiểm công đoạn ở Chất lượng › IPQC Công đoạn › [Lập Phiếu IPQC]; lỗi thì lập NCR."
            },
            {
               "step": 9,
               "action": "FQC Thành phẩm và Đóng gói, Nhập kho (Chương 12, 11)",
               "detail": "• Chất lượng › FQC Thành phẩm, tab Chờ Kiểm FQC → [Lập FQC] → [Lưu Biên Bản FQC]. Phiếu FQC chỉ kết luận chất lượng (không nhập kho, không tạo phiếu giao); SL Đạt không vượt sản lượng công đoạn cuối.\n• Lô Đạt / Nhân nhượng tự sinh phiếu đóng gói ở Xưởng sản xuất › Đóng Gói & Nhập Kho, tab Chờ Đóng Gói → [Đóng gói] → [Hoàn tất đóng gói & nhập kho]: nhập Kho thành phẩm và in tem thùng số nhảy.\n• Lỗi chất lượng: [Tạo NCR] trên phiếu kiểm, xử lý theo 8D ở Chất lượng › Sự cố NCR."
            },
            {
               "step": 10,
               "action": "Giao hàng và Chốt đơn (Chương 14, 06)",
               "detail": "• Chỉ lô đã FQC Đạt, đã đóng gói và nhập kho mới giao được. Kinh doanh › Giao hàng › tab Chờ Xuất Giao: tích các mặt hàng cùng một khách → [Lập Phiếu Giao Hàng (n mặt hàng - Tên khách)] hoặc [Lập phiếu] trên dòng; hoặc [Giao Hàng] ở Đóng Gói & Nhập Kho.\n• [Lưu] → Đã lên lịch. Hệ thống chặn khi giao vượt SL đặt cộng % bù hao của dòng đơn (để trống là 5%, 0% là không giao vượt; tính cả các phiếu đang mở).\n• [Duyệt giao] → Đang giao: tự lập phiếu xuất kho thành phẩm. Bấm bước Đã giao khi khách nhận: số đã giao cộng vào đơn, công nợ tính lại.\n• Đơn không tự hoàn thành: trên chi tiết đơn bấm [Chốt hoàn tất (Dung sai ±x%)] khi đã giao đủ trong dung sai, hoặc [Chốt đơn]."
            },
            {
               "step": 11,
               "action": "Thu tiền, Công nợ và Đối soát (Chương 15)",
               "detail": "• Tài Chính › Thu chi & Sổ quỹ › [Tạo Thu Chi]; hoặc [Lập Phiếu Thu] trên Phiếu giao hàng.\n• Theo dõi Tài Chính › Công nợ KH, Công nợ NCC, sổ chi tiết công nợ ([Sổ cái]).\n• Cuối tháng tại Tài Chính › Đối soát công nợ: [In biên bản], đối tác ký xác nhận rồi người có quyền Duyệt bấm [Chốt sổ]."
            }
         ],
         "inlineViews": [
            {
               "name": "Bản đồ menu: 6 phân khu, 12 nhóm menu và chương hướng dẫn",
               "trigger": "Thanh menu bên trái (máy tính) hoặc nút [Ứng dụng] ở thanh dưới đáy (điện thoại)",
               "description": "I. Tổng quan: Dashboard • Báo Cáo Quản Trị.\nII. Bán hàng & Thương mại — Kinh doanh: Báo giá (Ch 05), Đơn hàng (Ch 06), ĐH Gia công (Ch 13), Giao hàng (Ch 14), Khách hàng (Ch 04), Sản phẩm (Ch 03), Loại sản phẩm (Ch 03).\nIII. Kế hoạch & Sản xuất — Kế hoạch: Bình file Prepress (Ch 07), Lệnh sản xuất (Ch 08), Kế hoạch Vật tư (Ch 09), Tiến Độ Công Đoạn (Ch 08). Xưởng sản xuất: Kế hoạch sản xuất, Nhật ký sản xuất, Đóng Gói & Nhập Kho, Sự cố thiết bị, Bảo trì bảo dưỡng (Ch 11), Thiết bị SX (Ch 03, 11). Kỹ thuật: Artwork Thiết kế (Ch 07), Kẽm CTP & Log, Quản lý Khuôn (Ch 10), Tiêu chuẩn SP (Ch 07), Kho Kỹ thuật (Ch 14). Chất lượng: IQC Đầu vào, IPQC Công đoạn, FQC Thành phẩm, Sự cố NCR, Biểu mẫu QC (Ch 12).\nIV. Kho vận & Cung ứng — Mua hàng: ĐH Mua hàng (Ch 13), Nhà Cung cấp (Ch 04, 13), Danh mục Vật tư, Loại vật tư (Ch 03). Kho: Kho Vật tư, Kho Thành phẩm, Kho Kỹ thuật, Danh mục Kho (Ch 14), Mã & Tồn NVL (Ch 03, 14).\nV. Tài chính & Kế toán — Tài Chính: Thu chi & Sổ quỹ, Công nợ KH, Công nợ NCC, Đối soát công nợ, Báo cáo Bán hàng (Ch 15).\nVI. Hệ thống & Quản trị — Hệ Thống & Quy Trình: Quy trình SX, Ma trận Hao hụt (Ch 03), Workflow Duyệt, Nhân sự, Phân quyền, Thông tin Cty (Ch 16), Cấu hình (Ch 03, 16). Hỗ Trợ: Lịch sử hệ thống, Nhật ký sự kiện, Thùng rác (Ch 16), Nhật ký Release, Phản hồi hệ thống, Hướng dẫn sử dụng (Ch 02).\nChương 01 là checklist kiểm thử Go-Live theo bộ phận và kịch bản xuyên suốt."
            },
            {
               "name": "Ô tìm kiếm trên Header",
               "trigger": "Thanh đầu trang của mọi trang danh sách",
               "description": "Ô Tìm kiếm trong <tên màn hình>... lọc ngay danh sách đang mở trên toàn bộ các trang và quay về trang 1; các trang danh sách không có ô tìm kiếm riêng. Trên điện thoại bấm biểu tượng kính lúp (Tìm kiếm nhanh). Xem Chương 02."
            },
            {
               "name": "Trang chi tiết: liên kết, Thảo luận, Tệp đính kèm, Lịch sử cập nhật",
               "trigger": "Bấm vào một dòng trên danh sách",
               "description": "Mã chứng từ hiện trên thanh tiêu đề; các ô khách hàng, sản phẩm, đơn hàng, lệnh SX, nhà cung cấp, công đoạn là đường dẫn mở thẳng bản ghi. Cuối trang có tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật và dòng Tạo lúc / Cập nhật lúc kèm người thao tác. Trên điện thoại, thanh nút dưới đáy hiện tối đa 4 nút, nút ít dùng nằm trong nút … bên phải."
            },
            {
               "name": "3 phân hệ chuẩn: Hướng dẫn, Lịch sử cập nhật, Phản hồi",
               "trigger": "Menu Hỗ Trợ, biểu tượng dấu hỏi trên tiêu đề trang danh sách, chân thanh menu, nút tròn góc dưới bên phải",
               "description": "• Hướng dẫn sử dụng: cẩm nang này; biểu tượng dấu hỏi mở đúng chương của màn hình đang xem; [In / Xuất PDF Toàn Bộ] in hoặc lưu thành PDF.\n• Nhật ký Release: danh sách phiên bản và thay đổi; số phiên bản đang dùng hiện ở chân thanh menu (APV-ERP v...).\n• Phản hồi hệ thống: mọi tài khoản gửi báo lỗi / góp ý kèm ảnh bằng nút tròn Gửi phản hồi / Báo lỗi; phiếu đi qua Mới → Đang xử lý → Hoàn thành → Đã đóng. Xem Chương 02."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/00_user_role_open_crud_and_restricted_admin_modules.png",
               "caption": "Hình 00.1 — Giao diện điều hướng với quyền nghiệp vụ mở cho các vai trò trong giai đoạn Go-Live; Nhân sự và Phân quyền chỉ dành cho ADMIN, DIRECTOR"
            }
         ],
         "notes": [
            "Trên trang chi tiết, khi thanh tiêu đề không đủ chỗ (kể cả màn hình 1440 px), các nút ít dùng được gom vào nút [Khác]; VD trên chi tiết lệnh sản xuất, [Thao tác] (Đặt gia công, Chốt kế hoạch, Tái đồng bộ Báo Giá…) và trên chi tiết đơn hàng, [Đặt GC] có thể nằm trong [Khác]. Hướng dẫn ghi tên nút gốc; không thấy nút thì mở [Khác].",
            "Trên điện thoại, bấm nút [Ứng dụng] ở thanh dưới đáy để mở Cổng Ứng Dụng APV Manager và gõ vào ô Tìm nhanh chức năng để tìm phân hệ.",
            "Ô tìm kiếm duy nhất nằm trên thanh Header và tìm trong đúng danh sách đang mở. Danh sách tự tải lại khi quay về từ trang chi tiết (VD sau khi xoá hoặc sửa), không cần bấm F5.",
            "Bản nháp (Lưu nháp) của mọi chứng từ chỉ người tạo, ADMIN và DIRECTOR thấy; muốn đồng nghiệp xử lý tiếp, bấm [Lưu].",
            "Các kho độc lập theo loại hàng: Kho Vật tư chỉ nhận vật tư, Kho Thành phẩm chỉ nhận thành phẩm, Kho Kỹ thuật nhận khuôn, bản kẽm, công cụ dụng cụ. Không có nghiệp vụ chuyển kho; hàng nhập kho nào thì xuất tại kho đó (Chương 14).",
            "Thành phẩm chỉ nhập kho qua Xưởng sản xuất › Đóng Gói & Nhập Kho; phiếu FQC không nhập kho và không tạo phiếu giao.",
            "Phần lớn trang danh sách có tab Thùng rác: xem bản ghi đã xoá, bấm [Phục hồi] để lấy lại đúng mã cũ (cần quyền Xoá của trang). Riêng công đoạn trong Quy trình SX xoá là mất hẳn.",
            "Thông tin công ty ở đầu các bản in lấy từ Hệ Thống & Quy Trình › Thông tin Cty. Mã biểu mẫu ISO chỉ có trên một số bản in, VD BM-KT-01 (dự toán giá thành), BM-SX-01, BM-KHSX-01, BM-QC-01, BM-QC-02, BM-QC-03, BM-KHO-01, BM-KHO-02, BM-KHO-03, BM-GH-01, BM-TC-02.",
            "Bổ sung 03/11/2026: Chương 17 hướng dẫn Sự cố thiết bị và Bảo trì định kỳ; Chương 18 hướng dẫn Dashboard, Báo cáo quản trị, Báo cáo bán hàng và Tiến độ công đoạn.",
            "Mỗi thao tác xem, thêm, sửa, xoá, duyệt chỉ dùng được khi vai trò có quyền tương ứng ở màn hình Phân quyền; chuyển chứng từ sang Xác nhận / Đã duyệt / Ban hành cần quyền duyệt.",
            "Danh sách nhóm theo ngày (Báo giá, Đơn hàng, ĐH Gia công, Mua hàng, Kế hoạch vật tư, Tiến độ công đoạn, Nhật ký sản xuất, KCS FQC, Phiếu kho, Giao hàng, Thu chi): mỗi dòng ngày có nút mũi tên đầu dòng (rê chuột hiện Thu gọn / Bung ra) để đóng hoặc mở các dòng của ngày đó; tổng phụ trên dòng ngày vẫn hiện khi thu gọn. Ở Bình file Prepress, nút [Mở rộng tất cả] / [Thu gọn chi tiết] mở hoặc đóng chi tiết mọi bài bình cùng lúc.",
            "Một số màn chỉ mở được bằng đường dẫn, không có mục menu hay nút dẫn tới, nên không thuộc quy trình vận hành: /planning/mrp, /outsource-orders/tracking-hub, /production-orders/matrix, /material-supply-board, /stock-card, /warehouse/inventory-check/mobile, /estimating (bảng tính giá thử nghiệm), /pricing-configs, /qc/reports. Báo giá dùng màn Báo giá (Chương 05), tồn kho dùng Sổ kho / NXT (Chương 14).",
            "Tab Thảo luận & Ghi chú trên trang chi tiết: rê chuột lên ghi chú của chính mình để hiện [Sửa] (sửa nội dung rồi lưu) và [Xóa] (hỏi lại Xóa ghi chú này? trước khi xoá). Ghi chú của người khác không sửa / xoá được."
         ],
         "subFlows": [
            {
               "name": "Thêm mới danh mục ngay trong ô chọn",
               "steps": [
                  "Ô chọn kho, máy, công đoạn, khuôn, kẽm, sản phẩm, khách hàng, vật tư… có nút thêm mới ở cuối danh sách gợi ý.",
                  "Bấm nút: form của danh mục đó mở ngay trong form đang nhập; điền và lưu, mục mới tự được chọn, không mất dữ liệu đang nhập.",
                  "Nút chỉ hiện với người có quyền tạo danh mục đó; không thấy nút thì nhờ người phụ trách danh mục tạo trước."
               ]
            },
            {
               "name": "Đọc thông báo lỗi khi lưu",
               "steps": [
                  "Lỗi khi lưu nêu đúng ô và lý do, VD “Khách hàng là bắt buộc”, “Khách hàng đã chọn không còn tồn tại, vui lòng chọn lại khách hàng”, “Sản phẩm đang được dùng ở chứng từ khác nên không xoá được”.",
                  "Lỗi trong bảng dòng hàng ghi rõ số dòng, VD “Dòng 3: …”. Sửa đúng ô được nêu rồi lưu lại.",
                  "Hệ thống đang cập nhật phiên bản thì báo “Hệ thống đang cập nhật”; chờ vài giây rồi thao tác lại, dữ liệu đang nhập không mất."
               ]
            },
            {
               "name": "Đọc màn hình chi tiết chứng từ",
               "steps": [
                  "Phần Thông tin chung dùng lưới 4 cột, nhãn nằm trên giá trị; mã chứng từ cha (khách hàng, đơn hàng, lệnh SX, máy, kho…) là liên kết, bấm để mở.",
                  "Bên dưới có 3 tab: Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật; cuối trang ghi người tạo / người cập nhật và thời điểm."
               ]
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 01. Checklist Kiểm Thử Go-Live Theo Bộ Phận & Kịch Bản Xuyên Suốt
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "golive_uat_crud",
         "aliases": [
            "testing",
            "test",
            "uat",
            "golive",
            "crud",
            "checklist",
            "qa"
         ],
         "title": "01. Checklist Kiểm Thử Go-Live Theo Bộ Phận & Kịch Bản Xuyên Suốt",
         "icon": "ClipboardCheck",
         "isoRef": "HD-UAT-01",
         "purpose": "Giúp từng bộ phận (Kinh doanh, Kế hoạch, Bình file, Sản xuất, QC, Kho vật tư, Giao hàng) tự kiểm thử đúng phần việc của mình trên hệ thống đang vận hành từ 02/11/2026: mỗi bộ phận có danh sách mục kiểm thử chi tiết ở chương nghiệp vụ của mình, chương này gom lại thành bản đồ checklist, kịch bản xuyên suốt một đơn hàng qua mọi bộ phận và 12 tiêu chí chung để đánh giá Đạt / Không đạt.",
         "scope": [
            "Áp dụng cho mọi nhân sự tham gia vận hành và nghiệm thu đợt Go-Live 02/11/2026 của 7 bộ phận: Kinh doanh, Kế hoạch, Bình file, Sản xuất, QC, Kho vật tư (kèm Mua hàng), Giao hàng.",
            "Mỗi chương nghiệp vụ có mục Checklist Go-Live riêng (mã mục theo bộ phận: SALE, KH, BF, SX, QC, KHO, MH, GH). Đánh dấu ô trước mục khi đã kiểm và đạt.",
            "Giai đoạn 1 (Go-Live, cấu hình hiện tại): ADMIN và DIRECTOR có Full Access; 16 vai trò nghiệp vụ được mở đủ quyền Xem, Thêm, Sửa, Xóa, Duyệt, Import, Export và Phạm vi Tất cả trên các phân hệ nghiệp vụ, trừ Nhân sự (/users), Phân quyền (/roles) và Lịch sử hệ thống, để kiểm chứng luồng liên thông không bị chặn.",
            "Giai đoạn 2 (chốt phân quyền vận hành): sau khi các bộ phận xác nhận luồng dữ liệu, Quản trị viên vào Phân quyền (/roles) → [Sửa quyền] để thu hẹp các cột quyền (Xem, Thêm, Sửa, Xóa, Import, Export, Review, Duyệt), Phạm vi Dữ liệu (Không được phép / Chỉ của mình / Của Team / Tất cả) và Phạm vi Tiền/Giá (Không được xem / Chỉ của mình / Của Team / Phòng ban / Tất cả) theo từng vai trò, rồi bấm [Lưu]."
         ],
         "terms": [
            {
               "term": "Kiểm thử CRUD",
               "definition": "Bốn thao tác dữ liệu nền tảng: Create (Thêm mới), Read (Xem & Tra cứu), Update (Sửa & Chuyển trạng thái), Delete (Xoá; phần lớn chứng từ và danh mục chính vào Thùng rác và khôi phục được)."
            },
            {
               "term": "Tiêu chuẩn Đạt (PASS)",
               "definition": "Thao tác thành công, có thông báo tiếng Việt rõ ràng, số liệu trên danh sách và trang chi tiết đúng với thao tác vừa làm mà không cần bấm F5 tải lại trang."
            },
            {
               "term": "Kiểm thử thêm nhanh",
               "definition": "Đang lập một chứng từ, dùng dòng thêm mới trong ô chọn (VD Thêm KH mới trên Báo giá, Thêm khách hàng mới trên Đơn hàng, + Thêm NCC trên phiếu nhập kho): lưu xong, bản ghi mới được chọn sẵn và dữ liệu đang nhập trên form vẫn còn."
            },
            {
               "term": "Mã mục checklist",
               "definition": "Dạng BỘ PHẬN-CHƯƠNG-SỐ, VD SALE-06-07 là mục 7 của Kinh doanh ở Chương 06. Khi báo lỗi, ghi mã mục để người xử lý tìm đúng bước kiểm thử."
            },
            {
               "term": "Kịch bản xuyên suốt",
               "definition": "Một đơn hàng thử đi qua đủ 7 bộ phận theo đúng thứ tự thật, mỗi bộ phận nhận chứng từ từ bộ phận trước và bàn giao cho bộ phận sau."
            }
         ],
         "responsibilities": [
            {
               "role": "Mỗi nhân viên (theo bộ phận)",
               "tasks": [
                  "Mở chương của bộ phận mình (bảng bên dưới), làm lần lượt các mục Checklist Go-Live trên dữ liệu thử và đánh dấu mục đạt.",
                  "Kiểm thêm 12 tiêu chí chung TC-01 đến TC-12 khi thao tác.",
                  "Mục không đạt: bấm nút tròn Gửi phản hồi góc dưới phải, ghi mã mục (VD QC-12-05), mã chứng từ đang thử và ảnh màn hình (Chương 02)."
               ]
            },
            {
               "role": "Trưởng bộ phận (SALES_MANAGER, PRODUCTION_MANAGER, TECH_MANAGER, QAQC_MANAGER, quản lý kho)",
               "tasks": [
                  "Phân công người kiểm từng nhóm mục, kiểm chéo phần bàn giao với bộ phận kế tiếp.",
                  "Chạy kịch bản xuyên suốt cùng các bộ phận khác ít nhất một lần, xác nhận nghiệm thu khi mọi mục của bộ phận đã đạt hoặc đã có phiếu phản hồi."
               ]
            },
            {
               "role": "Quản trị hệ thống",
               "tasks": [
                  "Theo dõi phiếu phản hồi trong ngày, báo lại kết quả xử lý; sau khi các bộ phận xác nhận, thu hẹp phân quyền theo vai trò (Giai đoạn 2)."
               ]
            }
         ],
         "processFlowchart": "graph TD\n    A[Kinh doanh - Báo giá, Đơn hàng đã duyệt] --> B[Kế hoạch - Lập Lệnh SX, Kế hoạch vật tư]\n    B --> C[Bình file - Bình bài, ghi bản kẽm, khuôn]\n    B --> D[Mua hàng - Đơn mua] --> E[QC - IQC lô vật tư]\n    E --> F[Kho vật tư - Nhập kho từ Chờ nhập kho, cấp phát cho Lệnh SX]\n    C --> G[Sản xuất - Công đoạn, nhật ký sản xuất]\n    F --> G\n    G --> H[QC - FQC thành phẩm]\n    H --> I[Đóng gói và nhập kho thành phẩm]\n    I --> J[Giao hàng - Phiếu giao theo lô, một khách mỗi phiếu]\n    J --> K{Mọi mục checklist đạt?}\n    K -->|Đạt| L[Trưởng bộ phận xác nhận nghiệm thu]\n    K -->|Chưa đạt| M[Gửi phản hồi kèm mã mục và ảnh]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Bước 1 — Kinh doanh: Báo giá và Đơn hàng",
               "detail": "Lập Báo giá cho khách thử (ghi chú -UAT01), gửi, khách duyệt, [Lập Đơn Hàng], [Duyệt Đơn]. Kiểm Chương 05, 06."
            },
            {
               "step": 2,
               "action": "Bước 2 — Kế hoạch: Lệnh sản xuất và vật tư",
               "detail": "Trên đơn bấm [Lập Lệnh SX]; [Duyệt Ban Hành]; mở Kế hoạch vật tư xem vật tư thiếu, [Tạo ĐMH]. Kiểm Chương 08, 09."
            },
            {
               "step": 3,
               "action": "Bước 3 — Bình file: bài bình, kẽm, khuôn",
               "detail": "Bình bài cho dòng đơn, [Gửi ghi bản kẽm], [Ghi bản kẽm xong], nghiệm thu kẽm; kiểm khuôn. Kiểm Chương 07, 10."
            },
            {
               "step": 4,
               "action": "Bước 4 — Mua hàng và QC đầu vào",
               "detail": "Duyệt đơn mua, nhận hàng, lập IQC theo đơn mua; lô Đạt hiện ở Kho vật tư › Phiếu nhập xuất › tab Chờ nhập kho. Kiểm Chương 12, 13."
            },
            {
               "step": 5,
               "action": "Bước 5 — Kho vật tư: nhập kho, cấp phát",
               "detail": "Bấm [Nhập Kho NVL] ở dòng lô; cấp phát vật tư cho Lệnh SX; xem Báo cáo NXT, Sổ kho khớp số. Kiểm Chương 14 (mục KHO)."
            },
            {
               "step": 6,
               "action": "Bước 6 — Sản xuất: công đoạn và nhật ký",
               "detail": "Bắt đầu công đoạn, ghi nhật ký sản xuất từng công đoạn, bàn giao BTP; kiểm sản lượng cộng vào Lệnh SX. Kiểm Chương 11."
            },
            {
               "step": 7,
               "action": "Bước 7 — QC thành phẩm và Đóng gói",
               "detail": "Lập FQC cho lô thành phẩm; lô Đạt sang Xưởng sản xuất › Đóng Gói & Nhập Kho, in tem thùng, nhập kho thành phẩm. Kiểm Chương 12."
            },
            {
               "step": 8,
               "action": "Bước 8 — Giao hàng",
               "detail": "Lập phiếu giao từ lô đã nhập kho, in phiếu giao, chuyển Đã giao; số đã giao trên đơn hàng cập nhật. Kiểm Chương 14 (mục GH)."
            },
            {
               "step": 9,
               "action": "Bước 9 — Đối chiếu cuối và nghiệm thu",
               "detail": "Mở đơn hàng -UAT01: các tab Lệnh SX, Giao hàng hiện đúng chứng từ, bấm được để mở; Trưởng bộ phận xác nhận checklist bộ phận mình."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "1. Kinh doanh (Sale) (SALES, SALES_MANAGER) — Chương 04, 05, 06",
               "createTest": "Thêm khách hàng có MST (tra cứu MST), lập Báo giá có giá bán do anh/chị nhập, [Lập Đơn Hàng] từ báo giá, lưu đơn kèm người liên hệ, SĐT, email.",
               "readTest": "Mở chi tiết khách hàng, báo giá, đơn hàng: mã chứng từ cha (khách hàng, báo giá, sản phẩm) bấm được để mở; giá trị dài xuống dòng, không bị cắt \"…\".",
               "updateTest": "Gửi báo giá, khách duyệt; sửa đơn Bản nháp; [Duyệt Đơn] với khách đủ MST và địa chỉ; thử thanh trạng thái bấm bước không hợp lệ để thấy lý do.",
               "deleteTest": "Xoá báo giá thử vào Thùng rác; thử xoá khách hàng đã có chứng từ để thấy bị chặn; thử hủy đơn đã có Lệnh SX đang chạy để thấy bị chặn.",
               "expectedResult": "Mọi thao tác có thông báo tiếng Việt rõ ràng; bước bị chặn nêu đúng lý do; Đơn đã duyệt › [Lập Lệnh SX] sang Kế hoạch; tính giá chỉ ghi giá vốn, không đổi giá bán."
            },
            {
               "roleGroup": "2. Kế hoạch (Planning) (PLANNER, PRODUCTION_MANAGER) — Chương 08, 09",
               "createTest": "Từ đơn hàng › [Lập Lệnh SX] (khổ in, UPS, bù hao %, 0% là hợp lệ); lập Kế hoạch vật tư, [Tạo ĐMH] cho vật tư thiếu.",
               "readTest": "Lệnh SX hiện link về Đơn hàng, Sản phẩm, Bài bình; Kế hoạch vật tư hiện đúng số Tồn khả dụng, Đã đặt, Còn thiếu.",
               "updateTest": "[Duyệt Ban Hành] (cần quyền Duyệt), [Chốt kế hoạch]; bulk [Bắt đầu chạy] chỉ cho lệnh Đã lên KH / Đã ban hành; [Tạm dừng] lệnh đang chạy.",
               "deleteTest": "Hủy lệnh: công đoạn còn mở và kế hoạch vật tư chưa nhận tự hủy, số lượng trả về dòng đơn; thử xoá lệnh đã có nhật ký SX để thấy bị chặn.",
               "expectedResult": "Mọi thao tác có thông báo tiếng Việt rõ ràng; bước bị chặn nêu đúng lý do; Sang Bình file (bài bình, ghi bản kẽm), Mua hàng (đơn mua từ kế hoạch), Kho vật tư (cấp phát), Xưởng (công đoạn)."
            },
            {
               "roleGroup": "3. Bình file (Prepress) & Khuôn kẽm (TECH, TECH_MANAGER) — Chương 07, 10",
               "createTest": "Tab Chờ bình › chọn dòng cùng đơn, cùng giấy, cùng cán màng › bình bài; [Gửi ghi bản kẽm] rồi [Ghi bản kẽm xong] tạo bộ kẽm Chờ nghiệm thu.",
               "readTest": "Bài bình, bản kẽm, khuôn hiện link về Lệnh SX, Đơn hàng, Sản phẩm; ảnh sản phẩm / bài bình hiện trên danh sách.",
               "updateTest": "Thử ghép 2 dòng khác giấy hoặc khác cán màng để thấy thông báo chặn; nghiệm thu kẽm, lắp máy in; khuôn chuyển bảo dưỡng.",
               "deleteTest": "Hủy bài bình chưa có lệnh; thử [Gửi ghi bản kẽm] khi công đoạn in chưa gán máy để thấy lý do \"chưa giao máy in, chưa biết khổ kẽm\".",
               "expectedResult": "Mọi thao tác có thông báo tiếng Việt rõ ràng; bước bị chặn nêu đúng lý do; Bài bình › Lập Lệnh SX qua form (từng bài); kẽm, khuôn sẵn sàng cho Xưởng in và bế."
            },
            {
               "roleGroup": "4. Sản xuất (Xưởng) (OPERATOR, PRODUCTION_MANAGER) — Chương 11",
               "createTest": "Ghi nhật ký sản xuất cho công đoạn (máy, ca, SL đạt, SL hỏng); ghi dừng máy / bảo trì; bàn giao BTP giữa công đoạn.",
               "readTest": "Nhật ký hiện link về Lệnh SX, công đoạn, máy; màn cảm ứng xưởng dùng được trên điện thoại 390px.",
               "updateTest": "Sửa nhật ký đã lưu: Lệnh SX và công đoạn bị khoá, chỉ sửa số lượng, giờ; thử bắt đầu công đoạn khi lệnh chưa ban hành hoặc thiếu kẽm / khuôn để thấy lý do.",
               "deleteTest": "Ghi nhầm lệnh thì xoá nhật ký và nhập lại; thử nhập SL vượt 105% công đoạn trước để thấy bị chặn.",
               "expectedResult": "Mọi thao tác có thông báo tiếng Việt rõ ràng; bước bị chặn nêu đúng lý do; Thành phẩm sang QC (FQC) rồi Đóng Gói & Nhập Kho."
            },
            {
               "roleGroup": "5. Chất lượng (QC) (QC, QC_INSPECTOR, QAQC_MANAGER) — Chương 12",
               "createTest": "IQC lô vật tư theo đơn mua; IPQC công đoạn; FQC thành phẩm; lập NCR từ phiếu QC không đạt (nguồn phát hiện IQC, IPQC, FQC, Khách hàng, NCC, Nội bộ đều lưu được).",
               "readTest": "Phiếu QC hiện link về Lệnh SX, đơn mua, lô, sản phẩm; NCR hiện đủ D1 đến D8.",
               "updateTest": "IQC Đạt › lô hiện ở Kho vật tư tab Chờ nhập kho; FQC không vượt kế hoạch; NCR Sửa / CAPA lưu D5, D7; [Đóng NCR] thiếu nội dung thì báo thiếu gì.",
               "deleteTest": "Thử sửa / xoá FQC đã đóng gói để thấy bị chặn.",
               "expectedResult": "Mọi thao tác có thông báo tiếng Việt rõ ràng; bước bị chặn nêu đúng lý do; IQC sang Kho vật tư (nhập kho); FQC sang Đóng gói, Kho thành phẩm, Giao hàng."
            },
            {
               "roleGroup": "6. Kho vật tư & Mua hàng (WAREHOUSE, người duyệt kho, mua hàng) — Chương 13, 14",
               "createTest": "Đơn mua: chọn NCC, ô Vật tư liệt kê vật tư của NCC lên đầu; [Gửi duyệt] hàng loạt; nhập kho từ tab Chờ nhập kho; cấp phát cho Lệnh SX; thêm vị trí kệ.",
               "readTest": "Phiếu kho hiện link về đơn mua, Lệnh SX, lô IQC; Báo cáo NXT và Sổ kho khớp số với phiếu.",
               "updateTest": "Kiểm kê: [Lưu Phiếu Kiểm Kê] › gửi duyệt › [Duyệt & Cân đối kho] tạo phiếu NK-KK / XK-KK; thử nhập vật tư vào kho khác loại để thấy bị chặn.",
               "deleteTest": "Thử xuất quá tồn để thấy bị chặn; thử nhận quá SL đặt + 5% để thấy bị chặn.",
               "expectedResult": "Mọi thao tác có thông báo tiếng Việt rõ ràng; bước bị chặn nêu đúng lý do; Vật tư đã nhập kho sẵn cho cấp phát; tồn và Kế hoạch vật tư cập nhật ngay."
            },
            {
               "roleGroup": "7. Giao hàng (DELIVERY, WAREHOUSE) — Chương 14",
               "createTest": "Từ lô đã đóng gói và nhập kho › lập phiếu giao (một phiếu chỉ một khách hàng); in phiếu giao, tem thùng.",
               "readTest": "Phiếu giao hiện link về Đơn hàng, Khách hàng, lô đóng gói; số đã giao trên đơn hàng cập nhật đúng.",
               "updateTest": "Chuyển Đang giao › Đã giao; lùi hoặc hủy phiếu thì hàng trả về kho đúng một lần.",
               "deleteTest": "Thử giao vượt SL đặt + bù hao để thấy bị chặn; thử gom 2 khách vào một phiếu để thấy bị chặn.",
               "expectedResult": "Mọi thao tác có thông báo tiếng Việt rõ ràng; bước bị chặn nêu đúng lý do; Đơn giao đủ trong dung sai › Kinh doanh [Chốt hoàn tất]; sang Kế toán thu tiền."
            }
         ],
         "uatChecklist": [
            {
               "id": "TC-01",
               "item": "Thêm, Sửa, Xoá phản hồi ngay, không cần F5",
               "standard": "Có thông báo tiếng Việt; danh sách và trang chi tiết cập nhật đúng ngay sau thao tác.",
               "method": "1) Thêm, sửa, xoá một bản ghi thử; 2) Quay lại danh sách, kiểm số liệu không cần tải lại trang."
            },
            {
               "id": "TC-02",
               "item": "Thêm nhanh trong ô chọn",
               "standard": "Bản ghi mới được chọn sẵn, dữ liệu đang nhập trên form còn nguyên; khách trùng MST bị chặn.",
               "method": "1) Đang lập đơn hàng, thêm khách hàng mới trong ô chọn; 2) Đang lập phiếu nhập kho, bấm [+ Thêm NCC]."
            },
            {
               "id": "TC-03",
               "item": "Lập chứng từ bước sau từ chứng từ gốc",
               "standard": "Form mới điền sẵn dữ liệu gốc để kiểm trước khi lưu.",
               "method": "1) Báo giá › [Lập Đơn Hàng]; 2) Đơn hàng › [Lập Lệnh SX]; 3) Lô IQC Đạt › [Nhập Kho NVL]; 4) Lô đã đóng gói › phiếu giao."
            },
            {
               "id": "TC-04",
               "item": "Ô chọn (combobox) tra đúng dữ liệu",
               "standard": "Ô chọn gõ tìm được theo mã và tên, chỉ hiện dữ liệu còn dùng; vật tư của NCC đã chọn lên đầu.",
               "method": "1) Gõ vài chữ của mã và của tên trong ô chọn Khách hàng, Sản phẩm, Vật tư, Lệnh SX; 2) Kiểm kết quả."
            },
            {
               "id": "TC-05",
               "item": "Mã chứng từ cha bấm được",
               "standard": "Trên trang chi tiết và hộp thoại, mã / tên chứng từ liên quan (đơn hàng, Lệnh SX, khách hàng, sản phẩm, NCC) là link mở đúng chứng từ.",
               "method": "1) Mở chi tiết phiếu giao, phiếu QC, nhật ký sản xuất; 2) Bấm từng mã liên quan."
            },
            {
               "id": "TC-06",
               "item": "Không cắt chữ, không che nội dung",
               "standard": "Mã, tên, ghi chú dài xuống dòng đọc đủ, không bị \"…\"; hộp thoại nằm gọn trong màn hình.",
               "method": "1) Mở chứng từ có tên sản phẩm dài; 2) Kiểm phần Thông tin chung và các hộp thoại."
            },
            {
               "id": "TC-07",
               "item": "Thanh trạng thái chỉ cho bước hợp lệ",
               "standard": "Bước không được phép thì mờ; bị từ chối luôn có thông báo nêu lý do.",
               "method": "1) Trên đơn hàng, báo giá, Lệnh SX, đơn mua, phiếu giao bấm thử một bước không hợp lệ; 2) Đọc thông báo."
            },
            {
               "id": "TC-08",
               "item": "Quy tắc nghiệp vụ chặn đúng",
               "standard": "Tồn kho không âm, không nhập sai loại kho, không giao vượt, không ghép bài khác giấy: bị chặn kèm lý do, không có lỗi hệ thống.",
               "method": "Làm các mục \"chặn\" trong checklist chương của bộ phận mình."
            },
            {
               "id": "TC-09",
               "item": "Điện thoại 390px dùng được",
               "standard": "Danh sách, chi tiết, form chính không vỡ, không che nút; bảng kéo ngang được.",
               "method": "1) Mở hệ thống trên điện thoại; 2) Làm một thao tác chính của bộ phận."
            },
            {
               "id": "TC-10",
               "item": "Biểu mẫu in & Xuất Excel",
               "standard": "Bản in đúng mẫu, đủ thông tin, vừa trang; file Excel mở được, đúng cột.",
               "method": "1) In chứng từ chính của bộ phận; 2) Xuất Excel danh sách."
            },
            {
               "id": "TC-11",
               "item": "Thảo luận, đính kèm, lịch sử",
               "standard": "Mỗi chứng từ có tab Thảo luận, Tệp đính kèm, Lịch sử cập nhật; cuối trang ghi Tạo bởi / Cập nhật bởi.",
               "method": "1) Mở chi tiết chứng từ; 2) Gửi một ghi chú, đính kèm một tệp (dán ảnh bằng Ctrl+V); 3) Xem Lịch sử cập nhật."
            },
            {
               "id": "TC-12",
               "item": "Ba phân hệ chuẩn: Hướng dẫn, Lịch sử cập nhật, Phản hồi",
               "standard": "Mở được Hướng dẫn sử dụng, Lịch sử cập nhật; gửi được phản hồi kèm ảnh; chân menu trái hiện đúng phiên bản mới nhất.",
               "method": "1) Bấm nút ? trên thanh trên cùng; 2) Gửi một phản hồi thử; 3) Xem phiên bản ở chân menu."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/05_roles_18_matrix_and_user_role_config.png",
               "caption": "Hình 01.1 — Màn hình Phân quyền (/roles): danh sách vai trò bên trái, ma trận quyền và phạm vi bên phải"
            }
         ],
         "notes": [
            "Dùng một mã nhận diện chung cho dữ liệu thử (VD thêm -UAT01 vào ghi chú đơn hàng) để truy vết từ Báo giá tới Giao hàng.",
            "Chỉ kiểm thử trên dữ liệu thử. Chứng từ đã chốt (phiếu kho đã chốt, phiếu giao Đã giao, kiểm kê đã cân đối) không xoá được, phải hủy theo đúng quy trình của chương tương ứng.",
            "Menu bên trái mở sẵn 3 nhóm Kinh doanh, Kế hoạch, Xưởng sản xuất; nhóm khác bấm để mở. Ô tìm kiếm chỉ có trên thanh trên cùng.",
            "Mục không đạt: gửi phản hồi kèm mã mục checklist, mã chứng từ và ảnh. Phiếu được xử lý sẽ chuyển Hoàn thành; anh/chị thử lại và báo nếu còn lỗi."
         ],
         "subFlows": [
            {
               "name": "Kinh doanh (Sale) — Chương 04: SALE-04-01 đến SALE-04-13 (13 mục); Chương 05: SALE-05-01 đến SALE-05-14 (14 mục); Chương 06: SALE-06-01 đến SALE-06-15 (15 mục)",
               "steps": [
                  "Thêm mới: Thêm khách hàng có MST (tra cứu MST), lập Báo giá có giá bán do anh/chị nhập, [Lập Đơn Hàng] từ báo giá, lưu đơn kèm người liên hệ, SĐT, email.",
                  "Xem: Mở chi tiết khách hàng, báo giá, đơn hàng: mã chứng từ cha (khách hàng, báo giá, sản phẩm) bấm được để mở; giá trị dài xuống dòng, không bị cắt \"…\".",
                  "Sửa / chuyển trạng thái: Gửi báo giá, khách duyệt; sửa đơn Bản nháp; [Duyệt Đơn] với khách đủ MST và địa chỉ; thử thanh trạng thái bấm bước không hợp lệ để thấy lý do.",
                  "Xoá / chặn: Xoá báo giá thử vào Thùng rác; thử xoá khách hàng đã có chứng từ để thấy bị chặn; thử hủy đơn đã có Lệnh SX đang chạy để thấy bị chặn.",
                  "Bàn giao: Đơn đã duyệt › [Lập Lệnh SX] sang Kế hoạch; tính giá chỉ ghi giá vốn, không đổi giá bán."
               ]
            },
            {
               "name": "Kế hoạch (Planning) — Chương 08: KH-08-01 đến KH-08-15 (15 mục); Chương 09: KH-09-01 đến KH-09-14 (14 mục)",
               "steps": [
                  "Thêm mới: Từ đơn hàng › [Lập Lệnh SX] (khổ in, UPS, bù hao %, 0% là hợp lệ); lập Kế hoạch vật tư, [Tạo ĐMH] cho vật tư thiếu.",
                  "Xem: Lệnh SX hiện link về Đơn hàng, Sản phẩm, Bài bình; Kế hoạch vật tư hiện đúng số Tồn khả dụng, Đã đặt, Còn thiếu.",
                  "Sửa / chuyển trạng thái: [Duyệt Ban Hành] (cần quyền Duyệt), [Chốt kế hoạch]; bulk [Bắt đầu chạy] chỉ cho lệnh Đã lên KH / Đã ban hành; [Tạm dừng] lệnh đang chạy.",
                  "Xoá / chặn: Hủy lệnh: công đoạn còn mở và kế hoạch vật tư chưa nhận tự hủy, số lượng trả về dòng đơn; thử xoá lệnh đã có nhật ký SX để thấy bị chặn.",
                  "Bàn giao: Sang Bình file (bài bình, ghi bản kẽm), Mua hàng (đơn mua từ kế hoạch), Kho vật tư (cấp phát), Xưởng (công đoạn)."
               ]
            },
            {
               "name": "Bình file (Prepress) & Khuôn kẽm — Chương 07: BF-07-01 đến BF-07-14 (14 mục); Chương 10: BF-10-01 đến BF-10-14 (14 mục)",
               "steps": [
                  "Thêm mới: Tab Chờ bình › chọn dòng cùng đơn, cùng giấy, cùng cán màng › bình bài; [Gửi ghi bản kẽm] rồi [Ghi bản kẽm xong] tạo bộ kẽm Chờ nghiệm thu.",
                  "Xem: Bài bình, bản kẽm, khuôn hiện link về Lệnh SX, Đơn hàng, Sản phẩm; ảnh sản phẩm / bài bình hiện trên danh sách.",
                  "Sửa / chuyển trạng thái: Thử ghép 2 dòng khác giấy hoặc khác cán màng để thấy thông báo chặn; nghiệm thu kẽm, lắp máy in; khuôn chuyển bảo dưỡng.",
                  "Xoá / chặn: Hủy bài bình chưa có lệnh; thử [Gửi ghi bản kẽm] khi công đoạn in chưa gán máy để thấy lý do \"chưa giao máy in, chưa biết khổ kẽm\".",
                  "Bàn giao: Bài bình › Lập Lệnh SX qua form (từng bài); kẽm, khuôn sẵn sàng cho Xưởng in và bế."
               ]
            },
            {
               "name": "Sản xuất (Xưởng) — Chương 11: SX-11-01 đến SX-11-14 (14 mục)",
               "steps": [
                  "Thêm mới: Ghi nhật ký sản xuất cho công đoạn (máy, ca, SL đạt, SL hỏng); ghi dừng máy / bảo trì; bàn giao BTP giữa công đoạn.",
                  "Xem: Nhật ký hiện link về Lệnh SX, công đoạn, máy; màn cảm ứng xưởng dùng được trên điện thoại 390px.",
                  "Sửa / chuyển trạng thái: Sửa nhật ký đã lưu: Lệnh SX và công đoạn bị khoá, chỉ sửa số lượng, giờ; thử bắt đầu công đoạn khi lệnh chưa ban hành hoặc thiếu kẽm / khuôn để thấy lý do.",
                  "Xoá / chặn: Ghi nhầm lệnh thì xoá nhật ký và nhập lại; thử nhập SL vượt 105% công đoạn trước để thấy bị chặn.",
                  "Bàn giao: Thành phẩm sang QC (FQC) rồi Đóng Gói & Nhập Kho."
               ]
            },
            {
               "name": "Chất lượng (QC) — Chương 12: QC-12-01 đến QC-12-16 (16 mục)",
               "steps": [
                  "Thêm mới: IQC lô vật tư theo đơn mua; IPQC công đoạn; FQC thành phẩm; lập NCR từ phiếu QC không đạt (nguồn phát hiện IQC, IPQC, FQC, Khách hàng, NCC, Nội bộ đều lưu được).",
                  "Xem: Phiếu QC hiện link về Lệnh SX, đơn mua, lô, sản phẩm; NCR hiện đủ D1 đến D8.",
                  "Sửa / chuyển trạng thái: IQC Đạt › lô hiện ở Kho vật tư tab Chờ nhập kho; FQC không vượt kế hoạch; NCR Sửa / CAPA lưu D5, D7; [Đóng NCR] thiếu nội dung thì báo thiếu gì.",
                  "Xoá / chặn: Thử sửa / xoá FQC đã đóng gói để thấy bị chặn.",
                  "Bàn giao: IQC sang Kho vật tư (nhập kho); FQC sang Đóng gói, Kho thành phẩm, Giao hàng."
               ]
            },
            {
               "name": "Kho vật tư & Mua hàng — Chương 13: MH-13-01 đến MH-13-10 (10 mục); Chương 14: KHO-14-01 đến KHO-14-11 (11 mục)",
               "steps": [
                  "Thêm mới: Đơn mua: chọn NCC, ô Vật tư liệt kê vật tư của NCC lên đầu; [Gửi duyệt] hàng loạt; nhập kho từ tab Chờ nhập kho; cấp phát cho Lệnh SX; thêm vị trí kệ.",
                  "Xem: Phiếu kho hiện link về đơn mua, Lệnh SX, lô IQC; Báo cáo NXT và Sổ kho khớp số với phiếu.",
                  "Sửa / chuyển trạng thái: Kiểm kê: [Lưu Phiếu Kiểm Kê] › gửi duyệt › [Duyệt & Cân đối kho] tạo phiếu NK-KK / XK-KK; thử nhập vật tư vào kho khác loại để thấy bị chặn.",
                  "Xoá / chặn: Thử xuất quá tồn để thấy bị chặn; thử nhận quá SL đặt + 5% để thấy bị chặn.",
                  "Bàn giao: Vật tư đã nhập kho sẵn cho cấp phát; tồn và Kế hoạch vật tư cập nhật ngay."
               ]
            },
            {
               "name": "Giao hàng — Chương 14: GH-14-01 đến GH-14-06 (6 mục)",
               "steps": [
                  "Thêm mới: Từ lô đã đóng gói và nhập kho › lập phiếu giao (một phiếu chỉ một khách hàng); in phiếu giao, tem thùng.",
                  "Xem: Phiếu giao hiện link về Đơn hàng, Khách hàng, lô đóng gói; số đã giao trên đơn hàng cập nhật đúng.",
                  "Sửa / chuyển trạng thái: Chuyển Đang giao › Đã giao; lùi hoặc hủy phiếu thì hàng trả về kho đúng một lần.",
                  "Xoá / chặn: Thử giao vượt SL đặt + bù hao để thấy bị chặn; thử gom 2 khách vào một phiếu để thấy bị chặn.",
                  "Bàn giao: Đơn giao đủ trong dung sai › Kinh doanh [Chốt hoàn tất]; sang Kế toán thu tiền."
               ]
            },
            {
               "name": "Thiết bị & Báo cáo (bổ sung 03/11/2026) — Chương 17: TB-17-01 đến TB-17-06 (6 mục); Chương 18: BC-18-01 đến BC-18-06 (6 mục)",
               "steps": [
                  "Thiết bị: báo sự cố, tiếp nhận, nghiệm thu, lập lịch PM, xuất Excel (kỹ thuật cơ điện, quản đốc).",
                  "Báo cáo: Dashboard theo kỳ, cảnh báo vận hành, báo cáo bán hàng khớp danh sách đơn, sổ kho, tiến độ công đoạn (Ban Giám đốc, kế hoạch, kế toán)."
               ]
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 02. Phản Hồi, Hướng Dẫn Sử Dụng, Lịch Sử Cập Nhật & Ô Tìm Kiếm Trên Header
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "feedback_guide",
         "aliases": [
            "feedback",
            "feedbacks",
            "help",
            "bug",
            "support",
            "my-requests",
            "guide",
            "changelog",
            "search"
         ],
         "title": "02. Phản Hồi, Hướng Dẫn Sử Dụng, Lịch Sử Cập Nhật & Ô Tìm Kiếm Trên Header",
         "icon": "MessageSquarePlus",
         "isoRef": "HD-FB-02",
         "purpose": "Hướng dẫn người dùng dùng 3 phân hệ hỗ trợ chuẩn có trên mọi màn hình: Phản hồi (/feedback) để báo lỗi, góp ý cải tiến hoặc đặt câu hỏi kèm ảnh chụp màn hình và theo dõi kết quả xử lý; Hướng dẫn sử dụng (/guide) để tra cứu cẩm nang theo chương, in hoặc tải PDF; Lịch sử cập nhật (/changelog) để xem nội dung từng phiên bản phần mềm. Kèm cách dùng ô tìm kiếm trên thanh tiêu đề (header) để lọc nhanh danh sách đang mở.",
         "scope": [
            "Áp dụng cho mọi tài khoản đã đăng nhập: ai cũng gửi được phản hồi, xem được danh sách phiếu, bình luận trên phiếu, đọc Hướng dẫn sử dụng và Lịch sử cập nhật.",
            "Người xử lý phiếu: tài khoản có quyền Duyệt (approve) ở phân hệ Góp ý & Hỗ trợ trong màn hình Phân quyền (/roles), và tài khoản Quản trị (ADMIN). Đóng phiếu và mở lại phiếu đã đóng: thêm Giám đốc (DIRECTOR) và Quản lý (MANAGER).",
            "Menu: Hỗ Trợ -> Phản hồi hệ thống (/feedback), Hướng dẫn sử dụng (/guide), Nhật ký Release (/changelog). Nút tròn Gửi phản hồi nổi ở góc dưới bên phải mọi màn hình.",
            "Ô tìm kiếm trên header áp dụng cho các trang danh sách; không hiện ở Dashboard (/), ở trang chi tiết/biểu mẫu và ở một số màn hình xưởng (/factory/operator, /factory/shopfloor, /factory/production-scheduling, /factory/machines)."
         ],
         "references": [
            "ISO 9001:2015 mục 7.4 — Trao đổi thông tin",
            "ISO 9001:2015 mục 7.5 — Thông tin dạng văn bản (cẩm nang hướng dẫn, nhật ký phiên bản)",
            "ISO 9001:2015 mục 9.1.2 — Sự thỏa mãn của khách hàng (ghi nhận phản hồi người dùng)",
            "ISO 9001:2015 mục 10.2 — Sự không phù hợp và hành động khắc phục"
         ],
         "terms": [
            {
               "term": "Phiếu phản hồi (#FB-XXXXXX)",
               "definition": "Mỗi lần gửi phản hồi tạo một phiếu có mã riêng. Phiếu gồm Loại, Mức độ, Tiêu đề, Mô tả, Module, Trang, tối đa 6 ảnh, lịch sử và bình luận."
            },
            {
               "term": "Loại phản hồi",
               "definition": "Lỗi, Cải tiến, Câu hỏi."
            },
            {
               "term": "Mức độ",
               "definition": "Thấp, Trung bình (mặc định), Cao, Khẩn cấp."
            },
            {
               "term": "Trạng thái phiếu",
               "definition": "Mới -> Đang xử lý -> Hoàn thành -> Đã đóng. Phiếu Hoàn thành hoặc Đã đóng có thể được mở lại về Đang xử lý kèm lý do."
            },
            {
               "term": "Nguồn phiếu",
               "definition": "Người dùng (gửi tay), QA Tester (phiếu do tài khoản kiểm thử gửi, hệ thống tự gắn) hoặc Hệ thống — Tự động (Trình duyệt) / Tự động (Máy chủ): phiếu do hệ thống tự tạo khi màn hình hoặc máy chủ gặp lỗi kỹ thuật. Trang /feedback có các chip lọc nhanh Tất cả / Người dùng / QA Tester / Hệ thống kèm số phiếu."
            },
            {
               "term": "Thông tin chẩn đoán",
               "definition": "Ô Đính kèm thao tác gần đây & thông tin chẩn đoán (bật sẵn) gửi kèm khoảng 50 thao tác gần nhất trên tab đang dùng (trang đã mở, nút đã bấm, lời gọi API, lỗi), lỗi console và môi trường trình duyệt để người xử lý tái hiện đúng các bước. Hệ thống không bao giờ ghi nội dung bạn gõ vào ô nhập hay mật khẩu; email, số điện thoại, mã số thuế, CCCD trong thông báo lỗi được che. Bỏ chọn ô này nếu không muốn đính kèm."
            },
            {
               "term": "Nhật ký sự kiện (dành cho người xử lý)",
               "definition": "Khối trên chi tiết phiếu, chỉ người xử lý và Quản trị viên thấy: một dòng thời gian gộp thao tác trên trình duyệt, request máy chủ và lịch sử thay đổi dữ liệu của người gửi trong 15 phút trước đến 2 phút sau lúc gửi phiếu. Dòng lỗi tô đỏ, các bước cùng một request gom thành một khối; nút [Sao chép cho dev] chép toàn bộ dòng thời gian. Người dùng thường không thấy khối này."
            },
            {
               "term": "Kết quả xử lý",
               "definition": "Khối hiện trên phiếu Hoàn thành / Đã đóng: ghi chú kết quả ngắn gọn và so sánh ảnh Trước / Sau khi sửa."
            },
            {
               "term": "Ô tìm kiếm trên header",
               "definition": "Ô Tìm kiếm trong <tên màn hình>... ở thanh trên cùng, lọc danh sách đang mở theo từ khóa trên toàn bộ các trang của danh sách đó (không tìm chéo sang phân hệ khác)."
            }
         ],
         "responsibilities": [
            {
               "role": "Mọi người dùng",
               "tasks": [
                  "Gửi phản hồi ngay tại màn hình gặp vấn đề bằng nút tròn Gửi phản hồi hoặc nút [Tạo phiếu] trên trang /feedback.",
                  "Ghi Tiêu đề và Mô tả theo gợi ý Bước làm / Mong muốn / Thực tế, đính kèm ảnh và khoanh vị trí lỗi.",
                  "Sửa nội dung hoặc thêm ảnh cho phiếu do mình gửi; bình luận khi cần bổ sung thông tin.",
                  "Khi phiếu chuyển Hoàn thành: đọc Kết quả xử lý, thử lại thao tác; nếu còn lỗi thì bình luận ngay trên phiếu."
               ]
            },
            {
               "role": "Người xử lý (quyền Duyệt ở Góp ý & Hỗ trợ, ADMIN)",
               "tasks": [
                  "Bấm [Bắt đầu xử lý] để nhận phiếu Mới.",
                  "Mở khối Nhật ký sự kiện trên chi tiết phiếu để xem người gửi đã làm gì ngay trước khi gửi (trang, nút bấm, request lỗi); bấm [Chỉ lỗi] để lọc dòng lỗi, [Sao chép cho dev] để chuyển cho đội kỹ thuật.",
                  "Bấm [Hoàn thành] khi đã sửa xong: nhập Kết quả xử lý (tối đa 400 ký tự) và với phiếu loại Lỗi đính kèm ít nhất 1 ảnh sau khi sửa.",
                  "Bấm [Mở lại] phiếu Hoàn thành khi cần làm tiếp (bắt buộc ghi lý do)."
               ]
            },
            {
               "role": "Trưởng nhóm duyệt đóng (DIRECTOR, MANAGER, ADMIN và người xử lý)",
               "tasks": [
                  "Bấm [Đóng phiếu] sau khi người dùng đã kiểm tra thực tế OK.",
                  "Bấm [Mở lại] phiếu Đã đóng nếu lỗi quay lại (bắt buộc ghi lý do)."
               ]
            },
            {
               "role": "Quản trị viên (ADMIN)",
               "tasks": [
                  "Sửa được mọi phiếu; là vai trò duy nhất được phép xóa phiếu phía máy chủ (màn hình hiện chưa có nút Xóa phiếu).",
                  "Cấp hoặc thu hồi quyền Duyệt ở phân hệ Góp ý & Hỗ trợ tại /roles để chỉ định người xử lý."
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "Mọi người dùng đã đăng nhập",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "❌",
               "approve": "❌",
               "export": "❌",
               "statusRules": "Xem toàn bộ phiếu; sửa và thêm/xóa ảnh trước chỉ trên phiếu do mình gửi; sửa được phiếu nguồn Tự động; bình luận trên mọi phiếu"
            },
            {
               "role": "Người xử lý (quyền Duyệt ở Góp ý & Hỗ trợ)",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "❌",
               "approve": "✅",
               "export": "❌",
               "statusRules": "Bắt đầu xử lý, Hoàn thành, Mở lại, Đóng phiếu; kéo thả thẻ trên Kanban (máy tính)"
            },
            {
               "role": "DIRECTOR / MANAGER (không có quyền Duyệt)",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "❌",
               "approve": "✅",
               "export": "❌",
               "statusRules": "Chỉ Đóng phiếu Hoàn thành và Mở lại phiếu Đã đóng"
            },
            {
               "role": "ADMIN",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "❌",
               "statusRules": "Toàn quyền; xóa phiếu chỉ thực hiện được phía máy chủ"
            }
         ],
         "processFlowchart": "graph TD\n    A[Gặp lỗi hoặc có góp ý] --> B[Bấm nút tròn Gửi phản hồi]\n    B --> C[Chọn Loại và Mức độ, nhập Tiêu đề và Mô tả]\n    C --> D[Chụp HD, Chụp nhanh, chọn ảnh hoặc dán Ctrl V]\n    D --> E[Cắt vùng và Vẽ ghi chú]\n    E --> F[Gửi phản hồi, phiếu Mới có mã FB]\n    F --> G[Người xử lý bấm Bắt đầu xử lý]\n    G --> H[Đang xử lý]\n    H --> I[Hoàn thành kèm Kết quả xử lý và ảnh sau khi sửa]\n    I --> J{Người dùng thử lại}\n    J -->|Còn lỗi| K[Bình luận trên phiếu, người xử lý Mở lại]\n    K --> H\n    J -->|Đạt| L[Trưởng nhóm Đóng phiếu]\n    M[Màn hình gặp lỗi kỹ thuật] --> N[Hệ thống tự tạo phiếu nguồn Tự động]\n    N --> F",
         "mainFlow": [
            {
               "step": 1,
               "action": "Mở bảng Gửi phản hồi ngay tại màn hình đang làm",
               "detail": "• Bấm nút tròn màu xanh tím góc dưới bên phải (tooltip **Gửi phản hồi / Báo lỗi**). Trên điện thoại bảng mở từ dưới lên.\n• Ô **Module** (dạng Nhóm > Màn hình) và **Trang** (đường dẫn hiện tại) được điền sẵn, có thể sửa.\n• Nếu vừa có lỗi kỹ thuật, ô Tiêu đề có thể được gợi ý sẵn từ lỗi đó."
            },
            {
               "step": 2,
               "action": "Chọn Loại, Mức độ và nhập nội dung",
               "detail": "• **Loại**: `[Lỗi]`, `[Cải tiến]`, `[Câu hỏi]`.\n• **Mức độ**: `[Thấp]`, `[Trung bình]`, `[Cao]`, `[Khẩn cấp]`.\n• **Tiêu đề** (bắt buộc, tối đa 200 ký tự).\n• **Mô tả**: ghi theo gợi ý sẵn trong ô: Bước làm / Mong muốn / Thực tế; nên ghi mã chứng từ đang thao tác (VD mã đơn hàng, mã lệnh sản xuất)."
            },
            {
               "step": 3,
               "action": "Đính kèm ảnh (tối đa 6 ảnh, mỗi ảnh tối đa 10MB)",
               "detail": "• Trên máy tính: `[Chụp HD]` chụp từ thẻ trình duyệt (trình duyệt hỏi chia sẻ, chọn **Chia sẻ thẻ này**); nếu từ chối hoặc không hỗ trợ, hệ thống tự chuyển sang chụp nhanh. `[Chụp nhanh]` chụp ngay trong nền. Ngoài ra có nút chọn ảnh từ máy, dán ảnh bằng Ctrl+V / ⌘+V hoặc kéo thả ảnh vào bảng.\n• Sau khi chụp: bấm một lần để giữ khung hình, kéo chuột để cắt vùng rồi bấm `[✓ Cắt vùng này]` (Enter), hoặc `[✓ Dùng toàn màn hình]` (Enter); `[✕ Hủy]` (ESC) để bỏ.\n• Trên điện thoại/máy tính bảng: `[Chụp ảnh]` (camera) hoặc `[Chọn từ thư viện]`."
            },
            {
               "step": 4,
               "action": "Khoanh vị trí lỗi trên ảnh",
               "detail": "• Bấm **Vẽ ghi chú** dưới ảnh vừa chụp (hoặc biểu tượng bút trên từng ảnh) để mở trình vẽ: Bút vẽ, Khoanh vùng, Viết chữ, Hoàn tác, Xóa hết; bấm `[Xong]` để lưu, `[✕ Hủy]` để bỏ.\n• **Cắt lại từ ảnh gốc** để chọn lại vùng mà không phải chụp lại; biểu tượng thùng rác để xóa ảnh."
            },
            {
               "step": 5,
               "action": "Gửi phản hồi",
               "detail": "• Giữ ô **Đính kèm thông tin chẩn đoán** (bật sẵn) để người xử lý có thêm dữ liệu kỹ thuật.\n• Bấm `[Gửi phản hồi]`. Thông báo **Đã gửi phản hồi #FB-XXXXXX** hiện kèm nút `[Mở phiếu]`. Phiếu mới ở trạng thái **Mới**.\n• Nút `[Gửi phản hồi]` bị mờ khi chưa có Tiêu đề hoặc ảnh đang tải lên."
            },
            {
               "step": 6,
               "action": "Theo dõi phiếu tại Phản hồi hệ thống (/feedback)",
               "detail": "• Vào `Hỗ Trợ -> Phản hồi hệ thống (/feedback)`. Chế độ **Danh sách** gom phiếu theo ngày gửi (Hôm nay, Hôm qua, ngày/tháng/năm) kèm số phiếu mỗi ngày; máy tính hiện dạng bảng (Mã, Tiêu đề, Loại, Mức độ, Trạng thái, Người gửi, Giờ), 20 phiếu/trang; điện thoại hiện thẻ và nút Tải thêm.\n• Chip trạng thái phía trên: Tất cả, Mới, Đang xử lý, Hoàn thành, Đã đóng (kèm số lượng).\n• Lọc nhanh nguồn: Tất cả nguồn / Người dùng / Tự động, kèm bộ đếm **lỗi tự động (24h)**. `[Bộ lọc]`: Nguồn, Loại, Mức độ, Module, Từ ngày, Đến ngày; `[Xóa bộ lọc]`.\n• Tìm theo mã phiếu, tiêu đề hoặc module bằng ô tìm kiếm trên header.\n• Chế độ **Kanban**: 4 cột theo trạng thái, mỗi cột có Tải thêm riêng."
            },
            {
               "step": 7,
               "action": "Xem chi tiết, sửa phiếu và bổ sung ảnh",
               "detail": "• Bấm vào một phiếu để mở cửa sổ chi tiết ngay trên danh sách (/feedback/$feedbackId); đóng bằng nút X, phím Esc hoặc bấm ra ngoài để quay lại đúng bộ lọc đang xem. Trên điện thoại cửa sổ phủ toàn màn hình.\n• Chi tiết gồm: Mô tả, **Ảnh trước** (x/6), Thông tin chẩn đoán (có `[Sao chép cho dev/agent]`), Lịch sử & bình luận, khối Thông tin phiếu (Mã phiếu, Trạng thái, Loại, Mức độ, Nguồn, Phiên bản, Người gửi, Người xử lý, Ngày gửi, Cập nhật).\n• Người gửi phiếu (hoặc ADMIN) thấy nút `[Sửa]` để sửa Tiêu đề, Loại, Mức độ, Mô tả, ảnh rồi bấm `[Lưu thay đổi]`; thêm ảnh bằng `[Thêm ảnh]` ở khung Ảnh trước hoặc xóa ảnh (có hỏi xác nhận).\n• Bình luận: nhập ở ô **Viết bình luận...**, đính kèm ảnh nếu cần, bấm `[Gửi]`."
            },
            {
               "step": 8,
               "action": "Xem kết quả xử lý và thử lại",
               "detail": "• Khi phiếu **Hoàn thành**, khối **Kết quả xử lý** hiện ghi chú kết quả và ảnh **Trước** / **Sau khi sửa**.\n• Thử lại đúng thao tác đã báo. Nếu vẫn lỗi, bình luận ngay trên phiếu để người xử lý bấm `[Mở lại]`. Nếu đạt, trưởng nhóm sẽ bấm `[Đóng phiếu]`."
            },
            {
               "step": 9,
               "action": "Tra cứu Hướng dẫn sử dụng (/guide)",
               "detail": "• Mở từ `Hỗ Trợ -> Hướng dẫn sử dụng`, từ menu tài khoản góc phải `Hướng dẫn sử dụng Go-Live`, hoặc biểu tượng dấu hỏi trên tiêu đề các trang danh sách (tooltip **Xem cẩm nang hướng dẫn sử dụng màn hình này**) để mở đúng chương của màn hình đang xem.\n• Ô tìm kiếm **Tìm chương, kịch bản test CRUD, checklist Go-Live, nghiệp vụ...** lọc danh sách chương (hiện số x/y Chương). Chọn chương ở **Mục lục Cẩm nang**.\n• `[Xem Theo Chương]` hoặc `[Xem Toàn Bộ (… Chương)]`; `[In Chương Này]`, `[In / Xuất PDF Toàn Bộ]` (in qua trình duyệt, chọn Lưu thành PDF để có file PDF)."
            },
            {
               "step": 10,
               "action": "Xem Lịch sử cập nhật (/changelog) và phiên bản đang dùng",
               "detail": "• Vào `Hỗ Trợ -> Nhật ký Release (/changelog)`: các phiên bản xếp theo thời gian, bản đầu tiên gắn nhãn **Mới nhất** và mở sẵn; bấm từng phiên bản để mở/thu gọn danh sách thay đổi. Mục **Tài liệu liên quan** mở chương hướng dẫn tương ứng ở thẻ mới.\n• Số phiên bản đang dùng hiện ở chân thanh menu bên trái (**APV-ERP v...**), lấy từ phiên bản mới nhất trong Lịch sử cập nhật.\n• Chuông thông báo trên header hiện các bản cập nhật mới chưa xem; bấm **Xem tất cả cập nhật** để mở /changelog."
            },
            {
               "step": 11,
               "action": "Dùng ô tìm kiếm trên header",
               "detail": "• Ở trang danh sách, gõ vào ô **Tìm kiếm trong <tên màn hình>...**: danh sách lọc ngay, trên toàn bộ các trang, và quay về trang 1. Từ khóa được giữ trên đường dẫn (tham số q) nên quay lại trang vẫn còn.\n• Phím Esc xóa từ khóa. Trên điện thoại bấm biểu tượng kính lúp (**Tìm kiếm nhanh**) để mở ô tìm kiếm.\n• Các trang danh sách không có ô tìm kiếm riêng trong trang; luôn dùng ô trên header."
            }
         ],
         "subFlows": [
            {
               "name": "Thêm phiếu từ trang /feedback (không qua nút tròn)",
               "steps": [
                  "Trên /feedback bấm `[Tạo phiếu]`.",
                  "Hộp **Gửi phản hồi**: nhập Tiêu đề (bắt buộc), chọn Loại, Mức độ, nhập Mô tả, Module (mặc định Hệ thống chung) và Trang.",
                  "Thêm ảnh bằng nút chọn ảnh, dán Ctrl+V hoặc kéo thả (tối đa 6, ảnh đầu là Ảnh bìa); giữ hoặc bỏ Đính kèm thông tin chẩn đoán.",
                  "Bấm `[Gửi phản hồi]` hoặc `[Hủy]`."
               ]
            },
            {
               "name": "Sửa phiếu đã gửi",
               "steps": [
                  "Mở chi tiết phiếu do mình gửi, bấm `[Sửa]`.",
                  "Hộp **Sửa phiếu #FB-...** cho phép đổi Tiêu đề, Loại, Mức độ, Mô tả, ảnh.",
                  "Bấm `[Lưu thay đổi]`. Người không phải người gửi (và không phải ADMIN) không thấy nút Sửa; máy chủ cũng chặn với thông báo **Bạn chỉ có thể chỉnh sửa phiếu phản hồi do chính mình tạo**."
               ]
            },
            {
               "name": "Bổ sung hoặc xóa Ảnh trước",
               "steps": [
                  "Trong chi tiết phiếu, khung **Ảnh trước (x/6)** bấm `[Thêm ảnh]` (điện thoại: Chụp ảnh / Chọn từ thư viện).",
                  "Xóa ảnh bằng nút Xóa ảnh trên ảnh, xác nhận **Xóa ảnh này khỏi phiếu?**.",
                  "Chỉ người gửi phiếu hoặc ADMIN làm được."
               ]
            },
            {
               "name": "Bình luận trên phiếu",
               "steps": [
                  "Ở khối **Lịch sử & bình luận**, nhập nội dung vào **Viết bình luận...** và/hoặc bấm Đính kèm ảnh (tối đa 6).",
                  "Bấm `[Gửi]`. Phải có nội dung hoặc ít nhất 1 ảnh.",
                  "Lịch sử ghi cả các lần đổi trạng thái (VD: chuyển Mới → Đang xử lý) kèm ghi chú."
               ]
            },
            {
               "name": "Chuyển trạng thái (người xử lý / trưởng nhóm)",
               "steps": [
                  "Trong chi tiết phiếu, khối **Hành động** (máy tính) hoặc thanh nút dưới đáy (điện thoại) hiện các nút được phép: `[Bắt đầu xử lý]`, `[Hoàn thành]`, `[Mở lại]`, `[Đóng phiếu]`.",
                  "Hoàn thành: nhập **Kết quả xử lý** (bắt buộc, tối đa 400 ký tự, viết ngắn gọn bằng ngôn ngữ người dùng), với phiếu loại Lỗi phải có ít nhất 1 **Ảnh sau khi sửa**.",
                  "Mở lại: bắt buộc nhập **Lý do mở lại**. Bắt đầu xử lý / Đóng phiếu: ghi chú không bắt buộc.",
                  "Bấm `[Xác nhận]` hoặc `[Hủy]`.",
                  "Trên Kanban (máy tính) có thể kéo thẻ sang cột trạng thái khác; bước chuyển không hợp lệ bị chặn với thông báo **Không thể chuyển từ ... sang ...**."
               ]
            },
            {
               "name": "Phiếu tự động khi màn hình gặp lỗi",
               "steps": [
                  "Khi màn hình báo **Đã có lỗi xảy ra!**, hệ thống tự gửi phiếu và hiện **Đã tự động gửi báo lỗi #FB-...**.",
                  "Có các nút `[Tải lại trang]`, `[Thử lại]`, `[Thêm mô tả]` (mở bảng Gửi phản hồi để bổ sung mô tả, ảnh cho chính phiếu đó), `[Về trang chủ]`.",
                  "Cùng một lỗi lặp lại không tạo phiếu mới mà tăng **Tần suất** (số lần, số người); nếu phiếu đang Hoàn thành thì tự mở lại về Đang xử lý; nếu phiếu đã đóng thì tạo phiếu mới.",
                  "Lỗi kiểm tra dữ liệu thông thường (đã báo bằng thông báo trên màn hình) không tạo phiếu tự động."
               ]
            },
            {
               "name": "In / tải Hướng dẫn sử dụng",
               "steps": [
                  "Mở /guide, chọn chương cần in.",
                  "Bấm `[In Chương Này]` hoặc `[In / Xuất PDF Toàn Bộ]` rồi chọn máy in hoặc Lưu thành PDF trong hộp in của trình duyệt."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "Mới",
               "to": "Đang xử lý",
               "action": "[Bắt đầu xử lý]",
               "allowedRoles": "ADMIN, người có quyền Duyệt ở Góp ý & Hỗ trợ"
            },
            {
               "from": "Đang xử lý",
               "to": "Hoàn thành",
               "action": "[Hoàn thành] — bắt buộc Kết quả xử lý (≤ 400 ký tự); phiếu loại Lỗi cần ≥ 1 ảnh sau khi sửa",
               "allowedRoles": "ADMIN, người có quyền Duyệt ở Góp ý & Hỗ trợ"
            },
            {
               "from": "Hoàn thành",
               "to": "Đang xử lý",
               "action": "[Mở lại] — bắt buộc lý do; hoặc tự động khi lỗi tự động tái diễn",
               "allowedRoles": "ADMIN, người có quyền Duyệt ở Góp ý & Hỗ trợ; Hệ thống"
            },
            {
               "from": "Hoàn thành",
               "to": "Đã đóng",
               "action": "[Đóng phiếu]",
               "allowedRoles": "ADMIN, người có quyền Duyệt ở Góp ý & Hỗ trợ, DIRECTOR, MANAGER"
            },
            {
               "from": "Đã đóng",
               "to": "Đang xử lý",
               "action": "[Mở lại] — bắt buộc lý do",
               "allowedRoles": "ADMIN, người có quyền Duyệt ở Góp ý & Hỗ trợ, DIRECTOR, MANAGER"
            }
         ],
         "inlineViews": [
            {
               "name": "Chi tiết phiếu dạng cửa sổ",
               "trigger": "Bấm một phiếu trên /feedback",
               "description": "Mở /feedback/$feedbackId ngay trên danh sách; đóng bằng X, Esc hoặc bấm ra ngoài để quay lại đúng bộ lọc. Điện thoại phủ toàn màn hình."
            },
            {
               "name": "Tự điền Module và Trang",
               "trigger": "Mở nút tròn Gửi phản hồi",
               "description": "Module và đường dẫn trang hiện tại được điền sẵn, sửa được."
            },
            {
               "name": "Thông tin chẩn đoán",
               "trigger": "Chi tiết phiếu có đính kèm chẩn đoán",
               "description": "Các thẻ Console & Lỗi, API lỗi, Thao tác, Môi trường; nút Sao chép cho dev/agent."
            },
            {
               "name": "Hướng dẫn theo màn hình",
               "trigger": "Biểu tượng dấu hỏi trên tiêu đề trang danh sách",
               "description": "Mở /guide đúng chương của màn hình đang xem."
            }
         ],
         "quickActions": [
            {
               "action": "Dán ảnh vào phản hồi",
               "shortcut": "Ctrl+V / ⌘+V",
               "description": "Dán ảnh từ clipboard vào bảng Gửi phản hồi, hộp Tạo phiếu, hộp chuyển trạng thái."
            },
            {
               "action": "Xác nhận vùng chụp",
               "shortcut": "Enter",
               "description": "Cắt vùng đã chọn hoặc dùng toàn màn hình."
            },
            {
               "action": "Hủy chụp / đóng chi tiết phiếu",
               "shortcut": "Esc",
               "description": "Bỏ chụp màn hình; đóng cửa sổ chi tiết phiếu."
            },
            {
               "action": "Xóa từ khóa tìm kiếm trên header",
               "shortcut": "Esc",
               "description": "Xóa từ khóa và bỏ lọc danh sách."
            },
            {
               "action": "Kéo thả ảnh",
               "description": "Kéo ảnh từ máy vào bảng Gửi phản hồi hoặc hộp Tạo phiếu."
            },
            {
               "action": "Kéo thả thẻ Kanban",
               "description": "Đổi trạng thái phiếu trên máy tính (chỉ người có quyền xử lý)."
            }
         ],
         "uatChecklist": [
            {
               "id": "FB-01",
               "item": "Tự điền Module và Trang",
               "standard": "Mở nút tròn Gửi phản hồi tại một màn hình: Module và Trang đúng màn hình đang đứng.",
               "method": "Kiểm tra 2 ô Module và Trang trong bảng Gửi phản hồi."
            },
            {
               "id": "FB-02",
               "item": "Đính kèm và khoanh ảnh",
               "standard": "Có ít nhất 1 ảnh (Chụp HD, Chụp nhanh, chọn ảnh hoặc Ctrl+V) và đã khoanh vị trí lỗi; không vượt 6 ảnh.",
               "method": "Dùng [Chụp HD] hoặc chọn ảnh, bấm Vẽ ghi chú, [Xong]."
            },
            {
               "id": "FB-03",
               "item": "Mô tả đủ Bước làm / Mong muốn / Thực tế",
               "standard": "Mô tả nêu mã chứng từ, các bước đã làm, kết quả mong muốn và thực tế.",
               "method": "Đọc lại ô Mô tả trước khi bấm [Gửi phản hồi]."
            },
            {
               "id": "FB-04",
               "item": "Sửa và thêm ảnh sau khi tạo",
               "standard": "Người gửi bấm [Sửa] / [Thêm ảnh] cập nhật ngay; người khác không thấy các nút này.",
               "method": "Thử trên 1 phiếu của mình và 1 phiếu của người khác."
            },
            {
               "id": "FB-05",
               "item": "Hoàn thành bắt buộc kết quả và ảnh sau",
               "standard": "Không bấm [Xác nhận] được khi thiếu Kết quả xử lý, hoặc thiếu ảnh sau khi sửa với phiếu loại Lỗi.",
               "method": "Người xử lý thử chuyển một phiếu Lỗi sang Hoàn thành."
            },
            {
               "id": "FB-06",
               "item": "Hướng dẫn mở đúng chương",
               "standard": "Bấm biểu tượng dấu hỏi trên một trang danh sách mở /guide đúng chương.",
               "method": "Thử trên 2–3 phân hệ khác nhau."
            },
            {
               "id": "FB-07",
               "item": "Phiên bản ở chân menu khớp Lịch sử cập nhật",
               "standard": "Số APV-ERP v... ở chân menu bằng phiên bản Mới nhất trên /changelog.",
               "method": "So sánh 2 vị trí."
            },
            {
               "id": "FB-08",
               "item": "Tìm kiếm trên header",
               "standard": "Gõ từ khóa lọc được bản ghi nằm ở trang sau của danh sách; Esc xóa lọc.",
               "method": "Thử trên /feedback và một danh sách nghiệp vụ."
            }
         ],
         "notes": [
            "Mọi lỗi và góp ý trong giai đoạn Go-Live gửi qua nút Phản hồi trên phần mềm để có mã phiếu và theo dõi đến khi xử lý xong; không gửi rời rạc qua tin nhắn cá nhân.",
            "Một phiếu tốt có ít nhất 1 ảnh và nêu rõ mã chứng từ đang thao tác (mã đơn hàng, lệnh sản xuất, sản phẩm...).",
            "Ảnh được tải lên máy chủ ngay khi đính kèm; mỗi ảnh tối đa 10MB, mỗi phiếu tối đa 6 ảnh.",
            "Mọi người dùng xem được tất cả phiếu phản hồi; không ghi mật khẩu hoặc thông tin nhạy cảm vào mô tả, bình luận.",
            "Phiếu chỉ được Đóng sau khi người dùng đã kiểm tra thực tế; người xử lý chỉ chuyển đến Hoàn thành.",
            "Phiên bản phần mềm lấy duy nhất từ Lịch sử cập nhật (/changelog); khi báo lỗi có thể đối chiếu số phiên bản ở chân menu."
         ],
         "forms": []
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 03. Dữ Liệu Gốc: Sản Phẩm, Loại SP, Vật Tư, Loại Vật Tư, Thiết Bị, Công Đoạn & Cấu Hình
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "master_data",
         "aliases": [
            "master",
            "master-data",
            "products",
            "product",
            "materials",
            "product-types",
            "material-types",
            "combobox"
         ],
         "title": "03. Dữ Liệu Gốc: Sản Phẩm, Loại SP, Vật Tư, Loại Vật Tư, Thiết Bị, Công Đoạn & Cấu Hình",
         "icon": "Database",
         "isoRef": "QT-DLG-03",
         "purpose": "Chuẩn hóa dữ liệu nền dùng chung cho mọi chứng từ: Sản phẩm (khách hàng, loại, kích thước, khổ trải, khổ giấy, số bát, số cái / thùng, hướng thớ giấy, FSC, vật tư và quy trình công đoạn), Loại sản phẩm, Vật tư, Loại vật tư, Thiết bị sản xuất (kể cả Khổ Kẽm CTP của máy in), Quy trình SX (công đoạn), Ma trận hao hụt và các danh mục Cấu hình. Báo giá, Đơn hàng, Bình file, Lệnh sản xuất, Mua hàng, Kho và Xưởng đều chọn dữ liệu từ các danh mục này.",
         "scope": [
            "Kinh doanh › Sản phẩm (/products) và Kinh doanh › Loại sản phẩm (/product-types): phòng Kinh doanh, Kỹ thuật.",
            "Mua hàng › Danh mục Vật tư và Mua hàng › Loại vật tư (/material-types); Kho › Mã & Tồn NVL (/materials): phòng Mua hàng, Kho. Danh mục Vật tư và Mã & Tồn NVL mở cùng một danh sách vật tư.",
            "Xưởng sản xuất › Thiết bị SX (/machines): Sản xuất, Bảo trì.",
            "Hệ Thống & Quy Trình › Quy trình SX (/processes), Ma trận Hao hụt (/waste-matrix), Cấu hình (/configs): Kỹ thuật, Kế hoạch, Quản trị hệ thống.",
            "Giai đoạn Go-Live: 16 vai trò nghiệp vụ được mở đủ Xem / Thêm / Sửa / Xoá trên các danh mục này; Admin thu hẹp lại tại Hệ Thống & Quy Trình › Phân quyền (Chương 16)."
         ],
         "references": [
            "ISO 9001:2015 mục 7.5 — Thông tin dạng văn bản (kiểm soát dữ liệu gốc)",
            "ISO 9001:2015 mục 8.5.1 — Kiểm soát sản xuất (định mức vật tư, quy trình công đoạn, thiết bị)",
            "FSC-STD-40-004 — Chuỗi hành trình sản phẩm (chứng nhận FSC trên sản phẩm)",
            "Chương 04 Khách hàng & Nhà cung cấp; Chương 10 Khuôn bế, Bản kẽm CTP; Chương 11 Xưởng sản xuất; Chương 13 Mua hàng; Chương 14 Kho"
         ],
         "terms": [
            {
               "term": "N.Sản phẩm",
               "definition": "Ô chọn Loại sản phẩm trên form Sản phẩm (bắt buộc). Danh sách lấy từ Kinh doanh › Loại sản phẩm; chưa có thì bấm dòng Thêm loại sản phẩm trong ô chọn."
            },
            {
               "term": "Số bát (Outs)",
               "definition": "Số con sản phẩm trên một tờ in, khai báo trên form Sản phẩm; dùng khi tính định mức vật tư và tính giá."
            },
            {
               "term": "Số cái / thùng",
               "definition": "Quy cách đóng thùng mặc định của sản phẩm; Đóng Gói & Nhập Kho lấy số này làm SP / thùng khi đóng gói và in tem thùng."
            },
            {
               "term": "Hướng thớ giấy (Grain)",
               "definition": "Ba lựa chọn: Tự do (Không khóa thớ), Thớ dọc (song song cạnh dài), Thớ ngang (song song cạnh ngắn). Khi chọn Thớ dọc hoặc Thớ ngang có thể tích ô 🔒 Khóa xoay thớ giấy (Chống nứt gân)."
            },
            {
               "term": "Chứng nhận nguồn gốc rừng (FSC CoC)",
               "definition": "Chọn một trong: Không yêu cầu FSC, FSC Mix Credit, FSC Recycled 100%, FSC 100% Pure Forest."
            },
            {
               "term": "SP Bộ/Combo",
               "definition": "Công tắc trên form Sản phẩm. Khi bật, form hiện khung Các thành phần của Bộ sản phẩm thay cho khung Chất liệu & Quy trình."
            },
            {
               "term": "Đồng bộ BOM",
               "definition": "Nút trên chi tiết Sản phẩm: bóc tách định mức vật tư và quy trình, lưu vào bảng Định mức & Quy trình chuẩn của sản phẩm và hiện bảng tổng kết Trước → Sau. Chỉ cập nhật giá vốn chuẩn, không đổi Đơn giá (Catalog)."
            },
            {
               "term": "Giá vốn chuẩn và Đơn giá (Catalog)",
               "definition": "Giá vốn chuẩn do [Tính giá vốn] / [Đồng bộ BOM] tính từ định mức, chỉ để tham khảo. Đơn giá (Catalog) là giá bán do Kinh doanh quyết định; hệ thống không tự tính hay ghi đè giá bán."
            },
            {
               "term": "Khổ Kẽm CTP",
               "definition": "Ô trên form Thiết bị SX dành cho máy in, VD 1030x800 mm. Mỗi máy in một khổ; dòng kẽm của lệnh lấy khổ theo máy in được giao, máy chưa khai khổ thì không gửi ghi bản kẽm được, bộ kẽm khác khổ không lắp được lên máy (Chương 10)."
            },
            {
               "term": "Ma trận hao hụt",
               "definition": "Mỗi công đoạn đã khai hao hụt trong Quy trình SX tự có một dòng gốc (hao phí setup và % bù hao chạy), chỉ xem, sửa tại công đoạn. Anh/chị thêm Bậc MOQ riêng để tính giá nhanh. Công thức hiển thị: Tổng phế phẩm dự toán = (Số lượng đặt x %) + số tờ / cái cố định."
            },
            {
               "term": "Lệnh SX hoạt động",
               "definition": "Lệnh sản xuất của sản phẩm chưa hủy, chưa xong (Bản nháp, Chế bản, Đã lên KH, Đã phát hành, Đang SX). Sửa sản phẩm khi còn lệnh như vậy phải xác nhận thêm một lần; các lệnh đã tạo giữ nguyên vật tư và công đoạn cũ."
            },
            {
               "term": "Thùng rác",
               "definition": "Tab trên danh sách Sản phẩm, Vật tư, Loại sản phẩm, Loại vật tư và Thiết bị SX. Bản ghi xoá được chuyển vào đây và có nút [Phục hồi]."
            }
         ],
         "responsibilities": [
            {
               "role": "Kinh doanh / Kỹ thuật",
               "tasks": [
                  "Tạo và cập nhật Sản phẩm, nhân bản sản phẩm, khai báo vật tư và quy trình công đoạn",
                  "Quản lý Loại sản phẩm",
                  "Bấm [Đồng bộ BOM] hoặc [Khác] › Chuẩn hóa dữ liệu khi cần lập định mức chuẩn; nhập Đơn giá (Catalog) theo giá bán đã chốt"
               ]
            },
            {
               "role": "Mua hàng / Kho",
               "tasks": [
                  "Tạo và cập nhật Vật tư, Loại vật tư",
                  "Theo dõi tồn kho vật tư (tự cập nhật khi chốt phiếu nhập / xuất kho)"
               ]
            },
            {
               "role": "Sản xuất / Bảo trì",
               "tasks": [
                  "Khai báo Thiết bị SX: loại máy, nhóm công đoạn, khổ làm việc, Khổ Kẽm CTP (máy in), năng suất chuẩn, thời gian setup, chu kỳ bảo trì, đơn giá thuê, khấu hao"
               ]
            },
            {
               "role": "Kỹ thuật / Kế hoạch / Quản trị",
               "tasks": [
                  "Quản lý Quy trình SX (công đoạn) và Ma trận Hao hụt",
                  "Bổ sung mục trong các danh mục Cấu hình (ĐVT, Nhóm vật tư, Loại phụ vật tư...)"
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền trên mọi danh mục"
            },
            {
               "role": "16 vai trò nghiệp vụ (cấu hình Go-Live mặc định)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Mở đủ quyền trên các danh mục. Nút [Thêm SP], [Thêm VT], [Thêm TB], [Thêm], [Sửa], [Xoá], [Nhập Excel] tự ẩn khi Admin tắt quyền tương ứng tại Phân quyền."
            },
            {
               "role": "Vai trò bị Admin thu hẹp quyền",
               "view": "👁",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Chỉ xem; Sản phẩm và Vật tư bị máy chủ chặn Thêm / Sửa / Xoá khi thiếu quyền; nút [Xuất Excel] vẫn hiện."
            }
         ],
         "processFlowchart": "graph TD\n    A[Cấu hình danh mục] --> B[Loại vật tư]\n    A --> C[Loại sản phẩm]\n    B --> D[Vật tư]\n    E[Thiết bị SX - có Khổ Kẽm CTP] --> F[Quy trình SX công đoạn]\n    F --> G[Ma trận hao hụt]\n    C --> H[Sản phẩm]\n    D --> H\n    F --> H\n    H --> I[Đồng bộ BOM và giá vốn chuẩn]\n    I --> J[Báo giá, Đơn hàng, Bình file, Lệnh SX dùng lại]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Chuẩn bị danh mục Cấu hình",
               "detail": "• Vào Hệ Thống & Quy Trình › Cấu hình. Danh mục chia theo nhóm (VD Hệ thống, Danh mục chung, Tài chính, Sản phẩm, Vật tư, Nhà cung cấp, Kế hoạch, Kỹ thuật, Sản xuất, Chất lượng, Kho vận); gõ ô Tìm danh mục... để tìm nhanh.\n• Chọn một danh mục, gõ tên vào ô Thêm ... cuối bảng rồi nhấn Enter để thêm; bấm vào mục để bật / tắt; biểu tượng xoá hỏi xác nhận trước khi xoá. Các ô chọn như Đơn vị tính, Nhóm vật tư, Loại phụ vật tư lấy dữ liệu từ đây.\n• Các lần cập nhật hệ thống không đặt lại nhóm công đoạn, đơn giá, cấu hình giá máy / công đoạn, bù hao và danh mục QC mà công ty đã chỉnh."
            },
            {
               "step": 2,
               "action": "Khai báo Loại vật tư và Vật tư",
               "detail": "• Mua hàng › Loại vật tư › [Thêm mới]: Mã loại vật tư (bắt buộc, tối đa 50 ký tự), Tên / Nhãn hiển thị chuẩn, Nhóm vật tư, Chất liệu chính, Định lượng GSM → [Tạo loại vật tư].\n• Mua hàng › Danh mục Vật tư (hoặc Kho › Mã & Tồn NVL) › [Thêm VT]: chọn Nhóm vật tư (bắt buộc), Loại vật tư, nhập Định lượng (GSM), Nhãn hiệu, Dài / Rộng (mm), Nhà cung cấp, Đơn vị tính, Mã vật tư, Tên gọi vật tư, Đơn giá, Tồn an toàn.\n• Bấm [Bóc tách quy cách] để tự điền thông số từ tên, [Tạo Tên & Mã] để sinh tên và mã → [Tạo mới]."
            },
            {
               "step": 3,
               "action": "Khai báo Thiết bị SX (có Khổ Kẽm CTP)",
               "detail": "• Xưởng sản xuất › Thiết bị SX › [Thêm TB] → trang Tạo Mới Thiết Bị.\n• 1. Thông Tin Nhận Diện: Mã Máy, Tên Máy (bắt buộc), Phân Loại Nhóm (chọn đúng loại máy, VD máy in offset), Danh Mục Công Đoạn, Hãng Sản Xuất, Năm Sản Xuất, ảnh máy.\n• 2. Năng Lực Kỹ Thuật: Khổ Làm Việc, Khổ Kẽm CTP (máy in) (VD 1030x800 mm; mỗi máy in một khổ), Định Lượng Giấy, Sản Lượng Chuẩn (/h), TG Setup (Phút), Công Suất (kW).\n• 3. Quản Trị Vận Hành (CMMS): Chu Kỳ Bảo Trì (Giờ / Ngày), Ngày Bảo Trì Dự Kiến, Đơn Giá Thuê (VNĐ/h), Khấu Hao (VNĐ/h) → [Tạo Mới Thiết Bị].\n• Máy in chưa khai Khổ Kẽm CTP thì lệnh dùng máy đó không gửi ghi bản kẽm được và máy hiện mờ khi lắp kẽm (Chương 10)."
            },
            {
               "step": 4,
               "action": "Khai báo Quy trình SX (công đoạn) và Ma trận Hao hụt",
               "detail": "• Hệ Thống & Quy Trình › Quy trình SX › [Thêm] → hộp Định nghĩa Công đoạn Mới: Tên Công Đoạn, Mã Công Đoạn (bắt buộc, VD IN-OFFSET-4-MAU), Nhóm Công Đoạn (Trước in / In ấn / Sau in / Thành phẩm / Khác), Loại Máy Mặc Định, Đơn Vị Tính, các định mức TG Setup Chuẩn (Phút), Tốc Độ Chuẩn (SL/Giờ), Hao Phí Setup (Tờ/Cái), % Bù Hao Chạy (%) và chi phí → [Lưu Công Đoạn].\n• Thêm nhanh công đoạn từ hộp Chọn công đoạn sản xuất trên form Sản phẩm ([Tạo mới]) thì chỉ cần nhập tên: mã công đoạn tự sinh từ tên, định mức tự khởi tạo, công đoạn mới được chọn sẵn vào sản phẩm.\n• Mã công đoạn đã xoá trước đây tạo lại được, không báo trùng.\n• Hệ Thống & Quy Trình › Ma trận Hao hụt: dòng gốc tự lấy từ công đoạn (bấm Sửa công đoạn để thay đổi). [Thêm Cấu Hình] để thêm Bậc MOQ riêng: Công Đoạn, MOQ, % Hao Hụt, Hao Hụt Cố Định, Trạng Thái Hoạt Động → [Thêm Mới]."
            },
            {
               "step": 5,
               "action": "Tạo Loại sản phẩm",
               "detail": "• Kinh doanh › Loại sản phẩm › [Thêm mới]: Mã loại sản phẩm (bắt buộc, tối đa 50 ký tự), Danh mục sản phẩm, Nhóm sản phẩm, Đơn vị tính (ĐVT), Thời gian SX chuẩn (ngày), Biên lợi nhuận định mức, Quy trình sản xuất chuẩn → [Tạo loại sản phẩm].\n• Bấm vào một dòng để mở khung chi tiết, bấm [Chỉnh Sửa] để sửa → [Lưu thay đổi]."
            },
            {
               "step": 6,
               "action": "Tạo Sản phẩm",
               "detail": "• Kinh doanh › Sản phẩm › [Thêm SP] → trang Tạo Sản Phẩm.\n• Khung Thông tin sản phẩm: Khách hàng*, N.Sản phẩm*, Mã sản phẩm (để trống thì hệ thống tự tạo theo khách hàng; chỉ gồm chữ, số, dấu gạch ngang, gạch dưới, tối đa 30 ký tự), Tên sản phẩm*, Đơn vị tính*, công tắc Đang dùng / Ngưng, SP Bộ/Combo, Dài* / Rộng* / Cao (mm, nhận số lẻ như 67,5), Khổ trải dài / rộng, Khổ giấy in, Khổ giấy mua, Số bát (Outs), Quy cách đóng gói, Số cái / thùng, Ghi chú, Hướng thớ giấy, Chứng nhận FSC, Hình ảnh (dán ảnh bằng Ctrl+V được).\n• Khung Chất liệu & Quy trình: Loại vật tư* (ít nhất 1), Vật tư cấu thành, Quy trình sản xuất* và phần Cấu hình định mức công đoạn & chi phí gia công.\n• Quy trình sản xuất: bấm [Chọn công đoạn] mở hộp Chọn công đoạn sản xuất với nút lọc Tất cả / Trước in / In ấn / Sau in / Thành phẩm và ô tìm tên hoặc mã; bấm vào dòng để chọn hoặc bỏ. Công đoạn chọn trước đứng trước; kéo ở cột Thứ tự để đổi chỗ; [Tạo mới] thêm công đoạn chưa có; [Xong (n công đoạn)] để áp dụng. Trên form các công đoạn hiện thành thẻ đánh số, kéo thả để đổi thứ tự, bấm × để bỏ; [Sắp theo chuẩn] xếp lại theo Trước in → In → Sau in → Thành phẩm. Bắt buộc có ít nhất 1 công đoạn In ấn và 1 công đoạn Thành phẩm.\n• Bấm [Tạo mới]. Thiếu ô bắt buộc thì ô tô đỏ, form tự cuộn tới ô đầu tiên và thông báo nêu tên từng ô."
            },
            {
               "step": 7,
               "action": "Sửa sản phẩm khi đang có Lệnh SX",
               "detail": "• Trên chi tiết sản phẩm bấm [Sửa], sửa thông tin rồi bấm [Cập nhật].\n• Nếu sản phẩm đang có Lệnh SX hoạt động, lần bấm đầu hiện cảnh báo: Sản phẩm … đang có n Lệnh SX hoạt động. Thay đổi BOM/quy trình sẽ KHÔNG áp dụng cho các Lệnh SX đã tạo … Bấm Cập nhật lần nữa để xác nhận. Sản phẩm chưa được lưu ở lần này.\n• Bấm [Cập nhật] lần nữa để lưu. Các lệnh đã tạo giữ nguyên vật tư và công đoạn cũ; cần đổi trên lệnh thì người lập lệnh sửa ở form lệnh (Chương 08)."
            },
            {
               "step": 8,
               "action": "Hoàn thiện định mức và theo dõi trên trang chi tiết",
               "detail": "• Chi tiết sản phẩm: thông tin phẳng kèm ảnh; Khách hàng là đường dẫn mở hồ sơ khách. Các tab Định mức Vật tư, Quy trình, Bảng chiết giá, Đơn hàng, Giao hàng, Khuôn & Kẽm; cuối trang có Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật.\n• [Tính giá vốn] mở hộp Dự tính & Đối soát Giá vốn chuẩn → [Xác nhận cập nhật giá vốn] chỉ ghi Giá vốn chuẩn. [Đồng bộ BOM] lưu định mức và quy trình chuẩn, hiện bảng Trước → Sau.\n• Nhãn phiên bản (VD v3) cạnh mã sản phẩm mở lịch sử phiên bản; mỗi lần cập nhật tăng phiên bản."
            }
         ],
         "subFlows": [
            {
               "name": "Sản phẩm — Thêm mới / Nhân bản",
               "steps": [
                  "Tại Kinh doanh › Sản phẩm bấm [Thêm SP] (cần quyền Thêm). Khi tạo mới, ô chọn sản phẩm cạnh tiêu đề Thông tin sản phẩm cho phép chọn một sản phẩm có sẵn để chép kích thước, khổ, BOM và quy trình sang form mới.",
                  "Hoặc trên chi tiết bấm [Nhân bản]; hoặc trên danh sách bấm biểu tượng Nhân bản nhanh ở cột thao tác: cửa sổ Nhân bản sản phẩm mở với mã -COPY và tên (Bản sao), khách hàng khoá theo sản phẩm gốc, đã điền sẵn kích thước, khổ giấy, đơn giá, Loại vật tư, Vật tư cấu thành, Quy trình sản xuất và cấu hình định mức từng công đoạn (kể cả vật tư đầu vào); sửa nếu cần rồi bấm [Tạo & Chọn ngay].",
                  "Form sản phẩm có hai nút [Huỷ] và [Tạo mới]; danh mục không có Lưu nháp. Cửa sổ thêm nhanh không đóng khi bấm ra ngoài hay nhấn Esc.",
                  "Mã sản phẩm trùng với sản phẩm đang dùng bị chặn và báo ngay dưới ô Mã sản phẩm."
               ]
            },
            {
               "name": "Sản phẩm — Sửa / Trạng thái",
               "steps": [
                  "Bấm vào dòng trên danh sách để mở chi tiết, bấm [Sửa] → [Cập nhật].",
                  "Sản phẩm đang có Lệnh SX hoạt động: bấm [Cập nhật] lần hai để xác nhận (xem bước 7).",
                  "Bật / tắt trạng thái Hoạt động / Ngưng ngay trên thanh tiêu đề trang chi tiết, xác nhận ở hộp Xác nhận thay đổi trạng thái."
               ]
            },
            {
               "name": "Sản phẩm — Xoá / Phục hồi",
               "steps": [
                  "Xoá từng dòng (biểu tượng thùng rác, xác nhận Xoá) hoặc [Xoá] trên chi tiết; xoá nhiều dòng: tích chọn rồi bấm [Xoá] trên thanh thao tác hàng loạt.",
                  "Sản phẩm xoá chuyển vào tab Thùng rác; bấm [Phục hồi] để lấy lại.",
                  "Xoá sản phẩm cũng chuyển các Lệnh SX của sản phẩm đó vào Thùng rác cùng đợt."
               ]
            },
            {
               "name": "Sản phẩm — Excel và Chuẩn hóa hàng loạt",
               "steps": [
                  "[Xuất Excel]: xuất các dòng theo bộ lọc; khi đang tích chọn thì thanh thao tác có [Xuất Excel] cho các dòng đã chọn.",
                  "[Khác] › Nhập Excel (cần quyền Thêm): chọn file .xlsx / .xls, kiểm tra dữ liệu ở cửa sổ duyệt trước khi ghi.",
                  "[Khác] › Chuẩn hóa dữ liệu (cần quyền Sửa): mở cửa sổ bóc tách định mức BOM hàng loạt cho nhiều sản phẩm."
               ]
            },
            {
               "name": "Loại sản phẩm / Loại vật tư — Thêm / Sửa / Xoá",
               "steps": [
                  "[Thêm mới] mở cửa sổ; bấm vào dòng để mở khung chi tiết, bấm [Chỉnh Sửa] → [Lưu thay đổi].",
                  "Xoá: biểu tượng thùng rác cuối dòng hoặc tích nhiều dòng → [Xoá (n)]. Loại đang được sản phẩm / vật tư dùng thì không xoá được, hệ thống báo và giữ nguyên dữ liệu.",
                  "Loại đã xoá nằm ở tab Thùng rác; tạo lại một mã loại sản phẩm đã từng xoá thì hệ thống khôi phục bản ghi cũ với thông tin mới. Mã trùng với loại đang dùng bị chặn.",
                  "Lọc nhanh theo Danh mục (Loại sản phẩm) hoặc Nhóm (Loại vật tư); [Xuất Excel]."
               ]
            },
            {
               "name": "Vật tư — Thêm / Sửa / Xoá / Excel",
               "steps": [
                  "[Thêm VT] (cần quyền Thêm) → form Thêm mới vật tư → [Tạo mới]; sửa: bấm vào dòng mở chi tiết → [Chỉnh sửa] → [Cập nhật].",
                  "Chi tiết vật tư: Loại vật tư và Nhà cung cấp (mã và tên) là đường dẫn bấm mở được.",
                  "Xoá từng dòng hoặc hàng loạt; vật tư đang dùng bị chặn: Không thể xoá vật tư do đang được liên kết và sử dụng trong Sản Phẩm / Đơn hàng / Kho.",
                  "Vật tư đã xoá nằm ở tab Thùng rác, bấm [Phục hồi].",
                  "[Xuất Excel], [Nhập Excel] (cần quyền Thêm); trong cửa sổ nhập có [Tải form mẫu Excel]."
               ]
            },
            {
               "name": "Thiết bị SX — Sửa / Thanh lý / Excel",
               "steps": [
                  "Bấm vào dòng mở chi tiết máy → [Sửa] → [Lưu Thiết Bị].",
                  "Chi tiết máy: thông tin phẳng kèm ảnh (có Khổ kẽm CTP, sản lượng chuẩn, chu kỳ và ngày bảo trì kế tiếp), công đoạn máy làm được là đường dẫn; các tab Lịch chạy, Bảo trì, Sự cố, Nhật ký máy lấy dữ liệu thật, mã lệnh SX bấm mở được.",
                  "Xoá: menu Thao tác trên dòng › Thanh lý (xác nhận Bạn có chắc chắn muốn thanh lý thiết bị này?), [Xoá] trên chi tiết, hoặc chọn nhiều dòng → [Xoá (n)]. Máy đã xoá nằm ở tab Thùng rác.",
                  "Lọc theo trạng thái Chờ việc, Đang chạy, Bảo trì, Hỏng máy; [Xuất Excel], [Nhập Excel]."
               ]
            },
            {
               "name": "Quy trình SX — Sửa / Xoá / Import",
               "steps": [
                  "Lọc theo nhóm Tất cả, Trước in, In ấn, Sau in, Thành phẩm, Khác; [Import], [Xuất Excel], [Thêm] (cần quyền Thêm).",
                  "Menu dòng › Chỉnh sửa → hộp Cập nhật Công đoạn → [Lưu Công Đoạn].",
                  "Xoá từng dòng (Bạn có chắc muốn xóa quy trình …?) hoặc hàng loạt. Công đoạn không vào Thùng rác, xoá là mất hẳn.",
                  "Chi tiết công đoạn: Nhóm là đường dẫn xem các công đoạn cùng nhóm."
               ]
            },
            {
               "name": "Sản phẩm › Tạo / Sửa — cấu hình công đoạn và thành phần bộ",
               "steps": [
                  "[⚙️ Mở rộng cấu hình]: mở khung Cấu hình định mức công đoạn & chi phí gia công để nhập thời gian chuẩn bị, phí bài, đơn giá chạy, bù hao và gia công ngoài cho từng công đoạn đã chọn; bấm Thu gọn để đóng lại.",
                  "[Chuẩn Hóa Thứ Tự] (trong khung cấu hình công đoạn): tự sắp lại các công đoạn theo trình tự In → Cán màng → UV → Bồi sóng → Bế → Dán → Đóng gói và báo \"Đã chuẩn hóa thứ tự công đoạn theo chuỗi công nghệ bao bì!\".",
                  "Thứ tự công đoạn quyết định trình tự sản xuất ở xưởng, nên chạy Chuẩn Hóa Thứ Tự rồi kiểm tra lại trước khi lưu sản phẩm.",
                  "[Thêm thành phần khác]: chỉ có ở sản phẩm dạng Combo/Bộ, thêm một thành phần con mới (mặc định 1 cái) để nhập tên, vật tư, công đoạn và quy cách."
               ]
            },
            {
               "name": "Sản phẩm › Chi tiết — kết quả Đồng bộ BOM",
               "steps": [
                  "Sau khi bấm Đồng bộ BOM hoặc Lưu định mức chuẩn, hộp Kết quả Đồng bộ Định mức Vật tư (BOM) & Quy trình (Routing) hiện ra liệt kê vật tư và công đoạn vừa được lưu.",
                  "[Xem Định mức Vật tư]: đóng hộp kết quả và chuyển sang tab Định mức Vật tư của sản phẩm để kiểm tra lại số liệu vừa đồng bộ."
               ]
            },
            {
               "name": "Sản phẩm › Danh sách — Chuẩn hóa dữ liệu (bóc tách định mức hàng loạt)",
               "steps": [
                  "Nút Chuẩn hóa dữ liệu trên danh sách sản phẩm (cần quyền sửa sản phẩm) mở hộp Bóc Tách Định Mức BOM Hàng Loạt.",
                  "Hộp chia sản phẩm theo các tab Tất cả, Sẵn sàng, Cần bổ sung và [Miễn trừ ( )], số trong ngoặc là số sản phẩm của nhóm.",
                  "[Miễn trừ ( )]: liệt kê các mã dịch vụ, phụ phí như phí vận chuyển, VAT, chiết khấu; các dòng này không chọn được và luôn được bỏ qua khi chuẩn hóa.",
                  "Mặc định hệ thống chọn sẵn các sản phẩm ở tab Sẵn sàng; bạn có thể tick thêm hoặc bỏ tick từng dòng.",
                  "Tùy chọn Ghi đè dữ liệu cũ: khi bật, sản phẩm đã có định mức sẽ bị xóa định mức cũ và tạo lại; khi tắt, các sản phẩm đó được bỏ qua.",
                  "Tùy chọn Tự động điền mẫu demo: khi bật, sản phẩm chưa có vật tư và công đoạn được gán giấy tiêu chuẩn và quy trình mặc định; khi tắt, chúng được bỏ qua.",
                  "[Tiến Hành Chuẩn Hóa ( sản phẩm)]: tạo định mức vật tư và công đoạn cho các sản phẩm đã chọn, rồi báo số sản phẩm thành công cùng số dòng vật tư và công đoạn đã tạo.",
                  "Nút Tiến Hành Chuẩn Hóa bị khóa khi chưa chọn sản phẩm nào; nếu có lỗi hệ thống báo \"Có lỗi xảy ra trong quá trình chuẩn hóa\" kèm lý do."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "Hoạt động",
               "to": "Ngưng",
               "action": "Tắt công tắc trạng thái trên thanh tiêu đề chi tiết Sản phẩm (hoặc công tắc Đang dùng / Ngưng trên form), xác nhận",
               "allowedRoles": "Người có quyền Sửa Sản phẩm"
            },
            {
               "from": "Ngưng",
               "to": "Hoạt động",
               "action": "Bật lại công tắc trạng thái, xác nhận",
               "allowedRoles": "Người có quyền Sửa Sản phẩm"
            },
            {
               "from": "Đang dùng",
               "to": "Thùng rác",
               "action": "Xoá Sản phẩm, Vật tư, Loại sản phẩm, Loại vật tư hoặc Thiết bị SX",
               "allowedRoles": "Người có quyền Xoá"
            },
            {
               "from": "Thùng rác",
               "to": "Đang dùng",
               "action": "[Phục hồi] ở tab Thùng rác",
               "allowedRoles": "Người có quyền Xoá"
            }
         ],
         "actionLinks": [
            {
               "from": "Form Sản phẩm",
               "to": "Thêm khách hàng / loại sản phẩm / loại vật tư / vật tư / công đoạn",
               "action": "Thêm nhanh khi chưa có trong ô chọn",
               "how": "Mở ô chọn, bấm dòng Thêm KH mới, Thêm loại sản phẩm, Thêm loại mới hoặc Thêm vật tư; công đoạn thêm bằng [Tạo mới] trong hộp Chọn công đoạn sản xuất. Lưu xong giá trị tự điền vào ô."
            },
            {
               "from": "Form Báo giá, Đơn hàng",
               "to": "Tạo nhanh Sản phẩm",
               "action": "Thêm sản phẩm mới ngay trong chứng từ",
               "how": "Ô chọn sản phẩm › dòng thêm sản phẩm mới → nhập form → [Tạo & Chọn ngay]."
            },
            {
               "from": "Chi tiết Sản phẩm",
               "to": "Khách hàng, Đơn hàng, Giao hàng, Khuôn & Kẽm",
               "action": "Xem dữ liệu liên quan",
               "how": "Bấm tên Khách hàng hoặc mở tab tương ứng trên trang chi tiết."
            },
            {
               "from": "Chi tiết Sản phẩm",
               "to": "Tạo Sản phẩm",
               "action": "Nhân bản",
               "how": "Bấm [Nhân bản]: trang Tạo Sản Phẩm mở với dữ liệu chép từ sản phẩm gốc."
            },
            {
               "from": "Chi tiết Thiết bị SX",
               "to": "Lệnh SX, Công đoạn, Nhật ký máy",
               "action": "Mở chứng từ liên quan",
               "how": "Bấm mã lệnh SX ở tab Lịch chạy / Nhật ký máy hoặc tên công đoạn máy làm được."
            }
         ],
         "inlineViews": [
            {
               "name": "Chi tiết Loại sản phẩm / Loại vật tư",
               "trigger": "Bấm vào một dòng trên Loại sản phẩm hoặc Loại vật tư",
               "description": "Khung chi tiết mở ngay trên danh sách, có [Chỉnh Sửa], [Đóng] và các tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật."
            },
            {
               "name": "Hộp Chọn công đoạn sản xuất",
               "trigger": "[Chọn công đoạn] trên form Sản phẩm",
               "description": "Nút lọc theo nhóm, ô tìm, bấm dòng để chọn / bỏ, kéo ở cột Thứ tự, [Bỏ hết], [Tạo mới], [Huỷ], [Xong (n công đoạn)]."
            },
            {
               "name": "Lịch sử phiên bản Sản phẩm",
               "trigger": "Bấm nhãn phiên bản (VD v3) cạnh mã trên chi tiết Sản phẩm",
               "description": "Xem các phiên bản đã lưu của sản phẩm."
            },
            {
               "name": "Dự tính & Đối soát Giá vốn chuẩn",
               "trigger": "[Tính giá vốn] trên chi tiết Sản phẩm",
               "description": "So sánh Giá vốn hiện tại, Giá vốn dự tính và Đơn giá niêm yết (Catalog), cách tính theo lô chuẩn; cảnh báo khi giá vốn cao hơn giá bán. [Xác nhận cập nhật giá vốn] chỉ ghi giá vốn, [Đóng] để thoát."
            }
         ],
         "quickActions": [
            {
               "action": "Lọc sản phẩm theo khách hàng",
               "description": "Dùng thẻ lọc / ô Nhóm khách hàng ở dòng lọc của danh sách Sản phẩm."
            },
            {
               "action": "Bóc tách quy cách vật tư",
               "description": "Trên form Vật tư, gõ tên rồi bấm [Bóc tách quy cách] để tự điền GSM và kích thước."
            },
            {
               "action": "Tạo Tên & Mã vật tư",
               "description": "Bấm [Tạo Tên & Mã] để hệ thống sinh tên chuẩn và mã vật tư."
            },
            {
               "action": "Tìm trong danh mục",
               "description": "Gõ vào ô tìm kiếm trên thanh Header; các trang danh mục không có ô tìm riêng."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/02_product_form_fk_modal_product_type.png",
               "caption": "Hình 03.1 — Cửa sổ Tạo nhanh Loại sản phẩm mở từ form Tạo Sản Phẩm; lưu xong loại mới tự điền vào ô N.Sản phẩm"
            }
         ],
         "notes": [
            "Tồn kho trên danh mục vật tư cập nhật theo số dư kho thật mỗi khi chốt hoặc hủy phiếu nhập / xuất kho. Vật tư chưa từng nhập kho giữ số tồn khai báo ban đầu cho tới lần nhập / xuất đầu tiên.",
            "Form vật tư có ô Trạng thái (Hoạt động / Ngưng dùng) nhưng hệ thống chưa lưu lựa chọn này; anh/chị đừng dùng ô này để ngưng vật tư. Vật tư không còn dùng thì xoá để đưa vào Thùng rác (vật tư đang được dùng sẽ không xoá được).",
            "Xoá Loại sản phẩm, Loại vật tư hoặc Vật tư đang được dùng sẽ bị chặn; dữ liệu giữ nguyên.",
            "Xoá sản phẩm cũng chuyển các Lệnh SX của sản phẩm vào Thùng rác. Kiểm tra tab Đơn hàng và các lệnh trước khi xoá.",
            "Sửa vật tư hoặc quy trình của sản phẩm không làm thay đổi các Lệnh SX đã tạo; hệ thống hỏi xác nhận khi sản phẩm còn lệnh hoạt động.",
            "Giá bán do Kinh doanh nhập. [Tính giá vốn] và [Đồng bộ BOM] chỉ cập nhật giá vốn chuẩn, không đổi Đơn giá (Catalog) hay Giá chốt trên báo giá, đơn hàng.",
            "Mở trang chi tiết với mã không tồn tại sẽ báo không tìm thấy và có nút quay lại danh sách. Xoá ở trang chi tiết rồi quay về danh sách, bản ghi đã biến mất mà không cần tải lại trang."
         ],
         "uatChecklist": [
            {
               "id": "DL-03-01",
               "item": "Tạo loại vật tư và vật tư mới",
               "standard": "Loại vật tư lưu thành công và chọn được trong form vật tư; vật tư mới hiện trong danh sách với đúng nhóm, loại, ĐVT, đơn giá",
               "method": "1) Vào Mua hàng › Loại vật tư › [Thêm mới]; 2) Nhập Mã loại vật tư IV300-UAT, Tên / Nhãn hiển thị chuẩn Giấy Ivory 300gsm UAT, Nhóm vật tư Giấy, Định lượng GSM 300 → [Tạo loại vật tư]; 3) Vào Mua hàng › Danh mục Vật tư › [Thêm VT]; 4) Chọn Nhóm vật tư Giấy, Loại vật tư IV300-UAT, Dài 790, Rộng 1090, Đơn vị tính Tờ, Đơn giá 3500; 5) Bấm [Tạo Tên & Mã] → [Tạo mới]; 6) Gõ mã vừa tạo vào ô tìm kiếm trên Header để kiểm tra"
            },
            {
               "id": "DL-03-02",
               "item": "Chi tiết vật tư có liên kết và không xoá được vật tư đang dùng",
               "standard": "Loại vật tư và Nhà cung cấp trên chi tiết là đường dẫn mở đúng bản ghi; xoá vật tư đã dùng trong sản phẩm báo Không thể xoá vật tư do đang được liên kết…",
               "method": "1) Mở chi tiết vật tư vừa tạo ở DL-03-01 (bấm vào dòng); 2) Bấm [Chỉnh sửa], chọn Nhà cung cấp bất kỳ → [Cập nhật]; 3) Trên chi tiết bấm tên Nhà cung cấp, kiểm tra mở đúng hồ sơ; quay lại, bấm Loại vật tư; 4) Chọn vật tư này làm Vật tư cấu thành của sản phẩm ở DL-03-04; 5) Quay lại chi tiết vật tư bấm [Xoá] → quan sát thông báo chặn"
            },
            {
               "id": "DL-03-03",
               "item": "Khai báo máy in có Khổ Kẽm CTP",
               "standard": "Máy lưu thành công; chi tiết máy hiện Khổ kẽm CTP 1030x800 mm; các tab Lịch chạy, Bảo trì, Sự cố, Nhật ký máy mở được, không hiện dữ liệu mẫu",
               "method": "1) Vào Xưởng sản xuất › Thiết bị SX › [Thêm TB]; 2) Nhập Mã Máy IN-UAT-01, Tên Máy Máy in offset UAT, Phân Loại Nhóm là loại máy in offset, Khổ Làm Việc 720x1020, Khổ Kẽm CTP (máy in) 1030x800 mm, Sản Lượng Chuẩn 8000, TG Setup 30 → [Tạo Mới Thiết Bị]; 3) Mở chi tiết máy, kiểm tra ô Khổ kẽm CTP; 4) Bấm [Sửa], đổi TG Setup thành 25 → [Lưu Thiết Bị]; 5) Lần lượt mở 4 tab dữ liệu liên quan"
            },
            {
               "id": "DL-03-04",
               "item": "Thêm công đoạn mới trong Quy trình SX",
               "standard": "Công đoạn lưu thành công, hiện ở đúng nhóm Sau in; dòng gốc tương ứng (nhãn Quy trình SX) tự có trong Ma trận Hao hụt",
               "method": "1) Vào Hệ Thống & Quy Trình › Quy trình SX › [Thêm]; 2) Nhập Tên Công Đoạn Ép nhũ UAT, Mã Công Đoạn EP-NHU-UAT, Nhóm Công Đoạn Sau in, Đơn Vị Tính Tờ, TG Setup Chuẩn 20, Tốc Độ Chuẩn 3000, Hao Phí Setup 50, % Bù Hao Chạy 2 → [Lưu Công Đoạn]; 3) Bấm thẻ lọc Sau in, kiểm tra công đoạn mới; 4) Vào Ma trận Hao hụt, gõ Ép nhũ UAT vào ô tìm kiếm trên Header, kiểm tra dòng gốc Quy trình SX"
            },
            {
               "id": "DL-03-05",
               "item": "Tạo sản phẩm mới với quy trình chọn trong hộp",
               "standard": "Sản phẩm lưu thành công, mã tự sinh theo khách hàng; chi tiết hiện đúng kích thước 67,5 mm, Số cái / thùng, quy trình đúng thứ tự đã kéo",
               "method": "1) Vào Kinh doanh › Sản phẩm › [Thêm SP]; 2) Chọn Khách hàng có sẵn, N.Sản phẩm bất kỳ, để trống Mã sản phẩm, Tên sản phẩm Hộp UAT 01, Đơn vị tính Cái; 3) Dài 67,5, Rộng 40, Cao 120, Số bát 6, Số cái / thùng 200; 4) Chọn Loại vật tư IV300-UAT; 5) Bấm [Chọn công đoạn], chọn Cắt giấy, In offset, Ép nhũ UAT, Bế, Dán hộp; kéo ở cột Thứ tự để đổi chỗ hai công đoạn rồi bấm [Sắp theo chuẩn] trên form; 6) Bấm [Xong] → [Tạo mới]; 7) Mở chi tiết kiểm tra các ô"
            },
            {
               "id": "DL-03-06",
               "item": "Báo thiếu ô bắt buộc trên form sản phẩm",
               "standard": "Không lưu được; các ô thiếu tô đỏ, form tự cuộn tới ô đầu tiên, thông báo nêu tên ô; thiếu công đoạn In ấn hoặc Thành phẩm báo Bắt buộc chọn ít nhất 1 công đoạn …",
               "method": "1) [Thêm SP]; 2) Chỉ nhập Tên sản phẩm Hộp thiếu UAT, bỏ trống Khách hàng, N.Sản phẩm, Dài, Rộng; 3) Bấm [Tạo mới], quan sát; 4) Điền đủ các ô trên, chọn quy trình chỉ có Cắt giấy → [Tạo mới], quan sát thông báo công đoạn; 5) Bấm [Huỷ]"
            },
            {
               "id": "DL-03-07",
               "item": "Sửa sản phẩm đang có Lệnh SX hoạt động",
               "standard": "Lần bấm [Cập nhật] đầu hiện cảnh báo có n Lệnh SX hoạt động và chưa lưu; bấm lần hai lưu thành công (Cập nhật sản phẩm thành công), lệnh cũ giữ nguyên công đoạn",
               "method": "1) Chọn một sản phẩm đã có Lệnh SX chưa hoàn thành (xem ở Kế hoạch › Lệnh sản xuất); 2) Mở chi tiết sản phẩm › [Sửa]; 3) Trong [Chọn công đoạn] thêm công đoạn Ép nhũ UAT → [Xong]; 4) Bấm [Cập nhật], đọc cảnh báo; 5) Bấm [Cập nhật] lần nữa; 6) Mở lệnh SX cũ, tab 4. Kế hoạch sản xuất, kiểm tra không có Ép nhũ UAT"
            },
            {
               "id": "DL-03-08",
               "item": "Thêm nhanh trong ô chọn trên form sản phẩm",
               "standard": "Cửa sổ thêm nhanh không đóng khi bấm ra ngoài hoặc Esc; lưu xong giá trị mới tự điền vào ô đang chọn",
               "method": "1) [Thêm SP]; 2) Mở ô N.Sản phẩm, bấm dòng Thêm loại sản phẩm; 3) Bấm ra ngoài cửa sổ và nhấn Esc, kiểm tra cửa sổ vẫn mở; 4) Nhập Mã loại sản phẩm HOP-UAT → [Tạo loại sản phẩm], kiểm tra ô N.Sản phẩm đã chọn HOP-UAT; 5) Mở ô Vật tư cấu thành, bấm Thêm vật tư, nhập vật tư Màng BOPP UAT → [Tạo & Chọn ngay]; 6) Trong [Chọn công đoạn] bấm [Tạo mới], nhập Cán màng UAT, lưu và kiểm tra công đoạn được chọn"
            },
            {
               "id": "DL-03-09",
               "item": "Liên kết, tab và lịch sử trên chi tiết sản phẩm",
               "standard": "Tên Khách hàng mở đúng hồ sơ khách; 6 tab nội dung mở được; Thảo luận & Ghi chú lưu bình luận; Lịch sử cập nhật ghi lần sửa; dòng Cập nhật lúc … bởi Administrator",
               "method": "1) Mở chi tiết sản phẩm Hộp UAT 01; 2) Bấm tên Khách hàng, rồi quay lại; 3) Mở lần lượt Định mức Vật tư, Quy trình, Bảng chiết giá, Đơn hàng, Giao hàng, Khuôn & Kẽm; 4) Ở tab Thảo luận & Ghi chú gõ Kiểm tra UAT và gửi; 5) Mở tab Lịch sử cập nhật và đọc dòng cuối trang"
            },
            {
               "id": "DL-03-10",
               "item": "Tính giá vốn không đổi giá bán",
               "standard": "Sau [Xác nhận cập nhật giá vốn], Giá vốn chuẩn đổi; Đơn giá (Catalog) giữ nguyên số cũ",
               "method": "1) Trên chi tiết Hộp UAT 01 ghi lại Đơn giá (Catalog); 2) Bấm [Tính giá vốn], đọc Giá vốn dự tính; 3) Bấm [Xác nhận cập nhật giá vốn]; 4) Bấm [Đồng bộ BOM], đọc bảng Trước → Sau; 5) So lại Đơn giá (Catalog) với số đã ghi"
            },
            {
               "id": "DL-03-11",
               "item": "Xoá và phục hồi sản phẩm",
               "standard": "Sản phẩm biến khỏi danh sách và nằm ở tab Thùng rác; [Phục hồi] đưa về danh sách đúng mã cũ",
               "method": "1) Trên danh sách Sản phẩm, ở dòng Hộp UAT 01 bấm biểu tượng thùng rác → Xoá; 2) Mở tab Thùng rác, tìm Hộp UAT 01 bằng ô tìm kiếm trên Header; 3) Bấm [Phục hồi]; 4) Quay về tab Đang Hoạt Động, kiểm tra mã sản phẩm"
            },
            {
               "id": "DL-03-12",
               "item": "Danh mục dùng được trên điện thoại 390px",
               "standard": "Không cuộn ngang cả trang; thanh công cụ không đè chữ; bảng kéo ngang được trong khung; trang chi tiết có thanh nút dưới đáy tối đa 4 nút, nút còn lại trong nút …",
               "method": "1) Mở trình duyệt điện thoại (hoặc thu cửa sổ còn rộng 390px), đăng nhập; 2) Bấm [Ứng dụng], gõ Sản phẩm vào ô Tìm nhanh chức năng, mở Sản phẩm; 3) Kéo ngang bảng, mở nút … trên thanh công cụ; 4) Bấm một dòng mở chi tiết, kiểm tra thanh nút dưới đáy; 5) Lặp lại với Thiết bị SX và Quy trình SX"
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 04. Khách Hàng, Nhà Cung Cấp & Tra Cứu MST
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "customers",
         "aliases": [
            "customer",
            "vendors",
            "vendor",
            "crm",
            "customers-create",
            "vendors-create"
         ],
         "title": "04. Khách Hàng, Nhà Cung Cấp & Tra Cứu MST",
         "icon": "Users",
         "isoRef": "QT-KD-00",
         "purpose": "Quản lý hồ sơ pháp lý Khách hàng (Kinh doanh › Khách hàng) và Nhà cung cấp (Mua hàng › Nhà Cung cấp): tra cứu thông tin doanh nghiệp bằng Mã số thuế, chặn tạo trùng mã/MST, gán NV Kinh doanh phụ trách, đặt hạn mức công nợ, theo dõi công nợ qua Sổ cái (không sửa tay) và xem Đơn hàng, Báo giá, Sản phẩm, Giao hàng của từng khách. Hồ sơ khách hàng phải đủ Mã số thuế và Địa chỉ thì đơn hàng của khách mới được duyệt.",
         "scope": [
            "Phòng Kinh Doanh: tạo, sửa, ngưng/khôi phục Khách hàng tại Kinh doanh › Khách hàng, hoặc thêm nhanh ngay trong ô chọn Khách hàng của Báo giá, Đơn hàng.",
            "Phòng Mua Hàng: tạo, sửa, ngừng hợp tác Nhà cung cấp và xưởng gia công tại Mua hàng › Nhà Cung cấp.",
            "Phòng Kế Toán: đặt Hạn mức công nợ, theo dõi công nợ phải thu/phải trả qua nút [Sổ cái] trên trang chi tiết và menu Công nợ KH.",
            "Quyền thao tác theo cấu hình Phân quyền, phân hệ Khách hàng và Nhà cung cấp (Xem / Thêm / Sửa / Xoá). Cấu hình Go-Live: các vai trò nghiệp vụ được mở đủ quyền; Quản trị viên thu hẹp bất kỳ lúc nào."
         ],
         "references": [
            "ISO 9001:2015 mục 8.2.1 — Trao đổi thông tin với khách hàng",
            "ISO 9001:2015 mục 8.4 — Kiểm soát quá trình, sản phẩm và dịch vụ do bên ngoài cung cấp (Nhà cung cấp, xưởng gia công)",
            "Chương 05 — Báo giá; Chương 06 — Đơn đặt hàng (duyệt đơn cần MST và Địa chỉ khách hàng)",
            "Quy chế Phân quyền nội bộ APV ERP (Hệ Thống & Quy Trình › Phân quyền)"
         ],
         "terms": [
            {
               "term": "MST (Mã số thuế)",
               "definition": "Mã 10 hoặc 13 số của doanh nghiệp. Nhập 13 số liền thì hệ thống tự thêm dấu gạch ngang sau số thứ 10 khi tra cứu."
            },
            {
               "term": "Mã khách hàng",
               "definition": "Mã duy nhất, tự sinh từ Tên viết tắt (sửa được), gồm chữ in hoa, số và các ký tự - _ . tối đa 20 ký tự."
            },
            {
               "term": "NV Kinh doanh phụ trách",
               "definition": "Nhân viên được gán cho khách hàng (mặc định là người tạo). Nếu vai trò bị giới hạn phạm vi dữ liệu Cá nhân hoặc Đội nhóm, người dùng chỉ thấy khách hàng do mình hoặc người cùng bộ phận phụ trách."
            },
            {
               "term": "Hạn mức công nợ",
               "definition": "Mức dư nợ tối đa cho phép (0 = không giới hạn). Danh sách tự đánh giá Vượt hạn mức, Cận hạn mức (từ 80%), Trong hạn mức hoặc Chưa đặt HM."
            },
            {
               "term": "Hạng KH (6T)",
               "definition": "Xếp hạng tự động theo doanh số và số đơn 6 tháng gần nhất: VIP (từ 500 triệu hoặc từ 20 đơn), Hạng A (từ 200 triệu hoặc từ 10 đơn), Hạng B, Hạng C."
            },
            {
               "term": "Đủ thông tin xuất HĐ",
               "definition": "Tự đánh giá, không bấm được: đủ khi có Mã số thuế, Tên đầy đủ, Địa chỉ và Email nhận hoá đơn đúng định dạng. Trên form hiện Thiếu thông tin xuất HĐ kèm các ô còn thiếu; trên trang chi tiết hiện ngay cạnh Mã số thuế (Đủ TT xuất HĐ hoặc Thiếu ...)."
            },
            {
               "term": "Thông tin bắt buộc để duyệt đơn",
               "definition": "Khách hàng phải có Mã số thuế và Địa chỉ trụ sở. Thiếu một trong hai, đơn hàng của khách bị từ chối duyệt kèm tên trường còn thiếu."
            }
         ],
         "responsibilities": [
            {
               "role": "Nhân viên Kinh doanh",
               "tasks": [
                  "Tạo khách hàng bằng [Tra cứu MST 1-chạm]; dùng khách hàng có sẵn khi hệ thống báo trùng",
                  "Giữ đủ Mã số thuế, Địa chỉ trụ sở để đơn hàng duyệt được; đủ Email nhận hoá đơn để xuất hoá đơn",
                  "Cập nhật người liên hệ, địa chỉ giao hàng, điều khoản thanh toán, dung sai màu và số lượng"
               ]
            },
            {
               "role": "Nhân viên Mua hàng",
               "tasks": [
                  "Tạo và cập nhật Nhà cung cấp, xưởng gia công",
                  "Bấm Ngừng hợp tác / Hợp tác lại khi thay đổi quan hệ cung ứng"
               ]
            },
            {
               "role": "Kế toán công nợ",
               "tasks": [
                  "Đặt Hạn mức công nợ khách hàng, hạn mức và nợ đầu kỳ nhà cung cấp",
                  "Theo dõi công nợ qua [Sổ cái] và menu Công nợ KH"
               ]
            },
            {
               "role": "Quản trị viên (ADMIN)",
               "tasks": [
                  "Cấu hình quyền Xem/Thêm/Sửa/Xoá và phạm vi dữ liệu cho Khách hàng, Nhà cung cấp tại Phân quyền",
                  "Phục hồi bản ghi đã xoá trong tab Thùng rác"
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Toàn quyền; Khách hàng/Nhà cung cấp không có bước duyệt"
            },
            {
               "role": "Vai trò nghiệp vụ (SALES, SALES_MANAGER... cấu hình Go-Live)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Theo quyền của vai trò. Nút [Thêm KH], [Nhập Excel], Sửa, Xoá, Phục hồi chỉ hiện khi có quyền tương ứng; dòng Thêm khách hàng mới trong ô chọn chỉ hiện khi có quyền Thêm khách hàng. Phạm vi dữ liệu Cá nhân/Đội nhóm lọc khách theo NV Kinh doanh phụ trách"
            },
            {
               "role": "Vai trò bị tắt quyền Xem khách hàng",
               "view": "❌",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "❌",
               "statusRules": "Hệ thống báo Không có quyền truy cập khi mở trang Khách hàng"
            }
         ],
         "processFlowchart": "graph TD\n    A[Bấm Thêm KH hoặc dòng Thêm khách hàng mới trong ô chọn] --> B[Nhập MST, bấm Tra cứu MST 1-chạm]\n    B --> C{Trùng mã KH hoặc MST}\n    C -->|Có, mở từ Báo giá hoặc Đơn hàng| D[Bấm Dùng khách hàng này]\n    D --> E[Khách hàng có sẵn được chọn vào chứng từ]\n    C -->|Có, ở trang Thêm mới khách hàng| F[Bấm Mở khách hàng để xem hồ sơ cũ]\n    C -->|Không| G[Bổ sung liên hệ, Email nhận hoá đơn, thanh toán, hạn mức, NV KD]\n    G --> H[Bấm Tạo mới]\n    H --> I[Khách hàng Hoạt động]\n    I --> J{Đủ MST và Địa chỉ}\n    J -->|Đủ| K[Đơn hàng của khách duyệt được]\n    J -->|Thiếu| L[Duyệt đơn bị từ chối, bấm Cập nhật Khách Hàng]\n    I --> M{Cần xoá}\n    M -->|Đã có đơn, báo giá, giao hàng, thu chi| N[Hệ thống chặn, nêu số chứng từ liên kết]\n    M -->|Chưa phát sinh| O[Vào Thùng rác, có thể Phục hồi]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Mở form Thêm mới khách hàng",
               "detail": "• Vào Kinh doanh › Khách hàng, bấm [Thêm KH] (trang Thêm mới khách hàng).\n• Hoặc khi đang lập Báo giá / Đơn hàng: mở ô chọn Khách hàng, bấm dòng cuối danh sách (Báo giá: Thêm KH mới; Đơn hàng: Thêm khách hàng mới). Cửa sổ Thêm mới khách hàng mở toàn màn hình, có nút [Hủy] / [Tạo mới] ở chân cửa sổ."
            },
            {
               "step": 2,
               "action": "Tra cứu thông tin doanh nghiệp bằng MST",
               "detail": "• Ở thanh Mã số thuế đầu form, nhập 10 hoặc 13 số rồi bấm [Tra cứu MST 1-chạm] (hoặc nhấn Enter).\n• Hệ thống tự điền Tên đầy đủ, Địa chỉ trụ sở (và Địa chỉ giao hàng nếu đang trống), Tên viết tắt, Mã khách hàng, Tên tài khoản ngân hàng.\n• Doanh nghiệp đã ngừng hoạt động/đóng MST: hiện cảnh báo trạng thái MST. Không tìm thấy: anh/chị nhập tay."
            },
            {
               "step": 3,
               "action": "Xử lý cảnh báo trùng",
               "detail": "• Hệ thống dò trên toàn bộ khách hàng theo MST, mã và tên đang nhập.\n• Khung đỏ Lỗi: Trùng mã khách hàng hoặc mã số thuế! (tạo mới trùng MST, hoặc trùng Mã KH): nút [Tạo mới] bị khoá.\n  – Đang thêm từ ô chọn của Báo giá/Đơn hàng: bấm [Dùng khách hàng này] ở dòng bị trùng, cửa sổ đóng và khách có sẵn được chọn ngay vào chứng từ.\n  – Đang ở trang Thêm mới khách hàng: bấm [Mở khách hàng] để mở hồ sơ đã có.\n• Khung vàng Lưu ý: Có khách hàng tên hoặc MST tương tự chỉ để tham khảo, không chặn lưu."
            },
            {
               "step": 4,
               "action": "Khai báo thông tin và lưu",
               "detail": "• Thông tin cơ bản: Tên đầy đủ, Tên viết tắt, Mã khách hàng, Điện thoại, Địa chỉ trụ sở (Theo ĐKKD) là bắt buộc; thêm Email nhận hoá đơn, Người đại diện, Chức vụ, Website, Địa chỉ giao hàng, logo.\n• Đại diện & giao dịch: Người liên hệ, Số điện thoại liên hệ (nút [📋 Giống Người đại diện], [📋 Giống SĐT chính]), Phương thức thanh toán, Hình thức giao hàng, Địa chỉ nhà xe / trung chuyển, Dung sai màu sắc, Dung sai số lượng.\n• Ngân hàng & phân loại: Số tài khoản ngân hàng, Tên tài khoản ([📋 Giống Tên công ty]), Ngân hàng, Hạn mức công nợ (nút nhanh 20M, 50M, 100M, 200M, 500M, 1 Tỷ), Loại khách hàng, Nhóm, Phân khúc, NV Kinh doanh phụ trách, Ghi chú.\n• Nhớ nhập Mã số thuế: thiếu MST hoặc Địa chỉ thì đơn hàng của khách không duyệt được.\n• Bấm [Tạo mới] (khi sửa là [Cập nhật]). Ô thiếu hoặc sai được tô đỏ và tự cuộn tới. Khách hàng không có Lưu nháp."
            },
            {
               "step": 5,
               "action": "Xem chi tiết khách hàng và công nợ",
               "detail": "• Bấm một dòng trong danh sách để mở chi tiết; tiêu đề trang là Mã khách hàng, công tắc Hoạt động / Ngưng ở đầu trang.\n• Khối thông tin: cơ bản (Mã số thuế kèm Đủ TT xuất HĐ hoặc Thiếu ...), giao dịch, Công nợ & Tín dụng (Dư nợ hiện tại, Hạn mức tín dụng, Đánh giá công nợ, Dư nợ đầu kỳ, Hạng khách hàng), ngân hàng, Nhân viên KD; dải số liệu Doanh số, Doanh thu giao, Còn nợ.\n• Các tab Đơn hàng, Báo giá, Sản phẩm, Giao hàng của riêng khách này; bên dưới là tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật; cuối trang ghi Tạo lúc / Cập nhật lúc kèm người thao tác và nút [Xem lịch sử].\n• Bấm [Sổ cái] để mở sổ cái công nợ phải thu; bấm số Dư nợ hiện tại để mở Công nợ KH lọc theo khách.\n• Công nợ không sửa tay: chỉ phát sinh từ Phiếu giao hàng và Phiếu thu; khách mới luôn có dư nợ đầu kỳ 0 đ."
            }
         ],
         "subFlows": [
            {
               "name": "Khách hàng — Thêm mới",
               "steps": [
                  "Bấm [Thêm KH] trên danh sách, hoặc dòng Thêm KH mới / Thêm khách hàng mới trong ô chọn của Báo giá / Đơn hàng",
                  "Nhập MST, bấm [Tra cứu MST 1-chạm]",
                  "Kiểm tra khung trùng; khung đỏ thì bấm [Dùng khách hàng này] hoặc [Mở khách hàng]",
                  "Điền các ô bắt buộc, bấm [Tạo mới]"
               ]
            },
            {
               "name": "Khách hàng — Danh sách & tra cứu",
               "steps": [
                  "Hàng trên: tab Danh Sách Khách Hàng / Thùng rác và nút [Xuất Excel], [Nhập Excel], [Thêm KH]",
                  "Hàng dưới: nút Lọc và các bộ lọc thả xuống Trạng thái (Hoạt động / Ngưng), Hạng KH (6T), Công nợ",
                  "Tìm khách bằng ô Tìm kiếm trên thanh đầu trang (trang danh sách không có ô tìm riêng)",
                  "Dưới tên khách hiện Người liên hệ · SĐT; tiêu đề cột đứng yên khi cuộn; bấm dòng để mở chi tiết"
               ]
            },
            {
               "name": "Khách hàng — Sửa",
               "steps": [
                  "Trên chi tiết bấm [Sửa], hoặc trên danh sách mở menu ... của dòng › Sửa thông tin",
                  "Sửa thông tin, bấm [Cập nhật]",
                  "Trùng Mã KH với khách khác bị chặn; trùng MST chỉ hiện cảnh báo vàng trên form nhưng khi lưu hệ thống vẫn từ chối: Mã số thuế ... đã được sử dụng bởi khách hàng khác",
                  "Từ form Báo giá bấm [Cập nhật hồ sơ KH], từ form Đơn hàng bấm [Sửa thông tin KH] để sửa nhanh hồ sơ khách đang chọn"
               ]
            },
            {
               "name": "Khách hàng — Lưu ngược liên hệ từ Báo giá / Đơn hàng",
               "steps": [
                  "Trên form Báo giá bấm [Lưu thông tin khách hàng], trên form Đơn hàng bấm [Lưu thông tin liên hệ]",
                  "Người liên hệ, Điện thoại, Email và Địa chỉ giao hàng đang nhập được ghi vào hồ sơ khách hàng",
                  "Lưu ý: địa chỉ giao hàng được ghi vào ô Địa chỉ của khách hàng; chỉ bấm khi địa chỉ đó đúng là địa chỉ cần lưu"
               ]
            },
            {
               "name": "Khách hàng — Ngưng / Hoạt động lại",
               "steps": [
                  "Trên chi tiết bấm công tắc trạng thái ở đầu trang (Hoạt động / Ngưng) và xác nhận",
                  "Danh sách lọc được theo Trạng thái Hoạt động / Ngưng"
               ]
            },
            {
               "name": "Khách hàng — Xoá và Phục hồi",
               "steps": [
                  "Trên danh sách: menu ... › Xoá và xác nhận; trên chi tiết: bấm [Xóa] và xác nhận",
                  "Khách đã có đơn hàng, báo giá, lệnh sản xuất, phiếu giao hàng, phiếu thu/chi, khuôn bế hoặc bản in: hệ thống chặn với thông báo Không thể xóa khách hàng này vì đã có dữ liệu liên kết kèm số lượng từng loại",
                  "Xoá thành công: khách vào tab Thùng rác",
                  "Phục hồi: mở tab Thùng rác, menu ... › Phục hồi (cần quyền Xoá)",
                  "Xoá nhiều: tích chọn nhiều dòng, bấm Xoá (n) trên thanh tác vụ; dòng bị chặn báo lỗi riêng, các dòng khác vẫn xoá"
               ]
            },
            {
               "name": "Khách hàng — Xuất / Nhập Excel",
               "steps": [
                  "Bấm [Xuất Excel] để tải danh sách theo bộ lọc (Mã KH, Tên khách hàng, Tên viết tắt, Người liên hệ, SĐT, Email, Nợ hiện tại, Hạn mức nợ, Địa chỉ, Nhóm...)",
                  "Bấm [Nhập Excel] (cần quyền Thêm), tải file mẫu, điền dữ liệu và xác nhận nhập",
                  "Mỗi dòng tạo một khách mới; dòng trùng mã/MST báo lỗi"
               ]
            },
            {
               "name": "Nhà cung cấp — Thêm mới",
               "steps": [
                  "Vào Mua hàng › Nhà Cung cấp, bấm [Thêm NCC] (hoặc dòng Thêm nhà cung cấp mới trong ô chọn NCC của chứng từ)",
                  "Nhập MST, bấm [Tra cứu MST 1-chạm] để tự điền tên, địa chỉ",
                  "Điền tên, tên viết tắt, Mã NCC, địa chỉ nhà máy/kho, loại dịch vụ, phân nhóm, hạn mức công nợ, Nợ đầu kỳ (VNĐ), ngân hàng",
                  "Bấm [Tạo mới]; trùng tên, tên viết tắt, MST hoặc mã với NCC đã có thì hiện khung đỏ Lỗi: Thông tin trùng lặp với dữ liệu đã có và nút lưu bị khoá"
               ]
            },
            {
               "name": "Nhà cung cấp — Xem / Sửa / Ngừng hợp tác / Xoá",
               "steps": [
                  "Bấm dòng NCC để xem chi tiết; [Sổ cái] mở công nợ phải trả",
                  "Bấm [Chỉnh sửa], sửa rồi bấm [Cập nhật]",
                  "Menu Thao tác › Ngừng hợp tác (hoặc Hợp tác lại)",
                  "Menu Thao tác › Xoá; NCC đang liên kết vật tư hoặc đơn gia công bị chặn kèm số liên kết; xoá thành công vào Thùng rác"
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "Hoạt động",
               "to": "Ngưng",
               "action": "Bấm công tắc trạng thái trên chi tiết khách hàng",
               "allowedRoles": "Người có quyền Sửa khách hàng"
            },
            {
               "from": "Ngưng",
               "to": "Hoạt động",
               "action": "Bấm công tắc trạng thái trên chi tiết khách hàng",
               "allowedRoles": "Người có quyền Sửa khách hàng"
            },
            {
               "from": "Hoạt động (NCC)",
               "to": "Ngưng (NCC)",
               "action": "Menu Thao tác › Ngừng hợp tác",
               "allowedRoles": "Người có quyền Sửa nhà cung cấp"
            },
            {
               "from": "Ngưng (NCC)",
               "to": "Hoạt động (NCC)",
               "action": "Menu Thao tác › Hợp tác lại",
               "allowedRoles": "Người có quyền Sửa nhà cung cấp"
            },
            {
               "from": "Đang dùng",
               "to": "Thùng rác",
               "action": "Xoá (chỉ khi chưa có chứng từ liên kết)",
               "allowedRoles": "Người có quyền Xoá khách hàng / nhà cung cấp"
            },
            {
               "from": "Thùng rác",
               "to": "Đang dùng",
               "action": "Tab Thùng rác › Phục hồi",
               "allowedRoles": "Người có quyền Xoá khách hàng / nhà cung cấp"
            }
         ],
         "actionLinks": [
            {
               "from": "Ô chọn Khách hàng trên Báo giá / Đơn hàng",
               "to": "Cửa sổ Thêm mới khách hàng",
               "action": "Thêm nhanh khách hàng",
               "how": "Bấm dòng Thêm KH mới (Báo giá) / Thêm khách hàng mới (Đơn hàng) cuối danh sách; lưu xong khách được chọn ngay vào chứng từ"
            },
            {
               "from": "Cửa sổ Thêm mới khách hàng (trùng MST/mã)",
               "to": "Báo giá / Đơn hàng đang lập",
               "action": "Dùng khách hàng có sẵn",
               "how": "Bấm [Dùng khách hàng này]"
            },
            {
               "from": "Trang Thêm mới khách hàng",
               "to": "Chi tiết khách hàng đã có",
               "action": "Mở hồ sơ trùng",
               "how": "Bấm [Mở khách hàng] trong khung lỗi trùng"
            },
            {
               "from": "Chi tiết Đơn hàng (khung Chưa đủ điều kiện duyệt đơn)",
               "to": "Chi tiết khách hàng",
               "action": "Bổ sung MST / Địa chỉ trước khi duyệt đơn",
               "how": "Bấm [Cập nhật Khách Hàng], bấm [Sửa], bổ sung rồi bấm [Cập nhật]"
            },
            {
               "from": "Chi tiết Báo giá / Đơn hàng",
               "to": "Chi tiết khách hàng",
               "action": "Xem hồ sơ khách",
               "how": "Bấm tên khách hàng (dạng liên kết) ở khối thông tin chung"
            },
            {
               "from": "Chi tiết khách hàng",
               "to": "Sổ cái công nợ phải thu",
               "action": "Xem công nợ",
               "how": "Bấm [Sổ cái] ở khối Công nợ & Tín dụng; bấm số Dư nợ hiện tại để mở Công nợ KH"
            },
            {
               "from": "Chi tiết khách hàng - tab Đơn hàng / Báo giá / Giao hàng",
               "to": "Chi tiết chứng từ",
               "action": "Mở chứng từ của khách",
               "how": "Bấm vào dòng trong tab"
            },
            {
               "from": "Chi tiết nhà cung cấp",
               "to": "Sổ cái công nợ phải trả",
               "action": "Xem công nợ NCC",
               "how": "Bấm [Sổ cái]"
            }
         ],
         "inlineViews": [
            {
               "name": "Tab chứng từ của khách hàng",
               "trigger": "Chi tiết khách hàng",
               "description": "Các tab Đơn hàng, Báo giá, Sản phẩm, Giao hàng hiện chứng từ của riêng khách này, kèm số lượng trên tab."
            },
            {
               "name": "Tình trạng xuất hoá đơn",
               "trigger": "Ô Mã số thuế trên chi tiết khách hàng",
               "description": "Hiện Đủ TT xuất HĐ hoặc Thiếu ... (các trường còn thiếu); rê chuột xem chi tiết."
            },
            {
               "name": "Cột Công nợ / Hạn mức",
               "trigger": "Danh sách khách hàng",
               "description": "Mỗi dòng hiện dư nợ, hạn mức và nhãn Vượt HM, Cận HM, Trong HM hoặc Chưa đặt HM; lọc nhanh bằng Công nợ và Hạng KH (6T)."
            },
            {
               "name": "Khung cảnh báo trùng",
               "trigger": "Form khách hàng khi gõ MST, mã hoặc tên",
               "description": "Khung đỏ chặn lưu (kèm nút Dùng khách hàng này / Mở khách hàng) hoặc khung vàng chỉ tham khảo."
            }
         ],
         "quickActions": [
            {
               "action": "Tra cứu MST",
               "shortcut": "Enter trong ô Mã số thuế",
               "description": "Chạy [Tra cứu MST 1-chạm] không cần bấm chuột"
            },
            {
               "action": "Thêm nhanh khách hàng / NCC",
               "description": "Dòng thêm mới ở cuối mọi ô chọn Khách hàng / Nhà cung cấp (cần quyền Thêm)"
            },
            {
               "action": "Chọn nhanh hạn mức",
               "description": "Nút 20M, 50M, 100M, 200M, 500M, 1 Tỷ dưới ô Hạn mức công nợ"
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/03_customer_modal_fullwidth_tax_lookup.png",
               "caption": "Hình 04.1 — Cửa sổ Thêm mới khách hàng mở từ Đơn hàng, có thanh Tra cứu MST 1-chạm"
            },
            {
               "src": "/guide-screenshots/07_order_form_customer_auto_returned.png",
               "caption": "Hình 04.2 — Sau khi lưu, khách hàng vừa tạo được điền ngay vào ô Khách hàng trên Đơn hàng"
            }
         ],
         "notes": [
            "Không tạo khách mới chỉ vì không tìm thấy trong ô chọn: hãy nhập MST, nếu hệ thống báo trùng thì bấm [Dùng khách hàng này] để tránh hai hồ sơ cho cùng một pháp nhân.",
            "Thiếu Mã số thuế hoặc Địa chỉ thì đơn hàng của khách không duyệt được; nên nhập đủ ngay khi tạo khách.",
            "Công nợ khách hàng không sửa tay ở bất kỳ màn hình nào; chênh lệch xử lý qua Phiếu giao hàng, Phiếu thu hoặc Đối soát công nợ.",
            "Khách đã phát sinh chứng từ không xoá được; nếu ngừng giao dịch, chuyển trạng thái sang Ngưng.",
            "Báo giá, Đơn đặt hàng, Phiếu giao hàng in tên pháp nhân lấy từ Tên đầy đủ của khách; nhập đúng tên theo đăng ký kinh doanh.",
            "Nhà cung cấp khác khách hàng ở chỗ có ô Nợ đầu kỳ (VNĐ) khi khai báo."
         ],
         "uatChecklist": [
            {
               "id": "SALE-04-01",
               "item": "Tạo khách hàng mới bằng tra cứu MST",
               "standard": "Tên đầy đủ, Địa chỉ trụ sở, Tên viết tắt, Mã khách hàng tự điền; bấm [Tạo mới] thành công, khách xuất hiện trong danh sách với trạng thái Hoạt động",
               "method": "1) Vào Kinh doanh › Khách hàng › [Thêm KH]; 2) Nhập MST thật của một khách mới (10 số) rồi nhấn Enter; 3) Nhập Điện thoại 0901234567, Email nhận hoá đơn ketoan@khachmau.vn; 4) Bấm [Tạo mới]; 5) Quay lại danh sách, tìm bằng ô Tìm kiếm trên đầu trang"
            },
            {
               "id": "SALE-04-02",
               "item": "Chặn tạo trùng MST",
               "standard": "Khung đỏ Lỗi: Trùng mã khách hàng hoặc mã số thuế! hiện ra, nút [Tạo mới] bị khoá, có nút [Mở khách hàng]",
               "method": "1) [Thêm KH]; 2) Nhập lại đúng MST của khách vừa tạo ở SALE-04-01; 3) Quan sát khung đỏ và nút [Tạo mới]; 4) Bấm [Mở khách hàng] → mở đúng hồ sơ cũ"
            },
            {
               "id": "SALE-04-03",
               "item": "Thêm nhanh khách từ ô chọn và dùng khách có sẵn khi trùng",
               "standard": "Cửa sổ Thêm mới khách hàng mở; khi trùng MST bấm [Dùng khách hàng này] thì cửa sổ đóng và khách có sẵn được chọn vào báo giá",
               "method": "1) Kinh doanh › Báo giá › [Tạo BG]; 2) Mở ô Khách hàng, bấm dòng Thêm KH mới; 3) Nhập MST của khách ở SALE-04-01; 4) Bấm [Dùng khách hàng này]; 5) Kiểm tra ô Khách hàng đã có tên khách"
            },
            {
               "id": "SALE-04-04",
               "item": "Sửa thông tin khách hàng",
               "standard": "Lưu thành công; trang chi tiết hiện giá trị mới; tab Lịch sử cập nhật ghi trường đã sửa từ giá trị cũ sang mới và người sửa",
               "method": "1) Mở chi tiết khách ở SALE-04-01; 2) Bấm [Sửa]; 3) Đổi Người liên hệ thành Nguyễn Văn Test, Dung sai số lượng 5%; 4) Bấm [Cập nhật]; 5) Mở tab Lịch sử cập nhật"
            },
            {
               "id": "SALE-04-05",
               "item": "Trùng MST khi sửa bị máy chủ từ chối",
               "standard": "Form hiện cảnh báo vàng; bấm [Cập nhật] bị từ chối với thông báo Mã số thuế ... đã được sử dụng bởi khách hàng khác, dữ liệu cũ giữ nguyên",
               "method": "1) Mở một khách khác, bấm [Sửa]; 2) Đổi MST thành MST của khách ở SALE-04-01; 3) Bấm [Cập nhật]; 4) Đọc thông báo lỗi; 5) Bấm [Huỷ]"
            },
            {
               "id": "SALE-04-06",
               "item": "Tình trạng đủ thông tin xuất hoá đơn",
               "standard": "Xoá Email nhận hoá đơn thì chi tiết hiện Thiếu ... cạnh Mã số thuế; nhập lại email đúng định dạng thì hiện Đủ TT xuất HĐ",
               "method": "1) Mở chi tiết khách, [Sửa]; 2) Xoá ô Email nhận hoá đơn, xem dòng Thiếu thông tin xuất HĐ trên form; 3) Bấm [Cập nhật], xem ô Mã số thuế trên chi tiết; 4) Sửa lại email ketoan@khachmau.vn, [Cập nhật], kiểm tra lại"
            },
            {
               "id": "SALE-04-07",
               "item": "Khách thiếu MST làm đơn hàng không duyệt được",
               "standard": "Chi tiết đơn hiện khung vàng Chưa đủ điều kiện duyệt đơn và nút [Duyệt Đơn (Thiếu MST/Đ/c)]; bấm duyệt bị từ chối nêu Mã số thuế (MST); bấm [Cập nhật Khách Hàng] mở đúng hồ sơ khách",
               "method": "1) Tạo khách KH-TEST-NOMST không nhập MST; 2) Tạo đơn hàng cho khách này, bấm [Lưu]; 3) Trên chi tiết đơn bấm [Duyệt Đơn (Thiếu MST/Đ/c)] › [Xác nhận duyệt]; 4) Đọc thông báo; 5) Bấm [Cập nhật Khách Hàng], bổ sung MST, quay lại duyệt thành công"
            },
            {
               "id": "SALE-04-08",
               "item": "Ngưng / Hoạt động lại khách hàng",
               "standard": "Công tắc đổi trạng thái sau khi xác nhận; lọc Trạng thái Ngưng trên danh sách thấy khách này",
               "method": "1) Mở chi tiết khách KH-TEST-NOMST; 2) Bấm công tắc Hoạt động › xác nhận; 3) Vào danh sách, chọn Trạng thái › Ngưng; 4) Bật lại Hoạt động"
            },
            {
               "id": "SALE-04-09",
               "item": "Chặn xoá khách đã có chứng từ",
               "standard": "Bị từ chối với thông báo Không thể xóa khách hàng này vì đã có dữ liệu liên kết kèm số đơn hàng / báo giá",
               "method": "1) Mở chi tiết khách đã có báo giá ở SALE-04-03; 2) Bấm [Xóa] › xác nhận; 3) Đọc thông báo"
            },
            {
               "id": "SALE-04-10",
               "item": "Xoá và phục hồi khách chưa có chứng từ",
               "standard": "Khách biến mất khỏi danh sách, nằm trong tab Thùng rác; Phục hồi đưa khách trở lại đúng mã cũ",
               "method": "1) Tạo khách KH-TEST-DEL; 2) Trên danh sách mở menu ... của dòng › Xoá › xác nhận; 3) Mở tab Thùng rác; 4) Menu ... › Phục hồi"
            },
            {
               "id": "SALE-04-11",
               "item": "Liên kết và tab chứng từ trên chi tiết khách",
               "standard": "Tab Đơn hàng, Báo giá hiện đúng chứng từ của khách; bấm dòng mở đúng chứng từ; tên khách trên chi tiết báo giá/đơn hàng là liên kết mở ngược về khách",
               "method": "1) Mở chi tiết khách ở SALE-04-01; 2) Mở tab Báo giá, bấm dòng báo giá; 3) Trên chi tiết báo giá bấm tên khách hàng; 4) Kiểm tra quay về đúng khách"
            },
            {
               "id": "SALE-04-12",
               "item": "Danh sách: bộ lọc, tìm kiếm, xuất Excel",
               "standard": "Lọc Hạng KH (6T), Công nợ cho kết quả đúng; tìm bằng ô Tìm kiếm trên đầu trang; tiêu đề cột đứng yên khi cuộn; file Excel tải về đúng bộ lọc",
               "method": "1) Kinh doanh › Khách hàng; 2) Chọn Công nợ › Chưa đặt HM; 3) Gõ tên khách vào ô Tìm kiếm trên đầu trang; 4) Cuộn danh sách; 5) Bấm [Xuất Excel], mở file"
            },
            {
               "id": "SALE-04-13",
               "item": "Màn hình điện thoại 390px",
               "standard": "Danh sách hiện dạng thẻ, không tràn ngang; chi tiết khách đọc được đủ thông tin; thanh nút dưới cùng tối đa 4 nút, nút còn lại trong nút …",
               "method": "1) Mở trình duyệt điện thoại (hoặc thu cửa sổ về rộng 390px); 2) Vào Kinh doanh › Khách hàng; 3) Bấm một khách; 4) Kiểm tra các nút [Sửa], [Xóa] và công tắc trạng thái"
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "SALES (Nhân Viên Kinh Doanh)",
               "createTest": "Tạo khách bằng [Thêm KH] và từ ô chọn trên Báo giá",
               "readTest": "Xem danh sách, chi tiết, tab Đơn hàng/Báo giá của khách",
               "updateTest": "Sửa liên hệ, bật/tắt Hoạt động",
               "deleteTest": "Xoá khách chưa có chứng từ; thử xoá khách đã có báo giá",
               "expectedResult": "Làm được theo quyền cấu hình Go-Live; xoá khách có chứng từ bị chặn kèm lý do"
            },
            {
               "roleGroup": "Vai trò bị tắt quyền Thêm khách hàng",
               "createTest": "Mở ô chọn Khách hàng trên Báo giá / Đơn hàng; tìm nút [Thêm KH] trên danh sách",
               "readTest": "Xem danh sách khách",
               "updateTest": "Mở chi tiết khách",
               "deleteTest": "Tìm nút Xoá",
               "expectedResult": "Không thấy dòng thêm mới trong ô chọn và nút [Thêm KH]; các thao tác khác theo quyền còn lại"
            },
            {
               "roleGroup": "ADMIN / DIRECTOR",
               "createTest": "Tạo khách",
               "readTest": "Xem mọi khách, kể cả khách do người khác phụ trách",
               "updateTest": "Sửa hạn mức công nợ",
               "deleteTest": "Phục hồi khách trong Thùng rác",
               "expectedResult": "Toàn quyền"
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 05. Báo Giá, Tính Giá Vốn & Lập Đơn Hàng
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "quotations",
         "aliases": [
            "quotation",
            "estimating",
            "pricing-configs"
         ],
         "title": "05. Báo Giá, Tính Giá Vốn & Lập Đơn Hàng",
         "icon": "MessageSquarePlus",
         "isoRef": "QT-KD-01",
         "permModule": "quotations",
         "purpose": "Chuẩn hoá việc lập Báo giá gửi khách tại Kinh doanh › Báo giá: chọn khách hàng và sản phẩm, kinh doanh tự nhập Giá chốt (giá bán), bộ phận tính giá ghi giá vốn tham khảo từng dòng (Dự toán BM-KT-01 hoặc Bảng chiết giá), gửi khách, ghi nhận khách duyệt và chuyển các dòng đã chốt sang Đơn hàng mà không phải nhập lại. Tính giá không bao giờ tự điền hay ghi đè giá bán.",
         "scope": [
            "Phòng Kinh Doanh: tạo, sửa, lưu nháp, gửi báo giá, in báo giá và lập Đơn hàng từ báo giá đã duyệt.",
            "Bộ phận tính giá / Kỹ thuật: nhận báo giá Đang xử lý, tính giá vốn tham khảo từng dòng. Giá chốt do kinh doanh nhập, không bị tính giá thay đổi.",
            "Người có quyền Duyệt báo giá (Trưởng phòng KD, Giám đốc hoặc vai trò được cấp): bấm [Khách duyệt] khi khách đã đồng ý.",
            "Quyền Xem/Thêm/Sửa/Xoá/Duyệt theo cấu hình vai trò tại Hệ Thống & Quy Trình › Phân quyền. Cấu hình Go-Live: các vai trò nghiệp vụ được mở đủ quyền; Quản trị viên thu hẹp khi cần."
         ],
         "references": [
            "ISO 9001:2015 mục 8.2 — Yêu cầu đối với sản phẩm và dịch vụ (xem xét yêu cầu khách hàng trước khi cam kết)",
            "Chương 04 — Khách hàng & tra cứu MST; Chương 06 — Đơn đặt hàng",
            "Quy chế Phân quyền nội bộ APV ERP (Hệ Thống & Quy Trình › Phân quyền)"
         ],
         "terms": [
            {
               "term": "Lưu nháp",
               "definition": "Ghi tạm báo giá khi chưa đủ thông tin (chỉ cần đã chọn Khách hàng). Bản nháp chỉ người tạo, Admin và Giám đốc thấy; người khác không thấy trên danh sách, không mở được."
            },
            {
               "term": "Lưu",
               "definition": "Báo giá mới hoặc đang Bản nháp: chuyển sang Đang xử lý để bộ phận tính giá nhận việc. Báo giá đã qua Bản nháp: nút đổi thành [Cập nhật], giữ nguyên trạng thái và tăng phiên bản (v2, v3...)."
            },
            {
               "term": "Giá chốt (Tính tiền)",
               "definition": "Giá bán thương thảo với khách, do kinh doanh nhập, dùng để tính Thành tiền. Bắt buộc lớn hơn 0đ khi cập nhật báo giá đã phát hành, khi Gửi BG và khi Khách duyệt."
            },
            {
               "term": "Đơn giá (Catalog)",
               "definition": "Đơn giá niêm yết lấy từ hồ sơ Sản phẩm. Sản phẩm chưa có đơn giá niêm yết thì để trống cho kinh doanh nhập, không tự suy ra từ giá vốn."
            },
            {
               "term": "Giá vốn tham khảo (BM-KT-01)",
               "definition": "Kết quả bóc tách chi phí một dòng báo giá (thành phần, vật tư, công đoạn). Lưu xong chỉ ghi giá vốn vào dòng; Giá chốt giữ nguyên, kể cả khi dòng chưa nhập giá. Dòng đã tính hiện nút xanh BM-KT-01 (giá vốn)."
            },
            {
               "term": "Bảng chiết giá (MOQ)",
               "definition": "Tab trên chi tiết báo giá để tính chi phí theo nhiều mốc số lượng; in bản nội bộ (bóc tách) hoặc bản gửi khách."
            },
            {
               "term": "Mốc số lượng bậc thang",
               "definition": "Nhân một dòng thành nhiều dòng với số lượng 5.000 / 10.000 / 20.000 / 50.000. Giá các mốc mới được gợi ý giảm dần từ Giá chốt của dòng gốc; anh/chị kiểm tra và sửa lại giá trước khi gửi khách."
            },
            {
               "term": "NON-MOQ",
               "definition": "Công tắc trên form đánh dấu báo giá không áp MOQ (chạy mẫu, chạy tay). Bản in có tiêu đề BÁO GIÁ (NON-MOQ / CHẠY MẪU)."
            }
         ],
         "responsibilities": [
            {
               "role": "Nhân viên Kinh doanh (SALES)",
               "tasks": [
                  "Tạo báo giá, chọn khách hàng, sản phẩm, số lượng và tự nhập Giá chốt",
                  "Bấm [Lưu nháp] khi chưa đủ thông tin, [Lưu] để chuyển bộ phận tính giá",
                  "Bấm [Gửi BG], [In BG] gửi khách; khi khách đồng ý thì báo người có quyền duyệt",
                  "Bấm [Lập Đơn Hàng] trên báo giá Đã duyệt"
               ]
            },
            {
               "role": "Bộ phận tính giá / Kỹ thuật",
               "tasks": [
                  "Mở báo giá Đang xử lý, bấm [Tính Giá] ở dòng sản phẩm để lập Dự toán BM-KT-01",
                  "Bấm [Lưu Dự Toán (Giá Vốn)] để ghi giá vốn tham khảo; không sửa Giá chốt của kinh doanh",
                  "Dùng tab Bảng chiết giá khi cần báo nhiều mốc số lượng"
               ]
            },
            {
               "role": "Trưởng phòng Kinh doanh / Giám đốc (quyền Duyệt báo giá)",
               "tasks": [
                  "Bấm [Khách duyệt] khi khách đã chấp nhận báo giá",
                  "Theo dõi giá vốn, % lợi nhuận trên từng dòng"
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Thấy cả bản nháp của mọi người; bấm được [Khách duyệt]."
            },
            {
               "role": "Vai trò nghiệp vụ (SALES, SALES_MANAGER... cấu hình Go-Live)",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Chỉ thấy và sửa bản nháp do mình tạo. Thiếu quyền Duyệt thì nút [Khách duyệt] bị mờ, rê chuột thấy Chỉ Giám Đốc hoặc Trưởng phòng Kinh Doanh mới có quyền duyệt Báo Giá này; thiếu quyền Thêm thì không thấy [Tạo BG]."
            }
         ],
         "processFlowchart": "graph TD\n    A[Tạo BG] --> B{Đủ thông tin}\n    B -->|Chưa| C[Lưu nháp - Bản nháp]\n    C --> A\n    B -->|Đủ| D[Lưu - Đang xử lý]\n    D --> E[Tính giá vốn từng dòng BM-KT-01]\n    E --> F[Đã tính giá]\n    D --> G[Gửi BG - Đã gửi]\n    F --> G\n    G --> H{Khách đồng ý}\n    H -->|Có| I[Khách duyệt - Đã duyệt]\n    H -->|Không| J[Từ chối]\n    J --> D\n    I --> K[Lập Đơn Hàng - chọn dòng chốt]\n    K --> L[Tạo Đơn Hàng Mới điền sẵn - Chương 06]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Tạo báo giá mới",
               "detail": "• Vào Kinh doanh › Báo giá, bấm [Tạo BG] (trang Tạo Báo Giá Mới).\n• Chọn Khách hàng (bắt buộc). Chưa có khách thì bấm dòng Thêm KH mới trong ô chọn (cần quyền Thêm khách hàng). Đã chọn khách thì có nút [Cập nhật hồ sơ KH] để sửa nhanh hồ sơ.\n• Nhập NV Kinh doanh phụ trách, Hiệu lực đến (mặc định 30 ngày), Đặt cọc, Điều khoản TT, TG giao hàng, Dung sai SL (Bù hao), Người liên hệ, Điện thoại, Email, Địa chỉ giao hàng. Bật NON-MOQ nếu là đơn chạy mẫu.\n• [Lưu thông tin khách hàng] ghi Người liên hệ, SĐT, Email và địa chỉ đang nhập vào hồ sơ khách (địa chỉ ghi vào ô Địa chỉ của khách)."
            },
            {
               "step": 2,
               "action": "Nhập dòng sản phẩm và Giá chốt",
               "detail": "• Ở bảng sản phẩm bấm [Thêm dòng], chọn ở ô Sản phẩm (ô chỉ mở khi đã chọn khách — hiện chữ Chọn KH trước). Hệ thống điền mã, tên, ĐVT, quy cách và Đơn giá (Catalog) nếu sản phẩm có đơn giá niêm yết.\n• Nhập Số lượng và Giá chốt (Tính tiền) theo giá đã thương thảo. Giá này do anh/chị quyết định; tính giá sau đó không thay đổi nó.\n• Có thể thêm [+ Mốc] số lượng bậc thang (giá gợi ý, cần kiểm tra lại) hoặc [Nhân bản] sản phẩm thành mã mới ngay trên dòng.\n• Nhập nhiều dòng từ file: [Tải mẫu Excel] rồi [Import Excel] (.xlsx, .xls)."
            },
            {
               "step": 3,
               "action": "Lưu nháp hoặc Lưu",
               "detail": "• [Lưu nháp]: chỉ cần đã chọn khách hàng; báo giá ở Bản nháp, chỉ anh/chị, Admin và Giám đốc thấy.\n• [Lưu]: báo giá chuyển Đang xử lý để bộ phận tính giá nhận việc (lần lưu đầu từ nháp chưa bắt buộc Giá chốt).\n• Báo giá đã qua Bản nháp chỉ còn nút [Cập nhật]; mọi dòng phải có Giá chốt lớn hơn 0đ, thiếu thì hệ thống liệt kê các dòng thiếu và nhảy tới ô đầu tiên. Mỗi lần cập nhật phiên bản tăng 1.\n• Lưu xong hệ thống mở trang chi tiết; tiêu đề trang là mã báo giá."
            },
            {
               "step": 4,
               "action": "Tính giá vốn tham khảo (Dự toán BM-KT-01)",
               "detail": "• Trên chi tiết báo giá, tab Sản phẩm: dòng chưa tính có nút [Tính Giá]; trong form có nút [Tính giá] trên dòng (báo giá phải lưu trước, nếu chưa hệ thống nhắc Vui lòng lưu báo giá (Lưu nháp hoặc Lưu) trước khi tính giá chi tiết).\n• Cửa sổ Dự Toán Kỹ Thuật: khai báo thành phần, vật tư, công đoạn; có [Thêm Chi Tiết], [Bảng Quy Trình], [Lưu Giá Vốn Vào SP] (ghi giá vốn chuẩn về sản phẩm, không đổi đơn giá niêm yết) và [In BM-KT-01]. Dải lưu ý dưới tiêu đề nhắc giá bán do kinh doanh nhập, kết quả chỉ để tham khảo.\n• Bấm [Lưu Dự Toán (Giá Vốn)]: chỉ ghi giá vốn tham khảo vào dòng; Giá chốt giữ nguyên. Dòng hiện nút xanh BM-KT-01 (giá vốn) để mở lại."
            },
            {
               "step": 5,
               "action": "Chuyển trạng thái trên chi tiết báo giá",
               "detail": "• Nút trên đầu trang theo trạng thái: Bản nháp và Đang xử lý có [Gửi BG], [Tính giá]; Đã gửi có [Khách duyệt], [Tính giá]; Đã tính giá có [Gửi BG], [Khách duyệt]; Đã duyệt có [Lập Đơn Hàng]. Luôn có [In BG], [Sửa], [Xoá].\n• Gửi BG và Khách duyệt luôn hỏi xác nhận; bị chặn nếu báo giá chưa có mặt hàng hoặc còn dòng giá 0đ (thông báo nêu tên từng sản phẩm).\n• Thanh trạng thái (Bản nháp → Đã gửi → Đang xử lý → Đã tính giá → Đã duyệt) chỉ cho bấm bước kế tiếp hoặc bước trước mà hệ thống cho phép; bước không được phép bị mờ. Khi hệ thống từ chối, thông báo đỏ nêu rõ lý do.\n• Nút Từ chối trên thanh trạng thái dùng khi khách không đồng ý (khi báo giá còn ở Bản nháp, Đã gửi hoặc Đang xử lý). Báo giá Từ chối có thể đưa lại Bản nháp hoặc Đang xử lý.\n• Ở Đã tính giá, nút ở cột % lợi nhuận mở cửa sổ Cập nhật Giá Bán để kinh doanh tự đặt giá theo % lợi nhuận."
            },
            {
               "step": 6,
               "action": "In báo giá gửi khách",
               "detail": "• Bấm [In BG]: cửa sổ in mẫu BÁO GIÁ (số chứng từ BG- kèm 8 ký tự đầu mã hệ thống), bật/tắt Hình ảnh, phóng to/thu nhỏ rồi in hoặc tải PDF.\n• Tab Bảng chiết giá có [In bảng chiết giá] › [In Nội Bộ (Bóc tách)] hoặc [In Cho Khách (Báo giá)]."
            },
            {
               "step": 7,
               "action": "Lập Đơn hàng từ báo giá đã duyệt (bàn giao sang Đơn hàng)",
               "detail": "• Báo giá Đã duyệt có nút [Lập Đơn Hàng]. Cửa sổ Chọn sản phẩm chốt đơn để chuyển sang Đơn hàng liệt kê mọi dòng (chọn sẵn hết) kèm tổng tiền; bỏ chọn dòng khách không đặt rồi bấm [Tiếp tục & Lập Đơn].\n• Trang Tạo Đơn Hàng Mới điền sẵn khách hàng, người liên hệ, điện thoại, email, địa chỉ giao, VAT, phí vận chuyển, tiền tệ, tỷ giá, điều khoản thanh toán, đặt cọc, NV phụ trách, ghi chú Từ báo giá + mã BG, ngày đặt hôm nay, hạn giao +7 ngày và các dòng đã chọn với số lượng, Giá chốt, giá vốn. Kiểm tra rồi bấm [Lưu nháp] / [Lưu] (xem Chương 06).\n• Trên danh sách, chọn đúng 1 báo giá Đã duyệt thì thanh tác vụ có [Tạo Đơn Hàng] (chuyển toàn bộ dòng).\n• Tab Đơn hàng trên chi tiết báo giá liệt kê các đơn đã lập; chi tiết đơn có ô Từ báo giá là liên kết quay về báo giá."
            }
         ],
         "subFlows": [
            {
               "name": "Danh sách & tìm kiếm",
               "steps": [
                  "Hàng trên: tab Danh Sách Báo Giá / Thùng rác và nút [Xuất Excel], [Tạo BG]; hàng dưới: nút nhóm theo ngày, bộ lọc thời gian, nút Lọc và Trạng thái BG.",
                  "Tìm báo giá bằng ô Tìm kiếm trên thanh đầu trang (không có ô tìm trong trang).",
                  "Mỗi dòng hiện Người liên hệ · SĐT dưới tên khách, người lập dưới ngày tạo, tiến độ dưới ngày hiệu lực: Còn N ngày, Quá hạn N ngày, chưa chốt, Đã chốt đơn, Khách từ chối.",
                  "Bấm mũi tên ở cột mã để xổ chi tiết ngay trên dòng; bấm vào dòng để mở trang chi tiết; tiêu đề cột đứng yên khi cuộn."
               ]
            },
            {
               "name": "Thêm mới",
               "steps": [
                  "Bấm [Tạo BG] (cần quyền Thêm).",
                  "Chọn khách hàng, thêm dòng sản phẩm, nhập số lượng và Giá chốt.",
                  "Bấm [Lưu nháp] hoặc [Lưu]; hệ thống mở trang chi tiết báo giá vừa tạo."
               ]
            },
            {
               "name": "Sửa",
               "steps": [
                  "Trên chi tiết bấm [Sửa]; tiêu đề trang Sửa + mã báo giá, cạnh đó là trạng thái hiện tại.",
                  "Báo giá Bản nháp: có [Lưu nháp] và [Lưu]. Báo giá đã chuyển đi: chỉ có [Cập nhật].",
                  "Báo giá đã có đơn hàng: form hiện cảnh báo đỏ Cảnh báo: Báo giá đã được lên Đơn hàng!; lưu thay đổi chỉ tăng phiên bản, không đổi đơn đã lập.",
                  "Không thể đặt Đã duyệt bằng cách sửa form; duyệt chỉ qua [Khách duyệt]."
               ]
            },
            {
               "name": "Xem chi tiết",
               "steps": [
                  "Khối thông tin chung: Khách hàng (liên kết mở hồ sơ khách), Mã KH, Hiệu lực đến, Liên hệ, Điện thoại, Email, NV Kinh doanh, Địa chỉ giao, Người duyệt, điều kiện thanh toán.",
                  "Tab Sản phẩm, Đơn hàng, Bảng chiết giá; bên dưới tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật.",
                  "Cuối trang: Tạo lúc / Cập nhật lúc kèm người thao tác, nút [Xem lịch sử]."
               ]
            },
            {
               "name": "Xoá",
               "steps": [
                  "Trên chi tiết: [Xoá] › xác nhận [Xoá báo giá].",
                  "Trên danh sách: biểu tượng thùng rác trên dòng, hoặc chọn nhiều dòng rồi bấm Xoá trên thanh tác vụ (cần quyền Xoá).",
                  "Báo giá bị xoá vào tab Thùng rác của trang, phục hồi được đúng mã cũ (cần quyền Xoá)."
               ]
            },
            {
               "name": "Xuất Excel",
               "steps": [
                  "Bấm [Xuất Excel]: mỗi dòng sản phẩm một hàng (Mã BG, Khách hàng, NV Kinh doanh, Ngày tạo, Hiệu lực, Trạng thái, Tổng giá trị, Mã SP, Tên SP, ĐVT, Số lượng, Đơn giá, Thành tiền, Biên LN (%), Ghi chú)."
               ]
            },
            {
               "name": "In",
               "steps": [
                  "[In BG] trên chi tiết: mẫu BÁO GIÁ gửi khách.",
                  "[In BM-KT-01] trong cửa sổ Dự Toán Kỹ Thuật › [In Ngay (Print A4)].",
                  "[In bảng chiết giá] trong tab Bảng chiết giá › [In Nội Bộ (Bóc tách)] hoặc [In Cho Khách (Báo giá)]."
               ]
            },
            {
               "name": "Đặt cọc và Thời gian giao hàng",
               "steps": [
                  "Ô Đặt cọc chọn sẵn: Không, 30%, 50%, 100%, Theo hợp đồng. Ô TG giao hàng chọn sẵn: 1-3 ngày, 3-5 ngày, 7-10 ngày.",
                  "Cần giá trị khác thì Quản trị viên thêm trong Hệ thống › Cấu hình (danh mục Đặt cọc, Thời gian giao hàng)."
               ]
            },
            {
               "name": "Đọc cột Chi tiết của dòng sản phẩm",
               "steps": [
                  "Cột Chi tiết ở màn xem báo giá và bản in báo giá ghi chất liệu trước rồi các công đoạn sản xuất, VD “Duplex 450gsm, Cắt xén giấy, In 4 màu CMYK, Cán màng bóng, Bế, Dán, Kiểm hàng, Đóng gói”.",
                  "Nội dung lấy theo sản phẩm hiện tại: sửa quy trình hoặc vật tư của sản phẩm thì báo giá hiển thị theo.",
                  "Hai dòng liền nhau chỉ gộp chung một ô Chi tiết khi nội dung giống hệt nhau."
               ]
            },
            {
               "name": "Tính giá là bản xem thử",
               "steps": [
                  "Hộp Tính giá trên báo giá ghi rõ “Bản xem thử · chỉ tham khảo”: ra giá vốn và giá bán tham khảo.",
                  "Kết quả không thay đổi giá báo trên dòng báo giá, không thay đổi giá bán của sản phẩm; giá chốt do kinh doanh nhập."
               ]
            },
            {
               "name": "Báo giá › Tạo / Sửa — nút trên dòng sản phẩm (sửa SP gốc, nhân bản SP, thêm mốc số lượng)",
               "steps": [
                  "Các nút dưới đây chỉ hiện khi dòng báo giá đã chọn một sản phẩm có trong danh mục.",
                  "[Chỉnh sửa sản phẩm gốc (Canonical Form)...] (biểu tượng bút cạnh mã SP): mở hộp sửa sản phẩm ngay trên báo giá; lưu xong, mã, tên, đơn vị, quy cách và giá vốn của dòng được cập nhật theo sản phẩm.",
                  "Sửa sản phẩm gốc không ghi đè giá bán sale đã nhập trên dòng; chỉ khi dòng chưa có giá thì hệ thống mới điền đơn giá niêm yết của sản phẩm.",
                  "[Nhân bản sản phẩm này làm SP mới (Canonical Form)...] (biểu tượng sao chép, hoặc nút Copy ở cột Thao tác): mở form tạo sản phẩm mới đã điền sẵn thông số của sản phẩm đang chọn, mã mới tự sinh theo khách hàng và tên thêm \"(Bản sao)\".",
                  "Sau khi lưu sản phẩm nhân bản, hệ thống chèn một dòng mới ngay dưới dòng gốc, giữ nguyên số lượng và giá của dòng gốc; nếu không tải được sản phẩm sẽ báo \"Không thể tải thông tin sản phẩm để sao chép\".",
                  "Nút [+ Mốc] ở cột Thao tác mở danh sách mốc số lượng bậc thang để chào giá theo nhiều số lượng.",
                  "[Mốc 5.000 cái (Chuẩn)]: chèn dòng mới 5.000 cái ngay dưới, giá điền sẵn bằng giá của dòng gốc.",
                  "[Mốc 10.000 cái (Giảm ~5%)]: chèn dòng mới 10.000 cái, giá điền sẵn bằng giá dòng gốc trừ khoảng 5%.",
                  "[Mốc 20.000 cái (Giảm ~10%)]: chèn dòng mới 20.000 cái, giá điền sẵn bằng giá dòng gốc trừ khoảng 10%.",
                  "[Mốc 50.000 cái (Giảm ~15%)]: chèn dòng mới 50.000 cái, giá điền sẵn bằng giá dòng gốc trừ khoảng 15%; mục ⚡ Thêm cả 4 mốc thêm cùng lúc 4 dòng.",
                  "Giá trên các dòng mốc chỉ là gợi ý tính từ giá sale đã nhập ở dòng gốc; sale kiểm tra và sửa lại giá từng dòng trước khi lưu báo giá.",
                  "Nếu mốc trùng với số lượng của dòng gốc, hệ thống báo \"Mốc số lượng này đã trùng với dòng hiện tại\" và không thêm dòng."
               ]
            },
            {
               "name": "Báo giá — Tính giá: hộp Dự Toán Kỹ Thuật (nút Xoay 90°)",
               "steps": [
                  "Nút [Tính giá] trên dòng chỉ dùng được sau khi báo giá đã được lưu; nếu chưa lưu, hệ thống báo \"Vui lòng lưu báo giá (Lưu nháp hoặc Lưu) trước khi tính giá chi tiết.\"; dòng combo hoặc hàng thương mại không tính giá.",
                  "Hộp Dự Toán Kỹ Thuật có nhãn \"Bản xem thử · chỉ tham khảo\": kết quả không thay đổi giá báo và giá bán của sản phẩm.",
                  "[Xoay 90°] (cạnh ô Chiều sớ giấy): bật/tắt đánh dấu xoay tấm trải 90° cho thành phần đang chọn, nút chuyển màu vàng khi đang bật.",
                  "Số con trên tờ vẫn được hệ thống tự tính theo cách xếp có lợi nhất trên khổ giấy, hoặc theo số con (ups) bạn nhập tay."
               ]
            },
            {
               "name": "Báo giá › tab Bảng chiết giá — các tab thành phần",
               "steps": [
                  "Tab Bảng chiết giá trên trang chi tiết báo giá hiện một bảng tính cho mỗi sản phẩm trong báo giá.",
                  "Mỗi thành phần của sản phẩm là một tab, tên tab là tên thành phần, nếu chưa đặt tên thì hiện [Component …] kèm số thứ tự.",
                  "Bấm vào tab [Component …] để xem và sửa tên thành phần, số Out/Up (số sản phẩm trên một tờ), vật tư và công đoạn của thành phần đó.",
                  "Biểu tượng thùng rác trên tab xóa thành phần đó khỏi bảng tính; chỉ hiện khi có từ hai thành phần trở lên.",
                  "Nút Thêm Thành phần tạo thêm một tab thành phần mới để khai báo.",
                  "Khung Tổng Hợp Chi Phí bên phải tự tính lại mỗi khi bạn sửa số liệu.",
                  "Nút Lưu bảng tính lưu bảng chiết giá và gắn vào dòng báo giá; việc lưu không đổi giá báo chốt do sale nhập."
               ]
            },
            {
               "name": "Bảng tính giá thử nghiệm (/estimating/calculator) — chỉ mở bằng đường dẫn",
               "steps": [
                  "Màn này không có mục menu và không thuộc quy trình báo giá chính thức (báo giá dùng Kinh doanh › Báo giá, Chương 05); chỉ dùng khi quản trị cần thử phương án giá.",
                  "Thông tin chung: Mã Báo Giá, Số lượng (Thành phẩm); tab Chi Tiết Component & Định Mức → [Thêm Component] để thêm thành phần (giấy, kích thước, công đoạn trong khung Bình bài & Công đoạn).",
                  "Tab Mô Phỏng Đa Máy In & Bù Hao: chọn mẫu hộp nhanh (🎁 Hộp Quà Luxury, 📦 Thùng Sóng Bồi, 🪟 Hộp Cửa Sổ Suppo), Chiều sớ giấy MD (Dọc) / CD (Ngang), đơn giá giấy theo gsm - đ/kg, Kho giấy WMS; màn so sánh chi phí và bù hao giữa các máy in.",
                  "[Xác Nhận Tạo Báo Giá]: tạo báo giá từ phương án đã chọn; giá bán trên báo giá vẫn do kinh doanh nhập và duyệt như Chương 05."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "(Mới)",
               "to": "Bản nháp",
               "action": "[Lưu nháp]",
               "allowedRoles": "Người có quyền Thêm báo giá"
            },
            {
               "from": "(Mới) / Bản nháp",
               "to": "Đang xử lý",
               "action": "[Lưu]",
               "allowedRoles": "Người có quyền Thêm / Sửa báo giá (bản nháp: chỉ người tạo, Admin, Giám đốc)"
            },
            {
               "from": "Bản nháp / Đang xử lý / Đã tính giá",
               "to": "Đã gửi",
               "action": "[Gửi BG] (cần có mặt hàng và giá > 0đ)",
               "allowedRoles": "Người có quyền Sửa báo giá"
            },
            {
               "from": "Bản nháp / Đã gửi / Đang xử lý",
               "to": "Đã tính giá",
               "action": "[Tính giá] trên đầu trang hoặc bước trên thanh trạng thái",
               "allowedRoles": "Người có quyền Sửa báo giá"
            },
            {
               "from": "Đã gửi / Đang xử lý / Đã tính giá",
               "to": "Đã duyệt",
               "action": "[Khách duyệt] (cần có mặt hàng và giá > 0đ)",
               "allowedRoles": "Người có quyền Duyệt báo giá"
            },
            {
               "from": "Bản nháp / Đã gửi / Đang xử lý / Đã tính giá / Đã duyệt",
               "to": "Từ chối",
               "action": "Nút Từ chối trên thanh trạng thái",
               "allowedRoles": "Người có quyền Sửa hoặc Duyệt báo giá"
            },
            {
               "from": "Từ chối",
               "to": "Bản nháp / Đang xử lý",
               "action": "Bấm bước trên thanh trạng thái",
               "allowedRoles": "Người có quyền Sửa báo giá"
            },
            {
               "from": "Bản nháp",
               "to": "Đã duyệt (không cho phép)",
               "action": "Hệ thống từ chối: phải qua Đã gửi, Đang xử lý hoặc Đã tính giá rồi mới duyệt",
               "allowedRoles": "—"
            }
         ],
         "actionLinks": [
            {
               "from": "Chi tiết Báo giá",
               "to": "Tạo Đơn Hàng Mới",
               "action": "Lập Đơn hàng từ báo giá Đã duyệt",
               "how": "Bấm [Lập Đơn Hàng], chọn các dòng chốt, bấm [Tiếp tục & Lập Đơn]."
            },
            {
               "from": "Danh sách Báo giá",
               "to": "Tạo Đơn Hàng Mới",
               "action": "Lập Đơn hàng cho toàn bộ dòng",
               "how": "Chọn đúng 1 báo giá Đã duyệt, bấm [Tạo Đơn Hàng] trên thanh tác vụ."
            },
            {
               "from": "Chi tiết Báo giá - tab Đơn hàng",
               "to": "Chi tiết Đơn hàng",
               "action": "Xem đơn đã lập từ báo giá",
               "how": "Bấm mã đơn trong tab Đơn hàng."
            },
            {
               "from": "Chi tiết Đơn hàng - ô Từ báo giá",
               "to": "Chi tiết Báo giá",
               "action": "Quay về báo giá gốc",
               "how": "Bấm mã báo giá ở ô Từ báo giá."
            },
            {
               "from": "Chi tiết Báo giá - ô Khách hàng",
               "to": "Chi tiết Khách hàng",
               "action": "Xem hồ sơ khách",
               "how": "Bấm tên khách hàng."
            },
            {
               "from": "Form Báo giá - ô Khách hàng",
               "to": "Cửa sổ Thêm mới khách hàng",
               "action": "Thêm nhanh khách hàng",
               "how": "Bấm dòng Thêm KH mới trong ô chọn; xem Chương 04 về trùng MST và [Dùng khách hàng này]."
            }
         ],
         "inlineViews": [
            {
               "name": "Xổ chi tiết báo giá trên danh sách",
               "trigger": "Bấm mũi tên cạnh Mã BG",
               "description": "Hiện bảng Chi tiết báo giá (sản phẩm, số lượng, đơn giá) ngay dưới dòng."
            },
            {
               "name": "Cửa sổ Dự Toán Kỹ Thuật",
               "trigger": "[Tính Giá] / nút xanh BM-KT-01 trên dòng sản phẩm",
               "description": "Bóc tách chi phí nhiều thành phần, hiện Giá Vốn và giá bán tham khảo; lưu chỉ ghi giá vốn vào dòng báo giá."
            },
            {
               "name": "Tab Bảng chiết giá",
               "trigger": "Chi tiết báo giá › tab Bảng chiết giá",
               "description": "Mỗi sản phẩm một bảng tính chi phí theo thành phần và quy trình, có [Lưu bảng tính] và [In bảng chiết giá]."
            }
         ],
         "quickActions": [
            {
               "action": "[Tạo BG]",
               "description": "Tạo báo giá mới từ danh sách."
            },
            {
               "action": "[Gửi BG] / [Khách duyệt] / [Tính giá]",
               "description": "Chuyển trạng thái ngay trên đầu trang chi tiết, có hộp xác nhận."
            },
            {
               "action": "[Lập Đơn Hàng]",
               "description": "Chuyển các dòng đã chốt của báo giá Đã duyệt sang trang Tạo Đơn Hàng Mới."
            },
            {
               "action": "[In BG]",
               "description": "In mẫu BÁO GIÁ gửi khách."
            }
         ],
         "forms": [
            {
               "code": "BM-KT-01",
               "name": "Bảng Bóc Tách Dự Toán Giá Thành (in từ cửa sổ Dự Toán Kỹ Thuật của dòng báo giá)"
            }
         ],
         "notes": [
            "Giá bán do kinh doanh nhập: Tính giá, Lưu Dự Toán (Giá Vốn) và Lưu Giá Vốn Vào SP chỉ ghi giá vốn, không tự điền hay ghi đè Giá chốt, kể cả dòng chưa nhập giá.",
            "Mẫu in BÁO GIÁ không ghi mã biểu mẫu ISO; số chứng từ in dạng BG- kèm 8 ký tự đầu của mã hệ thống.",
            "Bản nháp của người khác không hiện trên danh sách và không mở được; muốn đồng nghiệp xử lý thì bấm [Lưu] để chuyển Đang xử lý.",
            "Duyệt từng báo giá bằng [Khách duyệt]. Nút Phê duyệt trên thanh tác vụ của danh sách chỉ hiện khi mọi báo giá đang chọn ở Đã gửi, Đang xử lý hoặc Đã tính giá; báo giá Bản nháp không duyệt hàng loạt được.",
            "Báo giá không có trạng thái Hủy: nếu thanh trạng thái có nút Hủy, bấm vào hệ thống sẽ báo không chuyển được; khách không đồng ý thì dùng Từ chối.",
            "Các màn hình Dự toán tính giá, Cấu hình hệ số giá và bảng hạng mục chờ tính không có trên menu bên trái; chỉ mở bằng đường dẫn."
         ],
         "uatChecklist": [
            {
               "id": "SALE-05-01",
               "item": "Tạo báo giá và Lưu nháp",
               "standard": "Báo giá ở Bản nháp, mở trang chi tiết; tài khoản sale khác không thấy báo giá này trên danh sách",
               "method": "1) Vào Kinh doanh › Báo giá › [Tạo BG]; 2) Chọn khách KH-TEST; 3) [Thêm dòng], chọn 1 sản phẩm hộp giấy, Số lượng 5000, Giá chốt 2.500; 4) Bấm [Lưu nháp]; 5) Đăng nhập tài khoản sale khác, kiểm tra danh sách"
            },
            {
               "id": "SALE-05-02",
               "item": "Lưu nháp thiếu khách hàng bị chặn",
               "standard": "Thông báo Chọn khách hàng trước khi lưu nháp, không tạo báo giá",
               "method": "1) [Tạo BG]; 2) Không chọn khách; 3) Bấm [Lưu nháp]"
            },
            {
               "id": "SALE-05-03",
               "item": "Lưu chuyển Đang xử lý",
               "standard": "Báo giá chuyển Đang xử lý, mọi người có quyền xem đều thấy; nút trên form đổi thành [Cập nhật]",
               "method": "1) Mở báo giá ở SALE-05-01, bấm [Sửa]; 2) Bấm [Lưu]; 3) Kiểm tra trạng thái; 4) Bấm [Sửa] lần nữa, xem tên nút lưu"
            },
            {
               "id": "SALE-05-04",
               "item": "Cập nhật báo giá có dòng Giá chốt 0đ bị chặn",
               "standard": "Hệ thống liệt kê sản phẩm chưa nhập Giá báo chốt (cần lớn hơn 0đ) và nhảy tới ô đầu tiên; không lưu",
               "method": "1) Báo giá Đang xử lý › [Sửa]; 2) [Thêm dòng] sản phẩm thứ hai, để trống Giá chốt; 3) Bấm [Cập nhật]; 4) Nhập Giá chốt 3.000, [Cập nhật] lại → phiên bản tăng v2"
            },
            {
               "id": "SALE-05-05",
               "item": "Tính giá vốn không đổi Giá chốt",
               "standard": "Dòng hiện BM-KT-01 (giá vốn) với giá vốn mới; Giá chốt 2.500 giữ nguyên",
               "method": "1) Mở chi tiết báo giá, tab Sản phẩm; 2) Bấm [Tính Giá] ở dòng 1; 3) Trong cửa sổ Dự Toán Kỹ Thuật bấm [Lưu Dự Toán (Giá Vốn)]; 4) So Giá chốt trước và sau"
            },
            {
               "id": "SALE-05-06",
               "item": "Gửi báo giá từ Đang xử lý",
               "standard": "Hộp Xác nhận gửi báo giá hiện ra; sau [Gửi báo giá] trạng thái Đã gửi",
               "method": "1) Báo giá Đang xử lý › bấm [Gửi BG]; 2) Bấm [Gửi báo giá]; 3) Kiểm tra trạng thái và tab Lịch sử cập nhật (Trạng thái: Đang xử lý → Đã gửi)"
            },
            {
               "id": "SALE-05-07",
               "item": "Gửi BG bị từ chối khi còn dòng giá 0đ",
               "standard": "Thông báo đỏ Không thể gửi báo giá: Các sản phẩm sau chưa có đơn giá hợp lệ (> 0đ) kèm tên sản phẩm; trạng thái không đổi",
               "method": "1) Tạo báo giá mới, 1 dòng không nhập Giá chốt, bấm [Lưu nháp]; 2) Trên chi tiết bấm [Gửi BG]; 3) Đọc thông báo"
            },
            {
               "id": "SALE-05-08",
               "item": "Thanh trạng thái chỉ cho bước hợp lệ",
               "standard": "Bước không được phép bị mờ, không bấm được; bấm bước hợp lệ có hộp Chuyển trạng thái; nếu hệ thống từ chối thì hiện lý do bằng chữ",
               "method": "1) Mở báo giá Đã gửi; 2) Rê chuột lên các bước trên thanh trạng thái; 3) Bấm bước Đang xử lý › [Xác nhận]; 4) Ở báo giá Bản nháp bấm Từ chối › [Xác nhận], kiểm tra dải Đã từ chối"
            },
            {
               "id": "SALE-05-09",
               "item": "Khách duyệt cần quyền Duyệt",
               "standard": "Người có quyền Duyệt: báo giá sang Đã duyệt, hiện [Lập Đơn Hàng]. Vai trò bị tắt quyền Duyệt: nút [Khách duyệt] mờ kèm chú thích chỉ Giám Đốc hoặc Trưởng phòng Kinh Doanh",
               "method": "1) Đăng nhập Trưởng phòng KD; 2) Mở báo giá Đã gửi › [Khách duyệt] › [Xác nhận duyệt]; 3) Đăng nhập vai trò không có quyền Duyệt, mở báo giá Đã gửi khác, rê chuột lên [Khách duyệt]"
            },
            {
               "id": "SALE-05-10",
               "item": "Lập Đơn hàng từ báo giá (bàn giao sang Đơn hàng)",
               "standard": "Trang Tạo Đơn Hàng Mới điền sẵn khách, liên hệ, địa chỉ giao, điều khoản, chỉ các dòng đã chọn với đúng Giá chốt; ghi chú Từ báo giá + mã BG; lưu xong tab Đơn hàng của báo giá có đơn mới",
               "method": "1) Báo giá Đã duyệt có 2 dòng › [Lập Đơn Hàng]; 2) Bỏ chọn dòng 2, bấm [Tiếp tục & Lập Đơn]; 3) Đối chiếu dữ liệu; 4) Chọn Hạn giao hàng, bấm [Lưu]; 5) Quay lại báo giá, mở tab Đơn hàng"
            },
            {
               "id": "SALE-05-11",
               "item": "Liên kết hai chiều Báo giá - Đơn hàng - Khách hàng",
               "standard": "Bấm mã đơn trong tab Đơn hàng mở đúng đơn; ô Từ báo giá trên đơn mở lại đúng báo giá; tên khách mở đúng hồ sơ khách",
               "method": "1) Từ báo giá ở SALE-05-10 bấm mã đơn; 2) Trên đơn bấm mã ở ô Từ báo giá; 3) Trên báo giá bấm tên khách hàng"
            },
            {
               "id": "SALE-05-12",
               "item": "In báo giá",
               "standard": "Mẫu BÁO GIÁ hiện đúng khách, sản phẩm, số lượng, Giá chốt, tổng tiền; báo giá NON-MOQ có tiêu đề BÁO GIÁ (NON-MOQ / CHẠY MẪU)",
               "method": "1) Mở báo giá Đã duyệt › [In BG]; 2) Bật/tắt Hình ảnh; 3) Tải PDF; 4) Lặp lại với báo giá bật NON-MOQ"
            },
            {
               "id": "SALE-05-13",
               "item": "Xoá và phục hồi báo giá",
               "standard": "Báo giá vào tab Thùng rác; phục hồi lại đúng mã cũ",
               "method": "1) Mở báo giá thử › [Xoá] › [Xoá báo giá]; 2) Trên danh sách mở tab Thùng rác; 3) Phục hồi; 4) Kiểm tra báo giá trở lại danh sách"
            },
            {
               "id": "SALE-05-14",
               "item": "Danh sách, tìm kiếm và màn hình điện thoại 390px",
               "standard": "Tìm bằng ô Tìm kiếm trên đầu trang ra đúng báo giá; lọc Trạng thái BG đúng; trên 390px danh sách dạng thẻ, chi tiết có thanh nút dưới cùng tối đa 4 nút, còn lại trong nút …",
               "method": "1) Kinh doanh › Báo giá; 2) Gõ mã BG vào ô Tìm kiếm trên đầu trang; 3) Chọn Trạng thái BG › Đã duyệt; 4) Thu cửa sổ về 390px (hoặc dùng điện thoại), mở một báo giá, kiểm tra các nút"
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "SALES (Nhân Viên Kinh Doanh)",
               "createTest": "[Tạo BG], [Lưu nháp], [Lưu]",
               "readTest": "Xem danh sách; không thấy bản nháp của sale khác",
               "updateTest": "Sửa báo giá của mình, [Gửi BG]",
               "deleteTest": "Xoá báo giá thử",
               "expectedResult": "Làm được theo quyền cấu hình; bản nháp người khác không hiện"
            },
            {
               "roleGroup": "SALES_MANAGER / DIRECTOR (có quyền Duyệt)",
               "createTest": "Tạo báo giá",
               "readTest": "DIRECTOR thấy cả bản nháp của mọi người",
               "updateTest": "[Khách duyệt] báo giá Đã gửi",
               "deleteTest": "Xoá, phục hồi trong Thùng rác",
               "expectedResult": "Báo giá sang Đã duyệt, hiện [Lập Đơn Hàng]"
            },
            {
               "roleGroup": "Vai trò bị tắt quyền Duyệt báo giá",
               "createTest": "Tạo và gửi báo giá",
               "readTest": "Xem chi tiết báo giá Đã gửi",
               "updateTest": "Bấm [Khách duyệt]",
               "deleteTest": "—",
               "expectedResult": "Nút [Khách duyệt] mờ kèm chú thích; hệ thống từ chối duyệt"
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 06. Quản Lý Đơn Đặt Hàng: Lưu, Duyệt, Lập Lệnh SX & Chốt Đơn
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "orders",
         "aliases": [
            "order",
            "so",
            "orders-create",
            "sales-orders"
         ],
         "title": "06. Quản Lý Đơn Đặt Hàng: Lưu, Duyệt, Lập Lệnh SX & Chốt Đơn",
         "icon": "ShoppingCart",
         "isoRef": "QT-KD-02",
         "permModule": "orders",
         "purpose": "Quản lý vòng đời Đơn đặt hàng tại Kinh doanh › Đơn hàng: lập đơn từ Báo giá đã duyệt hoặc tạo trực tiếp, lưu nháp riêng tư, gửi chờ duyệt, duyệt đơn (khách hàng phải có Mã số thuế và Địa chỉ), bàn giao cho Bình file và Kế hoạch lập Lệnh sản xuất, theo dõi sản xuất - giao hàng - thanh toán trên từng dòng và chốt hoàn tất khi đã giao trong dung sai. Đơn giá trên đơn do kinh doanh nhập, hệ thống không tự tính lại.",
         "scope": [
            "Phòng Kinh Doanh: lập, sửa, lưu nháp và gửi duyệt đơn; nhập dòng sản phẩm từ Excel; in Đơn đặt hàng và Phiếu yêu cầu sản xuất; theo dõi tiến độ và chốt đơn.",
            "Trưởng phòng Kinh Doanh / Ban Giám Đốc (quyền Duyệt đơn hàng): bấm [Duyệt Đơn] hoặc Phê duyệt (Confirm) hàng loạt để đơn sang Đã xác nhận.",
            "Bình file và Kế hoạch: bình file từng dòng, lập Lệnh sản xuất từ đơn (Chương 07, 08).",
            "Kho / Giao nhận: tạo Phiếu giao hàng từ đơn (Chương 14). Gia công toàn phần đặt thẳng từ đơn, gia công một phần đặt từ Lệnh SX (Chương 13).",
            "Quyền Xem / Thêm / Sửa / Xoá / Duyệt theo cấu hình Phân quyền, phân hệ Đơn hàng. Cấu hình Go-Live: các vai trò nghiệp vụ được mở đủ quyền; Quản trị viên thu hẹp khi cần."
         ],
         "references": [
            "ISO 9001:2015 mục 8.2 — Yêu cầu đối với sản phẩm và dịch vụ (xem xét yêu cầu của khách hàng trước khi cam kết)",
            "ISO 9001:2015 mục 8.5.1 — Kiểm soát sản xuất và cung cấp dịch vụ",
            "Chương 04 — Khách hàng; Chương 05 — Báo giá; Chương 07 — Bình file; Chương 08 — Lệnh sản xuất; Chương 13 — Gia công ngoài; Chương 14 — Giao hàng",
            "Quy chế Phân quyền nội bộ APV ERP (Hệ Thống & Quy Trình › Phân quyền)"
         ],
         "terms": [
            {
               "term": "Đơn hàng (SO)",
               "definition": "Đơn đặt hàng của khách, mã dạng DH-... ở cột Mã ĐH; tiêu đề trang chi tiết là mã đơn."
            },
            {
               "term": "Lưu nháp",
               "definition": "Ghi tạm đơn khi chưa đủ thông tin (chỉ cần chọn Khách hàng). Bản nháp chỉ người tạo, Admin và Giám đốc thấy; người khác mở đường dẫn sẽ thấy Không tìm thấy đơn hàng."
            },
            {
               "term": "Lưu",
               "definition": "Kiểm tra đủ ô bắt buộc và chuyển đơn mới (hoặc đang nháp) sang Chờ duyệt. Đơn đã qua Bản nháp thì nút đổi thành [Cập nhật] và giữ nguyên trạng thái."
            },
            {
               "term": "Điều kiện duyệt đơn",
               "definition": "Khách hàng của đơn phải có Mã số thuế (MST) và Địa chỉ. Thiếu thì nút đổi thành [Duyệt Đơn (Thiếu MST/Đ/c)] và hệ thống từ chối duyệt, kể cả khi chuyển bằng thanh trạng thái hay duyệt hàng loạt."
            },
            {
               "term": "Dung sai giao hàng",
               "definition": "Tỷ lệ chênh lệch cho phép giữa số lượng giao và số lượng đặt; lấy mức lớn nhất giữa dung sai của đơn, của khách hàng và 5%. Huy hiệu Giao: đã giao/đặt (Dung sai ±x%) hiện cạnh trạng thái."
            },
            {
               "term": "Mức ưu tiên",
               "definition": "Thấp, Bình thường, Ưu tiên cao, Hỏa tốc. Đơn Hỏa tốc hoặc quá hạn giao được tô đỏ trên danh sách (trừ đơn đã Hoàn thành, Đã giao, Đã xuất HĐ, Đã đóng, Đã hủy)."
            },
            {
               "term": "Loại đơn hàng / Phân loại",
               "definition": "Loại đơn hàng: Sản xuất, Đơn mẫu, Bù hàng. Phân loại: Sản xuất hoặc Gia công. Đơn mẫu có thêm Loại mẫu: Nội bộ (miễn phí), Nội bộ (tính phí), Khách hàng."
            },
            {
               "term": "YCSX",
               "definition": "Phiếu Yêu cầu sản xuất in từ đơn bằng [In YCSX], khổ A4 ngang; ghi chú từng dòng in ở cột Ghi chú SX."
            },
            {
               "term": "Lệnh ghép theo bài bình",
               "definition": "Khi [Lập Lệnh SX], các dòng cùng bài bình được gom thành một lệnh in ghép; chỉ lấy số lượng còn lại chưa lên lệnh, bấm lại không tạo trùng."
            }
         ],
         "responsibilities": [
            {
               "role": "Nhân viên Kinh doanh",
               "tasks": [
                  "Lập đơn từ Báo giá đã duyệt hoặc tạo mới; nhập Hạn giao hàng, Mức ưu tiên, người liên hệ, đơn giá",
                  "Bấm [Lưu nháp] khi chưa đủ thông tin, [Lưu] để chuyển Chờ duyệt",
                  "Bổ sung MST và Địa chỉ khách hàng khi hệ thống cảnh báo",
                  "In Đơn đặt hàng và Phiếu yêu cầu sản xuất; theo dõi tiến độ, chốt đơn"
               ]
            },
            {
               "role": "Trưởng phòng Kinh Doanh / Ban Giám Đốc (quyền Duyệt)",
               "tasks": [
                  "Bấm [Duyệt Đơn] trên chi tiết hoặc Phê duyệt (Confirm) hàng loạt trên danh sách",
                  "Hủy đơn qua thanh trạng thái (bắt buộc nhập lý do)",
                  "Sửa đơn đã qua bước Đã duyệt"
               ]
            },
            {
               "role": "Bình file / Kế hoạch",
               "tasks": [
                  "Bình file các dòng chưa có bài bình, xác nhận Đã bình",
                  "Lập Lệnh sản xuất từ đơn đã duyệt ([Lập Lệnh SX] hoặc Lên LSX Ghép Bài)"
               ]
            },
            {
               "role": "Kế toán",
               "tasks": [
                  "Theo dõi tab Thanh toán, Quyết toán & P&L; [Thu Tiền Nhanh], [Quyết Toán & Đóng Đơn]"
               ]
            }
         ],
         "processFlowchart": "graph TD\n    A[Báo giá Đã duyệt - Lập Đơn Hàng] --> C[Tạo Đơn Hàng Mới]\n    B[Kinh doanh - Đơn hàng - Tạo đơn] --> C\n    C -->|Lưu nháp| D[Bản nháp - chỉ người tạo, Admin, Giám đốc thấy]\n    D -->|Lưu| E[Chờ duyệt]\n    C -->|Lưu| E\n    E --> F{Khách đủ MST và Địa chỉ}\n    F -->|Thiếu| G[Bị từ chối - Cập nhật Khách Hàng]\n    G --> F\n    F -->|Đủ| H[Duyệt Đơn - Đã xác nhận]\n    H --> I[Bình file từng dòng]\n    I --> J[Lập Lệnh SX - Đã lên KH]\n    H --> K[Đặt GC toàn phần]\n    J --> L[Tạo PGH]\n    L --> M{Đã giao trong dung sai}\n    M -->|Đạt| N[Chốt hoàn tất - Hoàn thành]\n    M -->|Chưa| L\n    E -->|Hủy kèm lý do| X[Đã hủy]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Mở trang Tạo Đơn Hàng Mới (từ Báo giá hoặc tạo trực tiếp)",
               "detail": "• Từ Báo giá Đã duyệt: trên chi tiết báo giá bấm [Lập Đơn Hàng], chọn dòng rồi [Tiếp tục & Lập Đơn]; hoặc trên danh sách Báo giá chọn đúng 1 báo giá Đã duyệt, bấm [Tạo Đơn Hàng]. Trang điền sẵn khách, người liên hệ, điện thoại, email, địa chỉ giao, VAT, phí vận chuyển, tiền tệ, tỷ giá, điều khoản thanh toán, đặt cọc, phương thức giao, NV phụ trách, ghi chú Từ báo giá + mã BG và các dòng (số lượng, Giá chốt, giá vốn). Ngày đặt là hôm nay, Hạn giao mặc định +7 ngày.\n• Tạo trực tiếp: vào Kinh doanh › Đơn hàng, bấm [Tạo đơn] (cần quyền Thêm)."
            },
            {
               "step": 2,
               "action": "Nhập thông tin chung và dòng sản phẩm",
               "detail": "• Chọn Khách hàng (dòng Thêm khách hàng mới trong ô chọn để thêm nhanh; nút [Sửa thông tin KH] để sửa hồ sơ khách đang chọn), Hạn giao hàng (bắt buộc, không nhỏ hơn ngày đặt), Mức ưu tiên, Phân loại, Loại đơn hàng, NV phụ trách, Tiền tệ / Tỷ giá.\n• Người liên hệ, Số điện thoại, Email được lưu trên đơn. [Lưu thông tin liên hệ] ghi thêm các ô này và địa chỉ giao vào hồ sơ khách (địa chỉ ghi vào ô Địa chỉ của khách — chỉ bấm khi đúng).\n• Dòng sản phẩm: Sản phẩm / Quy cách, Số PO, Số SO (tối đa 50 ký tự, không chứa dấu phẩy), SL đặt, % Bù, Đơn giá, Thành tiền, Hạn giao, Ghi chú. Đơn giá do anh/chị nhập theo giá đã chốt với khách. [Nhân bản] tạo mã sản phẩm mới từ sản phẩm đang chọn.\n• Nhập nhiều dòng: [Tải mẫu Excel], điền rồi [Import Excel]; hệ thống hiện bảng kiểm tra trước khi đưa vào đơn."
            },
            {
               "step": 3,
               "action": "Bấm [Lưu nháp] hoặc [Lưu]",
               "detail": "• [Lưu nháp]: chỉ cần Khách hàng (thiếu thì báo Chọn khách hàng trước khi lưu nháp). Đơn ở Bản nháp, riêng tư.\n• [Lưu]: kiểm tra đủ ô bắt buộc (ô sai tô đỏ, tự cuộn tới), đơn sang Chờ duyệt, mọi người có quyền xem đều thấy.\n• [Lưu nháp] chỉ hiện khi tạo mới hoặc sửa đơn đang Bản nháp; đơn đã qua Bản nháp chỉ còn [Cập nhật]. [Huỷ] để thoát, có thay đổi chưa lưu thì hệ thống hỏi trước khi rời trang."
            },
            {
               "step": 4,
               "action": "Duyệt đơn hàng",
               "detail": "• Mở chi tiết đơn Bản nháp hoặc Chờ duyệt, bấm [Duyệt Đơn] › [Xác nhận duyệt]. Đơn sang Đã xác nhận, các dòng sang Chờ bình file.\n• [Duyệt Đơn] chỉ bấm được với người có quyền Duyệt; người khác thấy nút mờ kèm chú thích Chỉ Giám Đốc hoặc Trưởng phòng Kinh Doanh mới có quyền duyệt Đơn hàng này.\n• Khách thiếu MST hoặc Địa chỉ: nút đổi thành [Duyệt Đơn (Thiếu MST/Đ/c)], khung vàng Chưa đủ điều kiện duyệt đơn hiện ở đầu trang kèm [Cập nhật Khách Hàng]; bấm duyệt bị từ chối với thông báo nêu trường còn thiếu.\n• Duyệt nhiều đơn: trên danh sách tích chọn các đơn Bản nháp/Chờ duyệt, bấm Phê duyệt (Confirm) trên thanh tác vụ; đơn không đạt điều kiện bị bỏ qua kèm lý do."
            },
            {
               "step": 5,
               "action": "Thanh trạng thái",
               "detail": "• Các bước: Bản nháp → Chờ duyệt → Đã duyệt → Đã xác nhận → Đã lên KH → Đang SX → Hoàn thành → Đã giao → Đã xuất HĐ → Đã đóng. Đơn đã có lệnh sản xuất hiện ở bước Đã lên KH.\n• Chỉ bước kế tiếp hoặc bước trước mà hệ thống cho phép mới bấm được (ví dụ đơn Chờ duyệt không quay về Bản nháp); mỗi lần chuyển có hộp Chuyển trạng thái. Khi hệ thống từ chối (thiếu MST, lệnh đang chạy...), thông báo đỏ nêu rõ lý do.\n• Nút Hủy hiện tới bước Đã xác nhận: bấm Hủy, nhập lý do trong hộp Lý do hủy đơn hàng, bấm [Xác nhận Hủy]; lý do được ghi vào Thảo luận của đơn. Đơn có lệnh sản xuất đã chạy không hủy được, hệ thống nêu mã lệnh cần dừng trước."
            },
            {
               "step": 6,
               "action": "Bàn giao sản xuất: Bình file, Lập Lệnh SX, Đặt GC, Tạo PGH",
               "detail": "• [Bình file] (khi còn dòng chưa có bài bình): mở trang tạo Bài bình với các dòng chưa bình.\n• [Lập Lệnh SX]: hộp Lập Kế Hoạch / Lệnh Sản Xuất, tích chọn sản phẩm rồi [Tạo Lệnh SX 1-Chạm] (tự nạp vật tư, công đoạn; gom dòng cùng bài bình thành lệnh ghép, chỉ lấy số lượng còn lại) hoặc [Mở Form Chi Tiết]. Đơn Bản nháp bị từ chối: Đơn ... đang nháp / đã huỷ / đã hoàn tất — không lập lệnh sản xuất. Dòng đang Yêu cầu bình lại cũng bị chặn.\n• Tab Sản phẩm: tích chọn dòng để dùng Trạng Thái Bình File (n), Bình File Ghép Bài (n), Giao Hàng Mục Đã Chọn (n), Yêu Cầu Bình Lại (n); chế độ xem theo bài bình có nút Lên LSX Ghép Bài cho từng bài.\n• [Đặt GC]: mở Tạo Đơn gia công gắn sẵn đơn hàng (gia công toàn phần). Gia công một phần đặt từ Lệnh SX (Chương 13).\n• [Tạo PGH] (đơn Đã duyệt, Đã xác nhận, Đang SX, Hoàn thành, Đã giao): mở Tạo Phiếu giao hàng gắn sẵn đơn và khách (Chương 14)."
            },
            {
               "step": 7,
               "action": "Theo dõi và chốt hoàn tất đơn",
               "detail": "• Chi tiết đơn: khối thông tin chung (Khách hàng, NV Sale, Từ báo giá là liên kết; PO khách; Tỷ giá; Thanh toán; phí vận chuyển), các tab Sản phẩm, Giao hàng, Chế bản, Lệnh SX, Thanh toán, Quyết toán & P&L; bên dưới Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật; cuối trang Tạo lúc / Cập nhật lúc kèm người thao tác.\n• Huy hiệu SẴN SÀNG XUẤT GIAO hiện khi đơn đã sản xuất đủ.\n• Nút chốt (quyền Sửa, đơn Đã xác nhận, Đã duyệt, Đã lên KH, Đang SX hoặc Đã giao): giao đủ trong dung sai thì hiện [Chốt hoàn tất (Dung sai ±x%)], chưa đạt thì [Chốt đơn]. Xác nhận xong đơn sang Hoàn thành.\n• Tab Quyết toán & P&L: [Thu Tiền Nhanh] / [Lập Phiếu Thu] (Tiền mặt, Chuyển khoản, Cấn trừ công nợ; không thu vượt số còn phải thu) và [Quyết Toán & Đóng Đơn] › [Xác Nhận Đóng Đơn Hàng]."
            }
         ],
         "subFlows": [
            {
               "name": "Danh sách, lọc và tìm kiếm",
               "steps": [
                  "Hàng trên: tab Danh sách / Thùng rác và nút [Xuất Excel], [Tạo đơn]. Hàng dưới: nút nhóm theo ngày, bộ lọc thời gian, nút Lọc, Trạng thái ĐH (Chờ Duyệt, Chờ Bình File, Đang Sản Xuất, Chờ Xuất Giao, Hoàn Thành) và tag hạn giao Gấp, Sắp trễ, Đã trễ, Đúng hạn.",
                  "Tìm đơn bằng ô Tìm kiếm trên thanh đầu trang (không có ô tìm trong trang).",
                  "Mỗi dòng: ngày · sale dưới mã đơn, liên hệ · SĐT dưới khách, mã sản phẩm nổi bật kèm số lượng; cột Hạn giao có Trễ / Hôm nay / Còn n ngày và nhãn Nguy cơ trễ. Tiêu đề cột đứng yên khi cuộn.",
                  "Bấm dòng để mở chi tiết; mũi tên ở cột mã xổ các dòng sản phẩm; nút chuyển chế độ xem Bảng / Kanban."
               ]
            },
            {
               "name": "Thêm mới đơn hàng",
               "steps": [
                  "Vào Kinh doanh › Đơn hàng, bấm [Tạo đơn].",
                  "Nhập thông tin chung, dòng sản phẩm (hoặc [Import Excel]).",
                  "Bấm [Lưu nháp] hoặc [Lưu]; hệ thống mở trang chi tiết đơn vừa tạo."
               ]
            },
            {
               "name": "Sửa đơn hàng",
               "steps": [
                  "Trên chi tiết bấm [Sửa]; tiêu đề trang Sửa + mã đơn, cạnh đó là trạng thái. Nút [Sửa] mờ kèm chú thích khi anh/chị không có quyền sửa ở trạng thái hiện tại.",
                  "Người có quyền Sửa sửa được đơn Bản nháp, Chờ duyệt, Chờ bình bài, Đã xác nhận, Đã duyệt; các trạng thái sau cần thêm quyền Duyệt.",
                  "Bấm [Lưu] (đơn nháp) hoặc [Cập nhật]. Đổi trạng thái sang Đã xác nhận/Đã duyệt trong lúc sửa cần quyền Duyệt.",
                  "Xoá một dòng sản phẩm: làm trong màn hình Sửa (mục Xóa sản phẩm trong menu dòng chỉ nhắc điều này)."
               ]
            },
            {
               "name": "Xoá đơn hàng",
               "steps": [
                  "Trên chi tiết bấm [Xoá] và xác nhận; hoặc tích chọn nhiều đơn trên danh sách, bấm Xoá trên thanh tác vụ.",
                  "Hệ thống chặn nếu đơn còn Lệnh SX đang hoạt động hoặc phiếu giao chưa hủy, nêu rõ mã lệnh/phiếu cần xử lý trước.",
                  "Đơn bị xoá vào tab Thùng rác, phục hồi được đúng mã cũ (cần quyền Xoá)."
               ]
            },
            {
               "name": "Trạng thái từng dòng sản phẩm",
               "steps": [
                  "Bấm nhãn trạng thái của dòng (Đổi trạng thái chi tiết) để chọn Chờ bình file, Yêu cầu bình lại hoặc Hủy dòng này.",
                  "Tích chọn nhiều dòng › Trạng Thái Bình File (n): Chuyển sang \"Chờ bình file\" hoặc Xác nhận \"Chờ tạo lệnh\" (Đã bình). Xác nhận Đã bình bị chặn nếu dòng chưa có bài bình (có nút Bình file ngay).",
                  "Menu thao tác của dòng: Xem sản phẩm, Chuyển đang SX, Ép hoàn thành, Xác nhận: Đã bình file, Sửa chi tiết ĐH, Xóa sản phẩm."
               ]
            },
            {
               "name": "In Đơn đặt hàng và Phiếu yêu cầu sản xuất",
               "steps": [
                  "[In ĐH] (có ở mọi trạng thái): mẫu ĐƠN ĐẶT HÀNG, gồm Cộng tiền hàng và Chi phí vận chuyển.",
                  "[In YCSX]: PHIẾU YÊU CẦU SẢN XUẤT (A4 ngang), ghi chú dòng in ở cột Ghi chú SX.",
                  "Trong cửa sổ xem trước: bật/tắt Hình ảnh, [Tải PDF] hoặc In."
               ]
            },
            {
               "name": "Xuất Excel",
               "steps": [
                  "Đặt bộ lọc, bấm [Xuất Excel]: mỗi dòng sản phẩm một hàng (Mã ĐH, Khách hàng, NV Kinh doanh, Ngày đặt, Hạn giao ĐH, Trạng thái, Thanh toán, Loại đơn, Phân loại, Tổng tiền ĐH, Mã SP, Tên SP, Quy cách, ĐVT, PO, SO, PO Khách, SL Đặt, SL Đã SX, SL Đã giao, SL Thiếu, Đơn giá, Thành tiền, Hạn giao SP, Ghi chú)."
               ]
            },
            {
               "name": "Đọc cột Chi tiết của dòng đơn hàng",
               "steps": [
                  "Cột Chi tiết ở màn xem đơn hàng và bản in ghi chất liệu trước rồi các công đoạn theo sản phẩm hiện tại.",
                  "Các dòng có chi tiết khác nhau luôn tách ô; chỉ dòng có chi tiết giống hệt mới gộp."
               ]
            },
            {
               "name": "Đặt cọc và Thời gian giao hàng",
               "steps": [
                  "Chọn từ danh sách có sẵn như ở Báo giá (Không, 30%, 50%, 100%, Theo hợp đồng; 1-3, 3-5, 7-10 ngày). Quản trị viên sửa danh sách trong Cấu hình."
               ]
            },
            {
               "name": "Đơn hàng › tab Sản phẩm — lập lệnh gộp và bình lại theo bài bình",
               "steps": [
                  "Tick chọn các dòng sản phẩm, thanh thao tác hiện thêm nút [Tạo LSX Gộp].",
                  "[Tạo LSX Gộp]: mở màn tạo lệnh sản xuất cho tất cả dòng đã chọn của đơn.",
                  "[Tạo LSX Gộp] bị chặn nếu có dòng đang \"Yêu cầu bình lại\" (chế bản phải xử lý xong) hoặc có dòng chưa hoàn tất bình file.",
                  "Bấm [Gom theo Bài bình] để xem các dòng sản phẩm nhóm theo bài bình.",
                  "[Mở Studio Bình Lại]: trên một nhóm bài bình, mở màn bình file với toàn bộ dòng của nhóm để sửa hoặc ghép lại bài bình.",
                  "[Ghép tất cả vào Bài bình mới]: ở khung \"Sản phẩm chưa gán bài bình\", mở màn bình file với tất cả dòng chưa có bài bình để ghép chung vào một bài bình mới."
               ]
            },
            {
               "name": "Đơn hàng — Duyệt bài bình ở tab Chế bản",
               "steps": [
                  "Mở chi tiết đơn hàng › tab Chế bản: bảng các dòng sản phẩm với cột Mã SP, Tên SP, Số lượng (pcs), Khổ giấy / Khổ in, Số bát (Ups), Số tờ in, Mã bài bình (*), Ghi chú kỹ thuật, Trạng thái.",
                  "Nhập Khổ giấy (VD 65x86), Số bát (Ups, VD 4) và Mã bài bình cho từng dòng; Số tờ in tự tính bằng số lượng chia số bát, làm tròn lên.",
                  "Bấm [Duyệt bài bình]: các dòng được đưa vào Bể chờ lập lệnh sản xuất, báo Đã duyệt bài bình thành công.",
                  "Bị chặn và báo theo từng sản phẩm khi thiếu Mã bài bình, thiếu Khổ giấy, hoặc Số bát (ups) nhỏ hơn 1.",
                  "Bình bài nhiều sản phẩm, ghép bài, tách bài vẫn làm ở Bình file Prepress (Chương 07)."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "(Mới)",
               "to": "Bản nháp",
               "action": "Bấm [Lưu nháp]",
               "allowedRoles": "Người có quyền Thêm đơn hàng"
            },
            {
               "from": "(Mới) / Bản nháp",
               "to": "Chờ duyệt",
               "action": "Bấm [Lưu]",
               "allowedRoles": "Người có quyền Thêm / Sửa đơn hàng"
            },
            {
               "from": "Bản nháp / Chờ duyệt",
               "to": "Đã xác nhận",
               "action": "[Duyệt Đơn] hoặc Phê duyệt (Confirm) hàng loạt; khách phải có MST và Địa chỉ",
               "allowedRoles": "Người có quyền Duyệt đơn hàng"
            },
            {
               "from": "Chờ duyệt",
               "to": "Đã duyệt",
               "action": "Bước Đã duyệt trên thanh trạng thái; khách phải có MST và Địa chỉ",
               "allowedRoles": "Người có quyền Sửa hoặc Duyệt đơn hàng"
            },
            {
               "from": "Chờ duyệt",
               "to": "Bản nháp (không cho phép)",
               "action": "Bước bị mờ; đơn đã gửi duyệt không kéo về nháp",
               "allowedRoles": "—"
            },
            {
               "from": "Đã duyệt / Đã xác nhận",
               "to": "Đã lên KH / Đang SX / Hoàn thành / Đã giao",
               "action": "Tự động theo lệnh sản xuất, hoặc bấm bước trên thanh trạng thái",
               "allowedRoles": "Người có quyền Sửa đơn hàng"
            },
            {
               "from": "Đã xác nhận / Đã duyệt / Đã lên KH / Đang SX / Đã giao",
               "to": "Hoàn thành",
               "action": "[Chốt hoàn tất (Dung sai ±x%)] hoặc [Chốt đơn]; hoặc [Quyết Toán & Đóng Đơn]",
               "allowedRoles": "Người có quyền Sửa đơn hàng"
            },
            {
               "from": "Hoàn thành",
               "to": "Đã giao / Đã đóng",
               "action": "Bấm bước trên thanh trạng thái",
               "allowedRoles": "Người có quyền Sửa đơn hàng"
            },
            {
               "from": "Đã giao",
               "to": "Đã xuất HĐ / Đã đóng",
               "action": "Bấm bước trên thanh trạng thái",
               "allowedRoles": "Người có quyền Sửa đơn hàng"
            },
            {
               "from": "Bản nháp tới Đang SX (chưa lệnh sản xuất nào bắt đầu chạy)",
               "to": "Đã hủy",
               "action": "Nút Hủy, nhập lý do, [Xác nhận Hủy]; bị từ chối nếu lệnh sản xuất của đơn đã chạy",
               "allowedRoles": "Người có quyền Sửa đơn hàng"
            },
            {
               "from": "Đã hủy",
               "to": "Bản nháp / Chờ duyệt",
               "action": "Bấm bước trên thanh trạng thái",
               "allowedRoles": "Người có quyền Sửa đơn hàng"
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Thấy cả bản nháp của mọi người; sửa đơn ở mọi trạng thái."
            },
            {
               "role": "Vai trò có quyền Duyệt đơn hàng (SALES_MANAGER... cấu hình Go-Live)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Bấm được [Duyệt Đơn] / Phê duyệt (Confirm); sửa được đơn từ Đã lên KH trở đi. Không thấy bản nháp của người khác."
            },
            {
               "role": "Vai trò chỉ có quyền Thêm / Sửa (không có Duyệt)",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "⚡",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Sửa và thấy nút [Xoá] khi đơn ở Bản nháp, Chờ duyệt, Chờ bình bài, Đã xác nhận, Đã duyệt; chỉ thấy bản nháp của mình; nút [Duyệt Đơn] mờ, không có Phê duyệt hàng loạt."
            },
            {
               "role": "Vai trò không được cấp quyền Đơn hàng",
               "view": "❌",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "❌",
               "statusRules": "Bị chặn với thông báo Không có quyền truy cập."
            }
         ],
         "actionLinks": [
            {
               "from": "Chi tiết Báo giá",
               "to": "Tạo Đơn Hàng Mới",
               "action": "Kế thừa Báo giá đã duyệt sang Đơn hàng",
               "how": "Bấm [Lập Đơn Hàng], chọn dòng, [Tiếp tục & Lập Đơn]; hoặc chọn 1 báo giá Đã duyệt trên danh sách, bấm [Tạo Đơn Hàng]."
            },
            {
               "from": "Chi tiết Đơn hàng - ô Từ báo giá / Khách hàng / NV Sale",
               "to": "Báo giá gốc / Hồ sơ khách / Người dùng",
               "action": "Mở chứng từ cha",
               "how": "Bấm vào liên kết ở khối thông tin chung."
            },
            {
               "from": "Chi tiết Đơn hàng",
               "to": "Tạo Bài bình",
               "action": "Bình file các dòng chưa có bài bình",
               "how": "Bấm [Bình file], hoặc Bình File Ghép Bài (n) sau khi tích chọn dòng."
            },
            {
               "from": "Chi tiết Đơn hàng",
               "to": "Lệnh sản xuất",
               "action": "Lập Lệnh sản xuất từ đơn",
               "how": "Bấm [Lập Lệnh SX] › [Tạo Lệnh SX 1-Chạm] hoặc [Mở Form Chi Tiết]; trên danh sách chọn 1 đơn Đã xác nhận, bấm Tạo Lệnh SX. Lệnh đã lập xem ở tab Lệnh SX."
            },
            {
               "from": "Chi tiết Đơn hàng",
               "to": "Tạo Đơn gia công",
               "action": "Đặt gia công toàn phần",
               "how": "Bấm [Đặt GC] (Chương 13)."
            },
            {
               "from": "Chi tiết Đơn hàng",
               "to": "Tạo Phiếu giao hàng",
               "action": "Giao hàng cho đơn",
               "how": "Bấm [Tạo PGH] hoặc Giao Hàng Mục Đã Chọn (n) (Chương 14)."
            },
            {
               "from": "Chi tiết Đơn hàng (khung Chưa đủ điều kiện duyệt đơn)",
               "to": "Chi tiết Khách hàng",
               "action": "Bổ sung MST / Địa chỉ trước khi duyệt",
               "how": "Bấm [Cập nhật Khách Hàng]."
            }
         ],
         "quickActions": [
            {
               "action": "Phê duyệt (Confirm) hàng loạt",
               "description": "Tích chọn các đơn Bản nháp/Chờ duyệt trên danh sách, bấm trên thanh tác vụ (cần quyền Duyệt); đơn thiếu MST/Địa chỉ bị bỏ qua kèm lý do."
            },
            {
               "action": "Xoá hàng loạt",
               "description": "Tích chọn nhiều đơn, bấm Xoá (cần quyền Xoá); đơn còn Lệnh SX hoạt động hoặc phiếu giao bị bỏ qua."
            },
            {
               "action": "Tạo Lệnh SX từ danh sách",
               "description": "Chọn đúng 1 đơn rồi bấm Tạo Lệnh SX trên thanh tác vụ."
            },
            {
               "action": "Lọc nhanh theo hạn giao",
               "description": "Tag Gấp, Sắp trễ, Đã trễ, Đúng hạn ở hàng bộ lọc."
            }
         ],
         "inlineViews": [
            {
               "name": "Huy hiệu giao hàng theo dung sai",
               "trigger": "Đầu trang chi tiết đơn",
               "description": "Giao: đã giao/đặt (Dung sai ±x%), xanh khi đạt dung sai, vàng khi đã giao một phần."
            },
            {
               "name": "Nhãn Nguy cơ trễ",
               "trigger": "Cột Hạn giao trên danh sách",
               "description": "Đơn còn mở có lệnh sản xuất dự kiến xong sau hạn giao hiện nhãn cam Nguy cơ trễ; Đã trễ / Còn n ngày tính theo ngày Việt Nam."
            },
            {
               "name": "Cảnh báo khách thiếu MST / Địa chỉ",
               "trigger": "Đơn Bản nháp hoặc Chờ duyệt có khách thiếu thông tin",
               "description": "Khung vàng Chưa đủ điều kiện duyệt đơn kèm [Cập nhật Khách Hàng]."
            },
            {
               "name": "Kanban đơn hàng",
               "trigger": "Nút chuyển chế độ xem trên danh sách",
               "description": "Xem đơn theo cột trạng thái."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/05_orders_list_settled.png",
               "caption": "Hình 06.1 — Danh sách Đơn đặt hàng với bộ lọc thời gian ở vị trí ngoài cùng bên trái"
            },
            {
               "src": "/guide-screenshots/08_order_detail_tolerance_and_fsc.png",
               "caption": "Hình 06.2 — Chi tiết Đơn hàng với huy hiệu giao hàng theo dung sai và nút chốt hoàn tất"
            }
         ],
         "forms": [
            {
               "code": "—",
               "name": "ĐƠN ĐẶT HÀNG (in bằng [In ĐH]) — mẫu in chưa ghi mã biểu mẫu ISO"
            },
            {
               "code": "—",
               "name": "PHIẾU YÊU CẦU SẢN XUẤT (in bằng [In YCSX], A4 ngang) — mẫu in chưa ghi mã biểu mẫu ISO"
            }
         ],
         "notes": [
            "Đơn Bản nháp là riêng tư: đồng nghiệp không thấy đơn trong danh sách hoặc ô chọn đơn hàng ở Lệnh SX / Giao hàng cho tới khi anh/chị bấm [Lưu].",
            "Không duyệt được đơn khi khách chưa có Mã số thuế hoặc Địa chỉ — cập nhật hồ sơ khách trước.",
            "Không lập Lệnh SX cho đơn Bản nháp; nên duyệt đơn trước khi bàn giao Kế hoạch.",
            "Không xoá được đơn còn Lệnh SX đang hoạt động hoặc phiếu giao chưa hủy; không hủy được đơn có lệnh đã chạy sản xuất.",
            "[Chốt hoàn tất (Dung sai ±x%)] chỉ thành công khi từng dòng đều đạt tỷ lệ giao tối thiểu; nếu không, hệ thống liệt kê sản phẩm giao thiếu.",
            "Đơn giá trên đơn là giá kinh doanh nhập; tính giá ở Báo giá / Sản phẩm không ghi đè đơn giá của đơn."
         ],
         "uatChecklist": [
            {
               "id": "SALE-06-01",
               "item": "Tạo đơn trực tiếp và Lưu nháp",
               "standard": "Đơn ở Bản nháp, mở trang chi tiết; tài khoản sale khác không thấy đơn trên danh sách",
               "method": "1) Kinh doanh › Đơn hàng › [Tạo đơn]; 2) Chọn khách KH-TEST, Hạn giao +10 ngày; 3) Thêm dòng sản phẩm hộp giấy, SL đặt 5000, Đơn giá 2.500; 4) Bấm [Lưu nháp]; 5) Đăng nhập sale khác, kiểm tra danh sách"
            },
            {
               "id": "SALE-06-02",
               "item": "Lưu thiếu ô bắt buộc bị chặn",
               "standard": "Ô Hạn giao hàng / dòng sản phẩm thiếu được tô đỏ và tự cuộn tới; đơn không lưu",
               "method": "1) [Tạo đơn]; 2) Chọn khách, xoá Hạn giao hàng, không thêm sản phẩm; 3) Bấm [Lưu]"
            },
            {
               "id": "SALE-06-03",
               "item": "Lưu chuyển Chờ duyệt, liên hệ được lưu trên đơn",
               "standard": "Đơn sang Chờ duyệt; Người liên hệ, SĐT, Email hiện đúng trên chi tiết và dưới tên khách ở danh sách; nút trên form đổi thành [Cập nhật]",
               "method": "1) Mở đơn ở SALE-06-01 › [Sửa]; 2) Nhập Người liên hệ Trần Thị B, SĐT 0912345678, Email b@khachmau.vn; 3) Bấm [Lưu]; 4) Kiểm tra chi tiết và danh sách; 5) Bấm [Sửa] lần nữa xem tên nút"
            },
            {
               "id": "SALE-06-04",
               "item": "Lập đơn từ báo giá đã duyệt",
               "standard": "Trang Tạo Đơn Hàng Mới điền sẵn khách, liên hệ, điều khoản và đúng các dòng đã chọn với Giá chốt; ghi chú Từ báo giá + mã; chi tiết đơn có ô Từ báo giá là liên kết",
               "method": "1) Mở báo giá Đã duyệt › [Lập Đơn Hàng]; 2) Bỏ chọn 1 dòng › [Tiếp tục & Lập Đơn]; 3) Đối chiếu số lượng, đơn giá; 4) Bấm [Lưu]; 5) Bấm mã ở ô Từ báo giá"
            },
            {
               "id": "SALE-06-05",
               "item": "Duyệt bị từ chối khi khách thiếu MST",
               "standard": "Khung vàng Chưa đủ điều kiện duyệt đơn; nút [Duyệt Đơn (Thiếu MST/Đ/c)]; bấm duyệt hiện thông báo đỏ nêu Mã số thuế (MST); trạng thái giữ Chờ duyệt",
               "method": "1) Tạo đơn cho khách KH-TEST-NOMST (không có MST), bấm [Lưu]; 2) Trên chi tiết bấm [Duyệt Đơn (Thiếu MST/Đ/c)] › [Xác nhận duyệt]; 3) Thử bấm bước Đã duyệt trên thanh trạng thái; 4) Đọc thông báo"
            },
            {
               "id": "SALE-06-06",
               "item": "Duyệt đơn thành công",
               "standard": "Đơn sang Đã xác nhận, các dòng sang Chờ bình file; tab Lịch sử cập nhật ghi Trạng thái: Chờ duyệt → Đã xác nhận và người duyệt",
               "method": "1) Bấm [Cập nhật Khách Hàng], bổ sung MST, [Cập nhật]; 2) Quay lại đơn, bấm [Duyệt Đơn] › [Xác nhận duyệt]; 3) Mở tab Lịch sử cập nhật"
            },
            {
               "id": "SALE-06-07",
               "item": "Thanh trạng thái chỉ cho bước hợp lệ",
               "standard": "Đơn Chờ duyệt: bước Bản nháp mờ, không bấm được; bước hợp lệ có hộp Chuyển trạng thái; khi bị từ chối luôn có thông báo nêu lý do",
               "method": "1) Mở một đơn Chờ duyệt; 2) Rê chuột lên bước Bản nháp và Đã duyệt; 3) Bấm Đã duyệt với khách đủ MST › [Xác nhận]; 4) Ghi lại thông báo"
            },
            {
               "id": "SALE-06-08",
               "item": "Vai trò không có quyền Duyệt",
               "standard": "Nút [Duyệt Đơn] mờ kèm chú thích Chỉ Giám Đốc hoặc Trưởng phòng Kinh Doanh...; danh sách không có Phê duyệt (Confirm)",
               "method": "1) Đăng nhập vai trò bị tắt quyền Duyệt đơn hàng; 2) Mở đơn Chờ duyệt, rê chuột lên [Duyệt Đơn]; 3) Trên danh sách tích chọn đơn Chờ duyệt, xem thanh tác vụ"
            },
            {
               "id": "SALE-06-09",
               "item": "Hủy đơn bắt buộc nhập lý do",
               "standard": "Hộp Lý do hủy đơn hàng bắt buộc nhập; đơn sang Đã hủy; lý do hiện trong tab Thảo luận & Ghi chú",
               "method": "1) Tạo đơn thử, bấm [Lưu]; 2) Bấm Hủy trên thanh trạng thái; 3) Nhập lý do Khách đổi mẫu; 4) Bấm [Xác nhận Hủy]; 5) Mở tab Thảo luận & Ghi chú"
            },
            {
               "id": "SALE-06-10",
               "item": "Lập Lệnh SX bị từ chối với đơn Bản nháp",
               "standard": "Thông báo Đơn ... đang nháp / đã huỷ / đã hoàn tất — không lập lệnh sản xuất; không có lệnh nào được tạo",
               "method": "1) Mở đơn Bản nháp ở SALE-06-01; 2) Bấm [Lập Lệnh SX]; 3) Tích chọn sản phẩm › [Tạo Lệnh SX 1-Chạm]; 4) Đọc thông báo"
            },
            {
               "id": "SALE-06-11",
               "item": "Bàn giao sang Kế hoạch: Lập Lệnh SX",
               "standard": "Tạo được lệnh, thông báo Đã tạo n Lệnh Sản Xuất; tab Lệnh SX có lệnh mới (bấm mở đúng lệnh); đơn hiện ở bước Đã lên KH; bấm lại không tạo trùng (báo Không còn số lượng để lập lệnh hoặc bỏ qua dòng đã lên lệnh đủ)",
               "method": "1) Mở đơn Đã xác nhận ở SALE-06-06; 2) [Lập Lệnh SX] › chọn hết › [Tạo Lệnh SX 1-Chạm]; 3) Mở tab Lệnh SX, bấm mã lệnh; 4) Quay lại đơn, bấm [Lập Lệnh SX] lần nữa"
            },
            {
               "id": "SALE-06-12",
               "item": "Chặn xoá đơn đã có Lệnh SX",
               "standard": "Thông báo Không thể xóa đơn hàng ... vì đang có 1 Lệnh SX hoạt động kèm mã lệnh",
               "method": "1) Mở đơn ở SALE-06-11; 2) Bấm [Xoá] › xác nhận; 3) Đọc thông báo"
            },
            {
               "id": "SALE-06-13",
               "item": "In Đơn đặt hàng và YCSX",
               "standard": "[In ĐH] hiện đúng khách, dòng hàng, Cộng tiền hàng, Chi phí vận chuyển, tổng; [In YCSX] khổ ngang có cột Ghi chú SX",
               "method": "1) Mở đơn có phí vận chuyển 200.000 và ghi chú dòng; 2) Bấm [In ĐH], [Tải PDF]; 3) Bấm [In YCSX], kiểm tra ghi chú"
            },
            {
               "id": "SALE-06-14",
               "item": "Danh sách: lọc, tìm kiếm, Excel",
               "standard": "Trạng thái ĐH và tag Gấp / Đã trễ lọc đúng; tìm bằng ô Tìm kiếm trên đầu trang; tiêu đề cột đứng yên khi cuộn; file Excel mỗi dòng sản phẩm một hàng",
               "method": "1) Kinh doanh › Đơn hàng; 2) Chọn Trạng thái ĐH › Chờ Duyệt; 3) Bấm tag Đã trễ; 4) Gõ mã đơn vào ô Tìm kiếm trên đầu trang; 5) [Xuất Excel]"
            },
            {
               "id": "SALE-06-15",
               "item": "Màn hình điện thoại 390px",
               "standard": "Danh sách dạng thẻ, không tràn ngang; chi tiết đơn có thanh nút dưới cùng tối đa 4 nút, nút còn lại trong nút …; [Duyệt Đơn] và [In ĐH] dùng được",
               "method": "1) Mở trên điện thoại (hoặc cửa sổ rộng 390px); 2) Kinh doanh › Đơn hàng; 3) Mở một đơn Chờ duyệt; 4) Bấm nút … xem các nút còn lại"
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "SALES (Nhân Viên Kinh Doanh)",
               "createTest": "[Tạo đơn], [Lưu nháp], [Lưu]; lập đơn từ báo giá",
               "readTest": "Xem danh sách; không thấy bản nháp của sale khác",
               "updateTest": "Sửa đơn Chờ duyệt của mình",
               "deleteTest": "Xoá đơn thử chưa có Lệnh SX",
               "expectedResult": "Làm được theo quyền cấu hình; nếu bị tắt quyền Duyệt thì [Duyệt Đơn] mờ"
            },
            {
               "roleGroup": "SALES_MANAGER / DIRECTOR (có quyền Duyệt)",
               "createTest": "Tạo đơn",
               "readTest": "DIRECTOR thấy cả bản nháp của mọi người",
               "updateTest": "[Duyệt Đơn], Phê duyệt (Confirm) hàng loạt, sửa đơn Đang SX",
               "deleteTest": "Xoá, phục hồi trong Thùng rác",
               "expectedResult": "Đơn đủ MST/Địa chỉ sang Đã xác nhận; đơn thiếu bị bỏ qua kèm lý do"
            },
            {
               "roleGroup": "PLANNER (Kế hoạch)",
               "createTest": "[Lập Lệnh SX] từ đơn Đã xác nhận",
               "readTest": "Xem đơn và tab Lệnh SX",
               "updateTest": "—",
               "deleteTest": "—",
               "expectedResult": "Lệnh tạo đúng số lượng còn lại, đơn hiện Đã lên KH"
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 07. Bình File Chế Bản, Ghép Bài, Artwork & Tiêu Chuẩn SP
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "tech_specs",
         "aliases": [
            "prepress",
            "layouts",
            "layout",
            "engineering",
            "specs",
            "designs",
            "technical",
            "print-layouts",
            "production/prepress",
            "prepress-wizard"
         ],
         "title": "07. Bình File Chế Bản, Ghép Bài, Artwork & Tiêu Chuẩn SP",
         "icon": "Image",
         "isoRef": "QT-KT-01",
         "purpose": "Hướng dẫn tổ Bình file (chế bản) nhận các dòng đơn hàng đã duyệt, bình bài đơn, ghép bài, tách bài, xử lý yêu cầu bình lại và chuyển bài bình cho Phòng Kế hoạch lập Lệnh sản xuất. Kèm theo: yêu cầu thiết kế Artwork (/designs) và hồ sơ Tiêu chuẩn sản phẩm / Thông số kỹ thuật (/specs).",
         "scope": [
            "Menu Kế hoạch › Bình file Prepress (/layouts), đứng trước Lệnh sản xuất. Có 5 tab kèm số đếm: Chờ bình, Chờ tạo lệnh, Đã tạo lệnh, Yêu cầu bình lại, Tất cả bài bình. Chi tiết một bài bình mở ở /layouts/<mã bài>.",
            "Các địa chỉ cũ /production/prepress, /production/prepress/create và /production/print-layouts nay tự chuyển về Bình file Prepress. Thư viện bài bình cũ (mã LO-…), nút Thêm sơ đồ mới và Tạo khuôn & kẽm không còn trên màn hình.",
            "Form bình file dùng chung ở 3 nơi: cửa sổ bình file trên trang Bình file Prepress, bước 2. Bình file trong trang Tạo lệnh sản xuất (/production-orders/create) và nút Sửa bài bình khi lập lệnh.",
            "Menu Kỹ thuật › Artwork Thiết kế (/designs) và Tiêu chuẩn SP (/specs).",
            "Người dùng chính: tổ Bình file / chế bản (vai trò Nhân Viên Kỹ Thuật / Chế Bản, Trưởng Phòng Kỹ Thuật). Phòng Kế hoạch (vai trò Kế Hoạch Sản Xuất) nhận bài bình để lập lệnh. Kinh doanh gửi yêu cầu bình lại từ đơn hàng."
         ],
         "references": [
            "ISO 9001:2015 mục 8.3 Thiết kế và phát triển sản phẩm",
            "ISO 9001:2015 mục 8.5.1 Kiểm soát sản xuất",
            "Chương 08 Lệnh sản xuất, Chương 10 Khuôn bế và bản kẽm CTP"
         ],
         "terms": [
            {
               "term": "Bài bình (bình file)",
               "definition": "Sắp các sản phẩm lên tờ in: nhập Mã bài bình, Khổ giấy in, Số Ups (số con trên tờ) của từng sản phẩm và Số lượng tờ in mỗi Ups. Hệ thống tự tính SL SX từng loại = Số Ups × SL tờ in; anh/chị sửa tay được."
            },
            {
               "term": "Bài đơn / Bài ghép / Tách bài",
               "definition": "Bài đơn: một sản phẩm trên tờ in. Bài ghép: nhiều sản phẩm in chung một tờ. Tách bài: một dòng số lượng lớn chia ra nhiều bài in; bộ lọc trên tab Chờ tạo lệnh và Tất cả bài bình có đủ 3 loại này."
            },
            {
               "term": "Điều kiện ghép bài (áp dụng từ 30/10/2026)",
               "definition": "Chỉ ghép được các sản phẩm cùng đơn hàng, cùng chất liệu giấy và cùng kiểu cán màng (mờ / bóng). Sản phẩm khác quy trình vẫn ghép được; khi lập lệnh, Phòng Kế hoạch thiết lập lại quy trình, bù hao, số ups và số lượng."
            },
            {
               "term": "SL Cần Bình",
               "definition": "Số lượng còn phải bình của dòng đơn hàng (SL đặt trừ phần đã bình hoặc đã lên lệnh). Dòng đã bình một phần hiện dòng chữ Đã bình x / y và nút Tách thêm bài."
            },
            {
               "term": "Chờ tạo lệnh / Đã tạo lệnh",
               "definition": "Trạng thái quan trọng nhất của bài bình: Chờ tạo lệnh là bài đã lưu, chưa có Lệnh sản xuất (còn sửa, xóa được). Đã tạo lệnh là bài đã gắn Lệnh sản xuất (chỉ xem, không sửa, không xóa)."
            },
            {
               "term": "Trạng thái bình bài trên trang chi tiết",
               "definition": "Nhãn cạnh mã bài: Chờ ghép bài, Đang bình file, Đang xuất kẽm CTP, Đã đặt khuôn bế, Hoàn thành bình bài. Khi có yêu cầu bình lại, bài chuyển Đang bình file và về Hoàn thành bình bài khi tổ bình file xác nhận xong. Nhãn này không thay cho việc ghi bản kẽm: kẽm chỉ tính đã xuất khi tổ CTP bấm Ghi bản kẽm xong ở lệnh."
            },
            {
               "term": "Yêu cầu bình lại",
               "definition": "Sale (từ đơn hàng) hoặc Kế hoạch (từ lệnh) yêu cầu sửa bài bình, ghi lý do tối thiểu 5 ký tự. Chỉ gửi được khi lệnh chưa bắt đầu in; đã in thì lập NCR / lệnh in bù."
            },
            {
               "term": "TSKT",
               "definition": "Thông số kỹ thuật / Tiêu chuẩn sản phẩm, mã dạng TSKT-YYYY-NNN."
            }
         ],
         "responsibilities": [
            {
               "role": "Tổ Bình file / Chế bản (Nhân Viên Kỹ Thuật / Chế Bản)",
               "tasks": [
                  "Bình file các dòng ở tab Chờ bình: bài đơn, ghép bài, tách bài; tải ảnh sơ đồ bài bình; ghi chú trở nhíp, tay kê, bù hao.",
                  "Sửa hoặc xóa bài bình khi còn Chờ tạo lệnh; bấm Đánh dấu đã bình đủ cho dòng không cần bình thêm.",
                  "Xử lý tab Yêu cầu bình lại: mở form bình hoặc Xử lý nhanh rồi Xác Nhận Hoàn Tất. Dòng có bài bình đã lên lệnh sản xuất (cột Bài bình hiện tại ghi Đã lên LSX-…) chỉ xử lý bằng Xử lý nhanh."
               ]
            },
            {
               "role": "Phòng Kế hoạch (Kế Hoạch Sản Xuất)",
               "tasks": [
                  "Bấm Tạo Lệnh SX trên bài Chờ tạo lệnh; ở form lệnh thiết lập lại quy trình, bù hao, số ups, số lượng (nhất là với bài ghép).",
                  "Giao máy in cho công đoạn in ở tab 4. Kế hoạch sản xuất của lệnh để tổ CTP ghi bản được kẽm đúng khổ (xem Chương 10).",
                  "Gửi Yêu cầu bình lại từ lệnh khi lệnh chưa in."
               ]
            },
            {
               "role": "Kinh doanh",
               "tasks": [
                  "Duyệt đơn hàng: dòng đơn đã duyệt tự vào tab Chờ bình.",
                  "Gửi Yêu cầu bình lại từ chi tiết đơn hàng; tạo yêu cầu thiết kế Artwork."
               ]
            },
            {
               "role": "Kỹ thuật / KCS",
               "tasks": [
                  "Xử lý hồ sơ Artwork, duyệt mẫu; lập và duyệt hồ sơ Tiêu chuẩn SP (TSKT)."
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "Có quyền Sửa ở Bình file, Đơn hàng hoặc Lệnh sản xuất",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Thấy nút Bình File Mới, Bình file, Tách thêm bài, Sửa; bấm một dòng Chờ bình là mở form bình. Khi lưu, máy chủ kiểm quyền Sửa của Lệnh sản xuất: tài khoản thiếu quyền này sẽ bị từ chối lưu."
            },
            {
               "role": "Có quyền Xóa ở Bình file hoặc Lệnh sản xuất",
               "view": "✅",
               "create": "❌",
               "edit": "❌",
               "delete": "✅",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Thấy biểu tượng thùng rác và nút Xóa bài bình (n). Chỉ xóa được bài chưa có Lệnh sản xuất; bài đã có lệnh được giữ lại."
            },
            {
               "role": "Có quyền Thêm ở Lệnh sản xuất",
               "view": "✅",
               "create": "✅",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Bấm Tạo Lệnh SX / Lưu & Tạo Lệnh SX để mở form lập lệnh từ bài bình và lưu lệnh."
            },
            {
               "role": "Chỉ có quyền Xem Bình file",
               "view": "✅",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Xem 5 tab, xuất Excel. Bấm một dòng Chờ bình chỉ mở đơn hàng, không mở form bình."
            },
            {
               "role": "Artwork Thiết kế / Tiêu chuẩn SP",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Menu hiện theo quyền Xem của phân hệ Thông số kỹ thuật. Các thao tác lưu hồ sơ TSKT hiện chỉ yêu cầu đăng nhập."
            }
         ],
         "processFlowchart": "graph TD\n    A[Đơn hàng được duyệt] --> B[Tab Chờ bình]\n    B -->|Bình file / Ghép bài| C{Cùng đơn, cùng giấy, cùng cán màng?}\n    C -->|Không| X[Hệ thống báo lý do, không cho ghép]\n    C -->|Có| D[Lưu Bài Bình]\n    D --> E[Tab Chờ tạo lệnh]\n    B -->|Lưu & Tạo Lệnh SX| G[Form Tạo lệnh sản xuất]\n    E -->|Tạo Lệnh SX| G\n    G -->|Kế hoạch sửa quy trình, bù hao, ups, SL rồi lưu| H[Tab Đã tạo lệnh]\n    E -->|Xóa bài bình| B\n    H -->|Yêu cầu bình lại từ đơn hàng / lệnh, lệnh tạm dừng| R[Tab Yêu cầu bình lại]\n    R -->|Xác Nhận Hoàn Tất| H\n    H --> K[Lệnh: giao máy in rồi Gửi ghi bản kẽm, xem Chương 10]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Mở Bình file Prepress và chọn việc cần làm",
               "detail": "• Menu Kế hoạch › Bình file Prepress. Bộ lọc thời gian ở đầu bên trái, ô tìm kiếm chung trên thanh tiêu đề (tìm mã đơn, khách hàng, sản phẩm).\n• Tab Chờ bình: các dòng đơn hàng đã duyệt chưa bình đủ, cột Mã ĐH, Khách hàng, Sản phẩm & Chất liệu (có ảnh thu nhỏ sản phẩm, mã sản phẩm, số PO / SO), SL Cần Bình, Điền nhanh bài bình, Hạn giao. Nhãn hạn: Hỏa tốc, Đơn gấp, Cận hạn (còn 2 ngày), Quá hạn; lọc nhanh bằng các thẻ Tất cả hạn / Hỏa tốc / Đơn gấp / Cận hạn / Quá hạn.\n• Nút [Lọc] mở hàng lọc theo cột (Lọc mã ĐH..., Lọc khách hàng..., Lọc sản phẩm...)."
            },
            {
               "step": 2,
               "action": "Bình bài đơn",
               "detail": "• Trên dòng cần bình bấm [Bình file] (hoặc bấm vào dòng, hoặc bấm nhanh một trong các ô + Mã bài, + Khổ in, + Ups, + Tờ in để mở form và đặt sẵn con trỏ vào ô đó).\n• Cửa sổ Bình File Sản Xuất: nhập Mã bài bình (bắt buộc, có nút [Gợi ý mã] tạo mã dạng BB-…), Khổ giấy in (bắt buộc, gõ tự do hoặc bấm thẻ chọn nhanh), Số lượng tờ in mỗi Ups (bắt buộc, tự gợi ý theo Ups, sửa tự do; bấm [Tự tính] để tính lại), Ảnh bài bình (Sơ đồ bình file), Ghi chú bài bình. Mục Khuôn bế & Máy in dự kiến (Tùy chọn) có ô chọn Máy in và Khuôn bế.\n• Bảng sản phẩm bên phải: SL Cần Bình, Số Ups (nút − / +), SL SX từng loại (tự tính, sửa tay được, có nút khôi phục).\n• Bấm [Lưu Bài Bình]: báo Đã lưu bài bình <mã>, dòng chuyển sang tab Chờ tạo lệnh. Thiếu thông tin hệ thống báo: Vui lòng nhập Mã bài bình. / Vui lòng nhập hoặc chọn Khổ giấy in. / Vui lòng chọn ít nhất 1 chi tiết đơn hàng vào bài bình."
            },
            {
               "step": 3,
               "action": "Ghép bài (nhiều sản phẩm một tờ in)",
               "detail": "• Tích chọn nhiều dòng ở tab Chờ bình → thanh thao tác hiện [Bình File / Ghép Bài (n)]; hoặc trong form bình gõ vào ô tìm để thêm sản phẩm khác của cùng đơn hàng.\n• Điều kiện: cùng đơn hàng, cùng chất liệu giấy, cùng kiểu cán màng. Sai điều kiện hệ thống báo rõ lý do và không cho ghép: Khác đơn hàng (…). Chỉ sản phẩm cùng đơn hàng mới được ghép chung 1 bài in. / Khác chất liệu giấy (…). Bình file ghép bài bắt buộc cùng chất liệu. / Khác kiểu cán màng (…). Cán màng phủ cả tờ in chung nên phải cùng kiểu.\n• Khi ghép hợp lệ, form hiện dải Khóa điều kiện ghép: ĐH …, Giấy …. Sản phẩm khác quy trình vẫn ghép được, form nhắc: quy trình của lệnh lấy hợp các công đoạn; chỉnh lại công đoạn, bù hao ở tab Kế hoạch sản xuất khi lập lệnh."
            },
            {
               "step": 4,
               "action": "Tách bài cho dòng số lượng lớn",
               "detail": "• Ở form bình, giảm SL SX của sản phẩm xuống phần muốn in trong bài này rồi lưu.\n• Dòng vẫn ở tab Chờ bình với chữ Đã bình x / y và nút [Tách thêm bài] để bình phần còn lại; SL Cần Bình tự trừ lùi.\n• Dòng không cần bình thêm: tích chọn → [Đánh dấu đã bình đủ] (báo Đã đánh dấu hoàn tất bình file)."
            },
            {
               "step": 5,
               "action": "Chuyển bài bình cho Kế hoạch lập Lệnh sản xuất",
               "detail": "• Tab Chờ tạo lệnh: mỗi bài hiện ảnh sơ đồ, đơn hàng & khách hàng, sản phẩm trong bài (bấm mũi tên để mở rộng từng sản phẩm, hoặc [Mở rộng tất cả]), Khổ giấy in, Số Ups, SL Tờ In, Tổng SL SX. Lọc loại bài: Tất cả loại bài / Bài đơn / Bài ghép / Tách bài.\n• Bấm [Tạo Lệnh SX] trên dòng (hoặc tích 1 bài → [Tạo Lệnh SX]) để mở trang Tạo lệnh sản xuất đã nạp sẵn khổ in, số con, số tờ, vật tư, khuôn kẽm, công đoạn. Trong form bình có sẵn nút [Lưu & Tạo Lệnh SX] để lưu bài và sang thẳng form lệnh.\n• Lưu lệnh xong, các dòng sang tab Đã tạo lệnh, cột Lệnh Sản Xuất là link mở lệnh.\n• Nút [Tạo Lệnh SX Hàng Loạt (n)] khi chọn nhiều bài hiện đã ngừng dùng: hệ thống báo phải mở từng bài và lập lệnh qua form."
            },
            {
               "step": 6,
               "action": "Xem chi tiết bài bình (/layouts/<mã>)",
               "detail": "• Bấm vào một bài ở tab Chờ tạo lệnh / Tất cả bài bình, hoặc nút [Chi tiết] với bài đã có lệnh.\n• Thông tin chung bài bình: Mã bài bình, Khổ giấy in, Tổng Số Ups, SL tờ in mỗi Ups, Đơn hàng, Khách hàng, Người bình file, Lệnh sản xuất (là link mở bản ghi), Máy in dự kiến, Khuôn bế, Ngày bình file, Ghi chú bài bình; ảnh sơ đồ bấm để phóng to; bảng sản phẩm trong bài.\n• Nút: [In] (Sơ đồ bài bình in), [Sửa], [Tạo Lệnh SX], [Xóa] (ba nút sau chỉ hiện khi bài chưa có lệnh).\n• Khung bên phải có 3 tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật."
            }
         ],
         "subFlows": [
            {
               "name": "Sửa / Xóa bài bình",
               "steps": [
                  "Tab Chờ tạo lệnh hoặc Tất cả bài bình → [Sửa] mở lại form, sửa xong bấm [Cập nhật Bài Bình].",
                  "Biểu tượng thùng rác → hộp Xóa bài bình <mã>? → [Xóa bài bình]: số lượng của các dòng hoàn lại tab Chờ bình. Xóa nhiều: tích chọn → [Xóa bài bình (n)] → [Xác nhận xóa]; bài đã có lệnh được bỏ qua (báo Đã xóa x bài bình, bỏ qua y bài đã tạo Lệnh SX).",
                  "Bài đã có Lệnh sản xuất không sửa, không xóa được. Nếu lưu trùng mã của bài đã có lệnh, hệ thống báo: Bài bình … đã có Lệnh sản xuất … — không sửa được bài đã lên lệnh. Hãy dùng \"Yêu cầu bình lại\" ở Đơn hàng / Lệnh sản xuất (chỉ khi lệnh chưa in)."
               ]
            },
            {
               "name": "Yêu cầu bình lại",
               "steps": [
                  "Gửi yêu cầu: chi tiết đơn hàng → chọn dòng → [Yêu Cầu Bình Lại (n)]; hoặc chi tiết Lệnh sản xuất → [Bình lại]; nhập lý do (tối thiểu 5 ký tự) → [Gửi Yêu Cầu Bình Lại]. Lệnh liên quan tạm dừng tới khi chế bản xác nhận xong.",
                  "Bị chặn khi lệnh đã bắt đầu in: Không thể bình lại: Lệnh sản xuất … đã bắt đầu in (…). Hãy lập phiếu NCR / lệnh in bù thay vì bình lại.",
                  "Tổ bình file: tab Yêu cầu bình lại hiện lý do. Bấm [Mở Form Bình] để bình lại đầy đủ (chỉ với bài chưa lên lệnh sản xuất; bài đã lên lệnh hiện Đã lên LSX-… dưới mã bài bình, nút [Mở Form Bình] mờ vì bài đã lên lệnh không sửa bằng form), hoặc [Xử lý nhanh] → hộp Xử lý yêu cầu bình lại (Mã bài bình mới, Khổ giấy in, Số Ups, SL tờ in mỗi Ups, Ghi chú xử lý) → [Xác Nhận Hoàn Tất]. Lệnh trở lại trạng thái trước khi tạm dừng."
               ]
            },
            {
               "name": "Bình file ngay khi tạo lệnh",
               "steps": [
                  "Kế hoạch › Lệnh sản xuất → tạo lệnh mới: 3 bước Chọn mặt hàng → Bình file → Lệnh sản xuất.",
                  "Dòng chưa có khổ in / số con có nút Bình file; chọn nhiều dòng để Bình file ghép (cùng điều kiện ghép như trên).",
                  "Bấm [Lưu & lập lệnh] để sang form lệnh; [Sửa bài bình] để quay lại chỉnh bài."
               ]
            },
            {
               "name": "Xuất Excel",
               "steps": [
                  "Nút xuất Excel trên đầu trang xuất danh sách của tab đang mở: tab Chờ bình xuất theo dòng đơn hàng (SL Đặt, SL Còn Chờ Bình…), tab bài bình xuất theo bài (Phân Loại, Khổ Giấy In, Tổng Số Ups, Người Bình File, Lệnh Sản Xuất…)."
               ]
            },
            {
               "name": "Artwork Thiết kế: Thêm / Sửa / Xóa (/designs)",
               "steps": [
                  "Menu Kỹ thuật › Artwork Thiết kế → [Tạo Yêu Cầu].",
                  "Nhập Sản phẩm (bắt buộc), Phân loại thiết kế (Thiết kế mới / Chỉnh sửa file cũ), Số lượng mẫu in thử, Kỹ thuật viên phụ trách (chỉ nhân sự tổ Thiết kế / Bình file / CTP, cạnh tên ghi tổ; để trống = chưa phân công), Trạng thái hồ sơ, Đường dẫn tệp Artwork, Yêu cầu chi tiết → [Tạo yêu cầu].",
                  "Menu dòng → sửa → [Lưu thay đổi]; [Xóa] → xác nhận.",
                  "Chi tiết hồ sơ: [Đổi trạng thái] Chờ xử lý / Đang thiết kế / Chờ duyệt KCS / Phê duyệt (Đạt) / Từ chối / Yêu cầu sửa; [Sửa]; [In Phiếu]. Sản phẩm, người phụ trách là link mở bản ghi."
               ]
            },
            {
               "name": "Tiêu chuẩn SP / TSKT (/specs)",
               "steps": [
                  "Menu Kỹ thuật › Tiêu chuẩn SP → [Lập TSKT mới].",
                  "Chọn Sản phẩm rồi bấm [Lấy data từ Product] để nạp quy trình; điền các mục thông số, vật tư, công cụ sản xuất & bình file, tiêu chuẩn chất lượng, ghi chú KCS → [Tạo mới]. Mã tự sinh TSKT-YYYY-NNN.",
                  "Sửa: chi tiết → [Sửa] → [Lưu cập nhật].",
                  "Chi tiết TSKT: trạng thái ở thanh tiêu đề; thanh tiến trình Bản nháp → Chờ duyệt → Đã duyệt → Lưu trữ / Lỗi thời. Bài bình, khuôn bế, khuôn ép nhũ là link mở bản ghi.",
                  "[Xuất Excel] xuất danh sách."
               ]
            },
            {
               "name": "Phân biệt sản phẩm trùng tên trên Bình file",
               "steps": [
                  "Danh sách bài bình (cột Sản phẩm trong bài), phần mở rộng của bài và bảng Chi tiết sản phẩm trong trang bài bình đều ghi mã sản phẩm dưới tên.",
                  "Hai sản phẩm cùng tên khác mã (VD …-00001 và …-00002) được phân biệt theo mã; tab Chờ bình ghi thêm PO / SO."
               ]
            },
            {
               "name": "Chi tiết bài bình — In sơ đồ",
               "steps": [
                  "[In] trên đầu trang chi tiết bài bình: mở bản xem trước \"In Sơ đồ Bài bình\" của mã bài bình đang xem, bấm [In Ngay] để in hoặc [Tải PDF] để lưu."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "Dòng đơn Chờ bình",
               "to": "Bài bình Chờ tạo lệnh",
               "action": "[Lưu Bài Bình] / [Lưu & Tạo Lệnh SX]",
               "allowedRoles": "Tổ Bình file (cần quyền Sửa Lệnh sản xuất)"
            },
            {
               "from": "Dòng đơn Chờ bình (bình một phần)",
               "to": "Vẫn Chờ bình, hiện Đã bình x / y",
               "action": "Lưu bài với SL SX nhỏ hơn SL Cần Bình, rồi [Tách thêm bài]",
               "allowedRoles": "Tổ Bình file"
            },
            {
               "from": "Dòng đơn Chờ bình",
               "to": "Rời tab Chờ bình",
               "action": "[Đánh dấu đã bình đủ]",
               "allowedRoles": "Tổ Bình file"
            },
            {
               "from": "Bài bình Chờ tạo lệnh",
               "to": "Đã tạo lệnh",
               "action": "[Tạo Lệnh SX] → lưu lệnh ở form lệnh",
               "allowedRoles": "Phòng Kế hoạch (quyền Thêm Lệnh sản xuất)"
            },
            {
               "from": "Bài bình Chờ tạo lệnh",
               "to": "Đã xóa, dòng đơn về Chờ bình",
               "action": "Thùng rác → [Xóa bài bình]",
               "allowedRoles": "Người có quyền Xóa Bình file / Lệnh sản xuất"
            },
            {
               "from": "Đã tạo lệnh (lệnh chưa in)",
               "to": "Yêu cầu bình lại (lệnh tạm dừng)",
               "action": "[Yêu Cầu Bình Lại (n)] ở đơn hàng hoặc [Bình lại] ở lệnh → [Gửi Yêu Cầu Bình Lại]",
               "allowedRoles": "Kinh doanh / Kế hoạch"
            },
            {
               "from": "Yêu cầu bình lại",
               "to": "Đã tạo lệnh (lệnh về trạng thái trước)",
               "action": "[Xử lý nhanh] → [Xác Nhận Hoàn Tất], hoặc [Mở Form Bình] khi bài bình chưa lên lệnh sản xuất",
               "allowedRoles": "Tổ Bình file"
            },
            {
               "from": "Hồ sơ thiết kế Chờ xử lý",
               "to": "Đang thiết kế / Chờ duyệt KCS / Phê duyệt (Đạt) / Từ chối / Yêu cầu sửa",
               "action": "[Đổi trạng thái]",
               "allowedRoles": "Kỹ thuật / KCS"
            },
            {
               "from": "TSKT Bản nháp",
               "to": "Chờ duyệt → Đã duyệt → Lưu trữ / Lỗi thời",
               "action": "Bấm bước trên thanh tiến trình",
               "allowedRoles": "Kỹ thuật"
            }
         ],
         "actionLinks": [
            {
               "from": "Đơn hàng (đã duyệt)",
               "to": "Bình file Prepress",
               "action": "Dòng đơn vào tab Chờ bình",
               "how": "Tự động sau khi đơn được duyệt"
            },
            {
               "from": "Bình file Prepress",
               "to": "Lệnh sản xuất",
               "action": "Lập lệnh từ bài bình",
               "how": "[Tạo Lệnh SX] trên bài Chờ tạo lệnh, [Lưu & Tạo Lệnh SX] trong form bình, hoặc [Tạo Lệnh SX] ở chi tiết bài bình"
            },
            {
               "from": "Đơn hàng / Lệnh sản xuất",
               "to": "Bình file Prepress",
               "action": "Yêu cầu bình lại",
               "how": "[Yêu Cầu Bình Lại (n)] ở đơn hàng, [Bình lại] ở lệnh"
            },
            {
               "from": "Chi tiết bài bình",
               "to": "Đơn hàng / Khách hàng / Lệnh sản xuất",
               "action": "Mở bản ghi cha",
               "how": "Bấm vào mã đơn, tên khách hàng, mã lệnh (link)"
            },
            {
               "from": "Lệnh sản xuất",
               "to": "Kẽm CTP",
               "action": "Ghi bản kẽm theo khổ máy in",
               "how": "Tab 3. Kế hoạch khuôn kẽm của lệnh → [Gửi ghi bản kẽm] / [Ghi bản kẽm xong] (Chương 10)"
            }
         ],
         "quickActions": [
            {
               "action": "Bình File Mới",
               "description": "Mở form bình trống, tìm và thêm dòng đơn hàng chờ bình."
            },
            {
               "action": "Bình File / Ghép Bài (n)",
               "description": "Tích chọn nhiều dòng Chờ bình để ghép chung một bài in."
            },
            {
               "action": "+ Mã bài / + Khổ in / + Ups / + Tờ in",
               "description": "Mở form bình của dòng và đặt sẵn con trỏ vào ô cần điền."
            },
            {
               "action": "Đánh dấu đã bình đủ",
               "description": "Đưa dòng không cần bình thêm ra khỏi tab Chờ bình."
            }
         ],
         "inlineViews": [
            {
               "name": "Cửa sổ bình file / ghép bài",
               "trigger": "[Bình file], [Tách thêm bài], [Sửa], [Bình File Mới], [Mở Form Bình] hoặc bấm vào dòng Chờ bình",
               "description": "Form 2 cột (thông tin bài bình bên trái, sản phẩm trong bài bên phải) mở ngay trên danh sách, không rời trang."
            },
            {
               "name": "Mở rộng sản phẩm trong bài",
               "trigger": "Mũi tên ở cột Mã Bài Bình & Ảnh, hoặc [Mở rộng tất cả]",
               "description": "Hiện từng sản phẩm của bài ghép: Mã ĐH, Sản phẩm, Chất liệu & Quy trình, SL Đặt, Số Ups, SL Tờ in, SL SX trong bài."
            },
            {
               "name": "Xử lý yêu cầu bình lại",
               "trigger": "[Xử lý nhanh] ở tab Yêu cầu bình lại",
               "description": "Hộp nhập nhanh mã bài mới, khổ giấy, số ups, số tờ, ghi chú rồi Xác Nhận Hoàn Tất."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/02_prepress_create_multi_item_gangrun.png",
               "caption": "Hình 07.1 — Trang Tạo Bài Bình File: thông tin chung, thẻ định mức giấy và bảng chi tiết đơn hàng với UPS từng dòng"
            },
            {
               "src": "/guide-screenshots/10_prepress_create_fk_modal_machine_returned.png",
               "caption": "Hình 07.2 — Chọn Máy in chỉ định ngay trên trang Tạo Bài Bình"
            }
         ],
         "forms": [],
         "notes": [
            "Ghép bài chỉ khi cùng đơn hàng, cùng chất liệu giấy, cùng kiểu cán màng; khác quy trình vẫn ghép được và được thiết lập lại ở Lệnh sản xuất.",
            "Bài bình đã có Lệnh sản xuất không sửa, không xóa; muốn sửa phải gửi Yêu cầu bình lại khi lệnh chưa in.",
            "Lệnh sản xuất không được lập vượt SL đặt + bù hao cho phép của dòng đơn; hủy hoặc xóa lệnh trả số lượng về dòng đơn và bài bình của lệnh hủy dùng lại được.",
            "Nút Tạo Lệnh SX Hàng Loạt đã ngừng dùng; lập lệnh từng bài qua form để giữ đủ công đoạn của sản phẩm.",
            "Trạng thái bình bài không còn tự đánh dấu lệnh đã xuất kẽm; kẽm chỉ tính đã xuất khi tổ CTP bấm Ghi bản kẽm xong.",
            "Phiếu in Sơ đồ bài bình in hiện chưa có mã biểu mẫu ISO trên mẫu in.",
            "Ô Kỹ thuật viên phụ trách thiết kế chỉ liệt kê nhân sự tổ Thiết kế, Bình file, Chế bản, CTP."
         ],
         "uatChecklist": [
            {
               "id": "BF-07-01",
               "item": "Mở Bình file Prepress, đủ 5 tab và số đếm khớp danh sách",
               "standard": "Thấy 5 tab Chờ bình, Chờ tạo lệnh, Đã tạo lệnh, Yêu cầu bình lại, Tất cả bài bình kèm số; số trên tab bằng số dòng trong bảng; tab Chờ bình có ảnh thu nhỏ sản phẩm, mã sản phẩm, PO / SO.",
               "method": "1. Đăng nhập tài khoản tổ bình file. 2. Vào Kế hoạch › Bình file Prepress. 3. Bấm lần lượt 5 tab, so số trên tab với tổng ở thanh phân trang. 4. Bấm thẻ Quá hạn, Cận hạn để kiểm tra lọc hạn giao."
            },
            {
               "id": "BF-07-02",
               "item": "Bình bài đơn từ dòng Chờ bình",
               "standard": "Báo Đã lưu bài bình <mã>; dòng rời tab Chờ bình, bài mới hiện ở tab Chờ tạo lệnh với đúng Khổ giấy in, Số Ups, SL Tờ In, Tổng SL SX = Ups × tờ in.",
               "method": "1. Tab Chờ bình, chọn dòng hộp giấy SL 5.000. 2. Bấm [Bình file]. 3. Bấm [Gợi ý mã], Khổ giấy in 65 x 86 cm, Số Ups 4, Số lượng tờ in mỗi Ups 1.250. 4. Bấm [Lưu Bài Bình]. 5. Mở tab Chờ tạo lệnh, kiểm tra dòng mới."
            },
            {
               "id": "BF-07-03",
               "item": "Form bình báo thiếu thông tin bắt buộc",
               "standard": "Không lưu được; ô lỗi tô đỏ và hiện: Vui lòng nhập Mã bài bình. / Vui lòng nhập hoặc chọn Khổ giấy in.",
               "method": "1. Mở [Bình File Mới]. 2. Thêm 1 dòng chờ bình bằng ô tìm. 3. Để trống Mã bài bình và Khổ giấy in. 4. Bấm [Lưu Bài Bình]. 5. Điền mã, để trống khổ, bấm lại."
            },
            {
               "id": "BF-07-04",
               "item": "Ghép bài hợp lệ: 2 sản phẩm cùng đơn, cùng giấy, cùng cán màng, khác quy trình",
               "standard": "Form hiện dải Khóa điều kiện ghép: ĐH …, Giấy … và dòng nhắc quy trình khác nhau; lưu được 1 bài, lọc Bài ghép thấy bài này, mở rộng thấy đủ 2 sản phẩm.",
               "method": "1. Chuẩn bị đơn có 2 dòng cùng giấy Ivory 300, cùng cán màng mờ, một sản phẩm có bế, một không. 2. Tab Chờ bình tích cả 2 dòng. 3. Bấm [Bình File / Ghép Bài (2)]. 4. Nhập mã, khổ, Ups mỗi dòng 2 → [Lưu Bài Bình]. 5. Tab Chờ tạo lệnh chọn thẻ Bài ghép, bấm mũi tên mở rộng."
            },
            {
               "id": "BF-07-05",
               "item": "Ghép bài bị từ chối khi khác đơn hàng",
               "standard": "Không mở được form ghép; hiện lý do: Khác đơn hàng (… ≠ …). Chỉ sản phẩm cùng đơn hàng mới được ghép chung 1 bài in.",
               "method": "1. Tab Chờ bình tích 2 dòng thuộc 2 đơn hàng khác nhau. 2. Bấm [Bình File / Ghép Bài (2)]. 3. Đọc thông báo. 4. Mở form 1 dòng, gõ mã đơn kia vào ô tìm: dòng đơn khác hiện lý do và không thêm được."
            },
            {
               "id": "BF-07-06",
               "item": "Ghép bài bị từ chối khi khác giấy hoặc khác kiểu cán màng",
               "standard": "Hiện đúng lý do: Khác chất liệu giấy (…). Bình file ghép bài bắt buộc cùng chất liệu. hoặc Khác kiểu cán màng (Cán màng bóng ≠ Cán màng mờ). Cán màng phủ cả tờ in chung nên phải cùng kiểu.",
               "method": "1. Dùng đơn có 3 dòng: A giấy Ivory cán mờ, B giấy Duplex cán mờ, C giấy Ivory cán bóng. 2. Tích A + B → [Bình File / Ghép Bài (2)], đọc lý do. 3. Bỏ chọn, tích A + C, bấm lại, đọc lý do."
            },
            {
               "id": "BF-07-07",
               "item": "Tách bài cho dòng số lượng lớn",
               "standard": "Sau lần bình đầu, dòng vẫn ở Chờ bình với Đã bình 6.000 / 10.000 và nút Tách thêm bài; bình tiếp 4.000 thì dòng rời Chờ bình; lọc Tách bài thấy 2 bài.",
               "method": "1. Chọn dòng SL 10.000. 2. [Bình file], Ups 4, sửa SL SX từng loại thành 6.000 → [Lưu Bài Bình]. 3. Quay lại tab Chờ bình xem dòng. 4. Bấm [Tách thêm bài], lưu 4.000. 5. Tab Tất cả bài bình chọn thẻ Tách bài."
            },
            {
               "id": "BF-07-08",
               "item": "Sửa và xóa bài bình chưa có lệnh",
               "standard": "Sửa: báo Đã cập nhật bài bình <mã>, số liệu mới hiện trên danh sách. Xóa: báo Đã xóa bài bình, dòng đơn quay lại tab Chờ bình đủ số lượng.",
               "method": "1. Tab Chờ tạo lệnh, bấm [Sửa] trên bài vừa tạo, đổi Số Ups 4 thành 6 → [Cập nhật Bài Bình]. 2. Bấm biểu tượng thùng rác → [Xóa bài bình]. 3. Mở tab Chờ bình tìm lại dòng."
            },
            {
               "id": "BF-07-09",
               "item": "Bài đã có lệnh được khóa sửa / xóa",
               "standard": "Bài ở Đã tạo lệnh / Tất cả bài bình (nhãn Đã tạo lệnh) chỉ có nút Chi tiết, không có Sửa, Tạo Lệnh SX, Xóa; xóa hàng loạt báo bỏ qua bài đã tạo Lệnh SX.",
               "method": "1. Tab Tất cả bài bình, tìm bài có nhãn Đã tạo lệnh. 2. Kiểm tra cột Thao tác. 3. Tích bài đó cùng 1 bài Chờ tạo lệnh → [Xóa bài bình (2)] → [Xác nhận xóa]. 4. Đọc thông báo."
            },
            {
               "id": "BF-07-10",
               "item": "Bàn giao sang Kế hoạch: Tạo Lệnh SX từ bài bình",
               "standard": "Trang Tạo lệnh sản xuất mở với khổ in, số con, số tờ, sản phẩm của bài đã nạp sẵn; lưu lệnh xong bài chuyển tab Đã tạo lệnh, cột Lệnh Sản Xuất là link mở đúng lệnh. Chọn nhiều bài bấm Tạo Lệnh SX Hàng Loạt thì hệ thống báo chức năng đã ngừng dùng.",
               "method": "1. Tab Chờ tạo lệnh, bấm [Tạo Lệnh SX] trên bài ghép ở BF-07-04. 2. Kế hoạch kiểm tra công đoạn, bù hao, Ups, số lượng rồi lưu lệnh. 3. Quay lại Bình file Prepress tab Đã tạo lệnh, bấm mã lệnh. 4. Tích 2 bài Chờ tạo lệnh → [Tạo Lệnh SX Hàng Loạt (2)], đọc thông báo."
            },
            {
               "id": "BF-07-11",
               "item": "Yêu cầu bình lại từ đơn hàng / lệnh và xử lý xong",
               "standard": "Dòng hiện ở tab Yêu cầu bình lại kèm lý do; lệnh tạm dừng. Sau Xác Nhận Hoàn Tất báo Đã xác nhận hoàn tất xử lý bình lại, dòng rời tab, lệnh về trạng thái trước. Lệnh đã bắt đầu in thì bị từ chối kèm hướng dẫn lập NCR / lệnh in bù.",
               "method": "1. Mở lệnh chưa in ở BF-07-10 → [Bình lại], lý do Sai khổ giấy → [Gửi Yêu Cầu Bình Lại]. 2. Kiểm tra trạng thái lệnh. 3. Bình file Prepress › tab Yêu cầu bình lại → [Xử lý nhanh], Khổ giấy in 72 x 102 cm → [Xác Nhận Hoàn Tất]. 4. Thử gửi bình lại cho một lệnh đã có nhật ký in."
            },
            {
               "id": "BF-07-12",
               "item": "Chi tiết bài bình: link bản ghi cha, 3 tab, in sơ đồ",
               "standard": "Đơn hàng, Khách hàng, Lệnh sản xuất là link mở đúng bản ghi; có 3 tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật (ghi người tạo và các lần sửa); [In] mở bản in Sơ đồ bài bình in.",
               "method": "1. Bấm một bài ở tab Tất cả bài bình. 2. Bấm lần lượt link đơn hàng, khách hàng, lệnh rồi quay lại. 3. Viết 1 thảo luận, đính kèm 1 ảnh sơ đồ, mở Lịch sử cập nhật. 4. Bấm [In]."
            },
            {
               "id": "BF-07-13",
               "item": "Ô chọn tra cứu trong form bình: Máy in, Khuôn bế, tìm dòng chờ bình",
               "standard": "Ô Chọn máy in..., Chọn khuôn bế... gõ vài chữ là lọc đúng danh mục; ô tìm dòng chờ bình lọc theo mã đơn, khách hàng, sản phẩm; lưu xong chi tiết bài hiện Máy in dự kiến và Khuôn bế đã chọn.",
               "method": "1. Mở form bình 1 dòng. 2. Mở mục Khuôn bế & Máy in dự kiến (Tùy chọn). 3. Gõ Komori vào ô máy in, gõ mã khuôn vào ô khuôn bế, chọn. 4. Lưu, mở chi tiết bài bình kiểm tra."
            },
            {
               "id": "BF-07-14",
               "item": "Kiểm tra trên điện thoại 390px",
               "standard": "Tab cuộn ngang đủ 5 tab, không dính chữ; bảng kéo ngang được, cột mã giữ bên trái; form bình xếp 1 cột, nút Lưu Bài Bình và Lưu & Tạo Lệnh SX bấm được; không có thanh cuộn ngang cả trang.",
               "method": "1. Mở trình duyệt điện thoại (hoặc chế độ thiết bị 390 x 844). 2. Vào Bình file Prepress. 3. Vuốt qua các tab, kéo ngang bảng. 4. Bấm [Bình file] một dòng, cuộn hết form, lưu thử."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "Nhân Viên Kỹ Thuật / Chế Bản",
               "createTest": "Tạo bài đơn và bài ghép từ tab Chờ bình.",
               "readTest": "Xem 5 tab, chi tiết bài bình, xuất Excel.",
               "updateTest": "Sửa bài Chờ tạo lệnh, xử lý Yêu cầu bình lại.",
               "deleteTest": "Xóa bài Chờ tạo lệnh; thử xóa bài đã có lệnh.",
               "expectedResult": "Tạo, sửa, xóa được bài chưa có lệnh (khi vai trò có quyền Sửa Lệnh sản xuất); bài đã có lệnh bị khóa."
            },
            {
               "roleGroup": "Kế Hoạch Sản Xuất",
               "createTest": "Bấm Tạo Lệnh SX trên bài Chờ tạo lệnh và lưu lệnh.",
               "readTest": "Xem tab Chờ tạo lệnh, Đã tạo lệnh, chi tiết bài bình.",
               "updateTest": "Gửi Yêu cầu bình lại từ lệnh chưa in.",
               "deleteTest": "Không xóa bài đã có lệnh.",
               "expectedResult": "Lệnh tạo đúng số lượng từ bài; bài chuyển Đã tạo lệnh; yêu cầu bình lại làm lệnh tạm dừng."
            },
            {
               "roleGroup": "Nhân Viên Kinh Doanh",
               "createTest": "Gửi Yêu Cầu Bình Lại từ chi tiết đơn hàng.",
               "readTest": "Xem Bình file Prepress (nếu được cấp quyền Xem).",
               "updateTest": "Không có quyền Sửa Lệnh sản xuất: thử lưu một bài bình.",
               "deleteTest": "Không thấy nút xóa bài bình.",
               "expectedResult": "Yêu cầu bình lại gửi được; lưu bài bình bị máy chủ từ chối do thiếu quyền."
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 08. Lệnh Sản Xuất: Lập Từ Đơn, Ghép / Tách, Ban Hành & Hủy
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "production_orders",
         "aliases": [
            "production-orders",
            "production",
            "planning",
            "po",
            "lsx",
            "production-orders/create",
            "production-orders/tracking",
            "production-orders/prepress-queue",
            "tracking"
         ],
         "title": "08. Lệnh Sản Xuất: Lập Từ Đơn, Ghép / Tách, Ban Hành & Hủy",
         "icon": "ClipboardList",
         "isoRef": "QT-SX-01",
         "purpose": "Hướng dẫn phòng Kế hoạch lập và điều hành Lệnh sản xuất (LSX) tại Kế hoạch › Lệnh sản xuất: nhận đơn hàng đã duyệt từ Sale, lập lệnh nhanh ngay trên đơn bằng [Lập Lệnh SX] hoặc lập từ bể chờ lệnh bằng [Thêm LSX] (lệnh đơn, ghép bài, tách đợt), lưu nháp / chờ duyệt, Duyệt Ban Hành có kiểm tra thiếu vật tư, theo dõi 5 tab của lệnh tới Hoàn thành; khi hủy hoặc xóa lệnh, số lượng trả về đơn hàng và các việc còn mở của lệnh được dừng theo.",
         "scope": [
            "Phòng Kế hoạch: lập, sửa, lưu nháp, lưu chờ duyệt, chốt kế hoạch, tạm dừng, hủy, xóa lệnh sản xuất.",
            "Người có quyền Duyệt Lệnh sản xuất: [Duyệt Ban Hành], [Lưu & Duyệt Ban Hành], [Chốt kế hoạch] / [Mở khóa KH], duyệt cấp bù phế phẩm.",
            "Nhận việc từ Sale: đơn hàng đã duyệt (không phải Bản nháp, Đã hủy, Hoàn tất). Giao việc cho Bình file (bài bình), Xưởng sản xuất (công đoạn), Kho vật tư (cấp vật tư), Mua hàng (đơn mua / đề nghị mua cho phần thiếu).",
            "Màn hình: Kế hoạch › Lệnh sản xuất với 4 tab [Danh Sách Lệnh SX], [Chờ Lập Lệnh], [Hàng Chờ CTP], [Tiến Độ CĐ]; trang Khởi tạo Lệnh Sản Xuất 3 bước; trang chi tiết lệnh; trang sửa lệnh. Menu Kế hoạch › Tiến Độ Công Đoạn mở thẳng tab [Tiến Độ CĐ].",
            "Menu trái mặc định mở sẵn 3 mục Kinh doanh, Kế hoạch, Xưởng sản xuất. Trong mục Kế hoạch: Bình file Prepress → Lệnh sản xuất → Kế hoạch Vật tư → Tiến Độ Công Đoạn."
         ],
         "references": [
            "ISO 9001:2015 mục 8.1 Hoạch định và kiểm soát việc thực hiện",
            "ISO 9001:2015 mục 8.5.1 Kiểm soát sản xuất và cung cấp dịch vụ",
            "Chương 06 Đơn hàng, Chương 07 Bình file chế bản, Chương 09 Kế hoạch vật tư và cấp phát, Chương 10 Khuôn bế và bản kẽm"
         ],
         "terms": [
            {
               "term": "LSX",
               "definition": "Lệnh sản xuất. Mã lệnh hiện ở đầu trang chi tiết và ở cột mã lệnh của danh sách."
            },
            {
               "term": "Lệnh Đơn / Lệnh Ghép / Tách Lệnh",
               "definition": "Lệnh Đơn cho 1 mặt hàng; Lệnh Ghép cho nhiều mặt hàng in chung một tờ in (ghép bài); Tách Lệnh để chỉ sản xuất một phần số lượng còn lại trong đợt này."
            },
            {
               "term": "Điều kiện ghép bài",
               "definition": "Chỉ ghép được các mặt hàng cùng đơn hàng, cùng chất liệu giấy và cùng kiểu cán màng. Khác quy trình sản xuất vẫn ghép được; công đoạn, bù hao, số con (UPS) và số lượng của từng mặt hàng được đặt lại trong lệnh."
            },
            {
               "term": "Bù hao (%)",
               "definition": "Phần trăm sản xuất dư so với SL đặt. Mặc định lấy theo dòng đơn hàng; dòng để trống tính 5%; nhập 0% là hợp lệ (không bù hao)."
            },
            {
               "term": "Trần lập lệnh",
               "definition": "Mỗi dòng đơn chỉ được lập lệnh tối đa SL đặt cộng bù hao, trừ số đã nằm trong các lệnh còn hiệu lực (lệnh đã hủy / đã xóa không tính)."
            },
            {
               "term": "Gate 1 (Đủ khổ in và UPS)",
               "definition": "Mặt hàng trong bể chờ lệnh phải có khổ in và số con trên tờ. Dòng thiếu hiện nhãn Thiếu khổ in/UPS, phải bình file trước khi lập lệnh."
            },
            {
               "term": "Chờ duyệt ban hành",
               "definition": "Trạng thái sau khi bấm [Lưu] trên lệnh mới hoặc lệnh nháp; mọi người thấy lệnh nhưng lệnh chưa xuống xưởng. Trên danh sách hiện gọn là Chờ duyệt."
            },
            {
               "term": "Bản nháp riêng",
               "definition": "Lệnh lưu bằng [Lưu nháp]: chỉ người tạo, Admin và Giám đốc thấy; không bắt buộc đủ thông tin."
            },
            {
               "term": "Chốt kế hoạch (Đã chốt KH)",
               "definition": "Khóa kế hoạch của lệnh: nút [Sửa] và [Xóa lệnh sản xuất] bị mờ. Lệnh tự chốt khi chuyển Đã lên KH hoặc Sẵn sàng lên KH; mở lại bằng [Thao tác] › [Mở khóa KH] (cần quyền Duyệt)."
            },
            {
               "term": "Kiểm tra thiếu vật tư khi ban hành",
               "definition": "Khi bấm [Duyệt Ban Hành], hệ thống tính phần còn thiếu của từng vật tư: trừ phần đã xuất kho cho lệnh, phần hàng mua riêng cho lệnh đã về kho, rồi so với tồn kho dùng chung còn lại."
            },
            {
               "term": "Khóa sau phát hành",
               "definition": "Từ khi lệnh Đã phát hành tới khi xong / hủy: không đổi SL, số con / tờ, khổ giấy in, số tờ chạy. Cần đổi thì tạm dừng hoặc hủy lệnh rồi lập lệnh mới."
            }
         ],
         "responsibilities": [
            {
               "role": "Nhân viên Kế hoạch sản xuất",
               "tasks": [
                  "Mở đơn hàng đã duyệt, bấm [Lập Lệnh SX] hoặc vào Lệnh sản xuất › [Thêm LSX] để lập lệnh; kiểm tra bù hao, khổ in, số con, công đoạn.",
                  "Rà soát 5 tab của lệnh, bấm [Lưu nháp] hoặc [Lưu]; theo dõi danh sách, Tiến Độ CĐ, in Lệnh SX và Báo Cáo KHSX.",
                  "Tái đồng bộ theo báo giá khi lệnh còn Bản nháp / Chờ duyệt ban hành; yêu cầu [Bình lại] khi bài bình sai."
               ]
            },
            {
               "role": "Trưởng phòng Kế hoạch (có quyền Duyệt Lệnh sản xuất)",
               "tasks": [
                  "Bấm [Duyệt Ban Hành], xử lý hộp Cảnh báo thiếu vật tư: [Tạo PR & Ban hành] hoặc [Bỏ qua & Ban hành].",
                  "Chốt / mở khóa kế hoạch; quyết định Tạm dừng, Tiếp tục, Hủy lệnh (bắt buộc ghi lý do)."
               ]
            },
            {
               "role": "Sale (đầu vào)",
               "tasks": [
                  "Duyệt đơn hàng, nhập bù hao từng dòng; đơn còn Bản nháp / Đã hủy / Hoàn tất không lập lệnh được."
               ]
            },
            {
               "role": "Bình file, Xưởng, Kho vật tư, Mua hàng (đầu ra)",
               "tasks": [
                  "Bình file: bình bài cho dòng thiếu khổ in / UPS, xử lý yêu cầu bình lại.",
                  "Xưởng: nhận lệnh Đã phát hành, bấm [Bắt đầu], ghi sản lượng công đoạn.",
                  "Kho vật tư: cấp vật tư ở tab 2. Kế hoạch vật tư (xem Chương 09). Mua hàng: duyệt đề nghị mua / đơn mua cho phần thiếu."
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền, thấy cả bản nháp riêng của người khác."
            },
            {
               "role": "Có quyền Duyệt Lệnh sản xuất",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Thấy [Lưu & Duyệt Ban Hành] trên form; dùng được [Duyệt Ban Hành], [Chốt kế hoạch], [Mở khóa KH] và bước Đã phát hành trên thanh trạng thái."
            },
            {
               "role": "Có quyền Thêm / Sửa Lệnh sản xuất (không có Duyệt)",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "⚡",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Không thấy [Lưu & Duyệt Ban Hành]; bấm [Duyệt Ban Hành] hoặc [Chốt kế hoạch] thì hệ thống báo Thao tác này cần quyền Duyệt. Vẫn [Bắt đầu], [Hoàn thành], [Tạm dừng lệnh], [Tiếp tục], [Hủy lệnh]. Xóa cần quyền Xóa và bị chặn khi lệnh Đã chốt KH hoặc đã có nhật ký sản xuất / KCS / phiếu kho đã ghi sổ."
            },
            {
               "role": "Chỉ có quyền Xem",
               "view": "👁",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Xem danh sách, chi tiết, in lệnh, xuất Excel; không thấy [Thêm LSX]. Bản nháp riêng của người khác không hiện."
            }
         ],
         "processFlowchart": "graph TD\n    S[Đơn hàng đã duyệt từ Sale] --> A{Cách lập lệnh}\n    A -->|Trên đơn: Lập Lệnh SX| Q[Tạo Lệnh SX 1-Chạm]\n    Q --> P[Đã lên KH]\n    A -->|Thêm LSX: bể chờ lệnh| B{Gate 1 đủ khổ in và UPS}\n    B -->|Thiếu| C[Bình file ngay trên trang tạo lệnh]\n    C --> B\n    B -->|Đủ| D[Lệnh Đơn hoặc Lệnh Ghép hoặc Tách Lệnh]\n    D --> E[Rà soát 5 tab: bù hao, UPS, công đoạn, SL]\n    E -->|Lưu nháp| F[Bản nháp riêng]\n    F --> E\n    E -->|Lưu| G[Chờ duyệt ban hành]\n    E -->|Lưu và Duyệt Ban Hành| H\n    G --> H{Duyệt Ban Hành kiểm tra thiếu vật tư}\n    P --> H\n    H -->|Thiếu| I[Tạo PR và Ban hành hoặc Bỏ qua và Ban hành]\n    I --> J[Đã phát hành: xuống Xưởng, Kho, Bình file]\n    H -->|Đủ| J\n    J -->|Bắt đầu| K[Đang SX]\n    K -->|Tạm dừng lệnh| L[Tạm ngưng]\n    L -->|Tiếp tục| K\n    K -->|Hoàn thành| M[Hoàn thành]\n    G -->|Hủy lệnh| N[Đã hủy: trả SL về đơn, hủy công đoạn mở, hủy vật tư chưa nhận]\n    J -->|Hủy lệnh| N\n    K -->|Hủy lệnh| N",
         "mainFlow": [
            {
               "step": 1,
               "action": "Nhận đơn từ Sale và mở danh sách Lệnh sản xuất",
               "detail": "• Vào Kế hoạch › Lệnh sản xuất. Hàng tab trên cùng: [Danh Sách Lệnh SX], [Chờ Lập Lệnh], [Hàng Chờ CTP], [Tiến Độ CĐ]; nằm trên thanh tiêu đề của chứng từ.\n• Danh Sách Lệnh SX: mỗi lệnh một dòng, có ảnh sản phẩm / bài bình và các cột tiến độ theo nhóm công đoạn. Bấm dòng để mở chi tiết lệnh. Có nút [Theo ngày], ô Nhóm (Không nhóm / Theo Ngày (Kế hoạch / Tạo) / Theo Khách hàng / Theo Trạng thái / Theo Mức ưu tiên), ô Trạng thái SX và 4 thẻ LSX Hỏa Tốc, LSX Gấp, Cận Hạn Giao, Quá Hạn để lọc nhanh.\n• Lệnh đã xóa nằm ở tab Thùng rác của trang (khôi phục được khi có quyền Xóa).\n• [Tiến Độ CĐ]: mỗi lệnh đang chạy một dòng, gom theo ngày hạn giao; cột Đang ở cho biết lệnh nằm ở công đoạn nào; một nhóm công đoạn chỉ báo xong khi cả nhóm xong."
            },
            {
               "step": 2,
               "action": "Lập lệnh nhanh từ đơn hàng ([Lập Lệnh SX])",
               "detail": "• Mở đơn hàng đã duyệt (Kinh doanh › Đơn hàng › bấm dòng đơn) → bấm [Lập Lệnh SX]. Hộp Lập Kế Hoạch / Lệnh Sản Xuất liệt kê các dòng, cột Số lượng (Đặt/Còn) cho biết Đã lên và Còn lại; dòng còn số lượng được chọn sẵn.\n• Mỗi dòng nhập Khổ in (VD 650x860), Số con (Ups) (tối thiểu 1) và Bù hao % (mặc định theo dòng đơn, để trống là 5%, 0% hợp lệ); dòng Chạy cho biết số tờ in ước tính.\n• Bấm [Tạo Lệnh SX 1-Chạm]: các dòng chung một bài bình gộp thành một lệnh ghép, các dòng khác mỗi dòng một lệnh; lệnh tạo ở trạng thái Đã lên KH và tự xếp lịch máy. Thông báo Đã tạo n Lệnh Sản Xuất từ Đơn Hàng …; dòng đã lên lệnh đủ bị bỏ qua và được nêu tên.\n• Muốn chỉnh chi tiết trước khi lập: bấm [Mở Form Chi Tiết] để sang trang Khởi tạo Lệnh Sản Xuất với các dòng đã chọn.\n• Đơn Bản nháp / Đã hủy / Hoàn tất, hoặc dòng đang chờ bình lại, bị từ chối kèm lý do."
            },
            {
               "step": 3,
               "action": "Lập lệnh từ bể chờ lệnh ([Thêm LSX])",
               "detail": "• Danh sách → [Thêm LSX] (cần quyền Thêm). Trang có 3 bước: 1. Chọn mặt hàng → 2. Bình file → 3. Lệnh sản xuất.\n• Tìm theo tên sản phẩm, mã SP, mã đơn hàng, bài bình; lọc Tất cả Khách hàng và Gate 1: ✅ Đủ điều kiện (Có khổ in & UPS) / ⚠️ Cần bổ sung quy cách.\n• Dòng thiếu khổ in / UPS: bấm [Bình file] trên dòng, hoặc chọn nhiều dòng rồi [Bình file ghép (n SP)]; nhập bài bình rồi [Lưu & lập lệnh] để sang thẳng bước Lệnh sản xuất.\n• Chọn 1 mặt hàng → [Tạo Lệnh Đơn]; từ 2 mặt hàng → [Tạo Lệnh Ghép (n)] (chỉ khi cùng đơn, cùng giấy, cùng kiểu cán màng; sai thì báo lý do); sản xuất một phần → [Tách Lệnh], nhập số lượng (từ 1 tới số còn lại) → [Xác Nhận Tách Lệnh].\n• Cách khác: tab [Chờ Lập Lệnh] → [Lập Lệnh Sản Xuất F0] trên bài bình đã bình xong."
            },
            {
               "step": 4,
               "action": "Rà soát form lệnh và lưu",
               "detail": "• Form có 5 tab: 1. Danh mục sản phẩm, 2. Kế hoạch vật tư, 3. Kế hoạch khuôn kẽm, 4. Kế hoạch sản xuất, 5. KCS & Đóng gói. Với lệnh ghép / tách, đặt lại công đoạn, bù hao, số con và số lượng từng mặt hàng ngay trên form. [Đồng bộ TCKT] nạp lại thông số, vật tư, công đoạn, kẽm, khuôn từ sản phẩm gốc; [Đổi mặt hàng khác] quay về bể chờ.\n• [Lưu nháp]: ghi tạm, chỉ người tạo / Admin / Giám đốc thấy. [Lưu] (hoặc [Tạo Lệnh SX] trên đầu trang): kiểm tra đủ thông tin, lệnh chuyển Chờ duyệt ban hành. [Lưu & Duyệt Ban Hành]: chỉ hiện với người có quyền Duyệt.\n• Số lượng vượt trần bị chặn: Số lượng lập lệnh … vượt số còn được lập … (đặt …, đã lập …). Dòng đã lập đủ: Dòng đơn hàng đã lập kế hoạch đủ: …\n• Lưu thành công: Khởi tạo Lệnh Sản Xuất thành công! và mở chi tiết lệnh; lưu lỗi thì không tạo lệnh dở."
            },
            {
               "step": 5,
               "action": "Duyệt Ban Hành và xử lý thiếu vật tư",
               "detail": "• Trên chi tiết lệnh (Bản nháp, Chờ duyệt ban hành, Chế bản, Chế bản xong, Sẵn sàng lên KH, Đã lên KH) bấm [Duyệt Ban Hành] (cần quyền Duyệt). Dải vàng Kế Hoạch Nội Bộ nhắc lệnh chưa xuống xưởng.\n• Lệnh chưa có định mức vật tư hoặc công đoạn bị chặn: Không thể ban hành lệnh khi chưa có định mức vật tư hoặc công đoạn nào.\n• Còn thiếu: hộp Cảnh báo thiếu vật tư liệt kê vật tư và số cần mua, có [Hủy], [Bỏ qua & Ban hành], [Tạo PR & Ban hành] (tạo đề nghị mua Nháp, ngày cần hàng sau 3 ngày; vật tư đã có đề nghị mua đang mở thì bỏ qua, không tạo trùng).\n• Ban hành xong: Đã ban hành lệnh sản xuất, trạng thái Đã phát hành. Lệnh hiện ở Xưởng sản xuất › Kế hoạch sản xuất, hàng chờ cấp vật tư và Hàng Chờ CTP."
            },
            {
               "step": 6,
               "action": "Theo dõi lệnh trên trang chi tiết",
               "detail": "• Đầu trang: ảnh bài bình, khối Tiến độ & đơn hàng (Khách hàng, Đơn hàng / PO, Hạn giao & KHSX, Kế hoạch SL) và Sẵn sàng triển khai (Vật tư · Khuôn & kẽm · KCS & đóng gói · Giao hàng). Khách hàng, đơn hàng, sản phẩm là link mở thẳng chứng từ gốc.\n• 5 tab: 1. Danh mục sản phẩm (SL Đặt, SL Tồn Kho, SL Kế Hoạch, SL Đã Chạy, SL Thành Phẩm, SL Giao Hàng); 2. Kế hoạch vật tư (Chương 09); 3. Kế hoạch khuôn kẽm (Chương 10); 4. Kế hoạch sản xuất (công đoạn, máy, sản lượng); 5. KCS & Đóng gói.\n• Cuối trang: Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật và dòng Tạo lúc / Cập nhật lúc kèm người thao tác."
            },
            {
               "step": 7,
               "action": "Chạy lệnh tới Hoàn thành bằng nút hoặc thanh trạng thái",
               "detail": "• Đã phát hành: [Bắt đầu] → Đang SX (công đoạn đầu tiên bắt đầu ở xưởng cũng tự chuyển lệnh sang Đang SX). Đang SX: [Hoàn thành] → Hoàn thành.\n• Mỗi lần đổi trạng thái có hộp xác nhận; lý do bắt buộc khi Hủy hoặc Tạm dừng, tùy chọn với bước khác; [Quay lại] để bỏ.\n• Thanh trạng thái Bản nháp → Đã lên KH → Đã phát hành → Đang SX → Hoàn thành chỉ cho bấm bước được phép; bước không hợp lệ hiện mờ. Khi hệ thống từ chối, thông báo nêu đúng lý do, VD Không thể chuyển Lệnh sản xuất từ \"Đã phát hành\" sang \"Hoàn thành\". Có thể chuyển sang: Đang SX, Đã hủy, Tạm ngưng, Tạm dừng."
            }
         ],
         "subFlows": [
            {
               "name": "Sửa lệnh sản xuất",
               "steps": [
                  "Chi tiết lệnh → [Sửa] (mờ khi Đã chốt KH; mở khóa bằng [Thao tác] › [Mở khóa KH]).",
                  "Sửa trên 5 tab như lúc tạo. Lệnh nháp có [Lưu nháp] và [Lưu]; lệnh đã qua nháp có [Cập nhật]; [Huỷ] để thoát không lưu.",
                  "Lệnh đã phát hành / đang chạy / đã xong: đổi SL, số con / tờ, khổ giấy, số tờ chạy bị từ chối kèm lý do. Sản lượng hoàn thành do KCS thành phẩm ghi, không sửa tay."
               ]
            },
            {
               "name": "Lưu nháp rồi gửi chờ duyệt",
               "steps": [
                  "[Lưu nháp] giữ lệnh làm dở (chỉ người tạo, Admin, Giám đốc thấy).",
                  "Đủ thông tin: mở lệnh → [Sửa] → [Lưu]; lệnh chuyển Chờ duyệt ban hành và hiện cho mọi người."
               ]
            },
            {
               "name": "Chốt kế hoạch / Mở khóa KH",
               "steps": [
                  "[Thao tác] → [Chốt kế hoạch]: Đã chốt kế hoạch (Khoá), lệnh có nhãn Đã chốt KH.",
                  "[Thao tác] → [Mở khóa KH]: Đã mở khóa kế hoạch. Cả hai cần quyền Duyệt."
               ]
            },
            {
               "name": "Tái đồng bộ Báo Giá",
               "steps": [
                  "Chỉ có khi lệnh Bản nháp / Chờ duyệt ban hành và chưa chốt kế hoạch.",
                  "[Thao tác] → [Tái đồng bộ Báo Giá] → xác nhận cảnh báo (xóa chỉnh tay trên kế hoạch vật tư / sản xuất). Thành công: Đồng bộ Kế hoạch thành công!"
               ]
            },
            {
               "name": "Tạm dừng, Tiếp tục",
               "steps": [
                  "Lệnh Đang SX: [Thao tác] → [Tạm dừng lệnh], nhập lý do → [Xác nhận]; lệnh chuyển Tạm ngưng, xưởng không bắt đầu được công đoạn.",
                  "Lệnh Tạm ngưng / Tạm dừng: [Tiếp tục] → Đang SX. Lệnh đang tạm giữ chờ bình lại thì bị chặn tới khi chế bản xác nhận đã xử lý.",
                  "Lệnh Đã sản xuất mở lại Đang SX được khi sản lượng ghi sai."
               ]
            },
            {
               "name": "Hủy lệnh (dừng theo dây chuyền)",
               "steps": [
                  "[Thao tác] → [Hủy lệnh] (có ở mọi trạng thái trừ Hoàn thành, Đã đóng, Đã hủy), nhập lý do → [Xác nhận]. Lý do lưu thành bình luận của lệnh.",
                  "Hệ thống tự: trả số lượng về dòng đơn hàng (lập lệnh mới được); công đoạn còn mở chuyển Đã hủy, rời hàng chờ máy và lịch; kế hoạch vật tư chưa nhận đủ chuyển Đã hủy, thôi tính thiếu và không còn hiện ở Kế hoạch Vật tư; đề nghị mua đang mở của lệnh bị từ chối; bài bình của lệnh dùng lại được.",
                  "Nếu còn đơn mua đang mở cho vật tư của lệnh: thông báo vàng nêu mã đơn mua để báo Mua hàng hủy đơn hoặc giữ làm hàng tồn chung; đơn mua chỉ phục vụ lệnh đã hủy không duyệt được.",
                  "Lệnh đã hủy không còn hiện trong ô chọn lệnh của các form mới và không đặt gia công được. Hủy đơn hàng chỉ hủy kèm các lệnh chưa chạy."
               ]
            },
            {
               "name": "Xóa lệnh sản xuất",
               "steps": [
                  "[Thao tác] → [Xóa lệnh sản xuất] (mờ khi Đã chốt KH) → xác nhận hộp Xác nhận xóa lệnh sản xuất?.",
                  "Lệnh cùng kế hoạch vật tư, công đoạn, định mức vào Thùng rác; số lượng trả về dòng đơn; trang quay về danh sách.",
                  "Lệnh đã có nhật ký sản xuất, biên bản KCS thành phẩm hoặc phiếu kho đã ghi sổ: không xóa được, hệ thống báo dùng Hủy lệnh.",
                  "Xóa nhiều: tích các lệnh Bản nháp / Chờ duyệt ban hành → [Xóa] trên thanh tác vụ → xác nhận."
               ]
            },
            {
               "name": "Yêu cầu bình lại",
               "steps": [
                  "Chi tiết lệnh → [Bình lại] (khi lệnh chưa in), chọn dòng, ghi lý do (tối thiểu 5 ký tự) → [Gửi Yêu Cầu Bình Lại].",
                  "Lệnh chuyển Tạm dừng chờ chế bản; chế bản xác nhận xong thì lệnh chạy tiếp. Đã bắt đầu in thì lập NCR / lệnh in bù."
               ]
            },
            {
               "name": "Đặt gia công một phần",
               "steps": [
                  "Lệnh thuộc đơn hàng, chưa Hoàn thành / Đã hủy: [Thao tác] → [Đặt gia công (một phần)] mở form đơn gia công đã điền đơn hàng và lệnh; chọn nhà gia công và công đoạn thuê ngoài."
               ]
            },
            {
               "name": "In và Xuất Excel",
               "steps": [
                  "Chi tiết → [In LSX] (BM-SX-01). Danh sách: tích nhiều lệnh → [In Lệnh SX] in gộp, hoặc [In tem thùng].",
                  "Danh sách → [Báo Cáo KHSX] (BM-KHSX-01, khổ A4 ngang).",
                  "Danh sách → [Xuất Excel] theo bộ lọc hiện tại (Mã LSX, Sản phẩm, Số lượng, Trạng thái, Hạn trả hàng, PO Reference). Không nhập lệnh bằng Excel."
               ]
            },
            {
               "name": "Quét sản lượng, In tem thùng trên lệnh",
               "steps": [
                  "[Thao tác] → [Quét sản lượng] mở cửa sổ quét mã của lệnh; [Thao tác] → [In tem thùng] in tem các lô đã đóng gói của lệnh."
               ]
            },
            {
               "name": "Hàng Chờ CTP",
               "steps": [
                  "Danh sách → [Hàng Chờ CTP]: thẻ Kẽm sẵn sàng, Đang ghi bản CTP, Chờ ghi bản kẽm; chỉ hiện lệnh tổ CTP làm được.",
                  "[Ghi bản] chuyển lệnh sang đang ghi bản; [Xong] khi kẽm ghi bản xong (trừ kho kẽm một lần)."
               ]
            },
            {
               "name": "Báo cáo TP trên dòng sản phẩm của lệnh",
               "steps": [
                  "Trang chi tiết lệnh › bảng sản phẩm › menu ba chấm của dòng › [Báo cáo TP]: nhập số lượng thành phẩm làm xong.",
                  "Số lượng được cộng vào SL đã sản xuất của dòng đơn hàng và ghi thành nhật ký; dòng đơn chưa sản xuất chuyển Đang SX. Dòng đơn không tự chuyển Đã giao — Đã giao chỉ đến từ phiếu giao hàng.",
                  "Báo cáo TP không thay cho KCS thành phẩm, đóng gói và giao hàng: thành phẩm vẫn đi FQC → Đóng gói & nhập kho → Phiếu giao (chương 11, 12, 14)."
               ]
            },
            {
               "name": "Lệnh sản xuất › phần đầu lệnh — Cấu trúc hợp phần và sơ đồ bài bình",
               "steps": [
                  "[Khởi tạo hợp phần từ sản phẩm]: thêm vào lệnh các hợp phần đã khai báo ở sản phẩm gốc, chỉ thêm phần còn thiếu; nếu đã đủ, hệ thống báo \"Các hợp phần của sản phẩm đã có đủ trong lệnh\".",
                  "Nút [Khởi tạo hợp phần từ sản phẩm] chỉ hiện khi lệnh có dòng sản phẩm nguồn và bị khóa khi kế hoạch lệnh đã khóa (trừ quản trị viên).",
                  "[Xem vector CAD] / [Xem ảnh chụp]: chuyển ô sơ đồ bài bình giữa hình vẽ khổ in tự động và ảnh chụp bài bình; nút chỉ hiện khi bài bình đã có ảnh.",
                  "[Tải ảnh CAD]: mở hộp \"Cập Nhật Ảnh Bài Bình Prepress\" để chọn ảnh, kéo thả, dán bằng Ctrl + V hoặc nhập liên kết ảnh; khi bài bình đã có ảnh, nút đổi tên thành [Đổi ảnh].",
                  "[Gỡ ảnh]: trong hộp cập nhật ảnh, bỏ ảnh đang chọn của bài bình; bấm [Lưu Thay Đổi] để lưu (nút này mờ khi ảnh chưa thay đổi)."
               ]
            },
            {
               "name": "Lệnh sản xuất › tab 2. Kế hoạch vật tư — Tách vật tư, In lại phiếu cấp, Cấp bù phế phẩm",
               "steps": [
                  "Nút Tách vật tư (biểu tượng tách) trên dòng Vật tư in mở hộp \"Tách Vật Tư\"; nút bị khóa khi kế hoạch lệnh đã khóa hoặc dòng đã xuất kho một phần.",
                  "[Thực hiện Tách]: chuyển số lượng nhập ở ô \"SL Tách sang dòng mới\" sang một dòng vật tư mới, dòng cũ giữ phần còn lại; số lượng tách phải lớn hơn 0 và nhỏ hơn số lượng gốc, nếu không hệ thống báo \"Số lượng tách không hợp lệ\".",
                  "[Phiếu A4]: trên dòng của bảng Lịch sử cấp phát, mở hộp \"In Lại Phiếu Cấp\" ở dạng phiếu xuất cấp phát sàn xưởng khổ A4.",
                  "[Tem Pallet Decal]: trong hộp \"In Lại Phiếu Cấp\", chuyển sang mẫu tem dán pallet có mã QR (nút [Phiếu Xuất A4] để quay lại mẫu phiếu).",
                  "[In Ngay (Tem Decal)] / [In Ngay (Phiếu A4)]: in mẫu đang xem trong hộp \"In Lại Phiếu Cấp\".",
                  "Trong bảng Cấp bù phế phẩm, dòng đang chờ duyệt có hai nút [Duyệt] và [Bác].",
                  "[Bác]: mở hộp phê duyệt ở chế độ từ chối với ghi chú gợi ý \"Từ chối: vượt quá tỷ lệ hao hụt cho phép\"; sửa ghi chú nếu cần rồi bấm [Xác Nhận Từ Chối], hệ thống báo \"Đã từ chối yêu cầu cấp bù!\"."
               ]
            },
            {
               "name": "Lệnh sản xuất › tab 3. Kế hoạch khuôn kẽm — các nút trên tab",
               "steps": [
                  "[Quét & đồng bộ]: đọc các công đoạn của lệnh để tạo các dòng khuôn còn thiếu, cập nhật mã khuôn và tự gán khuôn có sẵn trong kho nếu khớp; nút khóa khi kế hoạch lệnh đã khóa.",
                  "[Quét Quy Trình & Tự Động Tạo Danh Mục Khuôn]: hiện khi lệnh chưa có dòng khuôn hoặc kẽm nào, làm việc giống [Quét & đồng bộ].",
                  "[Xem chi tiết khuôn trong kho] (biểu tượng con mắt): mở trang chi tiết của khuôn trong kho mà dòng đang dùng; chỉ hiện khi dòng đã gắn với một khuôn trong kho.",
                  "[Chọn khuôn cũ có sẵn từ kho] (biểu tượng kính lúp): hiện trên dòng khuôn chưa sẵn sàng, mở hộp chọn một khuôn đã có trong kho để dùng lại cho lệnh.",
                  "Khi chọn khuôn cũ, hệ thống chặn khuôn đang hỏng, đang bảo dưỡng, chờ nghiệm thu hoặc đã thanh lý, và chặn khuôn khác loại với dòng của lệnh.",
                  "[Xóa dòng khuôn này]: xóa dòng khuôn khỏi kế hoạch của lệnh sau khi xác nhận; nút khóa khi kế hoạch lệnh đã khóa.",
                  "[Xóa dòng kẽm này]: xóa dòng kẽm khỏi kế hoạch của lệnh sau khi xác nhận; không hiện trên các dòng kẽm cũ chỉ hiển thị để tham khảo và khóa khi kế hoạch lệnh đã khóa."
               ]
            },
            {
               "name": "Lệnh sản xuất › tab 4. Kế hoạch sản xuất — các nút trên đầu bảng và trên dòng công đoạn",
               "steps": [
                  "[Sửa nhanh KHSX]: bật chế độ sửa trực tiếp trên bảng; các thay đổi về Máy, Setup, Tốc độ, % Gối đầu, lịch bắt đầu và hạn chót tự lưu ngay khi rời ô, bấm [Xong / Đóng] để tắt.",
                  "[Lập lịch gối đầu]: mở danh sách chọn cách xếp lịch tự động cho các công đoạn vào khe trống của máy theo ca.",
                  "Trong [Lập lịch gối đầu], chọn \"Từ Deadline giao hàng (Backward)\" để tính ngày bắt đầu muộn nhất vẫn kịp hạn giao, hoặc \"Từ Ngày triển khai (Forward)\" để xếp từng công đoạn vào khe trống sớm nhất, gối đầu với công đoạn trước.",
                  "[Nạp Master]: xóa các công đoạn chưa chạy của lệnh và nạp lại quy trình từ sản phẩm gốc; hệ thống báo lỗi nếu lệnh chưa gắn sản phẩm hoặc sản phẩm chưa có quy trình sản xuất.",
                  "[Sửa nhanh KHSX], [Lập lịch gối đầu] và [Nạp Master] đều bị khóa khi kế hoạch lệnh đã khóa.",
                  "[Chỉnh sửa cấu hình công đoạn] (biểu tượng bút trên dòng công đoạn): mở hộp sửa toàn bộ thông tin của công đoạn đó; bị khóa khi kế hoạch lệnh đã khóa."
               ]
            },
            {
               "name": "Lệnh sản xuất › tab 5. KCS & Đóng gói — các nút trên tab",
               "steps": [
                  "[Xem tất cả IPQC]: ở khung Kiểm soát công đoạn, mở danh sách phiếu kiểm tra công đoạn của toàn hệ thống.",
                  "[Xem tất cả NCR]: ở khung Sự cố chất lượng, mở danh sách phiếu xử lý sự cố NCR.",
                  "Nút [Lập NCR] mở hộp \"Khởi Tạo Phiếu Xử Lý Sự Cố NCR\" để ghi nhận lỗi phát sinh trong lúc sản xuất lệnh.",
                  "[Xác Nhận Kích Hoạt NCR]: tạo phiếu NCR gắn với lệnh, gồm mô tả, mức độ, số phế phẩm và chi phí thiệt hại; nút mờ khi chưa nhập \"Mô tả tóm tắt sự cố\"."
               ]
            },
            {
               "name": "Tạo lệnh sản xuất — Bể đơn hàng chờ lệnh và chọn bài bình",
               "steps": [
                  "[Nhập form thủ công]: bỏ qua bước chọn mặt hàng, mở thẳng form nhập thông số lệnh để tự điền.",
                  "[Chọn/Bỏ chọn tất cả hợp lệ]: chọn một lần mọi dòng đang hiển thị đủ điều kiện lập lệnh; nếu tất cả đã được chọn thì bấm lại để bỏ chọn; dòng \"Chưa đủ quy cách\" không bị chọn.",
                  "[Bình file cho mặt hàng này]: trên dòng hợp lệ, mở bước Bình file để tạo bài bình cho mặt hàng; nếu dòng đã có bài bình, nút dùng để sửa hoặc ghép lại bài bình đó.",
                  "Nút [Xem theo bài bình] mở hộp \"Chọn Sản Phẩm / Bài Bình Đã Bình File\" liệt kê các bài bình đã sẵn sàng lập lệnh.",
                  "[Chọn Bài Này]: lấy toàn bộ mặt hàng của bài bình đó đưa vào lệnh và tự nạp thông số; bài có nhiều mặt hàng được lập thành lệnh ghép.",
                  "[Tự nhập thông số thủ công]: hiện khi hộp chọn bài bình không có kết quả, chuyển sang form để tự điền thông số lệnh."
               ]
            },
            {
               "name": "Tạo / Sửa lệnh sản xuất — Hợp phần, Quy trình, Khuôn và Bài bình",
               "steps": [
                  "[Thêm hợp phần]: thêm một dòng hợp phần mới vào bảng cấu trúc hợp phần, có thể chọn hợp phần cha và dòng sản phẩm của lệnh.",
                  "[Xóa hợp phần]: xóa dòng hợp phần; các hợp phần con của nó chuyển lên cấp gốc; nút mờ khi lệnh chỉ còn một hợp phần.",
                  "Khi rê chuột vào nút xóa thấy \"[Hợp phần đã có công đoạn hoặc định mức vật tư, xóa các dòng đó trước]\" thì cần xóa công đoạn và vật tư của hợp phần đó trước rồi mới xóa được.",
                  "[Tải & Khử trùng lặp]: nạp quy trình công đoạn từ sản phẩm (lệnh ghép thì gộp quy trình của mọi sản phẩm), bỏ công đoạn trùng và sắp theo thứ tự công nghệ; nút mờ khi chưa chọn sản phẩm.",
                  "[Tải khuôn từ Sản phẩm]: nạp các khuôn bế đã liên kết với sản phẩm (dùng lại) và gợi ý thêm khuôn ép nhũ, khuôn thúc nổi nếu sản phẩm có; nếu sản phẩm chưa có khuôn, hệ thống nhắc thêm thủ công.",
                  "[Thư Viện Mẫu]: mở hộp \"Chọn Bản Bình Mẫu Từ Thư Viện Chế Bản\" để lấy ảnh và thông số bài bình (khổ in, số con, nhíp) có sẵn cho bài bình của lệnh."
               ]
            },
            {
               "name": "Tạo / Sửa lệnh sản xuất — Kế hoạch vật tư tự tính theo khổ in",
               "steps": [
                  "[Tự động tính lại theo Khổ in]: tính lại giấy in, màng cán và vật tư bồi theo khổ in hiện tại; các chỉnh tay trước đó trên bảng sẽ bị thay bằng số tự tính.",
                  "[Đổi Khổ ngang] / [Đổi Khổ dọc]: trên dòng màng cán, đổi khổ màng giữa khổ ngang và khổ dọc của tờ in (trừ 5mm), tự cập nhật khổ và mã màng.",
                  "[Khôi phục tính tự động cho dòng này] (biểu tượng quay lại): hiện trên dòng đã sửa tay, bỏ phần sửa tay của riêng dòng đó và tính lại tự động.",
                  "Các nút trên bảng vật tư không hiện khi lệnh đã khóa."
               ]
            },
            {
               "name": "Lệnh sản xuất › Hàng Chờ CTP — quay về danh sách",
               "steps": [
                  "[DS Lệnh SX]: trên màn Hàng Chờ CTP, quay về danh sách lệnh sản xuất."
               ]
            },
            {
               "name": "Lệnh sản xuất — Thêm / xoá công đoạn ở tab Kế hoạch sản xuất",
               "steps": [
                  "Tab 4. Kế hoạch sản xuất › [Thêm công đoạn]: nhập Tên công đoạn, Thuộc thành phần, Thứ tự, Số lượng chuẩn (Định mức), Bù hao (%), Yêu cầu kỹ thuật; công đoạn có khuôn / kẽm chọn tình trạng Làm mới, Dùng lại hoặc Dùng lại có chỉnh sửa.",
                  "Biểu tượng [Xóa công đoạn] trên dòng công đoạn → hộp Xóa công đoạn (không hoàn tác được) → xác nhận để xoá công đoạn khỏi lệnh.",
                  "Không xoá được công đoạn đã có nhật ký hoặc sản lượng: Công đoạn … đã có nhật ký / sản lượng — không xoá được. Huỷ hoặc điều chỉnh nhật ký sản xuất trước.",
                  "Hai nút mờ khi kế hoạch lệnh đã khoá."
               ]
            },
            {
               "name": "Lệnh sản xuất — Vật tư phụ, thêm định mức và sửa bù hao ở tab Kế hoạch vật tư",
               "steps": [
                  "Tab 2. Kế hoạch vật tư › khung Vật tư phụ (cột Mã / Tên Vật tư, Công đoạn, Thành phần, SL cần, Bù hao chạy, Tổng cần, Hạn cần VT, Tiến Độ Cấp Phát).",
                  "[Bóc tách]: tự thêm vật tư phụ theo từng công đoạn của lệnh, báo số vật tư đã bổ sung; nếu các công đoạn đã đủ định mức thì báo không cần bổ sung.",
                  "[Thêm vật tư] → hộp Thêm Vật Tư / Định Mức Phụ Cho Lệnh Sản Xuất: chọn Công đoạn áp dụng, Vật tư từ kho, (vật tư cán màng nhập Cạnh ngắn khổ in, Số tờ in chạy máy, chọn cán 2 mặt), Quy cách / Diễn giải, Số lượng (Net), Đơn vị, Bù hao (%) → [Lưu Định Mức].",
                  "Biểu tượng [Sửa bù hao] trên dòng vật tư: sửa số tờ bù hao bài (setup) và % bù hao chạy rồi lưu. Nút mờ khi kế hoạch đã khoá hoặc dòng đã cấp vật tư.",
                  "Vật tư đã xuất kho thì không sửa / xoá định mức: Vật tư đã được xuất kho, không thể sửa/xóa."
               ]
            },
            {
               "name": "Lệnh sản xuất — Lưu & Duyệt Ban Hành từ form, bỏ dòng kế hoạch vật tư đã có đơn mua",
               "steps": [
                  "Trên form lập / sửa lệnh, [Lưu & Duyệt Ban Hành] kiểm tồn kho theo định mức trước khi ban hành; thiếu vật tư thì hiện cảnh báo Cảnh báo tồn kho: Thiếu n mã vật tư — Yêu cầu tạo phiếu mua hàng, lệnh vẫn được ban hành. Muốn chọn tạo đề xuất mua ngay, dùng [Duyệt Ban Hành] trên trang chi tiết lệnh (hộp Cảnh báo thiếu vật tư).",
                  "Khi lưu form, không bỏ được dòng kế hoạch vật tư đã có đơn mua: Kế hoạch vật tư đã có đơn mua (…) — huỷ đơn mua trước khi bỏ dòng kế hoạch."
               ]
            },
            {
               "name": "Lệnh sản xuất — Tái đồng bộ Báo Giá và đổi trạng thái hàng loạt",
               "steps": [
                  "Chi tiết lệnh › [Thao tác] › [Tái đồng bộ Báo Giá]: nạp lại định mức vật tư và công đoạn từ dự toán gốc của lệnh.",
                  "Bị chặn khi: lệnh không tạo từ dự toán (thiếu mã dự toán), không tìm thấy dự toán gốc, vật tư đã xuất kho, đã có yêu cầu mua hàng đang xử lý, hoặc lệnh đã có nhật ký sản xuất / phiếu IPQC. Lệnh lập từ đơn hàng thông thường không có dự toán nên thường không dùng nút này.",
                  "Danh sách Lệnh sản xuất: tích chọn nhiều lệnh → [Bắt đầu chạy] (chỉ bật khi mọi lệnh đã chọn đều Đã ban hành) hoặc [Tạm dừng] → xác nhận. Lệnh nào không đổi được trạng thái thì bị bỏ qua và báo lý do theo từng lệnh, các lệnh còn lại vẫn đổi."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "Mới tạo",
               "to": "Bản nháp",
               "action": "[Lưu nháp]",
               "allowedRoles": "Có quyền Thêm Lệnh sản xuất"
            },
            {
               "from": "Mới tạo / Bản nháp",
               "to": "Chờ duyệt ban hành",
               "action": "[Lưu] hoặc [Tạo Lệnh SX]",
               "allowedRoles": "Có quyền Thêm / Sửa Lệnh sản xuất"
            },
            {
               "from": "Mới tạo (từ đơn hàng)",
               "to": "Đã lên KH",
               "action": "Đơn hàng › [Lập Lệnh SX] › [Tạo Lệnh SX 1-Chạm]",
               "allowedRoles": "Có quyền Thêm Lệnh sản xuất"
            },
            {
               "from": "Mới tạo / Bản nháp",
               "to": "Đã phát hành",
               "action": "[Lưu & Duyệt Ban Hành]",
               "allowedRoles": "Có quyền Duyệt Lệnh sản xuất"
            },
            {
               "from": "Bản nháp / Chờ duyệt ban hành",
               "to": "Đã lên KH",
               "action": "Bấm bước Đã lên KH trên thanh trạng thái (tự chốt kế hoạch)",
               "allowedRoles": "Có quyền Sửa Lệnh sản xuất"
            },
            {
               "from": "Bản nháp / Chờ duyệt ban hành / Chế bản / Chế bản xong / Sẵn sàng lên KH / Đã lên KH",
               "to": "Đã phát hành",
               "action": "[Duyệt Ban Hành] (kiểm tra thiếu vật tư)",
               "allowedRoles": "Có quyền Duyệt Lệnh sản xuất"
            },
            {
               "from": "Đã phát hành",
               "to": "Đang SX",
               "action": "[Bắt đầu], hoặc xưởng bắt đầu công đoạn đầu tiên",
               "allowedRoles": "Có quyền Sửa Lệnh sản xuất / Xưởng"
            },
            {
               "from": "Đang SX",
               "to": "Tạm ngưng",
               "action": "[Thao tác] → [Tạm dừng lệnh] (bắt buộc lý do)",
               "allowedRoles": "Có quyền Sửa Lệnh sản xuất"
            },
            {
               "from": "Lệnh đang chạy, chưa in",
               "to": "Tạm dừng",
               "action": "[Bình lại] → [Gửi Yêu Cầu Bình Lại]",
               "allowedRoles": "Có quyền Sửa Lệnh sản xuất"
            },
            {
               "from": "Tạm ngưng / Tạm dừng",
               "to": "Đang SX",
               "action": "[Tiếp tục] (bị chặn nếu còn dòng chờ bình lại)",
               "allowedRoles": "Có quyền Sửa Lệnh sản xuất"
            },
            {
               "from": "Đang SX",
               "to": "Hoàn thành",
               "action": "[Hoàn thành]",
               "allowedRoles": "Có quyền Sửa Lệnh sản xuất"
            },
            {
               "from": "Mọi trạng thái trừ Hoàn thành / Đã đóng / Đã hủy",
               "to": "Đã hủy",
               "action": "[Thao tác] → [Hủy lệnh] (bắt buộc lý do)",
               "allowedRoles": "Có quyền Sửa Lệnh sản xuất"
            },
            {
               "from": "Bước không được phép (VD Đã phát hành → Hoàn thành)",
               "to": "Giữ nguyên",
               "action": "Bước mờ trên thanh trạng thái; nếu gửi lên, hệ thống báo lý do và các bước được phép",
               "allowedRoles": "Mọi người"
            },
            {
               "from": "Đang SX",
               "to": "Đã sản xuất",
               "action": "Tự động khi mọi công đoạn của lệnh Hoàn thành",
               "allowedRoles": "Hệ thống"
            },
            {
               "from": "Đã sản xuất",
               "to": "Hoàn thành",
               "action": "Tự động khi tổng SL Đạt của KCS thành phẩm (FQC) đạt SL kế hoạch của lệnh",
               "allowedRoles": "Hệ thống (sau khi QC lập FQC)"
            },
            {
               "from": "Đang SX",
               "to": "Hoàn thành",
               "action": "Nút [Hoàn thành] trên trang chi tiết lệnh — chỉ hiện khi lệnh đang Đang SX; lệnh đã ở Đã sản xuất thì chờ FQC tự chuyển",
               "allowedRoles": "Người có quyền sửa Lệnh sản xuất"
            },
            {
               "from": "Hoàn thành",
               "to": "Đã đóng",
               "action": "Quy trình cho phép nhưng hiện chưa có nút trên màn hình",
               "allowedRoles": "—"
            }
         ],
         "actionLinks": [
            {
               "from": "Đơn hàng (Kinh doanh)",
               "to": "Lệnh sản xuất",
               "action": "Lập lệnh nhanh từ đơn đã duyệt",
               "how": "Chi tiết đơn → [Lập Lệnh SX] → [Tạo Lệnh SX 1-Chạm] hoặc [Mở Form Chi Tiết]"
            },
            {
               "from": "Bình file Prepress",
               "to": "Khởi tạo Lệnh Sản Xuất",
               "action": "Lập lệnh từ bài bình",
               "how": "Lệnh sản xuất → [Chờ Lập Lệnh] → [Lập Lệnh Sản Xuất F0]"
            },
            {
               "from": "Lệnh sản xuất",
               "to": "Bình file",
               "action": "Yêu cầu bình lại",
               "how": "Chi tiết lệnh → [Bình lại] → [Gửi Yêu Cầu Bình Lại]"
            },
            {
               "from": "Lệnh sản xuất",
               "to": "Mua hàng (đề nghị mua)",
               "action": "Đề nghị mua phần thiếu",
               "how": "[Duyệt Ban Hành] → hộp Cảnh báo thiếu vật tư → [Tạo PR & Ban hành]"
            },
            {
               "from": "Lệnh sản xuất",
               "to": "Kho vật tư",
               "action": "Cấp vật tư cho lệnh",
               "how": "Tab 2. Kế hoạch vật tư → [Xuất kho] hoặc [Cấp vật tư] trên dòng"
            },
            {
               "from": "Lệnh sản xuất",
               "to": "Xưởng sản xuất › Kế hoạch sản xuất",
               "action": "Lệnh Đã phát hành xuống xưởng",
               "how": "Tự động sau [Duyệt Ban Hành]; xem công đoạn ở tab 4. Kế hoạch sản xuất"
            },
            {
               "from": "Lệnh sản xuất",
               "to": "ĐH Gia công",
               "action": "Thuê ngoài một phần công đoạn",
               "how": "[Thao tác] → [Đặt gia công (một phần)]"
            }
         ],
         "quickActions": [
            {
               "action": "Lập Lệnh SX",
               "description": "Nút trên chi tiết đơn hàng; [Tạo Lệnh SX 1-Chạm] tạo lệnh Đã lên KH cho các dòng còn số lượng."
            },
            {
               "action": "Duyệt Ban Hành",
               "description": "Nút xanh trên chi tiết lệnh, ban hành xuống xưởng sau khi kiểm tra thiếu vật tư."
            },
            {
               "action": "In Lệnh SX hàng loạt",
               "description": "Tích nhiều dòng trên danh sách rồi bấm [In Lệnh SX]."
            },
            {
               "action": "Lọc nhanh theo mức khẩn",
               "description": "Bấm thẻ LSX Hỏa Tốc, LSX Gấp, Cận Hạn Giao, Quá Hạn."
            }
         ],
         "inlineViews": [
            {
               "name": "Hộp Lập Kế Hoạch / Lệnh Sản Xuất",
               "trigger": "[Lập Lệnh SX] trên chi tiết đơn hàng",
               "description": "Chọn dòng, nhập Khổ in, Số con (Ups), Bù hao %; xem Đã lên / Còn lại và số tờ in ước tính."
            },
            {
               "name": "Khối Sẵn sàng triển khai",
               "trigger": "Đầu trang chi tiết lệnh",
               "description": "Vật tư (Đã cấp đủ / Đủ vật tư, chờ cấp / Còn n dòng chờ cấp), Khuôn & kẽm, KCS & đóng gói, Giao hàng."
            },
            {
               "name": "Hộp Cảnh báo thiếu vật tư",
               "trigger": "[Duyệt Ban Hành] khi còn thiếu",
               "description": "Danh sách vật tư thiếu và lựa chọn tạo đề nghị mua hoặc bỏ qua."
            },
            {
               "name": "Thảo luận & Ghi chú / Tệp đính kèm / Lịch sử cập nhật",
               "trigger": "Cuối trang chi tiết lệnh",
               "description": "Trao đổi, đính kèm file và xem ai đổi gì, trạng thái cũ → mới."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/11_production_orders_list_settled.png",
               "caption": "Hình 08.1 — Danh sách Lệnh sản xuất với hàng chip trạng thái và các cột tiến độ công đoạn"
            },
            {
               "src": "/guide-screenshots/13_po_detail_tab1_area_weighted_gangrun.png",
               "caption": "Hình 08.2 — Chi tiết Lệnh sản xuất, tab 1. Danh mục sản phẩm với tỷ trọng phân bổ theo diện tích cho lệnh ghép"
            }
         ],
         "forms": [
            {
               "code": "BM-SX-01",
               "name": "Lệnh sản xuất (in từ [In LSX] / [In Lệnh SX])"
            },
            {
               "code": "BM-KHSX-01",
               "name": "Báo cáo kế hoạch sản xuất ([Báo Cáo KHSX])"
            },
            {
               "code": "BM-KHO-02A",
               "name": "Bảng kê nhặt hàng nguyên vật liệu ([In bảng kê] ở tab 2. Kế hoạch vật tư)"
            }
         ],
         "notes": [
            "Giai đoạn golive các vai trò nghiệp vụ được mở đủ quyền; phân quyền thật chỉnh ở Hệ Thống & Quy Trình › Phân quyền. Kiểm tra lại các dòng phân quyền ở trên sau khi chỉnh vai trò.",
            "Lệnh Đã chốt KH không sửa, không xóa được; mở khóa trước khi chỉnh.",
            "Bù hao 0% là hợp lệ: lệnh không sản xuất dư và giao hàng không vượt SL đặt.",
            "Hủy hoặc xóa lệnh trả lại số lượng cho dòng đơn hàng; muốn sản xuất lại thì lập lệnh mới.",
            "[Bỏ qua & Ban hành] vẫn ban hành dù thiếu vật tư; theo dõi mua hàng ở Kế hoạch Vật tư.",
            "Không cấp vật tư cho lệnh Bản nháp, Chờ duyệt ban hành, Hoàn thành, Đã hủy hoặc Đã đóng."
         ],
         "uatChecklist": [
            {
               "id": "KH-08-01",
               "item": "Lập lệnh nhanh từ đơn hàng Sale đã duyệt với bù hao 0%",
               "standard": "Tạo lệnh Đã lên KH; SL Kế Hoạch bằng SL đặt (không cộng dư); đơn hàng hiện Đã lên bằng SL đặt, Còn lại 0.",
               "method": "1) Kinh doanh › Đơn hàng, mở đơn thử đã duyệt (VD 1 dòng Hộp Ivory 300gsm 10.000 cái); 2) Bấm [Lập Lệnh SX]; 3) Nhập Khổ in 650x860, Số con (Ups) 4, Bù hao 0; 4) Bấm [Tạo Lệnh SX 1-Chạm]; 5) Mở lệnh vừa tạo, xem trạng thái và tab 1. Danh mục sản phẩm."
            },
            {
               "id": "KH-08-02",
               "item": "Chặn lập lệnh vượt số lượng đơn",
               "standard": "Lần thứ hai báo Không còn số lượng để lập lệnh: … đã lên lệnh đủ …; không tạo thêm lệnh.",
               "method": "1) Dùng lại đơn ở KH-08-01; 2) Bấm [Lập Lệnh SX] lần nữa, chọn đúng dòng đó; 3) Bấm [Tạo Lệnh SX 1-Chạm]; 4) Đọc thông báo; 5) Kiểm tra danh sách Lệnh sản xuất không có lệnh mới."
            },
            {
               "id": "KH-08-03",
               "item": "Lập Lệnh Ghép đúng điều kiện và bị chặn khi khác kiểu cán màng",
               "standard": "Hai mặt hàng cùng đơn, cùng giấy, cùng cán màng tạo được 1 lệnh ghép; mặt hàng khác cán màng bị báo Không thể ghép bài: Các sản phẩm khác quy trình cán màng.",
               "method": "1) Kế hoạch › Lệnh sản xuất › [Thêm LSX]; 2) Tích 2 dòng cùng đơn, cùng Ivory 300gsm, cùng cán mờ → [Tạo Lệnh Ghép (2)]; 3) Đặt lại bù hao / số con từng mặt hàng → [Lưu]; 4) Quay lại bể chờ, tích 1 dòng cán mờ + 1 dòng cán bóng → bấm ghép; 5) Đọc thông báo."
            },
            {
               "id": "KH-08-04",
               "item": "Bình file ngay trên trang tạo lệnh rồi Tách Lệnh",
               "standard": "Dòng Thiếu khổ in/UPS sau [Lưu & lập lệnh] sang thẳng bước Lệnh sản xuất; Tách Lệnh chỉ nhận số từ 1 tới số còn lại.",
               "method": "1) [Thêm LSX], lọc ⚠️ Cần bổ sung quy cách; 2) Bấm [Bình file] trên dòng, nhập Mã bài bình, Khổ giấy in, số UPS → [Lưu & lập lệnh]; 3) Về bể chờ, chọn dòng khác → [Tách Lệnh], nhập số lớn hơn số còn lại; 4) Nhập lại 3.000 → [Xác Nhận Tách Lệnh] → [Lưu]."
            },
            {
               "id": "KH-08-05",
               "item": "Lưu nháp, Lưu chờ duyệt và quyền xem bản nháp",
               "standard": "[Lưu nháp] ra Bản nháp, người khác không thấy; [Lưu] ra Chờ duyệt ban hành, mọi người thấy.",
               "method": "1) [Thêm LSX], chọn 1 dòng → [Tạo Lệnh Đơn] → [Lưu nháp]; 2) Đăng nhập tài khoản Kế hoạch khác, tìm mã lệnh trên danh sách (không thấy); 3) Quay lại tài khoản đầu, mở lệnh → [Sửa] → [Lưu]; 4) Tài khoản thứ hai lọc Trạng thái SX = Chờ duyệt, thấy lệnh."
            },
            {
               "id": "KH-08-06",
               "item": "Duyệt Ban Hành khi thiếu vật tư, tạo đề nghị mua",
               "standard": "Hiện hộp Cảnh báo thiếu vật tư; [Tạo PR & Ban hành] tạo đề nghị mua Nháp cho vật tư thiếu và lệnh chuyển Đã phát hành; bấm lại không tạo đề nghị mua trùng.",
               "method": "1) Mở lệnh Chờ duyệt ban hành dùng giấy đang hết tồn; 2) Bấm [Duyệt Ban Hành]; 3) Xem bảng vật tư thiếu → [Tạo PR & Ban hành]; 4) Kiểm tra trạng thái lệnh và đề nghị mua bên Mua hàng; 5) Lệnh hiện ở Xưởng sản xuất › Kế hoạch sản xuất."
            },
            {
               "id": "KH-08-07",
               "item": "Từ chối ban hành lệnh chưa có định mức và người không có quyền Duyệt",
               "standard": "Lệnh không định mức báo Không thể ban hành lệnh khi chưa có định mức vật tư hoặc công đoạn nào; tài khoản không có quyền Duyệt bị báo Thao tác này cần quyền Duyệt, trạng thái giữ nguyên.",
               "method": "1) Tạo lệnh nháp, xóa hết dòng ở tab 2 và tab 4 → [Lưu nháp]; 2) Bấm [Duyệt Ban Hành], đọc thông báo; 3) Đăng nhập vai trò đã bỏ quyền Duyệt Lệnh sản xuất, mở lệnh Chờ duyệt ban hành khác → [Duyệt Ban Hành]; 4) Xác nhận trạng thái không đổi."
            },
            {
               "id": "KH-08-08",
               "item": "Thanh trạng thái chỉ cho bước hợp lệ",
               "standard": "Lệnh Đã phát hành: bước Hoàn thành mờ, không bấm được; bấm Đang SX mở hộp xác nhận và chuyển đúng.",
               "method": "1) Mở lệnh Đã phát hành; 2) Rê chuột / bấm bước Hoàn thành trên thanh trạng thái; 3) Bấm [Bắt đầu] → [Xác nhận]; 4) Kiểm tra trạng thái Đang SX và tab Lịch sử cập nhật ghi Trạng thái: Đã phát hành → Đang SX."
            },
            {
               "id": "KH-08-09",
               "item": "Tạm dừng bắt buộc lý do, Tiếp tục",
               "standard": "Nút [Xác nhận] mờ khi chưa nhập lý do; sau xác nhận lệnh Tạm ngưng, lý do hiện trong Thảo luận & Ghi chú; [Tiếp tục] về Đang SX.",
               "method": "1) Mở lệnh Đang SX → [Thao tác] → [Tạm dừng lệnh]; 2) Để trống lý do, xem nút [Xác nhận]; 3) Nhập Thiếu giấy → [Xác nhận]; 4) Xem tab Thảo luận & Ghi chú; 5) Bấm [Tiếp tục] → [Xác nhận]."
            },
            {
               "id": "KH-08-10",
               "item": "Hủy lệnh dừng theo dây chuyền",
               "standard": "Lệnh Đã hủy; dòng đơn hàng có lại số Còn lại; công đoạn còn mở ở tab 4 là Đã hủy và rời lịch máy; vật tư chưa nhận của lệnh không còn trong Kế hoạch Vật tư; nếu có đơn mua đang mở thì hiện thông báo vàng nêu mã đơn mua.",
               "method": "1) Mở lệnh Đã phát hành chưa chạy (có đơn mua từ kế hoạch); 2) [Thao tác] → [Hủy lệnh], nhập lý do → [Xác nhận]; 3) Mở tab 4. Kế hoạch sản xuất; 4) Mở Kế hoạch › Kế hoạch Vật tư, tìm mã lệnh; 5) Mở đơn hàng gốc, bấm [Lập Lệnh SX] xem Còn lại."
            },
            {
               "id": "KH-08-11",
               "item": "Xóa lệnh: được với lệnh mới, bị chặn với lệnh đã có sản lượng",
               "standard": "Lệnh Bản nháp xóa xong nằm trong Thùng rác và số lượng trả về đơn; lệnh đã có nhật ký sản xuất báo … không xoá được. Dùng Huỷ lệnh để dừng lệnh.",
               "method": "1) Mở lệnh Bản nháp → [Thao tác] → [Xóa lệnh sản xuất] → xác nhận; 2) Danh sách › tab Thùng rác, tìm mã lệnh; 3) Mở lệnh Đang SX đã ghi sản lượng (mở khóa KH nếu nút xóa mờ) → [Thao tác] → [Xóa lệnh sản xuất]; 4) Đọc thông báo."
            },
            {
               "id": "KH-08-12",
               "item": "Khóa thông số sau phát hành",
               "standard": "Đổi SL hoặc số con của lệnh Đã phát hành bị từ chối kèm lý do Tạm dừng hoặc huỷ lệnh rồi lập lệnh mới; dữ liệu không đổi.",
               "method": "1) Mở lệnh Đã phát hành; nếu [Sửa] mờ thì [Thao tác] → [Mở khóa KH]; bấm [Sửa]; 2) Tab 1 đổi số con từ 4 thành 6; 3) Bấm [Cập nhật]; 4) Đọc thông báo, mở lại lệnh kiểm tra số con vẫn là 4."
            },
            {
               "id": "KH-08-13",
               "item": "Link về chứng từ gốc và lịch sử trên chi tiết lệnh",
               "standard": "Bấm Khách hàng, Đơn hàng / PO, sản phẩm mở đúng bản ghi; cuối trang có Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật, Tạo lúc / Cập nhật lúc kèm người thao tác.",
               "method": "1) Mở một lệnh lập từ đơn; 2) Bấm tên khách hàng, quay lại; 3) Bấm mã đơn hàng, quay lại; 4) Bấm tên sản phẩm ở tab 1; 5) Kéo cuối trang, thêm bình luận và 1 ảnh đính kèm, mở Lịch sử cập nhật."
            },
            {
               "id": "KH-08-14",
               "item": "Tìm và lọc danh sách, ô chọn lệnh ở form khác",
               "standard": "Ô tìm trên thanh tiêu đề tìm theo mã lệnh; lọc Trạng thái SX và thẻ Quá Hạn đúng số đếm; lệnh đã hủy không có trong ô chọn lệnh của form mới (VD Đặt gia công).",
               "method": "1) Gõ mã lệnh vào ô tìm kiếm trên đầu trang; 2) Chọn Trạng thái SX = Đang SX; 3) Bấm thẻ Quá Hạn; 4) Mở Kinh doanh › ĐH Gia công › tạo mới, mở ô Lệnh sản xuất, gõ mã lệnh đã hủy ở KH-08-10."
            },
            {
               "id": "KH-08-15",
               "item": "Kiểm tra trên điện thoại 390px",
               "standard": "Tab trên cùng cuộn ngang, bảng cuộn ngang không vỡ chữ; chi tiết lệnh có thanh nút dưới tối đa 4 nút và nút … chứa nút còn lại; [Duyệt Ban Hành] bấm được.",
               "method": "1) Mở trình duyệt điện thoại (hoặc chế độ thiết bị 390px); 2) Bấm Lệnh SX ở thanh dưới; 3) Cuộn ngang tab và bảng; 4) Mở một lệnh Chờ duyệt ban hành; 5) Bấm … xem [Thao tác], bấm [Duyệt Ban Hành]."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "Kế Hoạch Sản Xuất (PLANNER) — đủ quyền Thêm / Sửa / Xóa / Duyệt khi golive",
               "createTest": "Đơn hàng › [Lập Lệnh SX] › [Tạo Lệnh SX 1-Chạm]; Lệnh sản xuất › [Thêm LSX] › [Tạo Lệnh Đơn] › [Lưu].",
               "readTest": "Lọc Trạng thái SX, mở tab [Tiến Độ CĐ], mở chi tiết xem 5 tab và khối Sẵn sàng triển khai.",
               "updateTest": "[Sửa] lệnh Chờ duyệt ban hành → [Cập nhật]; [Duyệt Ban Hành]; [Chốt kế hoạch] / [Mở khóa KH].",
               "deleteTest": "Xóa lệnh Bản nháp, kiểm tra Thùng rác; thử xóa lệnh đã có nhật ký sản xuất để thấy bị chặn.",
               "expectedResult": "Mọi thao tác thành công đúng trạng thái; thao tác bị chặn đều có thông báo lý do."
            },
            {
               "roleGroup": "Vai trò bỏ quyền Duyệt Lệnh sản xuất (cấu hình ở Phân quyền)",
               "createTest": "[Thêm LSX] → form không có [Lưu & Duyệt Ban Hành], chỉ [Lưu nháp] / [Lưu].",
               "readTest": "Xem danh sách và chi tiết bình thường.",
               "updateTest": "[Duyệt Ban Hành] và [Chốt kế hoạch] bị báo Thao tác này cần quyền Duyệt; [Bắt đầu], [Tạm dừng lệnh], [Hủy lệnh] vẫn làm được.",
               "deleteTest": "Xóa lệnh Bản nháp được nếu còn quyền Xóa.",
               "expectedResult": "Không ban hành được lệnh; trạng thái lệnh không đổi sau khi bị từ chối."
            },
            {
               "roleGroup": "Vai trò chỉ có quyền Xem Lệnh sản xuất",
               "createTest": "Không thấy nút [Thêm LSX].",
               "readTest": "Xem danh sách, chi tiết, [In LSX], [Xuất Excel].",
               "updateTest": "Bấm bước trên thanh trạng thái hoặc [Sửa] bị từ chối.",
               "deleteTest": "Không thấy [Xóa] trên thanh tác vụ khi tích chọn.",
               "expectedResult": "Không thay đổi được dữ liệu lệnh; bản nháp riêng của người khác không hiện."
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 09. Kế Hoạch Vật Tư (MRP), Đơn Mua Từ Kế Hoạch, Cấp Phát Vật Tư & Giấy
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "paper_allocation",
         "aliases": [
            "material-planning",
            "material_planning",
            "supply",
            "mrp",
            "planning/paper-allocation",
            "paper-allocation",
            "material-supply-board"
         ],
         "title": "09. Kế Hoạch Vật Tư (MRP), Đơn Mua Từ Kế Hoạch, Cấp Phát Vật Tư & Giấy",
         "icon": "Package",
         "isoRef": "QT-KH-02",
         "purpose": "Hướng dẫn dùng Kế hoạch › Kế hoạch Vật tư để gom nhu cầu vật tư của các Lệnh sản xuất, bấm [Cân Đối MRP] so với tồn kho và hàng đang về, lập đơn mua hàng hoặc đề nghị mua (PR) cho phần thiếu, theo dõi hàng về qua IQC và nhập kho, cấp vật tư cho lệnh ([Cấp Đủ], [Cấp vật tư], [Xuất kho], cấp bù phế phẩm), cấp phát và thu hồi giấy, mực pha dư.",
         "scope": [
            "Phòng Kế hoạch: Cân Đối MRP, lập đơn mua / đề nghị mua từ kế hoạch, tách số lượng, theo dõi nhu cầu theo từng lệnh.",
            "Mua hàng: nhận đơn mua lập từ kế hoạch ở trạng thái Chờ duyệt (Mua hàng › ĐH Mua hàng) để duyệt và đặt hàng.",
            "QC và Kho vật tư: lô vật tư kiểm IQC Đạt hiện ở Kho › Kho Vật tư, tab Chờ nhập kho; nhập kho theo đơn mua làm tăng số đã có của kế hoạch.",
            "Thủ kho, Quản đốc: cấp vật tư cho lệnh, xả phôi, cấp bù, thu hồi giấy dư và mực pha dư.",
            "Màn hình Kế hoạch › Kế hoạch Vật tư có 3 tab: 1. Nhu Cầu Vật Tư, 2. Cấp Phát Giấy, 3. Cấp NVL Sàn Máy; cùng tab 2. Kế hoạch vật tư trong chi tiết Lệnh sản xuất.",
            "Chỉ tính lệnh còn hiệu lực: lệnh đã hủy hoặc đã xóa không còn hiện và không còn nhu cầu vật tư."
         ],
         "references": [
            "ISO 9001:2015 mục 8.1 Hoạch định và kiểm soát việc thực hiện",
            "ISO 9001:2015 mục 8.4 Kiểm soát quá trình, sản phẩm và dịch vụ do bên ngoài cung cấp",
            "ISO 9001:2015 mục 8.5.4 Bảo toàn",
            "Chương 08 Lệnh sản xuất; các chương Mua hàng, Chất lượng (IQC) và Kho vật tư"
         ],
         "terms": [
            {
               "term": "Dòng kế hoạch vật tư",
               "definition": "Nhu cầu một vật tư của một Lệnh sản xuất: số cần, số đã có của lệnh, số cần mua, đơn mua liên kết và trạng thái."
            },
            {
               "term": "Cân Đối MRP",
               "definition": "Tính lại số cần mua cho mọi dòng chưa đặt hàng của lệnh còn hiệu lực. Đã có của dòng = đã cấp cho lệnh + hàng đã nhận theo đơn mua của dòng. Đơn mua lập riêng cho dòng (kể cả Chờ duyệt) giữ chỗ, không tính thiếu lại. Tồn kho chung và đơn mua chung đã duyệt chia một lần cho các lệnh, chỉ dùng để giảm số cần mua."
            },
            {
               "term": "Giữ chỗ đơn mua",
               "definition": "Đơn mua lập từ kế hoạch trừ thẳng vào số cần mua của dòng. Dòng đã đặt đủ không lập thêm đơn mua / đề nghị mua được; hủy, xóa, mở lại hoặc khôi phục đơn mua thì số cần mua tính lại."
            },
            {
               "term": "Đang về",
               "definition": "Số lượng còn chưa về của đơn mua gắn với vật tư của lệnh, kèm ngày hàng về sớm nhất, hiện trên bảng định mức của lệnh ở chế độ Phân Bổ Lệnh SX."
            },
            {
               "term": "Cấp vật tư",
               "definition": "Xuất vật tư từ kho vật tư ra sàn máy cho lệnh theo tổng số lượng tồn (không chọn lô); tạo phiếu xuất đã hoàn tất cho lệnh."
            },
            {
               "term": "Xuất kho",
               "definition": "Mở form Phiếu xuất kho vật tư điền sẵn vật tư, số còn phải cấp và ghi chú Xuất cho LSX; lưu và hoàn tất ở phân hệ Kho."
            },
            {
               "term": "Cấp bù phế phẩm",
               "definition": "Yêu cầu thêm vật tư do hư hỏng trong sản xuất; phải được duyệt mới tăng số cần của dòng, sau đó kho cấp như bình thường."
            },
            {
               "term": "ĐÃ VỀ KHO, CHỜ CẤP",
               "definition": "Hàng mua theo đơn của dòng kế hoạch đã nhập kho nhưng chưa xuất cho lệnh. Chỉ khi xuất kho thật cho lệnh dòng mới thành ✓ ĐÃ CẤP ĐỦ."
            },
            {
               "term": "Xả phôi",
               "definition": "Xác nhận cắt giấy khổ mua ra khổ in và xuất giấy cho lệnh ở tab Cấp Phát Giấy."
            }
         ],
         "responsibilities": [
            {
               "role": "Nhân viên Kế hoạch",
               "tasks": [
                  "Bấm [Cân Đối MRP], đọc thẻ Đủ Tồn Kho / Thiếu Hụt Cần Mua / Đang Đặt Hàng (PO).",
                  "Lập đơn mua ([Mua], [Tạo ĐMH (n)]) hoặc đề nghị mua ([Tạo PR]) cho dòng thiếu; tách số lượng khi cần mua nhiều đợt.",
                  "Theo dõi từng lệnh ở chế độ Phân Bổ Lệnh SX: Đang về, ngày hàng về, mức sẵn sàng; báo Mua hàng khi hàng trễ."
               ]
            },
            {
               "role": "Mua hàng",
               "tasks": [
                  "Duyệt đơn mua Chờ duyệt lập từ kế hoạch, đặt hàng nhà cung cấp; xử lý đơn mua được cảnh báo khi lệnh bị hủy."
               ]
            },
            {
               "role": "QC (IQC) và Thủ kho vật tư",
               "tasks": [
                  "IQC kiểm lô hàng về; lô Đạt chuyển sang Kho Vật tư › Chờ nhập kho; thủ kho nhập kho ghi đúng đơn mua.",
                  "Cấp vật tư cho lệnh bằng [Cấp Đủ], [Cấp Phát], [Cấp vật tư] hoặc [Xuất kho]; xả phôi, in thẻ pallet, thu hồi giấy dư và mực pha dư."
               ]
            },
            {
               "role": "Quản đốc xưởng",
               "tasks": [
                  "Gửi yêu cầu cấp bù phế phẩm kèm lý do; người có quyền Duyệt Lệnh sản xuất duyệt hoặc từ chối.",
                  "Dùng [Cấp Bù] ở tab Cấp Phát Giấy khi hao hụt giấy vượt định mức; bấm [Đã đủ] ở tab Cấp NVL Sàn Máy khi vật tư đã sẵn sàng."
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "❌",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền các thao tác trên Kế hoạch vật tư."
            },
            {
               "role": "Có quyền Thêm Kế hoạch vật tư và quyền Sửa / Thêm Vật tư",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Thấy [Cân Đối MRP], [Tạo PR], [Mua], [Tạo Đơn Mua Hàng], [Tách số lượng]. Khi bấm, hệ thống kiểm tra thêm quyền Sửa Vật tư (cân đối, lập đơn mua, tách, cấp phát) và quyền Thêm Vật tư (đề nghị mua)."
            },
            {
               "role": "Có quyền Duyệt Lệnh sản xuất",
               "view": "✅",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Duyệt hoặc từ chối yêu cầu cấp bù phế phẩm ở tab 2. Kế hoạch vật tư của lệnh."
            },
            {
               "role": "Chỉ có quyền Xem",
               "view": "👁",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Xem nhu cầu, [In Kế Hoạch], xuất Excel; không thấy nút cân đối, mua, đề nghị mua."
            }
         ],
         "processFlowchart": "graph TD\n    A[Lệnh sản xuất còn hiệu lực có định mức] --> B[Kế hoạch Vật tư]\n    B --> C[Cân Đối MRP]\n    C --> D{Còn số cần mua}\n    D -->|Có| E[Mua / Tạo ĐMH hoặc Tạo PR]\n    E --> F[Đơn mua Chờ duyệt giữ chỗ số cần mua]\n    F --> G[Mua hàng duyệt và đặt hàng]\n    G --> H[Hàng về: IQC Đạt]\n    H --> I[Kho Vật tư tab Chờ nhập kho]\n    I --> J[Nhập kho theo đơn mua: dòng Nhận 1 phần / Đã nhận đủ, ĐÃ VỀ KHO CHỜ CẤP]\n    D -->|Không| K[Cấp phát cho lệnh đã duyệt]\n    J --> K\n    K --> L[Cấp Đủ hoặc Cấp vật tư hoặc Xuất kho]\n    L --> M[Phiếu xuất hoàn tất, dòng ĐÃ CẤP ĐỦ]\n    M --> N{Phát sinh phế phẩm}\n    N -->|Có| O[Cấp bù phế phẩm chờ duyệt]\n    O --> K\n    N -->|Không| P[Thu hồi giấy dư và mực pha dư]\n    A -->|Lệnh bị hủy hoặc xóa| Q[Dòng chưa nhận Đã hủy, ẩn khỏi Kế hoạch Vật tư]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Mở Kế hoạch Vật tư và Cân Đối MRP",
               "detail": "• Kế hoạch › Kế hoạch Vật tư, tab 1. Nhu Cầu Vật Tư, chế độ Tổng Hợp Cần Mua.\n• Thẻ tóm tắt: Đủ Tồn Kho, Thiếu Hụt Cần Mua, Đang Đặt Hàng (PO). Lọc Loại vật tư: Tất Cả Loại VT, Giấy In, Màng Cán, Mực In, Keo Dán, Khuôn & Kẽm, Vật Tư Khác; lọc Vật tư, Trạng thái.\n• Bấm [Cân Đối MRP]: thông báo Đã cân đối cung-cầu MRP cho n dòng kế hoạch. Phát hiện m vật tư thiếu hụt. Lệnh Đã lên KH / Đã phát hành / Đang SX có định mức mà chưa có kế hoạch vật tư được lập tự động. Dòng đã đặt hàng, lệnh đã hủy / hoàn thành / đóng không tính lại.\n• Bấm một dòng mở Chi tiết nhu cầu vật tư: Cần dùng, Tồn kho, Còn thiếu, Nhà cung cấp (link), Ngày cần hàng, các lệnh dùng vật tư (link Xem kế hoạch vật tư của lệnh) và các tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật."
            },
            {
               "step": 2,
               "action": "Lập đơn mua hàng từ kế hoạch",
               "detail": "• Dòng thiếu → [Mua] (hoặc menu … → [Tạo Đơn Mua Hàng]); hoặc tích nhiều dòng → [Tạo ĐMH (n)] trên thanh tác vụ.\n• Hộp Tạo Đơn Mua Hàng Tự Động (MRP Purchase Orders) gom theo nhà cung cấp, mỗi nhà cung cấp một đơn; mỗi dòng kế hoạch thành một dòng đơn mua đúng vật tư, SL Mua điền bằng số cần mua, Ngày giao sau 3 ngày, Đơn Giá theo giá chuẩn hoặc giá mua gần nhất.\n• Dòng chưa có nhà cung cấp phải chọn ở cột Gán NCC; thiếu thì báo Còn n vật tư chưa chọn Nhà Cung Cấp. Vui lòng chọn NCC trước khi tạo PO!\n• [Xác Nhận Tạo Đơn Mua Hàng]: đơn mua tạo ở Chờ duyệt, dòng kế hoạch chuyển Đã đặt hàng và giảm số cần mua; bấm [Xem PO] mở đơn. Dòng đã đặt đủ mà lập lại bị báo … đã đặt mua đủ (không còn số cần mua) — không lập thêm đơn mua."
            },
            {
               "step": 3,
               "action": "Theo dõi hàng về: IQC, nhập kho, cập nhật kế hoạch",
               "detail": "• Mua hàng duyệt đơn (đơn chưa duyệt không nhận hàng được), đặt nhà cung cấp.\n• Hàng về, QC lập phiếu IQC; lô Đạt (kể cả lô lập từ đơn mua) hiện ngay ở Kho › Kho Vật tư, tab Chờ nhập kho; nhập kho xong lô tự rời danh sách.\n• Phiếu nhập ghi đúng đơn mua khi hoàn tất: cộng số đã nhận vào đơn mua (không nhận vượt SL đặt + 5%), cộng số đã có của dòng kế hoạch (Nhận 1 phần / Đã nhận đủ), tăng tồn ở Kho › Mã & Tồn NVL.\n• Hàng này giữ riêng cho lệnh khi Duyệt Ban Hành và hiện ĐÃ VỀ KHO, CHỜ CẤP cho tới khi xuất cho lệnh. Kế hoạch của lệnh đã hủy không được cộng (hàng về kho chung)."
            },
            {
               "step": 4,
               "action": "Theo dõi nhu cầu theo lệnh (Phân Bổ Lệnh SX)",
               "detail": "• Chuyển sang Phân Bổ Lệnh SX; gom Theo Lệnh SX hoặc Theo Ngày Cần VT; lọc ✓ Sẵn sàng, ⚠ Cấp một phần, ⏳ Chờ cấp phát. Chỉ hiện lệnh từ Chế bản xong tới Đang SX (không có lệnh nháp, chờ duyệt, đã hủy).\n• Mỗi lệnh có nhãn ✓ SẴN SÀNG / ⚠ CẤP MỘT PHẦN / ❌ THIẾU HỤT / ⏳ CHỜ CẤP PHÁT, nút [Cấp Đủ] và [Chi tiết] (mở tab vật tư của lệnh).\n• Bảng định mức từng lệnh: nhãn ĐÃ CẤP / ĐÃ ĐẶT / THIẾU / CHỜ CẤP, cột Đơn Mua Hàng, dòng Đang về n kèm ngày hàng về; nút [Mua Hàng] cho dòng thiếu và [Cấp Phát] để xuất ra sàn."
            },
            {
               "step": 5,
               "action": "Cấp vật tư cho lệnh",
               "detail": "• Chỉ cấp cho lệnh đã duyệt và còn chạy; lệnh Bản nháp, Chờ duyệt ban hành, Hoàn thành, Đã hủy, Đã đóng bị báo … chưa duyệt, đã huỷ hoặc đã xong / đóng — không cấp vật tư được.\n• [Cấp Đủ] (theo lệnh): xuất từ kho vật tư đang hoạt động toàn bộ phần còn thiếu, tạo phiếu xuất đã hoàn tất.\n• [Cấp vật tư] (từng dòng ở tab 2. Kế hoạch vật tư của lệnh) hoặc [Cấp Phát]: hộp Cấp Vật Tư, chọn kho vật tư và công đoạn nhận, nhập số lượng (mặc định phần còn thiếu) → [📦 Xác Nhận Xuất Cấp Sàn Xưởng]. Kho tắt Cho phép xuất âm mà thiếu tồn thì báo Kho không đủ tồn (còn x, cần cấp y); kho bật xuất âm (mặc định khi golive) vẫn cấp được, tồn xuống âm và nhập bù sau.\n• [Xuất kho] ở đầu bảng Vật tư in: mở Phiếu xuất kho vật tư điền sẵn. Tích nhiều dòng: dòng còn thiếu → [Xuất kho (n)], 1 dòng đã cấp đủ → [Cấp bù], luôn có [In bảng kê].\n• Nhãn dòng: ✓ ĐÃ CẤP ĐỦ (đã xuất thật), ĐÃ VỀ KHO, CHỜ CẤP, ĐANG CẤP n%, CHƯA CẤP."
            },
            {
               "step": 6,
               "action": "Cấp bù phế phẩm",
               "detail": "• Tab 2. Kế hoạch vật tư của lệnh → [Cấp bù]. Hộp Yêu Cầu Cấp Bù Phế Phẩm / Hư Hỏng Sản Xuất: vật tư, số lượng (> 0), công đoạn gây lỗi, lý do (bắt buộc), ghi chú → [Gửi Yêu Cầu Cấp Bù].\n• Người có quyền Duyệt Lệnh sản xuất mở Phê Duyệt Cấp Bù Phế Phẩm (Quản Đốc), duyệt hoặc từ chối. Duyệt thì số cần của dòng tăng thêm; kho cấp phần bù bằng [Cấp vật tư] hoặc [Xuất kho]. Yêu cầu chờ duyệt hoặc bị từ chối không tính là đã cấp."
            },
            {
               "step": 7,
               "action": "Cấp phát và thu hồi giấy (tab 2. Cấp Phát Giấy)",
               "detail": "• Thẻ: Tất cả lệnh cấp, Chờ xả phôi, Đã xả phôi, Giấy dư thu hồi; bảng theo lệnh với Tờ Net (ĐM), Kho Cấp, Bù Hao, In Chạy, Giấy Dư Thu Hồi, trạng thái phôi.\n• [Xả Phôi]: xác nhận xả phôi, hệ thống tạo phiếu xuất kho giấy. [In Thẻ]: in thẻ pallet phôi giấy.\n• [Cấp Bù]: hộp Cấp Bù Giấy Hao Hụt Phát Sinh, nhập số tờ (+50, +100, +200, +500), lý do → [Xác Nhận Cấp Bù Giấy]; chỉ tăng số tờ bù hao trên lệnh, không tự tạo phiếu kho.\n• [Thu Hồi] / [Thu Hồi Mực]: chọn 📄 Giấy In Dôi Dư (Tờ) hoặc 🎨 Mực Pha Pantone Dư (Kg), nhập số lượng → [Xác Nhận Thu Hồi]; hệ thống tạo phiếu nhập kho đã hoàn tất vào kho vật tư."
            },
            {
               "step": 8,
               "action": "Cấp NVL Sàn Máy (tab 3)",
               "detail": "• Danh sách lệnh đang chuẩn bị vật tư: Chờ xử lý / Đang chuẩn bị / Sẵn sàng. Bấm dòng mở lệnh để cấp.\n• [Đã đủ]: đánh dấu vật tư của lệnh sẵn sàng (cần quyền Sửa Sản xuất)."
            }
         ],
         "subFlows": [
            {
               "name": "Tạo đề nghị mua (PR) từ kế hoạch",
               "steps": [
                  "[Tạo PR] trên đầu trang hoặc trong menu … của dòng.",
                  "Hộp Tạo Yêu Cầu Mua Hàng (PR): Vật tư, Số lượng (> 0), Ngày cần hàng, Lý do/Ghi chú → [Gửi yêu cầu]. Thông báo Đã tạo yêu cầu mua hàng PR-…, trạng thái Chờ duyệt.",
                  "Bị chặn khi dòng đã đặt mua đủ, đã có đề nghị mua đang mở (báo mã đề nghị đó) hoặc lệnh đã hủy / xong."
               ]
            },
            {
               "name": "Tách số lượng",
               "steps": [
                  "Dòng thiếu → … → [Tách số lượng].",
                  "Hộp Tách kế hoạch vật tư: Số lượng cần tách (nhỏ hơn số của dòng gốc), lý do → [Xác nhận tách]. Dòng con mới ở Chờ xử lý."
               ]
            },
            {
               "name": "Xác nhận sẵn sàng hàng loạt",
               "steps": [
                  "Tích các dòng → [Xác nhận Sẵn Sàng (n)] trên thanh tác vụ; dòng chưa Đã nhận đủ chuyển Đã nhận đủ."
               ]
            },
            {
               "name": "Khi đơn mua bị hủy, xóa hoặc mở lại",
               "steps": [
                  "Hủy / xóa đơn mua lập từ kế hoạch: số cần mua của dòng được tính lại, dòng hiện lại nút [Mua] (trừ khi còn đơn mua khác đang chạy).",
                  "Mở lại hoặc khôi phục đơn mua từ Thùng rác: số cần mua giảm lại tương ứng."
               ]
            },
            {
               "name": "Khi lệnh sản xuất bị hủy hoặc xóa",
               "steps": [
                  "Hủy lệnh: dòng kế hoạch chưa nhận đủ chuyển Đã hủy (số cần mua về 0), đề nghị mua đang mở bị từ chối, đơn mua đang mở được ghi chú cảnh báo cho Mua hàng.",
                  "Xóa lệnh: kế hoạch vật tư của lệnh vào Thùng rác cùng lệnh, giải phóng tồn đang giữ.",
                  "Cả hai trường hợp: lệnh không còn hiện ở Tổng Hợp Cần Mua và Phân Bổ Lệnh SX, không còn tính thiếu."
               ]
            },
            {
               "name": "In và Xuất Excel",
               "steps": [
                  "[In Kế Hoạch]: in Kế hoạch vật tư khổ ngang.",
                  "[Xuất Excel]: Mã Vật Tư, Tên Vật Tư, Nhu cầu, Tồn kho, Thiếu hụt, Trạng thái; ở Phân Bổ Lệnh SX xuất theo lệnh. Không nhập Excel.",
                  "Tab 2. Kế hoạch vật tư của lệnh → [In bảng kê]: Bảng kê nhặt hàng nguyên vật liệu (BM-KHO-02A)."
               ]
            },
            {
               "name": "Cấp phát giấy & thu hồi dư — lọc theo nhóm khách hàng và xả phôi",
               "steps": [
                  "Các tab theo nhóm khách hàng trên đầu bảng: [Tất cả nhóm KH], [R-PAC], [Dream Plastics], [JCV], [Grand Champion], [Basic], [DANLI], [Thẻ Bài]. Bấm một tab để chỉ hiện các dòng cấp giấy có nhóm khách hàng chứa tên tab đó, bấm lại [Tất cả nhóm KH] để bỏ lọc; danh sách quay về trang 1 mỗi lần đổi tab.",
                  "[Xả Phôi] chỉ hiện trên dòng giấy chưa xả; bấm để mở hộp thoại Xác Nhận Xả Mộc & Xuất Kho Phôi Giấy.",
                  "Trong hộp thoại, nhập Số Tờ In Mộc Thực Tế Sau Xả (mặc định = tờ cần + tờ bù), chọn Chiều Xớ Giấy (XỚ XUÔI hoặc XỚ NGANG), Số Lượng Kiện Pallet và tên Thợ Cắt Xén Phôi.",
                  "Ô [Tự động sinh phiếu xuất kho NVL và chuyển LSX sang trạng thái READY] được tick sẵn: khi tick, hệ thống lập phiếu xuất kho vật tư (đã hoàn tất) và trừ tồn giấy ở kho vật tư.",
                  "[Xác Nhận Xả Mộc & Xuất Kho]: ghi nhận số tờ đã xả, chiều xớ, số pallet và người xả, đánh dấu dòng giấy đã xả và chuyển vật tư của lệnh sản xuất sang sẵn sàng để xưởng in nhận giấy.",
                  "Nếu số tờ mộc bằng 0, hệ thống báo \"Số lượng tờ mộc phải lớn hơn 0\"; nếu lỗi khác sẽ hiện \"Lỗi xả mộc: …\" và không ghi nhận gì."
               ]
            },
            {
               "name": "Cấp phát giấy — In Thẻ Pallet nhận diện giấy in",
               "steps": [
                  "[In Thẻ] trên mỗi dòng giấy mở hộp thoại In Thẻ Pallet Nhận Diện Giấy In Offset để dán vào 4 mặt kiện pallet sau khi xả mộc.",
                  "[Tất cả (n)]: chọn in toàn bộ thẻ pallet của lệnh.",
                  "[P1 (… tờ)], [P2 (… tờ)]… (nút [P ( tờ)] theo từng pallet): chọn in riêng thẻ của một pallet, trong ngoặc là số tờ trên pallet đó.",
                  "[In n Thẻ Pallet (Khổ A4)]: mở cửa sổ in các thẻ đang chọn, khổ khuyến nghị A4 ngang; nút bị mờ khi lệnh chưa có thông tin pallet (màn hình báo \"Không tìm thấy thông tin kiện pallet giấy của Lệnh sản xuất này\")."
               ]
            },
            {
               "name": "Kế hoạch vật tư — Cấp Phát ra sàn xưởng và in phiếu / tem pallet",
               "steps": [
                  "[Cấp Phát] trên dòng vật tư chưa nhận đủ mở hộp thoại Cấp Vật Tư từ kho ra sàn máy cho lệnh sản xuất.",
                  "Nhập số lượng cấp; nếu để 0 hệ thống báo \"Nhập số lượng cấp phát\", nếu vượt tồn sẽ báo \"Kho chỉ còn … \" và không cho cấp.",
                  "[📦 Xác Nhận Xuất Cấp Sàn Xưởng]: lập phiếu xuất cấp và báo \"Cấp phát thành công … Phiếu: …\", sau đó tự mở màn hình In Phiếu Xuất Kho & Thẻ Decal Pallet.",
                  "[Phiếu Xuất A4]: xem trước phiếu xuất kho khổ A4; nút in ở cuối đổi thành [In Ngay (Phiếu A4)].",
                  "[Tem Pallet Decal]: chuyển sang xem trước tem decal dán pallet; nút in ở cuối đổi thành [In Ngay (Tem Decal)].",
                  "[In Ngay (Tem Decal)] / [In Ngay (Phiếu A4)]: in mẫu đang xem; bấm [Hoàn Tất] để đóng khi in xong."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "Chờ xử lý",
               "to": "Đã đặt hàng",
               "action": "[Xác Nhận Tạo Đơn Mua Hàng] trong hộp Tạo Đơn Mua Hàng",
               "allowedRoles": "Có quyền Thêm Kế hoạch vật tư và Sửa Vật tư"
            },
            {
               "from": "Đã đặt hàng",
               "to": "Nhận 1 phần / Đã nhận đủ",
               "action": "Hoàn tất phiếu nhập kho ghi đúng đơn mua (sau IQC Đạt)",
               "allowedRoles": "Kho vật tư"
            },
            {
               "from": "Đã đặt hàng",
               "to": "Tính lại số cần mua",
               "action": "Hủy / xóa đơn mua liên kết (không còn đơn mua khác)",
               "allowedRoles": "Mua hàng"
            },
            {
               "from": "Chờ xử lý / Nhận 1 phần",
               "to": "Chờ xử lý / Nhận 1 phần / Đã nhận đủ",
               "action": "[Cân Đối MRP] tính lại theo số đã cấp và đã nhận riêng cho dòng",
               "allowedRoles": "Có quyền Thêm Kế hoạch vật tư và Sửa Vật tư"
            },
            {
               "from": "Chờ xử lý",
               "to": "Đã nhận đủ (khi cấp đủ)",
               "action": "[Cấp Đủ], [Cấp Phát], [Cấp vật tư] hoặc phiếu [Xuất kho] cho lệnh",
               "allowedRoles": "Có quyền Sửa Vật tư / Thủ kho"
            },
            {
               "from": "Mọi trạng thái trừ Đã nhận đủ",
               "to": "Đã nhận đủ",
               "action": "[Xác nhận Sẵn Sàng (n)]",
               "allowedRoles": "Có quyền Sửa Vật tư"
            },
            {
               "from": "Chờ xử lý / Đã đặt hàng / Nhận 1 phần",
               "to": "Đã hủy",
               "action": "Lệnh sản xuất bị [Hủy lệnh]",
               "allowedRoles": "Tự động"
            },
            {
               "from": "Lệnh chưa duyệt / đã hủy / đã xong",
               "to": "Giữ nguyên",
               "action": "Cấp vật tư bị từ chối kèm lý do",
               "allowedRoles": "Mọi người"
            }
         ],
         "actionLinks": [
            {
               "from": "Kế hoạch Vật tư",
               "to": "Mua hàng › ĐH Mua hàng",
               "action": "Tạo đơn mua Chờ duyệt",
               "how": "[Mua] / [Tạo ĐMH (n)] → [Xác Nhận Tạo Đơn Mua Hàng] → [Xem PO]"
            },
            {
               "from": "Kế hoạch Vật tư",
               "to": "Mua hàng (đề nghị mua)",
               "action": "Tạo đề nghị mua",
               "how": "[Tạo PR] → [Gửi yêu cầu]"
            },
            {
               "from": "IQC Đầu vào",
               "to": "Kho Vật tư › Chờ nhập kho",
               "action": "Lô Đạt chờ nhập kho",
               "how": "Tự động khi phiếu IQC Đạt"
            },
            {
               "from": "Kế hoạch Vật tư",
               "to": "Lệnh sản xuất",
               "action": "Xem vật tư của lệnh",
               "how": "Phân Bổ Lệnh SX → [Chi tiết], hoặc Chi tiết nhu cầu vật tư → Xem kế hoạch vật tư của lệnh"
            },
            {
               "from": "Lệnh sản xuất",
               "to": "Phiếu xuất kho vật tư",
               "action": "Lập phiếu xuất cho lệnh",
               "how": "Tab 2. Kế hoạch vật tư → [Cấp vật tư] trên dòng hoặc [Xuất kho] cho cả lệnh"
            }
         ],
         "quickActions": [
            {
               "action": "Cân Đối MRP",
               "description": "Tính lại số cần mua toàn bộ kế hoạch trong một lần bấm."
            },
            {
               "action": "Mua",
               "description": "Nút trên dòng thiếu, mở ngay hộp tạo đơn mua cho vật tư đó."
            },
            {
               "action": "Tạo ĐMH (n)",
               "description": "Tích nhiều dòng thiếu để lập đơn mua theo từng nhà cung cấp."
            },
            {
               "action": "Cấp Đủ",
               "description": "Cấp toàn bộ phần còn thiếu cho một lệnh ở chế độ Phân Bổ Lệnh SX."
            }
         ],
         "inlineViews": [
            {
               "name": "Chi tiết nhu cầu vật tư",
               "trigger": "Bấm một dòng ở Tổng Hợp Cần Mua",
               "description": "Cần dùng, tồn, còn thiếu, nhà cung cấp, ngày cần hàng, các lệnh dùng vật tư, thảo luận, tệp đính kèm, lịch sử."
            },
            {
               "name": "Cấp Vật Tư",
               "trigger": "[Cấp vật tư] / [Cấp Phát]",
               "description": "Chọn kho vật tư và công đoạn nhận, xem tồn khả dụng, nhập số lượng cấp (mặc định phần còn thiếu)."
            },
            {
               "name": "Tạo Đơn Mua Hàng Tự Động",
               "trigger": "[Mua] / [Tạo ĐMH (n)]",
               "description": "Gom theo nhà cung cấp, sửa SL Mua, Đơn Giá, Ngày giao trước khi xác nhận."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/16_paper_allocation_buffer_modal.png",
               "caption": "Hình 09.1 — Hộp Cấp Bù Giấy Hao Hụt Phát Sinh trên tab Cấp Phát Giấy"
            },
            {
               "src": "/guide-screenshots/17_paper_allocation_pantone_ink_reclaim_modal.png",
               "caption": "Hình 09.2 — Hộp thu hồi Mực pha Pantone dư về kho vật tư"
            }
         ],
         "forms": [
            {
               "code": "BM-KHO-02A",
               "name": "Bảng kê nhặt hàng nguyên vật liệu (Picking list) của lệnh sản xuất"
            }
         ],
         "notes": [
            "Đơn mua lập từ Kế hoạch vật tư luôn ở Chờ duyệt; Mua hàng phải duyệt mới nhận hàng được.",
            "Đơn mua lập cho dòng kế hoạch giữ chỗ ngay cả khi còn Chờ duyệt, nên Cân Đối MRP không báo thiếu lại phần đó.",
            "[Cấp Bù] ở Cấp Phát Giấy chỉ ghi tăng số tờ trên lệnh; cần phiếu kho cho phần bù thì lập [Xuất kho].",
            "Cấp vật tư chỉ lấy từ kho vật tư; kho thành phẩm, kho kỹ thuật không dùng để cấp cho lệnh.",
            "Phiếu in Kế hoạch vật tư, Phiếu cấp phát vật tư và Thẻ pallet phôi giấy chưa có mã biểu mẫu ISO trên mẫu in."
         ],
         "uatChecklist": [
            {
               "id": "KH-09-01",
               "item": "Cân Đối MRP ra đúng số cần mua",
               "standard": "Thông báo Đã cân đối cung-cầu MRP cho n dòng kế hoạch. Phát hiện m vật tư thiếu hụt; dòng giấy của lệnh thử có Còn thiếu = Cần dùng − đã có − phần tồn chung chia được.",
               "method": "1) Kế hoạch › Kế hoạch Vật tư, tab 1. Nhu Cầu Vật Tư, Tổng Hợp Cần Mua; 2) Ghi lại tồn Ivory 300gsm ở Kho › Mã & Tồn NVL; 3) Bấm [Cân Đối MRP]; 4) Lọc Giấy In, bấm dòng Ivory 300gsm mở Chi tiết nhu cầu vật tư; 5) Đối chiếu Cần dùng, Tồn kho, Còn thiếu."
            },
            {
               "id": "KH-09-02",
               "item": "Lập đơn mua từ dòng thiếu",
               "standard": "Đơn mua tạo ở Chờ duyệt, đúng nhà cung cấp, đúng vật tư và SL Mua; dòng kế hoạch chuyển Đã đặt hàng, số cần mua giảm.",
               "method": "1) Trên dòng thiếu Ivory 300gsm bấm [Mua]; 2) Kiểm tra Gán NCC, SL Mua, Đơn Giá, Ngày giao; 3) Bấm [Xác Nhận Tạo Đơn Mua Hàng]; 4) Bấm [Xem PO], xem trạng thái; 5) Quay lại, xem trạng thái dòng kế hoạch."
            },
            {
               "id": "KH-09-03",
               "item": "Chặn mua trùng và bắt chọn nhà cung cấp",
               "standard": "Lập đơn lần hai cho dòng đã đặt đủ bị báo … đã đặt mua đủ (không còn số cần mua) — không lập thêm đơn mua; vật tư chưa chọn NCC bị báo Còn n vật tư chưa chọn Nhà Cung Cấp.",
               "method": "1) Tích dòng vừa đặt ở KH-09-02 → [Tạo ĐMH (1)] → [Xác Nhận Tạo Đơn Mua Hàng]; 2) Đọc thông báo; 3) Tích 1 vật tư chưa có NCC mặc định → [Tạo ĐMH (1)]; 4) Để trống Gán NCC, bấm xác nhận."
            },
            {
               "id": "KH-09-04",
               "item": "Lập nhiều đơn mua cùng lúc theo nhà cung cấp",
               "standard": "Chọn 3 dòng của 2 nhà cung cấp tạo đúng 2 đơn mua; mỗi dòng kế hoạch là một dòng đơn mua riêng.",
               "method": "1) Tích 3 dòng thiếu (2 dòng NCC A, 1 dòng NCC B); 2) Bấm [Tạo ĐMH (3)]; 3) Kiểm tra hộp gom 2 nhóm; 4) [Xác Nhận Tạo Đơn Mua Hàng]; 5) Mở 2 đơn ở Mua hàng › ĐH Mua hàng."
            },
            {
               "id": "KH-09-05",
               "item": "Tạo đề nghị mua (PR) và chặn PR trùng",
               "standard": "PR tạo với mã PR-… ở Chờ duyệt; tạo lần hai cho cùng dòng bị báo đã có đề nghị mua … đang mở.",
               "method": "1) Trên một dòng thiếu mở … → [Tạo PR]; 2) Nhập Số lượng 500, Ngày cần hàng, Lý do → [Gửi yêu cầu]; 3) Lặp lại trên cùng dòng; 4) Đọc thông báo."
            },
            {
               "id": "KH-09-06",
               "item": "Hàng về qua IQC, nhập kho cập nhật kế hoạch",
               "standard": "Lô IQC Đạt hiện ở Kho Vật tư › Chờ nhập kho; nhập kho xong dòng kế hoạch thành Nhận 1 phần / Đã nhận đủ, tồn NVL tăng, lệnh hiện ĐÃ VỀ KHO, CHỜ CẤP.",
               "method": "1) Mua hàng duyệt đơn ở KH-09-02; 2) QC lập phiếu IQC Đạt cho lô của đơn đó; 3) Kho › Kho Vật tư, tab Chờ nhập kho, nhập kho lô; 4) Mở Kho › Mã & Tồn NVL xem tồn; 5) Kế hoạch Vật tư xem trạng thái dòng; 6) Mở lệnh, tab 2. Kế hoạch vật tư."
            },
            {
               "id": "KH-09-07",
               "item": "Không nhận hàng vượt đơn mua",
               "standard": "Nhận quá SL đặt + 5% bị báo Nhận … vượt SL còn được nhận … (SL đặt + 5%); phiếu không hoàn tất.",
               "method": "1) Lập phiếu nhập kho theo đơn mua 1.000 tờ; 2) Nhập 1.100 tờ; 3) Bấm hoàn tất; 4) Đọc thông báo."
            },
            {
               "id": "KH-09-08",
               "item": "Phân Bổ Lệnh SX hiện Đang về và đúng phạm vi lệnh",
               "standard": "Lệnh có đơn mua chưa về hiện Đang về n kèm ngày hàng về; lệnh Bản nháp / Chờ duyệt / Đã hủy không có trong danh sách.",
               "method": "1) Chuyển sang Phân Bổ Lệnh SX, gom Theo Lệnh SX; 2) Tìm lệnh có đơn mua ở KH-09-04, mở rộng bảng định mức; 3) Tìm mã một lệnh Chờ duyệt ban hành; 4) Đổi sang Theo Ngày Cần VT."
            },
            {
               "id": "KH-09-09",
               "item": "Cấp vật tư cho lệnh và chặn lệnh chưa duyệt",
               "standard": "Lệnh Đã phát hành cấp được, dòng thành ✓ ĐÃ CẤP ĐỦ và có phiếu xuất; lệnh Chờ duyệt ban hành bị báo … chưa duyệt, đã huỷ hoặc đã xong / đóng — không cấp vật tư được.",
               "method": "1) Mở lệnh Đã phát hành, tab 2. Kế hoạch vật tư; 2) Bấm [Cấp vật tư] dòng giấy, chọn kho vật tư, giữ số mặc định → [📦 Xác Nhận Xuất Cấp Sàn Xưởng]; 3) Xem nhãn dòng và khối Sẵn sàng triển khai; 4) Mở lệnh Chờ duyệt ban hành, thử [Cấp vật tư]."
            },
            {
               "id": "KH-09-10",
               "item": "Cấp Đủ theo lệnh",
               "standard": "Lệnh chuyển ✓ SẴN SÀNG; mọi dòng ĐÃ CẤP; phiếu xuất hoàn tất xuất từ kho vật tư.",
               "method": "1) Phân Bổ Lệnh SX, lọc ⏳ Chờ cấp phát; 2) Bấm [Cấp Đủ] trên một lệnh Đã phát hành; 3) Đọc thông báo; 4) Bấm [Chi tiết] mở tab vật tư của lệnh, xem phiếu xuất."
            },
            {
               "id": "KH-09-11",
               "item": "Cấp bù phế phẩm phải duyệt",
               "standard": "Yêu cầu ở trạng thái chờ duyệt, số cần chưa đổi; sau khi duyệt số cần tăng đúng số bù và cấp được phần bù.",
               "method": "1) Lệnh Đang SX, tab 2 → [Cấp bù]; 2) Chọn giấy, số lượng 200, công đoạn In, lý do Lệch màu → [Gửi Yêu Cầu Cấp Bù]; 3) Tài khoản có quyền Duyệt mở Phê Duyệt Cấp Bù Phế Phẩm (Quản Đốc) → duyệt; 4) Bấm [Cấp vật tư] phần bù."
            },
            {
               "id": "KH-09-12",
               "item": "Hủy lệnh làm sạch Kế hoạch Vật tư",
               "standard": "Sau khi hủy lệnh, các dòng chưa nhận của lệnh không còn ở Tổng Hợp Cần Mua và Phân Bổ Lệnh SX; Cân Đối MRP không tính lệnh đó; đơn mua liên quan có ghi chú cảnh báo.",
               "method": "1) Ghi mã lệnh có dòng thiếu và đơn mua Chờ duyệt; 2) Hủy lệnh ở chi tiết lệnh; 3) Kế hoạch Vật tư tìm mã lệnh ở cả 2 chế độ; 4) Bấm [Cân Đối MRP]; 5) Mở đơn mua, xem Lịch sử cập nhật."
            },
            {
               "id": "KH-09-13",
               "item": "Cấp Phát Giấy: cấp bù và thu hồi giấy dư",
               "standard": "[Cấp Bù] +200 tờ tăng cột Bù Hao của lệnh; [Thu Hồi] 150 tờ tạo phiếu nhập kho hoàn tất vào kho vật tư.",
               "method": "1) Kế hoạch Vật tư › tab 2. Cấp Phát Giấy; 2) Trên một lệnh bấm [Cấp Bù], bấm +200, nhập lý do → [Xác Nhận Cấp Bù Giấy]; 3) Bấm [Thu Hồi], chọn 📄 Giấy In Dôi Dư (Tờ), nhập 150 → [Xác Nhận Thu Hồi]; 4) Kiểm tra phiếu nhập ở Kho Vật tư."
            },
            {
               "id": "KH-09-14",
               "item": "Kiểm tra trên điện thoại 390px",
               "standard": "Ba tab và chế độ xem cuộn ngang được; bảng cuộn ngang; Chi tiết nhu cầu vật tư mở toàn màn hình, link NCC và lệnh bấm được.",
               "method": "1) Mở Kế hoạch Vật tư ở chế độ 390px; 2) Cuộn ngang tab 1-2-3; 3) Bấm một dòng ở Tổng Hợp Cần Mua; 4) Bấm link nhà cung cấp, quay lại, bấm link lệnh."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "Kế Hoạch Sản Xuất (PLANNER)",
               "createTest": "[Cân Đối MRP]; [Mua] / [Tạo ĐMH (n)] → [Xác Nhận Tạo Đơn Mua Hàng]; [Tạo PR] → [Gửi yêu cầu].",
               "readTest": "Tổng Hợp Cần Mua, Phân Bổ Lệnh SX, Chi tiết nhu cầu vật tư, [In Kế Hoạch], [Xuất Excel].",
               "updateTest": "[Tách số lượng]; [Xác nhận Sẵn Sàng (n)].",
               "deleteTest": "Không có xóa dòng kế hoạch; dòng tự hủy khi lệnh bị hủy.",
               "expectedResult": "Đơn mua Chờ duyệt đúng NCC; không lập trùng đơn / đề nghị mua."
            },
            {
               "roleGroup": "Thủ Kho (WAREHOUSE) và Giám Đốc / Quản Đốc Sản Xuất (PRODUCTION_MANAGER)",
               "createTest": "Thủ kho: [Cấp Đủ], [Cấp vật tư], [Xuất kho], [Thu Hồi]. Quản đốc: [Cấp bù] → [Gửi Yêu Cầu Cấp Bù].",
               "readTest": "Phân Bổ Lệnh SX, Cấp Phát Giấy, Cấp NVL Sàn Máy.",
               "updateTest": "Quản đốc duyệt cấp bù (cần quyền Duyệt Lệnh sản xuất); bấm [Đã đủ] ở Cấp NVL Sàn Máy.",
               "deleteTest": "Không xóa dòng kế hoạch; thử cấp cho lệnh Chờ duyệt ban hành để thấy bị chặn.",
               "expectedResult": "Phiếu kho đúng kho vật tư, nhãn dòng đổi đúng; lệnh chưa duyệt không cấp được."
            },
            {
               "roleGroup": "Vai trò chỉ có quyền Xem Kế hoạch vật tư",
               "createTest": "Không thấy [Cân Đối MRP], [Tạo PR], [Mua].",
               "readTest": "Xem nhu cầu, in kế hoạch, xuất Excel.",
               "updateTest": "Không có nút sửa.",
               "deleteTest": "Không có.",
               "expectedResult": "Chỉ xem được, không thay đổi dữ liệu."
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 10. Khuôn Bế, Bản Kẽm CTP, Nhật Ký Kẽm & Tuổi Thọ
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "plates_molds",
         "aliases": [
            "molds",
            "plates",
            "ctp-logs",
            "tooling",
            "tech",
            "tooling-tracking-board",
            "plates/ctp-logs",
            "production/ctp-tracking"
         ],
         "title": "10. Khuôn Bế, Bản Kẽm CTP, Nhật Ký Kẽm & Tuổi Thọ",
         "icon": "Wrench",
         "isoRef": "QT-KT-02",
         "purpose": "Hướng dẫn tổ chế bản / CTP và kho khuôn: ghi bản kẽm cho từng Lệnh sản xuất theo đúng khổ kẽm của máy in, ký duyệt proof, lắp kẽm lên máy, báo hỏng và ghi bù, theo dõi tồn kẽm trong Nhật ký kẽm CTP; khai báo và quản lý vòng đời khuôn (khuôn bế, ép nhũ, thúc nổi, dập chìm, UV, lưới lụa): nghiệm thu, bảo dưỡng, báo hỏng, đặt làm ngoài, ghi lượt dập và cảnh báo tuổi thọ.",
         "scope": [
            "Menu Kỹ thuật › Kẽm CTP & Log (/plates): 2 tab Điều Phối Kẽm và Danh Mục Bản Kẽm; chi tiết bản kẽm /plates/<mã>.",
            "Menu Kỹ thuật › Quản lý Khuôn (/molds): 2 tab Danh mục khuôn và Kế hoạch khuôn; chi tiết khuôn /molds/<mã>.",
            "Trang mở bằng địa chỉ: Nhật Ký Kẽm CTP (/plates/ctp-logs); Theo dõi ghi kẽm theo bài bình (/production/ctp-tracking, trang cũ); /tooling-tracking-board tự chuyển về Kế hoạch khuôn.",
            "Trong Lệnh sản xuất: tab 3. Kế hoạch khuôn kẽm của từng lệnh, và tab Hàng Chờ CTP trên danh sách Kế hoạch › Lệnh sản xuất.",
            "Khổ kẽm của máy in khai báo ở Xưởng sản xuất › Thiết bị SX › Sửa › ô Khổ Kẽm CTP (máy in).",
            "Người dùng: tổ chế bản / CTP và kho khuôn (vai trò Nhân Viên Kỹ Thuật / Chế Bản, Trưởng Phòng Kỹ Thuật), Phòng Kế hoạch, Xưởng in / bế."
         ],
         "references": [
            "ISO 9001:2015 mục 7.1.3 Cơ sở hạ tầng",
            "ISO 9001:2015 mục 7.1.5 Nguồn lực theo dõi và đo lường",
            "ISO 9001:2015 mục 8.5.1 Kiểm soát sản xuất",
            "Chương 07 Bình file chế bản, Chương 08 Lệnh sản xuất"
         ],
         "terms": [
            {
               "term": "Khổ kẽm theo máy in",
               "definition": "Mỗi máy in khai báo 1 khổ kẽm (2 máy Komori điền sẵn 1030x800 mm). Dòng kẽm nội bộ của lệnh tự lấy khổ của máy in được giao cho công đoạn in, không chọn tay. Máy chưa khai báo khổ hoặc công đoạn in chưa giao máy thì không gửi ghi bản được; bộ kẽm khác khổ không lắp được lên máy."
            },
            {
               "term": "Kẽm xuất mới cho mỗi lệnh",
               "definition": "Mỗi lần Ghi bản kẽm xong tạo một bộ kẽm riêng mã PLT-… gắn với lệnh; lệnh mới chỉ dùng lại file bình cũ, không dùng lại kẽm. In xong, bộ kẽm được giữ 24 giờ để in bù; quá 24 giờ và lệnh đã đóng thì tự chuyển Đã thanh lý."
            },
            {
               "term": "Số lá kẽm theo kiểu in",
               "definition": "Khi thêm dòng kẽm cho lệnh, chọn kiểu in để có đúng số lá: CMYK 4 lá, CMYK + 2 pha 6 lá, CMYK 2 mặt A/B 8 lá, tự trở CMYK 4 lá, 2 màu 2 lá."
            },
            {
               "term": "Kẽm thuê ngoài",
               "definition": "Dòng kẽm nguồn thuê ngoài (in gia công, bên ngoài ra kẽm): không gửi tổ CTP, không trừ kho kẽm."
            },
            {
               "term": "Tồn kẽm CTP",
               "definition": "Nhật Ký Kẽm CTP là sổ kho kẽm nguyên của phòng CTP. Nhập kẽm làm tăng tồn; Ghi bản kẽm xong và ghi bù làm giảm tồn đúng số lá; Gửi ghi bản kẽm chưa trừ kho. Ô Tồn do hệ thống tự tính."
            },
            {
               "term": "Proof",
               "definition": "Mẫu in thử màu ký duyệt trước khi in. Kết quả: Ký Duyệt Đạt, Từ Chối Sửa File, Miễn Duyệt (Gấp). Đạt hoặc Miễn Duyệt đưa bộ kẽm Chờ nghiệm thu sang Sẵn sàng trên kệ."
            },
            {
               "term": "Lượt dập lũy kế và tuổi thọ khuôn",
               "definition": "Định Mức Dập Tối Đa mặc định 100.000 lượt, Chu Kỳ Bảo Dưỡng mặc định 25.000 lượt. Khuôn Cần bảo dưỡng khi số lượt từ lần bảo dưỡng gần nhất đạt chu kỳ; Sắp hết hạn khi đạt từ 85% định mức."
            },
            {
               "term": "Độ bền bộ kẽm theo lệnh",
               "definition": "Tab 3. Kế hoạch khuôn kẽm so số tờ chạy của lệnh với 80.000 lượt (mực thường) hoặc 40.000 lượt (mực UV); vượt thì cảnh báo và đề xuất ra thêm bộ kẽm hoặc nướng kẽm."
            },
            {
               "term": "Vòng đời khuôn / kẽm",
               "definition": "Chờ nghiệm thu → Sẵn sàng trên kệ → Đang chạy máy; Sẵn sàng / Đang chạy máy có thể sang Đang bảo dưỡng hoặc Hỏng / Sự cố. Hỏng chỉ đi Đang bảo dưỡng hoặc Thanh lý, không quay thẳng về Sẵn sàng. Đã thanh lý / Hủy là trạng thái cuối."
            }
         ],
         "responsibilities": [
            {
               "role": "Tổ chế bản / CTP",
               "tasks": [
                  "Nhận lệnh ở Hàng Chờ CTP hoặc tab 3 của lệnh, bấm Gửi ghi bản kẽm khi bắt đầu, Ghi bản kẽm xong khi ra kẽm.",
                  "Ký duyệt proof, lắp kẽm lên máy in đúng khổ, báo hỏng và ghi bù kẽm.",
                  "Ghi Nhập kẽm vào Nhật Ký Kẽm CTP khi kẽm mới về."
               ]
            },
            {
               "role": "Kho khuôn / Kỹ thuật",
               "tasks": [
                  "Khai báo khuôn, vị trí kệ, in tem QR; nghiệm thu khuôn mới hoặc khuôn gia công về.",
                  "Bảo dưỡng, sửa khuôn (nâng phiên bản), báo hỏng, thay khuôn, đặt làm ngoài; ghi nhận lượt dập.",
                  "Ở tab 3 của lệnh: gán khuôn cũ từ kho và kiểm định, đặt mới, nghiệm thu, xuất máy, thu hồi kho."
               ]
            },
            {
               "role": "Phòng Kế hoạch",
               "tasks": [
                  "Giao máy in cho công đoạn in ở tab 4. Kế hoạch sản xuất của lệnh trước khi gửi ghi bản kẽm.",
                  "Thêm dòng khuôn / kẽm cho lệnh (tab 3), theo dõi số dòng sẵn sàng và cảnh báo độ bền kẽm."
               ]
            },
            {
               "role": "Xưởng in / bế",
               "tasks": [
                  "Nhận kẽm lên máy (ký nhận ở hộp Lắp máy), báo hỏng kẽm khi có sự cố.",
                  "Nhận khuôn ra máy, trả khuôn về kệ kèm số lượt dập."
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "Người có quyền Xem Khuôn / Kẽm CTP",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Thấy menu tương ứng. Các thao tác khuôn, bản kẽm, proof, lắp máy, nhật ký kẽm hiện chỉ yêu cầu đăng nhập, không kiểm thêm quyền Thêm / Sửa / Xóa riêng."
            },
            {
               "role": "Thao tác kẽm / khuôn trong Lệnh sản xuất (tab 3, Hàng Chờ CTP)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Gửi ghi bản kẽm, Ghi bản kẽm xong, thêm / xóa dòng khuôn kẽm là thao tác sửa lệnh: cần quyền Sửa Lệnh sản xuất. Mọi nút bị khóa khi lệnh Đã chốt kế hoạch; lệnh đã hủy / xong / đóng không gửi ghi bản được."
            },
            {
               "role": "Vai trò mã PRODUCTION (nếu có)",
               "view": "✅",
               "create": "❌",
               "edit": "✅",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Không được tạo khuôn mới (Bộ phận sản xuất không được tạo khuôn mới. Vui lòng liên hệ bộ phận Chế bản.) và không được xóa khuôn."
            },
            {
               "role": "Người không có quyền Xem",
               "view": "❌",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "❌",
               "statusRules": "Menu bị ẩn."
            }
         ],
         "processFlowchart": "graph TD\n    A[Lệnh sản xuất có dòng kẽm] --> B{Công đoạn in đã giao máy in có khổ kẽm?}\n    B -->|Chưa| X[Báo: chưa giao máy in nên chưa biết khổ kẽm]\n    X --> B2[Kế hoạch giao máy ở tab 4. Kế hoạch sản xuất]\n    B2 --> B\n    B -->|Rồi| C[Gửi ghi bản kẽm: Đang ghi bản, chưa trừ kho]\n    C --> D[Ghi bản kẽm xong: tạo bộ kẽm PLT, trừ kho kẽm]\n    D --> E[Điều Phối Kẽm: Chờ duyệt proof]\n    E -->|Ký Duyệt Đạt / Miễn Duyệt| F[Sẵn sàng trên kệ]\n    F -->|Lắp máy đúng khổ| G[Đang chạy máy]\n    G --> H{Kẽm hỏng?}\n    H -->|Có| I[Báo hỏng và Ghi bù kẽm, trừ kho số lá ghi bản lại]\n    H -->|Không| J[In xong, giữ 24 giờ rồi tự Thanh lý]\n    K[Dòng khuôn của lệnh] --> L{Có khuôn trong kho?}\n    L -->|Có| M[Chọn khuôn cũ rồi Kiểm Định]\n    L -->|Không| N[Đặt Mới / Đặt làm ngoài rồi Nghiệm Thu vào kệ]\n    M --> O[Khuôn Sẵn sàng]\n    N --> O\n    O --> P[Xuất máy, ghi lượt dập, Thu hồi kho]\n    P --> Q{Đến chu kỳ bảo dưỡng / hỏng?}\n    Q -->|Có| R[Đang bảo dưỡng, sửa khuôn nâng phiên bản]\n    R --> O",
         "mainFlow": [
            {
               "step": 1,
               "action": "Chuẩn bị: máy in có khổ kẽm, lệnh có dòng kẽm và máy in",
               "detail": "• Xưởng sản xuất › Thiết bị SX › mở máy in › [Sửa] › ô Khổ Kẽm CTP (máy in), vd 1030x800 mm → lưu.\n• Ở Lệnh sản xuất, tab 4. Kế hoạch sản xuất: công đoạn in phải được giao máy in.\n• Tab 3. Kế hoạch khuôn kẽm: [Thêm khuôn / kẽm] → Loại Kẽm, chọn kiểu in để có đúng số lá, Số lượng, Ngày cần → lưu (báo Đã thêm dòng kẽm). Đầu tab hiện số khuôn, số bản kẽm, số dòng sẵn sàng và Độ bền kẽm (cảnh báo khi vượt 80.000 / 40.000 lượt)."
            },
            {
               "step": 2,
               "action": "Gửi ghi bản kẽm",
               "detail": "• Tab 3 của lệnh → [Gửi ghi bản kẽm], hoặc Kế hoạch › Lệnh sản xuất › tab Hàng Chờ CTP → [Ghi bản] trên dòng lệnh (chọn nhiều lệnh → [Gửi ghi bản kẽm]).\n• Thành công: Đã gửi ghi bản kẽm cho tổ chế bản; nhãn dòng kẽm Chờ ghi bản → Đang ghi bản. Kho kẽm chưa bị trừ.\n• Bị chặn nếu công đoạn in chưa giao máy: LSX-…: công đoạn in chưa giao máy in nên chưa biết khổ kẽm — giao máy in ở tab 4. Kế hoạch sản xuất rồi gửi ghi bản kẽm. Máy chưa khai khổ: Máy in … chưa khai báo khổ kẽm — khai báo ở Xưởng sản xuất → Thiết bị SX → Sửa → Khổ kẽm. Lệnh không có dòng kẽm: LSX-…: không có dòng kẽm chờ ghi bản."
            },
            {
               "step": 3,
               "action": "Ghi bản kẽm xong",
               "detail": "• Tab 3 của lệnh → [Ghi bản kẽm xong], hoặc Hàng Chờ CTP → [Xong] (nhiều lệnh: [Xong kẽm]).\n• Hệ thống báo Đã ghi nhận ghi bản kẽm xong, tạo bộ kẽm mã PLT-… gắn với lệnh (trạng thái Chờ nghiệm thu, proof Chờ duyệt), trừ kho kẽm đúng số lá vừa ghi bản và tự ghi Nhật Ký Kẽm CTP. Nhãn dòng kẽm thành Đã ghi bản xong. Nếu kho không đủ, hệ thống báo thêm cảnh báo tồn.\n• Bấm lần 2 không tạo thêm bộ, không trừ kho lần 2 (báo kẽm đã ghi bản xong hết, không còn dòng chờ ghi bản).\n• [In phiếu kẽm] in Phiếu ghi bản kẽm CTP của lệnh."
            },
            {
               "step": 4,
               "action": "Ký proof và lắp kẽm lên máy (Điều Phối Kẽm)",
               "detail": "• Kỹ thuật › Kẽm CTP & Log → tab 🖨️ Điều Phối Kẽm: đếm Tất cả bộ kẽm, Chờ Duyệt Proof, Proof Đã Ký, Đang Trên Máy In, Sự Cố / Ghi Bù; mỗi dòng có ảnh sản phẩm, khổ kẽm, bộ phân màu, máy in.\n• [Ký Proof]: chọn ✅ Ký Duyệt Đạt / ❌ Từ Chối Sửa File / ⚠️ Miễn Duyệt (Gấp), nhập người ký → xác nhận. Đạt hoặc Miễn Duyệt đưa bộ kẽm sang Sẵn sàng trên kệ; nút đổi thành Đã Ký.\n• [Lắp Máy]: ô chọn chỉ có máy in offset / flexo kèm khổ kẽm; máy chưa khai báo khổ hoặc khác khổ bộ kẽm hiện mờ kèm lý do, máy hợp khổ được chọn sẵn. Nhập Thợ trưởng máy, ca, tích các lá kẽm bàn giao → xác nhận: bộ kẽm sang Đang chạy máy. Kẽm Chờ nghiệm thu, Hỏng hoặc đã thanh lý không lắp được.\n• Bảng tự cập nhật ngay sau khi ký proof, lắp máy, báo hỏng."
            },
            {
               "step": 5,
               "action": "Báo hỏng và ghi bù kẽm",
               "detail": "• Trên Điều Phối Kẽm bấm nút báo hỏng / ghi bù, hoặc chi tiết kẽm → [Báo hỏng kẽm] / [Báo hỏng].\n• Chọn lý do, mức ưu tiên, số lá cần ghi bản lại → [Kích Hoạt Lệnh Ghi Bù Kẽm]: bộ kẽm sang Hỏng / Sự cố, tăng số lần ghi bù, kho kẽm trừ số lá ghi bản lại và tự ghi nhật ký. Kẽm đang Hỏng có nút [Ghi bù kẽm (n)]; mỗi lần bấm lại mở hộp ghi bù và trừ kho thêm một lần, nên chỉ bấm khi thật sự ghi thêm. Lệnh ghi bù chưa tự tạo bộ kẽm mới để lắp máy — bộ kẽm thay thế ghi theo Tab 3 của lệnh."
            },
            {
               "step": 6,
               "action": "Theo dõi tồn kẽm (Nhật Ký Kẽm CTP)",
               "detail": "• Mở /plates/ctp-logs. Đầu trang hiện Tồn kẽm hiện tại theo từng khổ.\n• Kẽm mới về: [Nhập kẽm] (hoặc [Ghi sổ phụ]) → Ngày, Tên Kẽm (khổ, vd 1030x800 mm), SL Nhập → [Thêm mới]: tồn khổ đó tăng.\n• Dòng xuất do Ghi bản kẽm xong / ghi bù tự ghi. Menu dòng → [Chỉnh Sửa] / [Xoá]; tồn các dòng sau tự tính lại."
            },
            {
               "step": 7,
               "action": "Khai báo khuôn và quản lý danh mục (/molds)",
               "detail": "• Kỹ thuật › Quản lý Khuôn → [Thêm khuôn mới]: Tên khuôn (bắt buộc, không trùng), Loại khuôn, Trạng thái, Khách hàng, Sản phẩm áp dụng, Dài / Rộng (mm), Số UPS, vị trí Khu / Kệ / Tầng / Ô, Định Mức Dập Tối Đa (100.000), Chu Kỳ Bảo Dưỡng (25.000), Nhà Cung Cấp, Chi Phí → [Tạo mới]. Báo Đã tạo khuôn thành công!, mã tự sinh DC-0001. Trùng tên: Vui lòng sửa lỗi trùng lặp dữ liệu trước khi lưu.\n• Tab Danh mục khuôn: thẻ lọc 6 loại (Khuôn bế, Ép kim / ép nhũ, Thúc nổi, Dập chìm, UV định hình, Lưới lụa) và trạng thái Sẵn sàng, Đang gá máy, Chờ xử lý, Bảo dưỡng, Cần bảo dưỡng, Hỏng, Sắp hết hạn, Thanh lý. Cột lượt dập có thanh hao mòn.\n• Tab Kế hoạch khuôn: nhu cầu khuôn của các lệnh đang chạy, lọc Chờ chuẩn bị, Cần làm mới, Đang làm ngoài, Dùng lại từ kho, Sẵn sàng tại kệ; có ảnh sản phẩm và nút đặt làm ngoài, nghiệm thu, đổi kệ."
            },
            {
               "step": 8,
               "action": "Vòng đời khuôn trên chi tiết khuôn (/molds/<mã>)",
               "detail": "• Chỉ hiện nút của bước được phép: Chờ nghiệm thu → [Nghiệm thu]; Sẵn sàng → [Chuyển bảo dưỡng], [Báo hỏng]; Đang bảo dưỡng → [Khôi phục / Sẵn sàng]. Khuôn Hỏng không có Khôi phục, phải qua bảo dưỡng hoặc thanh lý.\n• [Bảo dưỡng] mở phiếu ghi nhận: Bảo dưỡng định kỳ hoặc Sửa khuôn (Nâng v) (bắt buộc lý do). Khuôn Hỏng bấm Bảo dưỡng → chuyển Đang bảo dưỡng; bảo dưỡng xong bấm [Bảo dưỡng] lần nữa → khuôn về Sẵn sàng, chu kỳ tính lại, sửa khuôn tăng phiên bản.\n• [Thay khuôn]: chọn lý do → tạo khuôn phiên bản mới, khuôn cũ thành Đã thanh lý / Hủy. [Đặt làm ngoài]: chọn nhà cung cấp, đơn giá, ngày hẹn → tạo đơn gia công khuôn. [Cập nhật nhanh], [Đổi kệ kho], [In phiếu], [In tem], [Sửa], [Xoá].\n• Tab Lịch sử dập máy MES → [Ghi nhận lượt dập]: Mã lệnh, Số lượt dập, Máy dập, Thợ vận hành → lưu; lượt dập và hao mòn dao cập nhật ngay. Các tab khác: Sản phẩm ghép bài bình, Bài bình Prepress & CAD, KCS, Bảo trì & Nhật ký (có thảo luận và lịch sử cập nhật ghi người thực hiện), Phả hệ phiên bản."
            },
            {
               "step": 9,
               "action": "Khuôn cho từng lệnh (tab 3. Kế hoạch khuôn kẽm)",
               "detail": "• Khuôn cũ: biểu tượng tìm → hộp Gán Khuôn Có Sẵn Từ Kho → [Gán Khuôn Này] (máy chủ chỉ nhận khuôn đúng loại, không hỏng / không bảo dưỡng): khuôn có sẵn trong kho thì dòng khuôn Sẵn sàng ngay, không cần bước kiểm định.\n• Khuôn mới: [Đặt Mới] → nhà cung cấp, ngày hẹn giao → [Xác Nhận Đặt Khuôn]; không đặt trùng khuôn của lệnh. Nhận đủ đơn gia công thì dòng khuôn tự Sẵn sàng và khuôn được thêm vào danh mục khuôn (vị trí Kho Khuôn, không lập phiếu nhập kho kỹ thuật); hoặc [Nghiệm Thu] nhập Vị Trí Kệ Kho → [Xác Nhận Sẵn Sàng (READY)].\n• [Xuất Máy] → [Xác Nhận Bàn Giao Máy]; [Thu Hồi Kho] nhập vị trí và lượt dập → [Xác Nhận Nhập Kho] (lệnh đã có nhật ký sản xuất ở công đoạn dùng khuôn thì lượt dập lấy theo nhật ký, số nhập khi thu hồi không cộng thêm để tránh đếm hai lần); [Dập] ghi lượt dập; [Tem QR] in tem quét mở đúng trang khuôn. Mã khuôn dự kiến chưa có trong kho hiện dạng chữ kèm ghi chú Khuôn chưa có trong kho.\n• Một khuôn chỉ ở một máy; mọi nút khóa khi lệnh Đã chốt kế hoạch."
            }
         ],
         "subFlows": [
            {
               "name": "Khai báo bản kẽm thủ công",
               "steps": [
                  "Kẽm CTP & Log → tab 📋 Danh Mục Bản Kẽm → [Thêm bài in].",
                  "Nhập Tên bản in (bắt buộc), Kích thước, Trạng thái, Khách hàng, Sản phẩm, link file, vị trí kệ, Định Mức Lượt In Tối Đa (mặc định 40.000), Đơn Vị Ra Kẽm, Chi Phí Ra Kẽm → [Tạo mới]. Mã tự sinh PLT-0001.",
                  "Kẽm của lệnh nên tạo bằng Ghi bản kẽm xong (Bước 3) để gắn đúng lệnh và trừ kho."
               ]
            },
            {
               "name": "Chi tiết bản kẽm (/plates/<mã>)",
               "steps": [
                  "Nút: [In lệnh ghi], [In bàn giao], [Duyệt proof] (đã duyệt hiện Proof đã duyệt), theo trạng thái: Chờ nghiệm thu → [Nghiệm thu ghi kẽm]; Sẵn sàng → [Lắp máy in], [Báo hỏng kẽm]; Đang chạy máy → [Báo hỏng]; Hỏng → [Ghi bù kẽm (n)]; [Sửa], [Xoá].",
                  "Sản phẩm, Khách hàng, Lệnh SX trong Lịch sử in là link mở bản ghi. Tab Lịch sử in Offset & Ca máy, Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật.",
                  "Nút [Thanh lý] vẫn hiện nhưng chỉ chạy khi bước được phép: kẽm Sẵn sàng, Đang bảo dưỡng hoặc Hỏng. Kẽm Chờ nghiệm thu hoặc Đang chạy máy bấm Thanh lý sẽ bị từ chối kèm các bước hợp lệ; kẽm in xong tự thanh lý sau 24 giờ khi lệnh đã đóng."
               ]
            },
            {
               "name": "Sửa khuôn / bản kẽm, đổi kệ",
               "steps": [
                  "Chi tiết → [Sửa] mở form có sẵn dữ liệu → [Cập nhật].",
                  "Chi tiết khuôn → [Cập nhật nhanh]: chỉ liệt kê trạng thái hiện tại và các bước được phép, máy dập, ghi chú → [Lưu thay đổi].",
                  "[Đổi kệ kho] hoặc bút chì cạnh Vị trí kệ kho: Khu / Dãy, Kệ / Giá (bắt buộc), Tầng, Ô / Ngăn → [Lưu Vị Trí Mới]; vị trí trên trang đổi ngay."
               ]
            },
            {
               "name": "Xóa khuôn / bản kẽm",
               "steps": [
                  "Khuôn: menu dòng → [Xóa khuôn] hoặc chi tiết → [Xoá] → xác nhận. Bản kẽm: chi tiết → [Xoá], hoặc tích chọn ở Danh Mục Bản Kẽm → [Xoá (n)].",
                  "Xóa là xóa mềm, hệ thống hiện không chặn xóa khuôn / kẽm đã có lịch sử và bản ghi không vào Thùng rác. Chỉ xóa bản ghi nhập nhầm; khuôn / kẽm đã dùng thì Thay khuôn hoặc Thanh lý để giữ lịch sử."
               ]
            },
            {
               "name": "Hàng Chờ CTP (Kế hoạch › Lệnh sản xuất)",
               "steps": [
                  "Tab Hàng Chờ CTP liệt kê các lệnh còn việc ghi bản kẽm, đếm Tổng bài in, Tờ in cần chạy, Kẽm sẵn sàng, Đang ghi bản CTP, Chờ ghi bản kẽm.",
                  "Trên dòng: [Ghi bản] (gửi ghi bản), [Xong] (ghi bản xong, báo kho kẽm đã trừ số lá vừa xuất). Chọn nhiều lệnh: [Gửi ghi bản kẽm], [Xong kẽm], [Xuất Excel]."
               ]
            },
            {
               "name": "Theo dõi ghi kẽm theo bài bình (/production/ctp-tracking, trang cũ)",
               "steps": [
                  "Ba cột Chờ xử lý, Đang ghi kẽm, Hoàn thành với nút [Bắt đầu ghi], [Xong], [Hủy], [Làm lại].",
                  "Trang này chỉ đổi trạng thái bài bình, không tạo bộ kẽm và không trừ kho kẽm. Việc ghi bản kẽm cho lệnh dùng Bước 2 và 3."
               ]
            },
            {
               "name": "In tem và phiếu",
               "steps": [
                  "Khuôn: [In tem] (tem gáy QR), [In phiếu] (Thẻ theo dõi khuôn bế); trong lệnh: [Tem QR].",
                  "Kẽm: [In lệnh ghi], [In bàn giao], nút in bàn giao trên Điều Phối Kẽm; lệnh: [In phiếu kẽm] (Phiếu ghi bản kẽm CTP)."
               ]
            },
            {
               "name": "Danh sách khuôn — menu thao tác trên dòng khuôn",
               "steps": [
                  "[Sẵn sàng sử dụng]: chuyển khuôn về trạng thái sẵn sàng; chỉ hiện khi khuôn chưa ở trạng thái sẵn sàng và chưa hủy, nếu bước chuyển không hợp lệ hệ thống báo lỗi và giữ nguyên trạng thái."
               ]
            },
            {
               "name": "Chi tiết khuôn — khuôn tiền nhiệm / thay thế và sản phẩm ghép",
               "steps": [
                  "[Xem khuôn tiền nhiệm]: trong ô Khuôn tiền nhiệm (khuôn bản cũ đã hủy, kèm lượt dập và lý do hủy), bấm để mở chi tiết khuôn cũ.",
                  "[Xem khuôn thay thế mới]: trong ô khuôn thay thế, bấm để mở chi tiết khuôn phiên bản mới đã thay khuôn này.",
                  "[Xem khuôn thay thế mới →]: nút trên dải cảnh báo đỏ \"Khuôn đã bị hủy / ngưng dùng\" ở đầu trang, mở khuôn thay thế để dùng thay.",
                  "[Thêm sản phẩm ghép] mở hộp thoại Thêm sản phẩm ghép vào khuôn: chọn sản phẩm, nhập số con trên tờ in (UPS, tối thiểu 1) và ghi chú.",
                  "[Xác nhận liên kết]: gắn sản phẩm đã chọn vào khuôn; nút bị mờ khi chưa chọn sản phẩm, thành công báo \"Đã liên kết sản phẩm vào khuôn thành công!\"."
               ]
            },
            {
               "name": "Chi tiết khuôn — Bảo dưỡng / Sửa khuôn (nâng phiên bản)",
               "steps": [
                  "[Bảo dưỡng] trên đầu trang chi tiết khuôn mở hộp thoại bảo dưỡng với hai lựa chọn Bảo dưỡng định kỳ (giữ nguyên phiên bản) và Sửa khuôn (Nâng v).",
                  "[Thêm ảnh hiện trường]: đính kèm một hoặc nhiều ảnh dao bế, mút, vết cắt…; ảnh hiện dạng lưới, bấm biểu tượng thùng rác trên ảnh để bỏ.",
                  "[Đưa vào bảo dưỡng]: nhãn của nút xác nhận khi khuôn đang ở trạng thái Hỏng, bấm để chuyển khuôn sang Đang bảo dưỡng (chưa đặt lại mốc bảo dưỡng).",
                  "[Xác nhận sửa khuôn & Nâng v…] (ví dụ [Xác nhận sửa khuôn & Nâng v2]): khi chọn Sửa khuôn, ghi nhận sửa chữa, nâng phiên bản khuôn lên số đã nhập và đưa khuôn về Sẵn sàng.",
                  "Khi chọn Sửa khuôn mà chưa nhập lý do hoặc nội dung, hệ thống báo \"Vui lòng nhập lý do sửa khuôn hoặc chi tiết thay đổi kỹ thuật!\"; khuôn chưa nghiệm thu sẽ bị từ chối với thông báo cần nghiệm thu trước khi bảo dưỡng."
               ]
            },
            {
               "name": "Thêm / Sửa khuôn — ảnh khuôn",
               "steps": [
                  "[Tải ảnh khuôn]: chọn một ảnh PNG, JPG hoặc WEBP (tối đa 10MB) làm ảnh đại diện của khuôn; ảnh được lưu cùng khuôn khi bấm lưu biểu mẫu."
               ]
            },
            {
               "name": "Bản kẽm — báo hỏng trên danh sách và bảng điều phối CTP",
               "steps": [
                  "[Báo hỏng / Hủy kẽm]: trong menu thao tác của dòng kẽm, chuyển kẽm sang trạng thái Hỏng. Kẽm hỏng không đưa thẳng về Sẵn sàng được (chỉ sang Đang bảo dưỡng hoặc Thanh lý); cần kẽm thay thế thì ghi bản kẽm mới cho lệnh.",
                  "[Báo hỏng kẽm & kích hoạt ghi bù cấp tốc] (nút biểu tượng mũi tên xoay màu đỏ trên dòng kẽm) mở hộp thoại Báo Hỏng Bản Kẽm & Yêu Cầu Ghi Bù Cấp Tốc.",
                  "Trong hộp thoại, tick các màu kẽm bị hỏng, chọn lý do (hoặc Lý do kỹ thuật khác rồi mô tả), chọn mức [⚡ Dừng Máy Chờ Kẽm] hoặc [⏳ Bình Thường] và số lá kẽm ghi bù.",
                  "[Kích Hoạt Lệnh Ghi Bù Kẽm]: chuyển kẽm sang Hỏng, cộng số lần ghi bù và ghi hao hụt vào Nhật ký kẽm CTP; thiếu màu sẽ báo \"Vui lòng chọn ít nhất 1 màu kẽm bị hỏng cần ghi bù\", thiếu lý do báo \"Vui lòng chọn hoặc nhập lý do hỏng kẽm\".",
                  "[In Phiếu Bàn Giao Bản Kẽm CTP ISO 9001] (nút biểu tượng tờ giấy trên dòng kẽm): mở bản xem trước phiếu bàn giao kẽm, bấm [In Ngay] để in hoặc [Tải PDF] để lưu."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "Dòng kẽm của lệnh Chờ ghi bản",
               "to": "Đang ghi bản",
               "action": "[Gửi ghi bản kẽm] / [Ghi bản]",
               "allowedRoles": "Tổ CTP / Kế hoạch (quyền Sửa Lệnh sản xuất)"
            },
            {
               "from": "Dòng kẽm Chờ ghi bản / Đang ghi bản",
               "to": "Đã ghi bản xong (tạo bộ kẽm PLT Chờ nghiệm thu, trừ kho)",
               "action": "[Ghi bản kẽm xong] / [Xong]",
               "allowedRoles": "Tổ CTP"
            },
            {
               "from": "Bộ kẽm Chờ nghiệm thu",
               "to": "Sẵn sàng trên kệ",
               "action": "[Ký Proof] Đạt / Miễn Duyệt, hoặc [Nghiệm thu ghi kẽm]",
               "allowedRoles": "Tổ CTP / Kỹ thuật"
            },
            {
               "from": "Bộ kẽm Sẵn sàng trên kệ",
               "to": "Đang chạy máy",
               "action": "[Lắp Máy] / [Lắp máy in] (máy đúng khổ)",
               "allowedRoles": "Tổ CTP / Xưởng in"
            },
            {
               "from": "Bộ kẽm Sẵn sàng / Đang chạy máy",
               "to": "Hỏng / Sự cố",
               "action": "[Báo hỏng kẽm] / [Báo hỏng] → [Kích Hoạt Lệnh Ghi Bù Kẽm]",
               "allowedRoles": "Xưởng in / Tổ CTP"
            },
            {
               "from": "Bộ kẽm in xong",
               "to": "Đã thanh lý / Hủy",
               "action": "Tự động sau 24 giờ khi lệnh đã đóng; hoặc [Thanh lý] khi kẽm Sẵn sàng / Hỏng",
               "allowedRoles": "Hệ thống / Tổ CTP"
            },
            {
               "from": "Khuôn Chờ nghiệm thu",
               "to": "Sẵn sàng trên kệ",
               "action": "[Nghiệm thu] / [Nghiệm Thu] → [Xác Nhận Sẵn Sàng (READY)]",
               "allowedRoles": "Kho khuôn / Kỹ thuật"
            },
            {
               "from": "Khuôn Sẵn sàng",
               "to": "Đang bảo dưỡng / Hỏng / Sự cố",
               "action": "[Chuyển bảo dưỡng] / [Báo hỏng]",
               "allowedRoles": "Kho khuôn / Xưởng"
            },
            {
               "from": "Khuôn Hỏng / Sự cố",
               "to": "Đang bảo dưỡng",
               "action": "[Bảo dưỡng] (lần 1)",
               "allowedRoles": "Kho khuôn / Kỹ thuật"
            },
            {
               "from": "Khuôn Đang bảo dưỡng",
               "to": "Sẵn sàng trên kệ",
               "action": "[Bảo dưỡng] lần nữa → xác nhận, hoặc [Khôi phục / Sẵn sàng]",
               "allowedRoles": "Kho khuôn / Kỹ thuật"
            },
            {
               "from": "Khuôn chưa thay thế",
               "to": "Đã thanh lý / Hủy (tạo khuôn phiên bản mới)",
               "action": "[Thay khuôn]",
               "allowedRoles": "Kỹ thuật"
            },
            {
               "from": "Dòng khuôn của lệnh chưa sẵn sàng",
               "to": "Sẵn sàng",
               "action": "[Kiểm Định] (khuôn cũ), [Nghiệm Thu] (khuôn mới) hoặc nhận đủ đơn gia công khuôn",
               "allowedRoles": "Kho khuôn / Kỹ thuật"
            }
         ],
         "actionLinks": [
            {
               "from": "Thiết bị SX (máy in)",
               "to": "Kẽm của lệnh",
               "action": "Khổ kẽm quyết định khổ ghi bản và máy lắp được",
               "how": "Xưởng sản xuất › Thiết bị SX › Sửa › Khổ Kẽm CTP (máy in)"
            },
            {
               "from": "Lệnh sản xuất",
               "to": "Bản kẽm",
               "action": "Ghi bản kẽm cho lệnh",
               "how": "Tab 3. Kế hoạch khuôn kẽm → [Gửi ghi bản kẽm] / [Ghi bản kẽm xong], hoặc tab Hàng Chờ CTP"
            },
            {
               "from": "Ghi bản kẽm xong / ghi bù",
               "to": "Nhật Ký Kẽm CTP",
               "action": "Tự ghi xuất và trừ tồn kẽm",
               "how": "Tự động"
            },
            {
               "from": "Bản kẽm",
               "to": "Xưởng in",
               "action": "Bàn giao kẽm lên máy",
               "how": "[Lắp Máy] trên Điều Phối Kẽm, [In bàn giao]"
            },
            {
               "from": "Lệnh sản xuất / chi tiết khuôn",
               "to": "Đơn gia công ngoài",
               "action": "Đặt làm khuôn ngoài",
               "how": "[Đặt Mới] ở tab 3, [Đặt làm ngoài] ở trang khuôn hoặc Kế hoạch khuôn"
            }
         ],
         "quickActions": [
            {
               "action": "Ký Proof / Lắp Máy",
               "description": "Thao tác ngay trên bảng Điều Phối Kẽm, bảng tự cập nhật."
            },
            {
               "action": "Ghi bản / Xong",
               "description": "Gửi ghi bản và xác nhận ghi bản xong ngay trên Hàng Chờ CTP."
            },
            {
               "action": "Nhập kẽm",
               "description": "Ghi kẽm mới về để tăng tồn theo khổ."
            },
            {
               "action": "In tem",
               "description": "In tem gáy QR khuôn, quét mở đúng trang khuôn."
            }
         ],
         "inlineViews": [
            {
               "name": "Thanh hao mòn khuôn",
               "trigger": "Cột lượt dập và chi tiết khuôn",
               "description": "Hiện mức mòn dao theo lượt dập so với chu kỳ bảo dưỡng và định mức tuổi thọ."
            },
            {
               "name": "Độ bền kẽm của lệnh",
               "trigger": "Đầu tab 3. Kế hoạch khuôn kẽm",
               "description": "Số tờ chạy / ngưỡng lượt in của bộ kẽm, kèm khuyến nghị khi vượt."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/14_po_detail_tab3_ctp_plate_durability.png",
               "caption": "Hình 10.1 — Tab 3. Kế hoạch khuôn kẽm của Lệnh sản xuất với cảnh báo độ bền kẽm (80.000 lượt thường / 40.000 lượt UV)"
            }
         ],
         "forms": [],
         "notes": [
            "Gửi ghi bản kẽm và Ghi bản kẽm xong đều cần công đoạn in đã giao máy in và máy đó đã khai báo khổ kẽm.",
            "Kẽm in xuất mới cho mỗi lệnh, dùng 1 lần; lệnh mới chỉ dùng lại file bình, không dùng lại kẽm.",
            "Kẽm Chờ nghiệm thu chưa lắp được lên máy: ký proof Đạt / Miễn Duyệt hoặc Nghiệm thu ghi kẽm trước.",
            "Khuôn hỏng hoặc đang bảo dưỡng không gắn được cho lệnh; một khuôn chỉ ở một máy.",
            "Hệ thống chưa chặn xóa khuôn / kẽm đã có lịch sử; dùng Thay khuôn hoặc Thanh lý thay cho Xóa.",
            "Phiếu ghi bản kẽm CTP, Thẻ theo dõi khuôn bế, Lệnh ghi kẽm CTP, Phiếu bàn giao bản kẽm in từ màn hình này; kiểm tra mã biểu mẫu ISO trên bản in trước khi ban hành."
         ],
         "uatChecklist": [
            {
               "id": "BF-10-01",
               "item": "Khai báo khổ kẽm cho máy in",
               "standard": "Lưu được; chi tiết máy hiện Khổ kẽm CTP 1030x800 mm; ở hộp Lắp máy, máy này hiện kèm khổ.",
               "method": "1. Xưởng sản xuất › Thiết bị SX, mở máy in Komori 1. 2. Bấm [Sửa], ô Khổ Kẽm CTP (máy in) nhập 1030x800 mm. 3. Lưu, mở lại chi tiết máy kiểm tra."
            },
            {
               "id": "BF-10-02",
               "item": "Gửi ghi bản kẽm bị chặn khi công đoạn in chưa giao máy",
               "standard": "Không gửi được, hiện: LSX-…: công đoạn in chưa giao máy in nên chưa biết khổ kẽm — giao máy in ở tab 4. Kế hoạch sản xuất rồi gửi ghi bản kẽm. Kho kẽm không đổi.",
               "method": "1. Mở lệnh mới tạo từ bài bình (Chương 07) chưa giao máy cho công đoạn in. 2. Tab 3. Kế hoạch khuôn kẽm → [Thêm khuôn / kẽm], Loại Kẽm, kiểu CMYK 4 lá → lưu. 3. Bấm [Gửi ghi bản kẽm], đọc thông báo."
            },
            {
               "id": "BF-10-03",
               "item": "Gửi ghi bản kẽm thành công sau khi giao máy in",
               "standard": "Báo Đã gửi ghi bản kẽm cho tổ chế bản; dòng kẽm chuyển Đang ghi bản, khổ kẽm tự lấy 1030x800 mm; tồn kẽm ở Nhật Ký Kẽm CTP chưa giảm.",
               "method": "1. Tab 4. Kế hoạch sản xuất của lệnh ở BF-10-02, giao công đoạn in cho Komori 1. 2. Ghi lại tồn kẽm 1030x800 ở /plates/ctp-logs. 3. Quay lại tab 3 bấm [Gửi ghi bản kẽm]. 4. Kiểm tra nhãn dòng kẽm và tồn kẽm."
            },
            {
               "id": "BF-10-04",
               "item": "Ghi bản kẽm xong tạo bộ kẽm và trừ kho đúng 1 lần",
               "standard": "Báo Đã ghi nhận ghi bản kẽm xong; Điều Phối Kẽm có bộ PLT-… của lệnh ở Chờ Duyệt Proof; tồn kẽm giảm đúng 4 lá; bấm lần 2 báo kẽm đã ghi bản xong hết, tồn không giảm thêm.",
               "method": "1. Tab 3 của lệnh → [Ghi bản kẽm xong]. 2. Mở Kỹ thuật › Kẽm CTP & Log, tab Điều Phối Kẽm, tìm mã lệnh. 3. Mở /plates/ctp-logs so tồn. 4. Bấm [Ghi bản kẽm xong] lần nữa."
            },
            {
               "id": "BF-10-05",
               "item": "Hàng Chờ CTP: Ghi bản và Xong trên danh sách lệnh",
               "standard": "Lệnh có dòng kẽm chờ ghi bản hiện trong Hàng Chờ CTP; bấm Ghi bản chuyển Đang Ghi bản CTP; bấm Xong báo kho kẽm đã trừ số lá vừa xuất, lệnh hiện Kẽm Sẵn Sàng; số đếm đầu trang khớp.",
               "method": "1. Kế hoạch › Lệnh sản xuất › tab Hàng Chờ CTP. 2. Tìm lệnh thứ hai đã giao máy in. 3. Bấm [Ghi bản], rồi [Xong]. 4. So số Chờ ghi bản kẽm / Đang ghi bản CTP / Kẽm sẵn sàng trước và sau."
            },
            {
               "id": "BF-10-06",
               "item": "Ký proof đưa bộ kẽm sang Sẵn sàng",
               "standard": "Nút đổi thành Đã Ký; bộ kẽm chuyển Sẵn sàng trên kệ ngay, không cần tải lại trang; đếm Proof Đã Ký tăng 1.",
               "method": "1. Điều Phối Kẽm, dòng PLT-… ở BF-10-04. 2. Bấm [Ký Proof], chọn ✅ Ký Duyệt Đạt, nhập người ký Nguyễn Văn A → xác nhận."
            },
            {
               "id": "BF-10-07",
               "item": "Lắp kẽm: máy khác khổ bị khóa, máy đúng khổ lắp được",
               "standard": "Ô chọn máy chỉ có máy in; máy chưa khai khổ / khác khổ hiện mờ kèm lý do, Komori 1 được chọn sẵn; lắp xong bộ kẽm sang Đang chạy máy, cột Máy In hiện Komori 1. Kẽm Chờ nghiệm thu lắp thì bị từ chối.",
               "method": "1. Điều Phối Kẽm, dòng đã ký proof → [Lắp Máy]. 2. Mở ô chọn máy, đọc lý do các máy mờ. 3. Chọn Komori 1, Thợ trưởng máy Trần B, tích đủ 4 lá → xác nhận. 4. Thử [Lắp Máy] trên một bộ còn Chờ Duyệt Proof."
            },
            {
               "id": "BF-10-08",
               "item": "Báo hỏng và ghi bù kẽm",
               "standard": "Bộ kẽm sang Hỏng / Sự cố, đếm Sự Cố / Ghi Bù tăng; chi tiết kẽm hiện Đã ghi bù 1 lần; Nhật Ký Kẽm CTP có dòng xuất số lá ghi bản lại, tồn giảm tương ứng.",
               "method": "1. Mở bộ kẽm Đang chạy máy ở BF-10-07 → [Báo hỏng]. 2. Lý do Trầy lá Cyan, 1 lá → [Kích Hoạt Lệnh Ghi Bù Kẽm]. 3. Mở /plates/ctp-logs kiểm tra."
            },
            {
               "id": "BF-10-09",
               "item": "Nhập kẽm vào Nhật Ký Kẽm CTP",
               "standard": "Dòng mới hiện đúng ngày; Tồn kẽm hiện tại khổ 1030x800 mm tăng 100; ô Tồn không cho nhập tay.",
               "method": "1. Mở /plates/ctp-logs. 2. Bấm [Nhập kẽm], Tên Kẽm 1030x800 mm, SL Nhập 100 → [Thêm mới]. 3. Xem đầu trang và cột Tồn."
            },
            {
               "id": "BF-10-10",
               "item": "Thêm, sửa, xóa khuôn",
               "standard": "Tạo: báo Đã tạo khuôn thành công!, mã DC-…, mặc định 100.000 / 25.000 lượt. Trùng tên bị chặn. Sửa mở form có sẵn dữ liệu. Xóa khuôn nhập nhầm thì khuôn rời danh sách.",
               "method": "1. Kỹ thuật › Quản lý Khuôn → [Thêm khuôn mới], Tên KB Hộp test 01, Loại Khuôn bế, Dài 300, Rộng 200, Số UPS 4 → [Tạo mới]. 2. Tạo lại cùng tên. 3. Mở khuôn → [Sửa], đổi Số UPS 6 → [Cập nhật]. 4. Tạo khuôn KB Nhập nhầm rồi [Xoá]."
            },
            {
               "id": "BF-10-11",
               "item": "Vòng đời khuôn chỉ hiện bước hợp lệ",
               "standard": "Khuôn Hỏng không có nút Khôi phục / Sẵn sàng; Bảo dưỡng lần 1 chuyển Đang bảo dưỡng; lần 2 về Sẵn sàng; tab KCS, Bảo trì & Nhật ký ghi giờ, trạng thái cũ → mới và người thực hiện.",
               "method": "1. Mở khuôn ở BF-10-10, bấm [Nghiệm thu] nếu đang chờ. 2. [Báo hỏng]. 3. Kiểm tra các nút. 4. [Bảo dưỡng], chọn Bảo dưỡng định kỳ, lưu. 5. [Bảo dưỡng] lần nữa → xác nhận. 6. Mở tab KCS, Bảo trì & Nhật ký."
            },
            {
               "id": "BF-10-12",
               "item": "Ghi nhận lượt dập khuôn",
               "standard": "Lưu được, lượt dập lũy kế tăng 5.000 và thanh hao mòn cập nhật ngay; dòng mới ở tab Lịch sử dập máy MES có mã lệnh là link.",
               "method": "1. Chi tiết khuôn → tab Lịch sử dập máy MES → [Ghi nhận lượt dập]. 2. Mã lệnh LSX của BF-10-02, Số lượt dập 5.000, Máy dập, Thợ vận hành → lưu."
            },
            {
               "id": "BF-10-13",
               "item": "Khuôn cho lệnh: gán khuôn kho, kiểm định, đặt mới, tem QR",
               "standard": "Gán khuôn chỉ liệt kê khuôn đúng loại, không hỏng / không bảo dưỡng; Kiểm Định xong dòng Sẵn sàng; Đặt Mới tạo đơn gia công, đặt trùng bị chặn; Tem QR quét mở đúng trang khuôn; khuôn dự kiến ghi Khuôn chưa có trong kho.",
               "method": "1. Tab 3 của lệnh có công đoạn bế. 2. Biểu tượng tìm → chọn khuôn ở BF-10-10 → [Gán Khuôn Này] → [Kiểm Định] → [Xác Nhận Đạt Chuẩn READY]. 3. Dòng khuôn khác: [Đặt Mới], chọn NCC, ngày hẹn → [Xác Nhận Đặt Khuôn]; bấm Đặt Mới lần nữa. 4. Bấm [Tem QR], quét bằng điện thoại."
            },
            {
               "id": "BF-10-14",
               "item": "Chi tiết kẽm: link bản ghi cha, 3 tab và điện thoại 390px",
               "standard": "Sản phẩm, Khách hàng, Lệnh SX là link; có tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật. Trên 390px, tab Điều Phối Kẽm / Danh Mục Bản Kẽm cuộn ngang được, bảng kéo ngang, nút Ký Proof và Lắp Máy bấm được, không tràn trang.",
               "method": "1. Mở bộ kẽm PLT-… ở BF-10-04, bấm từng link. 2. Viết 1 thảo luận, đính kèm ảnh proof, mở Lịch sử cập nhật. 3. Chuyển trình duyệt sang 390 x 844, mở Kẽm CTP & Log, thử Ký Proof."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "Nhân Viên Kỹ Thuật / Chế Bản",
               "createTest": "Thêm khuôn mới, thêm bài in, Nhập kẽm.",
               "readTest": "Xem Điều Phối Kẽm, Danh mục khuôn, Kế hoạch khuôn, Nhật Ký Kẽm CTP.",
               "updateTest": "Ký proof, lắp máy, báo hỏng ghi bù, bảo dưỡng khuôn.",
               "deleteTest": "Xóa khuôn / bản kẽm nhập nhầm.",
               "expectedResult": "Làm được đủ thao tác; trạng thái chỉ đi theo bước hợp lệ."
            },
            {
               "roleGroup": "Kế Hoạch Sản Xuất",
               "createTest": "Thêm dòng kẽm / khuôn cho lệnh ở tab 3.",
               "readTest": "Xem độ bền kẽm, số dòng sẵn sàng của lệnh.",
               "updateTest": "Giao máy in cho công đoạn in, Gửi ghi bản kẽm.",
               "deleteTest": "Xóa dòng khuôn / kẽm của lệnh chưa chốt kế hoạch.",
               "expectedResult": "Gửi ghi bản được khi đã giao máy in có khổ kẽm; lệnh Đã chốt kế hoạch thì các nút bị khóa."
            },
            {
               "roleGroup": "Giám Đốc / Quản Đốc Sản Xuất (xưởng in / bế)",
               "createTest": "Thử Thêm khuôn mới (nếu vai trò mã PRODUCTION thì bị từ chối).",
               "readTest": "Xem khuôn, kẽm đang chạy máy.",
               "updateTest": "Báo hỏng kẽm, ghi nhận lượt dập, thu hồi khuôn về kho.",
               "deleteTest": "Thử xóa khuôn.",
               "expectedResult": "Ghi nhận vận hành được; vai trò PRODUCTION không tạo, không xóa được khuôn."
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 11. Xưởng Sản Xuất: Kế Hoạch Công Đoạn, Nhật Ký Sản Xuất, Bàn Giao BTP & Thiết Bị
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "factory",
         "aliases": [
            "shopfloor",
            "mes",
            "manufacturing",
            "process-planning",
            "production-scheduling",
            "production-logs",
            "machine-logs",
            "wip-transfer",
            "wip-transfers",
            "machines",
            "mes-incidents",
            "mes-maintenance",
            "maintenance",
            "incidents",
            "shopfloor-terminal",
            "loss-time-analytics",
            "oee",
            "andon"
         ],
         "title": "11. Xưởng Sản Xuất: Kế Hoạch Công Đoạn, Nhật Ký Sản Xuất, Bàn Giao BTP & Thiết Bị",
         "icon": "Factory",
         "isoRef": "QT-SX-04",
         "purpose": "Hướng dẫn anh/chị ở xưởng làm đúng trên phần mềm từ ngày golive 02/11/2026: xem và điều độ công đoạn của các Lệnh sản xuất (LSX) trên Kế hoạch sản xuất, bắt đầu và kết thúc công đoạn, ghi sản lượng Đạt/Hỏng vào Nhật ký sản xuất, ghi nhật ký máy (vận hành, dừng máy, bảo trì), bàn giao bán thành phẩm (BTP) giữa các công đoạn, thao tác trên Màn hình xưởng (máy tính bảng, điện thoại), báo sự cố và bảo trì thiết bị, quản lý danh mục Thiết bị SX. Mọi số liệu sản lượng của công đoạn và LSX được tính từ nhật ký sản xuất, nên ghi đúng nhật ký là việc quan trọng nhất của xưởng.",
         "scope": [
            "Menu Xưởng sản xuất có 6 mục: Kế hoạch sản xuất, Nhật ký sản xuất, Đóng Gói & Nhập Kho, Sự cố thiết bị, Bảo trì bảo dưỡng, Thiết bị SX. Đóng Gói & Nhập Kho hướng dẫn ở mục con cùng tên của chương này.",
            "Các màn hình không có mục menu riêng, mở bằng đường dẫn hoặc nút trong trang: Nhật ký máy (chế độ xem Thiết Bị & OEE trong Nhật ký sản xuất, hoặc /machine-logs), Sổ Giao Nhận BTP (/wip-transfer), Màn hình xưởng cho thợ máy (/mes hoặc /shopfloor/terminal), Bảng giám sát Andon (/mes/andon), Hiệu suất OEE (/mes/oee), Phân tích tổn thất máy (/shopfloor/loss-time-analytics). Đường dẫn /production-scheduling mở cùng màn hình Kế hoạch sản xuất.",
            "Người dùng chính: Quản đốc / Giám đốc sản xuất (PRODUCTION_MANAGER), Tổ trưởng và thợ vận hành máy (OPERATOR), Kế hoạch sản xuất (PLANNER) khi điều độ lịch máy, Kỹ thuật cơ điện khi xử lý sự cố, QC khi kiểm công đoạn và thành phẩm.",
            "Chỉ hiện công đoạn của LSX đã có quy trình công đoạn. Lập, duyệt, ban hành LSX và bình file xem chương Lệnh sản xuất và chương Bình file; kiểm IPQC, FQC xem chương KCS."
         ],
         "responsibilities": [
            {
               "role": "Quản đốc / Giám đốc sản xuất (PRODUCTION_MANAGER)",
               "tasks": [
                  "Mỗi đầu ca xem Kế hoạch sản xuất theo tab nhóm công đoạn, lọc Hôm nay và Chờ chạy để giao việc",
                  "Kiểm tra nhật ký sản xuất trong ngày; nhật ký sai LSX hoặc sai công đoạn thì xóa và nhập lại",
                  "Theo dõi Sự cố thiết bị, tiếp nhận và nghiệm thu khôi phục máy; lập lịch bảo trì định kỳ",
                  "Xem Andon xưởng, Hiệu suất OEE, Phân tích tổn thất máy"
               ]
            },
            {
               "role": "Tổ trưởng / Thợ vận hành máy (OPERATOR)",
               "tasks": [
                  "Kiểm tra đầu ca, bắt đầu và kết thúc công đoạn trên Màn hình xưởng hoặc nút [Bắt đầu] / [Check-out] ở tab Quy trình của LSX",
                  "Ghi sản lượng Đạt/Hỏng ngay khi xong mẻ: nút [Ghi Nhật Ký] trên Kế hoạch sản xuất hoặc [Thêm Nhật Ký] trên Nhật ký sản xuất",
                  "Lập phiếu bàn giao BTP cho công đoạn sau và tiếp nhận BTP từ công đoạn trước",
                  "Ghi dừng máy, báo sự cố ngay khi máy có vấn đề"
               ]
            },
            {
               "role": "Kế hoạch sản xuất (PLANNER)",
               "tasks": [
                  "Gán hoặc đổi máy, thợ, giờ bắt đầu, hạn hoàn thành, % gối đầu trong hộp Điều Độ & Gán Lịch Máy Sản Xuất",
                  "Xử lý cảnh báo chồng lịch, khóa / mở khóa lịch, dùng [Xếp theo hạn] trên Gantt khi cần xếp lại một máy",
                  "Theo dõi LSX trễ hạn trên Gantt, in và xuất Excel kế hoạch"
               ]
            },
            {
               "role": "Kỹ thuật cơ điện",
               "tasks": [
                  "Tiếp nhận phiếu sự cố, sửa máy, nghiệm thu và khôi phục máy",
                  "Cập nhật danh mục Thiết bị SX: loại máy, công đoạn máy làm được, chu kỳ bảo trì, Khổ Kẽm CTP của máy in"
               ]
            },
            {
               "role": "Ban Giám đốc & Quản trị viên (DIRECTOR / ADMIN)",
               "tasks": [
                  "Xem toàn bộ số liệu xưởng, OEE, Andon",
                  "Khôi phục bản ghi đã xóa từ tab Thùng rác của từng danh sách"
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền."
            },
            {
               "role": "PRODUCTION_MANAGER, OPERATOR, PLANNER và các vai trò nghiệp vụ khác",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Kế hoạch sản xuất, Nhật ký sản xuất, Bàn giao BTP, Màn hình xưởng, Sự cố và Bảo trì: chỉ cần đăng nhập. Nhật ký máy kiểm tra quyền nhật ký máy; Thiết bị SX chỉ hiện nút Thêm TB / Sửa / Thanh lý / Xoá khi vai trò có quyền thiết bị. Vai trò chưa được cấu hình quyền trong Phân quyền thì đang được dùng đủ chức năng (trừ Người dùng và Phân quyền). Dù có quyền, phần mềm vẫn chặn theo quy tắc nghiệp vụ (LSX chưa ban hành, vượt sản lượng công đoạn trước, máy sai loại...)."
            }
         ],
         "terms": [
            {
               "term": "Công đoạn",
               "definition": "Một bước trong quy trình của LSX (Cắt giấy, In, Cán màng, Bế, Dán...). Mỗi công đoạn có máy, thợ, giờ bắt đầu, hạn hoàn thành, số lượng kế hoạch và sản lượng Đạt."
            },
            {
               "term": "Tab nhóm công đoạn",
               "definition": "Kế hoạch sản xuất chia tab: Tất cả, Cắt giấy, In ấn, Cán màng, Tráng phủ, Bế - Ép nhũ, Dán, Thành phẩm. Số bên cạnh tab là số công đoạn theo bộ lọc đang chọn."
            },
            {
               "term": "Trạng thái công đoạn",
               "definition": "Chờ chạy, Sẵn sàng (đã nhận BTP), Đã lên lịch, Đang chạy, Tạm dừng, Hoàn thành, Hủy bỏ (Không làm). Bộ lọc Trạng thái trên Kế hoạch sản xuất gom thành: Chờ chạy, Đang chạy, Tạm dừng, Hoàn thành, Quá hạn."
            },
            {
               "term": "Điều kiện bắt đầu công đoạn",
               "definition": "Chỉ bắt đầu được khi LSX đã ban hành và không ở trạng thái Tạm dừng, Tạm ngưng, Đã sản xuất, Đã hủy; công đoạn chưa Hoàn thành / chưa Hủy; kẽm, khuôn của LSX đã sẵn sàng. Nếu không đạt, phần mềm báo rõ lý do và không cho bắt đầu."
            },
            {
               "term": "Giới hạn sản lượng theo công đoạn trước",
               "definition": "Tổng Đạt + Hỏng đã ghi của một công đoạn không được vượt sản lượng Đạt của công đoạn liền trước (quy đổi theo số lượng kế hoạch từng công đoạn, ví dụ tờ in sang con sau bế), cho phép dư 5%. Áp dụng khi ghi ở form Nhật ký sản xuất và trên Màn hình xưởng. Công đoạn đầu tiên không bị giới hạn này."
            },
            {
               "term": "Nhật ký sản xuất",
               "definition": "Bản ghi sản lượng của một công đoạn: LSX, công đoạn, máy, người thực hiện, ca, giờ bắt đầu / kết thúc, Số lượng đạt (OK), Số lượng hỏng (NG), lý do lỗi. Lưu, sửa, xóa nhật ký đều tự tính lại sản lượng công đoạn và LSX. Đã lưu thì không đổi được LSX và công đoạn."
            },
            {
               "term": "BTP và Phiếu bàn giao",
               "definition": "Bán thành phẩm xong một công đoạn được bàn giao sang công đoạn sau bằng phiếu bàn giao (mã phiếu, số tờ, pallet). Trạng thái phiếu: Đang chuyển, Đã nhận, Đã hủy."
            },
            {
               "term": "Nhật ký máy",
               "definition": "Ghi tình trạng máy theo ca. Loại: Vận hành, Dừng máy, Bảo trì (chọn trên form). Ngoài ra phần mềm tự tạo: loại Chuẩn bị máy khi thợ nộp Kiểm Tra Đầu Ca trên Màn hình xưởng, loại Bảo trì khi báo sự cố."
            },
            {
               "term": "Trạng thái máy",
               "definition": "Chờ việc, Đang chạy, Bảo trì, Hỏng máy."
            },
            {
               "term": "Lịch máy và khóa lịch",
               "definition": "LSX được xếp vào khe trống sớm nhất của máy trong giờ ca 08:00–12:00, 13:00–17:00, nghỉ Chủ nhật; tăng ca 17:00–20:00 chỉ dùng khi cần kịp hạn. Một máy không xếp chồng hai việc; nếu anh/chị sửa tay làm chồng lịch thì phải xác nhận và công đoạn được khóa lịch (biểu tượng ổ khóa), lần xếp sau không dời."
            },
            {
               "term": "Gối đầu (% Overlap)",
               "definition": "Gối đầu x% nghĩa là công đoạn sau được bắt đầu khi công đoạn trước đã chạy (100 − x)% (gối đầu 25% thì bắt đầu khi công đoạn trước xong 75%). Sau bước In có chờ khô mực thì không gối đầu."
            },
            {
               "term": "Chờ khô mực",
               "definition": "Sau công đoạn In, nếu công đoạn kế là Cán màng / Tráng phủ / Ép kim / Bế thì phần mềm tự cộng giờ chờ khô khi xếp lịch (số giờ chỉnh trong Cấu hình). Gantt hiện nhãn Chờ khô."
            },
            {
               "term": "MTTR / MTBF / OEE",
               "definition": "MTTR: thời gian sửa trung bình mỗi lần; MTBF: thời gian trung bình giữa hai lần sự cố; OEE = Sẵn sàng x Hiệu suất x Chất lượng, xem tại /mes/oee."
            }
         ],
         "processFlowchart": "graph TD\n    A[LSX đã ban hành, có quy trình công đoạn, kẽm khuôn sẵn sàng] --> B[Kế hoạch sản xuất - xếp máy, thợ, giờ chạy]\n    B --> C{Bắt đầu công đoạn}\n    C -->|LSX chưa ban hành, tạm dừng, tạm giữ, đã hủy hoặc công đoạn đã xong| X[Phần mềm báo lý do, không cho bắt đầu]\n    C -->|Đạt điều kiện| D[Công đoạn Đang chạy, máy Đang chạy, LSX chuyển Đang sản xuất]\n    D --> E[Ghi nhật ký sản xuất - SL Đạt và SL Hỏng]\n    E --> F{Vượt SL Đạt công đoạn trước quá 5 phần trăm}\n    F -->|Có| H[Chặn không cho lưu, báo số tối đa]\n    F -->|Không| I[Cộng sản lượng vào công đoạn và LSX]\n    I --> J[Kết thúc công đoạn - Hoàn thành cần có sản lượng]\n    J --> K[Lập phiếu bàn giao BTP sang công đoạn sau]\n    K --> L[Công đoạn sau tiếp nhận - chuyển Sẵn sàng]\n    L --> C\n    J --> M[Công đoạn cuối xong - QC kiểm FQC]\n    M --> N[Đóng gói và Nhập kho TP - chương KCS và Kho]\n    D --> P{Máy gặp sự cố}\n    P -->|Có| Q[Báo sự cố - máy Hỏng máy]\n    Q --> R[Tiếp nhận - máy Bảo trì]\n    R --> S[Nghiệm thu và khôi phục máy - Chờ việc hoặc Đang chạy]\n    S --> D",
         "mainFlow": [
            {
               "step": 1,
               "action": "Xem kế hoạch công đoạn đầu ca",
               "detail": "• Vào Xưởng sản xuất › Kế hoạch sản xuất. Mỗi dòng là một công đoạn: LSX, đơn hàng / khách hàng, sản phẩm (có ảnh thu nhỏ ở chế độ Nhóm ngày và Kanban máy), công đoạn, máy / thợ, giờ kế hoạch và hạn, số lượng kế hoạch, sản lượng Đạt, % tiến độ, Còn lại, trạng thái.\n• Tab nhóm công đoạn: Tất cả, Cắt giấy, In ấn, Cán màng, Tráng phủ, Bế - Ép nhũ, Dán, Thành phẩm.\n• Bộ lọc: Thời gian (Mọi thời gian, Hôm qua, Hôm nay, Ngày mai, Tuần này, Tùy chọn...), Trạng thái (Chờ chạy, Đang chạy, Tạm dừng, Hoàn thành, Quá hạn — có số đếm), Máy, Phạm vi (LSX ban hành / Mọi LSX), nút [Việc của tôi]. Nút [Xóa lọc] bỏ hết bộ lọc. Tìm kiếm dùng ô tìm chung trên đầu trang.\n• Chế độ xem: Nhóm ngày, Gantt, Kanban máy, Bảng. Bấm vào dòng / thẻ / thanh Gantt để mở hộp Điều Độ & Gán Lịch Máy Sản Xuất; bấm mã LSX ở chế độ Nhóm ngày, Gantt, Kanban để mở LSX.\n• [Xuất Excel] xuất theo bộ lọc; [In kế hoạch] in bản KẾ HOẠCH SẢN XUẤT khổ ngang; chọn nhiều dòng để Xuất Excel hoặc In riêng các dòng đó. Nút [Tạo LSX] mở trang tạo lệnh."
            },
            {
               "step": 2,
               "action": "Gán / đổi máy và lịch chạy",
               "detail": "• Lịch được xếp tự động khi LSX lên kế hoạch: mỗi công đoạn vào khe trống sớm nhất của máy trong giờ ca, không chồng việc của LSX khác.\n• Trong hộp Điều Độ & Gán Lịch Máy Sản Xuất: chọn máy, thợ, Dự kiến bắt đầu, Hạn hoàn thành, % gối đầu, ô Khóa lịch công đoạn này, bấm [Lưu Điều Độ].\n• Chọn máy sai loại so với công đoạn (ví dụ máy bế cho công đoạn In) thì bị chặn với thông báo máy không làm được công đoạn này.\n• Giờ mới chồng lên việc khác trên cùng máy: hộp Máy đã có việc trong khung giờ này hiện danh sách LSX bị chồng; bấm [Quay lại sửa] hoặc [Vẫn lưu và khóa lịch].\n• Trên Gantt: [Theo Ngày] / [Chi Tiết Giờ], nút Lùi / Tiến thời gian; dòng Chờ xếp máy là công đoạn chưa có máy; nhãn Trễ N ngày là LSX không kịp hạn giao (rê chuột xem gợi ý máy cùng loại). Nút [Xếp theo hạn] trên từng máy cho xem trước thứ tự mới theo hạn giao rồi bấm [Lưu]; công đoạn đang chạy hoặc đã khóa lịch giữ nguyên. Gantt không kéo thả."
            },
            {
               "step": 3,
               "action": "Bắt đầu công đoạn",
               "detail": "• Cách 1 (thợ máy): Màn hình xưởng, chọn máy, chọn bài trong Hàng Đợi Ca Máy, bấm [⚡ CĂN CHỈNH] hoặc [▶ CHẠY NGAY], xác nhận.\n• Cách 2 (quản đốc / kế hoạch): mở LSX › tab Quy trình, bấm [Bắt đầu] ở dòng công đoạn.\n• Phần mềm từ chối và báo lý do khi: LSX chưa ban hành / đã hủy / đóng; LSX đang tạm dừng, tạm giữ hoặc đã sản xuất xong; công đoạn đã Hoàn thành hoặc đã Hủy; kẽm hoặc khuôn của LSX chưa sẵn sàng.\n• Bắt đầu thành công: công đoạn Đang chạy, máy Đang chạy, LSX đang chuẩn bị chuyển sang Đang sản xuất. Hàng đợi của Màn hình xưởng chỉ hiện LSX xưởng làm được (không có lệnh nháp, chờ duyệt, đã hủy, tạm dừng)."
            },
            {
               "step": 4,
               "action": "Ghi sản lượng (Nhật ký sản xuất)",
               "detail": "• Cách 1: Kế hoạch sản xuất, bấm [Ghi Nhật Ký] ở dòng công đoạn — form điền sẵn LSX, công đoạn, máy, kế hoạch, đã đạt, còn lại.\n• Cách 2: Xưởng sản xuất › Nhật ký sản xuất, bấm [Thêm Nhật Ký], hoặc [Quét LSX] để quét mã vạch / gõ mã LSX.\n• Nhập: Lệnh sản xuất *, Công đoạn kế hoạch *, Máy sản xuất *, Người thực hiện *, Ca làm việc, Giờ bắt đầu làm việc, Giờ kết thúc / Ghi nhận (nút nhanh -30p, -1h, -2h, Bây giờ), Số lượng đạt (OK) *, Số lượng hỏng / Phế phẩm (NG), Lý do lỗi / Ghi nhận sự cố, Ghi chú vận hành, bấm [Lưu Nhật Ký Sản Xuất]. Thông báo: Ghi nhận sản lượng sản xuất thành công!\n• Chọn theo thứ tự Lệnh sản xuất → Công đoạn → Máy: ô Công đoạn chỉ có công đoạn của LSX đã chọn; ô Máy khoá tới khi chọn công đoạn, chọn công đoạn thì máy theo kế hoạch được điền sẵn và danh sách chỉ có máy làm được công đoạn đó (VD công đoạn bế chỉ có máy bế, máy ép nhũ). Ô Người thực hiện chỉ có nhân sự phòng sản xuất, cạnh tên ghi tổ (In, Bế, Dán…); người đăng nhập thuộc sản xuất được điền sẵn.\n• Bị chặn khi: giờ kết thúc trước giờ bắt đầu; LSX chưa ban hành hoặc đã hủy / đóng; công đoạn không thuộc LSX đã chọn; máy không dùng cho công đoạn (thông báo ghi tên máy và công đoạn); người thực hiện không thuộc phòng sản xuất; tổng Đạt + Hỏng vượt sản lượng Đạt của công đoạn trước quá 5% (thông báo ghi rõ số tối đa và nhắc ghi sản lượng công đoạn trước trước).\n• Sản lượng lưu xong tự cộng vào công đoạn và LSX, hiện ngay trên Kế hoạch sản xuất và tab Quy trình của LSX."
            },
            {
               "step": 5,
               "action": "Sửa hoặc xóa nhật ký nhập sai",
               "detail": "• Bấm vào dòng nhật ký để mở form Cập nhật nhật ký sản xuất. Sửa được máy, người thực hiện, ca, giờ, số lượng, lý do lỗi, ghi chú rồi bấm [Cập Nhật Nhật Ký].\n• Ô Lệnh sản xuất và Công đoạn kế hoạch bị khóa: nhật ký ghi nhầm LSX hoặc nhầm công đoạn thì xóa nhật ký đó và nhập lại nhật ký mới.\n• Xóa: biểu tượng thùng rác cuối dòng (hoặc chọn nhiều dòng › Xóa), xác nhận [Xóa]. Sản lượng của công đoạn và LSX được trừ lại. Nhật ký đã xóa nằm ở Thùng rác của danh sách.\n• Phần dưới form nhật ký có link tới LSX, máy, thợ và các tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật, kèm người tạo / người cập nhật."
            },
            {
               "step": 6,
               "action": "Kết thúc công đoạn",
               "detail": "• Màn hình xưởng: [🏁 BƯỚC 3: KẾT THÚC BÀI CHẠY], nhập SL chốt, bấm [🏁 Xác Nhận Hoàn Thành Bài]. Phần SL chốt chênh so với nhật ký đã ghi được ghi thêm thành nhật ký; SL chốt không được thấp hơn số đã ghi (muốn giảm thì sửa / xóa nhật ký thừa).\n• Tab Quy trình của LSX: bấm [Check-out], nhập SL Đạt chuẩn (OK), SL Phế phẩm (NG), thời gian chạy, ca, bấm [Xác Nhận Check-out].\n• Đổi công đoạn sang Hoàn thành mà chưa có sản lượng nào thì bị chặn: ghi nhật ký sản xuất trước.\n• Xong: máy về Chờ việc, công đoạn kế tiếp chuyển Sẵn sàng, có tem pallet BTP để in. Khi mọi công đoạn xong, LSX chuyển Đã sản xuất."
            },
            {
               "step": 7,
               "action": "Bàn giao BTP sang công đoạn sau",
               "detail": "• Mở Sổ Giao Nhận BTP (/wip-transfer), bấm [Tạo Bàn Giao]. Hoặc trên Màn hình xưởng bấm [Bàn Giao BTP]; hoặc tab Quy trình của LSX bấm [Giao BTP].\n• Nhập Lệnh Sản Xuất *, Công đoạn xuất * (hiện tồn BTP), Công đoạn nhận *, Số lượng bàn giao (Tờ) *, Mã Kiện / Pallet, Thợ máy giao ca, Ghi chú. Thông báo: Tạo phiếu bàn giao bán thành phẩm thành công.\n• Bị chặn khi: công đoạn xuất chưa có sản lượng Đạt; số chuyển vượt tồn BTP khả dụng; LSX nháp, chờ duyệt, đã hủy, đã xong.\n• Bên nhận bấm [Nhận] trên phiếu Đang chuyển, nhập số thực nhận, Phế phẩm / Lỗi phát hiện (Tờ), người nhận, ghi chú, bấm [Xác nhận tiếp nhận]. Số nhận + phế không được vượt số đã giao; phiếu đã hủy hoặc đã nhận không nhận lại được. Công đoạn nhận đang Chờ chạy / Đã lên lịch chuyển Sẵn sàng."
            },
            {
               "step": 8,
               "action": "Ghi nhật ký máy, dừng máy",
               "detail": "• Nhật ký sản xuất › chế độ xem Thiết Bị & OEE (hoặc /machine-logs). Lọc Tất cả / Vận hành / Dừng máy và theo ngày.\n• Bấm [Ghi sản lượng] mở form: Chọn Máy, Lệnh Sản Xuất (LSX), Ngày, Ca làm việc, Người vận hành, Loại Nhật ký (Vận hành / Dừng máy / Bảo trì).\n• Dừng máy: Loại sự cố / Lý do dừng máy, Thời gian dừng (phút), Nguyên nhân cụ thể, Biện pháp khắc phục. Vận hành: thời gian chạy, sản lượng, phế phẩm (có phế phải nhập lý do hoặc ảnh, tối đa 3 ảnh), tốc độ, áp lực, nhiệt độ. Bấm [Lưu Nhật ký].\n• Bấm dòng để xem nhanh, có [Sửa] và [Xem đầy đủ]. Màn hình không có nút xóa nhật ký máy.\n• Lưu ý: sản lượng tính cho LSX lấy từ Nhật ký sản xuất, không lấy từ nhật ký máy."
            },
            {
               "step": 9,
               "action": "Màn hình xưởng cho thợ máy (/mes)",
               "detail": "• Dùng trên máy tính bảng hoặc điện thoại. Ba góc nhìn: MA TRẬN XƯỞNG MES, BẢNG KẾ HOẠCH CA, TRẠM CẢM ỨNG MÁY. Chọn máy để vào trạm, chọn thợ máy.\n• [Kiểm Tra Đầu Ca]: tick các hạng mục an toàn, bấm [Xác Nhận Nộp Phiếu] (tạo nhật ký máy loại Chuẩn bị máy).\n• Chạy bài: [⚡ CĂN CHỈNH] rồi [▶️ CHUYỂN SANG CHẠY MÁY (RUN)], hoặc [▶ CHẠY NGAY].\n• Báo sản lượng: [📋 BƯỚC 2: BÁO SẢN LƯỢNG KÈM ẢNH], nhập Đạt / Phế, lý do, ảnh, bấm [Lưu Sản Lượng & Cập Nhật Tiến Độ] — được ghi vào Nhật ký sản xuất, cùng giới hạn theo công đoạn trước.\n• Kết thúc: [🏁 BƯỚC 3: KẾT THÚC BÀI CHẠY]. Máy có vấn đề: [BÁO SỰ CỐ], chọn nhóm, lý do, bấm [KÍCH HOẠT BÁO SỰ CỐ]."
            },
            {
               "step": 10,
               "action": "Báo sự cố và bảo trì thiết bị",
               "detail": "• Xưởng sản xuất › Sự cố thiết bị, bấm [Báo sự cố]: chọn thiết bị, loại sự cố (Cơ khí, Điện / Điều khiển, Khí nén / Bơm, Mực in / Hệ thống lô, Khuôn bế / Dao, Sự cố khác), mức độ (DỪNG MÁY KHẨN CẤP hoặc Cảnh Báo Vận Hành), mô tả, bấm [Xác Nhận Báo Sự Cố]. Máy chuyển Hỏng máy.\n• Phiếu CHỜ TIẾP NHẬN: [Tiếp Nhận], nhập kỹ thuật viên, [Xác Nhận Tiếp Nhận]; phiếu ĐANG SỬA CHỮA, máy Bảo trì.\n• Sửa xong: [Nghiệm Thu & Đóng], nhập Phương Án Sửa Chữa / Khắc Phục, Thời Gian Sửa (Phút), Trạng Thái Sau Khôi Phục (CHỜ VIỆC / CHẠY TIẾP), phụ tùng thay, bấm [Nghiệm Thu & Khôi Phục Máy].\n• Xưởng sản xuất › Bảo trì bảo dưỡng có thêm [Lập lịch PM]. Ba tab: Sự cố đang xử lý, Giờ chạy & PM, Lịch sử sửa chữa. Nút [Andon xưởng] mở bảng giám sát."
            },
            {
               "step": 11,
               "action": "Bàn giao cho QC và đóng gói",
               "detail": "• Trong khi chạy, QC kiểm công đoạn (IPQC) tại KCS công đoạn; xưởng chỉ chạy tốc độ cao sau khi QC ký mẫu.\n• Công đoạn cuối xong, QC lập phiếu KCS thành phẩm (FQC); SL Đạt của FQC không vượt sản lượng công đoạn cuối đã ghi nhật ký. Trên Màn hình xưởng có nút [Nghiệm Thu FQC & Nhập Kho] để mở phiếu FQC cho LSX đang chạy.\n• Lô FQC Đạt sang Xưởng sản xuất › Đóng Gói & Nhập Kho để đóng gói, in tem thùng và nhập kho thành phẩm (xem chương KCS và chương Kho)."
            }
         ],
         "subFlows": [
            {
               "name": "Nhật ký sản xuất — Thêm mới",
               "steps": [
                  "Vào Xưởng sản xuất › Nhật ký sản xuất, bấm [Thêm Nhật Ký] (hoặc [Ghi Nhật Ký] trên dòng công đoạn ở Kế hoạch sản xuất).",
                  "Chọn Lệnh sản xuất (có link Quét mã LSX), Công đoạn kế hoạch, Máy sản xuất, Người thực hiện, Ca làm việc.",
                  "Chỉnh Giờ bắt đầu làm việc và Giờ kết thúc / Ghi nhận bằng nút -30p, -1h, -2h, Bây giờ.",
                  "Nhập Số lượng đạt (OK), Số lượng hỏng / Phế phẩm (NG), lý do lỗi nếu có.",
                  "Bấm [Lưu Nhật Ký Sản Xuất]. Thông báo: Ghi nhận sản lượng sản xuất thành công!",
                  "Bị chặn nếu vượt sản lượng Đạt công đoạn trước quá 5%, LSX chưa ban hành / đã hủy, hoặc giờ kết thúc trước giờ bắt đầu — đọc thông báo và sửa theo."
               ]
            },
            {
               "name": "Nhật ký sản xuất — Xem / Sửa / Xóa",
               "steps": [
                  "Chế độ xem Nhật Ký Ca; lọc theo kỳ ngày; danh sách gom theo ngày, dòng nhóm có tổng phụ; mỗi dòng có ảnh thu nhỏ sản phẩm.",
                  "Bấm dòng để mở form Cập nhật nhật ký sản xuất; sửa giờ, số lượng, máy, người, ca, ghi chú rồi bấm [Cập Nhật Nhật Ký]. Ô LSX và công đoạn không sửa được.",
                  "Ghi nhầm LSX / công đoạn: bấm biểu tượng thùng rác cuối dòng, xác nhận [Xóa]; sản lượng công đoạn và LSX được trừ lại; nhập lại nhật ký đúng.",
                  "Chọn nhiều dòng để [Xuất Excel] hoặc [Xóa] hàng loạt.",
                  "Chế độ xem Thiết Bị & OEE mở danh sách nhật ký máy."
               ]
            },
            {
               "name": "Nhật ký máy",
               "steps": [
                  "Lọc Tất cả / Vận hành / Dừng máy và theo ngày.",
                  "Bấm [Ghi sản lượng], chọn Loại Nhật ký Vận hành / Dừng máy / Bảo trì, nhập thông tin, bấm [Lưu Nhật ký].",
                  "Bấm dòng để xem nhanh; [Sửa] để sửa (nút lưu là [Lưu thay đổi]); [Xem đầy đủ] mở trang chi tiết có link máy, LSX.",
                  "Có nút [Quét Mã Vạch]; chọn nhiều dòng › [Xuất Excel]. Không có nút xóa.",
                  "Nhật ký Chuẩn bị máy (từ Kiểm Tra Đầu Ca) và Bảo trì (từ báo sự cố) do phần mềm tự tạo."
               ]
            },
            {
               "name": "Bàn giao BTP — Tạo / Tiếp nhận / Hủy / In",
               "steps": [
                  "Tạo: [Tạo Bàn Giao], nhập thông tin, lưu. Công đoạn xuất phải có sản lượng Đạt; số chuyển không vượt tồn BTP khả dụng.",
                  "Tiếp nhận: [Nhận] trên phiếu Đang chuyển, nhập số thực nhận, phế phẩm, bấm [Xác nhận tiếp nhận].",
                  "Xem chi tiết: biểu tượng Xem chi tiết phiếu bàn giao mở ngăn chi tiết có link LSX, tuyến công đoạn, số lượng, người giao / nhận và các tab Thảo luận & Biên bản, Ảnh kiện hàng & Tài liệu, Lịch sử luân chuyển.",
                  "Hủy: trong ngăn chi tiết bấm [Hủy Phiếu] — chỉ khi phiếu còn Đang chuyển.",
                  "In: biểu tượng In thẻ bàn giao, ra bản in Thẻ Bàn Giao Bán Thành Phẩm.",
                  "Nút [Sửa] trong ngăn chi tiết hiện chỉ báo Tính năng sửa phiếu đang được cập nhật: phiếu sai thì hủy và lập lại."
               ]
            },
            {
               "name": "Thiết bị SX — Thêm / Xem / Sửa / Thanh lý",
               "steps": [
                  "Xưởng sản xuất › Thiết bị SX, bấm [Thêm TB], nhập mã máy, tên, loại máy, công đoạn máy làm được, khổ, sản lượng chuẩn, thời gian setup, chu kỳ bảo trì; máy in nhập thêm Khổ Kẽm CTP (máy chưa có khổ kẽm thì không gửi ghi bản kẽm được), bấm [Tạo Mới Thiết Bị].",
                  "Bấm dòng mở chi tiết máy: thông tin kèm ảnh và các tab Lịch chạy, Bảo trì, Sự cố, Nhật ký máy lấy dữ liệu thật.",
                  "Sửa: [Sửa] trên trang chi tiết, bấm [Lưu Thiết Bị]. Thanh lý: menu dòng [Thanh lý] hoặc [Xoá] trên trang chi tiết; bản ghi vào Thùng rác.",
                  "Lọc theo trạng thái Chờ việc / Đang chạy / Bảo trì / Hỏng máy; chọn nhiều dòng để Xuất Excel."
               ]
            },
            {
               "name": "Xếp lại lịch một máy theo hạn giao",
               "steps": [
                  "Kế hoạch sản xuất, chế độ Gantt.",
                  "Ở dòng máy cần xếp, bấm [Xếp theo hạn]; xem trước thứ tự mới và số việc trễ hạn trước → sau.",
                  "Bấm [Lưu]. Công đoạn đang chạy, đã khóa lịch giữ nguyên; công đoạn không bị xếp trước công đoạn phía trước của cùng LSX."
               ]
            },
            {
               "name": "Nhật ký sản xuất — chọn Lệnh → Công đoạn → Máy → Người thực hiện",
               "steps": [
                  "Chọn Lệnh sản xuất trước, rồi Công đoạn của lệnh; ô Máy chỉ còn máy làm được công đoạn đó (máy theo kế hoạch được điền sẵn).",
                  "Ô Người thực hiện chỉ có nhân sự phòng Sản xuất, cạnh tên ghi tổ; công đoạn có tổ riêng thì ưu tiên người của tổ đó.",
                  "Phần mềm từ chối lưu và báo lý do khi: công đoạn không thuộc lệnh (“Công đoạn … không thuộc lệnh sản xuất đã chọn”), máy không dùng cho công đoạn (“Máy … không dùng cho công đoạn …. Vui lòng chọn máy của công đoạn này.”), người ngoài sản xuất (“… không thuộc phòng sản xuất. Người thực hiện phải là nhân sự sản xuất.”), lệnh chưa ban hành / đã huỷ / đóng.",
                  "Ghi sản lượng theo máy mà không chọn công đoạn: máy phải làm được ít nhất một công đoạn của lệnh, nếu không báo “Máy … không làm được công đoạn nào của lệnh sản xuất này”."
               ]
            },
            {
               "name": "Bắt đầu / Check-out công đoạn (tab Quy trình của lệnh)",
               "steps": [
                  "Bấm [Bắt đầu] ở dòng công đoạn: công đoạn chuyển Đang chạy, lệnh chuyển Đang sản xuất.",
                  "Phần mềm từ chối khi lệnh chưa ban hành, đang tạm dừng / tạm giữ, đã xong hoặc đã huỷ (“Lệnh … chưa ban hành, đang tạm dừng / tạm giữ, đã xong hoặc đã huỷ — không bắt đầu công đoạn được.”), khi công đoạn đã huỷ / hoàn thành, hoặc khi khuôn, kẽm của lệnh chưa sẵn sàng.",
                  "Bấm [Check-out]: nhập SL Đạt, SL Phế (không âm); tổng không vượt đầu ra Đạt của công đoạn trước quá 5%, phần mềm báo rõ số tối đa. Check-out xong công đoạn Hoàn thành và sản lượng được ghi thành nhật ký sản xuất; mọi công đoạn hoàn thành thì lệnh chuyển Đã sản xuất xong."
               ]
            },
            {
               "name": "Điều độ máy — Lưu Điều Độ",
               "steps": [
                  "Kế hoạch sản xuất › bấm dòng công đoạn › hộp Điều Độ & Gán Lịch Máy Sản Xuất: chọn máy (tích Chỉ máy tương thích), thợ máy / trưởng ca, Dự kiến bắt đầu, Hạn hoàn thành, Tỷ lệ gối đầu %, Khóa lịch công đoạn này → [Lưu Điều Độ].",
                  "Máy đã có việc trong khung giờ đó: chọn [Vẫn lưu và khóa lịch] (chấp nhận chồng lịch) hoặc [Quay lại sửa].",
                  "Báo lỗi khi máy không làm được công đoạn (“Máy … không làm được công đoạn … — chọn máy loại …”), giờ hoàn thành trước giờ bắt đầu, hoặc công đoạn đang chạy / đã xong (không đổi máy / lịch được).",
                  "Cần quyền sửa Lệnh sản xuất. Bộ lọc nhanh: LSX ban hành / Mọi LSX, Việc của tôi, Hôm qua / Hôm nay / Ngày mai / Tuần này; chế độ xem Nhóm ngày, Gantt, Kanban máy, Bảng."
               ]
            },
            {
               "name": "Đóng Gói & Nhập Kho thành phẩm (/factory/packing)",
               "steps": [
                  "Lô FQC Đạt hoặc Nhân nhượng tự có phiếu đóng gói ở tab Chờ Đóng Gói (tab khác: Đã Nhập Kho, Tất Cả Lô).",
                  "Bấm [Đóng gói]: nhập Người đóng gói phụ trách * (chỉ nhân sự tổ Đóng gói), Kho thành phẩm nhận *, Số lô thành phẩm *, SP / thùng *, SL lỗi khi đóng gói, Thùng / pallet, Kích thước thùng, Trọng lượng cả bì, tuỳ chọn Dồn thùng lẻ vào thùng cuối, ghi chú → [Hoàn tất đóng gói & nhập kho].",
                  "Kết quả: phiếu nhập kho thành phẩm đã chốt (NK-TP-năm-số), tồn thành phẩm tăng theo lô, sinh tem thùng đánh số 1/N…N/N và mở màn in tem.",
                  "Báo lỗi khi: SL lỗi lớn hơn SL nhận từ KCS; SL đạt bằng 0; chưa nhập SP / thùng; chưa có kho loại Thành phẩm; lô KCS không còn Đạt hoặc đã xoá.",
                  "Sau nhập kho: [In Tem Thùng], [Giao Hàng] (chọn nhiều lô cùng khách hàng để gom một phiếu giao) hoặc [Chờ gom xe]. Gom phiếu khác khách hàng bị từ chối."
               ]
            },
            {
               "name": "Màn hình xưởng — Phiên làm việc (/mes/session/<mã>)",
               "steps": [
                  "Trang Phiên làm việc chưa có nút nào dẫn tới trên giao diện, chỉ mở bằng đường dẫn /mes/session/<mã phiên>; thao tác hằng ngày dùng Màn hình xưởng (/mes). Khi một phiên được bắt đầu, công đoạn chuyển Đang chạy, dòng đơn hàng chuyển Đang sản xuất.",
                  "Tạm dừng / Tiếp tục phiên khi máy nghỉ giữa chừng (phiên phải đang chạy mới tạm dừng được).",
                  "Bấm [Checkout]: nhập Số lượng Đạt (OK), Số lượng Lỗi (NG), Ghi chú / Nguyên nhân lỗi → [Lưu Báo Cáo]. Phiên đã hoàn thành không checkout lại được.",
                  "[Nhập QC nhanh] mở hộp Kiểm tra Chất lượng (QC Nháp) để ghi chú nhanh kích thước / trọng lượng đo tại máy; hộp này là bản nháp, chưa lưu thành biên bản. Kiểm công đoạn chính thức lập biên bản IPQC (chương 12)."
               ]
            },
            {
               "name": "Màn hình xưởng — chọn góc nhìn, làm mới và thanh trạng thái máy",
               "steps": [
                  "[Trạm Tablet (Thợ)]: chuyển màn hình sang góc nhìn của thợ đứng máy (một máy, nút bấm cỡ lớn); hai góc nhìn còn lại là [Ma Trận Xưởng (Quản Lý)] và [Bảng Kế Hoạch].",
                  "[Làm mới dữ liệu] (nút mũi tên tròn góc phải): tải lại trạng thái máy, hàng đợi và sản lượng mới nhất; nút mờ trong lúc đang tải.",
                  "[Mở Khóa Vận Hành]: chỉ hiện khi máy đang ở trạng thái SỰ CỐ DỪNG MÁY; bấm để đưa máy về đang chạy, công đoạn đang dở chạy tiếp và lần dừng máy được đóng lại kèm số phút dừng.",
                  "[ĐÃ KHẮC PHỤC XONG - TIẾP TỤC CHẠY]: nút trên dải cảnh báo đỏ khi máy đang dừng do sự cố, làm cùng việc với [Mở Khóa Vận Hành]; bấm xong hệ thống báo 'Đã phục hồi máy khỏi sự cố, tiếp tục chạy sản xuất!' và đồng hồ dừng máy về 0."
               ]
            },
            {
               "name": "Màn hình xưởng — nhận bài khi máy trống",
               "steps": [
                  "[Quét Barcode Phiếu In]: mở hộp quét mã, bắn súng mã vạch hoặc gõ mã lệnh sản xuất rồi bấm [Tìm kiếm] để xem lệnh và các công đoạn của lệnh.",
                  "Trong hộp quét, mỗi công đoạn có ô SL đạt/phế và nút [Xác nhận nhanh] để ghi ngay sản lượng vào nhật ký sản xuất; nếu lệnh chưa có công đoạn, màn hình báo cần kiểm tra lại kế hoạch.",
                  "[Kéo Bài Chờ]: mở danh sách các công đoạn chưa được gán máy để chọn bài nạp vào hàng đợi của máy đang xem.",
                  "[Kéo Công Đoạn Từ Kế Hoạch Chờ]: hiện khi hàng đợi của máy trống, mở cùng danh sách công đoạn chờ gán như [Kéo Bài Chờ].",
                  "Trong danh sách công đoạn chờ, gõ mã lệnh, tên sản phẩm, khách hàng hoặc tên công đoạn để lọc rồi bấm [Gán Vào Máy]; công đoạn đi vào cuối hàng đợi của máy và báo 'Đã gán công đoạn vào máy!'.",
                  "[Gán Lệnh Chạy Vào Máy Này]: nút trên thẻ máy ở góc nhìn Ma Trận Xưởng khi máy đang rảnh, mở cùng danh sách công đoạn chờ để gán cho đúng máy đó."
               ]
            },
            {
               "name": "Màn hình xưởng — bắt đầu chạy bài (căn chỉnh và chạy chính thức)",
               "steps": [
                  "[▶ BƯỚC 1: BẮT ĐẦU CHẠY BÀI]: nút trên thẻ máy ở góc nhìn Ma Trận Xưởng khi công đoạn chưa chạy; bấm mở hộp xác nhận, bấm [▶ Xác Nhận Bắt Đầu Chạy] để công đoạn và máy chuyển sang đang chạy.",
                  "Không bắt đầu được khi lệnh chưa ban hành, đã huỷ/đóng, đang tạm dừng, tạm giữ hoặc đã sản xuất xong, hoặc công đoạn đã huỷ/hoàn thành — hệ thống báo rõ lý do.",
                  "Máy phải là máy làm được công đoạn đó; nếu chọn sai, hệ thống báo 'Máy … không dùng cho công đoạn …. Vui lòng chọn máy của công đoạn này.'",
                  "[▶️ BẮT ĐẦU CHẠY CHÍNH THỨC (RUN)]: hiện khi bài đang ở GIAI ĐOẠN 1 căn chỉnh máy; bấm để chốt thời gian căn chỉnh thực tế và chuyển sang chạy sản xuất, hệ thống báo số phút căn chỉnh đã ghi."
               ]
            },
            {
               "name": "Màn hình xưởng — nút báo nhanh sản lượng và phế",
               "steps": [
                  "[+500 tờ] / [+1,000 tờ] / [+2,000 tờ] / [+5,000 tờ]: một chạm cộng ngay số tờ đạt tương ứng vào nhật ký sản xuất của bài đang chạy; hệ thống báo tổng tờ đạt và % tiến độ, sản lượng đạt cũng được chuyển làm đầu vào cho công đoạn kế tiếp.",
                  "Báo nhanh bị từ chối khi lệnh chưa ban hành hoặc đã huỷ/đóng ('… chưa ghi sản lượng được') hoặc máy không làm được công đoạn này.",
                  "[+10 Phế] / [+50 Phế]: cộng nhanh 10 hoặc 50 tờ phế cho bài đang chạy (không cần tờ đạt đi kèm); vẫn bị chặn nếu tổng đạt + phế vượt đầu ra của công đoạn trước quá 5%.",
                  "[📋 BÁO SẢN LƯỢNG / THỬ MÁY]: hiện khi bài còn ở giai đoạn căn chỉnh, mở bảng báo sản lượng có bàn phím số để ghi tờ thử máy, tờ đạt, tờ phế và ảnh thực tế (khi đã chạy chính thức nút này đổi thành [📋 BƯỚC 2: BÁO SẢN LƯỢNG KÈM ẢNH])."
               ]
            },
            {
               "name": "Màn hình xưởng — bảng báo sản lượng (bàn phím số) và lịch sử báo ca",
               "steps": [
                  "Bấm vào ô Đạt hoặc ô Phế để chọn ô đang nhập, rồi bấm các phím số; [XÓA (C)] đưa ô về 0.",
                  "[⌫ LÙI]: xoá chữ số cuối cùng của ô đang chọn, dùng khi bấm nhầm một số.",
                  "[⚡ ĐIỀN TOÀN BỘ CÒN LẠI (… tờ)] điền sẵn số tờ còn thiếu so với kế hoạch vào ô Đạt.",
                  "[Lưu Sản Lượng & Cập Nhật Tiến Độ] chỉ bấm được khi đã chọn thợ máy phụ trách và có ít nhất 1 tờ đạt hoặc phế; giờ kết thúc sớm hơn giờ bắt đầu sẽ bị chặn.",
                  "Thợ máy phải là nhân sự phòng sản xuất, nếu không hệ thống báo '… không thuộc phòng sản xuất. Người thực hiện phải là nhân sự sản xuất.'",
                  "[Lịch Sử Báo Ca (… tờ)] mở danh sách các lượt báo sản lượng của công đoạn kèm ảnh, tốc độ so với định mức và thời gian còn lại dự kiến.",
                  "[Báo Sản Lượng Lần Đầu]: hiện trong lịch sử báo ca khi công đoạn chưa có lượt báo nào, bấm để mở ngay bảng báo sản lượng.",
                  "[Báo Thêm Sản Lượng]: nút cuối hộp lịch sử báo ca, đóng lịch sử và mở bảng báo sản lượng để ghi thêm một lượt mới."
               ]
            },
            {
               "name": "Màn hình xưởng — KCS mẫu đầu ca và bàn giao BTP",
               "steps": [
                  "[KCS Mẫu Đầu Ca]: mở biên bản nghiệm thu tờ mẫu đầu ca, chọn Đạt hoặc Không đạt, ghi tên người kiểm và ghi chú rồi bấm [Lưu Biên Bản KCS].",
                  "Khi mẫu Đạt, công đoạn chuyển sang chạy chính thức và hệ thống báo máy được phép chạy tốc độ cao.",
                  "Khi mẫu Không đạt, công đoạn tạm dừng, máy chuyển sang dừng và hệ thống tự mở một phiếu NCR nội bộ cho công đoạn đó.",
                  "[Bàn Giao BTP] mở phiếu bàn giao bán thành phẩm với số lượng gợi ý bằng số tờ đạt và mã pallet tự sinh; có thể sửa số lượng, mã pallet và ghi chú.",
                  "[Xác Nhận Bàn Giao BTP]: lập phiếu bàn giao sang công đoạn kế tiếp của lệnh (tự tìm công đoạn sau); nút mờ khi số lượng bằng 0, xong báo 'Đã lập phiếu bàn giao BTP sang công đoạn kế tiếp!'."
               ]
            },
            {
               "name": "Bảng Andon xưởng — lọc nhóm máy, còi và lối tắt",
               "steps": [
                  "Các tab nhóm máy ([Tất cả], [In Offset], [Cán màng], [Bế kim], [Dán hộp], [Hoàn thiện]) lọc bảng Andon và các số tổng chỉ theo nhóm máy đã chọn.",
                  "[Còi: BẬT] / [Còi: TẮT]: bật hoặc tắt còi cảnh báo trên máy đang mở bảng Andon; khi bật sẽ phát một tiếng còi ngắn để kiểm tra loa.",
                  "[Bảo Trì TPM]: mở màn hình bảo trì và sự cố thiết bị để xem, tiếp nhận các báo hỏng máy."
               ]
            },
            {
               "name": "Phân tích OEE và danh sách thiết bị — lối tắt",
               "steps": [
                  "[Andon TV]: trên màn hình phân tích OEE, mở bảng Andon xưởng để chiếu lên TV theo dõi trạng thái máy theo thời gian thực.",
                  "[Theo dõi OEE]: trong menu thao tác của một dòng ở danh sách thiết bị, mở trang chi tiết thiết bị đó, nơi có tab OEE và lịch bảo trì."
               ]
            },
            {
               "name": "Kế hoạch công đoạn — khi danh sách trống và in kế hoạch",
               "steps": [
                  "[Xem tất cả công đoạn]: hiện khi đang bật lọc 'Việc của tôi' mà không có công đoạn nào giao cho bạn; bấm để tắt lọc và xem toàn bộ danh sách.",
                  "[Xem toàn bộ công đoạn (Gồm lệnh đang lập kế hoạch)]: hiện khi đang lọc 'LSX ban hành' mà danh sách trống nhưng còn công đoạn thuộc lệnh đang lập kế hoạch/chờ ban hành; bấm để bỏ lọc và xem cả các công đoạn đó.",
                  "[In] trên thanh thao tác hàng loạt: sau khi tích chọn các dòng, mở bản in Kế hoạch sản xuất công đoạn (khổ ngang) chỉ gồm các dòng đã chọn; muốn in toàn bộ dùng [In kế hoạch]."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "Chờ chạy / Sẵn sàng / Đã lên lịch / Tạm dừng",
               "to": "Đang chạy",
               "action": "[⚡ CĂN CHỈNH] / [▶ CHẠY NGAY] trên Màn hình xưởng hoặc [Bắt đầu] ở tab Quy trình của LSX. Bị từ chối kèm lý do khi LSX chưa ban hành, tạm dừng, tạm giữ, đã xong, đã hủy hoặc kẽm / khuôn chưa sẵn sàng.",
               "allowedRoles": "Người dùng đã đăng nhập (OPERATOR, PRODUCTION_MANAGER)"
            },
            {
               "from": "Đang chạy",
               "to": "Hoàn thành",
               "action": "[🏁 Xác Nhận Hoàn Thành Bài] trên Màn hình xưởng hoặc [Xác Nhận Check-out] ở tab Quy trình. Chặn nếu công đoạn chưa có sản lượng.",
               "allowedRoles": "Người dùng đã đăng nhập (OPERATOR, PRODUCTION_MANAGER)"
            },
            {
               "from": "Chờ chạy / Đã lên lịch (công đoạn nhận)",
               "to": "Sẵn sàng",
               "action": "Tiếp nhận phiếu bàn giao BTP, hoặc công đoạn trước Hoàn thành trên Màn hình xưởng",
               "allowedRoles": "Người dùng đã đăng nhập"
            },
            {
               "from": "Bất kỳ",
               "to": "Tạm dừng / Hủy bỏ (Không làm)",
               "action": "Đổi trạng thái công đoạn trong tab Quy trình của LSX",
               "allowedRoles": "PLANNER, PRODUCTION_MANAGER"
            },
            {
               "from": "LSX đang chuẩn bị (đã ban hành, đã lên kế hoạch...)",
               "to": "Đang sản xuất",
               "action": "Tự động khi công đoạn đầu tiên bắt đầu",
               "allowedRoles": "Hệ thống"
            },
            {
               "from": "Phiếu BTP Đang chuyển",
               "to": "Đã nhận",
               "action": "[Nhận] › [Xác nhận tiếp nhận]",
               "allowedRoles": "Người dùng đã đăng nhập"
            },
            {
               "from": "Phiếu BTP Đang chuyển",
               "to": "Đã hủy",
               "action": "[Hủy Phiếu] trong ngăn chi tiết",
               "allowedRoles": "Người dùng đã đăng nhập"
            },
            {
               "from": "Máy Chờ việc / Đang chạy",
               "to": "Hỏng máy",
               "action": "[Xác Nhận Báo Sự Cố] hoặc [KÍCH HOẠT BÁO SỰ CỐ] trên Màn hình xưởng",
               "allowedRoles": "Người dùng đã đăng nhập"
            },
            {
               "from": "Phiếu sự cố CHỜ TIẾP NHẬN (máy Hỏng máy)",
               "to": "ĐANG SỬA CHỮA (máy Bảo trì)",
               "action": "[Tiếp Nhận] › [Xác Nhận Tiếp Nhận]",
               "allowedRoles": "Kỹ thuật cơ điện, quản đốc"
            },
            {
               "from": "Phiếu ĐANG SỬA CHỮA (máy Bảo trì)",
               "to": "Đã nghiệm thu (máy Chờ việc hoặc Đang chạy)",
               "action": "[Nghiệm Thu & Đóng] › [Nghiệm Thu & Khôi Phục Máy]",
               "allowedRoles": "Quản đốc"
            }
         ],
         "actionLinks": [
            {
               "from": "Kế hoạch sản xuất",
               "to": "Lệnh sản xuất (/production-orders/mã)",
               "action": "Mở LSX",
               "how": "Bấm mã LSX ở chế độ Nhóm ngày, Gantt, Kanban, hoặc link LSX trong hộp Điều Độ"
            },
            {
               "from": "Kế hoạch sản xuất",
               "to": "Nhật ký sản xuất",
               "action": "Ghi sản lượng có điền sẵn",
               "how": "Nút [Ghi Nhật Ký] trên dòng / thẻ"
            },
            {
               "from": "Kế hoạch sản xuất",
               "to": "Tạo Lệnh sản xuất",
               "action": "Tạo LSX mới",
               "how": "Nút [Tạo LSX]"
            },
            {
               "from": "Nhật ký sản xuất (form đã lưu)",
               "to": "Lệnh sản xuất, Thiết bị, Người dùng",
               "action": "Mở bản ghi liên quan",
               "how": "Link Lệnh SX, Máy, Thợ dưới form"
            },
            {
               "from": "Nhật ký sản xuất",
               "to": "Nhật ký máy",
               "action": "Xem nhật ký thiết bị",
               "how": "Chế độ xem Thiết Bị & OEE"
            },
            {
               "from": "Lệnh sản xuất › tab Quy trình",
               "to": "Sổ Giao Nhận BTP",
               "action": "Bàn giao BTP",
               "how": "Nút [Giao BTP] ở dòng công đoạn có tồn BTP"
            },
            {
               "from": "Màn hình xưởng",
               "to": "KCS thành phẩm (chương KCS)",
               "action": "Mở phiếu FQC cho LSX đang chạy",
               "how": "Nút [Nghiệm Thu FQC & Nhập Kho]"
            },
            {
               "from": "Sự cố thiết bị / Bảo trì bảo dưỡng",
               "to": "Bảng giám sát Andon (/mes/andon)",
               "action": "Theo dõi sàn máy",
               "how": "Nút [Andon xưởng]"
            },
            {
               "from": "Bảng giám sát Andon",
               "to": "Màn hình xưởng / Sự cố",
               "action": "Vào trạm hoặc xử lý sự cố",
               "how": "Nút [Vào Trạm] hoặc [Sự Cố] trên thẻ máy"
            },
            {
               "from": "Sự cố thiết bị / Bảo trì bảo dưỡng",
               "to": "Thiết bị, phiếu sự cố",
               "action": "Mở chi tiết",
               "how": "Bấm tên máy hoặc dòng phiếu"
            }
         ],
         "inlineViews": [
            {
               "name": "Hộp Điều Độ & Gán Lịch Máy Sản Xuất",
               "trigger": "Bấm dòng / thẻ Kanban / thanh Gantt trên Kế hoạch sản xuất",
               "description": "Gán máy, thợ, giờ, % gối đầu, khóa / mở khóa lịch; chồng lịch phải xác nhận; máy sai loại bị chặn."
            },
            {
               "name": "Form Ghi nhận sản lượng công đoạn (1-chạm)",
               "trigger": "[Ghi Nhật Ký] trên Kế hoạch sản xuất",
               "description": "Form nhật ký điền sẵn LSX, công đoạn, máy, kế hoạch, đã đạt, còn lại."
            },
            {
               "name": "Form Cập nhật nhật ký sản xuất",
               "trigger": "Bấm dòng trên Nhật ký sản xuất",
               "description": "Sửa nhật ký (LSX, công đoạn khóa), link LSX / máy / thợ, tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật, người tạo / cập nhật."
            },
            {
               "name": "Ngăn chi tiết phiếu bàn giao BTP",
               "trigger": "Biểu tượng Xem chi tiết trên dòng phiếu",
               "description": "Tuyến công đoạn, số lượng, người giao / nhận, thảo luận, ảnh, lịch sử; In hoặc Hủy phiếu."
            },
            {
               "name": "Xem nhanh nhật ký máy",
               "trigger": "Bấm dòng trên Nhật ký máy",
               "description": "Chi tiết nhật ký, nút [Sửa] và [Xem đầy đủ]."
            },
            {
               "name": "Xem trước Xếp theo hạn",
               "trigger": "[Xếp theo hạn] trên dòng máy ở Gantt",
               "description": "Thứ tự mới theo hạn giao và số việc trễ trước → sau, bấm [Lưu] mới áp dụng."
            }
         ],
         "quickActions": [
            {
               "action": "Việc của tôi",
               "description": "Trên Kế hoạch sản xuất, chỉ hiện công đoạn được phân công cho anh/chị."
            },
            {
               "action": "Quét LSX",
               "description": "Trên Nhật ký sản xuất, quét mã vạch hoặc gõ mã LSX để mở công đoạn và ghi nhật ký."
            },
            {
               "action": "-30p / -1h / -2h / Bây giờ",
               "description": "Chỉnh nhanh giờ bắt đầu / kết thúc trên form nhật ký sản xuất."
            },
            {
               "action": "⚡ ĐIỀN TOÀN BỘ CÒN LẠI",
               "description": "Trên Màn hình xưởng, điền nhanh số còn lại của công đoạn khi báo sản lượng."
            },
            {
               "action": "Xếp theo hạn",
               "description": "Trên Gantt, xếp lại thứ tự việc của một máy theo hạn giao."
            },
            {
               "action": "Xuất Excel",
               "description": "Xuất công đoạn (Kế hoạch sản xuất), nhật ký sản xuất, nhật ký máy, thiết bị, sự cố / bảo trì."
            }
         ],
         "forms": [
            {
               "code": "KẾ HOẠCH SẢN XUẤT",
               "name": "Bản in Kế hoạch sản xuất công đoạn (in từ Kế hoạch sản xuất, chưa gán mã ISO trên bản in)"
            },
            {
               "code": "THẺ BÀN GIAO BTP",
               "name": "Thẻ bàn giao bán thành phẩm (in từ Sổ Giao Nhận BTP, chưa gán mã ISO trên bản in)"
            },
            {
               "code": "TEM PALLET BTP",
               "name": "Tem pallet bán thành phẩm in khi hoàn thành bài trên Màn hình xưởng (chưa gán mã ISO trên bản in)"
            },
            {
               "code": "BM-ISO-753",
               "name": "File Excel Báo cáo tổn thất OEE (/shopfloor/loss-time-analytics — mã nằm trong tên file xuất)"
            }
         ],
         "notes": [
            "Nhật ký sản xuất đã lưu không đổi được LSX và công đoạn. Ghi nhầm thì xóa nhật ký đó rồi nhập lại.",
            "Sản lượng công đoạn và LSX chỉ tính từ Nhật ký sản xuất (kể cả số báo trên Màn hình xưởng và tab Quy trình). Xóa nhật ký sẽ trừ lại sản lượng.",
            "Một công đoạn không ghi được Đạt + Hỏng vượt sản lượng Đạt của công đoạn liền trước quá 5%: ghi sản lượng công đoạn trước trước.",
            "LSX chưa ban hành, chờ duyệt, đã hủy, đóng thì không ghi sản lượng; LSX tạm dừng, tạm giữ, đã sản xuất xong thì không bắt đầu công đoạn.",
            "Công đoạn chỉ chuyển Hoàn thành khi đã có sản lượng; máy sai loại không gán được cho công đoạn.",
            "LSX đã phát hành bị khóa số lượng, số con / tờ, khổ giấy, số tờ chạy; sản lượng hoàn thành của LSX do KCS thành phẩm ghi.",
            "Phiếu bàn giao BTP cần công đoạn xuất có sản lượng Đạt, không vượt tồn BTP; chỉ hủy khi còn Đang chuyển; không nhận hai lần.",
            "Hủy LSX thì các công đoạn còn mở rời khỏi hàng chờ máy.",
            "Màn hình xưởng dùng được trên điện thoại và máy tính bảng; hàng chờ chỉ hiện LSX xưởng làm được.",
            "Đóng Gói & Nhập Kho: đóng gói, nhập kho thành phẩm, in tem thùng và gom phiếu giao xem mục con cùng tên ở chương này; lập FQC xem chương KCS, phiếu giao xem chương Kho.",
            "Người thực hiện ở Nhật ký sản xuất, Nhật ký máy, Điều độ máy, Báo thành phẩm chỉ chọn được nhân sự phòng Sản xuất; người đóng gói chỉ chọn nhân sự tổ Đóng gói.",
            "Màn hình xưởng (/mes, /shopfloor/terminal) không có mục menu riêng; mở từ Xưởng sản xuất › Bảo trì bảo dưỡng → [Andon xưởng] → [Vào Trạm] trên thẻ máy, hoặc gõ đường dẫn. Các bước Căn chỉnh, Chạy ngay, Báo sản lượng, Báo nhanh, Kết thúc đều kiểm máy phải làm được công đoạn và người thực hiện phải thuộc phòng sản xuất, báo rõ lý do như Nhật ký sản xuất.",
            "Báo sản lượng trên Màn hình xưởng: giờ bắt đầu mặc định là giờ bấm [▶ CHẠY NGAY] (nhật ký đang chạy); giờ kế hoạch chỉ dùng khi đã qua. Báo ngay sau khi chạy không bị chặn vì giờ kế hoạch còn ở phía sau.",
            "[⚡ CĂN CHỈNH] / [▶ CHẠY NGAY]: công đoạn in bị từ chối khi kẽm của lệnh chưa sẵn sàng (ghi bản kẽm ở Tab 3 của lệnh), công đoạn bế bị từ chối khi khuôn chưa sẵn sàng — cùng cách tính với cột sẵn sàng của Hàng Đợi Ca Máy.",
            "[🏁 KẾT THÚC BÀI CHẠY] bị từ chối khi công đoạn chưa có sản lượng đạt: báo sản lượng trước."
         ],
         "references": [
            "ISO 9001:2015 mục 8.1 — Hoạch định và kiểm soát việc thực hiện",
            "ISO 9001:2015 mục 8.5.1 — Kiểm soát sản xuất và cung cấp dịch vụ",
            "ISO 9001:2015 mục 8.5.2 — Nhận biết và truy xuất nguồn gốc (mã LSX, mã nhật ký, mã phiếu bàn giao, mã pallet)",
            "ISO 9001:2015 mục 7.1.3 — Cơ sở hạ tầng (thiết bị, bảo trì)",
            "Chương Lệnh sản xuất (tab Quy trình), chương Bình file, chương KCS (IPQC, FQC, Đóng gói), chương Kho"
         ],
         "uatChecklist": [
            {
               "id": "SX-11-01",
               "item": "Nhận LSX từ Kế hoạch / Bình file lên Kế hoạch sản xuất",
               "standard": "LSX vừa ban hành hiện đủ công đoạn ở đúng tab nhóm công đoạn, có máy, giờ chạy, ảnh sản phẩm; LSX chưa ban hành chỉ hiện khi chọn Mọi LSX và có nhãn Chưa ban hành.",
               "method": "1. Nhờ Kế hoạch ban hành một LSX mẫu (VD hộp giấy 5.000 cái, quy trình Cắt giấy › In › Bế › Dán). 2. Vào Xưởng sản xuất › Kế hoạch sản xuất, lọc Hôm nay / Tuần này. 3. Mở tab In ấn và Bế - Ép nhũ, tìm mã LSX. 4. Đổi Phạm vi sang Mọi LSX để xem LSX còn nháp."
            },
            {
               "id": "SX-11-02",
               "item": "Điều độ máy cho công đoạn, chặn máy sai loại và chồng lịch",
               "standard": "Chọn máy bế cho công đoạn In bị chặn có lý do; giờ chồng việc khác hiện hộp Máy đã có việc trong khung giờ này; [Vẫn lưu và khóa lịch] lưu kèm ổ khóa.",
               "method": "1. Bấm dòng công đoạn In của LSX mẫu. 2. Chọn một máy bế, bấm [Lưu Điều Độ] — đọc thông báo. 3. Chọn lại máy in, đặt giờ trùng việc đang có trên máy đó, bấm [Lưu Điều Độ]. 4. Bấm [Quay lại sửa], rồi thử lại và bấm [Vẫn lưu và khóa lịch]. 5. Mở Gantt kiểm tra ổ khóa."
            },
            {
               "id": "SX-11-03",
               "item": "Bắt đầu công đoạn bị từ chối khi chưa đủ điều kiện",
               "standard": "Phần mềm không cho bắt đầu và hiện đúng lý do (LSX tạm dừng / chưa ban hành, hoặc kẽm, khuôn chưa sẵn sàng); trạng thái công đoạn giữ nguyên.",
               "method": "1. Chọn một LSX đang Tạm dừng (hoặc nhờ Kế hoạch tạm dừng LSX mẫu thứ hai). 2. Mở LSX › tab Quy trình, bấm [Bắt đầu] ở công đoạn đầu. 3. Đọc thông báo lỗi. 4. Thử tương tự với LSX có công đoạn Bế mà khuôn chưa sẵn sàng."
            },
            {
               "id": "SX-11-04",
               "item": "Bắt đầu và kết thúc công đoạn hợp lệ",
               "standard": "Bắt đầu: công đoạn Đang chạy, máy Đang chạy, LSX chuyển Đang sản xuất. Kết thúc: công đoạn Hoàn thành, máy Chờ việc, công đoạn sau Sẵn sàng.",
               "method": "1. Màn hình xưởng (/mes), chọn máy cắt của LSX mẫu, chọn thợ. 2. Bấm [▶ CHẠY NGAY] rồi xác nhận. 3. Báo sản lượng 5.000 tờ Đạt. 4. Bấm [🏁 BƯỚC 3: KẾT THÚC BÀI CHẠY] › [🏁 Xác Nhận Hoàn Thành Bài]. 5. Mở LSX › tab Quy trình kiểm tra trạng thái."
            },
            {
               "id": "SX-11-05",
               "item": "Không cho Hoàn thành công đoạn chưa có sản lượng",
               "standard": "Đổi trạng thái sang Hoàn thành bị chặn với thông báo chưa có sản lượng nào, ghi nhật ký trước.",
               "method": "1. Mở LSX mẫu › tab Quy trình. 2. Ở công đoạn In chưa ghi nhật ký, đổi trạng thái sang Hoàn thành. 3. Đọc thông báo; kiểm tra trạng thái không đổi."
            },
            {
               "id": "SX-11-06",
               "item": "Thêm nhật ký sản xuất và sản lượng đồng bộ vào LSX",
               "standard": "Thông báo Ghi nhận sản lượng sản xuất thành công!; dòng mới có ảnh sản phẩm; SL Đạt của công đoạn và % tiến độ trên Kế hoạch sản xuất và tab Quy trình tăng đúng số vừa ghi.",
               "method": "1. Kế hoạch sản xuất, bấm [Ghi Nhật Ký] ở công đoạn In của LSX mẫu. 2. Chọn máy in, thợ, ca, bấm Bây giờ, nhập 2.000 Đạt, 50 Hỏng, lý do Lệch màu. 3. Bấm [Lưu Nhật Ký Sản Xuất]. 4. Xem lại dòng công đoạn và tab Quy trình của LSX."
            },
            {
               "id": "SX-11-07",
               "item": "Chặn ghi vượt sản lượng công đoạn trước",
               "standard": "Không lưu được; thông báo ghi rõ số đã ghi, số Đạt của công đoạn trước và số tối đa cho phép.",
               "method": "1. Công đoạn Cắt giấy của LSX mẫu đã có 5.000 tờ Đạt. 2. Ghi nhật ký công đoạn In 5.300 Đạt (tổng vượt 5.250). 3. Bấm [Lưu Nhật Ký Sản Xuất], đọc thông báo. 4. Sửa còn 3.000 và lưu được."
            },
            {
               "id": "SX-11-08",
               "item": "Sửa nhật ký: LSX và công đoạn bị khóa",
               "standard": "Form Cập nhật mở được; ô Lệnh sản xuất và Công đoạn kế hoạch không chọn được; sửa số lượng thì sản lượng LSX cập nhật theo; có link LSX / máy / thợ và tab Thảo luận, Tệp đính kèm, Lịch sử cập nhật.",
               "method": "1. Nhật ký sản xuất, bấm dòng nhật ký vừa tạo. 2. Thử bấm ô Lệnh sản xuất, Công đoạn kế hoạch. 3. Đổi Đạt từ 2.000 sang 1.900, bấm [Cập Nhật Nhật Ký]. 4. Bấm link Lệnh SX kiểm tra số mới; mở tab Lịch sử cập nhật xem dòng sửa."
            },
            {
               "id": "SX-11-09",
               "item": "Xóa nhật ký ghi nhầm và nhập lại",
               "standard": "Sau khi xóa, sản lượng công đoạn và LSX bị trừ đúng số của nhật ký; nhật ký nằm ở Thùng rác; nhập lại nhật ký đúng LSX thì số cộng lại.",
               "method": "1. Ghi một nhật ký 500 Đạt vào nhầm LSX khác. 2. Bấm biểu tượng thùng rác cuối dòng, xác nhận [Xóa]. 3. Kiểm tra sản lượng LSX bị nhầm giảm 500. 4. Ghi lại 500 Đạt vào đúng LSX mẫu."
            },
            {
               "id": "SX-11-10",
               "item": "Bàn giao BTP và tiếp nhận",
               "standard": "Phiếu mới ở Đang chuyển; số vượt tồn BTP bị chặn; tiếp nhận xong phiếu Đã nhận, công đoạn nhận chuyển Sẵn sàng; nhận lần hai bị từ chối.",
               "method": "1. Mở /wip-transfer, bấm [Tạo Bàn Giao]. 2. Chọn LSX mẫu, Công đoạn xuất In, Công đoạn nhận Bế, nhập số lớn hơn tồn hiển thị, lưu — đọc thông báo. 3. Nhập 1.800 tờ, pallet PLT-01, lưu. 4. Bấm [Nhận], nhập 1.790 nhận, 10 phế, lý do Rách mép, [Xác nhận tiếp nhận]. 5. Mở ngăn chi tiết, in thẻ bàn giao."
            },
            {
               "id": "SX-11-11",
               "item": "Ghi nhật ký dừng máy",
               "standard": "Nhật ký Dừng máy lưu được, hiện ở bộ lọc Dừng máy với thời gian dừng và lý do; trang chi tiết có link máy và LSX.",
               "method": "1. Nhật ký sản xuất › Thiết Bị & OEE. 2. Bấm [Ghi sản lượng], chọn máy in, LSX mẫu, ca, người vận hành, Loại Nhật ký Dừng máy. 3. Nhập lý do Kẹt giấy, 25 phút, nguyên nhân, biện pháp, bấm [Lưu Nhật ký]. 4. Lọc Dừng máy, bấm dòng › [Xem đầy đủ]."
            },
            {
               "id": "SX-11-12",
               "item": "Báo sự cố và khôi phục máy",
               "standard": "Báo sự cố: máy chuyển Hỏng máy; tiếp nhận: máy Bảo trì; nghiệm thu: máy về Chờ việc, phiếu sang tab Lịch sử sửa chữa.",
               "method": "1. Xưởng sản xuất › Sự cố thiết bị, bấm [Báo sự cố], chọn máy bế, Cơ khí, DỪNG MÁY KHẨN CẤP, mô tả. 2. Bấm [Tiếp Nhận], nhập tên kỹ thuật viên. 3. Bấm [Nghiệm Thu & Đóng], nhập phương án, 40 phút, CHỜ VIỆC. 4. Mở Thiết bị SX › máy đó xem tab Sự cố."
            },
            {
               "id": "SX-11-13",
               "item": "Màn hình xưởng trên điện thoại 390px",
               "standard": "Trên điện thoại màn hình rộng khoảng 390px, chọn được máy, nút bấm đủ lớn, không phải kéo ngang trang, làm trọn Kiểm Tra Đầu Ca, chạy bài, báo sản lượng, kết thúc bài.",
               "method": "1. Đăng nhập trên điện thoại (hoặc trình duyệt thu nhỏ còn 390px). 2. Mở /mes, chọn TRẠM CẢM ỨNG MÁY, chọn máy dán. 3. Bấm [Kiểm Tra Đầu Ca], tick hạng mục, [Xác Nhận Nộp Phiếu]. 4. Chạy bài Dán của LSX mẫu, báo 1.000 Đạt kèm 1 ảnh, kết thúc bài. 5. Kiểm tra nhật ký mới trên Nhật ký sản xuất và nhật ký máy loại Chuẩn bị máy."
            },
            {
               "id": "SX-11-14",
               "item": "Link liên kết và bàn giao sang QC",
               "standard": "Link Lệnh SX, Máy, Thợ mở đúng bản ghi; LSX có công đoạn cuối Hoàn thành hiện bên KCS thành phẩm để QC kiểm; SL Đạt FQC không nhập vượt sản lượng công đoạn cuối.",
               "method": "1. Mở một nhật ký đã lưu, bấm lần lượt link Lệnh SX, Máy, Thợ. 2. Kết thúc công đoạn cuối của LSX mẫu. 3. Trên Màn hình xưởng bấm [Nghiệm Thu FQC & Nhập Kho] hoặc nhờ QC mở KCS thành phẩm, chọn LSX mẫu. 4. Nhập SL Đạt lớn hơn sản lượng công đoạn cuối, kiểm tra bị chặn."
            },
            {
               "id": "SX-11-15",
               "item": "Nhật ký sản xuất chọn máy theo công đoạn",
               "standard": "Sau khi chọn công đoạn In, ô Máy chỉ còn máy in; ô Người thực hiện chỉ có nhân sự Sản xuất. Lưu với máy bế cho công đoạn In bị từ chối, báo đúng tên máy và công đoạn.",
               "method": "1. Nhật ký sản xuất › [Thêm Nhật Ký]. 2. Chọn LSX đang chạy, công đoạn In 4 màu. 3. Mở ô Máy, kiểm tra danh sách. 4. Thử lưu với máy bế (qua dữ liệu cũ hoặc nhập mã) → đọc thông báo."
            },
            {
               "id": "SX-11-16",
               "item": "Đóng gói và nhập kho thành phẩm",
               "standard": "Có phiếu NK-TP-… đã chốt, tồn thành phẩm tăng đúng SL đạt, tem thùng đánh số đủ 1/N…N/N; lô chuyển tab Đã Nhập Kho.",
               "method": "1. Xưởng sản xuất › Đóng Gói & Nhập Kho › tab Chờ Đóng Gói. 2. [Đóng gói] lô FQC Đạt 1.000 cái, SP / thùng 360, người đóng gói tổ Đóng gói → lưu. 3. Kiểm tra 3 tem, phiếu nhập kho thành phẩm và tồn kho."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "OPERATOR (thợ vận hành / tổ trưởng)",
               "createTest": "Thêm nhật ký sản xuất 1.000 Đạt cho công đoạn đang chạy; lập phiếu bàn giao BTP; ghi nhật ký Dừng máy.",
               "readTest": "Xem Kế hoạch sản xuất với [Việc của tôi], hàng chờ máy trên Màn hình xưởng, danh sách nhật ký của ca.",
               "updateTest": "Sửa số lượng nhật ký vừa ghi; thử đổi LSX / công đoạn (ô bị khóa); tiếp nhận phiếu BTP.",
               "deleteTest": "Xóa nhật ký ghi nhầm, kiểm tra sản lượng LSX trừ lại.",
               "expectedResult": "Làm được mọi thao tác ghi nhận của ca; các quy tắc chặn (vượt công đoạn trước, LSX chưa ban hành, Hoàn thành không có sản lượng) vẫn áp dụng và báo rõ lý do."
            },
            {
               "roleGroup": "PRODUCTION_MANAGER (quản đốc / giám đốc sản xuất)",
               "createTest": "Báo sự cố máy, lập lịch PM, thêm thiết bị mới có Khổ Kẽm CTP.",
               "readTest": "Xem Gantt, Andon xưởng, OEE, nhật ký máy, lịch sử sửa chữa.",
               "updateTest": "Tiếp nhận và nghiệm thu sự cố; đổi máy, thợ, giờ chạy công đoạn; [Xếp theo hạn] một máy.",
               "deleteTest": "Xóa nhật ký sai; thanh lý một thiết bị thử (vào Thùng rác).",
               "expectedResult": "Toàn bộ thao tác xưởng thực hiện được; máy sai loại và chồng lịch vẫn bị chặn hoặc phải xác nhận."
            },
            {
               "roleGroup": "PLANNER (kế hoạch sản xuất)",
               "createTest": "Tạo LSX từ nút [Tạo LSX] (theo chương Lệnh sản xuất).",
               "readTest": "Xem Kế hoạch sản xuất mọi tab, Mọi LSX, xuất Excel và in kế hoạch.",
               "updateTest": "Điều độ máy, khóa / mở khóa lịch, đổi % gối đầu.",
               "deleteTest": "Hủy bỏ (Không làm) một công đoạn thừa trong tab Quy trình.",
               "expectedResult": "Lịch cập nhật ngay trên Gantt; công đoạn đã hủy không còn trong hàng chờ máy."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/15_po_detail_tab4_inflight_process_and_curing_wait.png",
               "caption": "Hình 11.1 — Tab Quy trình công đoạn trên Lệnh sản xuất với nhãn Chờ khô mực và đổi máy / trạng thái công đoạn"
            },
            {
               "src": "/guide-screenshots/18_production_scheduling_gantt_aps.png",
               "caption": "Hình 11.2 — Kế hoạch sản xuất ở chế độ xem Gantt lịch máy"
            },
            {
               "src": "/guide-screenshots/20_production_log_form_unlocked_time_and_dynamic_combobox.png",
               "caption": "Hình 11.3 — Form nhật ký sản xuất với giờ bắt đầu / kết thúc chỉnh được và các nút -30p, -1h, -2h, Bây giờ"
            },
            {
               "src": "/guide-screenshots/21_shopfloor_touch_terminal_checkin_checkout.png",
               "caption": "Hình 11.4 — Màn hình cảm ứng xưởng máy (/shopfloor/terminal)"
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 12. Kiểm Soát Chất Lượng KCS (IQC, IPQC, FQC, NCR 8D)
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "quality",
         "aliases": [
            "qc",
            "qc-materials",
            "qc-process",
            "qc-final",
            "ncr",
            "qc-templates",
            "quality",
            "iqc",
            "ipqc",
            "fqc",
            "qc-reports"
         ],
         "title": "12. Kiểm Soát Chất Lượng KCS (IQC, IPQC, FQC, NCR 8D)",
         "icon": "ShieldCheck",
         "isoRef": "QT-QC-01",
         "purpose": "Hướng dẫn bộ phận QC kiểm soát chất lượng ở ba tầng: kiểm vật tư đầu vào (IQC), kiểm công đoạn trên máy (IPQC), nghiệm thu thành phẩm (FQC); xử lý hàng lỗi theo 8 bước 8D (NCR) và quản lý mẫu kiểm tra (Biểu mẫu QC). Phiếu KCS chỉ kết luận chất lượng: lô vật tư Đạt chuyển sang Kho vật tư chờ nhập kho, lô thành phẩm Đạt tự chuyển thành Phiếu đóng gói cho Sản xuất đóng thùng, nhập kho và giao hàng.",
         "scope": [
            "Menu Chất lượng: IQC Đầu vào, IPQC Công đoạn, FQC Thành phẩm, Sự cố NCR, Biểu mẫu QC.",
            "Menu Xưởng sản xuất › Đóng Gói & Nhập Kho: nơi tổ đóng gói nhận lô FQC Đạt, đóng thùng, nhập kho thành phẩm, in tem thùng và gom lô giao hàng. QC chỉ xem tình trạng lô.",
            "Người dùng chính: Trưởng phòng QA/QC (QAQC_MANAGER), Nhân viên KCS (QC_INSPECTOR), Nhân viên QC (QC).",
            "Bộ phận liên quan: Mua hàng (nhận hàng theo đơn mua), Kho vật tư (nhập kho lô IQC Đạt), Xưởng sản xuất (IPQC trên máy, đóng gói), Kho thành phẩm và Giao hàng (nhập kho, phiếu giao).",
            "Quyền lập, sửa, xoá phiếu theo cấu hình ở Hệ Thống & Quy Trình › Phân quyền; riêng đóng NCR cần quyền Duyệt của NCR."
         ],
         "references": [
            "ISO 9001:2015 mục 8.4 — Kiểm soát sản phẩm do bên ngoài cung cấp (IQC)",
            "ISO 9001:2015 mục 8.5.1 và 8.6 — Kiểm soát sản xuất và thông qua sản phẩm (IPQC, FQC)",
            "ISO 9001:2015 mục 8.7 và 10.2 — Kiểm soát đầu ra không phù hợp, hành động khắc phục (NCR 8D)",
            "ISO 2859-1 — Lấy mẫu theo AQL (cỡ mẫu, Ac/Re tự tra trên phiếu IQC, IPQC, FQC)",
            "Chương Mua hàng (Nhận hàng IQC), Chương Xưởng sản xuất (Đóng gói & Nhập kho), Chương Kho và Giao hàng"
         ],
         "terms": [
            {
               "term": "IQC (Kiểm tra vật tư đầu vào)",
               "definition": "Phiếu kiểm một lô vật tư nhà cung cấp giao: vật tư, nhà cung cấp, đơn mua, số lô NCC, số CoA, lấy mẫu, bảng chỉ tiêu, lỗi phát hiện, kết luận, SL nhập kho và SL loại. Lô Đạt hoặc Cảnh báo (nhân nhượng) hiện ở Kho vật tư chờ nhập kho."
            },
            {
               "term": "IPQC (Kiểm tra công đoạn)",
               "definition": "Một phiếu cho một công đoạn của một Lệnh SX, đi 4 bước: 1. Duyệt setup 4M (Người, Máy, Vật tư, Phương pháp) → 2. Ký mẫu → Cho sản xuất → 3. Kiểm tra lặp lại theo tần suất → 4. Chốt lô."
            },
            {
               "term": "FQC (Nghiệm thu thành phẩm)",
               "definition": "Biên bản kiểm lô thành phẩm theo AQL hoặc kiểm 100%: chỉ tiêu, lỗi, SL Đạt, SL loại, CoA. Không ghi quy cách thùng hay nhập kho. Lô Đạt tự sinh Phiếu đóng gói DG-… cho Sản xuất."
            },
            {
               "term": "Phiếu đóng gói (DG-…)",
               "definition": "Phiếu của Sản xuất, sinh từ lô FQC Đạt / Nhân nhượng với SL nhận = SL Đạt của KCS. Tổ đóng gói ghi người đóng gói, SL lỗi khi đóng gói, kho, số lô, quy cách thùng rồi hoàn tất để nhập kho và in tem thùng."
            },
            {
               "term": "NCR 8D (Phiếu xử lý sự không phù hợp)",
               "definition": "Hồ sơ xử lý lỗi: D1–D2 mô tả lỗi và nguồn phát hiện, hướng xử lý hàng lỗi và chi phí, D3 ngăn chặn, D4 nguyên nhân gốc (6M, 5 Why), D5 khắc phục, D7 phòng ngừa, D6/D8 kết quả xử lý và đóng hồ sơ."
            },
            {
               "term": "Nhân nhượng",
               "definition": "Chỉ chọn được khi kết luận tự tính là Không đạt, bắt buộc ghi Lý do nhân nhượng. Phiếu lưu ở trạng thái Cảnh báo và vẫn được nhập kho / bàn giao đóng gói như lô Đạt."
            },
            {
               "term": "Kết quả KCS",
               "definition": "Chờ kiểm, Đang kiểm, Đạt, Cảnh báo (nhân nhượng), Không đạt."
            },
            {
               "term": "Biểu mẫu QC (Mẫu kiểm tra)",
               "definition": "Bộ chỉ tiêu cho IQC, IPQC hoặc FQC, có phiên bản. Trạng thái Nháp → Đang áp dụng (Phát hành) → Lưu trữ. Mỗi mã chỉ có một bản Đang áp dụng; phiếu cũ giữ chỉ tiêu của mình."
            }
         ],
         "responsibilities": [
            {
               "role": "Nhân viên KCS, Nhân viên QC (QC_INSPECTOR, QC)",
               "tasks": [
                  "Lập phiếu IQC khi vật tư về (từ tab Chờ Kiểm IQC hoặc từ đơn mua)",
                  "Lập phiếu IPQC trên máy: duyệt setup 4M, ký mẫu, cho sản xuất, kiểm lặp lại, chốt lô",
                  "Lập phiếu FQC cho lệnh SX ở tab Chờ Kiểm FQC; in biên bản và CoA",
                  "Lập NCR từ phiếu Không đạt / Cảnh báo, ghi D3 ngăn chặn"
               ]
            },
            {
               "role": "Trưởng phòng QA/QC (QAQC_MANAGER)",
               "tasks": [
                  "Sửa phiếu IQC đã chốt kết quả khi cần",
                  "Chủ trì NCR: nguyên nhân gốc, D5 khắc phục, D7 phòng ngừa, xác minh hiệu quả, đóng NCR (khi được cấp quyền Duyệt NCR)",
                  "Tạo, sửa, phát hành mẫu kiểm tra; Khôi phục ISO khi cần"
               ]
            },
            {
               "role": "Tổ đóng gói (Xưởng sản xuất)",
               "tasks": [
                  "Nhận Phiếu đóng gói Chờ đóng gói, bấm [Đóng gói] → [Hoàn tất đóng gói & nhập kho]",
                  "In tem thùng, thẻ pallet; chuyển Chờ gom xe, tạo phiếu giao cho lô cùng khách hàng"
               ]
            },
            {
               "role": "Thủ kho vật tư",
               "tasks": [
                  "Nhập kho lô IQC Đạt / Cảnh báo ở Kho › Kho Vật tư › tab Chờ nhập kho; lô nhập xong tự rời danh sách"
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền, đóng được NCR, sửa được phiếu IQC đã chốt."
            },
            {
               "role": "QAQC_MANAGER, QC_INSPECTOR, QC (theo cấu hình Phân quyền)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Lập / sửa / xoá phiếu IQC, IPQC, FQC, NCR, mẫu kiểm tra cần quyền tương ứng của từng trang (hệ thống kiểm cả ở máy chủ). Phiếu IQC đã chốt Đạt / Không đạt chỉ người có quyền sửa hoặc duyệt KCS vật tư mới sửa. [Phê duyệt (Pass) (n)] trên danh sách FQC cần quyền Duyệt FQC. Đóng NCR cần quyền Duyệt NCR, thiếu quyền hệ thống báo Chỉ người có quyền duyệt NCR mới được đóng phiếu NCR."
            },
            {
               "role": "Người dùng không có quyền ghi KCS",
               "view": "👁",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Không thấy nút [Lập Phiếu IQC], [Lập Phiếu IPQC], [KCS Thành Phẩm], mục Chỉnh sửa trong menu dòng; vẫn xem và xuất Excel."
            }
         ],
         "processFlowchart": "graph TD\n    A[Vật tư về theo đơn mua] --> B[IQC Đầu vào]\n    B -->|Đạt hoặc Cảnh báo| C[Kho Vật tư - tab Chờ nhập kho]\n    C --> C2[Thủ kho nhập kho - lô rời danh sách]\n    B -->|Không đạt| N[Lập NCR 8D]\n    C2 --> D[Sản xuất theo Lệnh SX]\n    D --> E[IPQC: Duyệt setup 4M - Ký mẫu]\n    E --> E2[Cho sản xuất - công đoạn Đang chạy]\n    E2 --> E3[Kiểm tra lặp lại - Chốt lô]\n    E3 -->|Không đạt| N\n    E3 -->|Đạt| G[Tab Chờ Kiểm FQC]\n    G --> H[FQC Nghiệm thu thành phẩm]\n    H -->|Không đạt| N\n    H -->|Đạt hoặc Nhân nhượng| P[Phiếu đóng gói DG - Chờ đóng gói]\n    P --> Q[Tổ đóng gói: Hoàn tất đóng gói và nhập kho - in tem thùng]\n    Q --> R[Chờ giao hàng hoặc Chờ xe]\n    R --> S[Phiếu giao hàng - chỉ gom lô cùng khách hàng]\n    N --> N1[Mở]\n    N1 --> N2[Đang điều tra - D4]\n    N2 --> N3[Hành động KP - D5 D7]\n    N3 --> N4[Xác minh]\n    N4 --> N5[Đã đóng - D8]\n    N1 -.->|Đóng sớm khi đủ nội dung| N5\n    N2 -.->|Đóng sớm khi đủ nội dung| N5",
         "mainFlow": [
            {
               "step": 1,
               "action": "Kiểm tra vật tư đầu vào (IQC)",
               "detail": "• Vào Chất lượng › IQC Đầu vào. Trang có 2 tab: Lịch Sử IQC và Chờ Kiểm IQC.\n• Tab Chờ Kiểm IQC liệt kê dòng đơn mua còn số lượng chưa kiểm; bấm [Lập IQC] trên dòng để mở phiếu điền sẵn đơn mua, vật tư, nhà cung cấp. Cũng có thể mở từ Mua hàng: menu dòng đơn Đã đặt hàng / Nhận 1 phần → [Nhận hàng (IQC)], hoặc bấm [Lập Phiếu IQC] để lập tay.\n• Thông tin chung: Vật tư, Nhóm vật tư, Nhà cung cấp, Đơn mua, Số lô NCC, Số CoA (tích Đã đối chiếu), Ngày kiểm, Người kiểm.\n• Hàng lấy mẫu: Cỡ lô, Cách kiểm (AQL hoặc 100%), Mức kiểm, AQL nặng, AQL nhẹ. Cỡ mẫu và Ac/Re tự tra theo ISO 2859-1 (ví dụ lô 5.000, mức II, AQL 1,5 / 4,0 → 200 mẫu, Ac/Re 7/8 và 14/15). Kiểm 100% thì chọn Lỗi bị loại: Mọi lỗi hoặc Nặng trở lên.\n• Bảng Chỉ tiêu kiểm tra (chọn Mẫu kiểm tra ở đầu bảng): chỉ tiêu định tính chọn Đạt / Không đạt / N/A, chỉ tiêu định lượng nhập số đo, hệ thống tự đánh giá theo min – max. Nút [Tất cả Đạt] đặt Đạt cho các dòng định tính chưa chấm.\n• Bảng Lỗi phát hiện: nơi duy nhất nhập số lỗi Nghiêm trọng / Nặng / Nhẹ.\n• Kết luận tự tính: Không đạt khi có lỗi nghiêm trọng, lỗi nặng hoặc nhẹ chạm mức Re, hoặc có chỉ tiêu Không đạt. Chỉ khi Không đạt mới tích được Nhân nhượng và phải ghi Lý do nhân nhượng (phiếu lưu là Cảnh báo).\n• Nhập SL loại (SL nhập kho = Cỡ lô − SL loại), Nhận xét, bấm [Lưu Biên Bản IQC].\n• Lô Đạt hoặc Cảnh báo, kể cả lô lập từ đơn mua, hiện ngay ở Kho › Kho Vật tư › Phiếu nhập xuất › tab Chờ nhập kho với SL nhập kho. Lập phiếu IQC không còn được tính là đã nhận hàng: chỉ khi Thủ kho chốt phiếu nhập kho thì số nhận mới cộng vào đơn mua và lô tự rời khỏi danh sách chờ.\n• Lô Không đạt không vào hàng chờ nhập kho; bấm [Tạo NCR] để xử lý."
            },
            {
               "step": 2,
               "action": "Kiểm tra công đoạn trên máy (IPQC)",
               "detail": "• Vào Chất lượng › IPQC Công đoạn → [Lập Phiếu IPQC]. Thông tin chung: Lệnh SX, Công đoạn (phải thuộc đúng lệnh đã chọn), Nhóm công đoạn, Máy, Ca, Thợ đứng máy, Người kiểm, Mẫu chuẩn, Tần suất; hàng lấy mẫu tự tra cỡ mẫu và Ac/Re. Hệ thống tự nạp mẫu kiểm tra Đang áp dụng của công đoạn.\n• 1. Duyệt setup (4M): chấm từng dòng Người, Máy, Vật tư, Phương pháp là Đạt / Không đạt / N/A, mỗi dòng có ghi chú. Tích Không đạt, dừng máy nếu phải dừng. Bấm [Lưu]. Phiếu IPQC Không đạt đánh dấu công đoạn lỗi QC và mở [Lập NCR], nhưng không tự khoá Màn hình xưởng: quản đốc quyết định dừng máy, công đoạn vẫn báo sản lượng / kết thúc được.\n• 2. Ký mẫu: chấm chỉ tiêu sản phẩm trên mẫu đầu, nhập Số mẫu ký, Mẫu lỗi, Số mẫu lưu, Trưởng ca → [Ký mẫu]. Chỉ ký được khi duyệt setup Đạt và mọi chỉ tiêu sản phẩm Đạt.\n• [Cho sản xuất]: chỉ bấm được sau khi ký mẫu; công đoạn trên Lệnh SX chuyển Đang chạy, phiếu sang bước Kiểm tra lặp lại.\n• 3. Kiểm tra lặp lại: mỗi lần đến tần suất bấm [+ Lần kiểm], ghi giờ, mốc sản lượng, số mẫu, mẫu lỗi, mã lỗi, các thông số đo lại, kết quả (Đạt / Chỉnh máy / Dừng máy). Mã lỗi chọn ở lần kiểm được cộng vào bảng Lỗi phát hiện.\n• 4. Chốt lô: Tổng mẫu, Mẫu lỗi tự cộng (mẫu ký + các lần kiểm), so Ac/Re theo cỡ lô → kết luận Đạt / Không đạt tự động (Nhân nhượng phải ghi lý do) → [Chốt lô]. Chưa cho sản xuất thì chưa chốt lô được.\n• Không đạt (duyệt setup hoặc chốt lô) đánh dấu công đoạn lỗi KCS; trang chi tiết hiện khung cảnh báo và nút [Lập NCR]."
            },
            {
               "step": 3,
               "action": "Nghiệm thu thành phẩm (FQC) và bàn giao đóng gói",
               "detail": "• Vào Chất lượng › FQC Thành phẩm. Trang có 2 tab: Lịch Sử FQC và Chờ Kiểm FQC (lệnh SX đang sản xuất hoặc đã hoàn thành còn SL chưa kiểm). Bấm [Lập FQC] trên dòng, hoặc [KCS Thành Phẩm] trên thanh công cụ.\n• Thông tin chung: Lệnh SX, Sản phẩm, Khách hàng, Đơn hàng (lấy từ lệnh), Loại SP, Nhóm SP, Mẫu chuẩn (bắt buộc khi có chỉ tiêu so mẫu), Ngày kiểm, Người kiểm. Hàng lấy mẫu: Cỡ lô, Cách kiểm (AQL / 100%), Mức kiểm, AQL nặng, AQL nhẹ.\n• Chấm bảng Chỉ tiêu kiểm tra và bảng Lỗi phát hiện như IQC; kết luận tự tính, Nhân nhượng phải ghi lý do. Nhập SL loại; SL Đạt (bàn giao đóng gói) tự tính. Kiểm 100% thì SL loại tự lấy bằng số sản phẩm lỗi (sửa được). Bấm [Lưu Biên Bản FQC].\n• Giới hạn số lượng: tổng SL Đạt các biên bản của một lệnh không vượt SL kế hoạch, và không vượt SL Đạt của công đoạn cuối nếu lệnh có ghi nhật ký sản xuất. Vượt thì hệ thống báo: LSX … kế hoạch …, đã nghiệm thu Đạt … — biên bản này chỉ được Đạt tối đa …\n• Phiếu FQC chỉ kết luận chất lượng, không có ô nhập kho, quy cách thùng hay tạo phiếu giao. Lô Đạt / Nhân nhượng tự sinh Phiếu đóng gói DG-… ở trạng thái Chờ đóng gói, SL nhận = SL Đạt.\n• Trang chi tiết FQC: [In CoA] (lô Đạt / Cảnh báo), [In biên bản] (BM-QC-03), nút mã phiếu đóng gói [DG-…] mở màn Đóng gói, [Tạo NCR] (khi Không đạt, Cảnh báo hoặc có SL loại), [Sửa], [Xoá]. Có khung Phiếu đóng gói và khung Thông Tin Điều Vận & Giao Hàng chỉ để xem.\n• Ngay dưới số phiếu ở danh sách FQC hiện tình trạng lô: Chờ đóng gói → Chờ giao hàng (hoặc Chờ xe) → Giao XK-… (bấm mở phiếu giao); lô giao một phần ghi còn n. Lọc Tình trạng: Chờ đóng gói, Chưa giao, Chờ gom xe, Đã lên phiếu giao.\n• Lô đã đóng gói và nhập kho thì biên bản FQC không đổi được SL Đạt, kết quả, lệnh SX và không xoá được. Xoá biên bản chưa đóng gói thì phiếu đóng gói chờ cũng bị xoá theo."
            },
            {
               "step": 4,
               "action": "Đóng gói, nhập kho, tem thùng, giao hàng (Sản xuất thực hiện, QC theo dõi)",
               "detail": "• Vào Xưởng sản xuất › Đóng Gói & Nhập Kho. Tab: Chờ Đóng Gói, Đã Nhập Kho, Tất Cả Lô.\n• Bấm [Đóng gói] trên dòng → hộp Phiếu Đóng Gói DG-…: chọn Người đóng gói phụ trách, nhập SL lỗi khi đóng gói (SL đạt = SL nhận từ KCS − SL lỗi), Kho thành phẩm nhận, Số lô thành phẩm, SP / thùng (lấy theo Số cái / thùng của sản phẩm, chưa có thì nhập), Thùng / pallet, kích thước, trọng lượng; tích Dồn thùng lẻ vào thùng cuối nếu cần → [Hoàn tất đóng gói & nhập kho]. Hệ thống nhập kho thành phẩm theo SL đạt đóng gói, tạo tem thùng số nhảy và tự mở hộp in tem.\n• In tem: [In Tem Thùng] trên dòng, hoặc tích nhiều lô → [In tem thùng (n)]. Hộp In tem thùng số nhảy cho chọn thùng (mặc định thùng chưa in), khổ Cuộn 80 × 150 mm hoặc Dàn A4 (4 tem) → [In n tem]. Tem có logo, khách hàng, số ĐH / PO, LSX, lô, số thùng 1/N … N/N, dấu QC PASSED và QR riêng từng thùng; in lại giữ nguyên mã tem. [In thẻ pallet] in thẻ kiện pallet.\n• Lô đã nhập kho: [Giao Hàng] trên dòng, hoặc tích nhiều lô → [Giao hàng (n)] / [Chờ gom xe (n)]. Chỉ gom phiếu giao khi các lô cùng một khách hàng; chọn lẫn khách hàng hệ thống báo Chỉ gom phiếu giao khi cùng khách hàng … và không mở phiếu.\n• Phiếu đã nhập kho bấm [Sửa phiếu] chỉ sửa người đóng gói, pallet, kích thước, trọng lượng, ghi chú. Lô đã lên phiếu giao đủ không còn nút đóng gói, nhập kho hay giao hàng."
            },
            {
               "step": 5,
               "action": "Lập và xử lý NCR 8D",
               "detail": "• Lập NCR: [Tạo NCR Mới] ở Chất lượng › Sự cố NCR; hoặc từ phiếu kiểm: IQC [Tạo NCR] trên chi tiết / [+ Lập Phiếu NCR] trong menu dòng (phiếu Không đạt, Cảnh báo); IPQC [Lập NCR] trên chi tiết / [Tạo NCR Sự Cố] trong menu dòng (phiếu Không đạt); FQC [Tạo NCR] trên chi tiết / [Tạo NCR Sự Cố] trong menu dòng. Lập từ phiếu kiểm thì Nguồn phát hiện, chứng từ gốc, số lô, số lượng, chỉ tiêu không đạt được điền sẵn.\n• D1–D2. Mô tả sự không phù hợp: Nguồn phát hiện (IQC, IPQC, FQC, Khách hàng, NCC, Nội bộ), Mức độ (Nghiêm trọng, Cao, Trung bình, Thấp), Trạng thái, Số lô, Lệnh SX, Công đoạn, Máy, Sản phẩm, Vật tư, Nhà cung cấp, Khách hàng, Chứng từ gốc, Cỡ lô, Cỡ mẫu, SL đạt, SL lỗi, ĐVT, D2. Mô tả lỗi.\n• Hướng xử lý & chi phí: chọn cách xử lý hàng lỗi (Gia công sửa lỗi / Chọn lọc (Rework), Hủy phế phẩm & Lập lệnh bù (Scrap & Reprint), Xin nhân nhượng xuất hàng (Concession), Trả Nhà cung cấp (Return to Vendor - RTV), Hạ cấp / Tận dụng nội bộ (Downgrade); danh sách lấy từ cấu hình QC_DISPOSITION_OPTIONS), Bộ phận chịu trách nhiệm, Người phụ trách, chi phí Hủy hàng, Lựa / sửa lỗi, In bù / phụ phí.\n• D4. Nguyên nhân gốc: chọn nhóm 6M, trả lời Why 1–5, ghi Nguyên nhân gốc (để trống thì hệ thống nối chuỗi 5 Why).\n• D3. Ngăn chặn, D5. Khắc phục, D7. Phòng ngừa là ba ô riêng, lưu riêng; D6/D8. Kết quả xử lý; Kế hoạch & thời hạn.\n• Bấm [Tạo Phiếu NCR 8D]. Sửa sau bằng [Sửa / CAPA] → [Lưu Thay Đổi]; D5, D7 hiện lại đúng nội dung đã lưu.\n• Trên trang chi tiết bấm lần lượt [Bắt đầu điều tra (D4)] → [Thực thi CAPA] → [Chuyển thẩm tra] → [Đóng Hồ Sơ NCR (D8)]. [In 8D] in Phiếu xử lý sự không phù hợp có đủ D5, D7.\n• Đóng NCR: cần quyền Duyệt NCR và phải có đủ nguyên nhân gốc, hành động khắc phục (D5) và cách xử lý hàng lỗi. Thiếu thì hệ thống báo Chưa đóng NCR được — còn thiếu … Phiếu Mở hoặc Đang điều tra được đóng sớm (sự cố nhỏ) bằng mục [Đóng NCR] trong menu dòng ở danh sách (hỏi xác nhận trước) hoặc chọn Trạng thái Đã đóng trên form sửa. Phiếu đã đóng không mở lại được."
            },
            {
               "step": 6,
               "action": "Quản lý Biểu mẫu QC (mẫu kiểm tra)",
               "detail": "• Vào Chất lượng › Biểu mẫu QC. Tab lọc: Tất cả, IQC Vật tư, IPQC Công đoạn, FQC Thành phẩm.\n• [Tạo Tiêu Chuẩn] → nhập Mã, Tên, Phân hệ (IQC · Vật tư đầu vào / IPQC · Công đoạn / FQC · Thành phẩm), Nhóm vật tư hoặc Công đoạn hoặc Nhóm thành phẩm và Loại sản phẩm áp dụng, Trạng thái (Đang áp dụng / Nháp / Lưu trữ), Quy tắc lấy mẫu, AQL, Mô tả; IPQC thêm Tần suất kiểm tra lặp lại và Số mẫu ký. Danh mục nhóm vật tư, công đoạn, nhóm thành phẩm lấy từ Hệ Thống & Quy Trình › Cấu hình (nhóm Chất lượng).\n• [Thêm chỉ tiêu]: tên chỉ tiêu, Loại (Định lượng / Định tính), Mức lỗi (Nghiêm trọng / Nặng / Nhẹ), Bắt buộc, Nguồn (Đo tại xưởng / Theo CoA / Gửi lab), Dụng cụ, Tiêu chuẩn, Nhóm; định lượng nhập Chuẩn / Min / Max / ĐVT. IPQC chọn Giai đoạn (Duyệt setup / Lặp lại / Cả hai) và bật Đo lại mỗi lần kiểm để chỉ tiêu thành một cột ở bảng kiểm lặp lại. Mũi tên lên / xuống để sắp xếp. Bấm [Lưu bộ tiêu chuẩn].\n• Trang chi tiết (tiêu đề Mã vN): [Chỉnh sửa chỉ tiêu], [Nhân bản], [Phát hành] (bản Nháp, có hộp xác nhận), [Phiên bản mới] (bản Đang áp dụng). Có Thông tin chung và Lịch sử phiên bản.\n• Sửa một bản Đang áp dụng không ghi đè: hệ thống tạo phiên bản mới (Nháp, trừ khi chọn Trạng thái Đang áp dụng). Khi phát hành, bản đang áp dụng cùng mã chuyển Lưu trữ; phiếu cũ vẫn giữ chỉ tiêu đã chấm.\n• Xoá mẫu đã dùng trong phiếu thì mẫu chuyển Lưu trữ thay vì xoá. [Khôi Phục ISO] nạp lại 16 bộ tiêu chuẩn gốc (có hộp xác nhận).\n• Phiếu IQC / IPQC / FQC mới tự nạp bản Đang áp dụng theo nhóm vật tư, công đoạn hoặc thành phẩm."
            }
         ],
         "subFlows": [
            {
               "name": "IQC — Lập / Sửa / Xoá / In / Excel",
               "steps": [
                  "Lập: [Lập Phiếu IQC], hoặc tab Chờ Kiểm IQC → [Lập IQC], hoặc Mua hàng → menu dòng → [Nhận hàng (IQC)] → điền → [Lưu Biên Bản IQC].",
                  "Xem: bấm dòng. Trang chi tiết có [Tạo NCR] (phiếu Không đạt / Cảnh báo), [In phiếu], [Sửa], [Xoá].",
                  "Sửa: menu dòng → Chỉnh sửa, hoặc [Sửa] → [Cập Nhật Phiếu IQC]. Phiếu đã chốt Đạt / Không đạt với người không đủ quyền hiện dòng Phiếu đã chốt kết quả. Chỉ Quản lý QC hoặc Ban Giám Đốc được sửa, các ô bị khoá.",
                  "Xoá: [Xoá] trên chi tiết hoặc chọn nhiều dòng → [Xoá]. Phiếu đã xoá nằm ở tab Thùng rác, khôi phục được đúng mã cũ.",
                  "In: [In phiếu] — Phiếu kiểm tra vật tư đầu vào (BM-QC-01). Excel: [Xuất Excel] trên thanh công cụ hoặc theo dòng chọn."
               ]
            },
            {
               "name": "IPQC — Lập / Sửa / Xoá / In",
               "steps": [
                  "[Lập Phiếu IPQC] → thông tin chung, 1. Duyệt setup (4M) → [Lưu] → 2. [Ký mẫu] → [Cho sản xuất] → 3. [+ Lần kiểm] theo tần suất → 4. [Chốt lô].",
                  "Sửa: menu dòng → Chỉnh sửa, hoặc [Sửa] trên chi tiết. Thanh giai đoạn trên phiếu cho bấm chuyển nhanh giữa các bước đã mở.",
                  "Xoá: [Xoá] trên chi tiết (vào Thùng rác, khôi phục được).",
                  "In: [In phiếu] — Báo cáo kiểm tra công đoạn (BM-QC-02): thông tin chung, 4M, ký mẫu, bảng kiểm lặp lại (quá 12 lần sang trang 2), chốt lô, ô ký.",
                  "Phiếu Không đạt: [Lập NCR] trên chi tiết hoặc menu dòng [Tạo NCR Sự Cố]."
               ]
            },
            {
               "name": "FQC — Lập / Sửa / Xoá / In / Duyệt",
               "steps": [
                  "Lập: [KCS Thành Phẩm] hoặc tab Chờ Kiểm FQC → [Lập FQC] → điền → [Lưu Biên Bản FQC].",
                  "Sửa: menu dòng → Chỉnh sửa, hoặc [Sửa] → [Cập Nhật Biên Bản FQC]. Lô đã đóng gói nhập kho không đổi được SL Đạt, kết quả.",
                  "Duyệt nhanh: chọn phiếu Chờ kiểm → [Phê duyệt (Pass) (n)] (cần quyền Duyệt). Số liệu cho kết quả Không đạt thì hệ thống không cho chuyển Đạt.",
                  "In: [In biên bản] (BM-QC-03), [In CoA] (Phiếu chứng nhận chất lượng). Thanh công cụ: [Báo Cáo KCS] in Báo cáo thành phẩm & kiểm định KCS theo kỳ.",
                  "Xoá: [Xoá] trên chi tiết hoặc chọn nhiều dòng → [Xoá]; xoá kèm phiếu đóng gói đang chờ."
               ]
            },
            {
               "name": "NCR — Lập / Sửa / Đóng / In",
               "steps": [
                  "[Tạo NCR Mới] hoặc lập từ phiếu kiểm lỗi → [Tạo Phiếu NCR 8D].",
                  "Sửa: menu dòng → Chỉnh sửa / CAPA, hoặc [Sửa / CAPA] → [Lưu Thay Đổi]. Ô Trạng thái trên form chỉ cho chuyển theo đúng thứ tự; sai bước hệ thống báo Không chuyển NCR từ … sang … được và gợi ý bước hợp lệ.",
                  "Đóng: [Đóng Hồ Sơ NCR (D8)] ở bước Xác minh; hoặc menu dòng [Đóng NCR] cho phiếu Mở, Đang điều tra, Xác minh (hỏi xác nhận Đóng phiếu …? Phiếu đã đóng không mở lại được).",
                  "In: [In 8D]. Xoá: [Xoá] trên chi tiết hoặc chọn nhiều dòng → [Xoá] (vào Thùng rác).",
                  "Lọc nhanh: Tất cả sự cố, Mới mở, Đang điều tra, Khắc phục CAPA, Đã đóng; [Xuất Excel]."
               ]
            },
            {
               "name": "Biểu mẫu QC — Tạo / Sửa / Phát hành / Phiên bản",
               "steps": [
                  "[Tạo Tiêu Chuẩn] → khai báo → [Thêm chỉ tiêu] → [Lưu bộ tiêu chuẩn]; thông báo Đã tạo bộ tiêu chuẩn QC thành công.",
                  "Sửa bản Nháp: [Chỉnh sửa chỉ tiêu] → lưu, thông báo Đã cập nhật bộ tiêu chuẩn QC.",
                  "Sửa bản Đang áp dụng: hệ thống tạo phiên bản mới, thông báo Đã tạo phiên bản vN (Nháp — bấm Phát hành để áp dụng).",
                  "[Phát hành] trên bản Nháp → xác nhận; bản cũ cùng mã chuyển Lưu trữ.",
                  "Nhân bản bằng biểu tượng trên dòng hoặc [Nhân bản]; xoá bằng biểu tượng Xóa / Lưu trữ."
               ]
            },
            {
               "name": "Biểu mẫu QC — Khôi Phục ISO (bộ tiêu chuẩn gốc)",
               "steps": [
                  "Chất lượng › Biểu mẫu QC › [Khôi Phục ISO] › xác nhận [Khôi phục tiêu chuẩn gốc].",
                  "Hệ thống khôi phục 16 bộ tiêu chuẩn gốc ngành bao bì giấy offset (6 nhóm IQC, 6 công đoạn IPQC, 4 dòng FQC); biểu mẫu do công ty tự tạo thêm được giữ nguyên.",
                  "Dùng khi bộ gốc bị sửa sai hoặc xoá; trước khi bấm, báo trưởng QA vì các bộ gốc đã chỉnh sẽ trở về nội dung gốc."
               ]
            },
            {
               "name": "Phiếu IQC / IPQC / FQC / NCR — khu vực hình ảnh và hồ sơ CoA",
               "steps": [
                  "Trên phiếu IQC, IPQC, FQC, khu vực hồ sơ hình ảnh có 3 ô: Ảnh Mẫu Kiểm / Mẫu Ký, Ảnh Lỗi Thực Tế (NG) và Hồ Sơ CoA / Test Report.",
                  "[Ảnh / PDF CoA]: tải lên ảnh chụp hoặc tệp PDF chứng nhận chất lượng (CoA, test report) của lô hàng vào ô Hồ Sơ CoA; hai ô ảnh còn lại chỉ nhận ảnh.",
                  "Ảnh lớn được tự thu nhỏ trước khi tải lên; tải xong hệ thống báo \"Đã tải lên … tệp đính kèm\", lỗi thì báo \"Lỗi tải tệp lên server\" kèm lý do.",
                  "Trên phiếu NCR, khu vực này có 2 ô: Ảnh Lỗi (Trước Xử Lý) và Ảnh Kết Quả (Sau Xử Lý), cả hai đều nhận ảnh hoặc PDF.",
                  "Biểu tượng thùng rác trên từng tệp (title Xóa tệp) gỡ tệp khỏi phiếu; khi xem phiếu ở chế độ chỉ đọc thì không có nút tải lên và nút xóa."
               ]
            },
            {
               "name": "Biểu mẫu QC — nhân bản bộ tiêu chuẩn và chỉ tiêu",
               "steps": [
                  "[Nhân bản bộ tiêu chuẩn QC] (biểu tượng sao chép ở cột thao tác): tạo bản sao của bộ tiêu chuẩn với mã thêm đuôi -COPY và tên thêm \"(Bản sao)\", rồi mở ngay trang sửa bản sao.",
                  "Bản sao được tạo ở trạng thái đang dùng, nên rà soát và chỉnh tên, chỉ tiêu trước khi đưa vào kiểm tra thực tế.",
                  "[Nhân bản chỉ tiêu này] (trong trang tạo/sửa biểu mẫu): chèn một chỉ tiêu giống hệt ngay dưới chỉ tiêu đang chọn, tên thêm \"(Bản sao)\".",
                  "[Xóa chỉ tiêu]: bỏ chỉ tiêu đó khỏi biểu mẫu đang soạn; thay đổi chỉ được ghi lại khi bạn lưu biểu mẫu."
               ]
            },
            {
               "name": "Báo cáo QC — Biểu đồ Pareto",
               "steps": [
                  "[Phóng lớn] (góc phải khung Biểu Đồ Pareto 80/20): mở biểu đồ Pareto lỗi ở cửa sổ lớn để xem rõ từng loại lỗi và đường tích lũy, theo đúng công đoạn đang lọc."
               ]
            },
            {
               "name": "Đóng gói thành phẩm — nút mở nhanh sổ kho",
               "steps": [
                  "[Sổ kho TP]: nút phụ trên màn Đóng gói, mở danh sách phiếu nhập / xuất của kho thành phẩm để đối chiếu các lô đã đóng gói nhập kho."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "IQC: (Tạo mới)",
               "to": "Đạt / Cảnh báo (nhân nhượng) / Không đạt",
               "action": "Kết luận tự tính từ chỉ tiêu và lỗi → [Lưu Biên Bản IQC]. Đạt / Cảnh báo vào Kho Vật tư › tab Chờ nhập kho",
               "allowedRoles": "Người có quyền lập phiếu IQC"
            },
            {
               "from": "IQC: Đạt / Không đạt",
               "to": "Kết luận khác",
               "action": "[Sửa] → [Cập Nhật Phiếu IQC]",
               "allowedRoles": "Admin, Giám đốc, Trưởng QA/QC hoặc người có quyền sửa / duyệt KCS vật tư"
            },
            {
               "from": "IPQC: (Tạo mới)",
               "to": "Đang kiểm → Đạt / Cảnh báo (nhân nhượng) / Không đạt",
               "action": "[Lưu] → [Ký mẫu] → [Cho sản xuất] (công đoạn Đang chạy) → [+ Lần kiểm] → [Chốt lô]",
               "allowedRoles": "Người có quyền lập / sửa phiếu IPQC"
            },
            {
               "from": "FQC: (Tạo mới)",
               "to": "Đạt / Cảnh báo (nhân nhượng) / Không đạt",
               "action": "[Lưu Biên Bản FQC]; Đạt / Cảnh báo tự sinh Phiếu đóng gói DG-… Chờ đóng gói",
               "allowedRoles": "Người có quyền lập phiếu FQC"
            },
            {
               "from": "FQC: Chờ kiểm",
               "to": "Đạt",
               "action": "[Phê duyệt (Pass) (n)] trên thanh tác vụ (bị chặn nếu số liệu cho Không đạt)",
               "allowedRoles": "Người có quyền Duyệt FQC"
            },
            {
               "from": "Phiếu đóng gói: Chờ đóng gói",
               "to": "Đã đóng gói & nhập kho",
               "action": "[Đóng gói] → [Hoàn tất đóng gói & nhập kho]",
               "allowedRoles": "Tổ đóng gói (quyền sửa của trang Đóng gói)"
            },
            {
               "from": "NCR: Mở",
               "to": "Đang điều tra",
               "action": "[Bắt đầu điều tra (D4)]",
               "allowedRoles": "Người có quyền sửa NCR"
            },
            {
               "from": "NCR: Đang điều tra",
               "to": "Hành động KP (khắc phục)",
               "action": "[Thực thi CAPA]",
               "allowedRoles": "Người có quyền sửa NCR"
            },
            {
               "from": "NCR: Hành động KP",
               "to": "Xác minh",
               "action": "[Chuyển thẩm tra]",
               "allowedRoles": "Người có quyền sửa NCR"
            },
            {
               "from": "NCR: Xác minh",
               "to": "Đang điều tra",
               "action": "[Sửa / CAPA] → Trạng thái Đang điều tra khi xác minh chưa đạt",
               "allowedRoles": "Người có quyền sửa NCR"
            },
            {
               "from": "NCR: Xác minh (hoặc đóng sớm từ Mở / Đang điều tra)",
               "to": "Đã đóng",
               "action": "[Đóng Hồ Sơ NCR (D8)], menu dòng [Đóng NCR] hoặc Trạng thái Đã đóng trên form; bắt buộc có nguyên nhân gốc, D5 khắc phục, cách xử lý hàng lỗi",
               "allowedRoles": "Người có quyền Duyệt NCR"
            },
            {
               "from": "Biểu mẫu QC: Nháp",
               "to": "Đang áp dụng",
               "action": "[Phát hành] → xác nhận; bản Đang áp dụng cũ cùng mã chuyển Lưu trữ",
               "allowedRoles": "Người có quyền sửa Biểu mẫu QC"
            }
         ],
         "actionLinks": [
            {
               "from": "Mua hàng (đơn Đã đặt hàng / Nhận 1 phần)",
               "to": "Phiếu IQC",
               "action": "[Nhận hàng (IQC)]",
               "how": "Menu dòng đơn mua; phiếu IQC điền sẵn đơn mua, nhà cung cấp."
            },
            {
               "from": "Phiếu IQC Đạt / Cảnh báo",
               "to": "Kho › Kho Vật tư › Phiếu nhập xuất › tab Chờ nhập kho",
               "action": "Tự động khi lưu phiếu",
               "how": "Thủ kho lập phiếu nhập từ lô; chốt nhập xong số nhận cộng vào đơn mua và lô rời danh sách chờ."
            },
            {
               "from": "Phiếu IPQC",
               "to": "Công đoạn trên Lệnh SX",
               "action": "[Cho sản xuất] / [Chốt lô]",
               "how": "Cho sản xuất chuyển công đoạn sang Đang chạy; Không đạt đánh dấu công đoạn lỗi KCS."
            },
            {
               "from": "Lệnh SX đang sản xuất / hoàn thành",
               "to": "Phiếu FQC",
               "action": "[Lập FQC]",
               "how": "Tab Chờ Kiểm FQC."
            },
            {
               "from": "Phiếu FQC Đạt / Nhân nhượng",
               "to": "Xưởng sản xuất › Đóng Gói & Nhập Kho",
               "action": "Tự sinh Phiếu đóng gói DG-…; nút [DG-…] trên chi tiết FQC",
               "how": "Phiếu đóng gói Chờ đóng gói, SL nhận = SL Đạt. Kho thành phẩm cũng thấy ở tab Hàng Chờ Nhập Kho TP (từ FQC Đạt)."
            },
            {
               "from": "Phiếu đóng gói đã nhập kho",
               "to": "Phiếu giao hàng",
               "action": "[Giao Hàng] / [Giao hàng (n)]",
               "how": "Chỉ lô đã nhập kho, chưa giao đủ, cùng một khách hàng; lô cũng hiện trong hàng chờ giao bên Giao hàng."
            },
            {
               "from": "Phiếu IQC / IPQC / FQC lỗi",
               "to": "Phiếu NCR",
               "action": "[Tạo NCR] / [Lập NCR] / [+ Lập Phiếu NCR] / [Tạo NCR Sự Cố]",
               "how": "NCR điền sẵn nguồn phát hiện, chứng từ gốc, số lô, số liệu và chỉ tiêu không đạt."
            },
            {
               "from": "Biểu mẫu QC Đang áp dụng",
               "to": "Phiếu IQC / IPQC / FQC mới",
               "action": "Tự nạp chỉ tiêu",
               "how": "Theo nhóm vật tư, công đoạn hoặc nhóm / loại thành phẩm; đổi được ở ô Mẫu kiểm tra."
            }
         ],
         "inlineViews": [
            {
               "name": "Hàng chờ kiểm",
               "trigger": "Tab Chờ Kiểm IQC / Chờ Kiểm FQC",
               "description": "Dòng đơn mua hoặc lệnh SX chưa kiểm hết; lập phiếu một chạm bằng [Lập IQC] / [Lập FQC]."
            },
            {
               "name": "Hộp lập / sửa biên bản FQC",
               "trigger": "[KCS Thành Phẩm] hoặc menu dòng Chỉnh sửa ở danh sách FQC",
               "description": "Lập hoặc sửa biên bản FQC ngay trên danh sách."
            },
            {
               "name": "Tình trạng lô dưới số phiếu FQC",
               "trigger": "Danh sách FQC",
               "description": "Chờ đóng gói / Chờ giao hàng / Chờ xe / Giao XK-…; bấm mã phiếu giao để mở."
            },
            {
               "name": "Khung Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật",
               "trigger": "Trang chi tiết IQC, IPQC, FQC, NCR, Biểu mẫu QC",
               "description": "Trao đổi, đính kèm ảnh / tệp, xem ai sửa gì (giá trị cũ → mới)."
            }
         ],
         "quickActions": [
            {
               "action": "Lọc kết quả",
               "description": "IQC: Tất cả kết quả, Đạt chuẩn, Cảnh báo, Từ chối. FQC: Tất cả kết quả, Đạt, Không đạt, Chờ duyệt và Tiến độ xuất giao. NCR: Tất cả sự cố, Mới mở, Đang điều tra, Khắc phục CAPA, Đã đóng."
            },
            {
               "action": "Tất cả Đạt",
               "description": "Trên bảng Chỉ tiêu kiểm tra, đặt Đạt cho mọi chỉ tiêu định tính chưa chấm rồi sửa riêng dòng lỗi."
            },
            {
               "action": "Tìm kiếm",
               "description": "Dùng ô tìm kiếm chung trên thanh đầu trang."
            },
            {
               "action": "Thùng rác",
               "description": "Tab Thùng rác ở danh sách IQC, IPQC, FQC, NCR: xem phiếu đã xoá và khôi phục đúng mã cũ."
            }
         ],
         "forms": [
            {
               "code": "BM-QC-01",
               "name": "Phiếu kiểm tra vật tư đầu vào (IQC) — nút [In phiếu]"
            },
            {
               "code": "BM-QC-02",
               "name": "Báo cáo kiểm tra công đoạn (IPQC) — nút [In phiếu]"
            },
            {
               "code": "BM-QC-03",
               "name": "Biên bản kiểm tra thành phẩm (FQC) — nút [In biên bản]"
            },
            {
               "code": "CoA",
               "name": "Phiếu chứng nhận chất lượng (CoA) — nút [In CoA] trên phiếu FQC Đạt / Cảnh báo"
            },
            {
               "code": "BM-KCS-01",
               "name": "Báo cáo thành phẩm & kiểm định KCS — nút [Báo Cáo KCS] ở danh sách FQC"
            },
            {
               "code": "Chưa gán mã",
               "name": "Phiếu xử lý sự không phù hợp (NCR 8D) — nút [In 8D]"
            },
            {
               "code": "Chưa gán mã",
               "name": "Tem thùng số nhảy (cuộn 80 × 150 mm hoặc A4 4 tem) và thẻ kiện pallet — màn Đóng Gói & Nhập Kho"
            }
         ],
         "notes": [
            "Lập phiếu IQC không tính là đã nhận hàng; số nhận chỉ cộng vào đơn mua khi Thủ kho chốt phiếu nhập kho từ tab Chờ nhập kho.",
            "Phiếu FQC không còn nút nhập kho, in tem thùng / pallet hay tạo phiếu giao; các việc này làm ở Xưởng sản xuất › Đóng Gói & Nhập Kho.",
            "Tổng SL Đạt FQC của một lệnh không vượt SL kế hoạch (và không vượt SL Đạt công đoạn cuối nếu lệnh có nhật ký sản xuất).",
            "NCR đi theo thứ tự Mở → Đang điều tra → Hành động KP → Xác minh → Đã đóng; được đóng sớm từ Mở / Đang điều tra khi đủ nội dung. Phiếu đã đóng không mở lại được.",
            "Nội dung D5 / D7 nhập trước ngày 02/11/2026 (bản 02.11.2026.4) chưa được lưu, nhờ anh/chị mở [Sửa / CAPA] nhập lại.",
            "Trang chi tiết NCR, dòng Nguồn phát hiện hiện nhóm nguồn (Nhà cung cấp / Nội bộ / Khiếu nại khách hàng); mở [Sửa / CAPA] để thấy đúng điểm phát hiện IQC / IPQC / FQC đã chọn.",
            "Trên trang chi tiết, các ô Lệnh SX, Sản phẩm, Khách hàng, Đơn hàng, Vật tư, Nhà cung cấp, Đơn mua, Máy, Công đoạn, Chứng từ gốc là liên kết, bấm để mở thẳng bản ghi.",
            "Ô người kiểm ở IQC, IPQC, FQC chỉ liệt kê nhân sự QC / Kiểm soát chất lượng.",
            "Biên bản IPQC: bấm Đạt / Không đạt trên thanh trạng thái để chuyển; quy tắc ký mẫu trước khi cho sản xuất vẫn được kiểm và báo rõ lý do khi chưa đủ.",
            "Tab Chờ Kiểm FQC liệt kê cả lệnh Đã sản xuất (mọi công đoạn xong) còn số lượng chưa kiểm, cùng lệnh Đang sản xuất / Hoàn thành."
         ],
         "uatChecklist": [
            {
               "id": "QC-12-01",
               "item": "IQC Đạt từ đơn mua vào hàng Chờ nhập kho của Kho vật tư (bàn giao từ Mua hàng sang Kho)",
               "standard": "Phiếu lưu Đạt; lô hiện ở Kho Vật tư › tab Chờ nhập kho với SL nhập kho = Cỡ lô − SL loại; đơn mua chưa tăng số đã nhận cho tới khi Thủ kho chốt nhập; nhập xong lô rời danh sách chờ.",
               "method": "1. Mua hàng: chọn đơn đang Đã đặt hàng (ví dụ Giấy Ivory 300 gsm, 5.000 tờ) → menu dòng → [Nhận hàng (IQC)]. 2. Nhập Số lô NCC LOT-TEST-01, Cỡ lô 5.000, Mức kiểm II, AQL 1,5 / 4,0 (thấy 200 mẫu, Ac/Re 7/8 và 14/15). 3. Bấm [Tất cả Đạt], SL loại 0 → [Lưu Biên Bản IQC]. 4. Mở Kho › Kho Vật tư › Phiếu nhập xuất › tab Chờ nhập kho, tìm LOT-TEST-01. 5. Mở lại đơn mua kiểm số đã nhận chưa đổi. 6. Thủ kho chốt nhập, quay lại tab Chờ nhập kho kiểm lô đã biến mất."
            },
            {
               "id": "QC-12-02",
               "item": "IQC Không đạt và Nhân nhượng",
               "standard": "Có lỗi nặng ≥ Re thì kết luận tự thành Không đạt, lô không vào Chờ nhập kho, chi tiết có [Tạo NCR]. Tích Nhân nhượng không ghi lý do thì không lưu được; ghi lý do thì phiếu thành Cảnh báo và lô vào Chờ nhập kho.",
               "method": "1. [Lập Phiếu IQC] cho Màng BOPP, Cỡ lô 1.200. 2. Ở bảng Lỗi phát hiện cộng lỗi nặng tới mức Re → thấy kết luận Không đạt → [Lưu Biên Bản IQC]. 3. Kiểm Kho Vật tư › tab Chờ nhập kho không có lô. 4. Lập phiếu thứ hai giống vậy, tích Nhân nhượng, để trống lý do → bấm lưu, thấy báo lỗi. 5. Ghi lý do “Khách đồng ý dùng” → lưu, phiếu hiện Cảnh báo, lô có trong Chờ nhập kho."
            },
            {
               "id": "QC-12-03",
               "item": "IPQC đủ 4 bước và chặn sai thứ tự",
               "standard": "[Cho sản xuất] bị mờ trước khi ký mẫu; sau Cho sản xuất công đoạn trên Lệnh SX hiện Đang chạy; [Chốt lô] chỉ bấm được sau Cho sản xuất; Tổng mẫu = mẫu ký + các lần kiểm.",
               "method": "1. [Lập Phiếu IPQC]: chọn một LSX đang chạy, công đoạn In, máy in, ca 1. 2. Chấm 4M đều Đạt → [Lưu]. 3. Kiểm [Cho sản xuất] đang mờ (di chuột thấy Cần ký mẫu trước). 4. Chấm chỉ tiêu sản phẩm Đạt, Số mẫu ký 5 → [Ký mẫu] → [Cho sản xuất]. 5. Mở LSX kiểm công đoạn In Đang chạy. 6. [+ Lần kiểm] 2 lần, mỗi lần 5 mẫu, 0 lỗi → [Chốt lô]; kiểm Tổng mẫu 15, kết luận Đạt."
            },
            {
               "id": "QC-12-04",
               "item": "IPQC Không đạt dẫn sang NCR",
               "standard": "Duyệt setup có dòng Không đạt thì không ký mẫu được; phiếu Không đạt hiện khung cảnh báo đỏ và [Lập NCR]; NCR mở ra có Nguồn phát hiện IPQC, LSX, công đoạn điền sẵn.",
               "method": "1. Lập phiếu IPQC, dòng Máy chấm Không đạt, tích Không đạt, dừng máy → [Lưu]. 2. Kiểm [Ký mẫu] không bấm được. 3. Mở chi tiết phiếu → bấm [Lập NCR]. 4. Kiểm ô Nguồn phát hiện = IPQC, Lệnh SX và Công đoạn đã điền."
            },
            {
               "id": "QC-12-05",
               "item": "FQC Đạt tự sinh Phiếu đóng gói (bàn giao QC sang Xưởng)",
               "standard": "Sau khi lưu, dưới số phiếu FQC hiện Chờ đóng gói; chi tiết FQC có nút [DG-…]; Xưởng sản xuất › Đóng Gói & Nhập Kho tab Chờ Đóng Gói có phiếu với SL nhận = SL Đạt; phiếu FQC không có nút nhập kho hay in tem thùng.",
               "method": "1. FQC Thành phẩm › tab Chờ Kiểm FQC → [Lập FQC] cho LSX có kế hoạch 10.000. 2. Cỡ lô 3.000, Mẫu chuẩn MC-01, [Tất cả Đạt], SL loại 0 → [Lưu Biên Bản FQC]. 3. Kiểm dòng mới ở Lịch Sử FQC có Chờ đóng gói. 4. Mở chi tiết, bấm [DG-…] → đến màn Đóng gói, phiếu ở tab Chờ Đóng Gói, SL nhận 3.000."
            },
            {
               "id": "QC-12-06",
               "item": "FQC vượt kế hoạch bị từ chối",
               "standard": "Hệ thống báo LSX … kế hoạch …, đã nghiệm thu Đạt … — biên bản này chỉ được Đạt tối đa … và không lưu phiếu.",
               "method": "1. Dùng LSX kế hoạch 10.000 đã có FQC Đạt 3.000 (mục QC-12-05). 2. [KCS Thành Phẩm] cho cùng LSX, Cỡ lô 8.000, SL loại 0, chấm Đạt → [Lưu Biên Bản FQC]. 3. Kiểm thông báo ghi tối đa 7.000 (hoặc thấp hơn nếu công đoạn cuối mới Đạt ít hơn). 4. Sửa Cỡ lô 7.000 → lưu được."
            },
            {
               "id": "QC-12-07",
               "item": "Đóng gói, nhập kho, tem thùng và khoá phiếu FQC",
               "standard": "Hoàn tất xong phiếu sang tab Đã Nhập Kho, có số phiếu nhập kho TP, hộp in tem tự mở với đủ số thùng 1/N … N/N có QR; dưới số phiếu FQC đổi thành Chờ giao hàng; sửa SL Đạt FQC bị từ chối.",
               "method": "1. Ở phiếu DG của mục QC-12-05 bấm [Đóng gói]. 2. Chọn Người đóng gói, SL lỗi khi đóng gói 20, Kho thành phẩm, Số lô LOT-TP-01, SP / thùng 500 → [Hoàn tất đóng gói & nhập kho]. 3. Kiểm hộp In tem thùng số nhảy hiện 6 thùng (2.980 SP), chọn Cuộn 80 × 150 mm → [In n tem]. 4. Quay lại FQC kiểm tình trạng Chờ giao hàng. 5. [Sửa] phiếu FQC đổi SL loại → lưu, thấy báo lỗi lô đã đóng gói nhập kho."
            },
            {
               "id": "QC-12-08",
               "item": "Gom phiếu giao chỉ cùng khách hàng (bàn giao sang Giao hàng)",
               "standard": "Chọn lô của 2 khách hàng thì báo Chỉ gom phiếu giao khi cùng khách hàng … và không mở phiếu; lô cùng khách mở được phiếu giao điền sẵn; sau khi lưu phiếu giao, FQC hiện Giao XK-….",
               "method": "1. Đóng Gói & Nhập Kho › tab Đã Nhập Kho: tích 1 lô khách A và 1 lô khách B → [Giao hàng (2)] → đọc thông báo. 2. Bỏ lô khách B, tích thêm lô khác của khách A → [Giao hàng (2)] → lưu phiếu giao. 3. Thử [Chờ gom xe (n)] với một lô khác, kiểm FQC hiện Chờ xe. 4. Mở FQC thứ nhất kiểm dưới số phiếu là Giao XK-…, bấm mở đúng phiếu."
            },
            {
               "id": "QC-12-09",
               "item": "NCR lập từ phiếu IQC và lưu đúng từng Nguồn phát hiện",
               "standard": "NCR lập từ IQC Không đạt có sẵn Nguồn phát hiện IQC, vật tư, NCC, số lô, chứng từ gốc; mỗi lựa chọn IQC, IPQC, FQC, Khách hàng, NCC, Nội bộ đều lưu được và mở [Sửa / CAPA] hiện lại đúng lựa chọn.",
               "method": "1. Mở phiếu IQC Không đạt ở QC-12-02 → [Tạo NCR] → kiểm các ô đã điền → [Tạo Phiếu NCR 8D]. 2. [Sửa / CAPA] → đổi Nguồn phát hiện sang NCC → [Lưu Thay Đổi] → mở lại [Sửa / CAPA] kiểm còn NCC. 3. Lặp bước 2 với IPQC, FQC, Khách hàng, Nội bộ, IQC."
            },
            {
               "id": "QC-12-10",
               "item": "NCR đi đủ vòng 8D, D5 và D7 lưu riêng, in 8D",
               "standard": "Trạng thái đổi lần lượt Mở → Đang điều tra → Hành động KP → Xác minh → Đã đóng với thông báo Đã chuyển hồ sơ NCR sang …; D5, D7 hiện lại đúng sau nhiều lần lưu; bản in 8D có D5 và D7.",
               "method": "1. [Tạo NCR Mới]: Nguồn Nội bộ, Mức độ Cao, LSX bất kỳ, D2 “Lệch màu tờ in” → [Tạo Phiếu NCR 8D]. 2. [Bắt đầu điều tra (D4)]. 3. [Sửa / CAPA]: Why 1–3, Nguyên nhân gốc “Mật độ mực sai”, D5 “Chỉnh lại mật độ mực”, D7 “Thêm bước đo mật độ đầu ca”, cách xử lý Sửa lỗi / chọn lọc → [Lưu Thay Đổi]. 4. Sửa lại D7 lần 2 → lưu, kiểm D5 vẫn còn. 5. [Thực thi CAPA] → [Chuyển thẩm tra] → [Đóng Hồ Sơ NCR (D8)]. 6. [In 8D] kiểm có D5, D7."
            },
            {
               "id": "QC-12-11",
               "item": "Đóng NCR thiếu nội dung bị từ chối và nói rõ thiếu gì",
               "standard": "Hỏi xác nhận Đóng phiếu …? rồi báo Chưa đóng NCR được — còn thiếu nguyên nhân gốc, hành động khắc phục (…); phiếu vẫn ở trạng thái cũ. Bổ sung đủ thì đóng sớm được, danh sách báo Đã đóng ….",
               "method": "1. [Tạo NCR Mới] chỉ điền D2, để trống D4, D5. 2. Ở danh sách Sự cố NCR, menu dòng → [Đóng NCR] → xác nhận. 3. Đọc thông báo thiếu. 4. [Sửa / CAPA] nhập Nguyên nhân gốc và D5 → [Lưu Thay Đổi]. 5. Danh sách → [Đóng NCR] → xác nhận → phiếu sang Đã đóng. 6. Kiểm phiếu Hành động KP không có mục [Đóng NCR] trong menu dòng."
            },
            {
               "id": "QC-12-12",
               "item": "Đóng NCR cần quyền Duyệt NCR",
               "standard": "Tài khoản không có quyền Duyệt NCR không thấy mục [Đóng NCR]; nếu đổi Trạng thái Đã đóng trên form thì hệ thống báo Chỉ người có quyền duyệt NCR mới được đóng phiếu NCR.",
               "method": "1. Đăng nhập tài khoản vai trò QC (đã bỏ quyền Duyệt NCR ở Phân quyền). 2. Mở danh sách NCR, kiểm menu dòng không có [Đóng NCR]. 3. Mở phiếu ở Xác minh → [Sửa / CAPA] → Trạng thái Đã đóng → [Lưu Thay Đổi] → đọc thông báo. 4. Đăng nhập Trưởng QA/QC có quyền Duyệt và đóng thành công."
            },
            {
               "id": "QC-12-13",
               "item": "Biểu mẫu QC: phiên bản mới và phát hành",
               "standard": "Sửa bản Đang áp dụng tạo vN+1 ở Nháp, bản cũ không đổi; [Phát hành] hỏi xác nhận, bản mới Đang áp dụng, bản cũ Lưu trữ; phiếu IQC mới nạp chỉ tiêu mới, phiếu cũ giữ chỉ tiêu cũ.",
               "method": "1. Biểu mẫu QC › tab IQC Vật tư, mở mẫu giấy đang áp dụng (ví dụ v2). 2. [Chỉnh sửa chỉ tiêu] → [Thêm chỉ tiêu] “Độ trắng”, Định lượng, Min 85 → [Lưu bộ tiêu chuẩn] → thấy Đã tạo phiên bản v3 (Nháp …). 3. [Phát hành] → xác nhận. 4. Lịch sử phiên bản: v3 Đang áp dụng, v2 Lưu trữ. 5. Lập IQC giấy mới thấy chỉ tiêu Độ trắng; mở phiếu IQC cũ không có."
            },
            {
               "id": "QC-12-14",
               "item": "Liên kết bản ghi cha và 3 tab trên trang chi tiết",
               "standard": "Bấm Lệnh SX, Sản phẩm, Khách hàng, Đơn hàng (FQC); Vật tư, Nhà cung cấp, Đơn mua (IQC); Máy, Công đoạn (IPQC); Chứng từ gốc (NCR) đều mở đúng bản ghi. Mỗi trang chi tiết có Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật ghi đúng người và giá trị cũ → mới.",
               "method": "1. Mở chi tiết FQC ở QC-12-05, bấm từng liên kết Lệnh SX, Sản phẩm, Khách hàng, Đơn hàng. 2. Làm tương tự ở chi tiết IQC (QC-12-01), IPQC (QC-12-03), NCR (QC-12-09). 3. Ở NCR viết một bình luận, đính kèm 1 ảnh, sửa Mức độ rồi mở Lịch sử cập nhật kiểm có dòng Mức độ cũ → mới."
            },
            {
               "id": "QC-12-15",
               "item": "Phiếu kiểm dùng được trên điện thoại (khung 390 px)",
               "standard": "Không có thanh cuộn ngang toàn trang; bảng chỉ tiêu hiện mỗi chỉ tiêu một thẻ; nút [+ Lần kiểm] trải hết chiều ngang; lưu được phiếu.",
               "method": "1. Mở trên điện thoại (hoặc trình duyệt chỉnh khung 390 px). 2. [Lập Phiếu IQC] → chấm 3 chỉ tiêu trên thẻ, nhập SL loại → [Lưu Biên Bản IQC]. 3. Mở một phiếu IPQC đã Cho sản xuất → [Sửa] → [+ Lần kiểm] → nhập số mẫu → [Lưu]. 4. Mở chi tiết FQC kiểm các nút đầu trang không đè lên nhau."
            },
            {
               "id": "QC-12-16",
               "item": "Thùng rác và khôi phục phiếu KCS",
               "standard": "Phiếu xoá biến khỏi danh sách, nằm ở tab Thùng rác; khôi phục về đúng mã cũ và đủ dữ liệu.",
               "method": "1. Xoá một phiếu IPQC thử bằng [Xoá] trên chi tiết. 2. Danh sách IPQC › tab Thùng rác → tìm mã phiếu → khôi phục. 3. Kiểm phiếu quay lại danh sách với đúng mã và các lần kiểm."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "QAQC_MANAGER (Trưởng phòng QA/QC)",
               "createTest": "Lập IQC, IPQC, FQC, NCR, tạo mẫu kiểm tra mới",
               "readTest": "Xem mọi danh sách và chi tiết, xuất Excel, in BM-QC-01/02/03, CoA, 8D",
               "updateTest": "Sửa phiếu IQC đã chốt Đạt; phát hành mẫu kiểm tra; đóng NCR ở bước Xác minh",
               "deleteTest": "Xoá phiếu IPQC thử rồi khôi phục từ Thùng rác",
               "expectedResult": "Mọi thao tác thành công nếu vai trò có quyền Duyệt NCR; đóng NCR thiếu nội dung vẫn bị báo thiếu."
            },
            {
               "roleGroup": "QC_INSPECTOR (Nhân viên KCS)",
               "createTest": "Lập IQC từ tab Chờ Kiểm IQC, IPQC 4 bước, FQC từ tab Chờ Kiểm FQC, NCR từ phiếu lỗi",
               "readTest": "Xem chi tiết, tình trạng lô dưới số phiếu FQC, mở phiếu đóng gói DG-…",
               "updateTest": "Sửa phiếu IPQC đang kiểm; thử [Đóng NCR] khi vai trò không có quyền Duyệt NCR",
               "deleteTest": "Xoá phiếu FQC chưa đóng gói (phiếu đóng gói chờ bị xoá theo); thử xoá FQC đã nhập kho",
               "expectedResult": "Lập, sửa thành công theo quyền; không đóng được NCR khi thiếu quyền Duyệt; FQC đã nhập kho không xoá được."
            },
            {
               "roleGroup": "QC (Nhân viên QC)",
               "createTest": "Lập IQC cho lô vật tư về theo đơn mua, lập NCR Nguồn NCC",
               "readTest": "Xem danh sách IQC, NCR, Biểu mẫu QC",
               "updateTest": "Ghi D3 ngăn chặn trên NCR; sửa phiếu IQC đã chốt (khi vai trò không có quyền sửa / duyệt IQC)",
               "deleteTest": "Xoá NCR lập nhầm",
               "expectedResult": "Theo cấu hình Phân quyền: thiếu quyền thì không thấy nút tương ứng và phiếu IQC đã chốt hiện dòng Phiếu đã chốt kết quả, các ô bị khoá."
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/22_qc_final_list_settled.png",
               "caption": "Hình 12.1 — Màn hình KCS & Đóng gói thành phẩm (/qc-final): danh sách biên bản FQC, trạng thái giao hàng và thao tác đóng gói / giao"
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 13. Mua Hàng NVL, Nhà Cung Cấp & Gia Công Ngoài
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "purchasing_outsourcing",
         "aliases": [
            "purchasing",
            "procurement",
            "outsourcing",
            "outsource-orders",
            "purchase-orders",
            "purchase-requests",
            "outsource-orders-tracking"
         ],
         "title": "13. Mua Hàng NVL, Nhà Cung Cấp & Gia Công Ngoài",
         "icon": "ShoppingCart",
         "isoRef": "QT-MH-01",
         "purpose": "Hướng dẫn đặt mua nguyên vật liệu theo nhu cầu thực tế của lệnh sản xuất (Mua hàng › ĐH Mua hàng), quản lý Nhà cung cấp, Danh mục vật tư, Loại vật tư và Đơn gia công ngoài (Kinh doanh › ĐH Gia công). Đơn mua đi theo các bước Bản nháp → Chờ duyệt → Đã duyệt → Đã đặt hàng → Nhận 1 phần / Đã nhận đủ. Hàng về được kiểm IQC; lô Đạt chuyển sang Kho Vật tư › tab Chờ nhập kho để thủ kho nhập kho, và số đã nhận tự cộng vào đơn mua và Kế hoạch vật tư.",
         "scope": [
            "Menu Mua hàng (nhóm Kho vận & Cung ứng): ĐH Mua hàng (tab Đơn Mua Hàng và Cần Mua (MRP)), Nhà Cung cấp, Danh mục Vật tư, Loại vật tư.",
            "Menu Kinh doanh › ĐH Gia công: đặt gia công ngoài theo đơn hàng (toàn phần) hoặc theo lệnh sản xuất (một phần), xuất gửi hàng đi và nghiệm thu hàng về; tab Danh Sách Đơn và Tiến độ.",
            "Bàn giao sang Kho: phiếu IQC Đạt của đơn mua hiện ở Kho › Kho Vật tư › Phiếu nhập xuất › tab Chờ nhập kho; thủ kho bấm [Nhập Kho NVL] (chương 14).",
            "Người lập đơn mua: nhân viên mua hàng / kế hoạch (PLANNER), quản lý (MANAGER); người duyệt: người có quyền duyệt mua hàng; KCS lập phiếu IQC; thủ kho nhập kho. Quyền cụ thể theo Phân quyền vai trò; bản nháp chỉ người tạo, Admin và Giám đốc thấy."
         ],
         "references": [
            "ISO 9001:2015 mục 8.4 — Kiểm soát sản phẩm và dịch vụ do bên ngoài cung cấp (mua vật tư, thuê gia công ngoài).",
            "ISO 9001:2015 mục 8.4.3 — Thông tin cho nhà cung cấp bên ngoài (Đơn đặt mua hàng, Đơn đặt gia công ngoài).",
            "ISO 9001:2015 mục 8.6 — Thông qua sản phẩm (kiểm IQC trước khi nhập kho).",
            "Chương 09 Kế hoạch vật tư, Chương 12 Chất lượng (IQC), Chương 14 Kho vận (Chờ nhập kho, Nhập Kho NVL)."
         ],
         "terms": [
            {
               "term": "ĐMH (Đơn mua hàng)",
               "definition": "Chứng từ đặt mua vật tư gửi nhà cung cấp. Một đơn có nhiều dòng vật tư, mỗi dòng có thể gắn một lệnh sản xuất và có ghi chú dòng in trên đơn."
            },
            {
               "term": "Cần Mua (MRP)",
               "definition": "Tab thứ hai trên trang ĐH Mua hàng, liệt kê vật tư đang thiếu theo Kế hoạch vật tư (số thiếu, đơn giá dự kiến, NCC gợi ý, lệnh cần). Lập đơn ngay bằng [Lập PO] hoặc chọn nhiều dòng cùng NCC rồi bấm [Lập Đơn Mua Hàng (n vật tư - Tên NCC)]; mỗi dòng chọn thành một dòng đơn đúng vật tư, đúng số cần mua."
            },
            {
               "term": "Giữ chỗ số cần mua",
               "definition": "Đơn mua đang chạy giữ chỗ số cần mua của dòng Kế hoạch vật tư, nên dòng đã đặt đủ không lập thêm đơn được. Hủy, xoá hoặc khôi phục đơn mua thì số cần mua được tính lại."
            },
            {
               "term": "Lưu nháp / Lưu / Gửi duyệt",
               "definition": "[Lưu nháp] giữ đơn ở Bản nháp (chỉ cần chọn nhà cung cấp). [Lưu] chuyển đơn mới sang Chờ duyệt. Đơn Bản nháp gửi duyệt bằng [Trình duyệt] trên trang xem, hoặc chọn nhiều đơn trên danh sách rồi bấm Gửi duyệt."
            },
            {
               "term": "Nhận hàng (IQC)",
               "definition": "Mục trên menu ... của đơn Đã đặt hàng / Nhận 1 phần. Mở phiếu IQC vật tư điền sẵn đơn mua và nhà cung cấp; lô Đạt chuyển sang Kho Vật tư › tab Chờ nhập kho. Đơn chưa duyệt không nhận hàng; tổng nhận không vượt SL đặt + 5%. Phần dư 5% chỉ dùng được trong lần nhận cuối: khi đơn đã Đã nhận đủ thì không nhập kho thêm được nữa."
            },
            {
               "term": "ĐGC (Đơn gia công ngoài)",
               "definition": "Đơn thuê đơn vị bên ngoài làm trọn sản phẩm (Toàn phần) hoặc một chuỗi công đoạn của lệnh sản xuất (Một phần). Trạng thái: Bản nháp → Chờ duyệt → Đang GC → Hoàn thành, hoặc Đã hủy."
            },
            {
               "term": "Dung sai khi nghiệm thu gia công",
               "definition": "Khi số đạt thiếu không quá 5% so với số đặt, người nghiệm thu có thể tích Chấp nhận dung sai thực tế & Đánh dấu hoàn tất đơn gia công để đóng đơn."
            }
         ],
         "responsibilities": [
            {
               "role": "Nhân viên mua hàng / Kế hoạch (PLANNER, MANAGER)",
               "tasks": [
                  "Theo dõi tab Cần Mua (MRP) và Kế hoạch vật tư, lập đơn mua đúng số thiếu.",
                  "Lập, sửa, Lưu nháp / Lưu đơn mua; gửi duyệt hàng loạt các đơn nháp; bấm [Đã đặt hàng] sau khi gửi đơn cho NCC; theo dõi ngày dự kiến nhận.",
                  "Khai báo Nhà cung cấp, Danh mục vật tư (gắn NCC cho vật tư để vật tư của NCC lên đầu khi lập đơn), Loại vật tư.",
                  "Lập Đơn gia công ngoài, xuất gửi hàng đi, nghiệm thu hàng gia công về."
               ]
            },
            {
               "role": "Người duyệt mua hàng (Ban Giám đốc / Quản lý)",
               "tasks": [
                  "Bấm [Duyệt PO] cho đơn Chờ duyệt (kể cả đơn sinh từ Kế hoạch vật tư hoặc Lệnh sản xuất).",
                  "Hủy đơn không còn cần mua; đơn chỉ phục vụ lệnh đã hủy không duyệt được."
               ]
            },
            {
               "role": "KCS (QC_INSPECTOR / QAQC_MANAGER) và Thủ kho (WAREHOUSE)",
               "tasks": [
                  "KCS lập phiếu IQC từ [Nhận hàng (IQC)] khi hàng về; kết luận Đạt / Không đạt.",
                  "Thủ kho nhập kho lô IQC Đạt từ tab Chờ nhập kho và chốt phiếu; số nhận tự cộng vào đơn mua."
               ]
            },
            {
               "role": "Kế toán (ACCOUNTANT)",
               "tasks": [
                  "Cột Thanh toán trên đơn mua và đơn gia công hiện “—” vì phần mềm chưa có phiếu chi trả nhà cung cấp; công nợ nhà gia công theo dõi và đối soát ở Tài Chính › Công nợ NCC."
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền; thấy cả bản nháp của người khác."
            },
            {
               "role": "Mua hàng / Kế hoạch (PLANNER, MANAGER)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "⚡",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Gửi duyệt hàng loạt cần quyền sửa đơn mua và chỉ áp dụng khi mọi đơn chọn đều là Bản nháp; xoá hàng loạt chỉ đơn Bản nháp. Mục Hủy đơn hàng trên danh sách cần quyền xoá. Duyệt / Đã đặt hàng cần quyền duyệt mua hàng."
            },
            {
               "role": "Thủ kho / KCS",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Xem đơn mua để nhận hàng; Nhận hàng (IQC) hiện với người có quyền sửa đơn mua khi đơn Đã đặt hàng / Nhận 1 phần."
            },
            {
               "role": "Vai trò không có quyền Mua hàng",
               "view": "❌",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "❌",
               "statusRules": "Ẩn nút Tạo ĐMH / Chỉnh sửa / Hủy đơn hàng; máy chủ báo Không có quyền truy cập."
            }
         ],
         "processFlowchart": "graph TD\n    A[Kế hoạch vật tư báo thiếu] --> B{Cách lập đơn mua}\n    B -->|Tạo Đơn Mua Hàng tại Kế hoạch vật tư| C[Đơn mua Chờ duyệt]\n    B -->|Tab Cần Mua MRP hoặc Tạo ĐMH| D[Form Tạo Đơn Mua Hàng - vật tư của NCC lên đầu]\n    D -->|Lưu nháp| E[Bản nháp]\n    E -->|Trình duyệt hoặc Gửi duyệt hàng loạt| C\n    D -->|Lưu| C\n    C -->|Duyệt PO| F[Đã duyệt]\n    F -->|Đã đặt hàng| G[Đã đặt hàng]\n    G -->|Nhận hàng IQC| H[Phiếu IQC vật tư]\n    H -->|Đạt| I[Kho Vật tư - tab Chờ nhập kho - Nhập Kho NVL]\n    H -->|Không đạt| J[Lập NCR - trả NCC]\n    I --> K[Chốt phiếu nhập - đơn Nhận 1 phần hoặc Đã nhận đủ]\n    C -->|Hủy đơn| L[Đã hủy - số cần mua tính lại]\n    F -->|Hủy đơn| L\n    G -->|Hủy đơn| L\n    M[Đơn hàng hoặc Lệnh SX] --> N[Đơn gia công - Lưu - Chờ duyệt]\n    N -->|Xuất Gửi BTP| O[Đang GC]\n    O -->|Nghiệm Thu Hàng đủ hoặc chấp nhận dung sai| P[Hoàn thành - ghi sản lượng công đoạn]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Xác định nhu cầu mua",
               "detail": "• Mua hàng › ĐH Mua hàng › tab Cần Mua (MRP): danh sách vật tư đang thiếu, lọc theo Nhà cung cấp, [Làm mới] để tải lại.\n• Bấm [Lập PO] trên một dòng để mở form đơn mua điền sẵn NCC, vật tư, số lượng thiếu. Hoặc tick nhiều dòng cùng một NCC rồi bấm [Lập Đơn Mua Hàng (n vật tư - Tên NCC)]: mỗi dòng chọn thành một dòng đơn.\n• Cách khác: Kế hoạch › Kế hoạch Vật tư, chọn các dòng thiếu và bấm tạo đơn mua; hệ thống gom đơn theo NCC, đơn vào Chờ duyệt.\n• Dòng đã có đơn mua đặt đủ thì không lập thêm được (tránh mua trùng)."
            },
            {
               "step": 2,
               "action": "Lập đơn mua hàng",
               "detail": "• Tab Đơn Mua Hàng › [Tạo ĐMH] → trang Tạo Đơn Mua Hàng.\n• Chọn Nhà cung cấp (bắt buộc). Chưa có NCC thì trong ô chọn bấm Thêm mới nhà cung cấp.\n• Bảng vật tư: ô Vật tư liệt kê vật tư của NCC vừa chọn ở trên cùng, các vật tư khác ở dưới (vẫn chọn được). Chọn LSX (tuỳ chọn; lệnh đã hủy / đóng không hiện), Số lượng (> 0), Đơn giá, Ghi chú dòng (quy cách, yêu cầu giao, in trên đơn). Thành tiền và Tổng cộng tự tính. [Thêm vật tư] để thêm dòng.\n• Nhập Ngày đặt (bắt buộc), Ngày dự kiến nhận, Ghi chú.\n• [Lưu nháp] (chỉ cần NCC) hoặc [Lưu] để chuyển Chờ duyệt."
            },
            {
               "step": 3,
               "action": "Gửi duyệt hàng loạt các đơn nháp",
               "detail": "• Trên tab Đơn Mua Hàng, lọc Bản nháp, tick các đơn cần gửi.\n• Trên thanh tác vụ hàng loạt bấm Gửi duyệt (chỉ bấm được khi mọi đơn chọn đều là Bản nháp).\n• Hệ thống báo Đã gửi duyệt n đơn mua hàng; đơn nào không gửi được thì báo số đơn lỗi và lý do. Các đơn chuyển Chờ duyệt.\n• Từng đơn: mở trang xem, bấm [Trình duyệt]."
            },
            {
               "step": 4,
               "action": "Duyệt và đặt hàng với NCC",
               "detail": "• Bấm dòng đơn để mở trang xem. Nút trên đầu trang theo trạng thái: Bản nháp → [Trình duyệt]; Chờ duyệt → [Duyệt PO]; Đã duyệt → [Đã đặt hàng]; Đã đặt hàng / Nhận 1 phần → [Đã nhận đủ]; đơn chưa Đã nhận đủ / Đã hủy có [Hủy đơn].\n• Thanh trạng thái chỉ cho bấm bước được phép (VD đơn Chờ duyệt không quay về Bản nháp); không chuyển được thì hiện đúng lý do.\n• Đơn sinh tự động từ Kế hoạch vật tư hoặc Lệnh sản xuất cũng bắt đầu ở Chờ duyệt. Đơn chỉ phục vụ lệnh đã hủy không duyệt được.\n• [In] để in Đơn đặt mua hàng gửi NCC; trên danh sách có In đơn PO ở menu ...."
            },
            {
               "step": 5,
               "action": "Nhận hàng qua IQC và nhập kho",
               "detail": "• Hàng về: trên danh sách bấm menu ... của đơn Đã đặt hàng / Nhận 1 phần → Nhận hàng (IQC). Trang Lập Biên Bản IQC mở với đơn mua và NCC điền sẵn (chương 12).\n• Lô IQC Đạt hiện ngay ở Kho › Kho Vật tư › Phiếu nhập xuất › tab Chờ nhập kho; thủ kho bấm [Nhập Kho NVL] và chốt phiếu (chương 14).\n• Khi chốt: số đã nhận cộng vào từng dòng đơn cùng vật tư (đơn có nhiều dòng cùng vật tư được chia đúng từng dòng), đơn chuyển Nhận 1 phần hoặc Đã nhận đủ, Kế hoạch vật tư cập nhật. Đơn chưa duyệt hoặc nhận vượt SL đặt + 5% bị chặn. Hủy phiếu nhập đã chốt thì trừ lại."
            },
            {
               "step": 6,
               "action": "Hủy hoặc xoá đơn mua",
               "detail": "• Danh sách: menu ... → Hủy đơn hàng (đơn Bản nháp, Chờ duyệt, Đã duyệt, Đã đặt hàng; cần quyền xoá), xác nhận → Đã hủy.\n• Trang xem: [Hủy đơn] với mọi đơn chưa Đã nhận đủ / Đã hủy; [Xoá] mở hộp xác nhận, đơn vào Thùng rác.\n• Chọn nhiều đơn Bản nháp → Xóa hàng loạt.\n• Hủy / xoá đơn lập từ Kế hoạch vật tư: số cần mua của dòng kế hoạch được tính lại để đặt mua lại."
            },
            {
               "step": 7,
               "action": "Đặt gia công ngoài",
               "detail": "• Toàn phần (nhà gia công làm trọn sản phẩm): Kinh doanh › ĐH Gia công › [Tạo ĐH GC], hoặc từ Đơn hàng; không cần lệnh sản xuất.\n• Một phần (thuê ngoài một chuỗi công đoạn): lập Lệnh sản xuất trước, rồi trên lệnh bấm Thao tác › Đặt gia công (một phần). Ô Lệnh sản xuất chỉ liệt kê lệnh của đơn hàng đang chọn; chọn một hoặc nhiều công đoạn liên tiếp của cùng một lệnh.\n• Nhập Đơn vị gia công, Hạn trả hàng, Ghi chú cho nhà gia công (in trên đơn); mỗi dòng có ĐVT (in, cán màng, bế tính theo tờ; dán tính theo pcs).\n• [Lưu nháp] hoặc [Lưu] → Chờ duyệt; thiếu nhà gia công, lệnh hay công đoạn thì báo ngay dưới ô.\n• Đơn nhiều dòng giá khác nhau: tổng tiền đơn bằng tổng tiền các dòng; mỗi lần nghiệm thu, công nợ nhà gia công tăng theo tỉ lệ SL đạt / SL đặt trên tổng tiền đó.\n• Trang xem đơn: [Xuất Gửi BTP] (chỉ hiện khi đơn Chờ duyệt / Đang GC; đơn nháp phải [Lưu] trước, đơn Hoàn thành / Đã hủy không gửi thêm) → nhập số lượng gửi → [Xác Nhận Xuất Gửi] → Đang GC.\n• Đơn đã xuất gửi hoặc đã nghiệm thu không hủy, không xoá được (công nợ nhà gia công và sản lượng công đoạn đã ghi).\n• Hàng về: [Nghiệm Thu Hàng] → nhập SL đạt, SL lỗi, ngày nhận; có thể tích Yêu cầu NCC đền bù, Chấp nhận dung sai thực tế (thiếu ≤ 5%) → [Xác Nhận Nghiệm Thu & Nhập Kho]. Tổng nhận không vượt số đã gửi (hoặc SL đặt cộng hao hụt). Đủ số hoặc chấp nhận dung sai → Hoàn thành, các công đoạn trong chuỗi được ghi sản lượng và hoàn thành.\n• Ô Tự động tạo Phiếu Nhập Kho BTP trên hộp nghiệm thu mặc định không tích: hệ thống hiện không quản kho bán thành phẩm, anh/chị hỏi quản trị trước khi tích ô này.\n• Tài Chính › Công nợ NCC: Nợ đầu kỳ, Phát sinh trong kỳ, Đã thanh toán, Nợ còn lại tính từ sổ công nợ nhà cung cấp theo tháng đang chọn."
            }
         ],
         "subFlows": [
            {
               "name": "Đơn mua hàng — Danh sách",
               "steps": [
                  "Hai tab: Đơn Mua Hàng và Cần Mua (MRP). Thẻ lọc trạng thái, bộ lọc thời gian, nút nhóm theo ngày (dòng ngày có tổng phụ), lọc theo cột Mã ĐMH, Nhà cung cấp, Ngày đặt, Ngày dự kiến.",
                  "Dưới tên NCC hiện liên hệ, người lập; dưới ngày giao hiện Trễ N ngày / Đã nhận đủ; cột tiến độ nhận hiện SL đã nhận / SL đặt.",
                  "Bấm mũi tên đầu dòng để xem dòng vật tư (SL đặt, Đã nhận, Còn thiếu, Đơn giá, LSX, Ghi chú) ngay tại chỗ.",
                  "Menu ... trên dòng: Chỉnh sửa, Nhận hàng (IQC) (Đã đặt hàng / Nhận 1 phần), In đơn PO, Hủy đơn hàng.",
                  "Chọn nhiều dòng: Gửi duyệt, Xóa (chỉ khi tất cả là Bản nháp), Xuất Excel."
               ]
            },
            {
               "name": "Đơn mua hàng — Xem",
               "steps": [
                  "Đầu trang: mã đơn, trạng thái, nút theo trạng thái, [In], [Sửa], [Xoá]; thanh trạng thái bên dưới.",
                  "Nhà cung cấp là link mở hồ sơ NCC; mỗi dòng vật tư có link mở vật tư và link LSX mở lệnh sản xuất.",
                  "Cuối trang có tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật (ghi cả thêm / sửa / xoá dòng) và dòng Tạo / Cập nhật bởi."
               ]
            },
            {
               "name": "Đơn mua hàng — Sửa",
               "steps": [
                  "Danh sách: menu ... → Chỉnh sửa; hoặc trang xem → [Sửa].",
                  "Đơn Bản nháp bấm [Lưu] → Chờ duyệt; đơn đã qua Bản nháp giữ nguyên trạng thái. Dòng đã nhận hàng không xoá được."
               ]
            },
            {
               "name": "Đơn mua hàng — In và Xuất Excel",
               "steps": [
                  "In: trang xem → [In], hoặc In đơn PO trên menu dòng; ghi chú dòng in trên đơn.",
                  "Xuất Excel theo bộ lọc hoặc dòng đang chọn, mỗi dòng vật tư một hàng; tải file mẫu mau_don_mua_hang."
               ]
            },
            {
               "name": "Nhà cung cấp — Thêm / Sửa / Ngừng hợp tác",
               "steps": [
                  "Mua hàng › Nhà Cung cấp → [Thêm NCC]; nhập Mã số thuế rồi bấm [Tra cứu MST 1-chạm] để tự điền tên, địa chỉ. Mã NCC hoặc MST trùng sẽ bị báo.",
                  "Menu ... trên dòng: Chỉnh sửa, Ngừng hợp tác (hoặc Hợp tác lại), Xóa. Không xoá được NCC đang liên kết vật tư hoặc đơn gia công: dùng Ngừng hợp tác.",
                  "Trang chi tiết NCC có tab Vật tư, Đơn gia công; nút [Gọi điện].",
                  "Thêm nhanh NCC từ phiếu nhập kho: nút [+ Thêm NCC] cạnh ô Nhà cung cấp (người có quyền tạo NCC)."
               ]
            },
            {
               "name": "Danh mục Vật tư và Loại vật tư",
               "steps": [
                  "Mua hàng › Danh mục Vật tư mở cùng màn hình Mã & Tồn NVL (chương 14); khai NCC của vật tư để vật tư đó lên đầu khi lập đơn mua cho NCC này.",
                  "Mua hàng › Loại vật tư → [Thêm mới]; loại đang được vật tư sử dụng không xoá được."
               ]
            },
            {
               "name": "Đơn gia công — Danh sách / Sửa / Xoá / In",
               "steps": [
                  "Kinh doanh › ĐH Gia công: tab Danh Sách Đơn và Tiến độ; nhóm theo ngày có tổng phụ số đơn, SL đặt / nhận, tổng tiền.",
                  "Sửa: menu ... → Chỉnh sửa, hoặc trang xem → [Sửa]. Xoá: trang xem → [Xoá], hoặc chọn nhiều dòng → Xóa.",
                  "Trang xem: Nhà gia công, Đơn hàng, Lệnh SX, Sản phẩm là link mở bản ghi gốc; [Nghiệm Thu Hàng] ẩn khi đơn Bản nháp, Hoàn thành, Đã hủy hoặc đã nhận đủ.",
                  "In: [In Đơn PO] (Đơn đặt gia công ngoài) và [In nghiệm thu] (Biên bản nghiệm thu & quyết toán gia công)."
               ]
            },
            {
               "name": "Đơn mua hàng & Gia công ngoài — In đơn và quay lại danh sách",
               "steps": [
                  "[In] trên chi tiết đơn mua hàng: mở bản xem trước đơn đặt mua theo dữ liệu đã lưu, bấm [In Ngay] để in hoặc [Tải PDF] để gửi nhà cung cấp.",
                  "[DS Đơn GC]: trên chế độ xem Tiến độ của màn Đơn gia công, bấm để quay về danh sách đơn gia công dạng bảng."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "(Tạo mới)",
               "to": "Bản nháp",
               "action": "[Lưu nháp] trên form đơn mua",
               "allowedRoles": "Người có quyền tạo đơn mua"
            },
            {
               "from": "(Tạo mới)",
               "to": "Chờ duyệt",
               "action": "[Lưu]; hoặc tạo đơn từ Kế hoạch vật tư / Lệnh sản xuất",
               "allowedRoles": "Người có quyền tạo đơn mua"
            },
            {
               "from": "Bản nháp",
               "to": "Chờ duyệt",
               "action": "[Trình duyệt] trên trang xem, [Lưu] trên trang sửa, hoặc Gửi duyệt hàng loạt trên danh sách",
               "allowedRoles": "Người có quyền sửa đơn mua"
            },
            {
               "from": "Chờ duyệt",
               "to": "Đã duyệt",
               "action": "[Duyệt PO]; đơn chỉ phục vụ lệnh đã hủy bị chặn",
               "allowedRoles": "Người có quyền duyệt mua hàng"
            },
            {
               "from": "Đã duyệt",
               "to": "Đã đặt hàng",
               "action": "[Đã đặt hàng] sau khi gửi đơn cho NCC",
               "allowedRoles": "Người có quyền duyệt mua hàng"
            },
            {
               "from": "Đã duyệt / Đã đặt hàng / Nhận 1 phần",
               "to": "Nhận 1 phần / Đã nhận đủ",
               "action": "Tự động khi thủ kho chốt phiếu nhập từ lô IQC Đạt của đơn (hoặc phiếu nhập ghi mã đơn)",
               "allowedRoles": "Thủ kho (chốt phiếu nhập)"
            },
            {
               "from": "Đã đặt hàng / Nhận 1 phần",
               "to": "Đã nhận đủ",
               "action": "[Đã nhận đủ] trên trang xem",
               "allowedRoles": "Người có quyền duyệt mua hàng"
            },
            {
               "from": "Bản nháp / Chờ duyệt / Đã duyệt / Đã đặt hàng / Nhận 1 phần",
               "to": "Đã hủy",
               "action": "Hủy đơn hàng trên danh sách (đến Đã đặt hàng) hoặc [Hủy đơn] trên trang xem; số cần mua của Kế hoạch vật tư tính lại",
               "allowedRoles": "Người có quyền duyệt / xoá đơn mua"
            },
            {
               "from": "Đơn gia công: (Tạo mới) / Bản nháp",
               "to": "Chờ duyệt",
               "action": "[Lưu] trên form đơn gia công",
               "allowedRoles": "Người có quyền tạo đơn gia công"
            },
            {
               "from": "Đơn gia công: Chờ duyệt",
               "to": "Đang GC",
               "action": "[Xuất Gửi BTP] → [Xác Nhận Xuất Gửi] (đơn gia công không có bước duyệt riêng: Chờ duyệt nghĩa là đã lưu, chờ gửi hàng; ô Tự động tạo Phiếu Xuất Kho BTP được tích sẵn và tạo phiếu xuất kho kèm theo)",
               "allowedRoles": "Người có quyền sửa đơn gia công"
            },
            {
               "from": "Đơn gia công: Đang GC",
               "to": "Hoàn thành",
               "action": "[Nghiệm Thu Hàng] đủ số lượng hoặc chấp nhận dung sai ≤ 5%",
               "allowedRoles": "Người có quyền sửa đơn gia công"
            }
         ],
         "actionLinks": [
            {
               "from": "Kế hoạch vật tư",
               "to": "Đơn mua hàng",
               "action": "Tạo đơn mua hàng từ các dòng thiếu",
               "how": "Đơn vào Chờ duyệt, gom theo NCC; dòng kế hoạch giữ chỗ số đã đặt."
            },
            {
               "from": "Tab Cần Mua (MRP)",
               "to": "Tạo Đơn Mua Hàng",
               "action": "[Lập PO] / [Lập Đơn Mua Hàng (n vật tư - Tên NCC)]",
               "how": "Form mở với NCC, vật tư và số lượng thiếu điền sẵn, mỗi dòng chọn một dòng đơn."
            },
            {
               "from": "Đơn mua (Đã đặt hàng / Nhận 1 phần)",
               "to": "Lập Biên Bản IQC",
               "action": "Nhận hàng (IQC)",
               "how": "Menu ... của dòng đơn; phiếu IQC điền sẵn đơn mua, NCC."
            },
            {
               "from": "Phiếu IQC Đạt",
               "to": "Kho Vật tư › tab Chờ nhập kho",
               "action": "[Nhập Kho NVL]",
               "how": "Chốt phiếu nhập cộng số đã nhận vào đơn mua và Kế hoạch vật tư."
            },
            {
               "from": "Đơn mua (trang xem)",
               "to": "Nhà cung cấp / Vật tư / Lệnh sản xuất",
               "action": "Bấm link",
               "how": "Mở thẳng bản ghi gốc."
            },
            {
               "from": "Lệnh sản xuất",
               "to": "Đơn gia công một phần",
               "action": "Thao tác › Đặt gia công (một phần)",
               "how": "Form mở sẵn đơn hàng, lệnh, loại Một phần."
            },
            {
               "from": "Đơn gia công (trang xem)",
               "to": "Nhà gia công / Đơn hàng / Lệnh SX / Sản phẩm",
               "action": "Bấm link",
               "how": "Mở thẳng bản ghi gốc."
            },
            {
               "from": "Đơn gia công",
               "to": "Công nợ NCC",
               "action": "Theo dõi công nợ",
               "how": "Menu Tài Chính › Công nợ NCC. Công nợ NCC chỉ phát sinh khi nghiệm thu hàng gia công (số đạt × đơn giá); nhận hàng đơn mua vật tư chưa tự ghi công nợ NCC, và giao diện chưa có phiếu chi trả nhà cung cấp."
            }
         ],
         "inlineViews": [
            {
               "name": "Dòng vật tư của đơn mua",
               "trigger": "Mũi tên đầu dòng trên danh sách đơn mua",
               "description": "Xem SL đặt, Đã nhận, Còn thiếu, Đơn giá, Thành tiền, LSX, Ghi chú mà không rời danh sách."
            },
            {
               "name": "Chi tiết gia công ngoài",
               "trigger": "Mũi tên đầu dòng trên danh sách đơn gia công",
               "description": "Xem quy cách, công đoạn gia công ngay trên danh sách."
            },
            {
               "name": "Xuất gửi / Nghiệm thu gia công",
               "trigger": "[Xuất Gửi BTP] / [Nghiệm Thu Hàng] trên trang xem đơn gia công",
               "description": "Hộp thoại ghi số lượng gửi đi và nhận về mà không rời trang."
            }
         ],
         "quickActions": [
            {
               "action": "Gửi duyệt nhiều đơn nháp",
               "description": "Tick các đơn Bản nháp trên danh sách → Gửi duyệt."
            },
            {
               "action": "Lọc trạng thái đơn mua",
               "description": "Thẻ lọc Bản nháp, Chờ duyệt, Đã duyệt, Đã đặt hàng, Nhận 1 phần, Đã nhận đủ, Đã hủy."
            },
            {
               "action": "Tìm kiếm",
               "description": "Ô tìm kiếm chung trên thanh đầu trang."
            },
            {
               "action": "Vật tư của NCC lên đầu",
               "description": "Chọn NCC trước, ô Vật tư hiện vật tư của NCC đó ở trên cùng, vật tư khác ở dưới."
            },
            {
               "action": "Thêm nhanh NCC / vật tư",
               "description": "Trong ô chọn Nhà cung cấp hoặc Vật tư bấm Thêm mới nhà cung cấp / Thêm mới vật tư."
            }
         ],
         "forms": [
            {
               "code": "Chưa gán mã",
               "name": "Đơn đặt mua hàng (PO) — in từ trang xem đơn mua ([In]) hoặc In đơn PO trên danh sách"
            },
            {
               "code": "Chưa gán mã",
               "name": "Đơn đặt gia công ngoài — [In Đơn PO] trên đơn gia công"
            },
            {
               "code": "Chưa gán mã",
               "name": "Biên bản nghiệm thu & quyết toán gia công — [In nghiệm thu] trên đơn gia công"
            }
         ],
         "notes": [
            "Đơn mua sinh từ Kế hoạch vật tư hoặc Lệnh sản xuất vào Chờ duyệt, phải [Duyệt PO] rồi [Đã đặt hàng] như đơn lập tay.",
            "Đơn chưa duyệt không nhận hàng; tổng nhận không vượt SL đặt + 5%. Phần dư 5% chỉ dùng được trong lần nhận cuối: khi đơn đã Đã nhận đủ thì không nhập kho thêm được nữa.",
            "Lô IQC Đạt của đơn mua tự hiện ở Kho Vật tư › tab Chờ nhập kho; số nhận chỉ cộng vào đơn khi thủ kho chốt phiếu nhập.",
            "Đơn mua giữ chỗ số cần mua của Kế hoạch vật tư; hủy, xoá, khôi phục đơn thì số cần mua tính lại, tránh mua trùng.",
            "Gửi duyệt và Xóa hàng loạt chỉ bấm được khi mọi đơn đang chọn là Bản nháp.",
            "Bản nháp chỉ người tạo, Admin và Giám đốc thấy.",
            "Không xoá được NCC hoặc Loại vật tư đang được sử dụng; dùng Ngừng hợp tác để ẩn NCC khỏi giao dịch mới.",
            "Lệnh sản xuất đã hủy / đóng không hiện ở ô chọn LSX và không đặt gia công được.",
            "Đơn mua và nhận hàng nhập được số lẻ (VD 0,5 kg, 2,75 m²); số đã nhận lưu đúng số lẻ."
         ],
         "uatChecklist": [
            {
               "id": "MH-13-01",
               "item": "Tạo đơn mua: vật tư của NCC lên đầu ô Vật tư",
               "standard": "Sau khi chọn NCC, ô Vật tư hiện vật tư của NCC đó ở trên cùng và vẫn liệt kê vật tư khác bên dưới; đơn lưu ở Chờ duyệt.",
               "method": "1. Mua hàng › ĐH Mua hàng › [Tạo ĐMH].\n2. Chọn NCC đã gắn vật tư (VD NCC giấy có Ivory 300gsm).\n3. Mở ô Vật tư: Ivory 300gsm ở trên; gõ tên vật tư của NCC khác vẫn chọn được.\n4. Nhập SL 1.000, đơn giá 2.500, Ngày đặt hôm nay, Ghi chú dòng Khổ 79x109 › [Lưu].\n5. Kiểm tra đơn ở Chờ duyệt, tổng 2.500.000."
            },
            {
               "id": "MH-13-02",
               "item": "Lập đơn từ tab Cần Mua (MRP)",
               "standard": "Chọn nhiều dòng cùng NCC tạo ra đơn có đủ từng dòng đúng vật tư, đúng số cần mua; chọn dòng 2 NCC thì được nhắc chọn cùng NCC.",
               "method": "1. ĐH Mua hàng › tab Cần Mua (MRP).\n2. Tick 2 dòng cùng một NCC › [Lập Đơn Mua Hàng (2 vật tư - Tên NCC)].\n3. Kiểm form có 2 dòng, số lượng bằng số thiếu › [Lưu].\n4. Quay lại tab: hai dòng không còn đề nghị mua thêm."
            },
            {
               "id": "MH-13-03",
               "item": "Gửi duyệt hàng loạt đơn nháp",
               "standard": "Báo Đã gửi duyệt n đơn mua hàng, các đơn chuyển Chờ duyệt; khi lẫn đơn không phải Bản nháp thì nút Gửi duyệt bị khoá.",
               "method": "1. Tạo 2 đơn bằng [Lưu nháp].\n2. Danh sách lọc Bản nháp, tick 2 đơn › Gửi duyệt.\n3. Kiểm tra thông báo và trạng thái Chờ duyệt.\n4. Tick 1 đơn Bản nháp và 1 đơn Chờ duyệt: Gửi duyệt và Xóa bị khoá."
            },
            {
               "id": "MH-13-04",
               "item": "Duyệt và đặt hàng; thanh trạng thái chỉ cho bước hợp lệ",
               "standard": "Chờ duyệt → [Duyệt PO] → Đã duyệt → [Đã đặt hàng] → Đã đặt hàng; bước Bản nháp không bấm được; người không có quyền duyệt bị báo lý do.",
               "method": "1. Mở đơn Chờ duyệt ở MH-13-03.\n2. Thử bấm bước Bản nháp trên thanh trạng thái: không bấm được.\n3. Đăng nhập người có quyền duyệt › [Duyệt PO] › [Đã đặt hàng].\n4. Mở tab Lịch sử cập nhật: thấy Trạng thái cũ → mới và người thao tác."
            },
            {
               "id": "MH-13-05",
               "item": "Nhận hàng qua IQC → Chờ nhập kho → nhập kho",
               "standard": "Lô IQC Đạt hiện ở Kho Vật tư › Chờ nhập kho; chốt phiếu nhập làm đơn mua chuyển Nhận 1 phần / Đã nhận đủ.",
               "method": "1. Danh sách đơn mua, đơn Đã đặt hàng 1.000 tờ › menu ... › Nhận hàng (IQC).\n2. KCS lập biên bản IQC Đạt 600 tờ › lưu.\n3. Kho › Kho Vật tư › Phiếu nhập xuất › tab Chờ nhập kho: thấy dòng 600 › [Nhập Kho NVL] › [Lưu] › [Duyệt & Chốt Kho].\n4. Mở lại đơn mua: Nhận 1 phần, dòng vật tư Đã nhận 600, Còn thiếu 400."
            },
            {
               "id": "MH-13-06",
               "item": "Chặn nhận hàng cho đơn chưa duyệt và nhận vượt",
               "standard": "Đơn Bản nháp / Chờ duyệt không có Nhận hàng (IQC) và phiếu nhập ghi mã đơn đó bị chặn khi chốt; nhận quá SL đặt + 5% bị chặn với thông báo số còn được nhận.",
               "method": "1. Mở menu ... của một đơn Chờ duyệt: không có Nhận hàng (IQC).\n2. Lập phiếu nhập kho ghi Số chứng từ tham chiếu là mã đơn Chờ duyệt › [Lưu] › [Duyệt & Chốt Kho]: bị báo chỉ nhận hàng cho đơn đã duyệt / đã đặt hàng.\n3. Với đơn ở MH-13-05 còn 400, lập phiếu nhập 500 tham chiếu mã đơn › chốt: bị báo vượt SL còn được nhận 450."
            },
            {
               "id": "MH-13-07",
               "item": "Hủy đơn mua",
               "standard": "Đơn chuyển Đã hủy, không còn Nhận hàng (IQC); số cần mua trên Kế hoạch vật tư tính lại.",
               "method": "1. Danh sách, đơn Đã duyệt lập từ Kế hoạch vật tư › menu ... › Hủy đơn hàng › xác nhận.\n2. Mở Kế hoạch vật tư: dòng vật tư của đơn lại hiện cần mua."
            },
            {
               "id": "MH-13-08",
               "item": "Đơn gia công: xuất gửi và nghiệm thu",
               "standard": "Xuất gửi chuyển Đang GC; nghiệm thu đủ chuyển Hoàn thành, nút Nghiệm Thu Hàng biến mất, tổng nhận không vượt số đã gửi.",
               "method": "1. Lệnh sản xuất › Thao tác › Đặt gia công (một phần), chọn nhà gia công, công đoạn Cán màng, Hạn trả hàng › [Lưu].\n2. Trang xem đơn › [Xuất Gửi BTP], nhập 2.000 tờ › [Xác Nhận Xuất Gửi]: trạng thái Đang GC.\n3. [Nghiệm Thu Hàng], SL đạt 1.980, SL lỗi 0, tích Chấp nhận dung sai thực tế › [Xác Nhận Nghiệm Thu & Nhập Kho].\n4. Kiểm Hoàn thành, công đoạn Cán màng trên lệnh ghi sản lượng; thử nghiệm thu thêm: không còn nút."
            },
            {
               "id": "MH-13-09",
               "item": "Link bản ghi gốc và tab chi tiết",
               "standard": "Trên trang xem đơn mua và đơn gia công, NCC, vật tư, LSX, đơn hàng, sản phẩm bấm mở đúng bản ghi; có tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật.",
               "method": "1. Mở đơn mua ở MH-13-05: bấm tên NCC, mã vật tư, LSX trên dòng.\n2. Mở đơn gia công ở MH-13-08: bấm Nhà gia công, Đơn hàng, Lệnh SX, Sản phẩm.\n3. Thêm một ghi chú ở tab Thảo luận & Ghi chú, tải một tệp ở Tệp đính kèm."
            },
            {
               "id": "MH-13-10",
               "item": "Thêm nhanh NCC trên phiếu nhập kho",
               "standard": "Tạo NCC mới ngay trên phiếu nhập, tạo xong ô Nhà cung cấp tự chọn NCC đó; người không có quyền tạo NCC không thấy nút.",
               "method": "1. Kho › Kho Vật tư › Phiếu nhập xuất › [Tạo mới], loại Nhập kho.\n2. Bấm [+ Thêm NCC], nhập MST, [Tra cứu MST 1-chạm], lưu.\n3. Kiểm ô Nhà cung cấp đã chọn NCC mới; NCC xuất hiện ở Mua hàng › Nhà Cung cấp."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "Mua hàng / Kế hoạch (PLANNER, MANAGER) — Chương 13",
               "createTest": "[Tạo ĐMH] → [Lưu nháp] và [Lưu]; tab Cần Mua (MRP) → [Lập PO]; ĐH Gia công → [Tạo ĐH GC] → [Lưu]; Nhà Cung cấp → [Thêm NCC].",
               "readTest": "Lọc đơn theo trạng thái, bung dòng vật tư, mở trang xem, bấm link NCC / vật tư / LSX, xem Lịch sử cập nhật.",
               "updateTest": "Gửi duyệt hàng loạt 2 đơn nháp; sửa đơn Chờ duyệt → [Cập nhật]; [Đã đặt hàng]; [Xuất Gửi BTP] / [Nghiệm Thu Hàng] đơn gia công.",
               "deleteTest": "Xóa hàng loạt đơn Bản nháp; Hủy đơn hàng đơn Đã duyệt; Ngừng hợp tác một NCC đang có vật tư.",
               "expectedResult": "Đơn đúng trạng thái; vật tư của NCC lên đầu; không xoá được NCC đang dùng; nút hàng loạt khoá khi có đơn không phải Bản nháp."
            },
            {
               "roleGroup": "Người duyệt mua hàng (DIRECTOR, MANAGER) — Chương 13",
               "createTest": "—",
               "readTest": "Lọc Chờ duyệt, mở đơn xem dòng vật tư, LSX liên kết.",
               "updateTest": "[Duyệt PO] đơn hợp lệ; thử duyệt đơn chỉ phục vụ lệnh đã hủy (bị chặn kèm lý do).",
               "deleteTest": "[Hủy đơn] một đơn Đã đặt hàng.",
               "expectedResult": "Duyệt chuyển Đã duyệt; thanh trạng thái báo đúng lý do khi bị từ chối; hủy trả số cần mua về Kế hoạch vật tư."
            },
            {
               "roleGroup": "KCS + Thủ kho (QC_INSPECTOR, WAREHOUSE) — Chương 13/14",
               "createTest": "Nhận hàng (IQC) từ đơn Đã đặt hàng → biên bản IQC Đạt; [Nhập Kho NVL] từ tab Chờ nhập kho.",
               "readTest": "Xem đơn mua: SL đã nhận, Còn thiếu.",
               "updateTest": "[Duyệt & Chốt Kho] phiếu nhập.",
               "deleteTest": "Hủy phiếu (Hoàn kho) phiếu nhập vừa chốt.",
               "expectedResult": "Đơn chuyển Nhận 1 phần / Đã nhận đủ khi chốt, trừ lại khi hủy phiếu; nhận vượt SL đặt + 5% bị chặn."
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 14. Kho Vận: Phiếu Nhập/Xuất, NXT, Sổ Kho, Kiểm Kê & Giao Hàng
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "inventory",
         "aliases": [
            "warehouse",
            "logistics",
            "deliveries",
            "delivery",
            "material-warehouse",
            "fg-inventory",
            "inventory",
            "transactions",
            "stock-card",
            "stocktake",
            "stocktakes",
            "nxt",
            "warehouse-master-data",
            "delivery-return"
         ],
         "title": "14. Kho Vận: Phiếu Nhập/Xuất, NXT, Sổ Kho, Kiểm Kê & Giao Hàng",
         "icon": "Warehouse",
         "isoRef": "QT-KHO-01",
         "purpose": "Hướng dẫn thủ kho vật tư, thủ kho thành phẩm và bộ phận giao hàng ghi nhận mọi biến động hàng bằng chứng từ: Phiếu nhập kho, Phiếu xuất kho (Nháp → Chờ duyệt → Đã chốt, hoặc Đã hủy), xem Báo cáo Nhập - Xuất - Tồn (NXT), Sổ kho, làm Kiểm kê có bước duyệt, và lập Phiếu giao hàng cho khách từ các lô thành phẩm đã đóng gói nhập kho. Mỗi kho độc lập, chỉ nhận đúng loại hàng của kho; không có chuyển kho. Tồn kho chỉ thay đổi khi phiếu được chốt (hoặc kiểm kê được duyệt), và Báo cáo NXT, Sổ kho, Kiểm kê dùng chung một cách tính tồn sổ sách nên số liệu luôn khớp nhau.",
         "scope": [
            "Menu Kho (nhóm Kho vận & Cung ứng): Kho Vật tư, Kho Thành phẩm, Kho Kỹ thuật, Danh mục Kho, Mã & Tồn NVL. Kho Kỹ thuật cũng mở được từ menu Kỹ thuật. Hệ thống không quản kho bán thành phẩm và kho phế liệu.",
            "Mỗi kho có thanh tab ở trên cùng: Phiếu nhập xuất, Báo cáo NXT, Sổ kho, Kiểm kê. Khi mở xem hoặc lập một phiếu, thanh tab này vẫn ở trên cùng, tiêu đề phiếu (mã phiếu, trạng thái, nút In) nằm ngay bên dưới; tên kho hiện trên thanh tiêu đề trên cùng.",
            "Kho nào nhận đúng loại hàng của kho đó: Kho Vật tư nhận vật tư; Kho Thành phẩm nhận thành phẩm; Kho Kỹ thuật nhận khuôn, bản kẽm, công cụ dụng cụ. Phiếu có mặt hàng sai loại kho bị chặn khi lưu và khi chốt, thông báo ghi rõ mặt hàng nào và kho đó chỉ nhận loại hàng gì.",
            "Không có nghiệp vụ chuyển kho: hàng nhập kho nào thì xuất tại kho đó, mỗi mặt hàng chỉ lưu ở một kho. Lập, sửa hoặc chốt phiếu cho mặt hàng đang còn tồn ở kho khác bị chặn, thông báo ghi rõ kho đang giữ hàng.",
            "Kho Vật tư › Phiếu nhập xuất có 3 tab: Phiếu kho, Chờ nhập kho (lô vật tư IQC Đạt, kể cả lô lập từ đơn mua hàng) và Chờ cấp phát (vật tư lệnh sản xuất cần cấp). Kho Thành phẩm có tab Hàng Chờ Nhập Kho TP (từ FQC Đạt).",
            "Danh mục Kho: trang có các tab Tổng quan, Danh mục Kho, Vị trí Kệ Kho, Báo cáo NXT. Bấm mã kho mở trang chi tiết kho (loại kho, người quản lý, địa chỉ, tab Vị trí lưu trữ).",
            "Giao hàng: menu Kinh doanh › Giao hàng, gồm tab Danh Sách Phiếu Giao và Chờ Xuất Giao. Hàng chỉ giao được sau khi lô thành phẩm đã qua FQC Đạt, đã đóng gói và nhập kho tại Xưởng sản xuất › Đóng Gói & Nhập Kho.",
            "Người dùng chính: Thủ Kho (WAREHOUSE), Giao Hàng / Điều Vận (DELIVERY); liên quan: Kế hoạch, Sản xuất (tổ đóng gói), QC, Mua hàng, Kinh doanh, Kế toán, Ban Giám đốc. Quyền cụ thể theo Phân quyền vai trò do quản trị cấp."
         ],
         "references": [
            "ISO 9001:2015 mục 7.1.5 / 7.5 — Thông tin dạng văn bản: phiếu kho, sổ kho, biên bản kiểm kê được lưu làm hồ sơ.",
            "ISO 9001:2015 mục 8.5.2 — Nhận biết và truy xuất nguồn gốc (số lô, vị trí kệ, mã phiếu tham chiếu đơn mua, biên bản IQC, lệnh sản xuất, tem thùng).",
            "ISO 9001:2015 mục 8.5.4 — Bảo toàn sản phẩm (nhập, lưu kho, xuất, giao hàng).",
            "ISO 9001:2015 mục 8.6 — Thông qua sản phẩm: chỉ giao lô thành phẩm đã FQC Đạt và đã đóng gói nhập kho.",
            "Chương 13 — Mua hàng (đơn mua, nhận hàng qua IQC); chương 12 — Chất lượng (IQC, FQC); chương 08 — Lệnh sản xuất (cấp vật tư); Xưởng sản xuất — Đóng Gói & Nhập Kho; chương 15 — Tài chính (phiếu thu, công nợ từ phiếu giao)."
         ],
         "terms": [
            {
               "term": "Phiếu kho",
               "definition": "Chứng từ ghi biến động hàng, có 2 loại: Nhập kho và Xuất kho. Không có phiếu chuyển kho (phiếu chuyển kho cũ chỉ còn để xem)."
            },
            {
               "term": "Trạng thái phiếu kho",
               "definition": "Nháp (chỉ người tạo, Admin, Giám đốc thấy) → Chờ duyệt (sau khi bấm Lưu) → Đã chốt (trang chi tiết phiếu ghi Đã chốt kho; sau khi bấm Duyệt & Chốt Kho, tồn kho đã thay đổi). Phiếu chưa chốt có thể xoá; phiếu đã chốt chỉ có thể Hủy phiếu (Hoàn kho) → Đã hủy."
            },
            {
               "term": "Duyệt & Chốt Kho",
               "definition": "Thao tác ghi sổ: cộng / trừ tồn, ghi Sổ kho, cập nhật đơn mua, kế hoạch vật tư, lệnh sản xuất liên quan. Không hoàn tác; muốn sửa thì Hủy phiếu (Hoàn kho) rồi lập phiếu mới."
            },
            {
               "term": "Loại kho",
               "definition": "Khi tạo kho chọn một trong: Kho nguyên vật liệu, Kho thành phẩm, Kho công cụ dụng cụ, Kho vật tư kỹ thuật. Loại kho quyết định kho nhận loại hàng nào; kho còn tồn hàng khác loại không đổi được loại kho."
            },
            {
               "term": "Cho phép xuất âm",
               "definition": "Ô trên từng kho ở Danh mục Kho (mặc định bật cho giai đoạn chạy thử và golive; danh sách kho hiện nhãn Cho xuất âm). Bật: phiếu xuất, cấp vật tư, giao hàng vẫn chốt được khi tồn chưa đủ, số dư xuống dưới 0 và nhập bù sau. Tắt: hệ thống chặn và báo mã hàng, số còn lại, số cần giảm. Chỉ quản trị hệ thống được tắt ô này."
            },
            {
               "term": "Số chứng từ tham chiếu",
               "definition": "Ô ghi mã chứng từ gốc. Phiếu nhập ghi mã đơn mua (VD PO2610-7104) hoặc mã biên bản IQC của đơn đó: khi chốt, hệ thống cộng số đã nhận vào đơn mua và Kế hoạch vật tư; khi hủy phiếu đã chốt thì trừ lại."
            },
            {
               "term": "Tồn sổ sách",
               "definition": "Số tồn hệ thống tính từ các phiếu đã chốt. Báo cáo NXT (Tồn cuối kỳ), Sổ kho (Tồn lũy kế) và cột Sổ sách trên phiếu kiểm kê dùng chung một cách tính, nên luôn khớp nhau."
            },
            {
               "term": "Báo cáo NXT",
               "definition": "Bảng Tồn đầu kỳ, Tổng nhập, Tổng xuất, Tồn cuối kỳ theo mặt hàng và kho trong khoảng ngày chọn; mỗi mặt hàng một dòng (không tách tồn theo lô). Phiếu đã chốt rồi hủy (Hoàn kho) vẫn tính trong kỳ: phiếu gốc nằm ở Tổng xuất (hoặc Tổng nhập) và bút toán hoàn nằm ở chiều ngược lại, nên tổng nhập / xuất tăng nhưng Tồn cuối kỳ đúng."
            },
            {
               "term": "Sổ kho",
               "definition": "Lịch sử từng lần nhập, xuất của một mặt hàng: Ngày, Số chứng từ, Diễn giải, Nhập kho, Xuất kho, Tồn lũy kế. Bấm số chứng từ để mở phiếu gốc."
            },
            {
               "term": "Phiếu kiểm kê",
               "definition": "Đang kiểm kê (Khóa sổ) → Chờ duyệt → Đã chốt & Cân đối, hoặc Đã hủy. Trong lúc kiểm kê, kho bị khoá chốt phiếu nhập xuất: phiếu mới lập cho kho đó tự ở Chờ duyệt, ghi chú [Dời sau kiểm kê #KK-…], chốt sau khi duyệt kiểm kê. Duyệt xong hệ thống tự sinh phiếu nhập NK-KK (hàng thừa) và phiếu xuất XK-KK (hàng thiếu)."
            },
            {
               "term": "Phiếu giao hàng",
               "definition": "Chứng từ giao thành phẩm cho một khách hàng (có thể gồm nhiều đơn của cùng khách). Trạng thái: Bản nháp → Đã lên lịch → Đang giao → Đã giao → Hoàn tất chứng từ, hoặc Đã hủy."
            },
            {
               "term": "Phiếu xuất kho tự động khi giao",
               "definition": "Khi phiếu giao chuyển sang Đang giao (hoặc Đã giao), hệ thống tự lập phiếu xuất kho thành phẩm đã chốt để trừ tồn. Phiếu xuất này chỉ hoàn kho qua phiếu giao (hủy hoặc lùi phiếu giao về Đã lên lịch), không hủy tay ở kho."
            },
            {
               "term": "Phụ phí dịch vụ",
               "definition": "Dòng ngoài đơn trên phiếu giao (VD phí vận chuyển), không kiểm tồn, không trừ kho."
            }
         ],
         "responsibilities": [
            {
               "role": "Thủ kho vật tư (WAREHOUSE)",
               "tasks": [
                  "Nhập kho lô vật tư IQC Đạt từ tab Chờ nhập kho bằng nút [Nhập Kho NVL], kiểm số thực nhận rồi [Duyệt & Chốt Kho].",
                  "Cấp vật tư cho lệnh sản xuất từ tab Chờ cấp phát ([Xuất Cấp Phát]) hoặc chốt phiếu xuất do kế hoạch lập từ lệnh.",
                  "Hủy phiếu đã chốt khi ghi sai (Hoàn kho); khai báo vị trí kệ; xem NXT, Sổ kho; lập phiếu kiểm kê và Gửi duyệt."
               ]
            },
            {
               "role": "Thủ kho thành phẩm (WAREHOUSE)",
               "tasks": [
                  "Theo dõi tab Hàng Chờ Nhập Kho TP (từ FQC Đạt); hàng thành phẩm được nhập kho tại Xưởng sản xuất › Đóng Gói & Nhập Kho (nút [Đóng gói & nhập kho] mở thẳng phiếu đóng gói).",
                  "Kiểm tra phiếu xuất kho tự động sinh từ phiếu giao, xem NXT, Sổ kho, kiểm kê kho thành phẩm."
               ]
            },
            {
               "role": "Người duyệt kho (có quyền Duyệt kho)",
               "tasks": [
                  "Mở phiếu kiểm kê Chờ duyệt, bấm [Duyệt & Cân đối kho] hoặc [Trả lại] kèm lý do để đếm lại."
               ]
            },
            {
               "role": "Kế hoạch / Quản đốc",
               "tasks": [
                  "Từ Lệnh sản xuất › tab Kế hoạch vật tư bấm [Xuất kho] (cả lệnh) hoặc [Cấp vật tư] (từng dòng) để lập phiếu xuất cấp phát; theo dõi số đã cấp trên lệnh sau khi thủ kho chốt."
               ]
            },
            {
               "role": "Giao Hàng / Điều Vận (DELIVERY) & Kinh doanh",
               "tasks": [
                  "Lập phiếu giao từ tab Chờ Xuất Giao, nút [Giao FQC], nút [Giao Hàng] ở màn Đóng gói, hoặc [Lập phiếu]; chỉ gom các lô của cùng một khách.",
                  "Quét thùng xếp xe, bấm [Duyệt giao], chuyển Đã giao khi khách nhận; in phiếu giao có giá / không giá; ghi nhận Trả hàng."
               ]
            },
            {
               "role": "Kế toán",
               "tasks": [
                  "Từ phiếu giao Đang giao / Đã giao bấm [Lập Phiếu Thu]; theo dõi công nợ phải thu (chương 15)."
               ]
            }
         ],
         "processFlowchart": "graph TD\n    A[Đơn mua đã duyệt - hàng về] --> B[IQC vật tư Đạt]\n    B --> C[Tab Chờ nhập kho - Nhập Kho NVL]\n    C --> D{Lưu nháp hay Lưu}\n    D -->|Lưu nháp| E[Nháp - chỉ người tạo thấy]\n    E --> D\n    D -->|Lưu| F[Chờ duyệt]\n    F --> G[Duyệt và Chốt Kho]\n    G -->|Sai loại kho hoặc hàng đang ở kho khác| H[Bị chặn - sửa phiếu]\n    G -->|Hợp lệ| I[Đã chốt - cộng tồn - đơn mua Nhận 1 phần hoặc Đã nhận đủ]\n    I --> J[Tab Chờ cấp phát - Xuất Cấp Phát cho lệnh SX]\n    J --> K[Đã chốt - trừ tồn - cộng số đã cấp vào lệnh]\n    I -->|Ghi sai| L[Hủy phiếu Hoàn kho]\n    M[FQC Đạt] --> N[Đóng gói và nhập kho TP tại Xưởng]\n    N --> O[Chờ giao hàng hoặc Chờ xe]\n    O --> P[Lập phiếu giao - chỉ cùng 1 khách]\n    P --> Q[Đã lên lịch]\n    Q --> R[Duyệt giao - Đang giao - tự lập phiếu xuất trừ kho TP]\n    R --> S[Đã giao - cộng SL đã giao vào đơn hàng - công nợ]\n    S --> T[Lập phiếu thu]\n    U[Kiểm kê - Đang kiểm kê khoá sổ] --> V[Gửi duyệt]\n    V -->|Trả lại| U\n    V -->|Duyệt và Cân đối kho| W[Tự sinh NK-KK hàng thừa và XK-KK hàng thiếu - mở khoá kho]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Mở đúng kho và tab",
               "detail": "• Menu Kho › Kho Vật tư (hoặc Kho Thành phẩm, Kho Kỹ thuật). Trang mở ở tab Phiếu nhập xuất.\n• Thanh tab trên cùng: Phiếu nhập xuất, Báo cáo NXT, Sổ kho, Kiểm kê.\n• Trong Phiếu nhập xuất của Kho Vật tư có thêm tab Chờ nhập kho và Chờ cấp phát; Kho Thành phẩm có tab Hàng Chờ Nhập Kho TP (từ FQC Đạt). Số bên cạnh tab là số dòng đang chờ."
            },
            {
               "step": 2,
               "action": "Nhập kho vật tư từ hàng chờ IQC",
               "detail": "• Tab Chờ nhập kho liệt kê các lô vật tư đã kiểm IQC Đạt chưa nhập (kể cả lô lập từ đơn mua hàng): Biên Bản IQC, Nhà Cung Cấp, Mã Vật Tư, Tên Nguyên Vật Liệu, SL Đạt Nhập Kho, Số Lô NCC, Ngày Kiểm.\n• Bấm [Nhập Kho NVL] trên dòng: phiếu nhập mở sẵn vật tư, số lượng đạt, Số chứng từ tham chiếu = mã biên bản IQC, ghi chú nguồn gốc.\n• Kiểm số thực nhận, chọn Vị trí lưu trữ (kệ) nếu kho đã khai báo kệ, rồi bấm [Lưu]. Mở phiếu và bấm [Duyệt & Chốt Kho] → [Chốt Kho].\n• Khi chốt: tồn kho tăng, đơn mua của lô chuyển Nhận 1 phần hoặc Đã nhận đủ, Kế hoạch vật tư cập nhật, lô rời khỏi tab Chờ nhập kho."
            },
            {
               "step": 3,
               "action": "Lập phiếu nhập / xuất thủ công",
               "detail": "• Bấm [Tạo mới] trên tab Phiếu kho. Chọn Loại giao dịch: Nhập kho (Receipt) hoặc Xuất kho (Issue); không đổi được loại khi sửa.\n• Ô Kho nhận / Kho xuất chỉ liệt kê kho đúng loại và chọn sẵn kho chính của loại đó (VD Kho Vật tư chọn sẵn KHO-VT). Anh/chị kiểm tra lại kho trước khi lưu.\n• Phiếu nhập: chọn Nhà cung cấp; nhà cung cấp chưa có thì bấm [+ Thêm NCC] để tạo nhanh, tạo xong tự chọn. Phiếu xuất: chọn Lệnh Sản Xuất (Xuất cho SX) hoặc Khách hàng (Nếu xuất giao hàng).\n• Ghi Số chứng từ tham chiếu (VD mã đơn mua PO2610-7104, mã lệnh LSX-2610-008), Người giao / Nhận hàng (Tài xế), Biển số xe / Phương tiện, Ghi chú / Diễn giải chứng từ. Có thể dán chữ chép từ Excel / Word vào các ô này, chữ vào đúng ô.\n• Bảng hàng: [Thêm dòng], [Nhập Excel], hoặc [Thêm vật tư] / [Thêm thành phẩm] / [Thêm khuôn / bản kẽm / CCDC] để tạo nhanh mặt hàng mới và thêm ngay vào phiếu. Nhập Số lượng, Đơn giá, Vị trí lưu trữ, Ghi chú dòng. Phiếu xuất hiện Tồn: của kho xuất dưới ô số lượng, báo Thiếu! nếu vượt. Cuối bảng có Tổng số dòng và Tổng giá trị.\n• Đính kèm ảnh phiếu cân, biên bản giao nhận: kéo thả, chọn tệp, hoặc nhấn Ctrl+V ở bất kỳ đâu trên trang phiếu để dán ảnh chụp."
            },
            {
               "step": 4,
               "action": "Lưu nháp hoặc Lưu",
               "detail": "• [Lưu nháp]: phiếu ở trạng thái Nháp, chỉ người tạo, Admin, Giám đốc thấy.\n• [Lưu]: kiểm tra đủ thông tin và đúng loại kho, chuyển phiếu sang Chờ duyệt.\n• Phiếu Nháp / Chờ duyệt sửa được (biểu tượng Sửa phiếu nháp trên danh sách hoặc [Sửa Phiếu] ở trang xem) và xoá được ([Xóa Phiếu] hoặc biểu tượng Xóa phiếu nháp)."
            },
            {
               "step": 5,
               "action": "Duyệt & Chốt Kho",
               "detail": "• Mở phiếu → [Duyệt & Chốt Kho] → [Chốt Kho]. Không hoàn tác được.\n• Hệ thống chặn nếu: mặt hàng sai loại kho; mặt hàng đang tồn ở kho khác; kho đang khoá sổ kiểm kê; kho không cho xuất âm mà tồn không đủ (báo mã hàng, Còn lại, Cần giảm); phiếu nhập tham chiếu đơn mua chưa duyệt hoặc nhận vượt SL đặt + 5%.\n• Phiếu nhập tham chiếu phiếu đóng gói thành phẩm bị chặn: thành phẩm phải nhập tại Xưởng sản xuất › Đóng Gói & Nhập Kho.\n• Chốt xong: tồn kho, Sổ kho, Báo cáo NXT, cột Tồn kho ở Mã & Tồn NVL cập nhật. Phiếu xuất có Lệnh sản xuất cộng số đã cấp vào lệnh và kế hoạch vật tư."
            },
            {
               "step": 6,
               "action": "Cấp vật tư cho lệnh sản xuất",
               "detail": "• Tab Chờ cấp phát liệt kê nhu cầu vật tư của các lệnh sản xuất chưa cấp đủ. Bấm [Xuất Cấp Phát] trên dòng: phiếu xuất mở sẵn lệnh, vật tư theo kế hoạch vật tư, tham chiếu = mã lệnh.\n• Hoặc kế hoạch mở Lệnh sản xuất › tab Kế hoạch vật tư bấm [Xuất kho] / [Cấp vật tư].\n• Cấp vật tư chỉ lấy từ Kho Vật tư; không cấp cho lệnh chưa duyệt hoặc đã hủy.\n• Thủ kho kiểm số rồi [Duyệt & Chốt Kho]."
            },
            {
               "step": 7,
               "action": "Hủy phiếu đã chốt (Hoàn kho)",
               "detail": "• Trên danh sách bấm biểu tượng Hủy phiếu (Hoàn kho) của phiếu Đã chốt, nhập lý do. Tồn kho được hoàn lại, số đã cấp cho lệnh và số đã nhận trên đơn mua được trừ lại; phiếu chuyển Đã hủy. Bấm hủy hai lần không hoàn kho hai lần.\n• Phiếu xuất sinh từ phiếu giao không hủy ở đây: hủy hoặc lùi phiếu giao về Đã lên lịch để hoàn kho."
            },
            {
               "step": 8,
               "action": "Báo cáo NXT và Sổ kho",
               "detail": "• Tab Báo cáo NXT: chọn khoảng ngày, kho; bật Hiện Tồn = 0 để thấy đủ danh mục hàng đúng loại của kho (kể cả hàng chưa từng nhập xuất). Cột Tồn Đầu Kỳ, Tổng Nhập, Tổng Xuất, Tồn Cuối Kỳ. Nút Thẻ Kho trên dòng mở Sổ kho của mặt hàng. Thanh trên có [Kiểm toán Sổ], [In / PDF] (có chữ ký người lập, thủ kho, kế toán) và Xuất Excel.\n• Tab Sổ kho: chọn vật tư / sản phẩm (gõ mã hoặc tên), khoảng ngày, kho. Bảng Ngày Tháng, Số Chứng Từ, Diễn Giải, Nhập Kho, Xuất Kho, Tồn Lũy Kế; bấm số chứng từ để mở phiếu gốc. Có [In / PDF] và [Xuất Excel].\n• Tồn Cuối Kỳ trên NXT bằng Tồn Lũy Kế dòng cuối trên Sổ kho cùng kỳ, cùng kho."
            },
            {
               "step": 9,
               "action": "Kiểm kê có bước duyệt",
               "detail": "• Tab Kiểm kê → [Tạo phiếu], chọn kho: bảng tự nạp đủ danh mục hàng của kho; [Nạp đủ danh mục kho] nạp lại dòng đã xoá; [Quét mã] để đếm bằng máy quét (quét lại cùng mã cộng thêm 1). Cột Sổ sách bằng Tồn Cuối Kỳ trên NXT. Nhập Thực tế; Chênh lệch tự tính; dòng lệch phải ghi nguyên nhân.\n• Bấm [Lưu Phiếu Kiểm Kê] → phiếu Đang kiểm kê (Khóa sổ): kho không chốt được phiếu nhập xuất cho tới khi kiểm kê xong.\n• Đếm xong, mở phiếu → [Gửi duyệt] → Chờ duyệt (kho vẫn khoá).\n• Người có quyền Duyệt kho mở phiếu → [Duyệt & Cân đối kho]: hệ thống tự sinh phiếu nhập NK-KK cho hàng thừa, phiếu xuất XK-KK cho hàng thiếu, tồn bằng số thực tế, mở khoá kho; phiếu chuyển Đã chốt & Cân đối. Cần đếm lại: [Trả lại] kèm lý do, phiếu về Đang kiểm kê.\n• Trang chi tiết có [Xuất Excel] và [In / PDF] (Biên bản kiểm kê kho khổ ngang có số lô, vị trí, giá trị lệch, dòng tổng)."
            },
            {
               "step": 10,
               "action": "Lập phiếu giao hàng",
               "detail": "• Điều kiện: lô thành phẩm đã FQC Đạt, đã đóng gói và nhập kho tại Xưởng sản xuất › Đóng Gói & Nhập Kho (lô ở trạng thái Chờ giao hàng / Chờ xe).\n• Cách lập: Kinh doanh › Giao hàng › tab Chờ Xuất Giao, tick các mặt hàng của cùng 1 khách → [Lập Phiếu Giao Hàng (n mặt hàng - Tên khách)] hoặc [Lập phiếu] trên từng dòng; hoặc [Giao FQC] → hộp Lô Thành Phẩm Đã Nghiệm Thu FQC (Sẵn Sàng Xuất Giao) → [Lập phiếu] / [Tạo Phiếu Xuất Giao (n) Lô Đã Chọn]; hoặc tại màn Đóng gói bấm [Giao Hàng]; hoặc [Lập phiếu] để lập từ đơn hàng.\n• Chọn lô của nhiều khách: hệ thống báo các khách đang chọn và không mở phiếu.\n• Trên form: chọn khách, đơn hàng ([Gộp thêm đơn] / [+ Gộp Đơn Hàng] chỉ gộp đơn cùng khách), NV Sale, ngày giao, hình thức giao, tài xế, biển số xe, người nhận, SĐT, địa chỉ nhận. Mỗi dòng hiện KCS: và Kho:; [Tồn kho] cập nhật tồn mới nhất; [+ Thêm SP]; [+ Thêm Phụ Phí Dịch Vụ]; bật thuế GTGT.\n• [Lưu nháp] → Bản nháp; [Lưu] → Đã lên lịch. Hệ thống chặn nếu: dòng hàng thuộc khách khác; SL giao vượt SL đặt cộng % bù hao của dòng đơn (tính cả các phiếu giao đang mở; dòng bù hao 0% không giao vượt SL đặt); lô không còn hàng đã đóng gói chưa giao; tháng của khách đã chốt công nợ."
            },
            {
               "step": 11,
               "action": "Xếp xe, giao hàng, in phiếu",
               "detail": "• Trang chi tiết phiếu giao: [Quét thùng] quét tem QR thùng carton xếp xe; [Vị trí xe] sửa địa chỉ nhận (khi phiếu còn Bản nháp / Đã lên lịch).\n• [Duyệt giao] (Bản nháp / Đã lên lịch) chuyển Đang giao: hệ thống tự lập phiếu xuất kho thành phẩm đã chốt. Kho không đủ tồn (và kho không cho xuất âm) thì báo mặt hàng còn bao nhiêu, cần bao nhiêu, giữ nguyên trạng thái.\n• Khách nhận hàng: bấm bước Đã giao trên thanh trạng thái → xác nhận. Số đã giao cộng vào đơn hàng, công nợ phải thu tính lại. Thanh trạng thái chỉ cho bấm bước được phép; không chuyển được thì hiện đúng lý do.\n• In: [In có giá] / [In không giá] (Phiếu giao hàng BM-GH-01), [In CoA]. [Đơn hàng] mở đơn bán; [Lập Phiếu Thu] (hiện Đã thu đủ khi đơn đã thu đủ); [Trả hàng] khi Đang giao / Đã giao."
            }
         ],
         "subFlows": [
            {
               "name": "Phiếu kho — Danh sách (Kho › Kho Vật tư › Phiếu nhập xuất)",
               "steps": [
                  "Tab Phiếu kho: bảng nhóm theo ngày (nút bật / tắt nhóm), thẻ lọc Tất cả loại phiếu / Nhập kho / Xuất kho và Tất cả trạng thái / Nháp / Chờ duyệt / Đã chốt / Đã hủy, ô chọn kho.",
                  "Cột: Mã phiếu, Trạng thái, Loại phiếu, Ngày lập, Kho nguồn, Kho đích, Tham chiếu, Thao tác; bấm tiêu đề cột để sắp xếp; bấm nút lọc để lọc theo từng cột. Tìm theo mã phiếu, tham chiếu bằng ô tìm kiếm trên thanh đầu trang.",
                  "Biểu tượng trên dòng: Sửa phiếu nháp, Xóa phiếu nháp (Nháp / Chờ duyệt), Hủy phiếu (Hoàn kho) (Đã chốt), In phiếu (mọi trạng thái).",
                  "Xuất Excel danh sách đang lọc, tải file mẫu; [Tạo mới] mở form phiếu."
               ]
            },
            {
               "name": "Phiếu kho — Xem chi tiết",
               "steps": [
                  "Thanh tab kho ở trên cùng, ngay dưới là mã phiếu, trạng thái và các nút [Sửa Phiếu], [Duyệt & Chốt Kho], [Xóa Phiếu] (phiếu chưa chốt), [In Phiếu].",
                  "Thẻ thông tin chung: Số phiếu, Loại phiếu, Ngày chứng từ, Người lập, Kho xuất / Kho nhập, Tham chiếu, Nhà cung cấp, Khách hàng, Lệnh SX, Đơn hàng, Phiếu giao, Người chốt. Kho, nhà cung cấp, khách hàng, lệnh, đơn hàng, phiếu giao là link bấm mở bản ghi gốc.",
                  "Bảng dòng hàng toàn chiều rộng có lô, đơn giá, thành tiền, dòng tổng; bấm tên hàng mở mặt hàng.",
                  "Cuối trang có tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật (ghi cả sửa từng dòng hàng) và dòng Tạo / Cập nhật bởi."
               ]
            },
            {
               "name": "Phiếu kho — In",
               "steps": [
                  "Biểu tượng In phiếu trên danh sách, [In Phiếu] ở trang xem hoặc [In phiếu] trên trang sửa.",
                  "Mẫu Phiếu Nhập kho (BM-KHO-01), Phiếu Xuất kho (BM-KHO-02); phiếu xuất cho lệnh sản xuất in thành Phiếu xuất kho nguyên vật liệu sản xuất. Ô chữ ký Người lập in họ tên người lập; phiếu do hệ thống tự lập ghi Hệ thống."
               ]
            },
            {
               "name": "Hàng chờ (tab trên Phiếu nhập xuất)",
               "steps": [
                  "Chờ nhập kho (Kho Vật tư): lô IQC Đạt chưa nhập → [Nhập Kho NVL]. Nhập xong lô tự rời khỏi danh sách.",
                  "Chờ cấp phát (Kho Vật tư): nhu cầu vật tư của lệnh sản xuất → [Xuất Cấp Phát].",
                  "Hàng Chờ Nhập Kho TP (từ FQC Đạt) (Kho Thành phẩm): lô thành phẩm Đạt chờ đóng gói → [Đóng gói & nhập kho] mở phiếu đóng gói ở Xưởng sản xuất; tổ đóng gói ghi SL đạt / lỗi, người đóng gói, in tem thùng rồi hoàn tất, phiếu nhập kho thành phẩm tự lập.",
                  "[Làm mới] tải lại hàng chờ."
               ]
            },
            {
               "name": "Báo cáo NXT (Kho › <kho> › Báo cáo NXT)",
               "steps": [
                  "Chọn kho, khoảng ngày; bật / tắt Hiện Tồn = 0.",
                  "Lọc theo Mã VT / TP, Tên VT / TP, ĐVT, Kho.",
                  "Thẻ Kho trên dòng mở Sổ kho đúng mặt hàng; [Kiểm toán Sổ] (có hộp xác nhận) chạy lại đối chiếu sổ; [In / PDF]; Xuất Excel lấy đủ mọi dòng."
               ]
            },
            {
               "name": "Sổ kho (Kho › <kho> › Sổ kho)",
               "steps": [
                  "Chọn vật tư / sản phẩm, khoảng ngày, kho (mặc định Tất cả kho).",
                  "Xem Tồn đầu kỳ và từng giao dịch; bấm số chứng từ mở phiếu gốc.",
                  "[In / PDF] và [Xuất Excel]: STT, Ngày Tháng, Số Chứng Từ, Diễn Giải, Nhập Kho, Xuất Kho, Tồn Lũy Kế."
               ]
            },
            {
               "name": "Kiểm kê — Danh sách / Thêm / Sửa / Xoá",
               "steps": [
                  "Danh sách: thẻ lọc Tất cả trạng thái, Đang kiểm kê (Khóa sổ), Chờ duyệt, Đã chốt & Cân đối, Đã hủy; cột Phiếu Nhập Cân Đối Thừa, Phiếu Xuất Cân Đối Thiếu, Người lập; [Tạo phiếu]; xuất Excel.",
                  "Thêm: chọn kho, ngày, ghi chú, nhập Thực tế, nguyên nhân → [Lưu Phiếu Kiểm Kê].",
                  "Sửa: biểu tượng Sửa phiếu kiểm kê trên danh sách hoặc [Sửa kiểm đếm] ở chi tiết, chỉ khi Đang kiểm kê.",
                  "Xoá: biểu tượng Xóa phiếu kiểm kê nháp (chỉ phiếu Đang kiểm kê), xoá xong kho mở khoá. [Hủy phiếu] ở chi tiết hủy đợt kiểm kê và mở khoá kho."
               ]
            },
            {
               "name": "Kiểm kê — Gửi duyệt / Duyệt / Trả lại / In",
               "steps": [
                  "[Gửi duyệt]: dòng chênh lệch thiếu nguyên nhân thì hệ thống báo các mã hàng cần bổ sung và chưa cho gửi.",
                  "[Duyệt & Cân đối kho] và [Trả lại] chỉ hiện với người có quyền Duyệt kho khi phiếu Chờ duyệt.",
                  "[Xuất Excel], [In / PDF] trên trang chi tiết."
               ]
            },
            {
               "name": "Danh mục Kho và Vị trí Kệ Kho (Kho › Danh mục Kho)",
               "steps": [
                  "Tab Danh mục Kho: [Thêm kho mới] → nhập mã, tên, Loại kho (Kho nguyên vật liệu, Kho thành phẩm, Kho công cụ dụng cụ, Kho vật tư kỹ thuật), người quản lý, ô Cho phép xuất âm → [Lưu kho hàng]. Sửa: biểu tượng Sửa kho → [Lưu thay đổi]. Xoá: biểu tượng Xóa kho.",
                  "Tab Vị trí Kệ Kho: [Thêm Vị Trí Kệ Mới] → Kho trực thuộc, Mã kệ/vị trí, Tên kệ/vị trí (bắt buộc), Dãy (Aisle), Tầng (Shelf), Ô (Bin) → [Tạo Vị Trí Kệ]. Sửa: biểu tượng Sửa vị trí kệ → [Lưu Thay Đổi]; Xoá: biểu tượng Xóa vị trí kệ. Lọc theo kho, tìm theo mã hoặc tên kệ.",
                  "Vị trí kệ của kho hiện ở cột Vị trí lưu trữ trên phiếu kho và tab Vị trí lưu trữ ở trang chi tiết kho."
               ]
            },
            {
               "name": "Mã & Tồn NVL (Kho › Mã & Tồn NVL)",
               "steps": [
                  "Cột Tồn kho lấy theo số dư thật trong kho, tự cập nhật sau mỗi lần chốt / hủy phiếu. Không sửa tồn trên danh mục: muốn đổi tồn thì lập phiếu nhập / xuất hoặc kiểm kê."
               ]
            },
            {
               "name": "Phiếu giao — Danh sách (Kinh doanh › Giao hàng)",
               "steps": [
                  "Tab Danh Sách Phiếu Giao (nhóm theo ngày, lọc trạng thái, khách hàng, sản phẩm, loại hình) và Chờ Xuất Giao (mặt hàng đã đóng gói nhập kho chưa giao, lọc khách hàng).",
                  "Bấm mũi tên đầu dòng xem dòng hàng; bấm dòng mở chi tiết. Menu ... trên dòng: Chỉnh sửa, In phiếu.",
                  "Chọn nhiều phiếu: Đã giao (Delivered), In Vận đơn, Xác nhận giao hàng, Xoá.",
                  "Thanh trên: [Giao FQC], [Lập phiếu], Xuất Excel; Nhập Excel nằm trong nút Khác (người có quyền tạo giao hàng)."
               ]
            },
            {
               "name": "Phiếu giao — Xem / Sửa / Xoá",
               "steps": [
                  "Xem: thông tin chung (khách hàng là link mở hồ sơ khách), bảng hàng thực giao, phụ phí, thùng carton đã quét, lô KCS liên kết; tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật.",
                  "Sửa: [Sửa] khi phiếu chưa Đã giao / Hoàn tất chứng từ; phiếu Đang giao không sửa dòng hàng (chuyển về Đã lên lịch để hoàn kho rồi mới sửa).",
                  "Xoá: [Xoá] → Xác nhận xoá?; phiếu vào Thùng rác. Phiếu Đang giao phải hủy (hoàn kho) trước; phiếu Đã giao / Hoàn tất chứng từ không xoá được (nhãn Đã Khóa Sổ Bất Biến)."
               ]
            },
            {
               "name": "Phiếu giao — Chuyển trạng thái",
               "steps": [
                  "Thanh trạng thái Bản nháp → Đã lên lịch → Đang giao → Đã giao; chỉ bước được phép mới bấm được, bấm xong hiện hộp xác nhận.",
                  "Nút Hủy trên thanh trạng thái hiện khi phiếu còn Bản nháp / Đã lên lịch.",
                  "Lùi Đang giao về Đã lên lịch hoặc hủy phiếu Đang giao: hệ thống hủy phiếu xuất kho và trả hàng về kho thành phẩm đúng một lần.",
                  "Phiếu chưa có dòng hàng không chuyển Đang giao / Đã giao."
               ]
            },
            {
               "name": "Phiếu giao — Trả hàng",
               "steps": [
                  "[Trả hàng] hiện khi phiếu Đang giao hoặc Đã giao. Nhập SL trả lại (không lớn hơn SL đã giao), lý do → xác nhận.",
                  "Hệ thống lập phiếu nhập kho hàng trả (đã chốt) đưa hàng về kho thành phẩm; trả hàng làm đơn thiếu lại thì đơn mở lại."
               ]
            },
            {
               "name": "Kho Kỹ thuật (khuôn, bản kẽm, công cụ dụng cụ)",
               "steps": [
                  "Mở Kỹ thuật › Kho Kỹ thuật hoặc Kho › Kho Kỹ thuật. Kho này chỉ nhận khuôn / bản kẽm / công cụ dụng cụ; nhập vật tư hoặc thành phẩm vào đây bị báo “… chỉ nhận khuôn / bản kẽm / CCDC”.",
                  "4 tab như các kho khác: Phiếu nhập xuất, Báo cáo NXT, Sổ kho, Kiểm kê.",
                  "[Tạo mới] phiếu: chọn Nhập kho hoặc Xuất kho, chọn mặt hàng kỹ thuật (đơn vị mặc định bộ). [Lưu nháp] giữ ở Nháp; [Lưu] chuyển Chờ duyệt.",
                  "Mở phiếu Chờ duyệt bấm [Duyệt & Chốt Kho] → [Chốt Kho]: tồn kho cập nhật, không sửa được nữa. Phiếu đã chốt muốn đảo thì dùng [Hủy phiếu (Hoàn kho)]."
               ]
            },
            {
               "name": "Nhập kho vật tư theo lô IQC",
               "steps": [
                  "Mỗi lô IQC chỉ nhập kho một lần: phiếu nhập thứ hai cho lô đã nhập không chốt được, phần mềm báo lô đã nhập bằng phiếu nào.",
                  "Lô thuộc đơn mua chưa duyệt hiện lý do ngay dưới nút và khoá [Nhập Kho NVL]; duyệt đơn mua trước rồi chốt lại.",
                  "Số lượng nhận được nhập số lẻ (VD 0,5 kg)."
               ]
            },
            {
               "name": "Giao hàng hàng loạt",
               "steps": [
                  "Kinh doanh › Giao hàng: tick nhiều phiếu Đã xếp lịch / Đang giao rồi bấm [Đã giao] để chuyển cùng lúc.",
                  "Nhập Excel phiếu giao chỉ cập nhật trạng thái; dòng hàng sai được báo rõ trên từng phiếu để sửa."
               ]
            },
            {
               "name": "Danh sách phiếu giao — lô FQC sẵn sàng và cập nhật vị trí",
               "steps": [
                  "[Lô FQC Sẵn Sàng Xếp Xe]: ô chỉ số trên đầu danh sách, đếm các lô đã đạt KCS FQC và đã đóng gói nhập kho thành phẩm; bấm để mở bảng chọn lô.",
                  "Trong bảng chọn lô, bấm [Lập phiếu] trên một lô để mở form tạo phiếu giao đã điền sẵn lô đó.",
                  "Tick nhiều lô rồi bấm [Tạo Phiếu Xuất Giao (n) Lô Đã Chọn] hoặc [Xuất Giao (n) Lô Đã Chọn] để lập một phiếu giao cho cả nhóm; nếu các lô thuộc nhiều khách hàng, hệ thống báo \"Chỉ gom phiếu giao khi cùng khách hàng…\" và không lập phiếu.",
                  "[Cập nhật vị trí]: trong menu thao tác của phiếu giao, mở form sửa phiếu và đưa con trỏ tới phần vị trí; chỉ hiện khi phiếu đang ở Nháp hoặc Đã lên lịch."
               ]
            },
            {
               "name": "Chi tiết phiếu giao — tab Kiện hàng, KCS FQC và trạm quét thùng",
               "steps": [
                  "[Kiện Hàng & Thùng Carton /]: tab hiển thị số thùng đã lên xe trên tổng số thùng (ví dụ 3/10) và danh sách tem thùng với trạng thái ĐÃ LÊN XE hoặc CHỜ QUÉT.",
                  "[Trạm Quét Mã Vạch (Súng / Camera)]: mở trạm quét để bắn súng mã vạch hoặc gõ mã tem thùng (dạng LBL-…) cho từng thùng xếp lên xe.",
                  "Mỗi lần quét đúng, thùng chuyển sang Đã lên xe và hiện \"Đã quét thành công Thùng x/y…\"; tem không tồn tại, tem của khách hàng khác hoặc tem đã gắn phiếu giao khác đều bị từ chối kèm thông báo lý do.",
                  "[Đóng Trạm Quét]: đóng trạm quét, các thùng đã quét vẫn được giữ trên phiếu giao.",
                  "[Gỡ]: trên dòng thùng, gỡ thùng đó khỏi chuyến xe (báo \"Đã gỡ thùng carton khỏi phiếu giao hàng\"); nút không hiện khi phiếu đã giao.",
                  "[KCS FQC & Nguồn Gốc Lô]: tab liệt kê các biên bản KCS FQC của các lệnh sản xuất trong phiếu (kết quả, số lượng kiểm/đạt, người kiểm, ngày kiểm); nếu chưa có sẽ báo \"Chưa có hồ sơ FQC liên kết\".",
                  "[Phát Hành & In CoA (A4)]: trong tab KCS FQC, in giấy chứng nhận chất lượng cho chuyến giao."
               ]
            },
            {
               "name": "Tạo / Sửa phiếu giao — VAT và gộp đơn cùng khách hàng",
               "steps": [
                  "Công tắc [⚡ Kèm Dịch Vụ VAT] (bật sẵn khi tạo phiếu mới) thêm dòng Thuế GTGT tính trên tiền hàng, chọn mức 8%, 10%, 5% hoặc 0%.",
                  "[Tắt Dịch Vụ VAT]: nút thùng rác trên dòng thuế VAT, bấm để xóa dòng thuế và tự tắt công tắc VAT; không bấm được khi phiếu đã khóa.",
                  "[+ Gộp Đơn Hàng] mở hộp thoại Gộp Thêm Đơn Hàng Cùng Khách Hàng; nút bị mờ khi chưa chọn khách hàng hoặc phiếu đã khóa.",
                  "Ô chọn đơn hàng chỉ liệt kê đơn của đúng khách hàng trên phiếu; chọn lại đơn chính hoặc đơn đã chọn sẽ báo \"Đơn hàng này đã là đơn chính hoặc đã được chọn\".",
                  "Tick các mặt hàng cần giao thêm (mặt hàng đã có trên phiếu bị khóa, không tick được).",
                  "[Gộp Vào Phiếu Giao]: thêm các mặt hàng đã tick vào danh sách giao của phiếu; nút bị mờ khi chưa tick mặt hàng nào."
               ]
            },
            {
               "name": "Phiếu nhập / xuất kho — Hình ảnh & Tệp đính kèm",
               "steps": [
                  "[Tải ảnh / tệp lên]: chọn một hoặc nhiều ảnh, PDF, Word, Excel, CSV, TXT hoặc ZIP (mỗi tệp tối đa 100MB), có thể kéo thả hoặc Ctrl+V dán ảnh chụp màn hình.",
                  "Khi đang tạo phiếu mới, tệp được giữ tạm và lưu cùng phiếu khi bấm lưu; với phiếu đã có, tệp được lưu ngay vào phiếu.",
                  "Tệp quá 100MB bị bỏ qua với thông báo vượt giới hạn; tệp tải lỗi báo \"Không thể tải …\".",
                  "[Xóa tệp đính kèm]: nút thùng rác trên dòng tệp, xóa tệp khỏi phiếu (báo \"Đã xóa tệp đính kèm\"); không hiện khi phiếu ở chế độ chỉ xem."
               ]
            },
            {
               "name": "Kiểm kê — Tạo phiếu khi kho đang có phiếu chưa chốt",
               "steps": [
                  "Nếu kho đã chọn đang có phiếu kiểm kê chưa chốt, màn hình hiện cảnh báo vàng và nút [Lưu Phiếu Kiểm Kê] bị mờ vì mỗi kho chỉ mở một phiên kiểm kê một lúc.",
                  "[Mở phiếu #…] (kèm mã phiếu đang dở): mở phiếu kiểm kê đang dở của kho để đếm tiếp, hoặc chốt / hủy phiếu đó trước khi tạo phiếu mới."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "(Mới)",
               "to": "Nháp",
               "action": "Phiếu kho: [Lưu nháp]",
               "allowedRoles": "Người có quyền tạo phiếu kho"
            },
            {
               "from": "(Mới) / Nháp",
               "to": "Chờ duyệt",
               "action": "Phiếu kho: [Lưu]",
               "allowedRoles": "Người có quyền tạo / sửa phiếu kho"
            },
            {
               "from": "Nháp / Chờ duyệt",
               "to": "Đã chốt",
               "action": "Phiếu kho: [Duyệt & Chốt Kho] → [Chốt Kho]; chặn khi sai loại kho, hàng đang ở kho khác, kho đang kiểm kê, thiếu tồn ở kho không cho xuất âm",
               "allowedRoles": "Thủ kho"
            },
            {
               "from": "Nháp / Chờ duyệt",
               "to": "(Xoá)",
               "action": "Phiếu kho: [Xóa Phiếu] / biểu tượng Xóa phiếu nháp",
               "allowedRoles": "Người có quyền xoá phiếu kho"
            },
            {
               "from": "Đã chốt",
               "to": "Đã hủy",
               "action": "Phiếu kho: Hủy phiếu (Hoàn kho) + lý do; tồn, lệnh SX, đơn mua, kế hoạch vật tư được đảo lại. Phiếu xuất của phiếu giao không hủy ở đây.",
               "allowedRoles": "Thủ kho"
            },
            {
               "from": "(Mới)",
               "to": "Đang kiểm kê (Khóa sổ)",
               "action": "Kiểm kê: [Lưu Phiếu Kiểm Kê] — kho khoá chốt phiếu nhập xuất",
               "allowedRoles": "Thủ kho"
            },
            {
               "from": "Đang kiểm kê (Khóa sổ)",
               "to": "Chờ duyệt",
               "action": "Kiểm kê: [Gửi duyệt] — dòng lệch phải có nguyên nhân",
               "allowedRoles": "Thủ kho"
            },
            {
               "from": "Chờ duyệt",
               "to": "Đã chốt & Cân đối",
               "action": "Kiểm kê: [Duyệt & Cân đối kho] — tự sinh NK-KK / XK-KK, mở khoá kho",
               "allowedRoles": "Người có quyền Duyệt kho"
            },
            {
               "from": "Chờ duyệt",
               "to": "Đang kiểm kê (Khóa sổ)",
               "action": "Kiểm kê: [Trả lại] kèm lý do",
               "allowedRoles": "Người có quyền Duyệt kho"
            },
            {
               "from": "Đang kiểm kê / Chờ duyệt",
               "to": "Đã hủy",
               "action": "Kiểm kê: [Hủy phiếu] — mở khoá kho",
               "allowedRoles": "Thủ kho (Chờ duyệt: người có quyền Duyệt kho)"
            },
            {
               "from": "(Mới)",
               "to": "Bản nháp",
               "action": "Phiếu giao: [Lưu nháp]",
               "allowedRoles": "Người có quyền tạo Giao hàng"
            },
            {
               "from": "(Mới) / Bản nháp",
               "to": "Đã lên lịch",
               "action": "Phiếu giao: [Lưu]",
               "allowedRoles": "Người có quyền tạo Giao hàng"
            },
            {
               "from": "Bản nháp / Đã lên lịch",
               "to": "Đang giao",
               "action": "Phiếu giao: [Duyệt giao] hoặc bước Đang giao — tự lập phiếu xuất trừ kho thành phẩm",
               "allowedRoles": "Người có quyền sửa Giao hàng"
            },
            {
               "from": "Đang giao",
               "to": "Đã giao",
               "action": "Phiếu giao: bước Đã giao — cộng SL đã giao vào đơn hàng, tính lại công nợ",
               "allowedRoles": "Người có quyền sửa Giao hàng"
            },
            {
               "from": "Đang giao",
               "to": "Đã lên lịch / Đã hủy",
               "action": "Phiếu giao: lùi bước hoặc hủy — hoàn kho thành phẩm đúng một lần",
               "allowedRoles": "Người có quyền sửa Giao hàng"
            },
            {
               "from": "Bản nháp / Đã lên lịch",
               "to": "Đã hủy",
               "action": "Phiếu giao: nút Hủy trên thanh trạng thái → xác nhận",
               "allowedRoles": "Người có quyền sửa Giao hàng"
            },
            {
               "from": "Đã giao",
               "to": "Hoàn tất chứng từ",
               "action": "Phiếu giao: hoàn tất chứng từ; sau bước này không đổi ngược trạng thái",
               "allowedRoles": "Người có quyền sửa Giao hàng"
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền; thấy bản nháp của mọi người; chỉ quản trị hệ thống được tắt Cho phép xuất âm của kho."
            },
            {
               "role": "WAREHOUSE (Thủ kho)",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "⚡",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Sửa / xoá chỉ phiếu Nháp hoặc Chờ duyệt; phiếu Đã chốt chỉ Hủy (Hoàn kho). Duyệt & Cân đối kho / Trả lại phiếu kiểm kê cần quyền Duyệt kho được cấp trong Phân quyền."
            },
            {
               "role": "DELIVERY / SALES (Giao nhận, Kinh doanh)",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "⚡",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Phiếu giao sửa / xoá khi chưa Đã giao / Hoàn tất chứng từ; phiếu Đang giao không sửa dòng, không xoá; tháng đã chốt công nợ không tạo / sửa được. Quét / gỡ tem thùng cần quyền sửa Giao hàng."
            },
            {
               "role": "Vai trò khác",
               "view": "✅",
               "create": "✅",
               "edit": "⚡",
               "delete": "⚡",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Theo ma trận Phân quyền vai trò do quản trị cấp; thiếu quyền thì nút bị ẩn và máy chủ từ chối."
            }
         ],
         "actionLinks": [
            {
               "from": "IQC vật tư Đạt (tab Chờ nhập kho)",
               "to": "Phiếu nhập kho vật tư",
               "action": "[Nhập Kho NVL]",
               "how": "Tham chiếu = mã biên bản IQC; chốt phiếu cộng số đã nhận vào đơn mua và Kế hoạch vật tư."
            },
            {
               "from": "Phiếu nhập có tham chiếu mã đơn mua",
               "to": "Đơn mua hàng & Kế hoạch vật tư",
               "action": "[Duyệt & Chốt Kho] / Hủy phiếu (Hoàn kho)",
               "how": "Chốt: cộng SL đã nhận, đơn sang Nhận 1 phần / Đã nhận đủ; Hủy: trừ lại."
            },
            {
               "from": "Tab Chờ cấp phát / Lệnh sản xuất › Kế hoạch vật tư",
               "to": "Phiếu xuất kho vật tư",
               "action": "[Xuất Cấp Phát] / [Xuất kho] / [Cấp vật tư]",
               "how": "Phiếu xuất mở sẵn lệnh và vật tư; chốt cộng số đã cấp vào lệnh."
            },
            {
               "from": "Hàng Chờ Nhập Kho TP (từ FQC Đạt)",
               "to": "Xưởng sản xuất › Đóng Gói & Nhập Kho",
               "action": "[Đóng gói & nhập kho]",
               "how": "Mở phiếu đóng gói của lô; hoàn tất đóng gói tự lập phiếu nhập kho thành phẩm."
            },
            {
               "from": "Báo cáo NXT",
               "to": "Sổ kho",
               "action": "Thẻ Kho",
               "how": "Mở Sổ kho đúng mặt hàng và kho."
            },
            {
               "from": "Sổ kho",
               "to": "Phiếu kho gốc",
               "action": "Bấm số chứng từ",
               "how": "Mở trang xem phiếu."
            },
            {
               "from": "Phiếu kho (trang xem)",
               "to": "Kho, NCC, Khách hàng, Lệnh SX, Đơn hàng, Phiếu giao",
               "action": "Bấm link trên thẻ thông tin",
               "how": "Mở thẳng bản ghi gốc."
            },
            {
               "from": "Phiếu kiểm kê được duyệt",
               "to": "Phiếu nhập NK-KK / Phiếu xuất XK-KK",
               "action": "[Duyệt & Cân đối kho]",
               "how": "Mã phiếu cân đối hiện ở cột Phiếu Nhập Cân Đối Thừa / Phiếu Xuất Cân Đối Thiếu."
            },
            {
               "from": "Chờ Xuất Giao / Giao FQC / Đóng gói",
               "to": "Phiếu giao hàng",
               "action": "[Lập phiếu] / [Tạo Phiếu Xuất Giao (n) Lô Đã Chọn] / [Giao Hàng]",
               "how": "Mở form phiếu giao nạp sẵn lô đã đóng gói của cùng một khách."
            },
            {
               "from": "Phiếu giao",
               "to": "Phiếu xuất kho thành phẩm",
               "action": "[Duyệt giao]",
               "how": "Tự lập phiếu xuất đã chốt, xem ở Kho Thành phẩm › Phiếu nhập xuất (trang xem phiếu có link Phiếu giao)."
            },
            {
               "from": "Phiếu giao",
               "to": "Đơn hàng / Phiếu thu / Phiếu nhập hàng trả",
               "action": "[Đơn hàng] / [Lập Phiếu Thu] / [Trả hàng]",
               "how": "Mở đơn bán; lập phiếu thu (chương 15); lập phiếu nhập kho hàng trả đã chốt."
            }
         ],
         "quickActions": [
            {
               "action": "Tìm phiếu kho theo mã hoặc tham chiếu",
               "shortcut": "Ô tìm kiếm trên thanh đầu trang",
               "description": "Lọc danh sách phiếu đang mở."
            },
            {
               "action": "Dán ảnh chứng từ",
               "shortcut": "Ctrl+V trên trang phiếu kho",
               "description": "Ảnh chụp vào mục Tệp đính kèm; chữ chép từ Excel / Word vào đúng ô đang nhập."
            },
            {
               "action": "Thêm nhanh nhà cung cấp",
               "shortcut": "[+ Thêm NCC] cạnh ô Nhà cung cấp",
               "description": "Tạo NCC mới ngay trên phiếu nhập, tạo xong tự chọn (cần quyền tạo NCC)."
            },
            {
               "action": "Thêm nhanh mặt hàng",
               "shortcut": "[Thêm vật tư] / [Thêm thành phẩm] / [Thêm khuôn / bản kẽm / CCDC]",
               "description": "Tạo mặt hàng chưa có trong danh mục và thêm ngay vào phiếu."
            },
            {
               "action": "Mở thẻ kho nhanh",
               "shortcut": "Thẻ Kho trên dòng Báo cáo NXT",
               "description": "Đi thẳng tới Sổ kho của mặt hàng."
            },
            {
               "action": "Quét thùng xếp xe",
               "shortcut": "[Quét thùng] trên phiếu giao",
               "description": "Quét QR tem thùng bằng súng quét hoặc camera."
            },
            {
               "action": "Quét mã khi kiểm kê",
               "shortcut": "[Quét mã] trên phiếu kiểm kê",
               "description": "Quét lại cùng mã cộng thêm 1 vào số thực tế."
            }
         ],
         "inlineViews": [
            {
               "name": "Tồn kho khi xuất",
               "trigger": "Chọn hàng trên phiếu xuất",
               "description": "Hiện Tồn: của kho xuất dưới ô số lượng, báo Thiếu! nếu vượt."
            },
            {
               "name": "Dòng hàng của phiếu giao",
               "trigger": "Mũi tên đầu dòng trên danh sách Giao hàng",
               "description": "Xem SL Đặt, Thực giao, Bù hao, Đơn giá, Thành tiền ngay trên danh sách."
            },
            {
               "name": "Lô thành phẩm sẵn sàng giao",
               "trigger": "[Giao FQC]",
               "description": "Hộp Lô Thành Phẩm Đã Nghiệm Thu FQC (Sẵn Sàng Xuất Giao): chọn một hoặc nhiều lô cùng khách để lập phiếu."
            },
            {
               "name": "Gộp đơn cùng khách",
               "trigger": "[+ Gộp Đơn Hàng] / [Gộp thêm đơn] trên form phiếu giao",
               "description": "Chọn dòng còn phải giao của đơn khác cùng khách để thêm vào phiếu."
            }
         ],
         "forms": [
            {
               "code": "BM-KHO-01",
               "name": "Phiếu Nhập Kho"
            },
            {
               "code": "BM-KHO-02",
               "name": "Phiếu Xuất Kho / Phiếu Xuất Kho Nguyên Vật Liệu Sản Xuất"
            },
            {
               "code": "BM-GH-01",
               "name": "Phiếu Giao Hàng — in có giá / không giá"
            },
            {
               "code": "(không mã)",
               "name": "Biên Bản Kiểm Kê Kho (In / PDF khổ ngang)"
            },
            {
               "code": "(không mã)",
               "name": "Báo cáo Nhập - Xuất - Tồn và Sổ kho (In / PDF, có chữ ký người lập, thủ kho, kế toán)"
            }
         ],
         "notes": [
            "Tồn kho chỉ thay đổi khi phiếu Đã chốt hoặc phiếu kiểm kê được duyệt. Phiếu Nháp và Chờ duyệt chưa ảnh hưởng tồn.",
            "Kho độc lập, không chuyển kho: nhập kho nào xuất kho đó; mỗi mặt hàng chỉ lưu ở một kho. Kho chỉ nhận đúng loại hàng của kho.",
            "Kho Vật tư và Kho Thành phẩm quản theo tổng số lượng, không tách tồn theo lô; số lô vẫn ghi trên phiếu và tem để truy vết.",
            "Thành phẩm nhập kho qua Xưởng sản xuất › Đóng Gói & Nhập Kho, không lập phiếu nhập tay tham chiếu phiếu đóng gói.",
            "Phiếu nhập hàng mua: lập từ tab Chờ nhập kho, hoặc ghi đúng mã đơn mua ở Số chứng từ tham chiếu. Đơn mua chưa duyệt không nhận hàng; không nhận vượt SL đặt + 5%.",
            "Trong lúc kho đang kiểm kê (Đang kiểm kê hoặc Chờ duyệt), mọi lệnh chốt phiếu nhập xuất của kho bị khoá.",
            "Ô Cho phép xuất âm đang bật mặc định cho giai đoạn golive: phiếu xuất vẫn chốt được khi tồn chưa đủ. Muốn kiểm tra chặn tồn âm, quản trị tắt ô này trên kho cần kiểm tra.",
            "Phiếu giao chỉ cho một khách; chỉ lô đã đóng gói nhập kho mới lên phiếu giao; SL giao không vượt SL đặt cộng % bù hao của dòng đơn.",
            "Phiếu giao Đang giao đã trừ kho; lùi về Đã lên lịch hoặc hủy thì hoàn kho đúng một lần. Phiếu Đã giao / Hoàn tất chứng từ khoá sửa, xoá.",
            "Tháng công nợ của khách đã chốt thì không tạo, sửa hay đổi trạng thái phiếu giao có ngày giao trong tháng đó.",
            "Các kho độc lập, không chuyển hàng giữa các kho: nhập kho nào xuất kho đó. Kho đang còn hàng không đổi loại kho được (xuất hết hàng trước).",
            "Phiếu Nháp / Chờ duyệt sửa và xoá được; phiếu Đã chốt chỉ huỷ (hoàn kho)."
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/04_deliveries_clean_nav_and_emdash.png",
               "caption": "Hình 14.1 — Danh sách Giao hàng (/delivery): tab Danh Sách Phiếu Giao / Chờ Xuất Giao, lọc nhanh trạng thái, nút Giao FQC (Nghiệm thu), Xuất Excel, Nhập Excel, Lập phiếu"
            }
         ],
         "uatChecklist": [
            {
               "id": "KHO-14-01",
               "item": "Nhập kho vật tư từ tab Chờ nhập kho (lô IQC Đạt của đơn mua)",
               "standard": "Lô IQC Đạt hiện ở Chờ nhập kho; sau khi chốt, lô rời danh sách, tồn tăng đúng số lượng, đơn mua chuyển Nhận 1 phần hoặc Đã nhận đủ.",
               "method": "1. Mua hàng › ĐH Mua hàng: chọn đơn Đã đặt hàng (VD đặt 1.000 tờ giấy Ivory 300gsm), menu ... › Nhận hàng (IQC), lập biên bản IQC Đạt 1.000.\n2. Kho › Kho Vật tư › Phiếu nhập xuất › tab Chờ nhập kho: thấy dòng biên bản vừa lập.\n3. Bấm [Nhập Kho NVL], kiểm số 1.000, bấm [Lưu].\n4. Mở phiếu, bấm [Duyệt & Chốt Kho] › [Chốt Kho].\n5. Kiểm tra: tab Chờ nhập kho không còn dòng đó; Báo cáo NXT cộng 1.000; đơn mua chuyển Đã nhận đủ."
            },
            {
               "id": "KHO-14-02",
               "item": "Chặn nhập sai loại kho",
               "standard": "Hệ thống không lưu, báo rõ mặt hàng là loại gì và kho chỉ nhận loại hàng gì.",
               "method": "1. Kho › Kho Thành phẩm › Phiếu nhập xuất › [Tạo mới], loại Nhập kho, Kho nhận chọn sẵn kho thành phẩm.\n2. Bấm [Nhập Excel] nạp một dòng mã vật tư giấy (VD mã giấy Ivory) hoặc mở phiếu nhập vật tư cũ đổi kho nhận.\n3. Bấm [Lưu].\n4. Kiểm tra thông báo dạng: ... là vật tư, nhưng Kho thành phẩm chỉ nhận thành phẩm."
            },
            {
               "id": "KHO-14-03",
               "item": "Chặn nhập / xuất mặt hàng đang tồn ở kho khác",
               "standard": "Hệ thống báo Mỗi mặt hàng chỉ lưu ở một kho, ghi rõ kho đang giữ hàng; không có loại phiếu Chuyển kho.",
               "method": "1. Chọn một vật tư đang có tồn ở KHO-VT.\n2. Tạo phiếu nhập cùng vật tư vào một kho vật tư khác (nếu có kho thứ hai cùng loại) › [Lưu].\n3. Kiểm tra thông báo chặn và ô Loại giao dịch chỉ có Nhập kho / Xuất kho."
            },
            {
               "id": "KHO-14-04",
               "item": "Cấp vật tư cho lệnh sản xuất từ Chờ cấp phát",
               "standard": "Phiếu xuất mở sẵn lệnh và vật tư; chốt xong tồn giảm, số đã cấp trên lệnh tăng, dòng rời khỏi Chờ cấp phát khi cấp đủ.",
               "method": "1. Kho › Kho Vật tư › Phiếu nhập xuất › tab Chờ cấp phát, chọn một lệnh (VD LSX-2611-001).\n2. Bấm [Xuất Cấp Phát], kiểm vật tư và số lượng, Tồn: hiện dưới ô số lượng.\n3. [Lưu] › mở phiếu › [Duyệt & Chốt Kho] › [Chốt Kho].\n4. Mở Lệnh sản xuất › tab Kế hoạch vật tư: số đã cấp tăng đúng."
            },
            {
               "id": "KHO-14-05",
               "item": "Chặn xuất vượt tồn khi kho tắt Cho phép xuất âm",
               "standard": "Chốt phiếu bị chặn, thông báo ghi mã hàng, Còn lại, Cần giảm; tồn không xuống dưới 0. Bật lại ô thì chốt được.",
               "method": "1. Quản trị: Kho › Danh mục Kho, sửa kho vật tư thử, bỏ tick Cho phép xuất âm › [Lưu thay đổi].\n2. Tạo phiếu Xuất kho một vật tư tồn 50 với số lượng 80; dòng hiện Thiếu!.\n3. [Lưu] › [Duyệt & Chốt Kho] › [Chốt Kho].\n4. Kiểm tra thông báo không đủ tồn kho. Sau khi thử xong bật lại Cho phép xuất âm."
            },
            {
               "id": "KHO-14-06",
               "item": "Hủy phiếu đã chốt (Hoàn kho)",
               "standard": "Phiếu chuyển Đã hủy, tồn trở về như trước khi chốt; bấm hủy lần nữa báo phiếu đã bị hủy.",
               "method": "1. Trên tab Phiếu kho chọn phiếu nhập vừa chốt ở KHO-14-01.\n2. Bấm biểu tượng Hủy phiếu (Hoàn kho), nhập lý do Nhập sai số lượng.\n3. Kiểm tra Báo cáo NXT trừ lại 1.000, đơn mua trừ lại số đã nhận."
            },
            {
               "id": "KHO-14-07",
               "item": "Báo cáo NXT khớp Sổ kho",
               "standard": "Tồn Cuối Kỳ trên NXT bằng Tồn Lũy Kế dòng cuối trên Sổ kho; Tổng Nhập / Tổng Xuất bằng tổng cột Nhập Kho / Xuất Kho.",
               "method": "1. Kho › Kho Vật tư › Báo cáo NXT, chọn Tháng này, kho KHO-VT.\n2. Ghi Tồn Cuối Kỳ của một vật tư có phát sinh.\n3. Bấm Thẻ Kho trên dòng đó, cùng khoảng ngày.\n4. So sánh số; bấm một số chứng từ để mở phiếu gốc.\n5. Bấm [In / PDF] ở cả hai màn, kiểm bản in có chữ ký."
            },
            {
               "id": "KHO-14-08",
               "item": "Kiểm kê: Gửi duyệt và Duyệt sinh phiếu cân đối",
               "standard": "Dòng lệch thiếu nguyên nhân không gửi được; duyệt xong phiếu Đã chốt & Cân đối, có mã NK-KK và XK-KK, NXT bằng số thực tế, kho mở khoá.",
               "method": "1. Kho › Kho Vật tư › Kiểm kê › [Tạo phiếu], chọn KHO-VT; Sổ sách tự nạp.\n2. Sửa Thực tế: vật tư A thừa 5, vật tư B thiếu 3, chưa ghi nguyên nhân › [Lưu Phiếu Kiểm Kê].\n3. Thử chốt một phiếu xuất của KHO-VT: bị báo kho đang khoá sổ kiểm kê.\n4. Mở phiếu kiểm kê › [Gửi duyệt]: bị báo thiếu nguyên nhân; ghi nguyên nhân rồi gửi lại.\n5. Đăng nhập người có quyền Duyệt kho › [Duyệt & Cân đối kho].\n6. Kiểm tra cột Phiếu Nhập Cân Đối Thừa / Phiếu Xuất Cân Đối Thiếu và Báo cáo NXT."
            },
            {
               "id": "KHO-14-09",
               "item": "Trả lại phiếu kiểm kê và quyền duyệt",
               "standard": "Người không có quyền Duyệt kho không thấy [Duyệt & Cân đối kho] / [Trả lại]; người có quyền trả lại được, phiếu về Đang kiểm kê.",
               "method": "1. Tạo phiếu kiểm kê, [Gửi duyệt].\n2. Đăng nhập tài khoản thủ kho không có quyền Duyệt kho: mở phiếu, không thấy hai nút duyệt.\n3. Đăng nhập tài khoản có quyền › [Trả lại], nhập lý do Đếm lại kệ A.\n4. Phiếu về Đang kiểm kê (Khóa sổ)."
            },
            {
               "id": "KHO-14-10",
               "item": "Thêm vị trí kệ kho",
               "standard": "Báo Đã thêm vị trí kệ kho mới thành công!, dòng mới hiện trong bảng và chọn được ở cột Vị trí lưu trữ của phiếu kho.",
               "method": "1. Kho › Danh mục Kho › tab Vị trí Kệ Kho › [Thêm Vị Trí Kệ Mới].\n2. Kho trực thuộc KHO-VT, Mã KHO-VT-A1, Tên Kệ Giấy Cuộn Dãy A, Dãy A, Tầng 1, Ô 01 › [Tạo Vị Trí Kệ].\n3. Tạo phiếu nhập KHO-VT, mở ô Vị trí lưu trữ: thấy KHO-VT-A1."
            },
            {
               "id": "KHO-14-11",
               "item": "Link chứng từ gốc và tab lịch sử trên trang xem phiếu",
               "standard": "Kho, nhà cung cấp, lệnh SX, phiếu giao trên thẻ thông tin bấm mở đúng bản ghi; có tab Thảo luận & Ghi chú, Tệp đính kèm, Lịch sử cập nhật; thanh tab kho nằm trên mã phiếu.",
               "method": "1. Mở một phiếu xuất cấp phát đã chốt.\n2. Bấm link Lệnh SX, quay lại; bấm link Kho xuất.\n3. Dán một ảnh bằng Ctrl+V: ảnh vào tab Tệp đính kèm.\n4. Mở tab Lịch sử cập nhật xem người lập, người chốt."
            },
            {
               "id": "GH-14-01",
               "item": "Lập phiếu giao từ lô đã đóng gói nhập kho",
               "standard": "Chỉ lô đã đóng gói & nhập kho hiện ở Chờ Xuất Giao / Giao FQC; phiếu lưu ở Đã lên lịch với đúng đơn giá, SL của lô.",
               "method": "1. Xưởng sản xuất › Đóng Gói & Nhập Kho: hoàn tất đóng gói & nhập kho một lô FQC Đạt (VD 5.000 hộp của khách A).\n2. Kinh doanh › Giao hàng › tab Chờ Xuất Giao: thấy dòng lô đó (lô chưa đóng gói không hiện).\n3. Bấm [Lập phiếu] trên dòng, điền tài xế, biển số xe 51C-889.99 › [Lưu].\n4. Kiểm tra trạng thái Đã lên lịch, Tiền hàng, thuế, tổng cộng khác 0."
            },
            {
               "id": "GH-14-02",
               "item": "Chỉ gom phiếu giao khi cùng khách hàng",
               "standard": "Chọn lô của 2 khách thì hiện cảnh báo, không mở phiếu; thêm dòng đơn của khách khác vào phiếu thì không lưu được.",
               "method": "1. Giao hàng › tab Chờ Xuất Giao: tick 1 dòng khách A và 1 dòng khách B: thấy Chỉ chọn các mặt hàng của cùng 1 khách hàng!, không có nút lập phiếu.\n2. [Giao FQC]: tick 2 lô của 2 khách › [Tạo Phiếu Xuất Giao (2) Lô Đã Chọn]: báo Chỉ gom phiếu giao khi cùng khách hàng.\n3. Tick 2 lô cùng khách A: mở được form phiếu giao."
            },
            {
               "id": "GH-14-03",
               "item": "Chặn giao vượt số lượng cho phép",
               "standard": "Lưu bị chặn, thông báo ghi Tối đa và Đang xuất; dòng bù hao 0% không giao quá SL đặt.",
               "method": "1. Chọn đơn khách A: dòng đặt 5.000, bù hao 0%, đã có phiếu giao mở 3.000.\n2. Lập phiếu giao mới cho dòng đó với SL 2.500 › [Lưu].\n3. Kiểm tra thông báo vượt quá số lượng cho phép (Tối đa 2.000)."
            },
            {
               "id": "GH-14-04",
               "item": "Duyệt giao trừ kho và hoàn kho khi lùi trạng thái",
               "standard": "[Duyệt giao] chuyển Đang giao và sinh phiếu xuất kho thành phẩm đã chốt; lùi về Đã lên lịch thì phiếu xuất bị hủy, tồn trở lại đúng một lần.",
               "method": "1. Mở phiếu ở GH-14-01 › [Duyệt giao] › xác nhận.\n2. Kho › Kho Thành phẩm › Phiếu nhập xuất: thấy phiếu xuất đã chốt có link Phiếu giao; NXT trừ 5.000.\n3. Thử Hủy phiếu (Hoàn kho) phiếu xuất này ở kho: bị báo phải hủy qua phiếu giao.\n4. Trên phiếu giao bấm bước Đã lên lịch › xác nhận: NXT cộng lại 5.000.\n5. [Duyệt giao] lại, rồi bấm bước Đã giao: đơn hàng cộng SL đã giao."
            },
            {
               "id": "GH-14-05",
               "item": "In phiếu giao và thanh trạng thái",
               "standard": "[In có giá] / [In không giá] ra Phiếu giao hàng BM-GH-01 đúng khách, đơn, số lượng; thanh trạng thái chỉ cho bấm bước hợp lệ, phiếu Đã giao hiện nhãn Đã Khóa Sổ Bất Biến, không còn [Sửa] / [Xoá].",
               "method": "1. Mở phiếu Đã giao ở GH-14-04.\n2. Bấm [In có giá], rồi [In không giá]; kiểm bản in không có đơn giá ở bản không giá.\n3. Kiểm tra không có nút [Sửa], [Xoá]; bước Bản nháp không bấm được.\n4. Bấm link khách hàng trên thẻ thông tin mở hồ sơ khách; bấm [Đơn hàng] mở đơn bán."
            },
            {
               "id": "GH-14-06",
               "item": "Màn hình điện thoại 390px (kho và giao hàng)",
               "standard": "Không tràn ngang trang; thanh tab kho cuộn ngang được; bảng kéo ngang được; nút chính hiện đủ; mã phiếu trên đầu trang hiện đủ.",
               "method": "1. Mở trình duyệt trên điện thoại (hoặc thu cửa sổ rộng 390px).\n2. Mở Kho › Kho Vật tư › Phiếu nhập xuất, chuyển các tab Chờ nhập kho, Báo cáo NXT, Kiểm kê.\n3. Mở một phiếu kho và một phiếu giao; kiểm nút [Duyệt & Chốt Kho], [Duyệt giao], [Quét thùng] bấm được."
            },
            {
               "id": "KHO-14-12",
               "item": "Kho Kỹ thuật chỉ nhận hàng kỹ thuật",
               "standard": "Phiếu nhập khuôn vào Kho Kỹ thuật chốt được, tồn tăng; chọn vật tư giấy cho Kho Kỹ thuật bị từ chối.",
               "method": "Kho › Kho Kỹ thuật › [Tạo mới] Nhập kho 1 khuôn → [Lưu] → mở phiếu → [Duyệt & Chốt Kho]. Thử lập phiếu chọn vật tư giấy."
            },
            {
               "id": "KHO-14-13",
               "item": "Lô IQC không nhập kho hai lần",
               "standard": "Phiếu nhập thứ hai cho cùng lô không chốt được, báo phiếu đã nhập trước.",
               "method": "Chốt nhập một lô IQC; lập phiếu nhập khác cho cùng lô và bấm chốt."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "Thủ kho vật tư (WAREHOUSE) — Chương 14",
               "createTest": "Tab Chờ nhập kho › [Nhập Kho NVL] › [Lưu]; [Tạo mới] phiếu xuất cho lệnh; Kiểm kê › [Tạo phiếu] › [Lưu Phiếu Kiểm Kê]; Danh mục Kho › Vị trí Kệ Kho › [Thêm Vị Trí Kệ Mới].",
               "readTest": "Xem Báo cáo NXT, Sổ kho, mở trang xem phiếu kho, bấm link Lệnh SX / Nhà cung cấp, xem tab Lịch sử cập nhật.",
               "updateTest": "Sửa phiếu Chờ duyệt rồi [Duyệt & Chốt Kho]; [Sửa kiểm đếm] phiếu kiểm kê rồi [Gửi duyệt].",
               "deleteTest": "Xoá phiếu Nháp; Hủy phiếu (Hoàn kho) phiếu đã chốt; xoá phiếu kiểm kê Đang kiểm kê.",
               "expectedResult": "Tồn chỉ đổi khi chốt / hủy; phiếu sai loại kho hoặc hàng ở kho khác bị chặn; không thấy nút duyệt kiểm kê nếu chưa có quyền Duyệt kho."
            },
            {
               "roleGroup": "Người duyệt kho (quyền Duyệt kho) — Chương 14",
               "createTest": "—",
               "readTest": "Lọc Kiểm kê theo Chờ duyệt, mở phiếu xem chênh lệch, nguyên nhân.",
               "updateTest": "[Duyệt & Cân đối kho] một phiếu; [Trả lại] kèm lý do một phiếu khác.",
               "deleteTest": "[Hủy phiếu] kiểm kê đang Chờ duyệt.",
               "expectedResult": "Duyệt sinh NK-KK / XK-KK, NXT bằng thực tế, kho mở khoá; trả lại đưa phiếu về Đang kiểm kê."
            },
            {
               "roleGroup": "Giao Hàng / Điều Vận (DELIVERY) — Chương 14",
               "createTest": "Giao hàng › tab Chờ Xuất Giao › [Lập phiếu] › [Lưu]; [Giao FQC] chọn 2 lô cùng khách.",
               "readTest": "Xem danh sách phiếu giao, bung dòng hàng, mở chi tiết, xem thùng đã quét.",
               "updateTest": "[Quét thùng], [Duyệt giao], bước Đã giao; [Vị trí xe] sửa địa chỉ khi Đã lên lịch.",
               "deleteTest": "[Xoá] phiếu Bản nháp; thử xoá phiếu Đang giao (bị chặn).",
               "expectedResult": "Chỉ gom lô cùng khách; không giao vượt SL cho phép; Đang giao trừ kho thành phẩm, lùi trạng thái hoàn kho đúng một lần; phiếu Đã giao bị khoá."
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 15. Tài Chính Kế Toán: Thu Chi, Công Nợ Phải Thu/Phải Trả & Đối Soát
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "finance_system",
         "aliases": [
            "finance",
            "receipts",
            "cashbook",
            "debts",
            "ar",
            "ap",
            "ar-aging",
            "reconciliations",
            "sales-debts",
            "vendor-debts",
            "reports-sales"
         ],
         "title": "15. Tài Chính Kế Toán: Thu Chi, Công Nợ Phải Thu/Phải Trả & Đối Soát",
         "icon": "Banknote",
         "isoRef": "QT-TC-01",
         "purpose": "Hướng dẫn ghi nhận dòng tiền vào Sổ quỹ (Phiếu thu / Phiếu chi tại /finance/receipts), theo dõi Công nợ phải thu khách hàng (/debts) và Công nợ phải trả nhà cung cấp gia công (/purchasing/debts), xem Sổ chi tiết công nợ từng đối tác, và đối soát - chốt sổ công nợ theo tháng (/finance/reconciliations) để in Biên bản đối chiếu gửi khách hàng hoặc nhà cung cấp ký xác nhận. Số dư công nợ không nhập tay: hệ thống tự tính từ Phiếu giao hàng đã giao và Phiếu thu đã xác nhận (phải thu), từ Nghiệm thu hàng gia công (phải trả).",
         "scope": [
            "Kế toán (ACCOUNTANT): lập, sửa, xoá Phiếu thu / Phiếu chi; theo dõi Công nợ KH, Công nợ NCC; in Biên bản đối soát và Báo cáo tổng hợp công nợ; chốt sổ kỳ đối soát nếu được cấp quyền Duyệt (approve) ở phân hệ Tài chính.",
            "Ban Giám đốc (DIRECTOR) và Quản trị viên (ADMIN): xem toàn bộ, chốt sổ kỳ đối soát, xem bản nháp của mọi người.",
            "Kinh doanh và Giao nhận: lập phiếu thu nhanh ngay từ Đơn hàng (tab Quyết toán & P&L) hoặc từ Phiếu giao hàng đã xuất/đã giao.",
            "Menu Tài Chính gồm: Thu chi & Sổ quỹ (/finance/receipts), Công nợ KH (/debts), Công nợ NCC (/purchasing/debts), Đối soát công nợ (/finance/reconciliations), Báo cáo Bán hàng (/reports/sales). Mỗi mục chỉ hiện với người có quyền Xem của phân hệ tương ứng (receipts, debts, reports).",
            "Phân quyền Nhân sự (/users), Vai trò (/roles) và cấu hình hệ thống được hướng dẫn ở chương Quản trị hệ thống, không thuộc chương này."
         ],
         "references": [
            "ISO 9001:2015 mục 7.5 — Thông tin dạng văn bản (lưu Phiếu thu/chi, Biên bản đối soát làm hồ sơ).",
            "ISO 9001:2015 mục 8.2.1 — Trao đổi thông tin với khách hàng (đối chiếu, xác nhận công nợ).",
            "ISO 9001:2015 mục 8.4 — Kiểm soát nhà cung cấp bên ngoài (công nợ gia công ngoài).",
            "Chương 14 — Giao hàng (phát sinh công nợ phải thu); chương 13 — Mua hàng & Gia công ngoài (Nghiệm thu hàng gia công phát sinh công nợ phải trả)."
         ],
         "terms": [
            {
               "term": "Phiếu thu (Thu) / Phiếu chi (Chi)",
               "definition": "Chứng từ sổ quỹ. Mã tự sinh dạng PT-năm-số (thu) hoặc PC-năm-số (chi); phiếu thu nhanh từ đơn hàng / phiếu giao có mã dạng PT + ngày + số."
            },
            {
               "term": "Hình thức",
               "definition": "Tiền mặt, Chuyển khoản hoặc Cấn trừ. Thẻ Quỹ Tiền Mặt tính các phiếu Tiền mặt; Quỹ Ngân Hàng tính phần còn lại."
            },
            {
               "term": "Công nợ phải thu (AR)",
               "definition": "Nợ hiện tại của khách hàng = Nợ ban đầu khai báo trên khách hàng + tổng tiền các Phiếu giao hàng ở trạng thái Đã giao / Hoàn thành − tổng các Phiếu thu (loại Thu) ở trạng thái Đã xác nhận / Hoàn thành. Hệ thống tính lại mỗi khi lưu, sửa, xoá phiếu thu hoặc phiếu giao."
            },
            {
               "term": "Công nợ phải trả (AP)",
               "definition": "Nợ nhà cung cấp gia công: tăng khi bấm [Nghiệm Thu Hàng] trên Đơn gia công (số lượng đạt × đơn giá), giảm khi có tiền đền bù phế phẩm khấu trừ cho nhà cung cấp, hoặc khi có khoản thanh toán cho nhà cung cấp được ghi nhận."
            },
            {
               "term": "Kỳ đối soát",
               "definition": "Bản ghi theo từng khách hàng / nhà cung cấp và từng tháng (mã DS-mã KH-năm tháng) gồm Dư nợ đầu kỳ, Phát sinh tăng, Đã thanh toán, Dư nợ cuối kỳ. Hệ thống tự tạo và cập nhật khi có giao hàng / thu tiền / nghiệm thu trong tháng."
            },
            {
               "term": "Chốt sổ",
               "definition": "Khoá kỳ đối soát (trạng thái Đã xác nhận). Kỳ đã chốt không còn tự cập nhật số liệu, và không thể tạo, sửa hoặc đổi trạng thái Phiếu giao hàng có ngày giao thuộc tháng đó."
            },
            {
               "term": "Bản nháp",
               "definition": "Phiếu thu/chi bấm [Lưu nháp]: chỉ người tạo, Admin và Giám đốc thấy; chưa tính vào công nợ."
            },
            {
               "term": "Phạm vi dữ liệu / Phạm vi tài chính",
               "definition": "Cấu hình trên vai trò cho phân hệ receipts: Phạm vi dữ liệu giới hạn danh sách phiếu theo người tạo / nhóm / tất cả; Phạm vi tài chính có thể ẩn cột Số tiền với người không được xem."
            }
         ],
         "responsibilities": [
            {
               "role": "Kế toán (ACCOUNTANT)",
               "tasks": [
                  "Lập Phiếu thu khi nhận tiền khách hàng, Phiếu chi khi chi tiền, đính kèm chứng từ (hoá đơn, uỷ nhiệm chi, biên nhận).",
                  "Cuối tháng mở Đối soát công nợ, kiểm tra số liệu, in Biên bản đối chiếu gửi đối tác ký.",
                  "Theo dõi khách hàng Đang nợ / Vượt hạn mức trên Công nợ KH."
               ]
            },
            {
               "role": "Kế toán trưởng / Giám đốc (người có quyền Duyệt phân hệ Tài chính)",
               "tasks": [
                  "Bấm [Chốt sổ] / [Chốt sổ] sau khi khách hàng xác nhận công nợ.",
                  "Kiểm tra Báo Cáo Tổng Hợp Công Nợ (BM-TC-02)."
               ]
            },
            {
               "role": "Kinh doanh / Giao nhận",
               "tasks": [
                  "Thu tiền tại chỗ: bấm [Lập Phiếu Thu] trên Phiếu giao hàng hoặc [+ Lập Phiếu Thu] trong tab Quyết toán & P&L của Đơn hàng.",
                  "Đảm bảo Phiếu giao hàng được chuyển Đã giao để công nợ phải thu phát sinh đúng."
               ]
            },
            {
               "role": "Mua hàng / Gia công",
               "tasks": [
                  "Nghiệm thu hàng gia công đúng số lượng đạt và tiền đền bù để công nợ phải trả nhà cung cấp chính xác."
               ]
            }
         ],
         "processFlowchart": "graph TD\n    A[Phiếu giao hàng chuyển Đã giao] --> B[Tự động tăng Công nợ phải thu]\n    B --> C{Thu tiền}\n    C -->|Từ phiếu giao hoặc đơn hàng| D[Lập Phiếu Thu nhanh - Hoàn thành]\n    C -->|Tại Thu chi và Sổ quỹ| E[Tạo phiếu thu chi]\n    E -->|Lưu nháp| F[Bản nháp - chưa tính công nợ]\n    F -->|Lưu| G[Đã xác nhận]\n    E -->|Lưu| G\n    D --> H[Tự động giảm Công nợ phải thu]\n    G --> H\n    H --> I[Kỳ đối soát tháng tự cập nhật]\n    J[Nghiệm thu hàng gia công] --> K[Tự động tăng Công nợ phải trả NCC]\n    K --> I\n    I --> L[In Biên bản đối chiếu công nợ]\n    L --> M{Đối tác xác nhận}\n    M -->|Đồng ý| N[Chốt sổ - khoá kỳ]\n    M -->|Chưa khớp| O[Rà soát phiếu giao và phiếu thu trong kỳ]\n    O --> I",
         "mainFlow": [
            {
               "step": 1,
               "action": "Xem Sổ quỹ Thu chi (/finance/receipts)",
               "detail": "• Vào `Tài Chính -> Thu chi & Sổ quỹ (/finance/receipts)`.\n• Bốn thẻ đầu trang: **Tổng Tồn Quỹ**, **Quỹ Tiền Mặt**, **Quỹ Ngân Hàng**, **Số Dư Ròng Trong Kỳ** — tính theo các phiếu đang lọc.\n• Bộ lọc thời gian bên trái thanh công cụ; nút nhóm theo ngày bật/tắt nhóm phiếu theo ngày, mỗi nhóm hiện Tổng Thu, Tổng Chi và dòng tiền ròng trong ngày.\n• Bộ lọc cột: Mã phiếu, Khách hàng, Ngày, Loại phiếu (Thu/Chi), Phương thức (Tiền mặt / Chuyển khoản / Cấn trừ), Trạng thái. Tìm nhanh bằng ô tìm kiếm chung trên header (theo mã phiếu, số tham chiếu, ghi chú, tên khách hàng).\n• Bấm một dòng để mở chi tiết phiếu."
            },
            {
               "step": 2,
               "action": "Tạo Phiếu thu / Phiếu chi — [Lưu nháp] và [Lưu]",
               "detail": "• Bấm `[Tạo Thu Chi]` (/finance/receipts/create).\n• Khối **Phân loại**: Loại phiếu* (Thu / Chi), Hạng mục (Thu tiền hàng / Đặt cọc / Hoàn tiền / Khác), Từ quy trình (Từ đơn hàng / Từ báo giá / Khác).\n• Khối **Thông tin thu**: Đối tượng (Khách hàng)*, Số tiền*, Ngày thu*, Hình thức* (Tiền mặt / Chuyển khoản / Cấn trừ), Số tham chiếu (số giao dịch ngân hàng, mã đơn hàng...), Ghi chú / Lý do (có nút điền nhanh như Thanh toán đủ, Đặt cọc đơn hàng, Thanh toán đợt 1...).\n• Khối **Chứng từ đính kèm**: tải tệp lên hoặc dán URL rồi bấm `[Thêm URL]`.\n• Bên dưới form hiện công nợ hiện tại của khách hàng đã chọn để đối chiếu.\n• Bấm `[Lưu nháp]` để ghi tạm (bắt buộc đã chọn khách hàng): phiếu ở **Bản nháp**, chỉ người tạo, Admin, Giám đốc thấy, chưa tính vào công nợ.\n• Bấm `[Lưu]` để kiểm tra đủ thông tin và chuyển phiếu sang **Đã xác nhận** — công nợ khách hàng và kỳ đối soát tháng hiện tại được tính lại ngay.\n• Bấm `[Huỷ]` để quay lại danh sách không lưu."
            },
            {
               "step": 3,
               "action": "Thu tiền nhanh từ Phiếu giao hàng hoặc Đơn hàng",
               "detail": "• Trên chi tiết Phiếu giao hàng ở trạng thái Đang giao / Đã giao / Hoàn thành: bấm `[Lập Phiếu Thu]`.\n• Trên chi tiết Đơn hàng, tab **Quyết toán & P&L**, khi còn số tiền phải thu: bấm `[+ Lập Phiếu Thu]`.\n• Hộp thoại **Lập Phiếu Thu Nhanh (1-Chạm)**: nhập số tiền (> 0), chọn hình thức, số tham chiếu, ghi chú rồi bấm `[Xác Nhận Thu ... đ]`.\n• Phiếu được tạo ngay ở trạng thái **Hoàn thành**, trừ công nợ khách hàng và cập nhật tình trạng thanh toán của đơn hàng (Chưa TT / TT 1 phần / Đã TT)."
            },
            {
               "step": 4,
               "action": "Theo dõi Công nợ khách hàng (/debts) và Sổ chi tiết",
               "detail": "• Vào `Tài Chính -> Công nợ KH (/debts)`. Chọn **Kỳ đối soát** (tháng) trên thanh lọc.\n• Bảng: Khách hàng, Nợ đầu kỳ, Phát sinh (+/–), Đã thanh toán, Nợ hiện tại, Hạn mức, Trạng thái (Vượt hạn mức / Đang nợ / Tốt), Hành động. Danh sách xếp theo nợ giảm dần; chip lọc nhanh **Đang nợ**, **Vượt hạn mức**.\n• Bấm `[Sổ cái]` trên dòng (trên điện thoại: `[Sổ cái công nợ]`) để mở **Sổ chi tiết công nợ** (/finance/ar/ledger/mã): chọn khoảng ngày, xem Dư nợ đầu kỳ, Ghi nợ (Bán hàng) từ từng phiếu giao, Ghi có (Thu tiền) từ từng phiếu thu, số dư lũy kế; bấm `[In sổ]` để in.\n• Bấm tên khách hàng để mở hồ sơ khách hàng. `[Xuất Excel]` xuất bảng công nợ đang lọc."
            },
            {
               "step": 5,
               "action": "Theo dõi Công nợ nhà cung cấp (/purchasing/debts)",
               "detail": "• Vào `Tài Chính -> Công nợ NCC (/purchasing/debts)`, chọn **Kỳ đối soát**, lọc **Tất cả** / **Đang nợ**.\n• Bấm `[Sổ cái]` để mở **Sổ chi tiết công nợ** nhà cung cấp (/finance/ap/ledger/mã): Phát sinh nợ (Mua hàng / Gia công) lấy từ các lần nghiệm thu hàng gia công, Phát sinh có (Đã thanh toán) từ các khoản thanh toán cho nhà cung cấp.\n• Tick chọn các dòng phát sinh rồi bấm `[In Đối Soát (n)]` để in Biên bản đối soát công nợ NCC cho các dòng đã chọn."
            },
            {
               "step": 6,
               "action": "Đối soát & chốt sổ công nợ hằng tháng (/finance/reconciliations)",
               "detail": "• Vào `Tài Chính -> Đối soát công nợ (/finance/reconciliations)`. Chuyển giữa `[Khách Hàng (Phải Thu AR)]` và `[Nhà Cung Cấp (Phải Trả AP)]`.\n• Bảng: Kỳ đối soát, Đối tác, Dư nợ đầu kỳ, Giao hàng (+) hoặc Mua hàng/Gia công (+), Đã thu tiền (-) hoặc Đã thanh toán (-), Dư nợ cuối kỳ, Trạng thái (Chờ xác nhận / Đã xác nhận). Lọc theo Tháng, Năm, Trạng thái.\n• Bấm một dòng khách hàng để mở cửa sổ chi tiết kỳ: 4 ô Nợ Đầu Kỳ / Giao Hàng (+) / Đã Thu (-) / Nợ Cuối Kỳ và 3 tab **Phiếu Giao Hàng**, **Phiếu Thu Tiền**, **Bảng Kê Sổ Cái**.\n• Bấm `[In BB]` (trên dòng) hoặc `[In biên bản]` (trong cửa sổ chi tiết) để mở trang **Xem trước bản in** Biên bản đối chiếu và xác nhận công nợ (2 bản, có chỗ ký hai bên), bấm `[In Biên Bản]`.\n• Khi đối tác đã ký xác nhận, người có quyền Duyệt phân hệ Tài chính bấm `[Chốt sổ]` (trên dòng) hoặc `[Chốt sổ]` (trong cửa sổ chi tiết). Kỳ chuyển **Đã xác nhận / Đã Khóa Sổ**.\n• Bấm `[In Công Nợ]` (tab Khách hàng) để in báo cáo tổng hợp công nợ toàn bộ khách hàng theo khoảng Từ - Đến, tuỳ chọn Hiện chi tiết giao dịch, khổ giấy Ngang / Đứng, hoặc `[Xuất Excel]`."
            }
         ],
         "subFlows": [
            {
               "name": "Phiếu thu/chi — Xem chi tiết (/finance/receipts/$id)",
               "steps": [
                  "Bấm dòng phiếu trên danh sách.",
                  "Xem Mã phiếu, Khách hàng, Số tiền, Ngày thu, Phương thức TT, Số tham chiếu, Loại phiếu, Ghi chú và trạng thái.",
                  "Nút trên đầu trang: [Sổ cái công nợ] (mở sổ chi tiết công nợ của khách hàng), [In phiếu], [Sửa], [Xoá]."
               ]
            },
            {
               "name": "Phiếu thu/chi — Sửa",
               "steps": [
                  "Trên chi tiết phiếu bấm [Sửa] (/finance/receipts/$id/edit).",
                  "Phiếu đang Bản nháp: có [Lưu nháp] và [Lưu]; bấm [Lưu] để chuyển sang Đã xác nhận.",
                  "Phiếu đã xác nhận: chỉ có nút [Cập nhật]; trạng thái giữ nguyên, công nợ được tính lại theo số tiền mới."
               ]
            },
            {
               "name": "Phiếu thu/chi — Xoá đơn lẻ",
               "steps": [
                  "Trên chi tiết phiếu bấm [Xoá], xác nhận [Xoá phiếu thu] trong hộp thoại.",
                  "Phiếu chuyển vào Thùng rác (khôi phục được tại /trash), công nợ khách hàng được tính lại ngay."
               ]
            },
            {
               "name": "Phiếu thu/chi — Xoá hàng loạt và Xuất Excel",
               "steps": [
                  "Trên danh sách chọn nhiều phiếu (nhấn giữ một dòng để bật chế độ chọn rồi tick các dòng), thanh thao tác hàng loạt hiện ở dưới.",
                  "Bấm [Xoá] → xác nhận để xoá các phiếu đã chọn; hoặc [Xuất Excel] để xuất riêng các phiếu đã chọn.",
                  "Không chọn dòng nào: nút [Xuất Excel] trên thanh công cụ xuất toàn bộ phiếu theo bộ lọc hiện tại (cột Mã phiếu, Loại, Ngày, Khách hàng, Số tiền, Phương thức, Số tham chiếu, Ghi chú, Trạng thái)."
               ]
            },
            {
               "name": "Phiếu thu/chi — In",
               "steps": [
                  "Trên chi tiết phiếu bấm [In phiếu].",
                  "Mẫu in tự đổi tiêu đề PHIẾU THU (Receipt Voucher) hoặc PHIẾU CHI (Payment Voucher) theo loại phiếu, có thông tin pháp nhân công ty ở đầu trang."
               ]
            },
            {
               "name": "Công nợ KH (/debts) — Xem, lọc, xuất",
               "steps": [
                  "Chọn tháng ở ô Kỳ đối soát.",
                  "Lọc chip Đang nợ / Vượt hạn mức hoặc bộ lọc cột Khách hàng, Trạng thái.",
                  "Bấm [Sổ cái] để xem sổ chi tiết; [Xuất Excel] để xuất (Mã, Tên, Nợ đầu kỳ, Phát sinh, Đã thanh toán, Nợ hiện tại, Hạn mức tín dụng).",
                  "Màn hình chỉ xem: không thêm/sửa/xoá công nợ trực tiếp. Muốn thay đổi số dư thì sửa chứng từ gốc (phiếu giao, phiếu thu) hoặc Nợ ban đầu trên hồ sơ khách hàng."
               ]
            },
            {
               "name": "Sổ chi tiết công nợ phải thu (/finance/ar/ledger/$id)",
               "steps": [
                  "Mở từ [Sổ cái] trên Công nợ KH, [Sổ chi tiết] trên /finance/ar, hoặc [Sổ cái công nợ] trên phiếu thu.",
                  "Chọn khoảng ngày ở ô chọn ngày; dư nợ đầu kỳ lấy từ kỳ đối soát của tháng bắt đầu (nếu có) hoặc tính từ các chứng từ trước ngày bắt đầu.",
                  "Bấm [In sổ] để in sổ chi tiết công nợ phải thu."
               ]
            },
            {
               "name": "Công nợ NCC (/purchasing/debts) và Sổ chi tiết NCC (/finance/ap/ledger/$id)",
               "steps": [
                  "Chọn Kỳ đối soát, lọc Tất cả / Đang nợ, [Xuất Excel] để xuất danh sách.",
                  "Bấm [Sổ cái] mở sổ chi tiết; chọn khoảng ngày; tick các dòng phát sinh; bấm [In Đối Soát (n)].",
                  "Màn hình chỉ xem: công nợ NCC phát sinh từ nghiệm thu hàng gia công, không nhập tay."
               ]
            },
            {
               "name": "Đối soát công nợ — Xem chi tiết kỳ, In, Chốt sổ",
               "steps": [
                  "Tại /finance/reconciliations chọn tab Khách Hàng hoặc Nhà Cung Cấp, lọc Tháng / Năm / Trạng thái.",
                  "Khách hàng: bấm dòng để mở chi tiết kỳ với 3 tab Phiếu Giao Hàng, Phiếu Thu Tiền, Bảng Kê Sổ Cái; bấm [Đóng] để quay lại.",
                  "[In BB] mở trang in Biên bản đối chiếu (/finance/ar/reconciliations/$id/print hoặc /finance/ap/reconciliations/$id/print) trong tab mới, bấm [In Biên Bản].",
                  "[Chốt sổ] chỉ hiện ở kỳ khách hàng chưa chốt và với người có quyền Duyệt phân hệ Tài chính; người không có quyền thấy thông báo chỉ Kế Toán Trưởng hoặc Giám Đốc mới được chốt.",
                  "[Xuất Excel] xuất danh sách kỳ đối soát (Kỳ, Mã/Tên đối tác, Dư nợ đầu kỳ, Phát sinh tăng, Đã thanh toán, Dư nợ cuối kỳ, Trạng thái)."
               ]
            },
            {
               "name": "Báo cáo Tổng hợp Công nợ khách hàng (BM-TC-02)",
               "steps": [
                  "Bấm [In Công Nợ] tại /finance/reconciliations (tab Khách hàng) hoặc tại /finance/ar.",
                  "Chọn Từ - Đến, bật Hiện chi tiết giao dịch nếu cần, chọn Khổ giấy.",
                  "In trực tiếp hoặc bấm [Xuất Excel] trong cửa sổ in."
               ]
            },
            {
               "name": "Báo cáo Bán hàng (/reports/sales)",
               "steps": [
                  "Mục cuối của menu Tài Chính mở trang Báo cáo quản trị ở nhóm bán hàng; xem hướng dẫn chi tiết ở chương Báo cáo quản trị."
               ]
            },
            {
               "name": "Sửa phiếu thu — In",
               "steps": [
                  "[In] trên màn sửa phiếu thu: mở bản xem trước phiếu thu theo dữ liệu đã lưu (phần đang sửa chưa lưu sẽ không có trên bản in), bấm [In Ngay] hoặc [Tải PDF]."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "(Mới)",
               "to": "Bản nháp",
               "action": "Bấm [Lưu nháp] trên form phiếu thu/chi (đã chọn khách hàng)",
               "allowedRoles": "Người được vào Thu chi & Sổ quỹ"
            },
            {
               "from": "(Mới) hoặc Bản nháp",
               "to": "Đã xác nhận",
               "action": "Bấm [Lưu] — tính vào công nợ ngay",
               "allowedRoles": "Người được vào Thu chi & Sổ quỹ; bản nháp chỉ người tạo, Admin, Giám đốc mở được"
            },
            {
               "from": "(Mới)",
               "to": "Hoàn thành",
               "action": "Bấm [Xác Nhận Thu ... đ] trong hộp thoại Lập Phiếu Thu Nhanh từ Phiếu giao hàng hoặc Đơn hàng",
               "allowedRoles": "Người mở được Phiếu giao hàng / Đơn hàng"
            },
            {
               "from": "Bản nháp / Đã xác nhận / Hoàn thành",
               "to": "Thùng rác",
               "action": "Bấm [Xoá] trên chi tiết hoặc xoá hàng loạt — công nợ tính lại",
               "allowedRoles": "Người được vào Thu chi & Sổ quỹ"
            },
            {
               "from": "Kỳ đối soát khách hàng: Chờ xác nhận",
               "to": "Đã xác nhận (Đã Khóa Sổ)",
               "action": "Bấm [Chốt sổ] ở dòng kỳ, chọn nhiều kỳ rồi [Chốt sổ] trên thanh chọn, hoặc [Chốt sổ] trong hộp chi tiết kỳ. Kỳ đối soát nhà cung cấp hiện chưa có chốt sổ.",
               "allowedRoles": "Admin, Giám đốc và vai trò có quyền Duyệt (approve) phân hệ Tài chính"
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN / DIRECTOR",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền; thấy bản nháp của mọi người; chốt sổ kỳ đối soát."
            },
            {
               "role": "ACCOUNTANT (Kế toán)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Giai đoạn Go-Live mọi vai trò nghiệp vụ được mở đủ quyền cho receipts, debts, reconciliations, finance. Quản trị có thể tắt quyền Duyệt (approve) phân hệ Tài chính để chỉ Kế toán trưởng / Giám đốc chốt sổ."
            },
            {
               "role": "Các vai trò nghiệp vụ khác (SALES, DELIVERY, WAREHOUSE...)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Mặc định Go-Live mở đủ quyền; Phạm vi dữ liệu của phân hệ receipts quyết định thấy phiếu của mình, của nhóm hay tất cả; Phạm vi tài chính có thể ẩn Số tiền; bản nháp của người khác không hiển thị."
            }
         ],
         "actionLinks": [
            {
               "from": "Phiếu giao hàng (/delivery/$id)",
               "to": "Phiếu thu",
               "action": "[Lập Phiếu Thu]",
               "how": "Hiện khi phiếu giao Đang giao / Đã giao / Hoàn thành; phiếu thu tạo ở Hoàn thành, số tham chiếu mặc định là mã phiếu giao."
            },
            {
               "from": "Đơn hàng — tab Quyết toán & P&L",
               "to": "Phiếu thu",
               "action": "[+ Lập Phiếu Thu]",
               "how": "Hiện khi đơn còn số tiền phải thu; cập nhật tình trạng thanh toán của đơn."
            },
            {
               "from": "Phiếu thu (/finance/receipts/$id)",
               "to": "Sổ chi tiết công nợ phải thu",
               "action": "[Sổ cái công nợ]",
               "how": "Mở /finance/ar/ledger của khách hàng trên phiếu."
            },
            {
               "from": "Công nợ KH (/debts)",
               "to": "Sổ chi tiết công nợ / Hồ sơ khách hàng",
               "action": "[Sổ cái] / bấm tên khách hàng",
               "how": "Mở /finance/ar/ledger/$id hoặc /customers/$id."
            },
            {
               "from": "Công nợ NCC (/purchasing/debts)",
               "to": "Sổ chi tiết công nợ NCC",
               "action": "[Sổ cái]",
               "how": "Mở /finance/ap/ledger/$id."
            },
            {
               "from": "Đơn gia công (/outsource-orders/$id)",
               "to": "Công nợ NCC",
               "action": "[Nghiệm Thu Hàng]",
               "how": "Số lượng đạt × đơn giá cộng vào công nợ phải trả; tiền đền bù phế phẩm trừ vào công nợ."
            },
            {
               "from": "Đối soát công nợ (/finance/reconciliations)",
               "to": "Trang in Biên bản",
               "action": "[In BB] / [In biên bản]",
               "how": "Mở trang Xem trước bản in trong tab mới."
            }
         ],
         "quickActions": [
            {
               "action": "Tạo phiếu thu / chi",
               "description": "Nút [Tạo Thu Chi] trên Thu chi & Sổ quỹ."
            },
            {
               "action": "Thu tiền 1 chạm",
               "description": "[Lập Phiếu Thu] trên Phiếu giao hàng, [+ Lập Phiếu Thu] trên Đơn hàng."
            },
            {
               "action": "Tìm phiếu",
               "description": "Ô tìm kiếm chung trên header: theo mã phiếu, số tham chiếu, ghi chú, tên khách hàng."
            },
            {
               "action": "Nhóm theo ngày",
               "description": "Nút bật/tắt nhóm phiếu theo ngày trên Thu chi & Sổ quỹ, mỗi nhóm có Tổng Thu / Tổng Chi / ròng trong ngày."
            },
            {
               "action": "Mở sổ chi tiết công nợ",
               "description": "[Sổ cái] trên Công nợ KH / Công nợ NCC."
            }
         ],
         "inlineViews": [
            {
               "name": "Chi tiết kỳ đối soát khách hàng",
               "trigger": "Bấm một dòng kỳ khách hàng trên /finance/reconciliations",
               "description": "Cửa sổ nổi với 4 ô số dư, tab Phiếu Giao Hàng / Phiếu Thu Tiền / Bảng Kê Sổ Cái, nút [In biên bản], [Chốt sổ], [Đóng]."
            },
            {
               "name": "Lập Phiếu Thu Nhanh (1-Chạm)",
               "trigger": "[Lập Phiếu Thu] trên phiếu giao / [+ Lập Phiếu Thu] trên đơn hàng",
               "description": "Hộp thoại nhập số tiền, hình thức, tham chiếu, ghi chú; không phải rời màn hình đang làm."
            },
            {
               "name": "Công nợ khách hàng trên form phiếu thu",
               "trigger": "Chọn Đối tượng (Khách hàng) trên form",
               "description": "Hiện công nợ hiện tại của khách hàng ngay dưới form để đối chiếu số tiền thu."
            }
         ],
         "forms": [
            {
               "code": "BM-TC-01",
               "name": "Biên bản đối chiếu và xác nhận công nợ khách hàng (nút In biên bản trong chi tiết kỳ đối soát)"
            },
            {
               "code": "BM-TC-02",
               "name": "Báo cáo tổng hợp công nợ khách hàng (Ban hành 01/2025)"
            }
         ],
         "notes": [
            "Phiếu chi hiện cũng chọn Đối tượng là Khách hàng (bắt buộc) và không làm giảm công nợ nhà cung cấp; chỉ phiếu loại Thu ở trạng thái Đã xác nhận / Hoàn thành mới trừ công nợ phải thu.",
            "Phiếu thu nháp không tính vào công nợ — nhớ bấm [Lưu] khi đã nhận tiền.",
            "Không xoá Phiếu thu đã thuộc kỳ khách hàng đã ký xác nhận; xoá hoặc sửa sẽ làm số dư hiện tại thay đổi (kỳ đã chốt giữ nguyên số liệu đã chốt).",
            "Phiếu giao hàng có ngày giao thuộc tháng đã chốt sổ không tạo, sửa hay đổi trạng thái được (thông báo: Kỳ kế toán của tháng này đã bị khóa).",
            "Các trang In BB, sổ chi tiết in bằng cửa sổ trình duyệt; chọn đúng khổ A4.",
            "Phiếu thu/chi in ra chưa có mã biểu mẫu ISO trên đầu trang.",
            "Nút [Xuất Excel] trên trang Sổ chi tiết công nợ (khách hàng và nhà cung cấp) hiện chưa xuất file; dùng [In sổ] / [In Đối Soát] hoặc Xuất Excel ở danh sách Đối soát công nợ.",
            "Trang /finance/ar (Công nợ phải thu tổng hợp) và /finance/ar-aging đều hiển thị cùng bảng tổng hợp công nợ khách hàng (Mã KH, Tên, Dư nợ đầu kỳ, Dư nợ hiện tại, [Sổ chi tiết]); hiện chưa có màn hình phân tích tuổi nợ riêng.",
            "Sau khi xoá hoặc sửa ở trang chi tiết rồi quay lại danh sách, danh sách tự tải lại, không cần F5."
         ],
         "screenshots": []
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 16. Hệ Thống & Quy Trình: Nhân Sự, Phân Quyền, Workflow Duyệt, Cấu Hình & Thùng Rác
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "system_admin",
         "aliases": [
            "system",
            "roles",
            "users",
            "security",
            "auth",
            "company-info",
            "workflows",
            "configs",
            "processes",
            "waste-matrix",
            "trash",
            "audit-logs",
            "user-events",
            "profile",
            "settings",
            "hr"
         ],
         "title": "16. Hệ Thống & Quy Trình: Nhân Sự, Phân Quyền, Workflow Duyệt, Cấu Hình & Thùng Rác",
         "icon": "ShieldCheck",
         "isoRef": "QT-HT-01",
         "purpose": "Hướng dẫn quản trị nền tảng dùng chung của APV ERP: tài khoản Nhân sự (/users), Vai trò và Ma trận phân quyền (/roles), danh mục Quy trình SX (/processes), Ma trận Hao hụt (/waste-matrix), Workflow Duyệt (/workflows), Thông tin Cty (/company-info), Cấu hình danh mục chọn (/configs), cùng các công cụ hỗ trợ Lịch sử hệ thống (/system/audit-logs), Thùng rác (/trash), Hồ sơ cá nhân (/profile) và Cài đặt người dùng (/settings). Mục tiêu: đúng người thấy đúng chức năng, dữ liệu nền nhập một lần dùng chung cho mọi phân hệ, và mọi thao tác xoá nhầm hay thay đổi đều có thể khôi phục hoặc truy vết.",
         "scope": [
            "Menu Hệ Thống & Quy Trình: Quy trình SX (/processes), Ma trận Hao hụt (/waste-matrix), Workflow Duyệt (/workflows), Nhân sự (/users), Phân quyền (/roles), Thông tin Cty (/company-info), Cấu hình (/configs).",
            "Menu Hỗ Trợ: Lịch sử hệ thống (/system/audit-logs), Nhật ký sự kiện (/system/user-events), Thùng rác (/trash). Nhật ký Release (/changelog), Phản hồi hệ thống (/feedback) và Hướng dẫn sử dụng (/guide) được hướng dẫn ở Chương 02.",
            "Menu tài khoản góc phải Header: Hồ sơ cá nhân (/profile), Cài đặt tài khoản (/settings), Đăng xuất.",
            "Quản trị viên và Ban Giám đốc (ADMIN, DIRECTOR — Full Access) quản lý Nhân sự, Phân quyền và xem Lịch sử hệ thống. Theo cấu hình Go-Live hiện tại, 16 vai trò nghiệp vụ còn lại được mở đủ quyền trên các danh mục Quy trình SX, Ma trận Hao hụt, Workflow Duyệt, Thông tin Cty, Cấu hình và Thùng rác, nhưng không thấy Nhân sự, Phân quyền và Lịch sử hệ thống.",
            "Mọi người dùng đã đăng nhập tự cập nhật Hồ sơ cá nhân và Cài đặt người dùng của chính mình."
         ],
         "references": [
            "ISO 9001:2015 mục 5.3 — Vai trò, trách nhiệm và quyền hạn trong tổ chức.",
            "ISO 9001:2015 mục 7.1.3 và 7.1.5 — Cơ sở hạ tầng và nguồn lực theo dõi, đo lường (thông số công đoạn, định mức hao hụt).",
            "ISO 9001:2015 mục 7.5 — Thông tin dạng văn bản: kiểm soát, lưu giữ, truy vết thay đổi và khôi phục dữ liệu.",
            "Cấu hình vai trò chuẩn Go-Live 18 vai trò của hệ thống (Admin, Ban Giám Đốc và 16 vai trò nghiệp vụ)."
         ],
         "terms": [
            {
               "term": "Vai trò (Role)",
               "definition": "Nhóm quyền gán cho nhân sự, ví dụ Thủ Kho, Kế Toán, Nhân Viên Kinh Doanh. Mỗi nhân sự có đúng một Vai trò hệ thống; đổi quyền của Vai trò là đổi quyền cho mọi nhân sự thuộc vai trò đó."
            },
            {
               "term": "Full Access — Toàn quyền hệ thống",
               "definition": "Công tắc trên Vai trò cho phép làm mọi thao tác ở mọi phân hệ. Vai trò bật Full Access hiện nhãn ADMIN, vai trò còn lại hiện nhãn CUSTOM. Muốn chỉnh quyền chi tiết phải tắt Full Access trước."
            },
            {
               "term": "Quyền thao tác",
               "definition": "Các cột trên Ma trận phân quyền: Tất cả, Xem, Thêm, Sửa, Xóa, Import, Export, Review, Duyệt. Cột Tất cả bật hoặc tắt cùng lúc mọi quyền của một phân hệ."
            },
            {
               "term": "Phạm vi Dữ liệu",
               "definition": "Giới hạn bản ghi được xem trong một phân hệ: Không được phép, Chỉ của mình (bản ghi mình tạo hoặc mình phụ trách), Của Team (cùng Bộ phận chi tiết; nhân sự chưa khai báo Bộ phận chi tiết được xử lý như Chỉ của mình), Tất cả."
            },
            {
               "term": "Phạm vi Tiền/Giá",
               "definition": "Giới hạn được xem số tiền, đơn giá: Không được xem, Chỉ của mình, Của Team, Phòng ban, Tất cả. Ngoài phạm vi, các ô tiền bị che."
            },
            {
               "term": "Nhật ký sự kiện (/system/user-events)",
               "definition": "Nhật ký kỹ thuật theo từng người dùng và từng tab trình duyệt (phiên): chuyển trang, bấm nút, lời gọi API, lỗi màn hình, request ghi dữ liệu / lỗi / chậm trên máy chủ, đăng nhập và đăng xuất. Lọc theo Người dùng, Loại, Mức (Thông tin / Cảnh báo / Lỗi), khoảng ngày; bấm mã phiên hoặc mã request trên một dòng để lọc theo phiên/request đó; tìm mã request bằng ô tìm kiếm trên header; cột Phiếu liên quan mở phiếu phản hồi cùng phiên. Không lưu nội dung ô nhập hay mật khẩu. Dữ liệu tự xóa sau 30 ngày. Cùng quyền xem với Lịch sử hệ thống."
            },
            {
               "term": "Thùng rác",
               "definition": "Nơi lưu bản ghi đã xoá của các chứng từ và danh mục chính (Khách hàng, Sản phẩm, Báo giá, Đơn hàng, Lệnh sản xuất, Đơn mua hàng, Phiếu giao hàng, phiếu KCS, NCR, Nhật ký sản xuất, Khuôn...). Có thể Khôi phục hoặc Xoá vĩnh viễn."
            },
            {
               "term": "Transition (Bước chuyển trạng thái)",
               "definition": "Một dòng trên Workflow Duyệt: Hành động, Từ trạng thái, Sang trạng thái, Leadtime (ngày), Trách nhiệm và màu hiển thị. Dùng để vẽ thanh tiến trình trên trang chi tiết chứng từ."
            },
            {
               "term": "MOQ và Hao hụt cố định",
               "definition": "Trên Ma trận Hao hụt: MOQ là số lượng tối thiểu áp dụng dòng cấu hình; % Hao Hụt tính theo số lượng đặt; Hao Hụt Cố Định là số tờ/con bù hao cho mỗi lần chạy máy."
            }
         ],
         "responsibilities": [
            {
               "role": "Quản Trị Viên (ADMIN)",
               "tasks": [
                  "Tạo, sửa, xoá Vai trò và chỉnh Ma trận phân quyền tại Phân quyền (/roles).",
                  "Tạo tài khoản, gán Vai trò, Phòng ban, Chức vụ; khoá hoặc mở khoá; đặt lại mật khẩu tại Nhân sự (/users).",
                  "Tra cứu và xuất Lịch sử hệ thống; xử lý Thùng rác; duy trì Thông tin Cty và Cấu hình.",
                  "Khi có phiếu phản hồi hoặc người dùng báo lỗi: mở Nhật ký sự kiện (/system/user-events), lọc theo người dùng và mốc thời gian (hoặc bấm mã phiên) để xem lại các bước đã làm và request lỗi."
               ]
            },
            {
               "role": "Ban Giám Đốc (DIRECTOR)",
               "tasks": [
                  "Toàn quyền như Quản trị viên (vai trò Full Access).",
                  "Phê duyệt thay đổi phân quyền chính thức sau giai đoạn Go-Live."
               ]
            },
            {
               "role": "Kế Hoạch / Kỹ Thuật / Quản Đốc Sản Xuất",
               "tasks": [
                  "Khai báo và cập nhật danh mục Quy trình SX: mã, nhóm, loại máy, tốc độ chuẩn, thời gian setup, hao phí.",
                  "Cập nhật Ma trận Hao hụt theo công đoạn."
               ]
            },
            {
               "role": "Trưởng các bộ phận",
               "tasks": [
                  "Cập nhật các danh sách chọn của bộ phận mình tại Cấu hình (/configs).",
                  "Đề xuất bước chuyển và người chịu trách nhiệm trên Workflow Duyệt (/workflows)."
               ]
            },
            {
               "role": "Mọi người dùng",
               "tasks": [
                  "Cập nhật Hồ sơ cá nhân, ảnh đại diện, mẫu chữ ký tại /profile.",
                  "Chọn giao diện, kiểu menu, số dòng mỗi trang tại Cài đặt tài khoản (/settings).",
                  "Khôi phục bản ghi mình xoá nhầm tại Thùng rác (/trash) nếu vai trò có quyền."
               ]
            }
         ],
         "processFlowchart": "graph TD\n    A[Admin mở Phân quyền] --> B[Thêm vai trò hoặc chọn vai trò có sẵn]\n    B --> C[Bấm Sửa quyền và tích Xem Thêm Sửa Xóa Duyệt theo phân hệ]\n    C --> D[Chọn Phạm vi Dữ liệu và Phạm vi Tiền Giá rồi bấm Lưu]\n    D --> E[Mở Nhân sự và bấm Thêm]\n    E --> F[Nhập hồ sơ chọn Vai trò Phòng ban Chức vụ rồi Lưu hồ sơ]\n    F --> G[Nhân sự đăng nhập và chỉ thấy menu được cấp quyền Xem]\n    G --> H{Có sự cố dữ liệu}\n    H -->|Xoá nhầm chứng từ| I[Khôi phục tại Thùng rác]\n    H -->|Cần truy vết ai sửa gì| J[Lọc Lịch sử hệ thống và xuất BM-ISO-753]\n    H -->|Quên mật khẩu| K[Admin bấm Reset Mật Khẩu trên hồ sơ nhân sự]\n    A --> L[Thiết lập dữ liệu nền Quy trình SX Ma trận Hao hụt Workflow Cấu hình Thông tin Cty]\n    L --> M[Các phân hệ nghiệp vụ và bản in dùng chung dữ liệu nền]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Thiết lập Vai trò và Ma trận phân quyền (/roles)",
               "detail": "• Vào `Hệ Thống & Quy Trình -> Phân quyền (/roles)` (chỉ hiện với vai trò có quyền Xem Phân quyền; theo cấu hình hiện tại là ADMIN và DIRECTOR).\n• Cột trái là danh sách Vai trò (ô `Tìm vai trò...`); vai trò Full Access có nhãn ADMIN, vai trò còn lại nhãn CUSTOM. Bấm một vai trò để xem ma trận quyền bên phải.\n• Bấm `[Thêm vai trò]` để tạo mới (/roles/new): nhập `Mã Vai Trò`, `Tên Vai Trò`, `Mô Tả` rồi bấm `[Lưu Vai Trò]`. Bấm `[Sửa thông tin]` để đổi tên hoặc mô tả (/roles/$roleId/edit).\n• Bấm `[Sửa quyền]` để mở khoá ma trận: tích các cột Tất cả, Xem, Thêm, Sửa, Xóa, Import, Export, Review, Duyệt cho từng phân hệ (nhóm Kinh Doanh, Kế Hoạch & Mua Hàng, Tài Chính, Sản Xuất, Kỹ Thuật, Chất Lượng, Kho, Hệ thống). Chọn `Phạm vi Dữ liệu` và `Phạm vi Tiền/Giá` ở hai cột cuối.\n• Công tắc `Full Access` bật toàn quyền hệ thống; khi đang bật, hệ thống báo \"Vui lòng tắt Full Access trước khi chỉnh quyền chi tiết\".\n• Bấm `[Lưu]` để áp dụng (thông báo \"Đã lưu cấu hình phân quyền thành công.\") hoặc `[Hủy]` để bỏ thay đổi. Máy chủ kiểm tra quyền theo cấu hình mới ngay từ thao tác kế tiếp của người dùng thuộc vai trò đó."
            },
            {
               "step": 2,
               "action": "Quản lý tài khoản Nhân sự (/users)",
               "detail": "• Vào `Hệ Thống & Quy Trình -> Nhân sự (/users)`. Bộ lọc trên bảng: Mã NV, Thông tin chung, Số điện thoại, Vai trò, Phòng ban, Trạng thái (Hoạt động / Vô hiệu).\n• Bấm `[Thêm nhân sự]` (/users/new): điền `Họ và tên *`, `Email *`, `Vai trò hệ thống *`, `Phòng ban *`, `Chức vụ *`; `Mã nhân viên` để trống sẽ tự tạo; `Mật khẩu (mặc định: 123456)`. Có thêm nhóm Hồ sơ Pháp lý & Hợp đồng (CCCD, Mã số thuế, Số BHXH, Loại hợp đồng, Ngân hàng...). Bấm `[Lưu hồ sơ]`.\n• Bấm một dòng để mở chi tiết (/users/$userId) với các tab Thông tin chung, Hợp đồng & Pháp lý, Lịch sử hệ thống. Nút trên đầu trang: `[Reset Mật Khẩu]` (đặt lại về 123456), `[Sửa hồ sơ]` (lưu bằng `[Cập nhật hồ sơ]`), `[Xoá]`.\n• Chọn nhiều dòng để dùng thanh thao tác hàng loạt: `[Xuất Excel]`, `[Vô hiệu hóa]`, `[Mở khóa]`. Dùng `[Nhập Excel]` để nạp danh sách nhân sự theo file mẫu (cột Mã NV, Họ và tên, Email, Vai trò, Phòng ban, Trạng thái).\n• Tài khoản Vô hiệu không đăng nhập và không gọi được chức năng nào cho tới khi được `[Mở khóa]`."
            },
            {
               "step": 3,
               "action": "Khai báo danh mục Quy trình SX và Ma trận Hao hụt (/processes, /waste-matrix)",
               "detail": "• Vào `Hệ Thống & Quy Trình -> Quy trình SX (/processes)`. Thanh nhóm phía trên lọc theo Tất cả, Trước in, In ấn, Sau in, Thành phẩm, Khác.\n• Bấm `[Thêm]` để mở hộp Định nghĩa Công đoạn Mới: `Mã Công Đoạn` (tự gợi ý từ tên), `Nhóm Công Đoạn`, `Tên Công Đoạn`, `Loại Máy Mặc Định`, `Đơn Vị Tính`; nhóm Định Mức Lập Lịch & Công Suất Xưởng (TG Setup Chuẩn, Tốc Độ Chuẩn, Hao Phí Setup, % Bù Hao Chạy, Chuyển bài cùng khuôn/dạng, Rửa máy / Đổi mực, Chờ nhiệt đầu ngày); nhóm chi phí; các ô Hỗ trợ in CMYK, Hỗ trợ in Pantone, Yêu Cầu Khuôn Bế / Khuôn Ép. Bấm `[Lưu Công Đoạn]`.\n• Sửa hoặc xoá từ menu ba chấm của dòng: `Chỉnh sửa`, `Gỡ bỏ`. Bấm vào dòng để xem chi tiết (/processes/$processId) gồm định mức, thông số phụ trợ ca máy và bảng năng lực theo dạng bài; trên trang chi tiết có `[Xoá]`.\n• Có `[Import]` và `[Xuất Excel]` cho danh sách công đoạn.\n• `Ma trận Hao hụt (/waste-matrix)` chỉ dùng để tính giá nhanh. Mỗi công đoạn đã khai báo Hao Phí Setup / % Bù Hao Chạy tự có 1 dòng gốc (MOQ 0, nguồn `Quy trình SX`), tự cập nhật khi sửa công đoạn; muốn đổi thì bấm dòng → `[Sửa công đoạn]`.\n• Muốn thêm bậc MOQ riêng (VD từ 5.000 tờ hao hụt thấp hơn): bấm `[Thêm Cấu Hình]`, chọn `Công Đoạn`, nhập `MOQ`, `% Hao Hụt`, `Hao Hụt Cố Định`, bấm `[Thêm Mới]`; không nhập trùng MOQ đã có. Bấm vào dòng để xem Chi Tiết Cấu Hình Hao Hụt kèm công thức: Tổng phế phẩm dự toán = Số lượng đặt x % hao hụt + hao hụt cố định cho mỗi lần chạy máy."
            },
            {
               "step": 4,
               "action": "Cấu hình Workflow Duyệt, danh sách chọn và Thông tin công ty (/workflows, /configs, /company-info)",
               "detail": "• `Workflow Duyệt (/workflows)`: cột trái liệt kê các quy trình nhóm theo Đầu vào, Quá trình, Đầu ra, Hỗ trợ. Chọn một quy trình để xem bảng Hành động, Từ trạng thái, Sang trạng thái, Leadtime, Trách nhiệm. Bấm `[Thêm bước]` mở hộp Thêm Transition, nhập Hành động, chọn Từ trạng thái và Sang trạng thái, Leadtime (ngày), Trách nhiệm rồi bấm `[Thêm mới]`; biểu tượng bút để Sửa Transition (`[Cập nhật]`), biểu tượng thùng rác để xoá. Có thể chọn màu cho hành động và trạng thái. Các bước này hiển thị thành thanh tiến trình trên trang chi tiết Báo giá, Đơn hàng, Lệnh sản xuất, Đơn mua hàng, Đơn gia công, Phiếu giao hàng, KCS công đoạn và KCS thành phẩm.\n• `Cấu hình (/configs)`: cột trái chia theo Hệ thống, Tài chính, Kinh doanh, Sản phẩm, Vật tư, Nhà cung cấp, Kỹ thuật, Sản xuất (ô `Tìm danh mục...`). Mỗi danh mục có dạng Danh sách chọn, Cài đặt, Bảng dữ liệu hoặc Nhóm tag. Với Danh sách chọn: gõ tên rồi Enter hoặc bấm `[Thêm]`; bấm vào mục để bật/tắt; biểu tượng thùng rác để xoá (hộp Xác nhận xóa). Mục đã có sẽ báo trùng. Các mục ở đây là lựa chọn trong các ô chọn của phân hệ khác, ví dụ Nhóm vật tư và Loại phụ vật tư dùng ở Loại vật tư (/material-types).\n• `Thông tin Cty (/company-info)`: bấm `[Chỉnh sửa]`, cập nhật tên công ty tiếng Việt và tiếng Anh, tên viết tắt, mã số thuế, địa chỉ trụ sở và nhà máy, người đại diện, tài khoản ngân hàng, hotline, email, website, fax; tải Logo thương hiệu và Con dấu tròn pháp nhân; bấm `[Lưu thay đổi]`. Thông tin này được dùng ở phần đầu các bản in."
            },
            {
               "step": 5,
               "action": "Truy vết thay đổi và khôi phục dữ liệu (/system/audit-logs, /trash)",
               "detail": "• `Hỗ Trợ -> Lịch sử hệ thống (/system/audit-logs)`: thẻ đếm Hôm Nay, Tuần Này, Phê Duyệt, Hủy / Xóa; lọc theo Phân hệ, Hành động (Tạo mới, Cập nhật, Đổi trạng thái, Phê duyệt, Hoàn thành, Xóa), Từ ngày, Đến ngày và các ô lọc Thời Gian, Nhân Sự, Mã Đối Tượng, Chi Tiết Biến Động. Bấm `[Ẩn KPI]` / `[Hiện KPI]` để ẩn hoặc hiện bốn thẻ đếm, `[Làm mới]` để tải lại, `[Xuất BM-ISO-753]` để xuất file Excel báo cáo kiểm toán (người thực hiện, phân hệ, mã chứng từ, trường biến động, giá trị cũ, giá trị mới).\n• `Hỗ Trợ -> Thùng rác (/trash)`: lọc Danh mục (Tất cả, Khách hàng, Sản phẩm, Đơn hàng, Người dùng) và các cột Module, ID Bản ghi, Dữ liệu gốc, Người xoá, Thời gian. Ở cột Thao tác bấm biểu tượng `Khôi phục` rồi xác nhận `[Khôi phục]`, hoặc biểu tượng `Xóa vĩnh viễn` rồi xác nhận `[Xoá Vĩnh Viễn]`.\n• Khôi phục bị từ chối nếu mã của bản ghi đã được dùng cho bản ghi khác; xoá vĩnh viễn bị từ chối nếu dữ liệu gốc còn đang được bản ghi khác liên kết."
            },
            {
               "step": 6,
               "action": "Hồ sơ cá nhân và Cài đặt tài khoản (/profile, /settings)",
               "detail": "• Bấm ảnh đại diện góc phải Header: `Hồ sơ cá nhân`, `Cài đặt tài khoản`, `Hướng dẫn sử dụng Go-Live`, `Đăng xuất`.\n• `Hồ sơ cá nhân (/profile)`: bấm `[Chỉnh sửa hồ sơ]`, cập nhật thông tin liên hệ, CCCD, tài khoản ngân hàng, rồi `[Lưu thay đổi]`; có thể đổi ảnh đại diện và tải mẫu chữ ký. Vai trò và trạng thái tài khoản chỉ Admin đổi được.\n• `Cài đặt tài khoản (/settings)` — trang Cài đặt người dùng: Chế độ hiển thị (Sáng, Tối, Tự động), Màu chủ đạo, Kiểu hiển thị Menu (Ngang & Dọc Dual-Axis hoặc Cây phân cấp Dọc), Mật độ hiển thị (Thoải mái, Thu gọn), Sidebar mặc định, Hiện lời chào, Số dòng/trang (10, 20, 25, 50, 100, 200 — áp dụng cho mọi danh sách; chọn số dòng ở ô dưới bất kỳ danh sách nào cũng đổi ô này, và danh sách giữ số đó khi chuyển trang, mở chi tiết rồi quay lại hay tải lại trang), Định dạng ngày, Hiển thị tiền tệ. Bấm `[Mặc định]` để trả về cài đặt gốc. Cài đặt lưu theo tài khoản trên trình duyệt đang dùng."
            }
         ],
         "subFlows": [
            {
               "name": "Vai trò — Thêm mới (/roles/new)",
               "steps": [
                  "Tại /roles bấm [Thêm vai trò].",
                  "Nhập Mã Vai Trò (ví dụ ADMIN, MANAGER, USER...), Tên Vai Trò, Mô Tả.",
                  "Bấm [Lưu Vai Trò]; thông báo \"Tạo vai trò thành công\" và quay về /roles.",
                  "Chọn vai trò vừa tạo, bấm [Sửa quyền] để cấp quyền ngay. Lưu ý: vai trò chưa được cấu hình quyền nào thì hệ thống tạm cho thao tác mọi phân hệ nghiệp vụ (chỉ trừ Nhân sự và Phân quyền), vì vậy phải cấu hình quyền trước khi gán vai trò cho nhân sự."
               ]
            },
            {
               "name": "Vai trò — Sửa thông tin và Sửa quyền",
               "steps": [
                  "[Sửa thông tin] mở /roles/$roleId/edit để đổi Tên và Mô tả, bấm [Lưu Vai Trò].",
                  "[Sửa quyền] mở khoá ma trận ngay trên /roles; tích quyền, chọn Phạm vi Dữ liệu và Phạm vi Tiền/Giá.",
                  "Bấm [Lưu] để áp dụng hoặc [Hủy] để bỏ. Trong khi đang sửa, không chọn được vai trò khác (hệ thống nhắc \"Hãy lưu hoặc hủy chỉnh sửa trước\")."
               ]
            },
            {
               "name": "Vai trò — Xoá",
               "steps": [
                  "Chọn vai trò, bấm [Xóa].",
                  "Hộp Xác nhận xóa vai trò báo hành động không thể hoàn tác; bấm [Xóa].",
                  "Vai trò bị xoá không vào Thùng rác. Trước khi xoá, chuyển các nhân sự đang dùng vai trò đó sang vai trò khác."
               ]
            },
            {
               "name": "Nhân sự — Thêm mới (/users/new)",
               "steps": [
                  "Tại /users bấm [Thêm].",
                  "Điền Họ và tên, Email, Vai trò hệ thống, Phòng ban, Chức vụ (bắt buộc); Mã nhân viên để trống sẽ tự tạo.",
                  "Mật khẩu để trống dùng mặc định 123456.",
                  "Bấm [Lưu hồ sơ]. Bấm [Hủy] hoặc [Hủy bỏ] để thoát không lưu."
               ]
            },
            {
               "name": "Nhân sự — Sửa, Reset mật khẩu, Xoá (/users/$userId)",
               "steps": [
                  "Mở chi tiết nhân sự, bấm [Sửa hồ sơ], chỉnh rồi bấm [Cập nhật hồ sơ]. Có thể mở nhanh từ menu ba chấm của dòng: Chỉnh sửa thông tin.",
                  "Bấm [Reset Mật Khẩu], xác nhận để đặt lại mật khẩu về 123456; báo nhân sự đăng nhập lại.",
                  "Bấm [Xoá], xác nhận \"Xác nhận xoá người dùng?\": tài khoản bị đăng xuất khỏi mọi phiên và không đăng nhập được nữa. Người dùng bị xoá không khôi phục từ Thùng rác; nếu chỉ tạm ngưng, dùng [Vô hiệu hóa]."
               ]
            },
            {
               "name": "Nhân sự — Hàng loạt và Excel",
               "steps": [
                  "Tích chọn nhiều dòng trên /users.",
                  "[Vô hiệu hóa] hoặc [Mở khóa] các tài khoản đã chọn (có hộp xác nhận).",
                  "[Xuất Excel] xuất các dòng đã chọn; nút Xuất Excel trên thanh công cụ xuất danh sách.",
                  "[Nhập Excel] nạp nhân sự từ file theo mẫu tải về trong hộp nhập; thông báo số dòng lỗi nếu có."
               ]
            },
            {
               "name": "Quy trình SX — Thêm, Sửa, Xoá, Excel (/processes)",
               "steps": [
                  "[Thêm] mở hộp Định nghĩa Công đoạn Mới; nhập các ô bắt buộc Mã Công Đoạn, Tên Công Đoạn, Loại Máy Mặc Định, Đơn Vị Tính; bấm [Lưu Công Đoạn].",
                  "Sửa: menu ba chấm của dòng, chọn Chỉnh sửa (hộp Cập nhật Công đoạn).",
                  "Xoá: menu ba chấm, chọn Gỡ bỏ và xác nhận; hoặc mở chi tiết (/processes/$processId) bấm [Xoá] (hộp Xác nhận xoá quy trình). Có thể chọn nhiều dòng và Xoá hàng loạt.",
                  "[Import] nạp công đoạn từ Excel (cột Mã CĐ, Tên Công đoạn bắt buộc); [Xuất Excel] xuất danh sách.",
                  "Từ form Sản phẩm (/products) có thể tạo nhanh công đoạn mới mà không phải rời form."
               ]
            },
            {
               "name": "Ma trận Hao hụt — Thêm, Sửa, Xoá, Excel (/waste-matrix)",
               "steps": [
                  "[Thêm Cấu Hình] mở hộp Thêm Cấu Hình Mới; chọn Công Đoạn, nhập MOQ, % Hao Hụt, Hao Hụt Cố Định, Trạng Thái Hoạt Động; bấm [Thêm Mới].",
                  "Sửa: biểu tượng bút ở cột Thao tác hoặc [Chỉnh Sửa] trong hộp chi tiết; bấm [Cập Nhật].",
                  "Xoá: biểu tượng thùng rác, xác nhận \"Bạn có chắc chắn muốn xóa cấu hình này?\".",
                  "[Xuất Excel] xuất bảng; có tải file mẫu Excel."
               ]
            },
            {
               "name": "Workflow Duyệt — Thêm, Sửa, Xoá bước (/workflows)",
               "steps": [
                  "Chọn quy trình ở cột trái.",
                  "[Thêm bước]: nhập Hành động (ví dụ Duyệt báo giá), chọn Từ trạng thái, Sang trạng thái, nhập Leadtime (ngày), Trách nhiệm (ví dụ Sale Admin); bấm [Thêm mới]. Nút chỉ bấm được khi đủ Hành động, Từ và Sang trạng thái.",
                  "Biểu tượng bút: Sửa Transition, bấm [Cập nhật]. Có thể đổi màu hành động, màu trạng thái nguồn và đích.",
                  "Biểu tượng thùng rác: hộp Xóa transition?, bấm [Xóa]."
               ]
            },
            {
               "name": "Cấu hình — Thêm, bật/tắt, Xoá mục (/configs)",
               "steps": [
                  "Chọn danh mục ở cột trái (có thể tìm bằng ô Tìm danh mục...).",
                  "Danh sách chọn: gõ tên mục, Enter hoặc bấm [Thêm]; mục trùng sẽ báo đã tồn tại.",
                  "Bấm vào mục để bật hoặc tắt (mục tắt không còn hiện để chọn).",
                  "Biểu tượng thùng rác: hộp Xác nhận xóa, bấm [Xóa].",
                  "Danh mục dạng Bảng dữ liệu và Nhóm tag thêm, sửa, xoá tương tự ngay trên bảng hoặc ô Thêm tag...."
               ]
            },
            {
               "name": "Thông tin Cty — Sửa (/company-info)",
               "steps": [
                  "Bấm [Chỉnh sửa].",
                  "Cập nhật thông tin pháp lý, ngân hàng, kênh liên lạc; tải Logo thương hiệu và Con dấu tròn pháp nhân.",
                  "Bấm [Lưu thay đổi] (thông báo \"Đã cập nhật thông tin doanh nghiệp thành công!\") hoặc [Hủy]."
               ]
            },
            {
               "name": "Thùng rác — Khôi phục, Xoá vĩnh viễn (/trash)",
               "steps": [
                  "Lọc theo Danh mục hoặc các ô lọc cột để tìm bản ghi.",
                  "Bấm biểu tượng Khôi phục, xác nhận [Khôi phục]: bản ghi trở lại danh sách gốc.",
                  "Bấm biểu tượng Xóa vĩnh viễn, xác nhận [Xoá Vĩnh Viễn]: bản ghi bị xoá hẳn, không lấy lại được."
               ]
            },
            {
               "name": "Lịch sử hệ thống — Tra cứu và Xuất Excel (/system/audit-logs)",
               "steps": [
                  "Chọn Phân hệ, Hành động, Từ ngày, Đến ngày; nhập Nhân Sự hoặc Mã Đối Tượng ở hàng lọc.",
                  "Đọc cột Chi Tiết Biến Động Dữ Liệu để biết trường nào đổi từ giá trị nào sang giá trị nào.",
                  "Bấm [Xuất BM-ISO-753] để tải file Excel các dòng đang hiển thị."
               ]
            },
            {
               "name": "Đăng nhập và quên mật khẩu",
               "steps": [
                  "Nhập Email hoặc Tên đăng nhập / Mã NV và Mật khẩu, bấm [Đăng nhập hệ thống].",
                  "Quên mật khẩu: liên hệ Quản trị viên để bấm [Reset Mật Khẩu] trên hồ sơ nhân sự, sau đó đăng nhập bằng mật khẩu 123456."
               ]
            },
            {
               "name": "Nhật ký sự kiện (/system/user-events)",
               "steps": [
                  "Người có quyền xem Phân quyền hoặc người xử lý Phản hồi mới mở được; người khác thấy “Bạn không có quyền xem nhật ký sự kiện”.",
                  "Lọc theo người dùng, Loại (Chuyển trang, Bấm, Gửi biểu mẫu, Gọi API, Console, Lỗi, Máy chủ, Đăng nhập / xuất), Mức (Thông tin, Cảnh báo, Lỗi), Từ ngày / Đến ngày; chip “N lỗi” để xem nhanh lỗi; tìm theo tên sự kiện, mã request, mã phiên ở ô tìm kiếm trên header.",
                  "Mỗi dòng: Thời gian, Người dùng, Loại, Sự kiện, Phiên / Request, Phiếu liên quan (mã phiếu phản hồi cùng phiên). Bấm người dùng / phiên / request để lọc theo đó; [Xuất Excel] để lưu."
               ]
            },
            {
               "name": "Duyệt chứng từ trên từng màn hình",
               "steps": [
                  "Workflow Duyệt (/workflows) là bảng tham chiếu các bước và trách nhiệm của từng quy trình; việc duyệt thực hiện ngay trên màn hình chứng từ.",
                  "Người duyệt lọc trạng thái Chờ duyệt ở danh sách của mình (đơn hàng, lệnh sản xuất, đơn mua, phiếu kho, kiểm kê…) rồi mở chứng từ bấm nút duyệt (VD [Duyệt & Chốt Kho] cho phiếu kho).",
                  "Hiện phần mềm không gửi thông báo khi có chứng từ chờ duyệt; người lập nhắc người duyệt hoặc người duyệt rà danh sách Chờ duyệt mỗi ngày."
               ]
            },
            {
               "name": "Cài đặt tài khoản (Cài đặt người dùng)",
               "steps": [
                  "Bấm ảnh đại diện góc phải header › [Cài đặt tài khoản] (/settings).",
                  "Xem Họ tên, Email của tài khoản; đổi Chế độ hiển thị (sáng / tối), Màu chủ đạo, Kiểu hiển thị Menu, Mật độ hiển thị, Sidebar mặc định (Mở rộng / Thu nhỏ (icon) / Tự động), bật / tắt Hiện lời chào.",
                  "Chọn định dạng ngày (dd/MM/yyyy, yyyy-MM-dd, MM/dd/yyyy), cách hiện tiền tệ (Ký hiệu ₫, Mã VND, Tên đầy đủ) và ngôn ngữ (Tiếng Việt / English).",
                  "Cài đặt lưu trên trình duyệt đang dùng; đổi máy hoặc trình duyệt cần chọn lại."
               ]
            },
            {
               "name": "Yêu cầu của tôi (/my-requests)",
               "steps": [
                  "Mục này đã bỏ khỏi menu Hỗ trợ từ bản 03.11.2026.13 vì màn hình chỉ có dữ liệu mẫu, không lưu yêu cầu lên hệ thống và không có người duyệt.",
                  "Góp ý, đề xuất, báo lỗi chính thức gửi qua Phản hồi hệ thống (/feedback) theo chương 02; đề xuất mua hàng lập ở Kế hoạch vật tư (chương 09)."
               ]
            },
            {
               "name": "Nhân sự — Hợp đồng lao động",
               "steps": [
                  "Hệ Thống & Quy Trình › Nhân sự › mở một nhân viên › tab Hợp đồng & Pháp lý.",
                  "Tab hiện danh sách hợp đồng: Số hợp đồng, Loại hợp đồng (Thử việc, Thời vụ, Xác định thời hạn, Không xác định thời hạn), Ngày bắt đầu, Ngày kết thúc, Lương cơ bản, Trạng thái (Nháp, Đang hiệu lực, Đã hết hạn, Đã chấm dứt).",
                  "Biểu tượng thùng rác → Xoá hợp đồng? (không hoàn tác được) để xoá. Thêm và sửa hợp đồng hiện chưa dùng được trên màn hình này — liên hệ quản trị hệ thống để ghi hợp đồng."
               ]
            },
            {
               "name": "Thùng rác, nhân sự trùng mã, ma trận hao hụt — các trường hợp bị chặn",
               "steps": [
                  "Phục hồi ([Phục hồi] ở tab Thùng rác của danh sách, hoặc [Khôi phục] ở Hỗ Trợ › Thùng rác) bị chặn khi mã của bản ghi đã được dùng cho bản ghi khác: Không thể phục hồi do mã đã được sử dụng cho một bản ghi khác. Phục hồi ở tab Thùng rác của danh sách cần quyền Xoá của trang đó.",
                  "Khôi phục một lần xoá có kèm dữ liệu con (VD đơn hàng cùng các dòng) thì dữ liệu con được lấy lại cùng lúc. Đơn mua lập cho kế hoạch vật tư đã huỷ hoặc đã được đặt bằng đơn khác không khôi phục được (tránh mua trùng).",
                  "[Xoá Vĩnh Viễn] bị chặn khi dữ liệu còn được bản ghi khác dùng: Không thể xóa vĩnh viễn vì dữ liệu gốc đang bị ràng buộc bởi các bản ghi khác trong hệ thống.",
                  "Nhân sự › [Thêm nhân sự] / [Nhập Excel]: Email và Mã nhân viên không được trùng, kể cả với nhân viên đã nghỉ còn trong danh sách (trạng thái Vô hiệu) — báo … đã tồn tại trong hệ thống (có thể thuộc về nhân viên đã nghỉ). Nhân viên đã Xoá thì email và mã được giải phóng, dùng lại được.",
                  "Ma trận hao hụt › [Thêm Cấu Hình]: mỗi công đoạn chỉ có một dòng cho mỗi bậc MOQ; trùng với dòng gốc lấy từ Quy trình SX thì báo Công đoạn này đã có dòng gốc MOQ … lấy từ Quy trình SX. Hãy nhập bậc MOQ khác."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "Hoạt động",
               "to": "Vô hiệu",
               "action": "[Vô hiệu hóa] trên danh sách Nhân sự, hoặc chọn Trạng thái Tạm khóa khi sửa hồ sơ",
               "allowedRoles": "Vai trò có quyền Sửa Nhân sự (ADMIN, DIRECTOR)"
            },
            {
               "from": "Vô hiệu",
               "to": "Hoạt động",
               "action": "[Mở khóa] trên danh sách Nhân sự, hoặc chọn Trạng thái Đang hoạt động khi sửa hồ sơ",
               "allowedRoles": "Vai trò có quyền Sửa Nhân sự (ADMIN, DIRECTOR)"
            },
            {
               "from": "Nhân sự đang dùng",
               "to": "Đã xoá",
               "action": "[Xoá] trên chi tiết nhân sự (thu hồi mọi phiên đăng nhập)",
               "allowedRoles": "Vai trò có quyền Xóa Nhân sự (ADMIN, DIRECTOR)"
            },
            {
               "from": "Vai trò CUSTOM",
               "to": "Vai trò ADMIN (Full Access)",
               "action": "[Sửa quyền] rồi bật công tắc Full Access, bấm [Lưu]",
               "allowedRoles": "Vai trò có quyền Sửa Phân quyền (ADMIN, DIRECTOR)"
            },
            {
               "from": "Cấu hình hao hụt Hoạt động",
               "to": "Tạm dừng",
               "action": "Tắt Trạng Thái Hoạt Động trong hộp Sửa Cấu Hình Hao Hụt, bấm [Cập Nhật]",
               "allowedRoles": "Người thấy menu Ma trận Hao hụt"
            },
            {
               "from": "Mục cấu hình đang bật",
               "to": "Đang tắt",
               "action": "Bấm vào mục trong Danh sách chọn (Click để tắt / Click để bật)",
               "allowedRoles": "Người thấy menu Cấu hình"
            },
            {
               "from": "Bản ghi đã xoá (trong Thùng rác)",
               "to": "Đã khôi phục",
               "action": "[Khôi phục]",
               "allowedRoles": "Vai trò có quyền Xem và Sửa Thùng rác"
            },
            {
               "from": "Bản ghi đã xoá (trong Thùng rác)",
               "to": "Xoá vĩnh viễn",
               "action": "[Xoá Vĩnh Viễn]",
               "allowedRoles": "Vai trò có quyền Xóa Thùng rác"
            }
         ],
         "permissionRules": [
            {
               "role": "ADMIN, DIRECTOR (Full Access)",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Toàn quyền trên mọi màn hình của chương này, gồm Nhân sự, Phân quyền và Lịch sử hệ thống."
            },
            {
               "role": "16 vai trò nghiệp vụ — Nhân sự (/users), Phân quyền (/roles), Lịch sử hệ thống (/system/audit-logs)",
               "view": "❌",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "❌",
               "statusRules": "Cấu hình Go-Live khoá hai phân hệ Người dùng và Phân quyền cho mọi vai trò không phải Full Access; menu bị ẩn và máy chủ từ chối thao tác. Lịch sử hệ thống đi theo quyền Xem Phân quyền."
            },
            {
               "role": "16 vai trò nghiệp vụ — Quy trình SX, Ma trận Hao hụt, Workflow Duyệt, Thông tin Cty, Cấu hình",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "✅",
               "approve": "✅",
               "export": "✅",
               "statusRules": "Đang mở đủ quyền theo cấu hình Go-Live. Admin thu hẹp tại /roles ở các dòng Quy trình SX, Quy trình WF, Công ty, Cấu hình."
            },
            {
               "role": "16 vai trò nghiệp vụ — Thùng rác (/trash)",
               "view": "✅",
               "create": "❌",
               "edit": "✅",
               "delete": "✅",
               "approve": "❌",
               "export": "❌",
               "statusRules": "Sửa = Khôi phục; Xóa = Xoá vĩnh viễn. Đang mở theo cấu hình Go-Live."
            },
            {
               "role": "Mọi người dùng — Hồ sơ cá nhân (/profile), Cài đặt tài khoản (/settings)",
               "view": "✅",
               "create": "❌",
               "edit": "⚡",
               "delete": "❌",
               "approve": "❌",
               "export": "❌",
               "statusRules": "Chỉ sửa hồ sơ và cài đặt của chính mình; không tự đổi Vai trò hay Trạng thái tài khoản."
            }
         ],
         "actionLinks": [
            {
               "from": "Phân quyền (/roles)",
               "to": "Tạo vai trò (/roles/new)",
               "action": "Thêm vai trò",
               "how": "Bấm [Thêm vai trò] ở thanh trên cùng."
            },
            {
               "from": "Phân quyền (/roles)",
               "to": "Sửa vai trò (/roles/$roleId/edit)",
               "action": "Đổi tên, mô tả",
               "how": "Chọn vai trò, bấm [Sửa thông tin]."
            },
            {
               "from": "Nhân sự (/users)",
               "to": "Chi tiết nhân sự (/users/$userId)",
               "action": "Xem hồ sơ, reset mật khẩu, xoá",
               "how": "Bấm vào dòng nhân sự."
            },
            {
               "from": "Nhân sự (/users)",
               "to": "Phân quyền (/roles)",
               "action": "Quyền của nhân sự",
               "how": "Quyền đi theo Vai trò hệ thống đã gán; muốn đổi quyền một người thì đổi Vai trò của người đó, muốn đổi quyền cả nhóm thì sửa Vai trò."
            },
            {
               "from": "Cấu hình (/configs)",
               "to": "Các form nghiệp vụ, ví dụ Loại vật tư (/material-types), Nhân sự (/users)",
               "action": "Bổ sung lựa chọn",
               "how": "Thêm mục vào danh mục tương ứng; mục mới hiện ngay trong ô chọn của form."
            },
            {
               "from": "Thông tin Cty (/company-info)",
               "to": "Bản in chứng từ",
               "action": "Cập nhật tiêu đề bản in",
               "how": "Sửa tên, địa chỉ, mã số thuế, logo, con dấu rồi [Lưu thay đổi]."
            },
            {
               "from": "Workflow Duyệt (/workflows)",
               "to": "Trang chi tiết Báo giá, Đơn hàng, Lệnh sản xuất, Đơn mua hàng, Đơn gia công, Phiếu giao hàng, KCS",
               "action": "Thanh tiến trình trạng thái",
               "how": "Các bước của quy trình tương ứng được vẽ thành thanh tiến trình trên trang chi tiết."
            },
            {
               "from": "Sản phẩm (/products)",
               "to": "Quy trình SX (/processes)",
               "action": "Tạo nhanh công đoạn",
               "how": "Trong form sản phẩm mở hộp tạo công đoạn mới thay vì sang menu Quy trình SX."
            },
            {
               "from": "Mọi danh sách chứng từ",
               "to": "Thùng rác (/trash)",
               "action": "Khôi phục bản ghi xoá nhầm",
               "how": "Bản ghi bị xoá của các chứng từ chính được đưa vào Thùng rác."
            },
            {
               "from": "Header — ảnh đại diện",
               "to": "Hồ sơ cá nhân (/profile), Cài đặt tài khoản (/settings), Hướng dẫn sử dụng (/guide)",
               "action": "Tài khoản của tôi",
               "how": "Bấm ảnh đại diện góc phải và chọn mục."
            }
         ],
         "inlineViews": [
            {
               "name": "Ma trận phân quyền ngay trên danh sách vai trò",
               "trigger": "Bấm một vai trò ở cột trái /roles",
               "description": "Ma trận quyền, Phạm vi Dữ liệu và Phạm vi Tiền/Giá của vai trò hiện ngay bên phải, không phải mở trang khác."
            },
            {
               "name": "Hộp Chi Tiết Cấu Hình Hao Hụt",
               "trigger": "Bấm một dòng trên /waste-matrix",
               "description": "Xem công đoạn áp dụng, MOQ, % hao hụt, hao hụt bù hao và công thức tính; có [Chỉnh Sửa] và [Đóng]."
            },
            {
               "name": "Hộp Định nghĩa / Cập nhật Công đoạn",
               "trigger": "[Thêm] hoặc Chỉnh sửa trên /processes",
               "description": "Thêm và sửa công đoạn ngay trên danh sách."
            }
         ],
         "quickActions": [
            {
               "action": "Thêm vai trò",
               "description": "[Thêm vai trò] trên /roles."
            },
            {
               "action": "Sửa quyền một vai trò",
               "description": "Chọn vai trò, [Sửa quyền], tích quyền, [Lưu]."
            },
            {
               "action": "Khoá nhanh nhiều tài khoản",
               "description": "Tích chọn trên /users, bấm [Vô hiệu hóa]."
            },
            {
               "action": "Đặt lại mật khẩu",
               "description": "Chi tiết nhân sự, [Reset Mật Khẩu] (về 123456)."
            },
            {
               "action": "Khôi phục bản ghi xoá nhầm",
               "description": "/trash, biểu tượng Khôi phục, [Khôi phục]."
            },
            {
               "action": "Xuất nhật ký kiểm toán",
               "description": "/system/audit-logs, lọc rồi bấm [Xuất BM-ISO-753]."
            },
            {
               "action": "Thêm lựa chọn cho ô chọn",
               "description": "/configs, chọn danh mục, gõ tên rồi Enter."
            }
         ],
         "forms": [
            {
               "code": "BM-ISO-753",
               "name": "Báo Cáo Kiểm Toán Nhật Ký Hệ Thống (xuất Excel từ Lịch sử hệ thống)"
            }
         ],
         "screenshots": [
            {
               "src": "/guide-screenshots/05_roles_18_matrix_and_user_role_config.png",
               "caption": "Hình 16.1 — Màn hình Phân quyền (/roles): danh sách vai trò bên trái, ma trận quyền và phạm vi bên phải"
            }
         ],
         "notes": [
            "Cấu hình vai trò Go-Live hiện tại: ADMIN và DIRECTOR có Full Access; 16 vai trò còn lại (MANAGER, SALES_MANAGER, SALES, PLANNER, PRODUCTION_MANAGER, TECH_MANAGER, TECH, QAQC_MANAGER, QC_INSPECTOR, QC, ACCOUNTANT, WAREHOUSE, DELIVERY, OPERATOR, HR, USER) được mở đủ quyền và Phạm vi Tất cả trên các phân hệ nghiệp vụ, trừ Người dùng và Phân quyền. Khi kết thúc Go-Live, Admin thu hẹp quyền từng vai trò tại /roles.",
            "Menu bên trái chỉ hiện mục mà vai trò có quyền Xem. Nếu một nhân sự không thấy menu sau khi được cấp quyền, nhờ họ đăng xuất và đăng nhập lại.",
            "Bản nháp (Lưu nháp) của mọi chứng từ chỉ người tạo, ADMIN và DIRECTOR thấy; cấp thêm quyền không làm người khác thấy bản nháp.",
            "Vai trò mới tạo mà chưa lưu ma trận quyền được hệ thống coi như mở mọi phân hệ nghiệp vụ (trừ Nhân sự, Phân quyền). Luôn bấm [Sửa quyền] và [Lưu] cho vai trò mới trước khi gán cho nhân sự.",
            "Không xoá vai trò đang có nhân sự sử dụng; chuyển nhân sự sang vai trò khác trước.",
            "Muốn tạm ngưng một nhân sự nghỉ việc, dùng [Vô hiệu hóa] thay vì [Xoá] để giữ lịch sử thao tác và khôi phục được.",
            "Xoá vai trò, xoá nhân sự và xoá công đoạn không đưa vào Thùng rác; chỉ chứng từ và danh mục chính mới khôi phục được.",
            "Xoá vĩnh viễn trong Thùng rác không thể hoàn tác.",
            "Cài đặt tài khoản (giao diện, menu, số dòng mỗi trang) lưu trên trình duyệt đang dùng; đổi máy hoặc trình duyệt cần chọn lại.",
            "Hiện chưa có chức năng tự đổi mật khẩu; người dùng quên mật khẩu liên hệ Quản trị viên để đặt lại.",
            "Yêu cầu của tôi (/my-requests) đã bỏ khỏi menu vì chỉ có dữ liệu mẫu, chưa lưu yêu cầu lên hệ thống; không dùng để gửi đề xuất chính thức. Góp ý và báo lỗi gửi qua Phản hồi hệ thống (/feedback).",
            "Sau khi xoá một bản ghi ở trang chi tiết và quay về danh sách, danh sách tự cập nhật, không cần tải lại trang.",
            "Chuyển chứng từ sang Xác nhận / Đã duyệt / Ban hành cần quyền duyệt của module đó trong Phân quyền."
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 17. Thiết Bị: Báo Sự Cố, Tiếp Nhận Sửa Chữa, Nghiệm Thu & Bảo Trì Định Kỳ (PM)
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "equipment_maintenance",
         "aliases": [
            "mes-incidents",
            "mes-maintenance",
            "incidents",
            "maintenance",
            "pm",
            "preventive-maintenance",
            "mttr",
            "mtbf",
            "su-co-thiet-bi",
            "bao-tri"
         ],
         "title": "17. Thiết Bị: Báo Sự Cố, Tiếp Nhận Sửa Chữa, Nghiệm Thu & Bảo Trì Định Kỳ (PM)",
         "icon": "Wrench",
         "isoRef": "QT-TB-01",
         "purpose": "Hướng dẫn xưởng và kỹ thuật cơ điện ghi nhận sự cố máy, tiếp nhận và sửa chữa, nghiệm thu khôi phục máy, theo dõi giờ chạy và lập lịch bảo trì định kỳ (PM) trên phần mềm. Mục tiêu là mọi lần dừng máy đều có phiếu, có người chịu trách nhiệm, có thời gian sửa và phụ tùng thay, để tính được độ sẵn sàng của máy (MTTR, MTBF) và bảo trì trước khi máy hỏng.",
         "scope": [
            "Menu Xưởng sản xuất › Sự cố thiết bị (/mes/incidents) và Xưởng sản xuất › Bảo trì bảo dưỡng (/mes/maintenance). Hai mục mở cùng một màn hình, chỉ khác tab mở đầu: Sự cố thiết bị mở tab Sự cố đang xử lý; Bảo trì bảo dưỡng mở tab Giờ chạy & PM và có thêm nút [Lập lịch PM].",
            "Áp dụng cho mọi máy trong danh mục Thiết bị SX. Kiểm tra đầu ca trên Màn hình xưởng và nhật ký máy (Vận hành / Dừng máy) xem chương 11.",
            "Người dùng: thợ vận hành và tổ trưởng (báo sự cố), kỹ thuật cơ điện (tiếp nhận, sửa, nghiệm thu), quản đốc / giám đốc sản xuất (theo dõi, lập lịch PM)."
         ],
         "references": [
            "ISO 9001:2015 mục 7.1.3 — Cơ sở hạ tầng (duy trì thiết bị)",
            "ISO 9001:2015 mục 7.1.5 — Nguồn lực theo dõi và đo lường",
            "ISO 9001:2015 mục 10.2 — Sự không phù hợp và hành động khắc phục",
            "Chương 11 — Xưởng sản xuất (nhật ký máy, Màn hình xưởng); Chương 03 — Dữ liệu gốc (Thiết bị SX)"
         ],
         "terms": [
            {
               "term": "Phiếu sự cố (INC-…)",
               "definition": "Phiếu ghi một lần máy gặp sự cố, mã dạng INC-năm-số. Đi qua 3 trạng thái: CHỜ TIẾP NHẬN → ĐANG SỬA CHỮA → Đã nghiệm thu (vào tab Lịch sử sửa chữa)."
            },
            {
               "term": "Phiếu PM (PM-…)",
               "definition": "Lịch bảo trì định kỳ của một máy, mã dạng PM-năm-số; lưu ngày bảo trì kế tiếp và chu kỳ (tháng) lên máy."
            },
            {
               "term": "Giờ chạy",
               "definition": "Ước tính từ nhật ký sản xuất của máy: tổng sản lượng Đạt + Hỏng chia 4.000 tờ/giờ, cộng thời gian căn chỉnh. Dùng để cảnh báo đến hạn bảo trì."
            },
            {
               "term": "Chu kỳ PM theo giờ",
               "definition": "Bằng chu kỳ bảo dưỡng (tháng) × 160 giờ; máy chưa khai báo chu kỳ dùng 500 giờ. Máy đã chạy ≥ 90% chu kỳ hoặc đã qua ngày bảo trì kế tiếp được đánh dấu Đến hạn."
            },
            {
               "term": "MTTR / MTBF",
               "definition": "MTTR: thời gian sửa trung bình mỗi sự cố (từ số phút sửa ghi khi nghiệm thu). MTBF: thời gian chạy trung bình giữa hai sự cố."
            },
            {
               "term": "Trạng thái máy",
               "definition": "ĐANG CHẠY, SỰ CỐ, BẢO TRÌ, CHỜ VIỆC. Phần mềm tự đổi theo phiếu sự cố mức Dừng máy khẩn cấp: báo sự cố → SỰ CỐ; tiếp nhận → BẢO TRÌ; nghiệm thu → CHỜ VIỆC hoặc ĐANG CHẠY theo lựa chọn. Mức Cảnh báo vận hành không đổi trạng thái máy."
            }
         ],
         "responsibilities": [
            {
               "role": "Thợ vận hành / Tổ trưởng (OPERATOR)",
               "tasks": [
                  "Báo sự cố ngay khi máy có vấn đề, mô tả hiện tượng cụ thể",
                  "Không tự ý chạy lại máy đang ở trạng thái SỰ CỐ khi chưa có nghiệm thu"
               ]
            },
            {
               "role": "Kỹ thuật cơ điện",
               "tasks": [
                  "Theo dõi tab Sự cố đang xử lý, bấm [Tiếp Nhận] phiếu mình phụ trách",
                  "Sửa xong ghi phương án khắc phục, số phút sửa, phụ tùng thay và bấm [Nghiệm Thu & Đóng]",
                  "Lập phiếu PM cho máy đến hạn"
               ]
            },
            {
               "role": "Quản đốc / Giám đốc sản xuất (PRODUCTION_MANAGER)",
               "tasks": [
                  "Xem 6 thẻ chỉ số đầu trang: Tổng số máy, Tỷ lệ sẵn sàng, Máy sự cố, Đang bảo trì, MTTR, MTBF",
                  "Rà tab Giờ chạy & PM hằng tuần, lập lịch PM cho máy đến hạn",
                  "Xuất Excel lịch sử sửa chữa khi đánh giá thiết bị"
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "Mọi vai trò có quyền xem Thiết bị SX",
               "view": "✅",
               "create": "✅",
               "edit": "✅",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Mục menu hiện theo quyền Thiết bị SX. Đã đăng nhập là báo sự cố, tiếp nhận, nghiệm thu và lập lịch PM được; phiếu sự cố không xoá trên màn hình này."
            }
         ],
         "processFlowchart": "graph TD\n    A[Máy có vấn đề] --> B[Báo sự cố: chọn máy, nhóm sự cố, mức độ, hiện tượng]\n    B --> C[Phiếu INC - CHỜ TIẾP NHẬN; máy chuyển SỰ CỐ]\n    C --> D[Kỹ thuật Tiếp nhận - ĐANG SỬA CHỮA; máy chuyển BẢO TRÌ]\n    D --> E[Sửa máy]\n    E --> F[Nghiệm thu: phương án, số phút sửa, phụ tùng]\n    F --> G[Máy về CHỜ VIỆC hoặc ĐANG CHẠY; phiếu vào Lịch sử sửa chữa]\n    H[Tab Giờ chạy & PM: máy Đến hạn] --> I[Lập phiếu PM: ngày bảo trì kế tiếp, chu kỳ]\n    I --> J[Ngày bảo trì và chu kỳ lưu lên máy]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Mở màn hình",
               "detail": "• Xưởng sản xuất › Sự cố thiết bị (tab Sự cố đang xử lý) hoặc Bảo trì bảo dưỡng (tab Giờ chạy & PM).\n• Đầu trang có 6 thẻ chỉ số: Tổng Số Máy, Tỷ Lệ Sẵn Sàng, Máy Sự Cố (DOWN), Đang Bảo Trì, MTTR Sửa Chữa, MTBF Giữa Các Sự Cố.\n• Gõ tên / mã máy, mã phiếu, loại hoặc lý do sự cố vào ô tìm kiếm trên header để lọc. Màn hình tự làm mới sau mỗi 15 giây."
            },
            {
               "step": 2,
               "action": "Báo sự cố",
               "detail": "• Bấm [Báo sự cố]. Nhập: Chọn Máy Bị Sự Cố (*), Nhóm Sự Cố (*) (Cơ khí, Điện / Tủ điện, Khí nén / Bơm, Mực / Nước / Lô cao su, Khuôn / Dao / Tấm lót, Khác), Mức Độ Nghiêm Trọng (*) (DỪNG MÁY KHẨN CẤP hoặc Cảnh Báo Vận Hành), Hiện Tượng & Lý Do Chi Tiết (*), Ghi Chú Bổ Sung.\n• Bấm [Xác Nhận Báo Sự Cố] (nút chỉ bấm được khi đã chọn máy và nhập lý do).\n• Kết quả: phiếu INC-… ở trạng thái CHỜ TIẾP NHẬN; mức DỪNG MÁY KHẨN CẤP chuyển máy sang SỰ CỐ, mức Cảnh Báo Vận Hành giữ máy chạy. Nếu hệ thống đã cài nhóm nhắn tin của xưởng, phần mềm gửi tin báo sự cố."
            },
            {
               "step": 3,
               "action": "Tiếp nhận sửa chữa",
               "detail": "• Kỹ thuật bấm [Tiếp Nhận] ở dòng phiếu CHỜ TIẾP NHẬN.\n• Nhập Tên Kỹ Thuật Viên Phụ Trách (để trống thì ghi tên người đang đăng nhập), bấm [Xác Nhận Tiếp Nhận].\n• Kết quả: phiếu ĐANG SỬA CHỮA; sự cố dừng máy thì máy chuyển BẢO TRÌ, cảnh báo vận hành thì máy vẫn chạy."
            },
            {
               "step": 4,
               "action": "Nghiệm thu và khôi phục máy",
               "detail": "• Sửa xong, bấm [Nghiệm Thu & Đóng] ở dòng phiếu ĐANG SỬA CHỮA.\n• Nhập Phương Án Sửa Chữa / Khắc Phục (*), Thời Gian Sửa (Phút) (*) lớn hơn 0, Trạng Thái Sau Khôi Phục (CHỜ VIỆC hoặc CHẠY TIẾP), Phụ Tùng Đã Thay Thế (nếu có).\n• Bấm [Nghiệm Thu & Khôi Phục Máy]. Phiếu chuyển sang tab Lịch sử sửa chữa; máy về trạng thái đã chọn."
            },
            {
               "step": 5,
               "action": "Theo dõi giờ chạy và lập lịch PM",
               "detail": "• Tab Giờ chạy & PM liệt kê từng máy: giờ chạy ước tính, chu kỳ, ngày bảo trì kế tiếp, cảnh báo Đến hạn.\n• Bấm [Lập phiếu PM] ở dòng máy (hoặc [Lập lịch PM] trên thanh công cụ). Nhập Ngày Bảo Trì Kế Tiếp (*) (mặc định hôm nay + 30 ngày), Chu Kỳ Bảo Dưỡng (Tháng) từ 1 đến 24 (mặc định 3), Ghi Chú Nội Dung Bảo Dưỡng, bấm [Lập Lịch Bảo Trì].\n• Ngày bảo trì kế tiếp và chu kỳ được lưu lên máy; lần sau cần lập lại phiếu PM sau khi bảo trì xong."
            },
            {
               "step": 6,
               "action": "Tra cứu và xuất báo cáo",
               "detail": "• Tab Lịch sử sửa chữa hiện 20 phiếu đã nghiệm thu gần nhất. Bấm vào dòng phiếu mở chi tiết nhật ký máy; bấm dòng máy ở tab PM mở chi tiết máy.\n• [Xuất Excel] xuất tab đang xem (Su-co-dang-xu-ly, Bao-tri-dinh-ky, Lich-su-sua-chua). Tick chọn dòng rồi bấm [Xuất Excel] trên thanh chọn để chỉ xuất các dòng đã chọn.\n• [Andon xưởng] mở bảng giám sát toàn xưởng (/mes/andon)."
            }
         ],
         "subFlows": [
            {
               "name": "Sự cố chỉ cảnh báo, máy vẫn chạy",
               "steps": [
                  "Vẫn báo sự cố với mức Cảnh Báo Vận Hành để có phiếu theo dõi.",
                  "Máy giữ nguyên trạng thái khi báo và khi tiếp nhận (vẫn chạy trong lúc kỹ thuật kiểm tra); nghiệm thu chọn CHẠY TIẾP để đóng phiếu."
               ]
            },
            {
               "name": "Xem một máy cụ thể",
               "steps": [
                  "Từ chi tiết máy (Xưởng sản xuất › Thiết bị SX) mở liên kết sự cố của máy, hoặc thêm ?machineId=<mã máy> vào đường dẫn /mes/incidents.",
                  "Danh sách chỉ còn phiếu và giờ chạy của máy đó."
               ]
            },
            {
               "name": "Đánh giá thiết bị định kỳ",
               "steps": [
                  "Mở tab Lịch sử sửa chữa, xuất Excel.",
                  "Dùng thẻ MTTR, MTBF và Tỷ lệ sẵn sàng làm số liệu đầu vào cho họp xem xét của lãnh đạo."
               ]
            }
         ],
         "statusTransitions": [
            {
               "from": "(Tạo mới)",
               "to": "CHỜ TIẾP NHẬN (máy: SỰ CỐ nếu Dừng máy khẩn cấp)",
               "action": "[Báo sự cố] → [Xác Nhận Báo Sự Cố]",
               "allowedRoles": "Người đã đăng nhập"
            },
            {
               "from": "CHỜ TIẾP NHẬN",
               "to": "ĐANG SỬA CHỮA (máy: BẢO TRÌ nếu Dừng máy khẩn cấp)",
               "action": "[Tiếp Nhận] → [Xác Nhận Tiếp Nhận]",
               "allowedRoles": "Kỹ thuật cơ điện / người đã đăng nhập"
            },
            {
               "from": "ĐANG SỬA CHỮA",
               "to": "Đã nghiệm thu (máy: CHỜ VIỆC hoặc ĐANG CHẠY)",
               "action": "[Nghiệm Thu & Đóng] → [Nghiệm Thu & Khôi Phục Máy]",
               "allowedRoles": "Kỹ thuật cơ điện / người đã đăng nhập"
            }
         ],
         "actionLinks": [
            {
               "from": "Sự cố thiết bị (dòng phiếu)",
               "to": "Chi tiết nhật ký máy (/machine-logs/<mã>)",
               "action": "Bấm vào dòng",
               "how": "Xem đầy đủ hiện tượng, người tiếp nhận, phương án sửa, phụ tùng."
            },
            {
               "from": "Giờ chạy & PM (dòng máy)",
               "to": "Chi tiết máy (/machines/<mã>)",
               "action": "Bấm vào dòng",
               "how": "Xem thông số máy, công đoạn máy làm được, lịch sử."
            },
            {
               "from": "Sự cố thiết bị",
               "to": "Andon xưởng (/mes/andon)",
               "action": "[Andon xưởng]",
               "how": "Bảng giám sát trạng thái toàn bộ máy trong xưởng."
            }
         ],
         "forms": [
            {
               "code": "BM-TB-01",
               "name": "Phiếu báo sự cố thiết bị (INC-…) — xuất Excel từ tab Sự cố đang xử lý"
            },
            {
               "code": "BM-TB-02",
               "name": "Kế hoạch bảo trì định kỳ (PM-…) — xuất Excel từ tab Giờ chạy & PM"
            },
            {
               "code": "BM-TB-03",
               "name": "Lịch sử sửa chữa thiết bị — xuất Excel từ tab Lịch sử sửa chữa"
            }
         ],
         "notes": [
            "Màn hình này không có nút xoá phiếu sự cố; phiếu đã nghiệm thu lưu làm hồ sơ thiết bị.",
            "Chỉ mức DỪNG MÁY KHẨN CẤP chuyển máy sang SỰ CỐ (và BẢO TRÌ khi tiếp nhận); mức Cảnh Báo Vận Hành giữ máy chạy. Máy dừng chỉ về chạy lại sau khi nghiệm thu.",
            "Phiếu PM lưu ngày bảo trì kế tiếp và chu kỳ lên máy, không tự sinh lịch lần sau; bảo trì xong cần lập phiếu PM mới.",
            "Giờ chạy là số ước tính từ nhật ký sản xuất, không thay cho đồng hồ giờ chạy trên máy.",
            "Tab Lịch sử sửa chữa chỉ hiện 20 phiếu gần nhất; muốn xem đủ thì xuất Excel hoặc mở chi tiết máy."
         ],
         "uatChecklist": [
            {
               "id": "TB-17-01",
               "item": "Báo sự cố dừng máy",
               "standard": "Phiếu INC-… ở CHỜ TIẾP NHẬN; máy hiện SỰ CỐ; thẻ Máy Sự Cố tăng 1.",
               "method": "1. Xưởng sản xuất › Sự cố thiết bị › [Báo sự cố]. 2. Chọn một máy, Nhóm Cơ khí, mức DỪNG MÁY KHẨN CẤP, hiện tượng “Kẹt giấy đầu cấp” → [Xác Nhận Báo Sự Cố]. 3. Kiểm tra dòng phiếu và trạng thái máy ở Thiết bị SX."
            },
            {
               "id": "TB-17-02",
               "item": "Thiếu thông tin bắt buộc",
               "standard": "Nút [Xác Nhận Báo Sự Cố] không bấm được khi chưa chọn máy hoặc chưa nhập lý do.",
               "method": "Mở form báo sự cố, chỉ chọn máy, để trống hiện tượng; kiểm tra nút bị khoá."
            },
            {
               "id": "TB-17-03",
               "item": "Tiếp nhận và nghiệm thu",
               "standard": "Tiếp nhận: phiếu ĐANG SỬA CHỮA, máy BẢO TRÌ. Nghiệm thu với 45 phút, CHẠY TIẾP: phiếu vào Lịch sử sửa chữa, máy ĐANG CHẠY, MTTR cập nhật.",
               "method": "1. [Tiếp Nhận] phiếu ở TB-17-01, để trống tên → kiểm tra tên người đăng nhập được ghi. 2. [Nghiệm Thu & Đóng], nhập phương án “Thay dây curoa”, 45 phút, CHẠY TIẾP, phụ tùng “Curoa A42” → lưu. 3. Kiểm tra tab Lịch sử sửa chữa và trạng thái máy."
            },
            {
               "id": "TB-17-04",
               "item": "Nghiệm thu thiếu số phút",
               "standard": "Nhập 0 phút thì báo “Thời gian sửa chữa phải lớn hơn 0”, phiếu không đổi trạng thái.",
               "method": "Ở phiếu đang sửa, nhập phương án nhưng để số phút 0 → bấm lưu."
            },
            {
               "id": "TB-17-05",
               "item": "Lập lịch PM",
               "standard": "Máy có ngày bảo trì kế tiếp và chu kỳ mới trên tab Giờ chạy & PM.",
               "method": "Bảo trì bảo dưỡng › dòng một máy › [Lập phiếu PM], ngày = hôm nay + 30, chu kỳ 3 tháng → [Lập Lịch Bảo Trì]; kiểm tra dòng máy."
            },
            {
               "id": "TB-17-06",
               "item": "Xuất Excel",
               "standard": "File Excel có đúng các dòng của tab đang xem; chọn dòng thì chỉ xuất dòng đã chọn.",
               "method": "Ở mỗi tab bấm [Xuất Excel]; tick 2 dòng rồi xuất lại."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "OPERATOR (Thợ vận hành)",
               "createTest": "Báo sự cố cho máy đang chạy",
               "readTest": "Xem tab Sự cố đang xử lý, tìm theo mã máy",
               "updateTest": "—",
               "deleteTest": "Không có nút xoá phiếu",
               "expectedResult": "Báo sự cố thành công, máy chuyển SỰ CỐ."
            },
            {
               "roleGroup": "Kỹ thuật cơ điện / PRODUCTION_MANAGER",
               "createTest": "Lập phiếu PM cho máy đến hạn",
               "readTest": "Xem 3 tab, mở chi tiết nhật ký máy, xuất Excel",
               "updateTest": "Tiếp nhận và nghiệm thu phiếu sự cố",
               "deleteTest": "—",
               "expectedResult": "Trạng thái phiếu và máy đổi đúng từng bước; thẻ MTTR / MTBF cập nhật."
            }
         ]
      },
      // ═══════════════════════════════════════════════════════════════════════════
      // CHƯƠNG 18. Dashboard, Báo Cáo Quản Trị, Báo Cáo Bán Hàng & Tiến Độ Công Đoạn
      // ═══════════════════════════════════════════════════════════════════════════
      {
         "id": "dashboard_reports",
         "aliases": [
            "dashboard",
            "analytics",
            "executive",
            "reports",
            "reports-sales",
            "management-reports",
            "tracking",
            "process-progress",
            "tien-do-cong-doan",
            "kpi"
         ],
         "title": "18. Dashboard, Báo Cáo Quản Trị, Báo Cáo Bán Hàng & Tiến Độ Công Đoạn",
         "icon": "LayoutDashboard",
         "isoRef": "QT-BC-01",
         "purpose": "Hướng dẫn Ban Giám đốc, trưởng bộ phận và kế hoạch đọc đúng các con số trên Dashboard, Báo cáo quản trị, Báo cáo bán hàng và bảng Tiến độ công đoạn: mỗi chỉ số lấy từ dữ liệu nào, lọc theo kỳ ra sao, bấm vào đâu để xem chi tiết và xuất Excel. Đây là đầu vào cho việc theo dõi, đo lường và xem xét của lãnh đạo.",
         "scope": [
            "Dashboard: menu Tổng quan › Dashboard (/). Báo cáo quản trị: Tổng quan › Báo Cáo Quản Trị (/reports). Báo cáo bán hàng: Tài Chính › Báo cáo Bán hàng (/reports/sales, mở cùng trang Báo cáo quản trị ở tab Doanh Thu). Tiến độ công đoạn: Kế hoạch › Tiến Độ Công Đoạn hoặc nút [Tiến Độ CĐ] trên danh sách Lệnh sản xuất.",
            "Các màn hình này chỉ để xem và xuất số liệu, không sửa chứng từ. Muốn sửa thì bấm vào dòng để mở chứng từ gốc.",
            "Nhân viên kinh doanh chỉ thấy số liệu đơn hàng của chính mình trên Dashboard; người có quyền xem toàn bộ dữ liệu thì có thêm bộ lọc Nhân viên."
         ],
         "references": [
            "ISO 9001:2015 mục 9.1 — Theo dõi, đo lường, phân tích và đánh giá",
            "ISO 9001:2015 mục 9.3 — Xem xét của lãnh đạo",
            "Chương 06 — Đơn hàng; Chương 08 — Lệnh sản xuất; Chương 14 — Kho; Chương 15 — Tài chính"
         ],
         "terms": [
            {
               "term": "Kỳ thời gian",
               "definition": "Bộ lọc dùng chung: Hôm nay, Tuần này, Tháng này (mặc định), Quý này, Năm nay, Tùy chỉnh (từ ngày → đến ngày). Các thẻ có % so với kỳ liền trước cùng độ dài."
            },
            {
               "term": "Doanh thu / Tổng doanh số",
               "definition": "Tổng giá trị đơn hàng tạo trong kỳ (Dashboard tính theo ngày tạo đơn, Báo cáo bán hàng tính theo ngày đặt đơn và không tính đơn nháp, đơn đã huỷ). Là số đơn hàng, không phải số hoá đơn đã xuất."
            },
            {
               "term": "Thực thu",
               "definition": "Tổng phiếu thu trong kỳ ở Tài chính › Thu chi & Sổ quỹ."
            },
            {
               "term": "Công nợ phát sinh",
               "definition": "Doanh số trong kỳ trừ thực thu trong kỳ (không âm)."
            },
            {
               "term": "Tuổi nợ",
               "definition": "Ở tab Tuổi Nợ Khách Hàng, tuổi nợ ước tính theo ngày đơn hàng gần nhất của khách: Trong hạn 0–30 ngày, Quá hạn trên 30 ngày; mỗi khách được xếp An toàn / Cần nhắc / Cảnh báo cao / Nguy cơ xấu. Đối chiếu chính xác từng chứng từ xem Sổ chi tiết công nợ (chương 15)."
            },
            {
               "term": "Hiệu suất (thẻ trên Dashboard)",
               "definition": "Tỷ lệ số máy đang chạy trên tổng số máy tại thời điểm xem. Hiệu suất OEE đầy đủ xem ở màn hình Hiệu suất OEE của xưởng."
            },
            {
               "term": "Công đoạn đang ở",
               "definition": "Trên Tiến độ công đoạn: công đoạn đầu tiên của lệnh chưa hoàn thành; lệnh đã xong mọi công đoạn ghi Xong công đoạn."
            }
         ],
         "responsibilities": [
            {
               "role": "Ban Giám đốc (DIRECTOR)",
               "tasks": [
                  "Xem Dashboard đầu ngày: Cảnh báo vận hành, Doanh thu, Đơn hàng, Đang sản xuất",
                  "Dùng Báo cáo quản trị và Báo cáo bán hàng cho họp xem xét định kỳ, xuất Excel lưu hồ sơ"
               ]
            },
            {
               "role": "Kế hoạch sản xuất (PLANNER) / Quản đốc",
               "tasks": [
                  "Mỗi ca mở Tiến độ công đoạn, ưu tiên nhóm Hạn giao gần nhất và lệnh có công đoạn trễ",
                  "Bấm vào lệnh trễ để mở tab Quy trình, điều độ lại máy (chương 11)"
               ]
            },
            {
               "role": "Kinh doanh (SALE)",
               "tasks": [
                  "Theo dõi doanh thu, đơn hàng, báo giá chờ duyệt của chính mình trên Dashboard"
               ]
            },
            {
               "role": "Kế toán",
               "tasks": [
                  "Theo dõi tab Dòng tiền và Tuổi Nợ Khách Hàng; xuất Excel tuổi nợ để nhắc nợ"
               ]
            }
         ],
         "permissionRules": [
            {
               "role": "Mọi vai trò đã đăng nhập",
               "view": "✅",
               "create": "❌",
               "edit": "❌",
               "delete": "❌",
               "approve": "❌",
               "export": "✅",
               "statusRules": "Dashboard mở cho mọi người; vai trò Kinh doanh chỉ thấy số liệu đơn của mình. Báo cáo quản trị / Báo cáo bán hàng hiện trên menu khi vai trò có quyền xem Báo cáo. Tiến độ công đoạn theo quyền xem Lệnh sản xuất."
            }
         ],
         "processFlowchart": "graph TD\n    A[Dashboard: Cảnh báo vận hành, KPI kỳ] --> B{Có cảnh báo?}\n    B -->|Lệnh SX chậm| C[Mở danh sách lệnh chậm]\n    C --> D[Tiến độ công đoạn: xem lệnh đang ở công đoạn nào, trễ bao nhiêu]\n    D --> E[Mở lệnh - tab Quy trình - điều độ lại]\n    B -->|Máy dừng / bảo trì| F[Sự cố thiết bị - chương 17]\n    A --> G[Báo cáo quản trị: Doanh thu, Tiến độ LSX, Sổ kho NXT, Tuổi nợ, Nhật ký xưởng]\n    G --> H[Xuất Excel - lưu hồ sơ xem xét lãnh đạo]",
         "mainFlow": [
            {
               "step": 1,
               "action": "Xem Dashboard",
               "detail": "• Tổng quan › Dashboard. Chọn Kỳ thời gian; lọc Khách hàng (chọn nhiều), Trạng thái đơn, Nhân viên (nếu có quyền xem toàn bộ).\n• Thanh Cảnh báo vận hành: số Lệnh SX chậm tiến độ (lệnh chưa xong đã tới hạn), Máy dừng / bảo trì, Phế phẩm % (vàng khi trên 2%), Mã phôi in dôi dư. Bấm vào cảnh báo mở danh sách chi tiết bên phải; bấm dòng để mở lệnh / phiếu giao / khách hàng / đơn hàng.\n• 4 thẻ chính: Doanh thu, Đơn hàng, Đang sản xuất (lệnh đang chạy), Hiệu suất. 6 thẻ nhanh: Tổng ĐH, Đang SX, Gia công, Giao hàng, BG chờ duyệt, VT sắp hết. Bấm thẻ để mở danh sách tương ứng."
            },
            {
               "step": 2,
               "action": "Các tab của Dashboard",
               "detail": "• Tổng quan, Sản xuất, Cấp phát giấy, Giao hàng (có tỷ lệ giao đúng hạn OTIF), Dòng tiền (Tiền thu, Tiền chi trong kỳ, Phải thu khách hàng).\n• Tab đang chọn được giữ trên đường dẫn, gửi link cho người khác sẽ mở đúng tab."
            },
            {
               "step": 3,
               "action": "Báo cáo quản trị",
               "detail": "• Tổng quan › Báo Cáo Quản Trị. Chọn kỳ (mặc định tháng này). 5 tab: Doanh Thu Bán Hàng, Tiến Độ LSX, Sổ Kho NXT, Tuổi Nợ Khách Hàng, Nhật Ký Xưởng.\n• Tiến Độ LSX: Kế hoạch sản xuất (tổng số lượng các lệnh lập trong kỳ), Thực đạt KCS và Phế phẩm phát sinh (từ nhật ký sản xuất theo ngày ghi), Tỷ lệ hoàn thành, biểu đồ sản lượng theo máy.\n• Sổ Kho NXT: chọn kho; thẻ Định giá vốn kho, Tổng lượng tồn, Nhập / Xuất trong kỳ; bảng Đầu kỳ / Nhập / Xuất / Cuối kỳ / Định giá.\n• Tuổi Nợ: Tổng công nợ, Trong hạn, Quá hạn, số khách có dư nợ, xếp hạng từng khách.\n• Bấm dòng để xem nhanh đơn hàng, lệnh, sản phẩm / vật tư, khách hàng mà không mất bộ lọc."
            },
            {
               "step": 4,
               "action": "Báo cáo bán hàng",
               "detail": "• Tài Chính › Báo cáo Bán hàng (mở tab Doanh Thu Bán Hàng).\n• Thẻ: Tổng doanh số, Đơn hàng ghi nhận (% so kỳ trước), Thực thu đã nhận, Công nợ phát sinh. Biểu đồ Xu hướng doanh thu 6 tháng và Top 5 khách hàng.\n• Bảng Chi Tiết Đơn Hàng: Mã đơn, PO khách, Khách hàng, Ngày đặt, Hẹn giao, Tổng tiền, Đã thu, Còn nợ, Trạng thái; bấm dòng mở đơn hàng."
            },
            {
               "step": 5,
               "action": "Xuất Excel báo cáo",
               "detail": "• [Xuất Excel] ở tab Doanh thu và Tiến độ LSX; [Xuất Sổ Kho] tải đủ mọi dòng của kho đang chọn; [Xuất Excel Tuổi Nợ] ở tab Tuổi nợ.\n• Tên và tiêu đề file ghi kỳ báo cáo để lưu hồ sơ."
            },
            {
               "step": 6,
               "action": "Theo dõi Tiến độ công đoạn",
               "detail": "• Kế hoạch › Tiến Độ Công Đoạn (hoặc [Tiến Độ CĐ] trên Lệnh sản xuất). Chỉ hiện lệnh chưa hoàn thành / chưa huỷ, gom theo Hạn giao (gần nhất lên trước); mỗi nhóm ghi số lệnh và số lệnh có công đoạn trễ.\n• Cột: Lệnh SX · Sản phẩm, Hạn giao (Trễ N ngày), Đang ở (công đoạn hiện tại, số công đoạn trễ), rồi mỗi nhóm công đoạn một cột. Đầu cột ghi số lệnh đang chờ ở công đoạn đó, số đang chạy ▶, số trễ ⚠.\n• Ô công đoạn: Đạt / Kế hoạch, %, thanh tiến độ, ngày hạn hoặc Đã xong / Chưa xếp lịch. Màu: xanh lá = xong, đỏ = trễ, vàng = đang chạy, trắng = đang chờ; viền tím = công đoạn hiện tại; — = lệnh không có công đoạn này. Rê chuột xem tên công đoạn chi tiết.\n• Bấm dòng mở lệnh ở tab Quy trình. Bảng chỉ để xem; dùng bộ lọc Theo ngày, kỳ, Nhóm, trạng thái, Gấp như danh sách lệnh."
            }
         ],
         "subFlows": [
            {
               "name": "Họp giao ban sáng",
               "steps": [
                  "Dashboard › Cảnh báo vận hành: xử lý lệnh chậm và máy dừng trước.",
                  "Tiến độ công đoạn: thu gọn các nhóm hạn giao xa, tập trung nhóm hạn hôm nay / ngày mai và ô đỏ.",
                  "Bấm lệnh trễ, mở tab Quy trình để điều độ lại hoặc ghi nhật ký còn thiếu."
               ]
            },
            {
               "name": "Báo cáo tháng cho xem xét lãnh đạo",
               "steps": [
                  "Báo Cáo Quản Trị, kỳ Tháng này (hoặc Tùy chỉnh đúng tháng).",
                  "Xuất Excel lần lượt Doanh thu, Tiến độ LSX, Sổ kho NXT, Tuổi nợ; lưu theo tháng.",
                  "Đối chiếu số Thực thu với Sổ quỹ và số Tuổi nợ với Sổ chi tiết công nợ trước khi trình."
               ]
            },
            {
               "name": "Một số liệu trông không đúng",
               "steps": [
                  "Bấm vào thẻ / dòng để mở danh sách hoặc chứng từ gốc và kiểm tra.",
                  "Kiểm tra kỳ thời gian và bộ lọc khách hàng / nhân viên đang chọn.",
                  "Vẫn sai thì gửi Phản hồi kèm ảnh màn hình và kỳ đang chọn (chương 02)."
               ]
            },
            {
               "name": "Dashboard › tab Cấp phát giấy",
               "steps": [
                  "[Xem Hub Cấp Phát]: mở màn cấp phát giấy và giấy dư (Kế hoạch › Kế hoạch Vật tư, phần cấp phát giấy) để xử lý các lệnh đang thiếu giấy."
               ]
            }
         ],
         "actionLinks": [
            {
               "from": "Dashboard › thẻ Doanh thu / Đơn hàng",
               "to": "Danh sách Đơn hàng",
               "action": "Bấm thẻ",
               "how": "Mở danh sách đơn để xem chi tiết."
            },
            {
               "from": "Dashboard › thẻ Đang sản xuất",
               "to": "Danh sách Lệnh sản xuất",
               "action": "Bấm thẻ",
               "how": "Xem các lệnh đang chạy."
            },
            {
               "from": "Dashboard › Cảnh báo vận hành",
               "to": "Hộp danh sách chi tiết",
               "action": "Bấm cảnh báo",
               "how": "Bấm dòng để mở lệnh, phiếu giao, khách hàng, đơn hàng hoặc nhật ký máy."
            },
            {
               "from": "Tiến độ công đoạn (dòng lệnh)",
               "to": "Lệnh sản xuất › tab Quy trình",
               "action": "Bấm dòng",
               "how": "Điều độ, bắt đầu / kết thúc công đoạn, ghi nhật ký."
            },
            {
               "from": "Báo cáo bán hàng (dòng đơn)",
               "to": "Chi tiết Đơn hàng",
               "action": "Bấm dòng",
               "how": "Xem đơn, phiếu thu, phiếu giao liên quan."
            }
         ],
         "forms": [
            {
               "code": "BM-BC-01",
               "name": "Báo cáo doanh thu bán hàng theo kỳ — [Xuất Excel] tab Doanh Thu"
            },
            {
               "code": "BM-BC-02",
               "name": "Báo cáo tiến độ lệnh sản xuất — [Xuất Excel] tab Tiến Độ LSX"
            },
            {
               "code": "BM-BC-03",
               "name": "Sổ kho nhập – xuất – tồn — [Xuất Sổ Kho]"
            },
            {
               "code": "BM-BC-04",
               "name": "Báo cáo tuổi nợ khách hàng — [Xuất Excel Tuổi Nợ]"
            }
         ],
         "notes": [
            "Doanh thu trên Dashboard và Báo cáo bán hàng là giá trị đơn hàng tạo / đặt trong kỳ, chưa phải doanh thu xuất hoá đơn; số kế toán chính thức lấy từ chương Tài chính.",
            "Thẻ Đơn hàng trên Dashboard đếm mọi đơn trong kỳ, không theo bộ lọc khách hàng / trạng thái / nhân viên; thẻ Doanh thu thì theo các bộ lọc này.",
            "Thẻ Đang sản xuất đếm lệnh đang chạy ở mọi thời điểm, không theo kỳ.",
            "Tuổi nợ ở Báo cáo quản trị là ước tính nhanh theo ngày đơn gần nhất của khách; nhắc nợ chính thức theo Sổ chi tiết công nợ và Đối soát công nợ.",
            "Tiến độ công đoạn chỉ để xem, không có xuất Excel; muốn xuất danh sách lệnh dùng [Xuất Excel] ở danh sách Lệnh sản xuất.",
            "Đường dẫn mở thẳng từng tab Báo cáo quản trị: /reports/sales (Doanh thu), /reports/production (Tiến độ LSX), /reports/inventory (Sổ kho NXT), /reports/ar-aging (Tuổi nợ). /analytics và /executive mở Dashboard.",
            "Tổng doanh số, Đơn hàng ghi nhận, Top khách hàng, xu hướng 6 tháng và bảng Chi tiết đơn hàng ở Báo cáo bán hàng không tính đơn nháp và đơn đã huỷ.",
            "Thẻ VT sắp hết trên Dashboard đếm số vật tư có khai báo tồn tối thiểu mà tồn hiện tại thấp hơn mức đó (cùng quy tắc thông báo vật tư sắp hết); khai báo tồn tối thiểu ở danh mục Vật tư."
         ],
         "uatChecklist": [
            {
               "id": "BC-18-01",
               "item": "Dashboard đổi kỳ",
               "standard": "Đổi Tháng này → Hôm nay thì thẻ Doanh thu / Đơn hàng thay đổi theo kỳ, có % so kỳ trước.",
               "method": "Mở Dashboard, ghi số Đơn hàng của Tháng này; chọn Hôm nay; so với số đơn tạo hôm nay ở danh sách Đơn hàng (lọc ngày tạo)."
            },
            {
               "id": "BC-18-02",
               "item": "Cảnh báo Lệnh SX chậm",
               "standard": "Số trên cảnh báo bằng số lệnh chưa xong có hạn ≤ hôm nay; bấm vào hiện đúng các lệnh đó.",
               "method": "Bấm cảnh báo Lệnh SX chậm tiến độ, đối chiếu với danh sách Lệnh sản xuất lọc trạng thái chưa xong và hạn ≤ hôm nay."
            },
            {
               "id": "BC-18-03",
               "item": "Kinh doanh chỉ thấy số của mình",
               "standard": "Đăng nhập tài khoản Kinh doanh: Dashboard chỉ tính đơn có nhân viên kinh doanh là mình, không có bộ lọc Nhân viên.",
               "method": "Đăng nhập tài khoản SALE, so thẻ Doanh thu với tổng đơn của mình trong danh sách Đơn hàng."
            },
            {
               "id": "BC-18-04",
               "item": "Báo cáo bán hàng khớp danh sách đơn",
               "standard": "Tổng doanh số và số đơn ghi nhận khớp tổng các đơn đặt trong kỳ; Thực thu khớp tổng phiếu thu trong kỳ.",
               "method": "Chọn một tháng, xuất Excel; đối chiếu tổng với danh sách Đơn hàng và Sổ quỹ cùng kỳ."
            },
            {
               "id": "BC-18-05",
               "item": "Xuất Sổ kho",
               "standard": "File có đủ mọi mặt hàng của kho đã chọn, số Cuối kỳ khớp Báo cáo NXT ở chương Kho.",
               "method": "Tab Sổ Kho NXT, chọn Kho Vật tư, [Xuất Sổ Kho]; so 3 mặt hàng với Kho › Báo cáo NXT."
            },
            {
               "id": "BC-18-06",
               "item": "Tiến độ công đoạn",
               "standard": "Lệnh có công đoạn quá hạn hiện ô đỏ “Trễ ·”, cột Đang ở đúng công đoạn chưa xong đầu tiên; bấm dòng mở tab Quy trình của lệnh.",
               "method": "Chọn một lệnh có công đoạn đã quá hạn kế hoạch, mở Tiến độ công đoạn, kiểm tra màu ô và cột Đang ở; bấm dòng."
            }
         ],
         "roleCrudTestScenarios": [
            {
               "roleGroup": "DIRECTOR / ADMIN",
               "createTest": "—",
               "readTest": "Xem Dashboard đủ 5 tab, Báo cáo quản trị đủ 5 tab, lọc theo nhân viên",
               "updateTest": "—",
               "deleteTest": "—",
               "expectedResult": "Thấy số liệu toàn công ty, xuất Excel được."
            },
            {
               "roleGroup": "SALE (Kinh doanh)",
               "createTest": "—",
               "readTest": "Xem Dashboard",
               "updateTest": "—",
               "deleteTest": "—",
               "expectedResult": "Chỉ thấy số liệu đơn của mình; không có bộ lọc Nhân viên."
            },
            {
               "roleGroup": "PLANNER / PRODUCTION_MANAGER",
               "createTest": "—",
               "readTest": "Xem Tiến độ công đoạn, mở lệnh trễ",
               "updateTest": "Điều độ lại ở tab Quy trình của lệnh (chương 11)",
               "deleteTest": "—",
               "expectedResult": "Bảng hiện đúng công đoạn hiện tại và trễ; mở lệnh đúng tab."
            }
         ]
      }
   ]
};
